function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4d21"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4d21"] = parcelRequire;
}
parcelRequire.register("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRequire.register("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRequire.register("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRequire.register("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRequire.register("6VZtt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42, (v) => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50c7c0793ca9e0ff$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $50c7c0793ca9e0ff$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $50c7c0793ca9e0ff$var$q = "function" === typeof Object.is ? Object.is : $50c7c0793ca9e0ff$var$p, $50c7c0793ca9e0ff$var$r = $hfliI.useSyncExternalStore, $50c7c0793ca9e0ff$var$t = $acw62.useRef, $50c7c0793ca9e0ff$var$u = $acw62.useEffect, $50c7c0793ca9e0ff$var$v = $acw62.useMemo, $50c7c0793ca9e0ff$var$w = $acw62.useDebugValue;
$50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $50c7c0793ca9e0ff$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $50c7c0793ca9e0ff$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($50c7c0793ca9e0ff$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $50c7c0793ca9e0ff$var$r(a, c[0], c[1]);
    $50c7c0793ca9e0ff$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $50c7c0793ca9e0ff$var$w(d);
    return d;
};

});
parcelRequire.register("hfliI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("30Ie1"));

});
parcelRequire.register("30Ie1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2313ad640c2ad62d$export$306c0aa65ff9ec16, (v) => $2313ad640c2ad62d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2313ad640c2ad62d$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $2313ad640c2ad62d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2313ad640c2ad62d$var$k = "function" === typeof Object.is ? Object.is : $2313ad640c2ad62d$var$h, $2313ad640c2ad62d$var$l = $acw62.useState, $2313ad640c2ad62d$var$m = $acw62.useEffect, $2313ad640c2ad62d$var$n = $acw62.useLayoutEffect, $2313ad640c2ad62d$var$p = $acw62.useDebugValue;
function $2313ad640c2ad62d$var$q(a, b) {
    var d = b(), f = $2313ad640c2ad62d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2313ad640c2ad62d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2313ad640c2ad62d$var$m(function() {
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2313ad640c2ad62d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2313ad640c2ad62d$var$p(d);
    return d;
}
function $2313ad640c2ad62d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2313ad640c2ad62d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2313ad640c2ad62d$var$t(a, b) {
    return b();
}
var $2313ad640c2ad62d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2313ad640c2ad62d$var$t : $2313ad640c2ad62d$var$q;
$2313ad640c2ad62d$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $2313ad640c2ad62d$var$u;

});



parcelRequire.register("laOt8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f6a1ae3267718cab$export$2e2bcd8739ae039);
function $f6a1ae3267718cab$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRequire.register("kjyEk", function(module, exports) {
"use strict";

});

parcelRequire.register("5PPry", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $hOJwo = parcelRequire("hOJwo");

var $1c8c5 = parcelRequire("1c8c5");

var $kr8mE = parcelRequire("kr8mE");

var $9QMEG = parcelRequire("9QMEG");
var $43f99ec25bf03fdb$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $kr8mE.RawSha256();
        if (secret) {
            this.outer = new $kr8mE.RawSha256();
            var inner = $43f99ec25bf03fdb$var$bufferFromSecret(secret);
            var outer = new Uint8Array($1c8c5.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $1c8c5.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $9QMEG.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $9QMEG.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $hOJwo.__awaiter)(this, void 0, void 0, function() {
            return (0, $hOJwo.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $43f99ec25bf03fdb$var$Sha256;
function $43f99ec25bf03fdb$var$bufferFromSecret(secret) {
    var input = (0, $9QMEG.convertToBuffer)(secret);
    if (input.byteLength > $1c8c5.BLOCK_SIZE) {
        var bufferHash = new $kr8mE.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($1c8c5.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRequire.register("hOJwo", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $cf8a6ac5d624fdcb$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $cf8a6ac5d624fdcb$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $cf8a6ac5d624fdcb$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $cf8a6ac5d624fdcb$var$extendStatics = function(d, b) {
    $cf8a6ac5d624fdcb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $cf8a6ac5d624fdcb$var$extendStatics(d, b);
};
function $cf8a6ac5d624fdcb$export$a8ba968b8961cb8a(d, b) {
    $cf8a6ac5d624fdcb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $cf8a6ac5d624fdcb$export$18ce0697a983be9b = function() {
    $cf8a6ac5d624fdcb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cf8a6ac5d624fdcb$export$18ce0697a983be9b.apply(this, arguments);
};
function $cf8a6ac5d624fdcb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $cf8a6ac5d624fdcb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $cf8a6ac5d624fdcb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $cf8a6ac5d624fdcb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $cf8a6ac5d624fdcb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $cf8a6ac5d624fdcb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $cf8a6ac5d624fdcb$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $cf8a6ac5d624fdcb$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $cf8a6ac5d624fdcb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $cf8a6ac5d624fdcb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $cf8a6ac5d624fdcb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($cf8a6ac5d624fdcb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $cf8a6ac5d624fdcb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $cf8a6ac5d624fdcb$export$10c90e4f7922046c(v) {
    return this instanceof $cf8a6ac5d624fdcb$export$10c90e4f7922046c ? (this.v = v, this) : new $cf8a6ac5d624fdcb$export$10c90e4f7922046c(v);
}
function $cf8a6ac5d624fdcb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $cf8a6ac5d624fdcb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $cf8a6ac5d624fdcb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $cf8a6ac5d624fdcb$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $cf8a6ac5d624fdcb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $cf8a6ac5d624fdcb$export$19a8beecd37a4c45 === "function" ? $cf8a6ac5d624fdcb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $cf8a6ac5d624fdcb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $cf8a6ac5d624fdcb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $cf8a6ac5d624fdcb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $cf8a6ac5d624fdcb$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $cf8a6ac5d624fdcb$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRequire.register("1c8c5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRequire.register("kr8mE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $1c8c5 = parcelRequire("1c8c5");
/**
 * @internal
 */ var $ee0cd14483f8bfb8$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($1c8c5.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $1c8c5.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $1c8c5.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $1c8c5.BLOCK_SIZE >= $1c8c5.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $1c8c5.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $1c8c5.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($1c8c5.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($1c8c5.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($1c8c5.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $1c8c5.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($1c8c5.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $ee0cd14483f8bfb8$var$RawSha256;

});

parcelRequire.register("9QMEG", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $6Pbqi = parcelRequire("6Pbqi");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $6Pbqi.convertToBuffer;
    }
});

var $gQGCm = parcelRequire("gQGCm");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $gQGCm.isEmptyData;
    }
});

var $j6YPJ = parcelRequire("j6YPJ");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $j6YPJ.numToUint8;
    }
});

var $2Mubd = parcelRequire("2Mubd");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $2Mubd.uint32ArrayFrom;
    }
});

});
parcelRequire.register("6Pbqi", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $4f805de621b431ff$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $dg00z = parcelRequire("dg00z");
// Quick polyfill
var $4f805de621b431ff$var$fromUtf8 = typeof $4f805de621b431ff$require$Buffer !== "undefined" && $4f805de621b431ff$require$Buffer.from ? function(input) {
    return $4f805de621b431ff$require$Buffer.from(input, "utf8");
} : $dg00z.fromUtf8;
function $4f805de621b431ff$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $4f805de621b431ff$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $4f805de621b431ff$var$convertToBuffer;

});
parcelRequire.register("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("dg00z", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $9a6cc697f73e5662$export$c7c5cef950a4d2fc);

var $XAoxB = parcelRequire("XAoxB");

var $eSuv4 = parcelRequire("eSuv4");
const $9a6cc697f73e5662$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $eSuv4.fromUtf8)(input) : (0, $XAoxB.fromUtf8)(input);
const $9a6cc697f73e5662$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $eSuv4.toUtf8)(input) : (0, $XAoxB.toUtf8)(input);

});
parcelRequire.register("XAoxB", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $0b31be0e89064635$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $0b31be0e89064635$export$b4b216764bb846eb);
const $0b31be0e89064635$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $0b31be0e89064635$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRequire.register("eSuv4", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $ad4dc4837527c443$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $ad4dc4837527c443$export$b4b216764bb846eb);
function $ad4dc4837527c443$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $ad4dc4837527c443$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRequire.register("gQGCm", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $c4428fae9f8ed397$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $c4428fae9f8ed397$var$isEmptyData;

});

parcelRequire.register("j6YPJ", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $de9dc41cb4682e52$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $de9dc41cb4682e52$var$numToUint8;

});

parcelRequire.register("2Mubd", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $2067798cbc3f3845$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $2067798cbc3f3845$var$uint32ArrayFrom;

});



parcelRequire.register("dNdRi", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRequire.register("kzGqM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $efa7fd707211b5be$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$efa7fd707211b5be$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($efa7fd707211b5be$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $efa7fd707211b5be$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};

});

parcelRequire.register("kWD7b", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $f3f790d06fe816e6$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return $f3f790d06fe816e6$var$map($f3f790d06fe816e6$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(k)) + eq;
        if ($f3f790d06fe816e6$var$isArray(obj[k])) return $f3f790d06fe816e6$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(name)) + eq + encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(obj));
};
var $f3f790d06fe816e6$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function $f3f790d06fe816e6$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $f3f790d06fe816e6$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});

parcelRequire.register("Y7YWM", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("aRe47")).then(()=>parcelRequire("kOnn9"));

});

parcelRequire.register("uQ1Em", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});
parcelRequire.register("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function("return this")();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRequire.register("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRequire.register("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRequire.register("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRequire.register("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


/**
 * React Router DOM v6.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @remix-run/router v1.8.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $1d34d5c4a288b213$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    submission: submission,
                    isFetchActionRedirect: true
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($1d34d5c4a288b213$var$_extends({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, $1d34d5c4a288b213$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let activeSubmission = submission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation),
            fetcherSubmission: activeSubmission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a submission, we will preserve it through the redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, activeSubmission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$var$createUseMatchesMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $1d34d5c4a288b213$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}

/**
 * React Router v6.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367)
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367)
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref4, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref5, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $040dbb9c344a508d$var$FormImpl = /*#__PURE__*/ $acw62.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref6, $040dbb9c344a508d$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
function $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        let submit = $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $040dbb9c344a508d$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $acw62.useState(()=>String(++$040dbb9c344a508d$var$fetcherId));
    let [Form] = $acw62.useState(()=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        return $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $acw62.useState(()=>(href)=>{
            !router && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
            !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $acw62.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $7939e29d663dd3ed$export$2af03a1de5c0910)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}









var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $d4cb5338ce396881$export$a49f528ae1a4d0ed = (0, $acw62.createContext)({
    color: "currentColor",
    size: "1em",
    weight: "regular",
    mirrored: !1
});


var $a51719eb0f3aa1eb$var$R = Object.defineProperty;
var $a51719eb0f3aa1eb$var$l = Object.getOwnPropertySymbols;
var $a51719eb0f3aa1eb$var$f = Object.prototype.hasOwnProperty, $a51719eb0f3aa1eb$var$g = Object.prototype.propertyIsEnumerable;
var $a51719eb0f3aa1eb$var$d = (t, r, e)=>r in t ? $a51719eb0f3aa1eb$var$R(t, r, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : t[r] = e, $a51719eb0f3aa1eb$var$s = (t, r)=>{
    for(var e in r || (r = {}))$a51719eb0f3aa1eb$var$f.call(r, e) && $a51719eb0f3aa1eb$var$d(t, e, r[e]);
    if ($a51719eb0f3aa1eb$var$l) for (var e of $a51719eb0f3aa1eb$var$l(r))$a51719eb0f3aa1eb$var$g.call(r, e) && $a51719eb0f3aa1eb$var$d(t, e, r[e]);
    return t;
};
var $a51719eb0f3aa1eb$var$a = (t, r)=>{
    var e = {};
    for(var o in t)$a51719eb0f3aa1eb$var$f.call(t, o) && r.indexOf(o) < 0 && (e[o] = t[o]);
    if (t != null && $a51719eb0f3aa1eb$var$l) for (var o of $a51719eb0f3aa1eb$var$l(t))r.indexOf(o) < 0 && $a51719eb0f3aa1eb$var$g.call(t, o) && (e[o] = t[o]);
    return e;
};
const $a51719eb0f3aa1eb$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, r)=>{
    const m = t, { alt: e, color: o, size: n, weight: c, mirrored: h, children: p, weights: u } = m, C = $a51719eb0f3aa1eb$var$a(m, [
        "alt",
        "color",
        "size",
        "weight",
        "mirrored",
        "children",
        "weights"
    ]), x = (0, $acw62.useContext)((0, $d4cb5338ce396881$export$a49f528ae1a4d0ed)), { color: v = "currentColor", size: i, weight: B = "regular", mirrored: I = !1 } = x, E = $a51719eb0f3aa1eb$var$a(x, [
        "color",
        "size",
        "weight",
        "mirrored"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $a51719eb0f3aa1eb$var$s($a51719eb0f3aa1eb$var$s({
        ref: r,
        xmlns: "http://www.w3.org/2000/svg",
        width: n != null ? n : i,
        height: n != null ? n : i,
        fill: o != null ? o : v,
        viewBox: "0 0 256 256",
        transform: h || I ? "scale(-1, 1)" : void 0
    }, E), C), !!e && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, e), p, u.get(c != null ? c : B));
});
$a51719eb0f3aa1eb$export$2e2bcd8739ae039.displayName = "IconBase";


var $6925feee259dfec9$var$V = Object.defineProperty, $6925feee259dfec9$var$h = Object.defineProperties;
var $6925feee259dfec9$var$c = Object.getOwnPropertyDescriptors;
var $6925feee259dfec9$var$r = Object.getOwnPropertySymbols;
var $6925feee259dfec9$var$o = Object.prototype.hasOwnProperty, $6925feee259dfec9$var$A = Object.prototype.propertyIsEnumerable;
var $6925feee259dfec9$var$m = (t, e, l)=>e in t ? $6925feee259dfec9$var$V(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[e] = l, $6925feee259dfec9$var$n = (t, e)=>{
    for(var l in e || (e = {}))$6925feee259dfec9$var$o.call(e, l) && $6925feee259dfec9$var$m(t, l, e[l]);
    if ($6925feee259dfec9$var$r) for (var l of $6925feee259dfec9$var$r(e))$6925feee259dfec9$var$A.call(e, l) && $6925feee259dfec9$var$m(t, l, e[l]);
    return t;
}, $6925feee259dfec9$var$H = (t, e)=>$6925feee259dfec9$var$h(t, $6925feee259dfec9$var$c(e));
const $6925feee259dfec9$var$u = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M228,104a12,12,0,0,1-24,0V69l-59.51,59.51a12,12,0,0,1-17-17L187,52H152a12,12,0,0,1,0-24h64a12,12,0,0,1,12,12Zm-44,24a12,12,0,0,0-12,12v64H52V84h64a12,12,0,0,0,0-24H48A20,20,0,0,0,28,80V208a20,20,0,0,0,20,20H176a20,20,0,0,0,20-20V140A12,12,0,0,0,184,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M184,80V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H176A8,8,0,0,1,184,80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M192,136v72a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64h72a8,8,0,0,1,0,16H48V208H176V136a8,8,0,0,1,16,0Zm32-96a8,8,0,0,0-8-8H152a8,8,0,0,0-5.66,13.66L172.69,72l-42.35,42.34a8,8,0,0,0,11.32,11.32L184,83.31l26.34,26.35A8,8,0,0,0,224,104Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M222,104a6,6,0,0,1-12,0V54.49l-69.75,69.75a6,6,0,0,1-8.48-8.48L201.51,46H152a6,6,0,0,1,0-12h64a6,6,0,0,1,6,6Zm-38,26a6,6,0,0,0-6,6v72a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V80a2,2,0,0,1,2-2h72a6,6,0,0,0,0-12H48A14,14,0,0,0,34,80V208a14,14,0,0,0,14,14H176a14,14,0,0,0,14-14V136A6,6,0,0,0,184,130Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M220,104a4,4,0,0,1-8,0V49.66l-73.16,73.17a4,4,0,0,1-5.66-5.66L206.34,44H152a4,4,0,0,1,0-8h64a4,4,0,0,1,4,4Zm-36,28a4,4,0,0,0-4,4v72a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V80a4,4,0,0,1,4-4h72a4,4,0,0,0,0-8H48A12,12,0,0,0,36,80V208a12,12,0,0,0,12,12H176a12,12,0,0,0,12-12V136A4,4,0,0,0,184,132Z"
        }))
    ]
]), $6925feee259dfec9$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $6925feee259dfec9$var$H($6925feee259dfec9$var$n({
        ref: e
    }, t), {
        weights: $6925feee259dfec9$var$u
    })));
$6925feee259dfec9$export$2e2bcd8739ae039.displayName = "ArrowSquareOut";


var $acw62 = parcelRequire("acw62");


var $2ce0e4ed0f10866c$var$l = Object.defineProperty, $2ce0e4ed0f10866c$var$n = Object.defineProperties;
var $2ce0e4ed0f10866c$var$r = Object.getOwnPropertyDescriptors;
var $2ce0e4ed0f10866c$var$t = Object.getOwnPropertySymbols;
var $2ce0e4ed0f10866c$var$Z = Object.prototype.hasOwnProperty, $2ce0e4ed0f10866c$var$v = Object.prototype.propertyIsEnumerable;
var $2ce0e4ed0f10866c$var$C = (e, s, a)=>s in e ? $2ce0e4ed0f10866c$var$l(e, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: a
    }) : e[s] = a, $2ce0e4ed0f10866c$var$m = (e, s)=>{
    for(var a in s || (s = {}))$2ce0e4ed0f10866c$var$Z.call(s, a) && $2ce0e4ed0f10866c$var$C(e, a, s[a]);
    if ($2ce0e4ed0f10866c$var$t) for (var a of $2ce0e4ed0f10866c$var$t(s))$2ce0e4ed0f10866c$var$v.call(s, a) && $2ce0e4ed0f10866c$var$C(e, a, s[a]);
    return e;
}, $2ce0e4ed0f10866c$var$S = (e, s)=>$2ce0e4ed0f10866c$var$n(e, $2ce0e4ed0f10866c$var$r(s));
const $2ce0e4ed0f10866c$var$E = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M228.75,100.05c-3.52-3.67-7.15-7.46-8.34-10.33-1.06-2.56-1.14-7.83-1.21-12.47-.15-10-.34-22.44-9.18-31.27s-21.27-9-31.27-9.18c-4.64-.07-9.91-.15-12.47-1.21-2.87-1.19-6.66-4.82-10.33-8.34C148.87,20.46,140.05,12,128,12s-20.87,8.46-27.95,15.25c-3.67,3.52-7.46,7.15-10.33,8.34-2.56,1.06-7.83,1.14-12.47,1.21C67.25,37,54.81,37.14,46,46S37,67.25,36.8,77.25c-.07,4.64-.15,9.91-1.21,12.47-1.19,2.87-4.82,6.66-8.34,10.33C20.46,107.13,12,116,12,128S20.46,148.87,27.25,156c3.52,3.67,7.15,7.46,8.34,10.33,1.06,2.56,1.14,7.83,1.21,12.47.15,10,.34,22.44,9.18,31.27s21.27,9,31.27,9.18c4.64.07,9.91.15,12.47,1.21,2.87,1.19,6.66,4.82,10.33,8.34C107.13,235.54,116,244,128,244s20.87-8.46,27.95-15.25c3.67-3.52,7.46-7.15,10.33-8.34,2.56-1.06,7.83-1.14,12.47-1.21,10-.15,22.44-.34,31.27-9.18s9-21.27,9.18-31.27c.07-4.64.15-9.91,1.21-12.47,1.19-2.87,4.82-6.66,8.34-10.33C235.54,148.87,244,140.05,244,128S235.54,107.13,228.75,100.05Zm-17.32,39.29c-4.82,5-10.28,10.72-13.19,17.76-2.82,6.8-2.93,14.16-3,21.29-.08,5.36-.19,12.71-2.15,14.66s-9.3,2.07-14.66,2.15c-7.13.11-14.49.22-21.29,3-7,2.91-12.73,8.37-17.76,13.19C135.78,214.84,130.4,220,128,220s-7.78-5.16-11.34-8.57c-5-4.82-10.72-10.28-17.76-13.19-6.8-2.82-14.16-2.93-21.29-3-5.36-.08-12.71-.19-14.66-2.15s-2.07-9.3-2.15-14.66c-.11-7.13-.22-14.49-3-21.29-2.91-7-8.37-12.73-13.19-17.76C41.16,135.78,36,130.4,36,128s5.16-7.78,8.57-11.34c4.82-5,10.28-10.72,13.19-17.76,2.82-6.8,2.93-14.16,3-21.29C60.88,72.25,61,64.9,63,63s9.3-2.07,14.66-2.15c7.13-.11,14.49-.22,21.29-3,7-2.91,12.73-8.37,17.76-13.19C120.22,41.16,125.6,36,128,36s7.78,5.16,11.34,8.57c5,4.82,10.72,10.28,17.76,13.19,6.8,2.82,14.16,2.93,21.29,3,5.36.08,12.71.19,14.66,2.15s2.07,9.3,2.15,14.66c.11,7.13.22,14.49,3,21.29,2.91,7,8.37,12.73,13.19,17.76,3.41,3.56,8.57,8.94,8.57,11.34S214.84,135.78,211.43,139.34ZM144,180a16,16,0,1,1-16-16A16,16,0,0,1,144,180Zm28-72c0,18.37-13.69,33.88-32.27,38.56A12,12,0,0,1,116,144v-8a12,12,0,0,1,12-12c11,0,20-7.18,20-16s-9-16-20-16-20,7.18-20,16v4a12,12,0,0,1-24,0v-4c0-22.06,19.74-40,44-40S172,85.94,172,108Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M232,128c0,12.51-17.82,21.95-22.68,33.69-4.68,11.32,1.42,30.64-7.78,39.85s-28.53,3.1-39.85,7.78C150,214.18,140.5,232,128,232s-22-17.82-33.69-22.68c-11.32-4.68-30.65,1.42-39.85-7.78s-3.1-28.53-7.78-39.85C41.82,150,24,140.5,24,128s17.82-22,22.68-33.69C51.36,83,45.26,63.66,54.46,54.46S83,51.36,94.31,46.68C106.05,41.82,115.5,24,128,24S150,41.82,161.69,46.68c11.32,4.68,30.65-1.42,39.85,7.78s3.1,28.53,7.78,39.85C214.18,106.05,232,115.5,232,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M225.86,102.82c-3.77-3.94-7.67-8-9.14-11.57-1.36-3.27-1.44-8.69-1.52-13.94-.15-9.76-.31-20.82-8-28.51s-18.75-7.85-28.51-8c-5.25-.08-10.67-.16-13.94-1.52-3.56-1.47-7.63-5.37-11.57-9.14C146.28,23.51,138.44,16,128,16s-18.27,7.51-25.18,14.14c-3.94,3.77-8,7.67-11.57,9.14C88,40.64,82.56,40.72,77.31,40.8c-9.76.15-20.82.31-28.51,8S41,67.55,40.8,77.31c-.08,5.25-.16,10.67-1.52,13.94-1.47,3.56-5.37,7.63-9.14,11.57C23.51,109.72,16,117.56,16,128s7.51,18.27,14.14,25.18c3.77,3.94,7.67,8,9.14,11.57,1.36,3.27,1.44,8.69,1.52,13.94.15,9.76.31,20.82,8,28.51s18.75,7.85,28.51,8c5.25.08,10.67.16,13.94,1.52,3.56,1.47,7.63,5.37,11.57,9.14C109.72,232.49,117.56,240,128,240s18.27-7.51,25.18-14.14c3.94-3.77,8-7.67,11.57-9.14,3.27-1.36,8.69-1.44,13.94-1.52,9.76-.15,20.82-.31,28.51-8s7.85-18.75,8-28.51c.08-5.25.16-10.67,1.52-13.94,1.47-3.56,5.37-7.63,9.14-11.57C232.49,146.28,240,138.44,240,128S232.49,109.73,225.86,102.82Zm-11.55,39.29c-4.79,5-9.75,10.17-12.38,16.52-2.52,6.1-2.63,13.07-2.73,19.82-.1,7-.21,14.33-3.32,17.43s-10.39,3.22-17.43,3.32c-6.75.1-13.72.21-19.82,2.73-6.35,2.63-11.52,7.59-16.52,12.38S132,224,128,224s-9.15-4.92-14.11-9.69-10.17-9.75-16.52-12.38c-6.1-2.52-13.07-2.63-19.82-2.73-7-.1-14.33-.21-17.43-3.32s-3.22-10.39-3.32-17.43c-.1-6.75-.21-13.72-2.73-19.82-2.63-6.35-7.59-11.52-12.38-16.52S32,132,32,128s4.92-9.15,9.69-14.11,9.75-10.17,12.38-16.52c2.52-6.1,2.63-13.07,2.73-19.82.1-7,.21-14.33,3.32-17.43S70.51,56.9,77.55,56.8c6.75-.1,13.72-.21,19.82-2.73,6.35-2.63,11.52-7.59,16.52-12.38S124,32,128,32s9.15,4.92,14.11,9.69,10.17,9.75,16.52,12.38c6.1,2.52,13.07,2.63,19.82,2.73,7,.1,14.33.21,17.43,3.32s3.22,10.39,3.32,17.43c.1,6.75.21,13.72,2.73,19.82,2.63,6.35,7.59,11.52,12.38,16.52S224,124,224,128,219.08,137.15,214.31,142.11ZM140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180Zm28-72c0,17.38-13.76,31.93-32,35.28V144a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8c13.23,0,24-9,24-20s-10.77-20-24-20-24,9-24,20v4a8,8,0,0,1-16,0v-4c0-19.85,17.94-36,40-36S168,88.15,168,108Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M225.86,102.82c-3.77-3.94-7.67-8-9.14-11.57-1.36-3.27-1.44-8.69-1.52-13.94-.15-9.76-.31-20.82-8-28.51s-18.75-7.85-28.51-8c-5.25-.08-10.67-.16-13.94-1.52-3.56-1.47-7.63-5.37-11.57-9.14C146.28,23.51,138.44,16,128,16s-18.27,7.51-25.18,14.14c-3.94,3.77-8,7.67-11.57,9.14C88,40.64,82.56,40.72,77.31,40.8c-9.76.15-20.82.31-28.51,8S41,67.55,40.8,77.31c-.08,5.25-.16,10.67-1.52,13.94-1.47,3.56-5.37,7.63-9.14,11.57C23.51,109.72,16,117.56,16,128s7.51,18.27,14.14,25.18c3.77,3.94,7.67,8,9.14,11.57,1.36,3.27,1.44,8.69,1.52,13.94.15,9.76.31,20.82,8,28.51s18.75,7.85,28.51,8c5.25.08,10.67.16,13.94,1.52,3.56,1.47,7.63,5.37,11.57,9.14C109.72,232.49,117.56,240,128,240s18.27-7.51,25.18-14.14c3.94-3.77,8-7.67,11.57-9.14,3.27-1.36,8.69-1.44,13.94-1.52,9.76-.15,20.82-.31,28.51-8s7.85-18.75,8-28.51c.08-5.25.16-10.67,1.52-13.94,1.47-3.56,5.37-7.63,9.14-11.57C232.49,146.28,240,138.44,240,128S232.49,109.73,225.86,102.82ZM128,192a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm8-48.72V144a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8c13.23,0,24-9,24-20s-10.77-20-24-20-24,9-24,20v4a8,8,0,0,1-16,0v-4c0-19.85,17.94-36,40-36s40,16.15,40,36C168,125.38,154.24,139.93,136,143.28Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM138,180a10,10,0,1,1-10-10A10,10,0,0,1,138,180Zm28-72c0,16.92-13.89,31-32,33.58V144a6,6,0,0,1-12,0v-8a6,6,0,0,1,6-6c14.34,0,26-9.87,26-22s-11.66-22-26-22-26,9.87-26,22v4a6,6,0,0,1-12,0v-4c0-18.75,17-34,38-34S166,89.25,166,108Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M225.86,102.82c-3.77-3.94-7.67-8-9.14-11.57-1.36-3.27-1.44-8.69-1.52-13.94-.15-9.76-.31-20.82-8-28.51s-18.75-7.85-28.51-8c-5.25-.08-10.67-.16-13.94-1.52-3.56-1.47-7.63-5.37-11.57-9.14C146.28,23.51,138.44,16,128,16s-18.27,7.51-25.18,14.14c-3.94,3.77-8,7.67-11.57,9.14C88,40.64,82.56,40.72,77.31,40.8c-9.76.15-20.82.31-28.51,8S41,67.55,40.8,77.31c-.08,5.25-.16,10.67-1.52,13.94-1.47,3.56-5.37,7.63-9.14,11.57C23.51,109.72,16,117.56,16,128s7.51,18.27,14.14,25.18c3.77,3.94,7.67,8,9.14,11.57,1.36,3.27,1.44,8.69,1.52,13.94.15,9.76.31,20.82,8,28.51s18.75,7.85,28.51,8c5.25.08,10.67.16,13.94,1.52,3.56,1.47,7.63,5.37,11.57,9.14C109.72,232.49,117.56,240,128,240s18.27-7.51,25.18-14.14c3.94-3.77,8-7.67,11.57-9.14,3.27-1.36,8.69-1.44,13.94-1.52,9.76-.15,20.82-.31,28.51-8s7.85-18.75,8-28.51c.08-5.25.16-10.67,1.52-13.94,1.47-3.56,5.37-7.63,9.14-11.57C232.49,146.28,240,138.44,240,128S232.49,109.73,225.86,102.82Zm-11.55,39.29c-4.79,5-9.75,10.17-12.38,16.52-2.52,6.1-2.63,13.07-2.73,19.82-.1,7-.21,14.33-3.32,17.43s-10.39,3.22-17.43,3.32c-6.75.1-13.72.21-19.82,2.73-6.35,2.63-11.52,7.59-16.52,12.38S132,224,128,224s-9.15-4.92-14.11-9.69-10.17-9.75-16.52-12.38c-6.1-2.52-13.07-2.63-19.82-2.73-7-.1-14.33-.21-17.43-3.32s-3.22-10.39-3.32-17.43c-.1-6.75-.21-13.72-2.73-19.82-2.63-6.35-7.59-11.52-12.38-16.52S32,132,32,128s4.92-9.15,9.69-14.11,9.75-10.17,12.38-16.52c2.52-6.1,2.63-13.07,2.73-19.82.1-7,.21-14.33,3.32-17.43S70.51,56.9,77.55,56.8c6.75-.1,13.72-.21,19.82-2.73,6.35-2.63,11.52-7.59,16.52-12.38S124,32,128,32s9.15,4.92,14.11,9.69,10.17,9.75,16.52,12.38c6.1,2.52,13.07,2.63,19.82,2.73,7,.1,14.33.21,17.43,3.32s3.22,10.39,3.32,17.43c.1,6.75.21,13.72,2.73,19.82,2.63,6.35,7.59,11.52,12.38,16.52S224,124,224,128,219.08,137.15,214.31,142.11ZM140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180Zm28-72c0,17.38-13.76,31.93-32,35.28V144a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8c13.23,0,24-9,24-20s-10.77-20-24-20-24,9-24,20v4a8,8,0,0,1-16,0v-4c0-19.85,17.94-36,40-36S168,88.15,168,108Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M223,105.58c-4-4.2-8.2-8.54-10-12.8-1.65-4-1.73-9.53-1.82-15.41-.14-9-.29-19.19-6.83-25.74s-16.74-6.69-25.74-6.83c-5.88-.09-11.43-.17-15.41-1.82-4.26-1.76-8.6-5.93-12.8-9.95-6.68-6.41-13.59-13-22.42-13s-15.74,6.62-22.42,13c-4.2,4-8.54,8.2-12.8,10-4,1.65-9.53,1.73-15.41,1.82-9,.14-19.19.29-25.74,6.83S44.94,68.37,44.8,77.37c-.09,5.88-.17,11.43-1.82,15.41-1.76,4.26-5.93,8.6-9.95,12.8-6.41,6.68-13,13.59-13,22.42s6.62,15.74,13,22.42c4,4.2,8.2,8.54,10,12.8,1.65,4,1.73,9.53,1.82,15.41.14,9,.29,19.19,6.83,25.74s16.74,6.69,25.74,6.83c5.88.09,11.43.17,15.41,1.82,4.26,1.76,8.6,5.93,12.8,9.95,6.68,6.41,13.59,13,22.42,13s15.74-6.62,22.42-13c4.2-4,8.54-8.2,12.8-10,4-1.65,9.53-1.73,15.41-1.82,9-.14,19.19-.29,25.74-6.83s6.69-16.74,6.83-25.74c.09-5.88.17-11.43,1.82-15.41,1.76-4.26,5.93-8.6,9.95-12.8,6.41-6.68,13-13.59,13-22.42S229.38,112.26,223,105.58Zm-5.78,39.3c-4.54,4.73-9.24,9.63-11.57,15.28-2.23,5.39-2.33,12-2.43,18.35-.12,8.2-.24,16-4.49,20.2s-12,4.37-20.2,4.49c-6.37.1-13,.2-18.35,2.43-5.65,2.33-10.55,7-15.28,11.57C139.09,222.75,133.62,228,128,228s-11.09-5.25-16.88-10.8c-4.73-4.54-9.63-9.24-15.28-11.57-5.39-2.23-12-2.33-18.35-2.43-8.2-.12-15.95-.24-20.2-4.49s-4.37-12-4.49-20.2c-.1-6.37-.2-13-2.43-18.35-2.33-5.65-7-10.55-11.57-15.28C33.25,139.09,28,133.62,28,128s5.25-11.09,10.8-16.88c4.54-4.73,9.24-9.63,11.57-15.28,2.23-5.39,2.33-12,2.43-18.35.12-8.2.24-15.95,4.49-20.2s12-4.37,20.2-4.49c6.37-.1,13-.2,18.35-2.43,5.65-2.33,10.55-7,15.28-11.57C116.91,33.25,122.38,28,128,28s11.09,5.25,16.88,10.8c4.73,4.54,9.63,9.24,15.28,11.57,5.39,2.23,12,2.33,18.35,2.43,8.2.12,16,.24,20.2,4.49s4.37,12,4.49,20.2c.1,6.37.2,13,2.43,18.35,2.33,5.65,7,10.55,11.57,15.28,5.55,5.79,10.8,11.26,10.8,16.88S222.75,139.09,217.2,144.88ZM136,180a8,8,0,1,1-8-8A8,8,0,0,1,136,180Zm28-72c0,16.44-14,30-32,31.8V144a4,4,0,0,1-8,0v-8a4,4,0,0,1,4-4c15.44,0,28-10.77,28-24s-12.56-24-28-24-28,10.77-28,24v4a4,4,0,0,1-8,0v-4c0-17.64,16.15-32,36-32S164,90.36,164,108Z"
        }))
    ]
]), $2ce0e4ed0f10866c$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((e, s)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $2ce0e4ed0f10866c$var$S($2ce0e4ed0f10866c$var$m({
        ref: s
    }, e), {
        weights: $2ce0e4ed0f10866c$var$E
    })));
$2ce0e4ed0f10866c$export$2e2bcd8739ae039.displayName = "SealQuestion";


var $acw62 = parcelRequire("acw62");


var $67aa543a4d20f937$var$o = Object.defineProperty, $67aa543a4d20f937$var$p = Object.defineProperties;
var $67aa543a4d20f937$var$E = Object.getOwnPropertyDescriptors;
var $67aa543a4d20f937$var$n = Object.getOwnPropertySymbols;
var $67aa543a4d20f937$var$d = Object.prototype.hasOwnProperty, $67aa543a4d20f937$var$A = Object.prototype.propertyIsEnumerable;
var $67aa543a4d20f937$var$r = (t, a, l)=>a in t ? $67aa543a4d20f937$var$o(t, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[a] = l, $67aa543a4d20f937$var$m = (t, a)=>{
    for(var l in a || (a = {}))$67aa543a4d20f937$var$d.call(a, l) && $67aa543a4d20f937$var$r(t, l, a[l]);
    if ($67aa543a4d20f937$var$n) for (var l of $67aa543a4d20f937$var$n(a))$67aa543a4d20f937$var$A.call(a, l) && $67aa543a4d20f937$var$r(t, l, a[l]);
    return t;
}, $67aa543a4d20f937$var$c = (t, a)=>$67aa543a4d20f937$var$p(t, $67aa543a4d20f937$var$E(a));
const $67aa543a4d20f937$var$M = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M234.49,111.07,90.41,22.94A20,20,0,0,0,60,39.87V216.13a20,20,0,0,0,30.41,16.93l144.08-88.13a19.82,19.82,0,0,0,0-33.86ZM84,208.85V47.15L216.16,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M228.23,134.69,84.15,222.81A8,8,0,0,1,72,216.12V39.88a8,8,0,0,1,12.15-6.69l144.08,88.12A7.82,7.82,0,0,1,228.23,134.69Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M232.4,114.49,88.32,26.35a16,16,0,0,0-16.2-.3A15.86,15.86,0,0,0,64,39.87V216.13A15.94,15.94,0,0,0,80,232a16.07,16.07,0,0,0,8.36-2.35L232.4,141.51a15.81,15.81,0,0,0,0-27ZM80,215.94V40l143.83,88Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M231.36,116.19,87.28,28.06a14,14,0,0,0-14.18-.27A13.69,13.69,0,0,0,66,39.87V216.13a13.69,13.69,0,0,0,7.1,12.08,14,14,0,0,0,14.18-.27l144.08-88.13a13.82,13.82,0,0,0,0-23.62Zm-6.26,13.38L81,217.7a2,2,0,0,1-2.06,0,1.78,1.78,0,0,1-1-1.61V39.87a1.78,1.78,0,0,1,1-1.61A2.06,2.06,0,0,1,80,38a2,2,0,0,1,1,.31L225.1,126.43a1.82,1.82,0,0,1,0,3.14Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M232.4,114.49,88.32,26.35a16,16,0,0,0-16.2-.3A15.86,15.86,0,0,0,64,39.87V216.13A15.94,15.94,0,0,0,80,232a16.07,16.07,0,0,0,8.36-2.35L232.4,141.51a15.81,15.81,0,0,0,0-27ZM80,215.94V40l143.83,88Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M230.32,117.9,86.24,29.79a11.91,11.91,0,0,0-12.17-.23A11.71,11.71,0,0,0,68,39.89V216.11a11.71,11.71,0,0,0,6.07,10.33,11.91,11.91,0,0,0,12.17-.23L230.32,138.1a11.82,11.82,0,0,0,0-20.2Zm-4.18,13.37L82.06,219.39a4,4,0,0,1-4.07.07,3.77,3.77,0,0,1-2-3.35V39.89a3.77,3.77,0,0,1,2-3.35,4,4,0,0,1,4.07.07l144.08,88.12a3.8,3.8,0,0,1,0,6.54Z"
        }))
    ]
]), $67aa543a4d20f937$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $67aa543a4d20f937$var$c($67aa543a4d20f937$var$m({
        ref: a
    }, t), {
        weights: $67aa543a4d20f937$var$M
    })));
$67aa543a4d20f937$export$2e2bcd8739ae039.displayName = "Play";




var $acw62 = parcelRequire("acw62");
var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


const $0190bc205d696513$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { asAnchor: asAnchor, href: href, leftIcon: leftIcon, rightIcon: rightIcon, children: children, className: className, ...rest } = props;
    const rootProps = {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("flex items-center justify-between text-base space-x-1 bg-logseq-400 rounded-lg py-3 px-4 whitespace-nowrap", "transition-opacity hover:opacity-80 active:opacity-100 disabled:hover:opacity-100", className)
    };
    if (href && !asAnchor) rootProps.onClick = ()=>{
        window?.open(href, "_blank");
    };
    const inner = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "l flex items-center",
                children: [
                    leftIcon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "pr-1.5",
                        children: leftIcon
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: children
                    })
                ]
            }),
            rightIcon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: "pl-1",
                children: rightIcon
            })
        ]
    });
    if (asAnchor) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: href,
        ...Object.assign(rootProps, rest),
        children: inner
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ...Object.assign(rootProps, rest),
        children: inner
    });
});




var $acw62 = parcelRequire("acw62");

const $58e8d8f711de3215$export$6732c884469525e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { children: children, className: className, delay: delay, animation: animation, ...rest } = props;
    const [animateClass, setAnimateClass] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        setTimeout(()=>{
            setAnimateClass(`ani-${animation || "slide-in-from-bottom"}`);
        }, delay || 1000);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("glass-card", "backdrop-blur-5xl", animateClass, className),
        style: {
            animationDuration: 20000
        },
        ...rest,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "glass-card-inner",
            children: children
        })
    });
});





var $acw62 = parcelRequire("acw62");


var $813e96925f3ecd9f$var$n = Object.defineProperty, $813e96925f3ecd9f$var$r = Object.defineProperties;
var $813e96925f3ecd9f$var$C = Object.getOwnPropertyDescriptors;
var $813e96925f3ecd9f$var$c = Object.getOwnPropertySymbols;
var $813e96925f3ecd9f$var$Z = Object.prototype.hasOwnProperty, $813e96925f3ecd9f$var$o = Object.prototype.propertyIsEnumerable;
var $813e96925f3ecd9f$var$l = (t, e, A)=>e in t ? $813e96925f3ecd9f$var$n(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: A
    }) : t[e] = A, $813e96925f3ecd9f$var$h = (t, e)=>{
    for(var A in e || (e = {}))$813e96925f3ecd9f$var$Z.call(e, A) && $813e96925f3ecd9f$var$l(t, A, e[A]);
    if ($813e96925f3ecd9f$var$c) for (var A of $813e96925f3ecd9f$var$c(e))$813e96925f3ecd9f$var$o.call(e, A) && $813e96925f3ecd9f$var$l(t, A, e[A]);
    return t;
}, $813e96925f3ecd9f$var$m = (t, e)=>$813e96925f3ecd9f$var$r(t, $813e96925f3ecd9f$var$C(e));
const $813e96925f3ecd9f$var$M = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M227,168a12,12,0,0,0-4.21-5.09C207.25,152.22,204,133.68,204,120c0-16.17,12.68-30.6,20.25-37.76a12,12,0,0,0,0-17.43C210.89,52.17,188.81,44,168,44a76.29,76.29,0,0,0-40,11.37,75.59,75.59,0,0,0-93.58,11A78.64,78.64,0,0,0,12,123.51,131,131,0,0,0,53.43,216,43.81,43.81,0,0,0,83.6,228h87.69a43.87,43.87,0,0,0,32.05-13.85,127.63,127.63,0,0,0,18.4-25.39c1.57-2.88,3-5.71,4.14-8.41C227.47,176.67,229.12,172.87,227,168Zm-41.23,29.82A19.78,19.78,0,0,1,171.29,204H83.6a19.85,19.85,0,0,1-13.7-5.42A107.18,107.18,0,0,1,36,122.88,54.49,54.49,0,0,1,51.5,83.28,50.86,50.86,0,0,1,88,68h.72A51.5,51.5,0,0,1,120.48,79.4a12,12,0,0,0,15,0A51.41,51.41,0,0,1,168,68a67.24,67.24,0,0,1,29.88,7.4C186.26,89.66,180,105.13,180,120c0,23.33,7.47,42.89,21.25,56.19A103.3,103.3,0,0,1,185.76,197.81ZM128.75,13A43.83,43.83,0,0,1,142.17,1.51a12,12,0,0,1,11.64,21,19.84,19.84,0,0,0-6.11,5.24A12,12,0,0,1,128.75,13Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,73.52Zm0,99.26c-16.79-11.53-24-30.87-24-52.78,0-18.3,11.68-34.81,24-46.48C204.53,62.66,185,56,168,56a63.72,63.72,0,0,0-40,14h0A63.71,63.71,0,0,0,88.88,56C52,55.5,23.06,86.3,24,123.19a119.62,119.62,0,0,0,37.65,84.12A32,32,0,0,0,83.6,216h87.7a31.75,31.75,0,0,0,23.26-10c15.85-17,21.44-33.2,21.44-33.2Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M223.3,169.59a8.07,8.07,0,0,0-2.8-3.4C203.53,154.53,200,134.64,200,120c0-17.67,13.47-33.06,21.5-40.67a8,8,0,0,0,0-11.62C208.82,55.74,187.82,48,168,48a72.23,72.23,0,0,0-40,12.13,71.56,71.56,0,0,0-90.71,9.09A74.63,74.63,0,0,0,16,123.4a127,127,0,0,0,40.14,89.73A39.8,39.8,0,0,0,83.59,224h87.68a39.84,39.84,0,0,0,29.12-12.57,125,125,0,0,0,17.82-24.6C225.23,174,224.33,172,223.3,169.59Zm-34.63,30.94a23.76,23.76,0,0,1-17.4,7.47H83.59a23.82,23.82,0,0,1-16.44-6.51A111.14,111.14,0,0,1,32,123,58.5,58.5,0,0,1,48.65,80.47,54.81,54.81,0,0,1,88,64h.78A55.45,55.45,0,0,1,123,76.28a8,8,0,0,0,10,0A55.39,55.39,0,0,1,168,64a70.64,70.64,0,0,1,36,10.35c-13,14.52-20,30.47-20,45.65,0,23.77,7.64,42.73,22.18,55.3A105.52,105.52,0,0,1,188.67,200.53ZM128.23,30A40,40,0,0,1,167,0h1a8,8,0,0,1,0,16h-1a24,24,0,0,0-23.24,18,8,8,0,1,1-15.5-4Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128.23,30A40,40,0,0,1,167,0h1a8,8,0,0,1,0,16h-1a24,24,0,0,0-23.24,18,8,8,0,1,1-15.5-4ZM223.3,169.59a8.07,8.07,0,0,0-2.8-3.4C203.53,154.53,200,134.64,200,120c0-17.67,13.47-33.06,21.5-40.67a8,8,0,0,0,0-11.62C208.82,55.74,187.82,48,168,48a72.23,72.23,0,0,0-40,12.13,71.56,71.56,0,0,0-90.71,9.09A74.63,74.63,0,0,0,16,123.4a127,127,0,0,0,40.14,89.73A39.8,39.8,0,0,0,83.59,224h87.68a39.84,39.84,0,0,0,29.12-12.57,125,125,0,0,0,17.82-24.6C225.23,174,224.33,172,223.3,169.59Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M219.4,167.84C201.71,155.69,198,135.12,198,120c0-18.42,13.86-34.29,22.12-42.12a6,6,0,0,0,0-8.71C208,57.7,187.07,50,168,50a70.23,70.23,0,0,0-40,12.55,69.6,69.6,0,0,0-89.31,8.08A72.63,72.63,0,0,0,18,123.35a125.11,125.11,0,0,0,39.53,88.33A37.85,37.85,0,0,0,83.6,222h87.7A37.83,37.83,0,0,0,199,210.07a122.6,122.6,0,0,0,17.54-24.2c6.55-12,5.77-13.75,5-15.48A6.07,6.07,0,0,0,219.4,167.84Zm-29.23,34A25.82,25.82,0,0,1,171.3,210H83.6A25.85,25.85,0,0,1,65.78,203,113.21,113.21,0,0,1,30,123a60.55,60.55,0,0,1,17.21-44A56.82,56.82,0,0,1,88,62h.81a57.35,57.35,0,0,1,35.44,12.71,6,6,0,0,0,7.5,0A57.39,57.39,0,0,1,168,62c13.89,0,28.81,4.68,39.11,12-9.44,10.14-21.1,26.59-21.1,46,0,23.78,7.81,42.6,22.66,54.77A107.33,107.33,0,0,1,190.17,201.89Zm-60-171.39A38,38,0,0,1,167,2h1a6,6,0,0,1,0,12h-1a26,26,0,0,0-25.18,19.5,6,6,0,1,1-11.62-3Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M223.3,169.59a8.07,8.07,0,0,0-2.8-3.4C203.53,154.53,200,134.64,200,120c0-17.67,13.47-33.06,21.5-40.67a8,8,0,0,0,0-11.62C208.82,55.74,187.82,48,168,48a72.2,72.2,0,0,0-40,12.13,71.56,71.56,0,0,0-90.71,9.09A74.63,74.63,0,0,0,16,123.4a127.06,127.06,0,0,0,40.14,89.73A39.8,39.8,0,0,0,83.59,224h87.68a39.84,39.84,0,0,0,29.12-12.57,125,125,0,0,0,17.82-24.6C225.23,174,224.33,172,223.3,169.59Zm-34.63,30.94a23.76,23.76,0,0,1-17.4,7.47H83.59a23.82,23.82,0,0,1-16.44-6.51A111.14,111.14,0,0,1,32,123,58.5,58.5,0,0,1,48.65,80.47,54.81,54.81,0,0,1,88,64h.78A55.45,55.45,0,0,1,123,76.28a8,8,0,0,0,10,0A55.44,55.44,0,0,1,168,64a70.64,70.64,0,0,1,36,10.35c-13,14.52-20,30.47-20,45.65,0,23.77,7.64,42.73,22.18,55.3A105.82,105.82,0,0,1,188.67,200.53ZM128.23,30A40,40,0,0,1,167,0h1a8,8,0,0,1,0,16h-1a24,24,0,0,0-23.24,18,8,8,0,1,1-15.5-4Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M218.27,169.49C199.86,156.84,196,135.6,196,120c0-19.17,14.25-35.53,22.75-43.57a4,4,0,0,0,0-5.81C207,59.48,186.59,52,168,52a68.3,68.3,0,0,0-40,13,67.61,67.61,0,0,0-87.88,7A70.65,70.65,0,0,0,20,123.3a123.11,123.11,0,0,0,38.9,86.92A35.81,35.81,0,0,0,83.6,220h87.7a35.84,35.84,0,0,0,26.19-11.3,119.93,119.93,0,0,0,17.24-23.79c6.08-11.1,5.42-12.62,4.94-13.72A4,4,0,0,0,218.27,169.49Zm-26.64,33.77A27.83,27.83,0,0,1,171.3,212H83.6a27.84,27.84,0,0,1-19.19-7.6A115.15,115.15,0,0,1,28,123.09,62.55,62.55,0,0,1,45.81,77.66,58.78,58.78,0,0,1,88,60h.84a59.37,59.37,0,0,1,36.66,13.15,4,4,0,0,0,5,0A59.35,59.35,0,0,1,168,60c15.12,0,31.45,5.41,42.11,13.73C200.68,83.42,188,100.16,188,120c0,23.79,8,42.44,23.12,54.17A107.64,107.64,0,0,1,191.63,203.26ZM132.13,31A36,36,0,0,1,167,4h1a4,4,0,0,1,0,8h-1a28,28,0,0,0-27.12,21A4,4,0,0,1,136,36a3.87,3.87,0,0,1-1-.13A4,4,0,0,1,132.13,31Z"
        }))
    ]
]), $813e96925f3ecd9f$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $813e96925f3ecd9f$var$m($813e96925f3ecd9f$var$h({
        ref: e
    }, t), {
        weights: $813e96925f3ecd9f$var$M
    })));
$813e96925f3ecd9f$export$2e2bcd8739ae039.displayName = "AppleLogo";


var $acw62 = parcelRequire("acw62");


var $db1c918c88a5ca18$var$L = Object.defineProperty, $db1c918c88a5ca18$var$o = Object.defineProperties;
var $db1c918c88a5ca18$var$Z = Object.getOwnPropertyDescriptors;
var $db1c918c88a5ca18$var$n = Object.getOwnPropertySymbols;
var $db1c918c88a5ca18$var$c = Object.prototype.hasOwnProperty, $db1c918c88a5ca18$var$p = Object.prototype.propertyIsEnumerable;
var $db1c918c88a5ca18$var$r = (l, e, t)=>e in l ? $db1c918c88a5ca18$var$L(l, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : l[e] = t, $db1c918c88a5ca18$var$m = (l, e)=>{
    for(var t in e || (e = {}))$db1c918c88a5ca18$var$c.call(e, t) && $db1c918c88a5ca18$var$r(l, t, e[t]);
    if ($db1c918c88a5ca18$var$n) for (var t of $db1c918c88a5ca18$var$n(e))$db1c918c88a5ca18$var$p.call(e, t) && $db1c918c88a5ca18$var$r(l, t, e[t]);
    return l;
}, $db1c918c88a5ca18$var$H = (l, e)=>$db1c918c88a5ca18$var$o(l, $db1c918c88a5ca18$var$Z(e));
const $db1c918c88a5ca18$var$E = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M244,160a12,12,0,0,1-12,12H200.67l17.66,29.89a12,12,0,1,1-20.66,12.21L140.9,118a12,12,0,0,1,20.66-12.2L186.48,148H232A12,12,0,0,1,244,160ZM133.15,148H97.39L162.33,38.11A12,12,0,1,0,141.67,25.9L128,49,114.33,25.9A12,12,0,1,0,93.67,38.11l20.39,34.51L69.52,148H24a12,12,0,0,0,0,24H133.15a12,12,0,0,0,0-24ZM58.83,189.67a12,12,0,0,0-16.43,4.22l-4.73,8A12,12,0,1,0,58.33,214.1l4.73-8A12,12,0,0,0,58.83,189.67Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M179.64,160H76.36L128,72.62Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M64.34,196.07l-9.45,16a8,8,0,1,1-13.78-8.14l9.46-16a8,8,0,1,1,13.77,8.14ZM232,152H184.2l-30.73-52a8,8,0,1,0-13.77,8.14l61.41,103.93a8,8,0,0,0,13.78-8.14L193.66,168H232a8,8,0,0,0,0-16Zm-89.53,0H90.38L158.89,36.07a8,8,0,0,0-13.78-8.14L128,56.89l-17.11-29a8,8,0,1,0-13.78,8.14l21.6,36.55L71.8,152H24a8,8,0,0,0,0,16H142.47a8,8,0,1,0,0-16Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM83.66,180.12l-4.8,8a8,8,0,1,1-13.72-8.24l4.8-8a8,8,0,0,1,13.72,8.24ZM128,152H56a8,8,0,0,1,0-16H91.47l27.2-45.33L105.14,68.12a8,8,0,0,1,13.72-8.24L128,75.12l9.14-15.24a8,8,0,0,1,13.72,8.24L110.13,136H128a8,8,0,0,1,0,16Zm72,0H174.13l16.73,27.88a8,8,0,0,1-13.72,8.24l-38.4-64a8,8,0,0,1,13.72-8.24L164.53,136H200a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M62.62,195.05l-9.45,16A6,6,0,0,1,42.83,205l9.46-16a6,6,0,1,1,10.33,6.1ZM232,154H183.06l-31.31-53a6,6,0,1,0-10.33,6.11l61.41,103.93a6,6,0,0,0,10.34-6.1l-23-38.95H232a6,6,0,0,0,0-12Zm-89.53,0H86.88L157.17,35.05A6,6,0,0,0,146.83,29L128,60.82,109.17,29a6,6,0,0,0-10.34,6.1L121,72.62,72.94,154H24a6,6,0,0,0,0,12H142.47a6,6,0,1,0,0-12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M64.34,196.07l-9.45,16a8,8,0,1,1-13.78-8.14l9.46-16a8,8,0,1,1,13.77,8.14ZM232,152H184.2l-30.73-52a8,8,0,1,0-13.77,8.14l61.41,103.93a8,8,0,0,0,13.78-8.14L193.66,168H232a8,8,0,0,0,0-16Zm-89.53,0H90.38L158.89,36.07a8,8,0,0,0-13.78-8.14L128,56.89l-17.11-29a8,8,0,1,0-13.78,8.14l21.6,36.55L71.8,152H24a8,8,0,0,0,0,16H142.47a8,8,0,1,0,0-16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M60.9,194l-9.46,16A4,4,0,1,1,44.56,206L54,190A4,4,0,0,1,60.9,194ZM232,156H181.92L150,102a4,4,0,1,0-6.89,4.07L204.56,210a4,4,0,1,0,6.88-4.07l-24.79-42H232a4,4,0,0,0,0-8Zm-89.53,0H83.37L155.44,34A4,4,0,1,0,148.56,30L128,64.75,107.44,30A4,4,0,1,0,100.56,34l22.79,38.58L74.08,156H24a4,4,0,0,0,0,8H142.47a4,4,0,1,0,0-8Z"
        }))
    ]
]), $db1c918c88a5ca18$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((l, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $db1c918c88a5ca18$var$H($db1c918c88a5ca18$var$m({
        ref: e
    }, l), {
        weights: $db1c918c88a5ca18$var$E
    })));
$db1c918c88a5ca18$export$2e2bcd8739ae039.displayName = "AppStoreLogo";


var $acw62 = parcelRequire("acw62");


var $ded21779901b8c91$var$o = Object.defineProperty, $ded21779901b8c91$var$p = Object.defineProperties;
var $ded21779901b8c91$var$E = Object.getOwnPropertyDescriptors;
var $ded21779901b8c91$var$n = Object.getOwnPropertySymbols;
var $ded21779901b8c91$var$d = Object.prototype.hasOwnProperty, $ded21779901b8c91$var$h = Object.prototype.propertyIsEnumerable;
var $ded21779901b8c91$var$r = (a, t, l)=>t in a ? $ded21779901b8c91$var$o(a, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : a[t] = l, $ded21779901b8c91$var$m = (a, t)=>{
    for(var l in t || (t = {}))$ded21779901b8c91$var$d.call(t, l) && $ded21779901b8c91$var$r(a, l, t[l]);
    if ($ded21779901b8c91$var$n) for (var l of $ded21779901b8c91$var$n(t))$ded21779901b8c91$var$h.call(t, l) && $ded21779901b8c91$var$r(a, l, t[l]);
    return a;
}, $ded21779901b8c91$var$c = (a, t)=>$ded21779901b8c91$var$p(a, $ded21779901b8c91$var$E(t));
const $ded21779901b8c91$var$u = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,96l-80,80L48,96Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z"
        }))
    ]
]), $ded21779901b8c91$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((a, t)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $ded21779901b8c91$var$c($ded21779901b8c91$var$m({
        ref: t
    }, a), {
        weights: $ded21779901b8c91$var$u
    })));
$ded21779901b8c91$export$2e2bcd8739ae039.displayName = "CaretDown";


var $acw62 = parcelRequire("acw62");


var $30a677830140f77c$var$V = Object.defineProperty, $30a677830140f77c$var$o = Object.defineProperties;
var $30a677830140f77c$var$v = Object.getOwnPropertyDescriptors;
var $30a677830140f77c$var$n = Object.getOwnPropertySymbols;
var $30a677830140f77c$var$p = Object.prototype.hasOwnProperty, $30a677830140f77c$var$d = Object.prototype.propertyIsEnumerable;
var $30a677830140f77c$var$m = (t, e, l)=>e in t ? $30a677830140f77c$var$V(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[e] = l, $30a677830140f77c$var$r = (t, e)=>{
    for(var l in e || (e = {}))$30a677830140f77c$var$p.call(e, l) && $30a677830140f77c$var$m(t, l, e[l]);
    if ($30a677830140f77c$var$n) for (var l of $30a677830140f77c$var$n(e))$30a677830140f77c$var$d.call(e, l) && $30a677830140f77c$var$m(t, l, e[l]);
    return t;
}, $30a677830140f77c$var$c = (t, e)=>$30a677830140f77c$var$o(t, $30a677830140f77c$var$v(e));
const $30a677830140f77c$var$Z = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M228,152v56a20,20,0,0,1-20,20H48a20,20,0,0,1-20-20V152a12,12,0,0,1,24,0v52H204V152a12,12,0,0,1,24,0Zm-108.49,8.49a12,12,0,0,0,17,0l40-40a12,12,0,0,0-17-17L140,123V40a12,12,0,0,0-24,0v83L96.49,103.51a12,12,0,0,0-17,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M168,112l-40,40L88,112Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,152v56a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v56H208V152a8,8,0,0,1,16,0ZM82.34,117.66A8,8,0,0,1,88,104h32V40a8,8,0,0,1,16,0v64h32a8,8,0,0,1,5.66,13.66l-40,40a8,8,0,0,1-11.32,0Zm25,2.34L128,140.69,148.69,120Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M82.34,117.66A8,8,0,0,1,88,104h32V40a8,8,0,0,1,16,0v64h32a8,8,0,0,1,5.66,13.66l-40,40a8,8,0,0,1-11.32,0ZM216,144a8,8,0,0,0-8,8v56H48V152a8,8,0,0,0-16,0v56a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A8,8,0,0,0,216,144Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M222,152v56a14,14,0,0,1-14,14H48a14,14,0,0,1-14-14V152a6,6,0,0,1,12,0v56a2,2,0,0,0,2,2H208a2,2,0,0,0,2-2V152a6,6,0,0,1,12,0Zm-98.24,4.24a6,6,0,0,0,8.48,0l40-40a6,6,0,0,0-8.48-8.48L134,137.51V40a6,6,0,0,0-12,0v97.51L92.24,107.76a6,6,0,0,0-8.48,8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,152v56a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v56H208V152a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,132.69V40a8,8,0,0,0-16,0v92.69L93.66,106.34a8,8,0,0,0-11.32,11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M220,152v56a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V152a4,4,0,0,1,8,0v56a4,4,0,0,0,4,4H208a4,4,0,0,0,4-4V152a4,4,0,0,1,8,0Zm-94.83,2.83a4,4,0,0,0,5.66,0l40-40a4,4,0,1,0-5.66-5.66L132,142.34V40a4,4,0,0,0-8,0V142.34L90.83,109.17a4,4,0,0,0-5.66,5.66Z"
        }))
    ]
]), $30a677830140f77c$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $30a677830140f77c$var$c($30a677830140f77c$var$r({
        ref: e
    }, t), {
        weights: $30a677830140f77c$var$Z
    })));
$30a677830140f77c$export$2e2bcd8739ae039.displayName = "DownloadSimple";


var $acw62 = parcelRequire("acw62");


var $039f66a52898037d$var$M = Object.defineProperty, $039f66a52898037d$var$o = Object.defineProperties;
var $039f66a52898037d$var$c = Object.getOwnPropertyDescriptors;
var $039f66a52898037d$var$m = Object.getOwnPropertySymbols;
var $039f66a52898037d$var$L = Object.prototype.hasOwnProperty, $039f66a52898037d$var$p = Object.prototype.propertyIsEnumerable;
var $039f66a52898037d$var$n = (l, a, t)=>a in l ? $039f66a52898037d$var$M(l, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : l[a] = t, $039f66a52898037d$var$r = (l, a)=>{
    for(var t in a || (a = {}))$039f66a52898037d$var$L.call(a, t) && $039f66a52898037d$var$n(l, t, a[t]);
    if ($039f66a52898037d$var$m) for (var t of $039f66a52898037d$var$m(a))$039f66a52898037d$var$p.call(a, t) && $039f66a52898037d$var$n(l, t, a[t]);
    return l;
}, $039f66a52898037d$var$Z = (l, a)=>$039f66a52898037d$var$o(l, $039f66a52898037d$var$c(a));
const $039f66a52898037d$var$d = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M225.79,110.7,58,14.65a20.24,20.24,0,0,0-20.12.06A19.62,19.62,0,0,0,28,31.84V224.16a19.62,19.62,0,0,0,9.91,17.13,20.22,20.22,0,0,0,20.12.06l167.76-96a19.76,19.76,0,0,0,0-34.6ZM52,203V53l75,75ZM144,145l12.4,12.4-58,33.2ZM98.41,65.43l58,33.2L144,111ZM178,145l-17-17,17-17,29.72,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M144,128,42.32,230A7.7,7.7,0,0,1,40,224.45V31.55A7.7,7.7,0,0,1,42.32,26Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M223.82,114.18,56,18.16a16,16,0,0,0-16.12,0A15.68,15.68,0,0,0,32,31.87V224.13a15.68,15.68,0,0,0,7.92,13.67,16,16,0,0,0,16.12,0l167.78-96a15.76,15.76,0,0,0,0-27.64ZM48,212.67V43.33L132.69,128Zm96-73.36,18.92,18.92-88.5,50.66ZM74.4,47.1l88.53,50.67L144,116.69ZM177.31,150l-22-22,22-22,38.43,22Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M223.82,114.18,56,18.16a16,16,0,0,0-16.12,0A15.68,15.68,0,0,0,32,31.87V224.13a15.68,15.68,0,0,0,7.92,13.67,16,16,0,0,0,16.12,0l167.78-96a15.76,15.76,0,0,0,0-27.64ZM144,139.31l18.92,18.92-88.5,50.66ZM74.4,47.1l88.53,50.67L144,116.69ZM177.31,150l-22-22,22-22,38.43,22Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M222.84,115.93,55,19.89a14,14,0,0,0-14.12,0A13.68,13.68,0,0,0,34,31.87V224.13a13.68,13.68,0,0,0,6.92,11.94,14,14,0,0,0,14.12,0l167.8-96a13.75,13.75,0,0,0,0-24.14ZM46,217.5V38.5L135.51,128Zm98-81,22.19,22.19L62.4,218.07ZM62.4,37.93l103.79,59.4L144,119.52ZM217,129.58l-.1.06L177,152.49,152.49,128,177,103.51l39.94,22.85.1.06a1.76,1.76,0,0,1,0,3.16Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M223.82,114.19,56,18.16a16,16,0,0,0-16.12,0A15.68,15.68,0,0,0,32,31.87V224.13a15.68,15.68,0,0,0,7.92,13.67,16,16,0,0,0,16.12,0l167.78-96a15.75,15.75,0,0,0,0-27.62ZM48,212.67V43.33L132.69,128Zm96-73.36,18.92,18.92-88.5,50.66ZM74.4,47.1l88.53,50.67L144,116.69ZM177.31,150l-22-22,22-22,38.43,22Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M221.89,117.69,54.05,21.62a12,12,0,0,0-12.13,0A11.69,11.69,0,0,0,36,31.87V224.13a11.69,11.69,0,0,0,5.92,10.21,12,12,0,0,0,12.13,0l167.77-96a11.76,11.76,0,0,0,.07-20.66Zm-52.44-20.8L144,122.34,50.4,28.75ZM44,222.33V33.67L138.34,128Zm6.4,4.92L144,133.66l25.45,25.45Zm167.51-95.88L176.65,155l-27-27,27-27L218,124.66a3.77,3.77,0,0,1-.07,6.71Z"
        }))
    ]
]), $039f66a52898037d$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((l, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $039f66a52898037d$var$Z($039f66a52898037d$var$r({
        ref: a
    }, l), {
        weights: $039f66a52898037d$var$d
    })));
$039f66a52898037d$export$2e2bcd8739ae039.displayName = "GooglePlayLogo";


var $acw62 = parcelRequire("acw62");


var $126ba61dfbd934cd$var$Z = Object.defineProperty, $126ba61dfbd934cd$var$r = Object.defineProperties;
var $126ba61dfbd934cd$var$M = Object.getOwnPropertyDescriptors;
var $126ba61dfbd934cd$var$A = Object.getOwnPropertySymbols;
var $126ba61dfbd934cd$var$o = Object.prototype.hasOwnProperty, $126ba61dfbd934cd$var$p = Object.prototype.propertyIsEnumerable;
var $126ba61dfbd934cd$var$c = (t, e, l)=>e in t ? $126ba61dfbd934cd$var$Z(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[e] = l, $126ba61dfbd934cd$var$n = (t, e)=>{
    for(var l in e || (e = {}))$126ba61dfbd934cd$var$o.call(e, l) && $126ba61dfbd934cd$var$c(t, l, e[l]);
    if ($126ba61dfbd934cd$var$A) for (var l of $126ba61dfbd934cd$var$A(e))$126ba61dfbd934cd$var$p.call(e, l) && $126ba61dfbd934cd$var$c(t, l, e[l]);
    return t;
}, $126ba61dfbd934cd$var$m = (t, e)=>$126ba61dfbd934cd$var$r(t, $126ba61dfbd934cd$var$M(e));
const $126ba61dfbd934cd$var$C = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M231.49,225.38a12,12,0,0,1-16.89-1.9C213.19,221.72,180,179.24,180,96A52,52,0,1,0,76,96c0,83.24-33.21,125.72-34.62,127.48A12,12,0,0,1,22.6,208.53C23,208,52,170.06,52,96a76,76,0,1,1,152,0c0,74.19,29.1,112.16,29.4,112.54A12,12,0,0,1,231.49,225.38ZM104,128a16,16,0,1,0-16-16A16,16,0,0,0,104,128Zm64-16a16,16,0,1,0-16,16A16,16,0,0,0,168,112ZM95.26,163l28,12a12,12,0,0,0,9.45,0l28-12A12,12,0,0,0,151.26,141l-23.27,10-23.27-10A12,12,0,0,0,95.26,163ZM128,192a57.12,57.12,0,0,0-38.66,15.15,12,12,0,0,0,16.23,17.69,32.86,32.86,0,0,1,44.85,0,12,12,0,1,0,16.23-17.69A57.1,57.1,0,0,0,128,192Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,216H168c-8-14.35-22.91-24-40-24s-32,9.65-40,24H32S64,176,64,96a64,64,0,0,1,128,0C192,176,224,216,224,216Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M229,222.25A8,8,0,0,1,217.76,221C216.39,219.27,184,177.86,184,96A56,56,0,0,0,72,96c0,81.86-32.37,123.27-33.75,125a8,8,0,0,1-12.51-10c.15-.2,7.69-9.9,15.13-28.74C47.77,164.8,56,135.64,56,96a72,72,0,0,1,144,0c0,39.64,8.23,68.8,15.13,86.28,7.48,18.94,15.06,28.64,15.14,28.74A8,8,0,0,1,229,222.25ZM100,96a12,12,0,1,0,12,12A12,12,0,0,0,100,96Zm68,12a12,12,0,1,0-12,12A12,12,0,0,0,168,108ZM99.58,136.84a8,8,0,0,0-7.15,14.31l32,16a7.94,7.94,0,0,0,7.15,0l32-16a8,8,0,0,0-7.16-14.31L128,151.05ZM128,184a54.07,54.07,0,0,0-47,28.11,8,8,0,1,0,14,7.78,37.35,37.35,0,0,1,66,0,8,8,0,0,0,14-7.78A54.07,54.07,0,0,0,128,184Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M161.22,217.74a4,4,0,0,1-3.31,6.26H98.1a4,4,0,0,1-3.31-6.26,40,40,0,0,1,66.43,0Zm68.93,3.37a8.29,8.29,0,0,1-6.43,2.89H184.56a4,4,0,0,1-3.76-2.65,56,56,0,0,0-105.59,0A4,4,0,0,1,71.45,224H32.23a8.2,8.2,0,0,1-6.42-2.93A8,8,0,0,1,25.75,211c.06-.07,7.64-9.78,15.12-28.72C47.77,164.8,56,135.64,56,96a72,72,0,0,1,144,0c0,39.64,8.23,68.8,15.13,86.28,7.48,18.94,15.06,28.65,15.13,28.74A8,8,0,0,1,230.15,221.11ZM88,108a12,12,0,1,0,12-12A12,12,0,0,0,88,108Zm79.16,32.42a8,8,0,0,0-10.73-3.58L128,151.06,99.58,136.84a8,8,0,0,0-7.15,14.32l32,16a8,8,0,0,0,7.15,0l32-16A8,8,0,0,0,167.16,140.42ZM168,108a12,12,0,1,0-12,12A12,12,0,0,0,168,108Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M227.74,220.69a6,6,0,0,1-8.42-.94C218,218.05,186,177.17,186,96A58,58,0,0,0,70,96c0,81.17-31.95,122.05-33.31,123.75a6,6,0,0,1-9.38-7.49C27.68,211.79,58,172.56,58,96a70,70,0,0,1,140,0c0,76.63,30.38,115.87,30.69,116.26A6,6,0,0,1,227.74,220.69ZM100,98a10,10,0,1,0,10,10A10,10,0,0,0,100,98Zm66,10a10,10,0,1,0-10,10A10,10,0,0,0,166,108ZM98.69,138.63a6,6,0,0,0-5.37,10.74l32,16A6,6,0,0,0,128,166a6.07,6.07,0,0,0,2.69-.63l32-16a6,6,0,0,0-5.37-10.74L128,153.29ZM128,186a52.07,52.07,0,0,0-45.24,27.08,6,6,0,0,0,10.49,5.84,39.33,39.33,0,0,1,69.51,0A6,6,0,0,0,168,222a5.89,5.89,0,0,0,2.91-.76,6,6,0,0,0,2.33-8.16A52.09,52.09,0,0,0,128,186Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M229,222.25A8,8,0,0,1,217.76,221C216.39,219.27,184,177.86,184,96A56,56,0,0,0,72,96c0,81.86-32.37,123.27-33.75,125a8,8,0,0,1-12.51-10c.15-.2,7.69-9.9,15.13-28.74C47.77,164.8,56,135.64,56,96a72,72,0,0,1,144,0c0,39.64,8.23,68.8,15.13,86.28,7.48,18.94,15.06,28.64,15.14,28.74A8,8,0,0,1,229,222.25ZM100,96a12,12,0,1,0,12,12A12,12,0,0,0,100,96Zm68,12a12,12,0,1,0-12,12A12,12,0,0,0,168,108ZM99.58,136.84a8,8,0,0,0-7.15,14.31l32,16a7.94,7.94,0,0,0,7.15,0l32-16a8,8,0,0,0-7.16-14.31L128,151.05ZM128,184a54.07,54.07,0,0,0-47,28.11,8,8,0,1,0,14,7.78,37.35,37.35,0,0,1,66,0,8,8,0,0,0,14-7.78A54.07,54.07,0,0,0,128,184Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M226.49,219.12a4,4,0,0,1-5.61-.62C219.54,216.82,188,176.48,188,96A60,60,0,0,0,68,96c0,80.48-31.53,120.82-32.88,122.5a4,4,0,0,1-6.25-5C29.18,213.11,60,173.45,60,96a68,68,0,0,1,136,0c0,40.48,8.47,70.27,15.57,88.14,7.69,19.35,15.48,29.27,15.56,29.36A4,4,0,0,1,226.49,219.12ZM100,100a8,8,0,1,0,8,8A8,8,0,0,0,100,100Zm64,8a8,8,0,1,0-8,8A8,8,0,0,0,164,108ZM97.79,140.42a4,4,0,1,0-3.58,7.16l32,16a4,4,0,0,0,3.58,0l32-16a4,4,0,0,0-3.58-7.16L128,155.53ZM128,188a50.05,50.05,0,0,0-43.49,26.05,4,4,0,1,0,7,3.89,41.34,41.34,0,0,1,73,0A4,4,0,0,0,168,220a3.94,3.94,0,0,0,1.94-.51,4,4,0,0,0,1.55-5.44A50.07,50.07,0,0,0,128,188Z"
        }))
    ]
]), $126ba61dfbd934cd$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $126ba61dfbd934cd$var$m($126ba61dfbd934cd$var$n({
        ref: e
    }, t), {
        weights: $126ba61dfbd934cd$var$C
    })));
$126ba61dfbd934cd$export$2e2bcd8739ae039.displayName = "LinuxLogo";


var $acw62 = parcelRequire("acw62");


var $c95591d3e0a09a63$var$H = Object.defineProperty, $c95591d3e0a09a63$var$r = Object.defineProperties;
var $c95591d3e0a09a63$var$l = Object.getOwnPropertyDescriptors;
var $c95591d3e0a09a63$var$h = Object.getOwnPropertySymbols;
var $c95591d3e0a09a63$var$n = Object.prototype.hasOwnProperty, $c95591d3e0a09a63$var$A = Object.prototype.propertyIsEnumerable;
var $c95591d3e0a09a63$var$V = (t, e, m)=>e in t ? $c95591d3e0a09a63$var$H(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: m
    }) : t[e] = m, $c95591d3e0a09a63$var$Z = (t, e)=>{
    for(var m in e || (e = {}))$c95591d3e0a09a63$var$n.call(e, m) && $c95591d3e0a09a63$var$V(t, m, e[m]);
    if ($c95591d3e0a09a63$var$h) for (var m of $c95591d3e0a09a63$var$h(e))$c95591d3e0a09a63$var$A.call(e, m) && $c95591d3e0a09a63$var$V(t, m, e[m]);
    return t;
}, $c95591d3e0a09a63$var$v = (t, e)=>$c95591d3e0a09a63$var$r(t, $c95591d3e0a09a63$var$l(e));
const $c95591d3e0a09a63$var$E = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M100,36H56A20,20,0,0,0,36,56v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V56A20,20,0,0,0,100,36ZM96,96H60V60H96Zm4,40H56a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V156A20,20,0,0,0,100,136Zm-4,60H60V160H96ZM200,36H156a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V56A20,20,0,0,0,200,36Zm-4,60H160V60h36Zm-60,76V148a12,12,0,0,1,24,0v24a12,12,0,0,1-24,0Zm84-8a12,12,0,0,1-12,12H196v32a12,12,0,0,1-12,12H148a12,12,0,0,1,0-24h24V148a12,12,0,0,1,24,0v4h12A12,12,0,0,1,220,164Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M112,56v48a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h48A8,8,0,0,1,112,56Zm-8,88H56a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V152A8,8,0,0,0,104,144Zm96-96H152a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V56A8,8,0,0,0,200,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M104,40H56A16,16,0,0,0,40,56v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,104,40Zm0,64H56V56h48v48Zm0,32H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm0,64H56V152h48v48ZM200,40H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,64H152V56h48v48Zm-64,72V144a8,8,0,0,1,16,0v32a8,8,0,0,1-16,0Zm80-16a8,8,0,0,1-8,8H184v40a8,8,0,0,1-8,8H144a8,8,0,0,1,0-16h24V144a8,8,0,0,1,16,0v8h24A8,8,0,0,1,216,160Zm0,32v16a8,8,0,0,1-16,0V192a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
            x: "40",
            y: "40",
            width: "80",
            height: "80",
            rx: "16"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
            x: "40",
            y: "136",
            width: "80",
            height: "80",
            rx: "16"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
            x: "136",
            y: "40",
            width: "80",
            height: "80",
            rx: "16"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M144,184a8,8,0,0,0,8-8V144a8,8,0,0,0-16,0v32A8,8,0,0,0,144,184Z"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,152H184v-8a8,8,0,0,0-16,0v56H144a8,8,0,0,0,0,16h32a8,8,0,0,0,8-8V168h24a8,8,0,0,0,0-16Z"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,184a8,8,0,0,0-8,8v16a8,8,0,0,0,16,0V192A8,8,0,0,0,208,184Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M104,42H56A14,14,0,0,0,42,56v48a14,14,0,0,0,14,14h48a14,14,0,0,0,14-14V56A14,14,0,0,0,104,42Zm2,62a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2Zm-2,34H56a14,14,0,0,0-14,14v48a14,14,0,0,0,14,14h48a14,14,0,0,0,14-14V152A14,14,0,0,0,104,138Zm2,62a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V152a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2ZM200,42H152a14,14,0,0,0-14,14v48a14,14,0,0,0,14,14h48a14,14,0,0,0,14-14V56A14,14,0,0,0,200,42Zm2,62a2,2,0,0,1-2,2H152a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2Zm-64,72V144a6,6,0,0,1,12,0v32a6,6,0,0,1-12,0Zm76-16a6,6,0,0,1-6,6H182v42a6,6,0,0,1-6,6H144a6,6,0,0,1,0-12h26V144a6,6,0,0,1,12,0v10h26A6,6,0,0,1,214,160Zm0,32v16a6,6,0,0,1-12,0V192a6,6,0,0,1,12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M104,40H56A16,16,0,0,0,40,56v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,104,40Zm0,64H56V56h48v48Zm0,32H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm0,64H56V152h48v48ZM200,40H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,64H152V56h48v48Zm-64,72V144a8,8,0,0,1,16,0v32a8,8,0,0,1-16,0Zm80-16a8,8,0,0,1-8,8H184v40a8,8,0,0,1-8,8H144a8,8,0,0,1,0-16h24V144a8,8,0,0,1,16,0v8h24A8,8,0,0,1,216,160Zm0,32v16a8,8,0,0,1-16,0V192a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M104,44H56A12,12,0,0,0,44,56v48a12,12,0,0,0,12,12h48a12,12,0,0,0,12-12V56A12,12,0,0,0,104,44Zm4,60a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4Zm-4,36H56a12,12,0,0,0-12,12v48a12,12,0,0,0,12,12h48a12,12,0,0,0,12-12V152A12,12,0,0,0,104,140Zm4,60a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V152a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4ZM200,44H152a12,12,0,0,0-12,12v48a12,12,0,0,0,12,12h48a12,12,0,0,0,12-12V56A12,12,0,0,0,200,44Zm4,60a4,4,0,0,1-4,4H152a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4Zm-64,72V144a4,4,0,0,1,8,0v32a4,4,0,0,1-8,0Zm72-16a4,4,0,0,1-4,4H180v44a4,4,0,0,1-4,4H144a4,4,0,0,1,0-8h28V144a4,4,0,0,1,8,0v12h28A4,4,0,0,1,212,160Zm0,32v16a4,4,0,0,1-8,0V192a4,4,0,0,1,8,0Z"
        }))
    ]
]), $c95591d3e0a09a63$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $c95591d3e0a09a63$var$v($c95591d3e0a09a63$var$Z({
        ref: e
    }, t), {
        weights: $c95591d3e0a09a63$var$E
    })));
$c95591d3e0a09a63$export$2e2bcd8739ae039.displayName = "QrCode";


var $acw62 = parcelRequire("acw62");


var $b85c2e5e1d29b190$var$m = Object.defineProperty, $b85c2e5e1d29b190$var$n = Object.defineProperties;
var $b85c2e5e1d29b190$var$h = Object.getOwnPropertyDescriptors;
var $b85c2e5e1d29b190$var$V = Object.getOwnPropertySymbols;
var $b85c2e5e1d29b190$var$r = Object.prototype.hasOwnProperty, $b85c2e5e1d29b190$var$H = Object.prototype.propertyIsEnumerable;
var $b85c2e5e1d29b190$var$Z = (l, e, t)=>e in l ? $b85c2e5e1d29b190$var$m(l, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : l[e] = t, $b85c2e5e1d29b190$var$A = (l, e)=>{
    for(var t in e || (e = {}))$b85c2e5e1d29b190$var$r.call(e, t) && $b85c2e5e1d29b190$var$Z(l, t, e[t]);
    if ($b85c2e5e1d29b190$var$V) for (var t of $b85c2e5e1d29b190$var$V(e))$b85c2e5e1d29b190$var$H.call(e, t) && $b85c2e5e1d29b190$var$Z(l, t, e[t]);
    return l;
}, $b85c2e5e1d29b190$var$M = (l, e)=>$b85c2e5e1d29b190$var$n(l, $b85c2e5e1d29b190$var$h(e));
const $b85c2e5e1d29b190$var$v = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M107.69,51.88a12,12,0,0,0-9.84-2.6l-60,10.91A12,12,0,0,0,28,72v36a12,12,0,0,0,12,12h60a12,12,0,0,0,12-12V61.09A12,12,0,0,0,107.69,51.88ZM88,96H52V82l36-6.54ZM223.69,30.79a12,12,0,0,0-9.84-2.6L137.85,42A12,12,0,0,0,128,53.82V108a12,12,0,0,0,12,12h76a12,12,0,0,0,12-12V40A12,12,0,0,0,223.69,30.79ZM204,96H152V63.83l52-9.45ZM100,136H40a12,12,0,0,0-12,12v36a12,12,0,0,0,9.85,11.81l60,10.91A12,12,0,0,0,112,194.91V148A12,12,0,0,0,100,136ZM88,180.53,52,174V160H88ZM216,136H140a12,12,0,0,0-12,12v54.18A12,12,0,0,0,137.85,214l76,13.82A12,12,0,0,0,228,216V148A12,12,0,0,0,216,136Zm-12,65.62-52-9.45V160h52Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M136,144h80v72l-80-14.55ZM40,184l64,11.64V144H40ZM136,54.55V112h80V40ZM40,112h64V60.36L40,72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,136H136a8,8,0,0,0-8,8v57.45a8,8,0,0,0,6.57,7.88l80,14.54A7.61,7.61,0,0,0,216,224a8,8,0,0,0,8-8V144A8,8,0,0,0,216,136Zm-8,70.41-64-11.63V152h64ZM104,136H40a8,8,0,0,0-8,8v40a8,8,0,0,0,6.57,7.87l64,11.64a8.54,8.54,0,0,0,1.43.13,8,8,0,0,0,8-8V144A8,8,0,0,0,104,136Zm-8,50.05-48-8.73V152H96ZM221.13,33.86a8,8,0,0,0-6.56-1.73l-80,14.55A8,8,0,0,0,128,54.55V112a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V40A8,8,0,0,0,221.13,33.86ZM208,104H144V61.22l64-11.63ZM109.13,54.22a8,8,0,0,0-6.56-1.73l-64,11.64A8,8,0,0,0,32,72v40a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V60.36A8,8,0,0,0,109.13,54.22ZM96,104H48V78.68L96,70Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M112,144v51.64a8,8,0,0,1-8,8,8.54,8.54,0,0,1-1.43-.13l-64-11.64A8,8,0,0,1,32,184V144a8,8,0,0,1,8-8h64A8,8,0,0,1,112,144Zm-2.87-89.78a8,8,0,0,0-6.56-1.73l-64,11.64A8,8,0,0,0,32,72v40a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V60.36A8,8,0,0,0,109.13,54.22ZM216,136H136a8,8,0,0,0-8,8v57.45a8,8,0,0,0,6.57,7.88l80,14.54A7.61,7.61,0,0,0,216,224a8,8,0,0,0,8-8V144A8,8,0,0,0,216,136Zm5.13-102.14a8,8,0,0,0-6.56-1.73l-80,14.55A8,8,0,0,0,128,54.55V112a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V40A8,8,0,0,0,221.13,33.86Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,138H136a6,6,0,0,0-6,6v57.45a6,6,0,0,0,4.93,5.91l80,14.54a5.46,5.46,0,0,0,1.07.1,6,6,0,0,0,6-6V144A6,6,0,0,0,216,138Zm-6,70.81-68-12.36V150h68ZM104,138H40a6,6,0,0,0-6,6v40a6,6,0,0,0,4.93,5.9l64,11.64a6.36,6.36,0,0,0,1.07.1,6,6,0,0,0,6-6V144A6,6,0,0,0,104,138Zm-6,50.45L46,179V150H98ZM219.84,35.39a6,6,0,0,0-4.91-1.29l-80,14.54A6,6,0,0,0,130,54.55V112a6,6,0,0,0,6,6h80a6,6,0,0,0,6-6V40A6,6,0,0,0,219.84,35.39ZM210,106H142V59.55l68-12.36ZM107.84,55.76a6,6,0,0,0-4.91-1.3l-64,11.64A6,6,0,0,0,34,72v40a6,6,0,0,0,6,6h64a6,6,0,0,0,6-6V60.36A6,6,0,0,0,107.84,55.76ZM98,106H46V77l52-9.46Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,136H136a8,8,0,0,0-8,8v57.45a8,8,0,0,0,6.57,7.88l80,14.54A7.61,7.61,0,0,0,216,224a8,8,0,0,0,8-8V144A8,8,0,0,0,216,136Zm-8,70.41-64-11.63V152h64ZM104,136H40a8,8,0,0,0-8,8v40a8,8,0,0,0,6.57,7.87l64,11.64a8.54,8.54,0,0,0,1.43.13,8,8,0,0,0,8-8V144A8,8,0,0,0,104,136Zm-8,50.05-48-8.73V152H96ZM221.13,33.86a8,8,0,0,0-6.56-1.73l-80,14.55A8,8,0,0,0,128,54.55V112a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V40A8,8,0,0,0,221.13,33.86ZM208,104H144V61.22l64-11.63ZM109.13,54.22a8,8,0,0,0-6.56-1.73l-64,11.64A8,8,0,0,0,32,72v40a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V60.36A8,8,0,0,0,109.13,54.22ZM96,104H48V78.68L96,70Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,140H136a4,4,0,0,0-4,4v57.45a4,4,0,0,0,3.28,3.94l80,14.55a4.37,4.37,0,0,0,.72.06,4,4,0,0,0,2.56-.93A4,4,0,0,0,220,216V144A4,4,0,0,0,216,140Zm-4,71.21-72-13.09V148h72ZM104,140H40a4,4,0,0,0-4,4v40a4,4,0,0,0,3.28,3.94l64,11.63a3.51,3.51,0,0,0,.72.07,4,4,0,0,0,4-4V144A4,4,0,0,0,104,140Zm-4,50.84L44,180.66V148h56ZM218.56,36.93a4,4,0,0,0-3.28-.87l-80,14.55A4,4,0,0,0,132,54.55V112a4,4,0,0,0,4,4h80a4,4,0,0,0,4-4V40A4,4,0,0,0,218.56,36.93ZM212,108H140V57.88l72-13.09ZM103.28,56.43l-64,11.63A4,4,0,0,0,36,72v40a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4V60.36a4,4,0,0,0-4.72-3.93ZM100,108H44V75.34l56-10.18Z"
        }))
    ]
]), $b85c2e5e1d29b190$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((l, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $b85c2e5e1d29b190$var$M($b85c2e5e1d29b190$var$A({
        ref: e
    }, l), {
        weights: $b85c2e5e1d29b190$var$v
    })));
$b85c2e5e1d29b190$export$2e2bcd8739ae039.displayName = "WindowsLogo";



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $2f66ed5559a61356$var$extendStatics = function(d, b) {
    $2f66ed5559a61356$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $2f66ed5559a61356$var$extendStatics(d, b);
};
function $2f66ed5559a61356$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $2f66ed5559a61356$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2f66ed5559a61356$var$__assign = function() {
    $2f66ed5559a61356$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2f66ed5559a61356$var$__assign.apply(this, arguments);
};
/**
 * Copied from fbjs is-shallow-equal
 */ var $2f66ed5559a61356$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $2f66ed5559a61356$var$is(x, y) {
    // SameValue algorithm
    if (x === y) // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else // Step 6.a: NaN == NaN
    return x !== x && y !== y;
}
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function $2f66ed5559a61356$var$shallowEqual(objA, objB) {
    if ($2f66ed5559a61356$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(var i = 0; i < keysA.length; i++){
        if (!$2f66ed5559a61356$var$hasOwnProperty.call(objB, keysA[i]) || !$2f66ed5559a61356$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
/**
 * Special symbol which might be used to delete properties
 * from an object calling [State.set](#set) or [State.merge](#merge).
 *
 * [Learn more...](https://hookstate.js.org/docs/nested-state#deleting-existing-element)
 */ var $2f66ed5559a61356$export$f883a24d5edde77c = Symbol("none");
// type PickByType<T, U, B = false> = Pick<T, KeysOfType<T, U, B>>;
/**
 * A symbol which is used for type inference marking.
 *
 * @hidden
 * @ignore
 */ var $2f66ed5559a61356$export$1309cde3af4b1033 = Symbol("__state");
function $2f66ed5559a61356$export$4af2f85fc25cecbb(initial, extension) {
    var store = $2f66ed5559a61356$var$createStore(initial);
    store.activate(extension);
    var methods = store.toMethods();
    return methods.self();
}
/**
 * A method to destroy a global state and resources allocated by the extensions
 */ function $2f66ed5559a61356$export$b1fb4cac938035f7(state) {
    state[$2f66ed5559a61356$var$self].deactivate();
}
/**
 * A method to check if a variable is an instance of Hookstate State
 */ function $2f66ed5559a61356$export$27cad3862625b1ff(v) {
    return !!(v === null || v === void 0 ? void 0 : v[$2f66ed5559a61356$var$self]);
}
/**
 * A method to check if a variable is an instance of traced (wrapped in a proxy) Hookstate Value
 */ function $2f66ed5559a61356$export$21a38a31e960475d(v) {
    return !!(v === null || v === void 0 ? void 0 : v[$2f66ed5559a61356$var$SelfMethodsID]);
}
/**
 * A function combines multiple extensions into one extension and returns it
 * Browse an example [here](https://hookstate.js.org/docs/extensions-snapshotable)
 */ function $2f66ed5559a61356$export$8b58be045bf06082(e1, e2, e3, e4, e5) {
    function extended(extensions) {
        var exts = extensions.map(function(i) {
            return i();
        });
        var onInitCbs = exts.map(function(i) {
            return i.onInit;
        }).filter(function(i) {
            return i;
        });
        var onPremergeCbs = exts.map(function(i) {
            return i.onPremerge;
        }).filter(function(i) {
            return i;
        });
        var onPresetCbs = exts.map(function(i) {
            return i.onPreset;
        }).filter(function(i) {
            return i;
        });
        var onSetCbs = exts.map(function(i) {
            return i.onSet;
        }).filter(function(i) {
            return i;
        });
        var onDestroyCbs = exts.map(function(i) {
            return i.onDestroy;
        }).filter(function(i) {
            return i;
        });
        var result = {
            onCreate: function(instanceFactory, combinedMethods) {
                for(var _i = 0, exts_1 = exts; _i < exts_1.length; _i++){
                    var ext = exts_1[_i];
                    if (ext.onCreate) {
                        var extMethods = ext.onCreate(instanceFactory, combinedMethods);
                        Object.assign(combinedMethods, extMethods);
                    }
                }
                return combinedMethods;
            }
        };
        if (onInitCbs.length > 0) result.onInit = function(s, e) {
            for(var _i = 0, onInitCbs_1 = onInitCbs; _i < onInitCbs_1.length; _i++){
                var cb = onInitCbs_1[_i];
                cb(s, e);
            }
        };
        if (onPremergeCbs.length > 0) result.onPremerge = function(s, d, r) {
            for(var _i = 0, onPremergeCbs_1 = onPremergeCbs; _i < onPremergeCbs_1.length; _i++){
                var cb = onPremergeCbs_1[_i];
                cb(s, d, r);
            }
        };
        if (onPresetCbs.length > 0) result.onPreset = function(s, d, r) {
            for(var _i = 0, onPresetCbs_1 = onPresetCbs; _i < onPresetCbs_1.length; _i++){
                var cb = onPresetCbs_1[_i];
                cb(s, d, r);
            }
        };
        if (onSetCbs.length > 0) result.onSet = function(s, d, r) {
            for(var _i = 0, onSetCbs_1 = onSetCbs; _i < onSetCbs_1.length; _i++){
                var cb = onSetCbs_1[_i];
                cb(s, d, r);
            }
        };
        if (onDestroyCbs.length > 0) result.onDestroy = function(s) {
            for(var _i = 0, onDestroyCbs_1 = onDestroyCbs; _i < onDestroyCbs_1.length; _i++){
                var cb = onDestroyCbs_1[_i];
                cb(s);
            }
        };
        return result;
    }
    return function() {
        return extended([
            e1,
            e2,
            e3,
            e4,
            e5
        ].filter(function(i) {
            return i;
        }));
    };
}
function $2f66ed5559a61356$export$7a18e83a30d41594(source, extension) {
    var parentMethods = Object(source) === source ? source[$2f66ed5559a61356$var$self] : undefined;
    if (parentMethods) {
        if (parentMethods.isMounted) {
            // Scoped state mount
            // eslint-disable-next-line react-hooks/rules-of-hooks
            var initializer = function() {
                // warning: this is called twice in react strict mode
                var store = parentMethods.store;
                var onSetUsedCallback = function() {
                    return setValue_1({
                        store: store,
                        state: state,
                        source: value_1.source // mutable, get the latest from value
                    });
                };
                var state = new $2f66ed5559a61356$var$StateMethodsImpl(store, parentMethods.path, store.get(parentMethods.path), store.edition, onSetUsedCallback);
                return {
                    store: store,
                    state: state,
                    source: source
                };
            };
            var _a = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(initializer), value_1 = _a[0], setValue_1 = _a[1];
            if (value_1.store !== parentMethods.store || !("source" in value_1)) throw new $2f66ed5559a61356$var$StateInvalidUsageError(parentMethods.path, $2f66ed5559a61356$var$ErrorId.InitStateStoreSwitchover);
            // TODO move to a class hide props on prototype level
            // hide props from development tools
            Object.defineProperty(value_1, "store", {
                enumerable: false
            });
            Object.defineProperty(value_1, "state", {
                enumerable: false
            });
            Object.defineProperty(value_1, "source", {
                enumerable: false
            });
            value_1.state.reconstruct(parentMethods.path, value_1.store.get(parentMethods.path), value_1.store.edition, // parent state object has changed its reference object
            // so the scopped state should change too
            value_1.source !== source);
            value_1.source = source;
            // need to subscribe in sync mode, because
            // safari delays calling the effect giving priority to timeouts and network events,
            // which can cause the state update
            parentMethods.subscribe(value_1.state); // no-op if already subscribed
            $2f66ed5559a61356$var$useIsomorphicLayoutEffect(function() {
                // warning: in strict mode, effect is called twice
                // so need to restore subscription and reconstruct the extension
                // after the first effect unmount callback
                value_1.state.onMount(); // no-op if already mounted
                parentMethods.subscribe(value_1.state); // no-op if already subscribed
                return function() {
                    value_1.state.onUnmount();
                    parentMethods.unsubscribe(value_1.state);
                };
            }, []);
            var state = value_1.state.self();
            // expose property in development tools
            value_1["[hookstate(scoped)]"] = state; // TODO use label here, add core extension to label states
            return state;
        } else {
            // Global state mount or destroyed link
            // eslint-disable-next-line react-hooks/rules-of-hooks
            var initializer = function() {
                // warning: this is called twice in react strict mode
                var store = parentMethods.store;
                var onSetUsedCallback = function() {
                    return setValue_2({
                        store: store,
                        state: state,
                        source: value_2.source // mutable, get the latest from value
                    });
                };
                var state = new $2f66ed5559a61356$var$StateMethodsImpl(store, $2f66ed5559a61356$var$RootPath, store.get($2f66ed5559a61356$var$RootPath), store.edition, onSetUsedCallback);
                return {
                    store: store,
                    state: state,
                    source: source
                };
            };
            var _b = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(initializer), value_2 = _b[0], setValue_2 = _b[1];
            if (value_2.store !== parentMethods.store || !("source" in value_2)) throw new $2f66ed5559a61356$var$StateInvalidUsageError(parentMethods.path, $2f66ed5559a61356$var$ErrorId.InitStateStoreSwitchover);
            // hide props from development tools
            Object.defineProperty(value_2, "store", {
                enumerable: false
            });
            Object.defineProperty(value_2, "state", {
                enumerable: false
            });
            Object.defineProperty(value_2, "source", {
                enumerable: false
            });
            value_2.state.reconstruct($2f66ed5559a61356$var$RootPath, value_2.store.get($2f66ed5559a61356$var$RootPath), value_2.store.edition, // parent state object has changed its reference object
            // so the scopped state should change too
            value_2.source !== source);
            value_2.source = source;
            // need to subscribe in sync mode, because
            // safari delays calling the effect giving priority to timeouts and network events,
            // which can cause the state update
            value_2.store.subscribe(value_2.state); // no-op if already subscribed
            $2f66ed5559a61356$var$useIsomorphicLayoutEffect(function() {
                // warning: in strict mode, effect is called twice
                // so need to restore subscription and reconstruct the extension
                // after the first effect unmount callback
                value_2.state.onMount(); // no-op if already mounted
                value_2.store.subscribe(value_2.state); // no-op if already subscribed
                return function() {
                    value_2.state.onUnmount();
                    value_2.store.unsubscribe(value_2.state);
                };
            }, []);
            var state = value_2.state.self();
            for(var ind = 0; ind < parentMethods.path.length; ind += 1)state = state.nested(parentMethods.path[ind]);
            // expose property in development tools
            value_2["[hookstate(global)]"] = state; // TODO use label here, add core extension to label states
            return state;
        }
    } else {
        // Local state mount
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var initializer = function() {
            // warning: this is called twice in react strict mode
            var store = $2f66ed5559a61356$var$createStore(source);
            var onSetUsedCallback = function() {
                return setValue_3({
                    store: store,
                    state: state
                });
            };
            var state = new $2f66ed5559a61356$var$StateMethodsImpl(store, $2f66ed5559a61356$var$RootPath, store.get($2f66ed5559a61356$var$RootPath), store.edition, onSetUsedCallback);
            return {
                store: store,
                state: state
            };
        };
        var _c = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(initializer), value_3 = _c[0], setValue_3 = _c[1];
        if ("source" in value_3) throw new $2f66ed5559a61356$var$StateInvalidUsageError($2f66ed5559a61356$var$RootPath, $2f66ed5559a61356$var$ErrorId.InitStateStoreSwitchover);
        // hide props from development tools
        Object.defineProperty(value_3, "store", {
            enumerable: false
        });
        Object.defineProperty(value_3, "state", {
            enumerable: false
        });
        value_3.state.reconstruct($2f66ed5559a61356$var$RootPath, value_3.store.get($2f66ed5559a61356$var$RootPath), value_3.store.edition, false);
        // need to subscribe in sync mode, because
        // safari delays calling the effect giving priority to timeouts and network events,
        // which can cause the state update
        value_3.store.subscribe(value_3.state); // no-op if already subscribed
        // need to attach the extension straight away
        // because extension methods are used in render function
        // and we can not defer it to the effect callback
        value_3.store.activate(extension); // no-op if already attached
        $2f66ed5559a61356$var$useIsomorphicLayoutEffect(function() {
            // warning: in strict mode, effect is called twice
            // so need to restore subscription and reconstruct the extension
            // after the first effect unmount callback
            value_3.state.onMount(); // no-op if already mounted
            value_3.store.subscribe(value_3.state); // no-op if already subscribed
            value_3.store.activate(extension); // no-op if already attached
            return function() {
                value_3.state.onUnmount();
                value_3.store.unsubscribe(value_3.state);
                value_3.store.deactivate(); // this will destroy the extensions
            };
        }, []);
        var state = value_3.state.self();
        // expose property in development tools
        value_3["[hookstate(local)]"] = state; // TODO use label here, add core extension to label states
        return state;
    }
}
function $2f66ed5559a61356$export$e8ecf3edd313f618(props) {
    var scoped = $2f66ed5559a61356$export$7a18e83a30d41594(props.state, props.extension);
    return props.suspend && $2f66ed5559a61356$export$a1428c8f7ba796e8(scoped) || props.children(scoped);
}
/**
 * If state is promised, then it returns a component which integrates with React 18 Suspend feature automatically.
 * Note, that React 18 Suspend support for data loading is still experimental,
 * but it worked as per our experiments and testing.
 */ function $2f66ed5559a61356$export$a1428c8f7ba796e8(state) {
    var p = state.promise;
    return p && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(function() {
        return p;
    }));
}
///
/// INTERNAL SYMBOLS (LIBRARY IMPLEMENTATION)
///
var $2f66ed5559a61356$var$self = Symbol("self");
var $2f66ed5559a61356$var$ErrorId;
(function(ErrorId) {
    ErrorId[ErrorId["StateUsedInDependencyList"] = 100] = "StateUsedInDependencyList";
    ErrorId[ErrorId["InitStateToValueFromState"] = 101] = "InitStateToValueFromState";
    ErrorId[ErrorId["SetStateToValueFromState"] = 102] = "SetStateToValueFromState";
    ErrorId[ErrorId["GetStateWhenPromised"] = 103] = "GetStateWhenPromised";
    ErrorId[ErrorId["SetStateWhenPromised"] = 104] = "SetStateWhenPromised";
    ErrorId[ErrorId["SetStateNestedToPromised"] = 105] = "SetStateNestedToPromised";
    ErrorId[ErrorId["SetStateWhenDestroyed"] = 106] = "SetStateWhenDestroyed";
    ErrorId[ErrorId["ToJson_Value"] = 108] = "ToJson_Value";
    ErrorId[ErrorId["ToJson_State"] = 109] = "ToJson_State";
    ErrorId[ErrorId["GetProperty_Function"] = 110] = "GetProperty_Function";
    ErrorId[ErrorId["InitStateStoreSwitchover"] = 111] = "InitStateStoreSwitchover";
    ErrorId[ErrorId["GetUnknownPlugin"] = 120] = "GetUnknownPlugin";
    ErrorId[ErrorId["SetProperty_State"] = 201] = "SetProperty_State";
    ErrorId[ErrorId["SetProperty_Value"] = 202] = "SetProperty_Value";
    ErrorId[ErrorId["SetPrototypeOf_State"] = 203] = "SetPrototypeOf_State";
    ErrorId[ErrorId["SetPrototypeOf_Value"] = 204] = "SetPrototypeOf_Value";
    ErrorId[ErrorId["PreventExtensions_State"] = 205] = "PreventExtensions_State";
    ErrorId[ErrorId["PreventExtensions_Value"] = 206] = "PreventExtensions_Value";
    ErrorId[ErrorId["DefineProperty_State"] = 207] = "DefineProperty_State";
    ErrorId[ErrorId["DefineProperty_Value"] = 208] = "DefineProperty_Value";
    ErrorId[ErrorId["DeleteProperty_State"] = 209] = "DeleteProperty_State";
    ErrorId[ErrorId["DeleteProperty_Value"] = 210] = "DeleteProperty_Value";
    ErrorId[ErrorId["Construct_State"] = 211] = "Construct_State";
    ErrorId[ErrorId["Construct_Value"] = 212] = "Construct_Value";
    ErrorId[ErrorId["Apply_State"] = 213] = "Apply_State";
    ErrorId[ErrorId["Apply_Value"] = 214] = "Apply_Value";
})($2f66ed5559a61356$var$ErrorId || ($2f66ed5559a61356$var$ErrorId = {}));
var $2f66ed5559a61356$var$StateInvalidUsageError = /** @class */ function(_super) {
    $2f66ed5559a61356$var$__extends(StateInvalidUsageError, _super);
    function StateInvalidUsageError(path, id, details) {
        return _super.call(this, "Error: HOOKSTATE-".concat(id, " [path: /").concat(path.join("/")).concat(details ? ", details: ".concat(details) : "", "]. ") + "See https://hookstate.js.org/docs/exceptions#hookstate-".concat(id)) || this;
    }
    return StateInvalidUsageError;
}(Error);
var $2f66ed5559a61356$var$SelfMethodsID = Symbol("ProxyMarker");
var $2f66ed5559a61356$var$RootPath = [];
var $2f66ed5559a61356$var$Store = /** @class */ function() {
    function Store(_value) {
        var _this = this;
        this._value = _value;
        // > 0 means active store, < 0 means destroyed
        // please note, in react strict mode and hot reload cases
        // state can be reused, so we should support store resurection
        this.edition = 1;
        this._subscribers = new Set();
        if (Object(_value) === _value && $2f66ed5559a61356$var$configuration.promiseDetector(_value)) this.setPromised(_value);
        else if (_value === $2f66ed5559a61356$export$f883a24d5edde77c) this.setPromised(undefined);
        var onSetUsedStoreStateMethods = function() {
            _this._stateMethods.reconstruct($2f66ed5559a61356$var$RootPath, _this.get($2f66ed5559a61356$var$RootPath), _this.edition, false);
        };
        onSetUsedStoreStateMethods[$2f66ed5559a61356$var$IsUnmounted] = true;
        this._stateMethods = new $2f66ed5559a61356$var$StateMethodsImpl(this, $2f66ed5559a61356$var$RootPath, this.get($2f66ed5559a61356$var$RootPath), this.edition, onSetUsedStoreStateMethods);
        this.subscribe(this._stateMethods);
    }
    Store.prototype.setPromised = function(promise) {
        var _this = this;
        this._value = $2f66ed5559a61356$export$f883a24d5edde77c;
        this._promiseError = undefined;
        this._promiseResolver = undefined;
        if (!promise) {
            this._promise = new Promise(function(resolve) {
                _this._promiseResolver = resolve;
            });
            return;
        }
        promise = promise.then(function(r) {
            if (_this._promise === promise) {
                _this._promise = undefined;
                _this._promiseError = undefined;
                _this._promiseResolver;
                _this.update(_this._stateMethods.self(), _this.set($2f66ed5559a61356$var$RootPath, r));
            }
        }).catch(function(err) {
            if (_this._promise === promise) {
                _this._promise = undefined;
                _this._promiseResolver = undefined;
                _this._promiseError = err;
                _this.edition += 1;
                var ad = {
                    path: $2f66ed5559a61356$var$RootPath
                };
                _this.update(_this._stateMethods.self(), ad);
            }
        });
        this._promise = promise;
    };
    Store.prototype.activate = function(extensionFactory) {
        var _a, _b, _c, _d;
        if (this.edition < 0) this.edition = -this.edition;
        if (this._extension === undefined) {
            this._extension = extensionFactory === null || extensionFactory === void 0 ? void 0 : extensionFactory();
            this._extensionMethods = (_b = (_a = this._extension) === null || _a === void 0 ? void 0 : _a.onCreate) === null || _b === void 0 ? void 0 : _b.call(_a, this._stateMethods.self(), {});
            // this is invoked with all extension methods activated on the state
            (_d = (_c = this._extension) === null || _c === void 0 ? void 0 : _c.onInit) === null || _d === void 0 || _d.call(_c, this._stateMethods.self(), this._extensionMethods || {});
        }
    };
    Store.prototype.deactivate = function() {
        var _a, _b;
        if (this._extension) {
            (_b = (_a = this._extension).onDestroy) === null || _b === void 0 || _b.call(_a, this._stateMethods.self());
            delete this._extension;
            delete this._extensionMethods;
        }
        if (this.edition > 0) this.edition = -this.edition;
    };
    Object.defineProperty(Store.prototype, "extension", {
        get: function() {
            return this._extensionMethods;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "promise", {
        get: function() {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "promiseError", {
        get: function() {
            return this._promiseError;
        },
        enumerable: false,
        configurable: true
    });
    Store.prototype.get = function(path) {
        var result = this._value;
        if (result === $2f66ed5559a61356$export$f883a24d5edde77c) return result;
        path.forEach(function(p) {
            result = result[p];
        });
        return result;
    };
    Store.prototype.set = function(path, value) {
        var _a, _b;
        if (this.edition < 0) // TODO convert to console log
        throw new $2f66ed5559a61356$var$StateInvalidUsageError(path, $2f66ed5559a61356$var$ErrorId.SetStateWhenDestroyed);
        if (path.length === 0) {
            // Root value UPDATE case,
            if (value === $2f66ed5559a61356$export$f883a24d5edde77c) this.setPromised(undefined);
            else if (Object(value) === value && $2f66ed5559a61356$var$configuration.promiseDetector(value)) {
                this.setPromised(value);
                value = $2f66ed5559a61356$export$f883a24d5edde77c;
            } else if (this._promise && !this._promiseResolver) throw new $2f66ed5559a61356$var$StateInvalidUsageError(path, $2f66ed5559a61356$var$ErrorId.SetStateWhenPromised);
            else this._promiseError = undefined;
            var prevValue = this._value;
            this._value = value;
            this.afterSet();
            if (prevValue === $2f66ed5559a61356$export$f883a24d5edde77c && this._value !== $2f66ed5559a61356$export$f883a24d5edde77c && this._promiseResolver) {
                this._promise = undefined;
                this._promiseError = undefined;
                var resolver = this._promiseResolver;
                this._promiseResolver;
                resolver(this._value);
            }
            return {
                path: path
            };
        }
        if (Object(value) === value && $2f66ed5559a61356$var$configuration.promiseDetector(value)) // TODO this one still can get into the state as nested property, need to check on read instead
        throw new $2f66ed5559a61356$var$StateInvalidUsageError(path, $2f66ed5559a61356$var$ErrorId.SetStateNestedToPromised);
        var target = this._value;
        for(var i = 0; i < path.length - 1; i += 1)target = target[path[i]];
        var p = path[path.length - 1];
        if (p in target) {
            if (value !== $2f66ed5559a61356$export$f883a24d5edde77c) {
                // Property UPDATE case
                target[p] = value;
                this.afterSet();
                return {
                    path: path
                };
            } else {
                // Property DELETE case
                if (Array.isArray(target) && typeof p === "number") target.splice(p, 1);
                else delete target[p];
                this.afterSet();
                // if an array of objects is about to loose existing property
                // we consider it is the whole object is changed
                // which is identified by upper path
                return {
                    path: path.slice(0, -1),
                    actions: (_a = {}, _a[p] = "D", _a)
                };
            }
        }
        if (value !== $2f66ed5559a61356$export$f883a24d5edde77c) {
            // Property INSERT case
            target[p] = value;
            this.afterSet();
            // if an array of objects is about to be extended by new property
            // we consider it is the whole object is changed
            // which is identified by upper path
            return {
                path: path.slice(0, -1),
                actions: (_b = {}, _b[p] = "I", _b)
            };
        }
        // Non-existing property DELETE case
        // no-op
        return {
            path: path
        };
    };
    Store.prototype.preset = function(state, value) {
        var _a, _b;
        (_b = (_a = this._extension) === null || _a === void 0 ? void 0 : _a.onPreset) === null || _b === void 0 || _b.call(_a, state, value, this._stateMethods.self());
    };
    Store.prototype.premerge = function(state, value) {
        var _a, _b;
        (_b = (_a = this._extension) === null || _a === void 0 ? void 0 : _a.onPremerge) === null || _b === void 0 || _b.call(_a, state, value, this._stateMethods.self());
    };
    Store.prototype.update = function(state, ad) {
        var _this = this;
        var _a, _b;
        (_b = (_a = this._extension) === null || _a === void 0 ? void 0 : _a.onSet) === null || _b === void 0 || _b.call(_a, state, ad, this._stateMethods.self());
        var actions = new Set();
        // check if actions descriptor can be unfolded into a number of individual update actions
        // this is the case when merge call swaps to properties for example
        // so we optimize rerendering only these properties
        if (ad.actions && Object.values(ad.actions).findIndex(function(i) {
            return i !== "U";
        }) === -1) // all actions are update actions
        Object.keys(ad.actions).forEach(function(key) {
            _this._subscribers.forEach(function(s) {
                return s.onSet({
                    path: ad.path.concat(key)
                }, actions);
            });
        });
        else this._subscribers.forEach(function(s) {
            return s.onSet(ad, actions);
        });
        actions.forEach(function(a) {
            return a();
        });
    };
    Store.prototype.afterSet = function() {
        if (this.edition > 0) this.edition += 1;
        if (this.edition < 0) this.edition -= 1;
    };
    Store.prototype.toMethods = function() {
        return this._stateMethods;
    };
    Store.prototype.subscribe = function(l) {
        this._subscribers.add(l);
    };
    Store.prototype.unsubscribe = function(l) {
        this._subscribers.delete(l);
    };
    Store.prototype.toJSON = function() {
        throw new $2f66ed5559a61356$var$StateInvalidUsageError($2f66ed5559a61356$var$RootPath, $2f66ed5559a61356$var$ErrorId.ToJson_Value);
    };
    return Store;
}();
// use symbol property to allow for easier reference finding
var $2f66ed5559a61356$var$UnusedValue = Symbol("UnusedValue");
// use symbol to mark that a function has no effect anymore
var $2f66ed5559a61356$var$IsUnmounted = Symbol("IsUnmounted");
var $2f66ed5559a61356$var$StateMethodsImpl = /** @class */ function() {
    function StateMethodsImpl(store, path, valueSource, valueEdition, onSetUsed) {
        this.store = store;
        this.path = path;
        this.valueSource = valueSource;
        this.valueEdition = valueEdition;
        this.onSetUsed = onSetUsed;
        this.valueUsed = $2f66ed5559a61356$var$UnusedValue;
    }
    Object.defineProperty(StateMethodsImpl.prototype, $2f66ed5559a61356$export$1309cde3af4b1033, {
        get: function() {
            return [
                this.get(),
                this.self()
            ];
        },
        enumerable: false,
        configurable: true
    });
    StateMethodsImpl.prototype.reconstruct = function(path, valueSource, valueEdition, reset) {
        this.path = path;
        this.valueSource = valueSource;
        this.valueEdition = valueEdition;
        this.valueUsed = $2f66ed5559a61356$var$UnusedValue;
        if (reset) {
            delete this.selfUsed;
            delete this.childrenCreated;
            delete this.childrenUsedPrevious;
        } else {
            this.valueUsedNoProxyPrevious = this.valueUsedNoProxy;
            this.childrenUsedPrevious = this.childrenUsed;
        }
        delete this.valueUsedNoProxy;
        delete this.childrenUsed;
    // We should not delete subscribers as these are self cleaned up when unmounted
    // Theoretically it is possible to reconnect subscribers like we done it for 
    // children, but it is easier and more efficient to leave subscribers to have independent lifecycle
    // If we delete subscribers here, scoped states wrapped in React.memo
    // will lose state change propagation and rerendering for scopped states
    // delete this.subscribers;
    };
    StateMethodsImpl.prototype.reconnect = function() {
        // Mark it's as used, because it is used in a dependency list
        // (we are making it's value used implicitly, so rerender is triggered).
        // Otherwise, no rerender => no effects running, even when a value is changed.
        // This is marking the state used a bit more than it might be really used
        // in the effect callback. More optimized / precise implementation would be
        // to remember useSelf as previous (similar to childrenUsed),
        // but it is a lot more complicated and the benefit is not worth the complexity.
        // So, mark it used.
        // We also using it without proxy if it wass used without proxy during the
        // previous render, because otherwise children usage might be not traced completely
        // and so will not result in renreder if children are updated.
        // This is covered by some tests, but there are so many possible corner cases...
        this.get({
            __internalAllowPromised: true,
            noproxy: this.valueUsedNoProxyPrevious
        });
        this.childrenUsed = $2f66ed5559a61356$var$__assign($2f66ed5559a61356$var$__assign({}, this.childrenUsedPrevious), this.childrenUsed);
    };
    StateMethodsImpl.prototype.getUntracked = function(__internalAllowPromised) {
        if (this.valueEdition !== this.store.edition) {
            this.valueSource = this.store.get(this.path);
            this.valueEdition = this.store.edition;
            if (this.valueUsed !== $2f66ed5559a61356$var$UnusedValue) {
                this.valueUsed = $2f66ed5559a61356$var$UnusedValue;
                this.get({
                    __internalAllowPromised: true
                }); // renew cache to keep it marked used
            }
        }
        if (__internalAllowPromised) return this.valueSource;
        if (this.store.promiseError) throw this.store.promiseError;
        if (this.store.promise) throw new $2f66ed5559a61356$var$StateInvalidUsageError(this.path, $2f66ed5559a61356$var$ErrorId.GetStateWhenPromised);
        return this.valueSource;
    };
    StateMethodsImpl.prototype.get = function(options) {
        var _a;
        var valueSource = this.getUntracked(options === null || options === void 0 ? void 0 : options.__internalAllowPromised);
        if (options === null || options === void 0 ? void 0 : options.stealth) return valueSource;
        if (this.valueUsed === $2f66ed5559a61356$var$UnusedValue) {
            if (Array.isArray(valueSource)) this.valueUsed = this.valueArrayImpl(valueSource);
            else if (Object(valueSource) === valueSource) {
                if (((_a = valueSource.constructor) === null || _a === void 0 ? void 0 : _a.name) === "Object") this.valueUsed = this.valueObjectImpl(valueSource);
                else {
                    // any other object except Object, for example Date
                    this.valueUsedNoProxy = true;
                    this.valueUsed = valueSource;
                }
            } else this.valueUsed = valueSource;
        }
        if (options === null || options === void 0 ? void 0 : options.noproxy) {
            this.valueUsedNoProxy = true;
            return valueSource;
        }
        return this.valueUsed;
    };
    Object.defineProperty(StateMethodsImpl.prototype, "value", {
        get: function() {
            // various tools, including react dev tools and webpack import
            // inspect an object and it's properties
            // so these should not throw
            // return this.get({ __internalAllowPromised: true })
            return this.get();
        },
        enumerable: false,
        configurable: true
    });
    StateMethodsImpl.prototype.setUntrackedV4 = function(newValue) {
        if (typeof newValue === "function") newValue = newValue(this.getUntracked());
        this.store.preset(this.self(), newValue);
        if (Object(newValue) === newValue && newValue[$2f66ed5559a61356$var$SelfMethodsID]) // TODO check on read instead as it might escape as nested on set anyway
        throw new $2f66ed5559a61356$var$StateInvalidUsageError(this.path, $2f66ed5559a61356$var$ErrorId.SetStateToValueFromState);
        if (newValue !== Object(newValue) && newValue === this.getUntracked(true)) // this is primitive value and has not changed
        // so skip this set call as it does not make an effect
        return null;
        return this.store.set(this.path, newValue);
    };
    StateMethodsImpl.prototype.set = function(newValue) {
        var ad = this.setUntrackedV4(newValue);
        if (ad) this.store.update(this.self(), ad);
    };
    StateMethodsImpl.prototype.mergeUntracked = function(sourceValue) {
        var r = this.mergeUntrackedV4(sourceValue);
        if (r) return [
            r.path
        ];
        return [];
    };
    StateMethodsImpl.prototype.mergeUntrackedV4 = function(sourceValue) {
        var currentValue = this.getUntracked();
        if (typeof sourceValue === "function") sourceValue = sourceValue(currentValue);
        this.store.premerge(this.self(), sourceValue);
        if (Array.isArray(currentValue)) {
            if (Array.isArray(sourceValue)) {
                var ad_1 = {
                    path: this.path,
                    actions: {}
                };
                sourceValue.forEach(function(e, i) {
                    ad_1.actions[currentValue.push(e) - 1] = "I";
                });
                if (Object.keys(ad_1.actions).length > 0) {
                    this.setUntrackedV4(currentValue);
                    return ad_1;
                }
                return null;
            } else {
                var ad_2 = {
                    path: this.path,
                    actions: {}
                };
                var deletedIndexes_1 = [];
                Object.keys(sourceValue).map(function(i) {
                    return Number(i);
                }).sort(function(a, b) {
                    return a - b;
                }).forEach(function(i) {
                    var index = Number(i);
                    var newPropValue = sourceValue[index];
                    if (newPropValue === $2f66ed5559a61356$export$f883a24d5edde77c) {
                        ad_2.actions[index] = "D";
                        deletedIndexes_1.push(index);
                    } else {
                        if (index in currentValue) ad_2.actions[index] = "U";
                        else ad_2.actions[index] = "I";
                        currentValue[index] = newPropValue;
                    }
                });
                // indexes are ascending sorted as per above
                // so, delete one by one from the end
                // this way index positions do not change
                deletedIndexes_1.reverse().forEach(function(p) {
                    currentValue.splice(p, 1);
                });
                if (Object.keys(ad_2.actions).length > 0) {
                    this.setUntrackedV4(currentValue);
                    return ad_2;
                }
                return null;
            }
        } else if (Object(currentValue) === currentValue) {
            var ad_3 = {
                path: this.path,
                actions: {}
            };
            Object.keys(sourceValue).forEach(function(key) {
                var newPropValue = sourceValue[key];
                if (newPropValue === $2f66ed5559a61356$export$f883a24d5edde77c) {
                    ad_3.actions[key] = "D";
                    delete currentValue[key];
                } else {
                    if (key in currentValue) ad_3.actions[key] = "U";
                    else ad_3.actions[key] = "I";
                    currentValue[key] = newPropValue;
                }
            });
            if (Object.keys(ad_3.actions).length > 0) {
                this.setUntrackedV4(currentValue);
                return ad_3;
            }
            return null;
        } else if (typeof currentValue === "string") return this.setUntrackedV4(currentValue + String(sourceValue));
        else return this.setUntrackedV4(sourceValue);
    };
    StateMethodsImpl.prototype.merge = function(sourceValue) {
        var r = this.mergeUntrackedV4(sourceValue);
        if (r) this.store.update(this.self(), r);
    };
    StateMethodsImpl.prototype.nested = function(key) {
        return this.child(key).self();
    };
    StateMethodsImpl.prototype.rerender = function(paths) {
        for(var _i = 0, paths_1 = paths; _i < paths_1.length; _i++){
            var path = paths_1[_i];
            this.store.update(this.self(), {
                path: path
            });
        }
    };
    StateMethodsImpl.prototype.activate = function(extensionFactory) {
        this.store.activate(extensionFactory);
    };
    StateMethodsImpl.prototype.deactivate = function() {
        this.store.deactivate();
    };
    StateMethodsImpl.prototype.subscribe = function(l) {
        if (this.subscribers === undefined) this.subscribers = new Set();
        this.subscribers.add(l);
    };
    StateMethodsImpl.prototype.unsubscribe = function(l) {
        if (this.subscribers) this.subscribers.delete(l);
    };
    Object.defineProperty(StateMethodsImpl.prototype, "isMounted", {
        get: function() {
            return !this.onSetUsed[$2f66ed5559a61356$var$IsUnmounted];
        },
        enumerable: false,
        configurable: true
    });
    StateMethodsImpl.prototype.onMount = function() {
        delete this.onSetUsed[$2f66ed5559a61356$var$IsUnmounted];
    };
    StateMethodsImpl.prototype.onUnmount = function() {
        this.onSetUsed[$2f66ed5559a61356$var$IsUnmounted] = true;
    };
    StateMethodsImpl.prototype.onSet = function(ad, actions) {
        var _this = this;
        var update = function() {
            var _a;
            var isAffected = false;
            if (_this.valueUsedNoProxy && _this.valueUsed !== $2f66ed5559a61356$var$UnusedValue) {
                actions.add(_this.onSetUsed);
                delete _this.selfUsed;
                isAffected = true;
            }
            var path = ad.path;
            var nextChildKey = path[_this.path.length];
            if (nextChildKey === undefined) // There is no next child to dive into
            // So it is this one which was updated
            {
                if (_this.valueUsed !== $2f66ed5559a61356$var$UnusedValue) {
                    actions.add(_this.onSetUsed);
                    delete _this.selfUsed;
                    delete _this.childrenUsed;
                    if (ad.actions && _this.childrenCreated) {
                        // TODO add automated unit tests for this part
                        if (Array.isArray(_this.valueSource) && Object.values(ad.actions).includes("D")) {
                            // this is an array and some elements were removed
                            // so invalidate cache for all children after the first deleted
                            var firstDeletedIndex = Object.keys(ad.actions).map(function(i) {
                                return Number(i);
                            }).sort(function(a, b) {
                                return a - b;
                            }).find(function(i) {
                                var _a;
                                return ((_a = ad.actions) === null || _a === void 0 ? void 0 : _a[i]) === "D";
                            });
                            for(var childKey in _this.childrenCreated)if (Number(childKey) >= firstDeletedIndex || childKey in ad.actions) delete _this.childrenCreated[childKey];
                        } else for(var childKey in ad.actions)delete _this.childrenCreated[childKey];
                    } else delete _this.childrenCreated;
                    return true;
                }
            } else {
                var nextChild = (_a = _this.childrenUsed) === null || _a === void 0 ? void 0 : _a[nextChildKey];
                if (nextChild && nextChild.onSet(ad, actions)) {
                    delete _this.selfUsed;
                    return true;
                }
            }
            return isAffected;
        };
        var updated = update();
        if (!updated && this.subscribers !== undefined) this.subscribers.forEach(function(s) {
            if (s.onSet(ad, actions)) delete _this.selfUsed;
        });
        return updated;
    };
    Object.defineProperty(StateMethodsImpl.prototype, "keys", {
        get: function() {
            var value = this.get();
            if (Array.isArray(value)) return Object.keys(value).map(function(i) {
                return Number(i);
            }).filter(function(i) {
                return Number.isInteger(i);
            });
            if (Object(value) === value) return Object.keys(value);
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    StateMethodsImpl.prototype.child = function(key) {
        this.childrenUsed = this.childrenUsed || {};
        var cachedChild = this.childrenUsed.hasOwnProperty(key) && this.childrenUsed[key];
        if (cachedChild) return cachedChild;
        var valueSource = this.valueSource[key];
        if (typeof valueSource === "function") // hitting a method of a custom type, should be no-op
        throw new $2f66ed5559a61356$var$StateInvalidUsageError(this.path, $2f66ed5559a61356$var$ErrorId.GetProperty_Function);
        this.childrenCreated = this.childrenCreated || {};
        var child = this.childrenCreated[key];
        var r;
        if (child) {
            child.reconstruct(this.path.concat(key), valueSource, this.valueEdition, false);
            r = child;
        } else {
            r = new StateMethodsImpl(this.store, this.path.concat(key), valueSource, this.valueEdition, this.onSetUsed);
            this.childrenCreated[key] = r;
        }
        if (this.valueUsedNoProxy) // TODO this is redundant when Downgraded plugin is deleted
        r.valueUsedNoProxy = true;
        this.childrenUsed[key] = r;
        return r;
    };
    StateMethodsImpl.prototype.valueArrayImpl = function(currentValue) {
        var _this = this;
        return $2f66ed5559a61356$var$proxyWrap(this.path, currentValue, function() {
            return currentValue;
        }, function(target, key) {
            if (key === "length") return target.length;
            if (key in Array.prototype) return Array.prototype[key];
            if (key === $2f66ed5559a61356$var$SelfMethodsID) return _this;
            if (typeof key === "symbol") // allow clients to associate hidden cache with state values
            return target[key];
            var index = Number(key);
            if (!Number.isInteger(index)) return undefined;
            return _this.child(index).get();
        }, function(target, key, value) {
            if (typeof key === "symbol") {
                // allow clients to associate hidden cache with state values
                target[key] = value;
                return true;
            }
            throw new $2f66ed5559a61356$var$StateInvalidUsageError(_this.path, $2f66ed5559a61356$var$ErrorId.SetProperty_Value);
        }, true);
    };
    StateMethodsImpl.prototype.valueObjectImpl = function(currentValue) {
        var _this = this;
        return $2f66ed5559a61356$var$proxyWrap(this.path, currentValue, function() {
            return currentValue;
        }, function(target, key) {
            if (key in Object.prototype) return Object.prototype[key];
            if (key === $2f66ed5559a61356$var$SelfMethodsID) return _this;
            if (typeof key === "symbol") // allow clients to associate hidden cache with state values
            return target[key];
            return _this.child(key).get();
        }, function(target, key, value) {
            if (typeof key === "symbol") {
                // allow clients to associate hidden cache with state values
                target[key] = value;
                return true;
            }
            throw new $2f66ed5559a61356$var$StateInvalidUsageError(_this.path, $2f66ed5559a61356$var$ErrorId.SetProperty_Value);
        }, true);
    };
    StateMethodsImpl.prototype.self = function() {
        var _this = this;
        if (this.selfUsed) return this.selfUsed;
        var getter = function(_, key) {
            if (key === $2f66ed5559a61356$var$self) return _this;
            if (typeof key === "symbol") return undefined;
            if (key === "toJSON") throw new $2f66ed5559a61356$var$StateInvalidUsageError(_this.path, $2f66ed5559a61356$var$ErrorId.ToJson_State);
            var nestedGetter = function(prop) {
                var currentValue = _this.get({
                    __internalAllowPromised: prop === "$$typeof" || prop === "constructor"
                });
                if (prop in Object.prototype) // Mark it used entirely, so changes to the value
                // invalidate and rerender results for Object.prototype.toString(),
                // for example.
                // We check for Object prototype functions
                // even for primitive values, because primitive values still
                // can have object methods.
                return Object.prototype[prop];
                if (Object(currentValue) !== currentValue && // if promised, it will be none
                currentValue !== $2f66ed5559a61356$export$f883a24d5edde77c) // This was an error case, but various tools like webpack bundler
                // and react dev tools attempt to get props out of non-null object,
                // so this was changed to return just undefined for any property request
                // as there is no way to fix 3rd party tools.
                // Logging a warning to console is also not an option
                // as it pollutes console for legitimate apps on app start app.
                // Ref: https://github.com/avkonst/hookstate/issues/125
                return undefined;
                if (Array.isArray(currentValue)) {
                    if (prop === "length") return currentValue.length;
                    if (prop in Array.prototype) return Array.prototype[prop];
                    var index = Number(prop);
                    if (!Number.isInteger(index)) return undefined;
                    return _this.nested(index);
                }
                return _this.nested(prop.toString());
            };
            switch(key){
                case "path":
                    return _this.path;
                case "keys":
                    return _this.keys;
                case "value":
                    return _this.value;
                case "ornull":
                    return _this.ornull;
                case "promised":
                    return _this.promised;
                case "promise":
                    return _this.promise;
                case "error":
                    return _this.error;
                case "get":
                    return function(opts) {
                        return _this.get(opts);
                    };
                case "set":
                    return function(p) {
                        return _this.set(p);
                    };
                case "merge":
                    return function(p) {
                        return _this.merge(p);
                    };
                case "nested":
                    return function(p) {
                        return nestedGetter(p);
                    };
                default:
                    // check if extension method
                    var ext = _this.store.extension;
                    if (ext && key in ext) return ext[key](_this.self());
                    // otherwise nested child
                    return nestedGetter(key);
            }
        };
        this.selfUsed = $2f66ed5559a61356$var$proxyWrap(this.path, this.valueSource, function(opts) {
            return _this.get({
                __internalAllowPromised: true,
                stealth: opts === null || opts === void 0 ? void 0 : opts.stealth
            });
        }, getter, function(_, key, value) {
            throw new $2f66ed5559a61356$var$StateInvalidUsageError(_this.path, $2f66ed5559a61356$var$ErrorId.SetProperty_State);
        }, false);
        return this.selfUsed;
    };
    Object.defineProperty(StateMethodsImpl.prototype, "promised", {
        get: function() {
            this.get({
                __internalAllowPromised: true
            }); // marks used
            return !!this.store.promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateMethodsImpl.prototype, "promise", {
        get: function() {
            var _this = this;
            var _a;
            this.get({
                __internalAllowPromised: true
            }); // marks used
            return (_a = this.store.promise) === null || _a === void 0 ? void 0 : _a.then(function(_) {
                return _this.self();
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateMethodsImpl.prototype, "error", {
        get: function() {
            this.get({
                __internalAllowPromised: !!this.store.promiseError
            }); // marks used
            return this.store.promiseError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateMethodsImpl.prototype, "ornull", {
        get: function() {
            var value = this.get();
            if (value === null || value === undefined) return value;
            return this.self();
        },
        enumerable: false,
        configurable: true
    });
    return StateMethodsImpl;
}();
function $2f66ed5559a61356$var$proxyWrap(path, // tslint:disable-next-line: no-any
targetBootstrap, // tslint:disable-next-line: no-any
targetGetter, // tslint:disable-next-line: no-any
propertyGetter, // tslint:disable-next-line: no-any
propertySetter, isValueProxy) {
    var onInvalidUsage = function(op) {
        throw new $2f66ed5559a61356$var$StateInvalidUsageError(path, op);
    };
    if (Object(targetBootstrap) !== targetBootstrap) targetBootstrap = {};
    return new Proxy(targetBootstrap, {
        getPrototypeOf: function(_target) {
            // should satisfy the invariants:
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/handler/getPrototypeOf#Invariants
            var targetReal = targetGetter();
            if (targetReal === undefined || targetReal === null) return null;
            if (targetReal === $2f66ed5559a61356$export$f883a24d5edde77c) return Object.getPrototypeOf(new Promise(function() {}));
            return Object.getPrototypeOf(targetReal);
        },
        setPrototypeOf: function(_target, v) {
            return onInvalidUsage(isValueProxy ? $2f66ed5559a61356$var$ErrorId.SetPrototypeOf_State : $2f66ed5559a61356$var$ErrorId.SetPrototypeOf_Value);
        },
        isExtensible: function(_target) {
            // should satisfy the invariants:
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/handler/isExtensible#Invariants
            return true; // required to satisfy the invariants of the getPrototypeOf
        // return Object.isExtensible(target);
        },
        preventExtensions: function(_target) {
            return onInvalidUsage(isValueProxy ? $2f66ed5559a61356$var$ErrorId.PreventExtensions_State : $2f66ed5559a61356$var$ErrorId.PreventExtensions_Value);
        },
        getOwnPropertyDescriptor: function(_target, p) {
            var targetReal = targetGetter();
            if (Object(targetReal) === targetReal) {
                var origin_1 = Object.getOwnPropertyDescriptor(targetReal, p);
                if (Array.isArray(targetReal) && p in Array.prototype) return origin_1;
                return origin_1 && {
                    // should be configurable as may not exist on proxy target
                    configurable: true,
                    enumerable: origin_1.enumerable,
                    get: function() {
                        return propertyGetter(targetReal, p);
                    },
                    set: undefined
                };
            }
            if (isValueProxy || targetReal === $2f66ed5559a61356$export$f883a24d5edde77c) return undefined;
            if (p === "value") return {
                // should be configurable as does not exist on proxy target
                configurable: true,
                enumerable: true,
                get: function() {
                    return targetGetter({
                        stealth: true
                    });
                },
                set: undefined
            };
            if (p === "path") return {
                // should be configurable as does not exist on proxy target
                configurable: true,
                enumerable: true,
                get: function() {
                    return path;
                },
                set: undefined
            };
            return undefined;
        },
        has: function(_target, p) {
            if (typeof p === "symbol") return false;
            var targetReal = targetGetter();
            if (Object(targetReal) === targetReal) return p in targetReal;
            if (isValueProxy || targetReal === $2f66ed5559a61356$export$f883a24d5edde77c) return false;
            return p === "value" || p === "path";
        },
        get: propertyGetter,
        set: propertySetter,
        deleteProperty: function(_target, p) {
            return onInvalidUsage(isValueProxy ? $2f66ed5559a61356$var$ErrorId.DeleteProperty_State : $2f66ed5559a61356$var$ErrorId.DeleteProperty_Value);
        },
        defineProperty: function(_target, p, attributes) {
            return onInvalidUsage(isValueProxy ? $2f66ed5559a61356$var$ErrorId.DefineProperty_State : $2f66ed5559a61356$var$ErrorId.DefineProperty_Value);
        },
        ownKeys: function(_target) {
            var targetReal = targetGetter();
            if (Array.isArray(targetReal)) {
                if (_target.length === undefined) // an object turned into an array now
                // inject length property now as it is defined on the array
                // to enable getOwnPropertyDescriptor for length not throw
                Object.defineProperty(targetBootstrap, "length", {
                    value: 0,
                    writable: true,
                    enumerable: false,
                    configurable: false
                });
            }
            if (Object(targetReal) === targetReal) return Object.getOwnPropertyNames(targetReal);
            if (isValueProxy || targetReal === $2f66ed5559a61356$export$f883a24d5edde77c) return [];
            return [
                "value",
                "path"
            ];
        },
        apply: function(_target, thisArg, argArray) {
            return onInvalidUsage(isValueProxy ? $2f66ed5559a61356$var$ErrorId.Apply_State : $2f66ed5559a61356$var$ErrorId.Apply_Value);
        },
        construct: function(_target, argArray, newTarget) {
            return onInvalidUsage(isValueProxy ? $2f66ed5559a61356$var$ErrorId.Construct_State : $2f66ed5559a61356$var$ErrorId.Construct_Value);
        }
    });
}
function $2f66ed5559a61356$var$createStore(initial) {
    var initialValue = initial;
    if (typeof initial === "function") initialValue = initial();
    if (Object(initialValue) === initialValue && initialValue[$2f66ed5559a61356$var$SelfMethodsID]) throw new $2f66ed5559a61356$var$StateInvalidUsageError($2f66ed5559a61356$var$RootPath, $2f66ed5559a61356$var$ErrorId.InitStateToValueFromState);
    return new $2f66ed5559a61356$var$Store(initialValue);
}
var $2f66ed5559a61356$var$configuration = {
    interceptDependencyListsMode: "always",
    isDevelopmentMode: typeof $cfae44f0dfdf62c0$exports === "object" && typeof $cfae44f0dfdf62c0$exports.env === "object" && false,
    promiseDetector: function(p) {
        return Promise.resolve(p) === p;
    },
    hiddenInterceptDependencyListsModeDebug: false
};
/**
 * Configures Hookstate behavior globally. This is for special cases only, when default
 * heuristics fail to work in a specific environment.
 *
 * @param config
 */ function $2f66ed5559a61356$export$8d21e34596265fa2(config) {
    var _a, _b, _c;
    $2f66ed5559a61356$var$configuration = {
        interceptDependencyListsMode: (_a = config.interceptDependencyListsMode) !== null && _a !== void 0 ? _a : $2f66ed5559a61356$var$configuration.interceptDependencyListsMode,
        isDevelopmentMode: (_b = config.isDevelopmentMode) !== null && _b !== void 0 ? _b : $2f66ed5559a61356$var$configuration.isDevelopmentMode,
        promiseDetector: (_c = config.promiseDetector) !== null && _c !== void 0 ? _c : $2f66ed5559a61356$var$configuration.promiseDetector,
        hiddenInterceptDependencyListsModeDebug: false
    };
    $2f66ed5559a61356$var$interceptReactHooks(); // not really required, but for safety
    if ($2f66ed5559a61356$var$configuration.interceptDependencyListsMode === "never") {
        $2f66ed5559a61356$var$configuration.hiddenInterceptDependencyListsModeDebug = false;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useEffect"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useEffect"] && $2f66ed5559a61356$var$useEffectOrigin;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useLayoutEffect"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useLayoutEffect"] && $2f66ed5559a61356$var$useLayoutEffectOrigin;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useInsertionEffect"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useInsertionEffect"] && $2f66ed5559a61356$var$useInsertionEffectOrigin;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useImperativeHandle"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useImperativeHandle"] && $2f66ed5559a61356$var$useImperativeHandleOrigin;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useMemo"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useMemo"] && $2f66ed5559a61356$var$useMemoOrigin;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useCallback"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useCallback"] && $2f66ed5559a61356$var$useCallbackOrigin;
        // the following does not make an effect as memo calls happen on module load
        // so it is always set to memoIntercept
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["memo"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["memo"] && $2f66ed5559a61356$var$memoOrigin;
    } else {
        // do not intercept if a hook is not defined in React
        // otherwise, it will enable 3rd party libs thinking the react runs at version 18
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useEffect"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useEffect"] && $2f66ed5559a61356$var$useEffectIntercept;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useLayoutEffect"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useLayoutEffect"] && $2f66ed5559a61356$var$useLayoutEffectIntercept;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useInsertionEffect"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useLayoutEffect"] && $2f66ed5559a61356$var$useInsertionEffectIntercept;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useImperativeHandle"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useImperativeHandle"] && $2f66ed5559a61356$var$useImperativeHandleIntercept;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useMemo"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useMemo"] && $2f66ed5559a61356$var$useMemoIntercept;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useCallback"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useCallback"] && $2f66ed5559a61356$var$useCallbackIntercept;
        // the following does not make an effect as memo calls happen on module load
        // so it is always set to memoIntercept
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["memo"] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["memo"] && $2f66ed5559a61356$var$memoIntercept;
        if ($2f66ed5559a61356$var$configuration.interceptDependencyListsMode === "development" && $2f66ed5559a61356$var$configuration.isDevelopmentMode) $2f66ed5559a61356$var$configuration.hiddenInterceptDependencyListsModeDebug = true;
    }
}
function $2f66ed5559a61356$var$reconnectDependencies(deps, fromIntercept) {
    for(var _i = 0, _a = deps || []; _i < _a.length; _i++){
        var i = _a[_i];
        if (i === Object(i)) {
            var state = i[$2f66ed5559a61356$var$self];
            if (state) {
                if (fromIntercept && $2f66ed5559a61356$var$configuration.hiddenInterceptDependencyListsModeDebug) throw new $2f66ed5559a61356$var$StateInvalidUsageError(state.path, $2f66ed5559a61356$var$ErrorId.StateUsedInDependencyList);
                state.reconnect();
            }
        }
    }
    return deps;
}
var $2f66ed5559a61356$var$useEffectOrigin;
function $2f66ed5559a61356$export$ed0ca0300c01832c(effect, deps) {
    $2f66ed5559a61356$var$reconnectDependencies(deps);
    return $2f66ed5559a61356$var$useEffectOrigin(effect, deps);
}
function $2f66ed5559a61356$var$useEffectIntercept(effect, deps) {
    $2f66ed5559a61356$var$reconnectDependencies(deps, true);
    return $2f66ed5559a61356$var$useEffectOrigin(effect, deps);
}
var $2f66ed5559a61356$var$useLayoutEffectOrigin;
function $2f66ed5559a61356$export$91c8b18630ff876a(effect, deps) {
    $2f66ed5559a61356$var$reconnectDependencies(deps);
    return $2f66ed5559a61356$var$useLayoutEffectOrigin(effect, deps);
}
function $2f66ed5559a61356$var$useLayoutEffectIntercept(effect, deps) {
    $2f66ed5559a61356$var$reconnectDependencies(deps, true);
    return $2f66ed5559a61356$var$useLayoutEffectOrigin(effect, deps);
}
var $2f66ed5559a61356$var$useInsertionEffectOrigin;
function $2f66ed5559a61356$export$6cee15fa149a0c33(effect, deps) {
    $2f66ed5559a61356$var$reconnectDependencies(deps);
    return $2f66ed5559a61356$var$useInsertionEffectOrigin(effect, deps);
}
function $2f66ed5559a61356$var$useInsertionEffectIntercept(effect, deps) {
    $2f66ed5559a61356$var$reconnectDependencies(deps, true);
    return $2f66ed5559a61356$var$useInsertionEffectOrigin(effect, deps);
}
var $2f66ed5559a61356$var$useImperativeHandleOrigin;
function $2f66ed5559a61356$export$f64bd6548cd8cffc(ref, init, deps) {
    $2f66ed5559a61356$var$reconnectDependencies(deps);
    return $2f66ed5559a61356$var$useImperativeHandleOrigin(ref, init, deps);
}
function $2f66ed5559a61356$var$useImperativeHandleIntercept(ref, init, deps) {
    $2f66ed5559a61356$var$reconnectDependencies(deps, true);
    return $2f66ed5559a61356$var$useImperativeHandleOrigin(ref, init, deps);
}
var $2f66ed5559a61356$var$useMemoOrigin;
function $2f66ed5559a61356$export$ec4b572a0b86ee2f(factory, deps) {
    $2f66ed5559a61356$var$reconnectDependencies(deps);
    return $2f66ed5559a61356$var$useMemoOrigin(factory, deps);
}
function $2f66ed5559a61356$var$useMemoIntercept(factory, deps) {
    $2f66ed5559a61356$var$reconnectDependencies(deps, true);
    return $2f66ed5559a61356$var$useMemoOrigin(factory, deps);
}
var $2f66ed5559a61356$var$useCallbackOrigin;
function $2f66ed5559a61356$export$6867ae797ad2b7d9(callback, deps) {
    $2f66ed5559a61356$var$reconnectDependencies(deps);
    return $2f66ed5559a61356$var$useCallbackOrigin(callback, deps);
}
function $2f66ed5559a61356$var$useCallbackIntercept(callback, deps) {
    $2f66ed5559a61356$var$reconnectDependencies(deps, true);
    return $2f66ed5559a61356$var$useCallbackOrigin(callback, deps);
}
var $2f66ed5559a61356$var$memoOrigin;
function $2f66ed5559a61356$export$6e172cde3cfe6d74(Component, propsAreEqual) {
    return $2f66ed5559a61356$var$memoOrigin(Component, function(prevProps, nextProps) {
        $2f66ed5559a61356$var$reconnectDependencies(Object.keys(nextProps).map(function(i) {
            return nextProps[i];
        }));
        return (propsAreEqual || $2f66ed5559a61356$var$shallowEqual)(prevProps, nextProps);
    });
}
function $2f66ed5559a61356$var$memoIntercept(Component, propsAreEqual) {
    return $2f66ed5559a61356$var$memoOrigin(Component, function(prevProps, nextProps) {
        $2f66ed5559a61356$var$reconnectDependencies(Object.keys(nextProps).map(function(i) {
            return nextProps[i];
        }), true);
        return (propsAreEqual || $2f66ed5559a61356$var$shallowEqual)(prevProps, nextProps);
    });
}
function $2f66ed5559a61356$var$interceptReactHooks() {
    if (!$2f66ed5559a61356$var$useEffectOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useEffect"]) {
        $2f66ed5559a61356$var$useEffectOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useEffect"];
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useEffect"] = $2f66ed5559a61356$var$useEffectIntercept;
    }
    if (!$2f66ed5559a61356$var$useLayoutEffectOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useLayoutEffect"]) {
        $2f66ed5559a61356$var$useLayoutEffectOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useLayoutEffect"];
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useLayoutEffect"] = $2f66ed5559a61356$var$useLayoutEffectIntercept;
    }
    if (!$2f66ed5559a61356$var$useInsertionEffectOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useInsertionEffect"]) {
        $2f66ed5559a61356$var$useInsertionEffectOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useInsertionEffect"];
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useInsertionEffect"] = $2f66ed5559a61356$var$useInsertionEffectIntercept;
    }
    if (!$2f66ed5559a61356$var$useImperativeHandleOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useImperativeHandle"]) {
        $2f66ed5559a61356$var$useImperativeHandleOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useImperativeHandle"];
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useImperativeHandle"] = $2f66ed5559a61356$var$useImperativeHandleIntercept;
    }
    if (!$2f66ed5559a61356$var$useMemoOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useMemo"]) {
        $2f66ed5559a61356$var$useMemoOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useMemo"];
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useMemo"] = $2f66ed5559a61356$var$useMemoIntercept;
    }
    if (!$2f66ed5559a61356$var$useCallbackOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useCallback"]) {
        $2f66ed5559a61356$var$useCallbackOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useCallback"];
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useCallback"] = $2f66ed5559a61356$var$useCallbackIntercept;
    }
    if (!$2f66ed5559a61356$var$memoOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["memo"]) {
        $2f66ed5559a61356$var$memoOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["memo"];
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["memo"] = $2f66ed5559a61356$var$memoIntercept;
    }
}
$2f66ed5559a61356$var$interceptReactHooks(); // TODO defer invoking it until state is created, so the configure had a chance to set it up first
// Do not try to use useLayoutEffect if DOM not available (SSR)
var $2f66ed5559a61356$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $2f66ed5559a61356$var$useLayoutEffectOrigin : $2f66ed5559a61356$var$useEffectOrigin;


// The app has a window to render DOM content in.
var $a4868a2a5bc73774$export$6367ea12ae86a4eb = typeof navigator !== "undefined" && typeof window !== "undefined";
// NW.JS' background script loads into invisible empty HTML page.
// Therefore NW.JS "main" script has all of window, document, navigator objects
// and window.open() won't be null if App's window is launched from such "main".
if ($a4868a2a5bc73774$export$6367ea12ae86a4eb && typeof nw !== "undefined") try {
    nw.Window.get();
} catch (err) {
    $a4868a2a5bc73774$export$6367ea12ae86a4eb = false;
}
var $a4868a2a5bc73774$export$344c79368b3a9c0 = !$a4868a2a5bc73774$export$6367ea12ae86a4eb;
var $a4868a2a5bc73774$export$1a85a5b39245481e = $a4868a2a5bc73774$export$6367ea12ae86a4eb ? navigator.userAgent : undefined;
function $a4868a2a5bc73774$export$7915e2c37dfd4f71(query, handler) {
    var mql = window.matchMedia(query);
    handler(mql.matches);
    var listener = ()=>handler(mql.matches);
    mql.addListener(listener);
    return ()=>mql.removeListener(listener);
}
var $a4868a2a5bc73774$export$ffb5f4729a158638 = {
    gui: $a4868a2a5bc73774$export$6367ea12ae86a4eb,
    terminal: $a4868a2a5bc73774$export$344c79368b3a9c0,
    registerQuery: $a4868a2a5bc73774$export$7915e2c37dfd4f71
};




var $ab66e3fdcbdd92a9$export$2e2bcd8739ae039 = (0, $a4868a2a5bc73774$export$ffb5f4729a158638);
// Fully functional Node & core modules.
// it is true for Node.js, Electron, NW.JS
// it is false for browsers with shims or bundles of some Node modules (shimmed process, EventEmitter, etc..)
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).node = typeof $cfae44f0dfdf62c0$exports !== "undefined" && !!$cfae44f0dfdf62c0$exports.versions && !!$cfae44f0dfdf62c0$exports.versions.node;
// Detects if the APP is launched as standalone Progressive Web App. Still a website, but looking like OS app, without url bar.
// TODO: WARNING: this returns true even for popup windows created with window.open()
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).pwa = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).gui && window.matchMedia("(display-mode: standalone)").matches && document.head.querySelector('[rel="manifest"]') !== null;
// Windows 10 app - Universal Windows Platform.
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).uwp = typeof Windows !== "undefined" && typeof MSApp !== "undefined";
// Node + Chromium
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).nwjs = !!((0, $a4868a2a5bc73774$export$ffb5f4729a158638).node && $cfae44f0dfdf62c0$exports.versions.nw);
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).electron = !!((0, $a4868a2a5bc73774$export$ffb5f4729a158638).node && $cfae44f0dfdf62c0$exports.versions.electron);
// Cordova mobile app
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).cordova = !!((0, $a4868a2a5bc73774$export$ffb5f4729a158638).gui && window.cordova);
// The platform requires app to be compiled, bundled or packaged.
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).packaged = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).uwp || (0, $a4868a2a5bc73774$export$ffb5f4729a158638).nwjs || (0, $a4868a2a5bc73774$export$ffb5f4729a158638).electron || (0, $a4868a2a5bc73774$export$ffb5f4729a158638).cordova;
// The app runs inside browser and is served from a server or browser cache.
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).web = !(0, $a4868a2a5bc73774$export$ffb5f4729a158638).node && !(0, $a4868a2a5bc73774$export$ffb5f4729a158638).packaged;
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).browser = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).web // alias
;
// App is a plain old webpage and not a PWA.
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).website = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).web && !(0, $a4868a2a5bc73774$export$ffb5f4729a158638).pwa;
// Script is executed inside Web Worker
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).worker = !(0, $a4868a2a5bc73774$export$ffb5f4729a158638).gui && typeof self !== "undefined" && self.importScripts !== undefined;
//&& self.close !== undefined
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).serviceWorker = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).worker && !!navigator.serviceWorker.controller || false;



var $3f953c817c94cd75$export$2e2bcd8739ae039 = (0, $a4868a2a5bc73774$export$ffb5f4729a158638);
// TODO: test user agent availability in worker
// TODO: figure out if these should be mutually exclusive (Tizen and Android are based on linux and have Linux in their user agents)
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).android = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).gui ? (0, $a4868a2a5bc73774$export$1a85a5b39245481e).includes("Android") : false;
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).chromeos = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).gui ? (0, $a4868a2a5bc73774$export$1a85a5b39245481e).includes("CrOS") : false;
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).tizen = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).gui ? (0, $a4868a2a5bc73774$export$1a85a5b39245481e).includes("Tizen") : false;
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).ios = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).gui && /iPad|iPhone|iPod/.test((0, $a4868a2a5bc73774$export$1a85a5b39245481e)) && !window.MSStream || false;
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).linuxBased = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).android || (0, $a4868a2a5bc73774$export$ffb5f4729a158638).tizen;
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).windows = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).node ? $cfae44f0dfdf62c0$exports.platform === "win32" : (0, $a4868a2a5bc73774$export$1a85a5b39245481e).includes("Windows");
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).macos = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).node ? $cfae44f0dfdf62c0$exports.platform === "darwin" : (0, $a4868a2a5bc73774$export$1a85a5b39245481e).includes("Macintosh");
(0, $a4868a2a5bc73774$export$ffb5f4729a158638).linux = (0, $a4868a2a5bc73774$export$ffb5f4729a158638).node ? $cfae44f0dfdf62c0$exports.platform === "linux" : (0, $a4868a2a5bc73774$export$1a85a5b39245481e).includes("Linux") && !(0, $a4868a2a5bc73774$export$ffb5f4729a158638).linuxBased && !(0, $a4868a2a5bc73774$export$ffb5f4729a158638).macos;



var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $41adf626f46b9a45$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $41adf626f46b9a45$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $6ae5e5baff12bbf7$exports = {};
"use strict";

$6ae5e5baff12bbf7$exports = (parcelRequire("6VZtt"));



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$var$index = (0, $acw62.useLayoutEffect);
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = $e62b4578a0a2b358$var$index;



var $acw62 = parcelRequire("acw62");
function $87f30c26962d1c2f$export$2e2bcd8739ae039(fn) {
    var ref = $acw62.useRef();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
}



var $hfliI = parcelRequire("hfliI");
function $9b194c139f2e9629$export$656eb38a7c1ce0b6(actorRef) {
    return "state" in actorRef;
}
function $9b194c139f2e9629$var$isDeferredActor(actorRef) {
    return "deferred" in actorRef;
}
function $9b194c139f2e9629$var$defaultGetSnapshot(actorRef) {
    return "getSnapshot" in actorRef ? actorRef.getSnapshot() : $9b194c139f2e9629$export$656eb38a7c1ce0b6(actorRef) ? actorRef.state : undefined;
}
function $9b194c139f2e9629$export$25c4ab29592aabd9(actorRef, getSnapshot) {
    if (getSnapshot === void 0) getSnapshot = $9b194c139f2e9629$var$defaultGetSnapshot;
    var actorRefRef = (0, $acw62.useRef)(actorRef);
    var deferredEventsRef = (0, $acw62.useRef)([]);
    var subscribe = (0, $acw62.useCallback)(function(handleStoreChange) {
        var unsubscribe = actorRef.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actorRef
    ]);
    var boundGetSnapshot = (0, $acw62.useCallback)(function() {
        return getSnapshot(actorRef);
    }, [
        actorRef,
        getSnapshot
    ]);
    var storeSnapshot = (0, $hfliI.useSyncExternalStore)(subscribe, boundGetSnapshot, boundGetSnapshot);
    var send = (0, $87f30c26962d1c2f$export$2e2bcd8739ae039)(function() {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var event = args[0];
            var currentActorRef = actorRefRef.current;
            // If the previous actor is a deferred actor,
            // queue the events so that they can be replayed
            // on the non-deferred actor.
            if ($9b194c139f2e9629$var$isDeferredActor(currentActorRef) && currentActorRef.deferred) deferredEventsRef.current.push(event);
            else currentActorRef.send(event);
        };
    });
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        actorRefRef.current = actorRef;
        // Dequeue deferred events from the previous deferred actorRef
        while(deferredEventsRef.current.length > 0){
            var deferredEvent = deferredEventsRef.current.shift();
            actorRef.send(deferredEvent);
        }
    }, [
        actorRef
    ]);
    return [
        storeSnapshot,
        send
    ];
}


var $e5053701c9017e98$exports = {};

$parcel$export($e5053701c9017e98$exports, "getServiceSnapshot", () => $e5053701c9017e98$export$2b6ccfda635c9803);
var $e5053701c9017e98$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $e5053701c9017e98$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $e5053701c9017e98$export$b29f828819edca8d(items, predicate) {
    var e_1, _a;
    var _b = $e5053701c9017e98$var$__read([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = $e5053701c9017e98$var$__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $e5053701c9017e98$export$2b6ccfda635c9803(service) {
    return service.status !== 0 ? service.state : service.machine.initialState;
}
// From https://github.com/reduxjs/react-redux/blob/master/src/utils/shallowEqual.ts
function $e5053701c9017e98$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $e5053701c9017e98$export$d36bdfa510afb180(objA, objB) {
    if ($e5053701c9017e98$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$e5053701c9017e98$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $9b3a0cd13590dfd2$var$isService(actor) {
    return "state" in actor && "machine" in actor;
}
var $9b3a0cd13590dfd2$var$defaultCompare = function(a, b) {
    return a === b;
};
var $9b3a0cd13590dfd2$var$defaultGetSnapshot = function(a, initialStateCacheRef) {
    if ($9b3a0cd13590dfd2$var$isService(a)) {
        // A status of 0 = interpreter not started
        if (a.status === 0 && initialStateCacheRef.current) return initialStateCacheRef.current;
        var snapshot = (0, $e5053701c9017e98$exports.getServiceSnapshot)(a);
        initialStateCacheRef.current = a.status === 0 ? snapshot : null;
        return snapshot;
    }
    return (0, $9b194c139f2e9629$export$656eb38a7c1ce0b6)(a) ? a.state : undefined;
};
function $9b3a0cd13590dfd2$export$2105062e25df4afe(actor, selector, compare, getSnapshot) {
    if (compare === void 0) compare = $9b3a0cd13590dfd2$var$defaultCompare;
    var initialStateCacheRef = (0, $acw62.useRef)(null);
    var subscribe = (0, $acw62.useCallback)(function(handleStoreChange) {
        var unsubscribe = actor.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actor
    ]);
    var boundGetSnapshot = (0, $acw62.useCallback)(function() {
        if (getSnapshot) return getSnapshot(actor);
        return $9b3a0cd13590dfd2$var$defaultGetSnapshot(actor, initialStateCacheRef);
    }, [
        actor,
        getSnapshot
    ]);
    var selectedSnapshot = (0, $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
    return selectedSnapshot;
}


const $1b0fbba0bcf650b5$export$99a4282e2c3b772d = (t)=>{
    var o;
    return null === (o = t.context.actorRef) || void 0 === o ? void 0 : o.getSnapshot();
}, $1b0fbba0bcf650b5$export$c39505fa2700473f = (o)=>{
    var n;
    return null === (n = $1b0fbba0bcf650b5$export$99a4282e2c3b772d(o)) || void 0 === n ? void 0 : n.context;
};


const $df90a4e3a95e1de7$export$2def2023b76dbf7d = (e)=>{
    const t = (t)=>(r)=>e({
                type: t,
                data: r
            });
    return {
        initializeMachine: t("INIT"),
        resendCode: t("RESEND"),
        signOut: t("SIGN_OUT"),
        submitForm: t("SUBMIT"),
        updateForm: t("CHANGE"),
        updateBlur: t("BLUR"),
        toFederatedSignIn: t("FEDERATED_SIGN_IN"),
        toResetPassword: t("RESET_PASSWORD"),
        toSignIn: t("SIGN_IN"),
        toSignUp: t("SIGN_UP"),
        skipVerification: t("SKIP")
    };
}, $df90a4e3a95e1de7$export$e6da373757d26435 = (r)=>{
    var n, s, i, a, o;
    const c = null !== (n = (0, $1b0fbba0bcf650b5$export$c39505fa2700473f)(r)) && void 0 !== n ? n : {}, { codeDeliveryDetails: u, remoteError: d, unverifiedContactMethods: l, validationError: m, totpSecretCode: h = null } = c, { socialProviders: v } = null !== (i = null === (s = r.context) || void 0 === s ? void 0 : s.config) && void 0 !== i ? i : {}, g = null !== (a = null == c ? void 0 : c.user) && void 0 !== a ? a : null === (o = r.context) || void 0 === o ? void 0 : o.user, f = m && Object.keys(m).length > 0, p = (0, $1b0fbba0bcf650b5$export$99a4282e2c3b772d)(r), S = r.hasTag("pending") || (null == p ? void 0 : p.hasTag("pending")), I = (()=>{
        switch(!0){
            case r.matches("idle"):
                return "idle";
            case r.matches("setup"):
                return "setup";
            case r.matches("signOut"):
                return "signOut";
            case r.matches("authenticated"):
                return "authenticated";
            case null == p ? void 0 : p.matches("confirmSignUp"):
                return "confirmSignUp";
            case null == p ? void 0 : p.matches("confirmSignIn"):
                return "confirmSignIn";
            case null == p ? void 0 : p.matches("setupTOTP.edit"):
            case null == p ? void 0 : p.matches("setupTOTP.submit"):
                return "setupTOTP";
            case null == p ? void 0 : p.matches("signIn"):
                return "signIn";
            case null == p ? void 0 : p.matches("signUp"):
                return "signUp";
            case null == p ? void 0 : p.matches("forceNewPassword"):
                return "forceNewPassword";
            case null == p ? void 0 : p.matches("resetPassword"):
                return "resetPassword";
            case null == p ? void 0 : p.matches("confirmResetPassword"):
                return "confirmResetPassword";
            case null == p ? void 0 : p.matches("verifyUser"):
                return "verifyUser";
            case null == p ? void 0 : p.matches("confirmVerifyUser"):
                return "confirmVerifyUser";
            case null == p ? void 0 : p.matches("setupTOTP.getTotpSecretCode"):
            case r.matches("signIn.runActor"):
                return "transition";
            default:
                return console.debug("Cannot infer `route` from Authenticator state:", r.value), null;
        }
    })(), P = ((e)=>{
        switch(e){
            case "idle":
            case "setup":
                return "configuring";
            case "authenticated":
                return "authenticated";
            default:
                return "unauthenticated";
        }
    })(I);
    return {
        authStatus: P,
        codeDeliveryDetails: u,
        error: d,
        hasValidationErrors: f,
        isPending: S,
        route: I,
        socialProviders: v,
        totpSecretCode: h,
        unverifiedContactMethods: l,
        user: g,
        validationErrors: m
    };
}, $df90a4e3a95e1de7$export$5f925d5954b1c10b = ({ send: e, state: t })=>{
    const s = $df90a4e3a95e1de7$export$2def2023b76dbf7d(e), i = $df90a4e3a95e1de7$export$e6da373757d26435(t);
    return Object.assign(Object.assign({}, s), i);
};




var $acw62 = parcelRequire("acw62");
/**
 * AuthenticatorContext serves static reference to the auth machine service.
 *
 * https://xstate.js.org/docs/recipes/react.html#context-provider
 */ const $cde51257bc807626$export$2254a7bd02a5abf7 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


const $ffecdd06c91dc243$export$7e92b2e9f0809b11 = "`useAuthenticator` must be used inside an `Authenticator.Provider`.";



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $9a4e52c79a7a812d$var$extendStatics = function(d, b) {
    $9a4e52c79a7a812d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $9a4e52c79a7a812d$var$extendStatics(d, b);
};
function $9a4e52c79a7a812d$export$a8ba968b8961cb8a(d, b) {
    $9a4e52c79a7a812d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $9a4e52c79a7a812d$export$18ce0697a983be9b = function() {
    $9a4e52c79a7a812d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9a4e52c79a7a812d$export$18ce0697a983be9b.apply(this, arguments);
};
function $9a4e52c79a7a812d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9a4e52c79a7a812d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $9a4e52c79a7a812d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $9a4e52c79a7a812d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $9a4e52c79a7a812d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $9a4e52c79a7a812d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $9a4e52c79a7a812d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $9a4e52c79a7a812d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $9a4e52c79a7a812d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $9a4e52c79a7a812d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $9a4e52c79a7a812d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($9a4e52c79a7a812d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $9a4e52c79a7a812d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $9a4e52c79a7a812d$export$10c90e4f7922046c(v) {
    return this instanceof $9a4e52c79a7a812d$export$10c90e4f7922046c ? (this.v = v, this) : new $9a4e52c79a7a812d$export$10c90e4f7922046c(v);
}
function $9a4e52c79a7a812d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9a4e52c79a7a812d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $9a4e52c79a7a812d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $9a4e52c79a7a812d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $9a4e52c79a7a812d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $9a4e52c79a7a812d$export$19a8beecd37a4c45 === "function" ? $9a4e52c79a7a812d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $9a4e52c79a7a812d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $9a4e52c79a7a812d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $9a4e52c79a7a812d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $9a4e52c79a7a812d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $9a4e52c79a7a812d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $36606c730099e1c8$exports = {};

$parcel$export($36606c730099e1c8$exports, "Amplify", () => $36606c730099e1c8$export$a3858a9a153cffc7);
var $22e905ae30d82ab4$exports = {};

$parcel$export($22e905ae30d82ab4$exports, "ConsoleLogger", () => $22e905ae30d82ab4$export$ba6a9c7ac8291f7f);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
var $3685f81745c941bf$export$480ff6141d16ea0 = 26;
var $3685f81745c941bf$export$b28184bf79b04783 = 1048576;
var $3685f81745c941bf$export$a21f820c9933d674 = 256000;
var $3685f81745c941bf$export$13470c6f1642bbce = "Logging";
var $3685f81745c941bf$export$d781556e70493844 = "AWSCloudWatch";
var $3685f81745c941bf$export$9a85ff898770a423 = "No credentials";
var $3685f81745c941bf$export$569d67cd7966b708 = [
    "ResourceNotFoundException",
    "InvalidSequenceTokenException"
];


var $22e905ae30d82ab4$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $22e905ae30d82ab4$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $22e905ae30d82ab4$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $22e905ae30d82ab4$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
var $22e905ae30d82ab4$export$ee432113040024a6;
(function(LOG_TYPE) {
    LOG_TYPE["DEBUG"] = "DEBUG";
    LOG_TYPE["ERROR"] = "ERROR";
    LOG_TYPE["INFO"] = "INFO";
    LOG_TYPE["WARN"] = "WARN";
    LOG_TYPE["VERBOSE"] = "VERBOSE";
})($22e905ae30d82ab4$export$ee432113040024a6 || ($22e905ae30d82ab4$export$ee432113040024a6 = {}));
var $22e905ae30d82ab4$export$ba6a9c7ac8291f7f = /** @class */ function() {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ function ConsoleLogger(name, level) {
        if (level === void 0) level = $22e905ae30d82ab4$export$ee432113040024a6.WARN;
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    ConsoleLogger.prototype._padding = function(n) {
        return n < 10 ? "0" + n : "" + n;
    };
    ConsoleLogger.prototype._ts = function() {
        var dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    };
    ConsoleLogger.prototype.configure = function(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LOG_TYPE|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype._log = function(type) {
        var e_1, _a;
        var msg = [];
        for(var _i = 1; _i < arguments.length; _i++)msg[_i - 1] = arguments[_i];
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) logger_level_name = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        var logger_level = $22e905ae30d82ab4$var$LOG_LEVELS[logger_level_name];
        var type_level = $22e905ae30d82ab4$var$LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        var log = console.log.bind(console);
        if (type === $22e905ae30d82ab4$export$ee432113040024a6.ERROR && console.error) log = console.error.bind(console);
        if (type === $22e905ae30d82ab4$export$ee432113040024a6.WARN && console.warn) log = console.warn.bind(console);
        var prefix = "[".concat(type, "] ").concat(this._ts(), " ").concat(this.name);
        var message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = "".concat(prefix, " - ").concat(msg[0]);
            log(message);
        } else if (msg.length === 1) {
            message = "".concat(prefix, " ").concat(msg[0]);
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            var obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = "".concat(prefix, " - ").concat(msg[0], " ").concat(obj);
            log("".concat(prefix, " - ").concat(msg[0]), obj);
        } else {
            message = "".concat(prefix, " ").concat(msg);
            log(prefix, msg);
        }
        try {
            for(var _b = $22e905ae30d82ab4$var$__values(this._pluggables), _c = _b.next(); !_c.done; _c = _b.next()){
                var plugin = _c.value;
                var logEvent = {
                    message: message,
                    timestamp: Date.now()
                };
                plugin.pushLogs([
                    logEvent
                ]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.log = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $22e905ae30d82ab4$var$__spreadArray([
            $22e905ae30d82ab4$export$ee432113040024a6.INFO
        ], $22e905ae30d82ab4$var$__read(msg), false));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.info = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $22e905ae30d82ab4$var$__spreadArray([
            $22e905ae30d82ab4$export$ee432113040024a6.INFO
        ], $22e905ae30d82ab4$var$__read(msg), false));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.warn = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $22e905ae30d82ab4$var$__spreadArray([
            $22e905ae30d82ab4$export$ee432113040024a6.WARN
        ], $22e905ae30d82ab4$var$__read(msg), false));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.error = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $22e905ae30d82ab4$var$__spreadArray([
            $22e905ae30d82ab4$export$ee432113040024a6.ERROR
        ], $22e905ae30d82ab4$var$__read(msg), false));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.debug = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $22e905ae30d82ab4$var$__spreadArray([
            $22e905ae30d82ab4$export$ee432113040024a6.DEBUG
        ], $22e905ae30d82ab4$var$__read(msg), false));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.verbose = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $22e905ae30d82ab4$var$__spreadArray([
            $22e905ae30d82ab4$export$ee432113040024a6.VERBOSE
        ], $22e905ae30d82ab4$var$__read(msg), false));
    };
    ConsoleLogger.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $3685f81745c941bf$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    };
    ConsoleLogger.prototype.listPluggables = function() {
        return this._pluggables;
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}();


var $36606c730099e1c8$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $36606c730099e1c8$var$logger = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("Amplify");
var $36606c730099e1c8$export$b412d755cfa0136 = /** @class */ function() {
    function AmplifyClass() {
        // Everything that is `register`ed is tracked here
        this._components = [];
        this._config = {};
        // All modules (with `getModuleName()`) are stored here for dependency injection
        this._modules = {};
        // for backward compatibility to avoid breaking change
        // if someone is using like Amplify.Auth
        this.Auth = null;
        this.Analytics = null;
        this.API = null;
        this.Credentials = null;
        this.Storage = null;
        this.I18n = null;
        this.Cache = null;
        this.PubSub = null;
        this.Interactions = null;
        this.Pushnotification = null;
        this.UI = null;
        this.XR = null;
        this.Predictions = null;
        this.DataStore = null;
        this.Geo = null;
        this.Notifications = null;
        this.Logger = (0, $22e905ae30d82ab4$exports.ConsoleLogger);
        this.ServiceWorker = null;
    }
    AmplifyClass.prototype.register = function(comp) {
        $36606c730099e1c8$var$logger.debug("component registered in amplify", comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === "function") {
            this._modules[comp.getModuleName()] = comp;
            this[comp.getModuleName()] = comp;
        } else $36606c730099e1c8$var$logger.debug("no getModuleName method for component", comp);
        // Finally configure this new component(category) loaded
        // With the new modularization changes in Amplify V3, all the Amplify
        // component are not loaded/registered right away but when they are
        // imported (and hence instantiated) in the client's app. This ensures
        // that all new components imported get correctly configured with the
        // configuration that Amplify.configure() was called with.
        comp.configure(this._config);
    };
    AmplifyClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        this._config = Object.assign(this._config, config);
        $36606c730099e1c8$var$logger.debug("amplify config", this._config);
        // Dependency Injection via property-setting.
        // This avoids introducing a public method/interface/setter that's difficult to remove later.
        // Plus, it reduces `if` statements within the `constructor` and `configure` of each module
        Object.entries(this._modules).forEach(function(_a) {
            var _b = $36606c730099e1c8$var$__read(_a, 2), Name = _b[0], comp = _b[1];
            // e.g. Auth.*
            Object.keys(comp).forEach(function(property) {
                // e.g. Auth["Credentials"] = this._modules["Credentials"] when set
                if (_this._modules[property]) comp[property] = _this._modules[property];
            });
        });
        this._components.map(function(comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    AmplifyClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable["getCategory"] && typeof pluggable["getCategory"] === "function") this._components.map(function(comp) {
            if (comp["addPluggable"] && typeof comp["addPluggable"] === "function") comp.addPluggable(pluggable);
        });
    };
    return AmplifyClass;
}();
var $36606c730099e1c8$export$a3858a9a153cffc7 = new $36606c730099e1c8$export$b412d755cfa0136();


var $2c4730a78a7bdcd6$exports = {};

$parcel$export($2c4730a78a7bdcd6$exports, "Platform", () => $2c4730a78a7bdcd6$export$2dffd0b5373a4389);
$parcel$export($2c4730a78a7bdcd6$exports, "getAmplifyUserAgent", () => $2c4730a78a7bdcd6$export$ede38edb26c0bfdf);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $6cb1e15d3e9d75a2$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($6cb1e15d3e9d75a2$export$638889172ebce0c4 || ($6cb1e15d3e9d75a2$export$638889172ebce0c4 = {}));
var $6cb1e15d3e9d75a2$export$3a8840c5b2ecf003;
(function(Category) {
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($6cb1e15d3e9d75a2$export$3a8840c5b2ecf003 || ($6cb1e15d3e9d75a2$export$3a8840c5b2ecf003 = {}));
var $6cb1e15d3e9d75a2$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["UpdateEndpoint"] = "2";
})($6cb1e15d3e9d75a2$export$30c16f5c43437fd7 || ($6cb1e15d3e9d75a2$export$30c16f5c43437fd7 = {}));
var $6cb1e15d3e9d75a2$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($6cb1e15d3e9d75a2$export$126e20fdc0f0d34b || ($6cb1e15d3e9d75a2$export$126e20fdc0f0d34b = {}));
var $6cb1e15d3e9d75a2$export$900b1436d7e65f4;
(function(AuthAction) {
    // SignUp = '1',
    // ConfirmSignUp = '2',
    // ResendSignUp = '3',
    // SignIn = '4',
    // GetMFAOptions = '5',
    // GetPreferredMFA = '6',
    // SetPreferredMFA = '7',
    // DisableSMS = '8',
    // EnableSMS = '9',
    // SetupTOTP = '10',
    // VerifyTotpToken = '11',
    // ConfirmSignIn = '12',
    // CompleteNewPassword = '13',
    // SendCustomChallengeAnswer = '14',
    // DeleteUserAttributes = '15',
    // DeleteUser = '16',
    // UpdateUserAttributes = '17',
    // UserAttributes = '18',
    // CurrentUserPoolUser = '19',
    // CurrentAuthenticatedUser = '20',
    // CurrentSession = '21',
    // VerifyUserAttribute = '22',
    // VerifyUserAttributeSubmit = '23',
    // VerifyCurrentUserAttribute = '24',
    // VerifyCurrentUserAttributeSubmit = '25',
    // SignOut = '26',
    // ChangePassword = '27',
    // ForgotPassword = '28',
    // ForgotPasswordSubmit = '29',
    AuthAction["FederatedSignIn"] = "30";
// CurrentUserInfo = '31',
// RememberDevice = '32',
// ForgetDevice = '33',
// FetchDevices = '34',
})($6cb1e15d3e9d75a2$export$900b1436d7e65f4 || ($6cb1e15d3e9d75a2$export$900b1436d7e65f4 = {}));
var $6cb1e15d3e9d75a2$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($6cb1e15d3e9d75a2$export$2f5a715aba4cde93 || ($6cb1e15d3e9d75a2$export$2f5a715aba4cde93 = {}));
var $6cb1e15d3e9d75a2$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["SearchByText"] = "1";
    GeoAction["SearchForSuggestions"] = "2";
    GeoAction["SearchByPlaceId"] = "3";
    GeoAction["SearchByCoordinates"] = "4";
    GeoAction["SaveGeofences"] = "5";
    GeoAction["GetGeofence"] = "6";
    GeoAction["ListGeofences"] = "7";
    GeoAction["DeleteGeofences"] = "8";
})($6cb1e15d3e9d75a2$export$afafab3eb8fc6fef || ($6cb1e15d3e9d75a2$export$afafab3eb8fc6fef = {}));
var $6cb1e15d3e9d75a2$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["None"] = "0";
    InAppMessagingAction["SyncMessages"] = "1";
    InAppMessagingAction["IdentifyUser"] = "2";
})($6cb1e15d3e9d75a2$export$c01a8c16ffda791e || ($6cb1e15d3e9d75a2$export$c01a8c16ffda791e = {}));
var $6cb1e15d3e9d75a2$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($6cb1e15d3e9d75a2$export$68e0695a774ab7fa || ($6cb1e15d3e9d75a2$export$68e0695a774ab7fa = {}));
var $6cb1e15d3e9d75a2$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($6cb1e15d3e9d75a2$export$aa89b4c447a07cee || ($6cb1e15d3e9d75a2$export$aa89b4c447a07cee = {}));
var $6cb1e15d3e9d75a2$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($6cb1e15d3e9d75a2$export$ade48b30f1e78672 || ($6cb1e15d3e9d75a2$export$ade48b30f1e78672 = {}));
var $6cb1e15d3e9d75a2$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["None"] = "0";
})($6cb1e15d3e9d75a2$export$2c5ee06ab9fa5040 || ($6cb1e15d3e9d75a2$export$2c5ee06ab9fa5040 = {}));
var $6cb1e15d3e9d75a2$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["Put"] = "1";
    StorageAction["Get"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
    StorageAction["Cancel"] = "7";
})($6cb1e15d3e9d75a2$export$d4f3c54b808b00ce || ($6cb1e15d3e9d75a2$export$d4f3c54b808b00ce = {}));


// generated by genversion
var $ebc0a6a6220d1fd4$export$83d89fbfd8236492 = "5.3.7";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $09aecb4271a366bf$export$a15eed0e463030a9 = function() {
    return typeof $parcel$global !== "undefined";
};
var $09aecb4271a366bf$export$a5e7eb32e5221222 = function() {
    return typeof globalThis !== "undefined";
};
var $09aecb4271a366bf$export$daba2802a1a41c1f = function() {
    return typeof window !== "undefined";
};
var $09aecb4271a366bf$export$b949ebcb877faa59 = function() {
    return typeof document !== "undefined";
};
var $09aecb4271a366bf$export$ba10401363d0f7f6 = function() {
    return typeof $cfae44f0dfdf62c0$exports !== "undefined";
};
var $09aecb4271a366bf$export$252f88727cff70c7 = function(object, prefix) {
    return !!Object.keys(object).find(function(key) {
        return key.startsWith(prefix);
    });
};



function $5bcc6d536a5b9021$export$ba3f37c54f0f7805() {
    var elementKeyPrefixedWithReact = function(key) {
        return key.startsWith("_react") || key.startsWith("__react");
    };
    var elementIsReactEnabled = function(element) {
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    var allElementsWithId = function() {
        return Array.from(document.querySelectorAll("[id]"));
    };
    return (0, $09aecb4271a366bf$export$b949ebcb877faa59)() && allElementsWithId().some(elementIsReactEnabled);
}
function $5bcc6d536a5b9021$export$86269c582305790() {
    return (0, $09aecb4271a366bf$export$ba10401363d0f7f6)() && typeof $cfae44f0dfdf62c0$exports.env !== "undefined" && !!Object.keys($cfae44f0dfdf62c0$exports.env).find(function(key) {
        return key.includes("react");
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $cf63d90f99f7c616$export$d91d90d62b78936d() {
    return (0, $09aecb4271a366bf$export$daba2802a1a41c1f)() && (0, $09aecb4271a366bf$export$252f88727cff70c7)(window, "__VUE");
}
function $cf63d90f99f7c616$export$257a4c0f8294a101() {
    return (0, $09aecb4271a366bf$export$a15eed0e463030a9)() && (0, $09aecb4271a366bf$export$252f88727cff70c7)($parcel$global, "__VUE");
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $a7019e12219b2eb0$export$6dafc32a94edaed3() {
    return (0, $09aecb4271a366bf$export$daba2802a1a41c1f)() && (0, $09aecb4271a366bf$export$252f88727cff70c7)(window, "__SVELTE");
}
function $a7019e12219b2eb0$export$819dcb7fe144d8b0() {
    return (0, $09aecb4271a366bf$export$ba10401363d0f7f6)() && typeof $cfae44f0dfdf62c0$exports.env !== "undefined" && !!Object.keys($cfae44f0dfdf62c0$exports.env).find(function(key) {
        return key.includes("svelte");
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $4fe97c1341951927$export$f8462bcf03110eff() {
    // @ts-ignore
    return (0, $09aecb4271a366bf$export$daba2802a1a41c1f)() && window["next"] && typeof window["next"] === "object";
}
function $4fe97c1341951927$export$61c08ed144a5d4ca() {
    return (0, $09aecb4271a366bf$export$a15eed0e463030a9)() && ((0, $09aecb4271a366bf$export$252f88727cff70c7)($parcel$global, "__next") || (0, $09aecb4271a366bf$export$252f88727cff70c7)($parcel$global, "__NEXT"));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $61d3b179c0d4374f$export$bed54a4e6d9d25fb() {
    return (0, $09aecb4271a366bf$export$daba2802a1a41c1f)() && // @ts-ignore
    (window["__NUXT__"] !== undefined || window["$nuxt"] !== undefined);
}
function $61d3b179c0d4374f$export$fb3ce982948d27e8() {
    // @ts-ignore
    return (0, $09aecb4271a366bf$export$a15eed0e463030a9)() && typeof $parcel$global["__NUXT_PATHS__"] !== "undefined";
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $1530bb3285d0a1d3$export$b5a20bd39eb02ba0() {
    var angularVersionSetInDocument = Boolean((0, $09aecb4271a366bf$export$b949ebcb877faa59)() && document.querySelector("[ng-version]"));
    var angularContentSetInWindow = Boolean(// @ts-ignore
    (0, $09aecb4271a366bf$export$daba2802a1a41c1f)() && typeof window["ng"] !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $1530bb3285d0a1d3$export$8ab518c8987c870f() {
    var _a;
    return (0, $09aecb4271a366bf$export$ba10401363d0f7f6)() && typeof $cfae44f0dfdf62c0$exports.env === "object" && ((_a = undefined, _a === void 0) ? void 0 : _a.startsWith("ng ")) || false;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $50991d5800439a6f$export$1c8414c1859e3748() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $25b60bcf0dd94efa$export$85fd46d5e29a4f7e() {
    // @ts-ignore
    return (0, $09aecb4271a366bf$export$a15eed0e463030a9)() && typeof $parcel$global["expo"] !== "undefined";
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $6b94d57755da91cb$export$41b1270b988065fb() {
    return (0, $09aecb4271a366bf$export$daba2802a1a41c1f)();
}


// These are in the order of detection where when both are detectable, the early Framework will be reported
var $cddbbd3c6e04a4ee$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).Expo,
        detectionMethod: (0, $25b60bcf0dd94efa$export$85fd46d5e29a4f7e)
    },
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).ReactNative,
        detectionMethod: (0, $50991d5800439a6f$export$1c8414c1859e3748)
    },
    // Next, detect web frameworks
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).NextJs,
        detectionMethod: (0, $4fe97c1341951927$export$f8462bcf03110eff)
    },
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).Nuxt,
        detectionMethod: (0, $61d3b179c0d4374f$export$bed54a4e6d9d25fb)
    },
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).Angular,
        detectionMethod: (0, $1530bb3285d0a1d3$export$b5a20bd39eb02ba0)
    },
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).React,
        detectionMethod: (0, $5bcc6d536a5b9021$export$ba3f37c54f0f7805)
    },
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).VueJs,
        detectionMethod: (0, $cf63d90f99f7c616$export$d91d90d62b78936d)
    },
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).Svelte,
        detectionMethod: (0, $a7019e12219b2eb0$export$6dafc32a94edaed3)
    },
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).WebUnknown,
        detectionMethod: (0, $6b94d57755da91cb$export$41b1270b988065fb)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).NextJsSSR,
        detectionMethod: (0, $4fe97c1341951927$export$61c08ed144a5d4ca)
    },
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).NuxtSSR,
        detectionMethod: (0, $61d3b179c0d4374f$export$fb3ce982948d27e8)
    },
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).ReactSSR,
        detectionMethod: (0, $5bcc6d536a5b9021$export$86269c582305790)
    },
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).VueJsSSR,
        detectionMethod: (0, $cf63d90f99f7c616$export$257a4c0f8294a101)
    },
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).AngularSSR,
        detectionMethod: (0, $1530bb3285d0a1d3$export$8ab518c8987c870f)
    },
    {
        platform: (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).SvelteSSR,
        detectionMethod: (0, $a7019e12219b2eb0$export$819dcb7fe144d8b0)
    }
];
function $cddbbd3c6e04a4ee$export$17b446b869dad473() {
    var _a;
    return ((_a = $cddbbd3c6e04a4ee$var$detectionMap.find(function(detectionEntry) {
        return detectionEntry.detectionMethod();
    })) === null || _a === void 0 ? void 0 : _a.platform) || (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).ServerSideUnknown;
}


// We want to cache detection since the framework won't change
var $2f2ed3122ffc90d4$var$frameworkCache;
var $2f2ed3122ffc90d4$var$frameworkChangeObservers = [];
// Setup the detection reset tracking / timeout delays
var $2f2ed3122ffc90d4$var$resetTriggered = false;
var $2f2ed3122ffc90d4$var$SSR_RESET_TIMEOUT = 10; // ms
var $2f2ed3122ffc90d4$var$WEB_RESET_TIMEOUT = 10; // ms
var $2f2ed3122ffc90d4$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
var $2f2ed3122ffc90d4$export$9ce73e459ec93b6a = function() {
    if (!$2f2ed3122ffc90d4$var$frameworkCache) {
        $2f2ed3122ffc90d4$var$frameworkCache = (0, $cddbbd3c6e04a4ee$export$17b446b869dad473)();
        // Everytime we update the cache, call each observer function
        $2f2ed3122ffc90d4$var$frameworkChangeObservers.forEach(function(fcn) {
            return fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        $2f2ed3122ffc90d4$var$resetTimeout((0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).ServerSideUnknown, $2f2ed3122ffc90d4$var$SSR_RESET_TIMEOUT);
        $2f2ed3122ffc90d4$var$resetTimeout((0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).WebUnknown, $2f2ed3122ffc90d4$var$WEB_RESET_TIMEOUT);
    }
    return $2f2ed3122ffc90d4$var$frameworkCache;
};
var $2f2ed3122ffc90d4$export$5d5c467ce0b213f = function(fcn) {
    $2f2ed3122ffc90d4$var$frameworkChangeObservers.push(fcn);
};
function $2f2ed3122ffc90d4$export$d2adf65b87e47523() {
    $2f2ed3122ffc90d4$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $2f2ed3122ffc90d4$var$resetTimeout(framework, delay) {
    if ($2f2ed3122ffc90d4$var$frameworkCache === framework && !$2f2ed3122ffc90d4$var$resetTriggered) setTimeout(function() {
        $2f2ed3122ffc90d4$export$d2adf65b87e47523();
        $2f2ed3122ffc90d4$var$resetTriggered = true;
        setTimeout($2f2ed3122ffc90d4$export$9ce73e459ec93b6a, $2f2ed3122ffc90d4$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}


var $2c4730a78a7bdcd6$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $2c4730a78a7bdcd6$var$BASE_USER_AGENT = "aws-amplify";
var $2c4730a78a7bdcd6$var$PlatformBuilder = /** @class */ function() {
    function PlatformBuilder() {
        this.userAgent = "".concat($2c4730a78a7bdcd6$var$BASE_USER_AGENT, "/").concat((0, $ebc0a6a6220d1fd4$export$83d89fbfd8236492));
    }
    Object.defineProperty(PlatformBuilder.prototype, "framework", {
        get: function() {
            return (0, $2f2ed3122ffc90d4$export$9ce73e459ec93b6a)();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformBuilder.prototype, "isReactNative", {
        get: function() {
            return this.framework === (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).ReactNative || this.framework === (0, $6cb1e15d3e9d75a2$export$638889172ebce0c4).Expo;
        },
        enumerable: false,
        configurable: true
    });
    PlatformBuilder.prototype.observeFrameworkChanges = function(fcn) {
        (0, $2f2ed3122ffc90d4$export$5d5c467ce0b213f)(fcn);
    };
    return PlatformBuilder;
}();
var $2c4730a78a7bdcd6$export$2dffd0b5373a4389 = new $2c4730a78a7bdcd6$var$PlatformBuilder();
var $2c4730a78a7bdcd6$export$7d201307d8979e21 = function(_a) {
    var _b = _a === void 0 ? {} : _a, category = _b.category, action = _b.action, framework = _b.framework, additionalInfo = _b.additionalInfo;
    var userAgent = [
        [
            $2c4730a78a7bdcd6$var$BASE_USER_AGENT,
            (0, $ebc0a6a6220d1fd4$export$83d89fbfd8236492)
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        framework || (0, $2f2ed3122ffc90d4$export$9ce73e459ec93b6a)()
    ]);
    if (additionalInfo) userAgent = userAgent.concat(additionalInfo);
    return userAgent;
};
var $2c4730a78a7bdcd6$export$ede38edb26c0bfdf = function(customUserAgentDetails) {
    var userAgent = $2c4730a78a7bdcd6$export$7d201307d8979e21(customUserAgentDetails);
    var userAgentString = userAgent.map(function(_a) {
        var _b = $2c4730a78a7bdcd6$var$__read(_a, 2), agentKey = _b[0], agentValue = _b[1];
        return "".concat(agentKey, "/").concat(agentValue);
    }).join(" ");
    return userAgentString;
};





var $1a908fb961b3fa6b$exports = {};

$parcel$export($1a908fb961b3fa6b$exports, "Hub", () => $1a908fb961b3fa6b$export$8c41bb232f1008b1);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $1a908fb961b3fa6b$var$__assign = undefined && undefined.__assign || function() {
    $1a908fb961b3fa6b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1a908fb961b3fa6b$var$__assign.apply(this, arguments);
};
var $1a908fb961b3fa6b$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $1a908fb961b3fa6b$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $1a908fb961b3fa6b$var$logger = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("Hub");
var $1a908fb961b3fa6b$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
function $1a908fb961b3fa6b$var$isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var $1a908fb961b3fa6b$export$6b38ef2be9abbbb9 = /** @class */ function() {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ HubClass.prototype._remove = function(channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function(_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                $1a908fb961b3fa6b$var$logger.warn("No listeners for ".concat(channel));
                return;
            }
            this.patterns = $1a908fb961b3fa6b$var$__spreadArray([], $1a908fb961b3fa6b$var$__read(this.patterns.filter(function(x) {
                return x !== pattern_1;
            })), false);
        } else {
            var holder = this.listeners[channel];
            if (!holder) {
                $1a908fb961b3fa6b$var$logger.warn("No listeners for ".concat(channel));
                return;
            }
            this.listeners[channel] = $1a908fb961b3fa6b$var$__spreadArray([], $1a908fb961b3fa6b$var$__read(holder.filter(function(_a) {
                var callback = _a.callback;
                return callback !== listener;
            })), false);
        }
    };
    /**
     * @deprecated Instead of calling Hub.remove, call the result of Hub.listen.
     */ HubClass.prototype.remove = function(channel, listener) {
        this._remove(channel, listener);
    };
    /**
     * Used to send a Hub event.
     *
     * @param channel - The channel on which the event will be broadcast
     * @param payload - The HubPayload
     * @param source  - The source of the event; defaults to ''
     * @param ampSymbol - Symbol used to determine if the event is dispatched internally on a protected channel
     *
     */ HubClass.prototype.dispatch = function(channel, payload, source, ampSymbol) {
        if (source === void 0) source = "";
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === $1a908fb961b3fa6b$var$AMPLIFY_SYMBOL;
            if (!hasAccess) $1a908fb961b3fa6b$var$logger.warn("WARNING: ".concat(channel, " is protected and dispatching on it can have unintended consequences"));
        }
        var capsule = {
            channel: channel,
            payload: $1a908fb961b3fa6b$var$__assign({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $1a908fb961b3fa6b$var$logger.error(e);
        }
    };
    /**
     * Used to listen for Hub events.
     *
     * @param channel - The channel on which to listen
     * @param callback - The callback to execute when an event is received on the specified channel
     * @param listenerName - The name of the listener; defaults to 'noname'
     * @returns A function which can be called to cancel the listener.
     *
     */ HubClass.prototype.listen = function(channel, callback, listenerName) {
        var _this = this;
        if (listenerName === void 0) listenerName = "noname";
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if ($1a908fb961b3fa6b$var$isLegacyCallback(callback)) {
            $1a908fb961b3fa6b$var$logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        } else if (typeof callback !== "function") throw new Error("No callback supplied to Hub");
        else cb = callback;
        if (channel instanceof RegExp) this.patterns.push({
            pattern: channel,
            callback: cb
        });
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb
            });
        }
        return function() {
            _this._remove(channel, cb);
        };
    };
    HubClass.prototype._toListeners = function(capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) holder.forEach(function(listener) {
            $1a908fb961b3fa6b$var$logger.debug("Dispatching to ".concat(channel, " with "), payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $1a908fb961b3fa6b$var$logger.error(e);
            }
        });
        if (this.patterns.length > 0) {
            if (!payload.message) {
                $1a908fb961b3fa6b$var$logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function(pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var _a = $1a908fb961b3fa6b$var$__read(match), groups = _a.slice(1);
                    var dispatchingCapsule = $1a908fb961b3fa6b$var$__assign($1a908fb961b3fa6b$var$__assign({}, capsule), {
                        patternInfo: groups
                    });
                    try {
                        pattern.callback(dispatchingCapsule);
                    } catch (e) {
                        $1a908fb961b3fa6b$var$logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}();
var $1a908fb961b3fa6b$export$8c41bb232f1008b1 = new $1a908fb961b3fa6b$export$6b38ef2be9abbbb9("__default__");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $0d974636016b3300$exports = {};

$parcel$export($0d974636016b3300$exports, "I18n", () => $0d974636016b3300$export$dbe3113d60765c1a);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $0d974636016b3300$var$__assign = undefined && undefined.__assign || function() {
    $0d974636016b3300$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0d974636016b3300$var$__assign.apply(this, arguments);
};
var $0d974636016b3300$var$logger = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("I18n");
/**
 * Language transition class
 */ var $0d974636016b3300$export$dbe3113d60765c1a = /** @class */ function() {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ function I18n(options) {
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang && typeof window !== "undefined" && window && window.navigator) this._lang = window.navigator.language;
        $0d974636016b3300$var$logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.prototype.setLanguage = function(lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.prototype.get = function(key, defVal) {
        if (defVal === void 0) defVal = undefined;
        if (!this._lang) return typeof defVal !== "undefined" ? defVal : key;
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf("-") > 0) val = this.getByLanguage(key, lang.split("-")[0]);
        if (val) return val;
        return typeof defVal !== "undefined" ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ I18n.prototype.getByLanguage = function(key, language, defVal) {
        if (defVal === void 0) defVal = null;
        if (!language) return defVal;
        var lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        this._dict[language] = $0d974636016b3300$var$__assign($0d974636016b3300$var$__assign({}, lang_dict), vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.prototype.putVocabularies = function(vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function(key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}();




var $a204f73577cd8409$var$logger = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("I18n");
var $a204f73577cd8409$var$_config = null;
var $a204f73577cd8409$var$_i18n = null;
/**
 * Export I18n APIs
 */ var $a204f73577cd8409$export$dbe3113d60765c1a = /** @class */ function() {
    function I18n() {}
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ I18n.configure = function(config) {
        $a204f73577cd8409$var$logger.debug("configure I18n");
        if (!config) return $a204f73577cd8409$var$_config;
        $a204f73577cd8409$var$_config = Object.assign({}, $a204f73577cd8409$var$_config, config.I18n || config);
        I18n.createInstance();
        return $a204f73577cd8409$var$_config;
    };
    I18n.getModuleName = function() {
        return "I18n";
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ I18n.createInstance = function() {
        $a204f73577cd8409$var$logger.debug("create I18n instance");
        if ($a204f73577cd8409$var$_i18n) return;
        $a204f73577cd8409$var$_i18n = new (0, $0d974636016b3300$exports.I18n)($a204f73577cd8409$var$_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.setLanguage = function(lang) {
        I18n.checkConfig();
        return $a204f73577cd8409$var$_i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.get = function(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === "undefined" ? key : defVal;
        return $a204f73577cd8409$var$_i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.putVocabulariesForLanguage = function(language, vocabularies) {
        I18n.checkConfig();
        return $a204f73577cd8409$var$_i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.putVocabularies = function(vocabularies) {
        I18n.checkConfig();
        return $a204f73577cd8409$var$_i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function() {
        if (!$a204f73577cd8409$var$_i18n) $a204f73577cd8409$var$_i18n = new (0, $0d974636016b3300$exports.I18n)($a204f73577cd8409$var$_config);
        return true;
    };
    return I18n;
}();
(0, $36606c730099e1c8$exports.Amplify).register($a204f73577cd8409$export$dbe3113d60765c1a);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $28ca6f9027b485a7$var$MIME_MAP = [
    {
        type: "text/plain",
        ext: "txt"
    },
    {
        type: "text/html",
        ext: "html"
    },
    {
        type: "text/javascript",
        ext: "js"
    },
    {
        type: "text/css",
        ext: "css"
    },
    {
        type: "text/csv",
        ext: "csv"
    },
    {
        type: "text/yaml",
        ext: "yml"
    },
    {
        type: "text/yaml",
        ext: "yaml"
    },
    {
        type: "text/calendar",
        ext: "ics"
    },
    {
        type: "text/calendar",
        ext: "ical"
    },
    {
        type: "image/apng",
        ext: "apng"
    },
    {
        type: "image/bmp",
        ext: "bmp"
    },
    {
        type: "image/gif",
        ext: "gif"
    },
    {
        type: "image/x-icon",
        ext: "ico"
    },
    {
        type: "image/x-icon",
        ext: "cur"
    },
    {
        type: "image/jpeg",
        ext: "jpg"
    },
    {
        type: "image/jpeg",
        ext: "jpeg"
    },
    {
        type: "image/jpeg",
        ext: "jfif"
    },
    {
        type: "image/jpeg",
        ext: "pjp"
    },
    {
        type: "image/jpeg",
        ext: "pjpeg"
    },
    {
        type: "image/png",
        ext: "png"
    },
    {
        type: "image/svg+xml",
        ext: "svg"
    },
    {
        type: "image/tiff",
        ext: "tif"
    },
    {
        type: "image/tiff",
        ext: "tiff"
    },
    {
        type: "image/webp",
        ext: "webp"
    },
    {
        type: "application/json",
        ext: "json"
    },
    {
        type: "application/xml",
        ext: "xml"
    },
    {
        type: "application/x-sh",
        ext: "sh"
    },
    {
        type: "application/zip",
        ext: "zip"
    },
    {
        type: "application/x-rar-compressed",
        ext: "rar"
    },
    {
        type: "application/x-tar",
        ext: "tar"
    },
    {
        type: "application/x-bzip",
        ext: "bz"
    },
    {
        type: "application/x-bzip2",
        ext: "bz2"
    },
    {
        type: "application/pdf",
        ext: "pdf"
    },
    {
        type: "application/java-archive",
        ext: "jar"
    },
    {
        type: "application/msword",
        ext: "doc"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xls"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xlsx"
    },
    {
        type: "message/rfc822",
        ext: "eml"
    }
];
var $28ca6f9027b485a7$export$dd1bc94b04021eeb = function(obj) {
    if (obj === void 0) obj = {};
    return Object.keys(obj).length === 0;
};
var $28ca6f9027b485a7$export$756e1e7707954007 = function(list, field, dir) {
    if (!list || !list.sort) return false;
    var dirX = dir && dir === "desc" ? -1 : 1;
    list.sort(function(a, b) {
        var a_val = a[field];
        var b_val = b[field];
        if (typeof b_val === "undefined") return typeof a_val === "undefined" ? 0 : 1 * dirX;
        if (typeof a_val === "undefined") return -1 * dirX;
        if (a_val < b_val) return -1 * dirX;
        if (a_val > b_val) return 1 * dirX;
        return 0;
    });
    return true;
};
var $28ca6f9027b485a7$export$5e10ed067f63a9ea = function(obj, less) {
    var ret = Object.assign({}, obj);
    if (less) {
        if (typeof less === "string") delete ret[less];
        else less.forEach(function(attr) {
            delete ret[attr];
        });
    }
    return ret;
};
var $28ca6f9027b485a7$export$49cecb876bed446d = function(filename, defVal) {
    if (defVal === void 0) defVal = "application/octet-stream";
    var name = filename.toLowerCase();
    var filtered = $28ca6f9027b485a7$var$MIME_MAP.filter(function(mime) {
        return name.endsWith("." + mime.ext);
    });
    return filtered.length > 0 ? filtered[0].type : defVal;
};
var $28ca6f9027b485a7$export$689bea3eece53c0e = function(contentType) {
    var type = contentType.toLowerCase();
    if (type.startsWith("text/")) return true;
    return "application/json" === type || "application/xml" === type || "application/sh" === type;
};
var $28ca6f9027b485a7$export$9e15fb06e64c4810 = function() {
    var result = "";
    var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(var i = 32; i > 0; i -= 1)result += chars[Math.floor(Math.random() * chars.length)];
    return result;
};
var $28ca6f9027b485a7$export$8f33cb495ca11832 = function(promise) {
    if (promise.isResolved) return promise;
    var isPending = true;
    var isRejected = false;
    var isFullfilled = false;
    var result = promise.then(function(data) {
        isFullfilled = true;
        isPending = false;
        return data;
    }, function(e) {
        isRejected = true;
        isPending = false;
        throw e;
    });
    result.isFullfilled = function() {
        return isFullfilled;
    };
    result.isPending = function() {
        return isPending;
    };
    result.isRejected = function() {
        return isRejected;
    };
    return result;
};
var $28ca6f9027b485a7$export$97b87b8868ff7a3c = function() {
    if (typeof self === "undefined") return false;
    var selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== "undefined" && self instanceof selfContext.WorkerGlobalScope;
};
var $28ca6f9027b485a7$export$a2708fdb45cd35f = function() {
    var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
    var isNode = typeof $cfae44f0dfdf62c0$exports !== "undefined" && $cfae44f0dfdf62c0$exports.versions != null && $cfae44f0dfdf62c0$exports.versions.node != null;
    return {
        isBrowser: isBrowser,
        isNode: isNode
    };
};
var $28ca6f9027b485a7$export$6281ea8cfc59a49c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$28ca6f9027b485a7$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
        ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : $28ca6f9027b485a7$export$6281ea8cfc59a49c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $28ca6f9027b485a7$export$f8790a3d3d35829c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$28ca6f9027b485a7$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferredKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
        ret[transferredKey] = whiteListForChildren.includes(key) ? obj[key] : $28ca6f9027b485a7$export$f8790a3d3d35829c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $28ca6f9027b485a7$export$250974ab4f95003c = function(obj) {
    return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
};



var $f0d1ba27142d0e07$exports = {};

$parcel$export($f0d1ba27142d0e07$exports, "parseAWSExports", () => $f0d1ba27142d0e07$export$1ef2e9c2da492d);

var $f0d1ba27142d0e07$var$__assign = undefined && undefined.__assign || function() {
    $f0d1ba27142d0e07$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f0d1ba27142d0e07$var$__assign.apply(this, arguments);
};
var $f0d1ba27142d0e07$var$logger = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("Parser");
var $f0d1ba27142d0e07$export$1ef2e9c2da492d = function(config) {
    var amplifyConfig = {};
    // Analytics
    if (config["aws_mobile_analytics_app_id"]) {
        var Analytics = {
            AWSPinpoint: {
                appId: config["aws_mobile_analytics_app_id"],
                region: config["aws_mobile_analytics_app_region"]
            }
        };
        amplifyConfig.Analytics = Analytics;
    }
    // Auth
    if (config["aws_cognito_identity_pool_id"] || config["aws_user_pools_id"]) amplifyConfig.Auth = {
        userPoolId: config["aws_user_pools_id"],
        userPoolWebClientId: config["aws_user_pools_web_client_id"],
        region: config["aws_cognito_region"],
        identityPoolId: config["aws_cognito_identity_pool_id"],
        identityPoolRegion: config["aws_cognito_region"],
        mandatorySignIn: config["aws_mandatory_sign_in"] === "enable",
        signUpVerificationMethod: config["aws_cognito_sign_up_verification_method"] || "code"
    };
    // Storage
    var storageConfig;
    if (config["aws_user_files_s3_bucket"]) storageConfig = {
        AWSS3: {
            bucket: config["aws_user_files_s3_bucket"],
            region: config["aws_user_files_s3_bucket_region"],
            dangerouslyConnectToHttpEndpointForTesting: config["aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing"]
        }
    };
    else storageConfig = config ? config.Storage || config : {};
    // Logging
    if (config["Logging"]) amplifyConfig.Logging = $f0d1ba27142d0e07$var$__assign($f0d1ba27142d0e07$var$__assign({}, config["Logging"]), {
        region: config["aws_project_region"]
    });
    // Geo
    if (config["geo"]) {
        amplifyConfig.Geo = Object.assign({}, config.geo);
        if (config.geo["amazon_location_service"]) amplifyConfig.Geo = {
            AmazonLocationService: config.geo["amazon_location_service"]
        };
    }
    amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
    amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
    amplifyConfig.Storage = Object.assign({}, storageConfig);
    amplifyConfig.Logging = Object.assign({}, amplifyConfig.Logging, config.Logging);
    $f0d1ba27142d0e07$var$logger.debug("parse config", config, "to amplifyconfig", amplifyConfig);
    return amplifyConfig;
};





var $de9f45d92f772164$exports = {};

$parcel$export($de9f45d92f772164$exports, "Credentials", () => $de9f45d92f772164$export$a9627919734faa48);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $7a47fb194d2f9787$var$dataMemory = {};
/** @class */ var $7a47fb194d2f9787$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {}
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ MemoryStorage.setItem = function(key, value) {
        $7a47fb194d2f9787$var$dataMemory[key] = value;
        return $7a47fb194d2f9787$var$dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ MemoryStorage.getItem = function(key) {
        return Object.prototype.hasOwnProperty.call($7a47fb194d2f9787$var$dataMemory, key) ? $7a47fb194d2f9787$var$dataMemory[key] : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ MemoryStorage.removeItem = function(key) {
        return delete $7a47fb194d2f9787$var$dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ MemoryStorage.clear = function() {
        $7a47fb194d2f9787$var$dataMemory = {};
        return $7a47fb194d2f9787$var$dataMemory;
    };
    return MemoryStorage;
}();
var $7a47fb194d2f9787$export$a2bd19c49e4760e8 = /** @class */ function() {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.amplify.test-ls", 1);
            this.storageWindow.removeItem("aws.amplify.test-ls");
        } catch (exception) {
            this.storageWindow = $7a47fb194d2f9787$export$d7392285c701ecf5;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */ StorageHelper.prototype.getStorage = function() {
        return this.storageWindow;
    };
    return StorageHelper;
}();



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $05e6294b0a9e5f29$exports = {};

$parcel$export($05e6294b0a9e5f29$exports, "GoogleOAuth", () => $05e6294b0a9e5f29$export$75ace714083c1340);


var $f37409221557361a$exports = {};

$parcel$export($f37409221557361a$exports, "NonRetryableError", () => $f37409221557361a$export$1e38badc838ad384);
$parcel$export($f37409221557361a$exports, "jitteredBackoff", () => $f37409221557361a$export$caea50bde345f648);
$parcel$export($f37409221557361a$exports, "jitteredExponentialRetry", () => $f37409221557361a$export$a24aa7705df9cf44);

var $f37409221557361a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f37409221557361a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f37409221557361a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f37409221557361a$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f37409221557361a$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f37409221557361a$var$logger = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("Util");
var $f37409221557361a$export$1e38badc838ad384 = /** @class */ function(_super) {
    $f37409221557361a$var$__extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
var $f37409221557361a$export$490cab1f6f83794d = function(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $f37409221557361a$export$9369b12211e1fce4(functionToRetry, args, delayFn, onTerminate) {
    return $f37409221557361a$var$__awaiter(this, void 0, void 0, function() {
        var _this = this;
        return $f37409221557361a$var$__generator(this, function(_a) {
            if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    return $f37409221557361a$var$__awaiter(_this, void 0, void 0, function() {
                        var attempt, terminated, timeout, wakeUp, lastError, _loop_1, state_1;
                        return $f37409221557361a$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    attempt = 0;
                                    terminated = false;
                                    wakeUp = function() {};
                                    onTerminate && onTerminate.then(function() {
                                        // signal not to try anymore.
                                        terminated = true;
                                        // stop sleeping if we're sleeping.
                                        clearTimeout(timeout);
                                        wakeUp();
                                    });
                                    _loop_1 = function() {
                                        var _b, _c, err_1, retryIn_1;
                                        return $f37409221557361a$var$__generator(this, function(_d) {
                                            switch(_d.label){
                                                case 0:
                                                    attempt++;
                                                    $f37409221557361a$var$logger.debug("".concat(functionToRetry.name, " attempt #").concat(attempt, " with this vars: ").concat(JSON.stringify(args)));
                                                    _d.label = 1;
                                                case 1:
                                                    _d.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        7
                                                    ]);
                                                    _b = {};
                                                    _c = resolve;
                                                    return [
                                                        4 /*yield*/ ,
                                                        functionToRetry.apply(void 0, $f37409221557361a$var$__spreadArray([], $f37409221557361a$var$__read(args), false))
                                                    ];
                                                case 2:
                                                    return [
                                                        2 /*return*/ ,
                                                        (_b.value = _c.apply(void 0, [
                                                            _d.sent()
                                                        ]), _b)
                                                    ];
                                                case 3:
                                                    err_1 = _d.sent();
                                                    lastError = err_1;
                                                    $f37409221557361a$var$logger.debug("error on ".concat(functionToRetry.name), err_1);
                                                    if ($f37409221557361a$export$490cab1f6f83794d(err_1)) {
                                                        $f37409221557361a$var$logger.debug("".concat(functionToRetry.name, " non retryable error"), err_1);
                                                        return [
                                                            2 /*return*/ ,
                                                            {
                                                                value: reject(err_1)
                                                            }
                                                        ];
                                                    }
                                                    retryIn_1 = delayFn(attempt, args, err_1);
                                                    $f37409221557361a$var$logger.debug("".concat(functionToRetry.name, " retrying in ").concat(retryIn_1, " ms"));
                                                    if (!(retryIn_1 === false || terminated)) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    return [
                                                        2 /*return*/ ,
                                                        {
                                                            value: reject(err_1)
                                                        }
                                                    ];
                                                case 4:
                                                    return [
                                                        4 /*yield*/ ,
                                                        new Promise(function(r) {
                                                            wakeUp = r; // export wakeUp for onTerminate handling
                                                            timeout = setTimeout(wakeUp, retryIn_1);
                                                        })
                                                    ];
                                                case 5:
                                                    _d.sent();
                                                    _d.label = 6;
                                                case 6:
                                                    return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                case 7:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    };
                                    _a.label = 1;
                                case 1:
                                    if (!!terminated) return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                    return [
                                        5 /*yield**/ ,
                                        _loop_1()
                                    ];
                                case 2:
                                    state_1 = _a.sent();
                                    if (typeof state_1 === "object") return [
                                        2 /*return*/ ,
                                        state_1.value
                                    ];
                                    return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                case 3:
                                    // reached if terminated while waiting for a timer.
                                    reject(lastError);
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                })
            ];
        });
    });
}
var $f37409221557361a$var$MAX_DELAY_MS = 300000;
function $f37409221557361a$export$caea50bde345f648(maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $f37409221557361a$var$MAX_DELAY_MS;
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $f37409221557361a$export$a24aa7705df9cf44 = function(functionToRetry, args, maxDelayMs, onTerminate) {
    if (maxDelayMs === void 0) maxDelayMs = $f37409221557361a$var$MAX_DELAY_MS;
    return $f37409221557361a$export$9369b12211e1fce4(functionToRetry, args, $f37409221557361a$export$caea50bde345f648(maxDelayMs), onTerminate);
};


var $05e6294b0a9e5f29$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $05e6294b0a9e5f29$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $05e6294b0a9e5f29$var$logger = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("CognitoCredentials");
var $05e6294b0a9e5f29$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser) {
        $05e6294b0a9e5f29$var$logger.debug("not in the browser, directly resolved");
        return res();
    }
    var ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
    if (ga) {
        $05e6294b0a9e5f29$var$logger.debug("google api already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $05e6294b0a9e5f29$export$75ace714083c1340 = /** @class */ function() {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function() {
        return $05e6294b0a9e5f29$var$__awaiter(this, void 0, void 0, function() {
            return $05e6294b0a9e5f29$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $05e6294b0a9e5f29$var$logger.debug("need to wait for the Google SDK loaded");
                        return [
                            4 /*yield*/ ,
                            $05e6294b0a9e5f29$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $05e6294b0a9e5f29$var$logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshGoogleTokenImpl()
                        ];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function() {
        var ga = null;
        if ((0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser) ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
        if (!ga) {
            $05e6294b0a9e5f29$var$logger.debug("no gapi auth2 available");
            return Promise.reject("no gapi auth2 available");
        }
        return new Promise(function(res, rej) {
            ga.getAuthInstance().then(function(googleAuth) {
                if (!googleAuth) {
                    $05e6294b0a9e5f29$var$logger.debug("google Auth undefined");
                    rej(new (0, $f37409221557361a$exports.NonRetryableError)("google Auth undefined"));
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    $05e6294b0a9e5f29$var$logger.debug("refreshing the google access token");
                    googleUser.reloadAuthResponse().then(function(authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        res({
                            token: id_token,
                            expires_at: expires_at
                        });
                    }).catch(function(err) {
                        if (err && err.error === "network_error") // Not using NonRetryableError so handler will be retried
                        rej("Network error reloading google auth response");
                        else rej(new (0, $f37409221557361a$exports.NonRetryableError)("Failed to reload google auth response"));
                    });
                } else rej(new (0, $f37409221557361a$exports.NonRetryableError)("User is not signed in with Google"));
            }).catch(function(err) {
                $05e6294b0a9e5f29$var$logger.debug("Failed to refresh google token", err);
                rej(new (0, $f37409221557361a$exports.NonRetryableError)("Failed to refresh google token"));
            });
        });
    };
    return GoogleOAuth;
}();


var $635604cca324ad48$exports = {};

$parcel$export($635604cca324ad48$exports, "FacebookOAuth", () => $635604cca324ad48$export$1b6b8b5328e38349);



var $635604cca324ad48$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $635604cca324ad48$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $635604cca324ad48$var$logger = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("CognitoCredentials");
var $635604cca324ad48$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser) {
        $635604cca324ad48$var$logger.debug("not in the browser, directly resolved");
        return res();
    }
    var fb = window["FB"];
    if (fb) {
        $635604cca324ad48$var$logger.debug("FB SDK already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $635604cca324ad48$export$1b6b8b5328e38349 = /** @class */ function() {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function() {
        return $635604cca324ad48$var$__awaiter(this, void 0, void 0, function() {
            return $635604cca324ad48$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $635604cca324ad48$var$logger.debug("need to wait for the Facebook SDK loaded");
                        return [
                            4 /*yield*/ ,
                            $635604cca324ad48$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $635604cca324ad48$var$logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshFacebookTokenImpl()
                        ];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function() {
        var fb = null;
        if ((0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser) fb = window["FB"];
        if (!fb) {
            var errorMessage = "no fb sdk available";
            $635604cca324ad48$var$logger.debug(errorMessage);
            return Promise.reject(new (0, $f37409221557361a$exports.NonRetryableError)(errorMessage));
        }
        return new Promise(function(res, rej) {
            fb.getLoginStatus(function(fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    var errorMessage = "no response from facebook when refreshing the jwt token";
                    $635604cca324ad48$var$logger.debug(errorMessage);
                    // There is no definitive indication for a network error in
                    // fbResponse, so we are treating it as an invalid token.
                    rej(new (0, $f37409221557361a$exports.NonRetryableError)(errorMessage));
                } else {
                    var response = fbResponse.authResponse;
                    var accessToken = response.accessToken, expiresIn = response.expiresIn;
                    var date = new Date();
                    var expires_at = expiresIn * 1000 + date.getTime();
                    if (!accessToken) {
                        var errorMessage = "the jwtToken is undefined";
                        $635604cca324ad48$var$logger.debug(errorMessage);
                        rej(new (0, $f37409221557361a$exports.NonRetryableError)(errorMessage));
                    }
                    res({
                        token: accessToken,
                        expires_at: expires_at
                    });
                }
            }, {
                scope: "public_profile,email"
            });
        });
    };
    return FacebookOAuth;
}();


var $7dd2573c500c67b1$export$75ace714083c1340 = new (0, $05e6294b0a9e5f29$exports.GoogleOAuth)();
var $7dd2573c500c67b1$export$1b6b8b5328e38349 = new (0, $635604cca324ad48$exports.FacebookOAuth)();




var $3d3b0b28ac1269dd$exports = {};

$parcel$export($3d3b0b28ac1269dd$exports, "getCredentialsForIdentity", () => $3d3b0b28ac1269dd$export$a49c1c173ab96b58);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $85b20ddd52b1cbb7$exports = {};

$parcel$export($85b20ddd52b1cbb7$exports, "cognitoIdentityTransferHandler", () => $85b20ddd52b1cbb7$export$8029646671d2c482);
$parcel$export($85b20ddd52b1cbb7$exports, "defaultConfig", () => $85b20ddd52b1cbb7$export$f84bd70098573c5c);
$parcel$export($85b20ddd52b1cbb7$exports, "getSharedHeaders", () => $85b20ddd52b1cbb7$export$a46bbeaba09f7285);
$parcel$export($85b20ddd52b1cbb7$exports, "buildHttpRpcRequest", () => $85b20ddd52b1cbb7$export$a692bdb7eb624f96);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $f0197382527bf92d$exports = {};

$parcel$export($f0197382527bf92d$exports, "getDnsSuffix", () => $f0197382527bf92d$export$1c28e37cdcc37f6d);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ var $8a7b63b3d563af8c$export$72f3cee421ee8a74 = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
var $8a7b63b3d563af8c$export$d7c12af0c0f12206 = {
    partitions: [
        $8a7b63b3d563af8c$export$72f3cee421ee8a74,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};


var $f0197382527bf92d$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $f0197382527bf92d$export$1c28e37cdcc37f6d = function(region) {
    var e_1, _a;
    var partitions = (0, $8a7b63b3d563af8c$export$d7c12af0c0f12206).partitions;
    try {
        for(var partitions_1 = $f0197382527bf92d$var$__values(partitions), partitions_1_1 = partitions_1.next(); !partitions_1_1.done; partitions_1_1 = partitions_1.next()){
            var _b = partitions_1_1.value, regions = _b.regions, outputs = _b.outputs, regionRegex = _b.regionRegex;
            var regex = new RegExp(regionRegex);
            if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (partitions_1_1 && !partitions_1_1.done && (_a = partitions_1.return)) _a.call(partitions_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, $8a7b63b3d563af8c$export$72f3cee421ee8a74).outputs.dnsSuffix;
};

var $ac57f732d4b6941f$exports = {};

$parcel$export($ac57f732d4b6941f$exports, "parseJsonError", () => $ac57f732d4b6941f$export$be467dfcc0538e25);
$parcel$export($ac57f732d4b6941f$exports, "parseJsonBody", () => $ac57f732d4b6941f$export$759bcb35b0d1bf81);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $66eccda658cfd950$exports = {};

$parcel$export($66eccda658cfd950$exports, "parseMetadata", () => $66eccda658cfd950$export$978f9418fe0cb26c);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $66eccda658cfd950$var$__assign = undefined && undefined.__assign || function() {
    $66eccda658cfd950$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $66eccda658cfd950$var$__assign.apply(this, arguments);
};
var $66eccda658cfd950$export$978f9418fe0cb26c = function(response) {
    var _a, _b;
    var headers = response.headers, statusCode = response.statusCode;
    return $66eccda658cfd950$var$__assign($66eccda658cfd950$var$__assign({}, $66eccda658cfd950$var$isMetadataBearer(response) ? response.$metadata : {}), {
        httpStatusCode: statusCode,
        requestId: (_b = (_a = headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : headers["x-amzn-request-id"]) !== null && _b !== void 0 ? _b : headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    });
};
var $66eccda658cfd950$var$isMetadataBearer = function(response) {
    return typeof (response === null || response === void 0 ? void 0 : response["$metadata"]) === "object";
};


var $ac57f732d4b6941f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ac57f732d4b6941f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ac57f732d4b6941f$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $ac57f732d4b6941f$export$be467dfcc0538e25 = function(response) {
    return $ac57f732d4b6941f$var$__awaiter(void 0, void 0, void 0, function() {
        var body, sanitizeErrorCode, code, message, error;
        var _a, _b, _c, _d, _e;
        return $ac57f732d4b6941f$var$__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (!response || response.statusCode < 300) return [
                        2 /*return*/ 
                    ];
                    return [
                        4 /*yield*/ ,
                        $ac57f732d4b6941f$export$759bcb35b0d1bf81(response)
                    ];
                case 1:
                    body = _f.sent();
                    sanitizeErrorCode = function(rawValue) {
                        var _a = $ac57f732d4b6941f$var$__read(rawValue.toString().split(/[\,\:]+/), 1), cleanValue = _a[0];
                        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
                        return cleanValue;
                    };
                    code = sanitizeErrorCode((_c = (_b = (_a = response.headers["x-amzn-errortype"]) !== null && _a !== void 0 ? _a : body.code) !== null && _b !== void 0 ? _b : body.__type) !== null && _c !== void 0 ? _c : "UnknownError");
                    message = (_e = (_d = body.message) !== null && _d !== void 0 ? _d : body.Message) !== null && _e !== void 0 ? _e : "Unknown error";
                    error = new Error(message);
                    return [
                        2 /*return*/ ,
                        Object.assign(error, {
                            name: code,
                            $metadata: (0, $66eccda658cfd950$exports.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var $ac57f732d4b6941f$export$759bcb35b0d1bf81 = function(response) {
    return $ac57f732d4b6941f$var$__awaiter(void 0, void 0, void 0, function() {
        var output;
        return $ac57f732d4b6941f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!response.body) throw new Error("Missing response payload");
                    return [
                        4 /*yield*/ ,
                        response.body.json()
                    ];
                case 1:
                    output = _a.sent();
                    return [
                        2 /*return*/ ,
                        Object.assign(output, {
                            $metadata: (0, $66eccda658cfd950$exports.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $0a7356909fc8cd74$exports = {};

$parcel$export($0a7356909fc8cd74$exports, "retryMiddleware", () => $0a7356909fc8cd74$export$a3922aa5f87bae85);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $0a7356909fc8cd74$var$__assign = undefined && undefined.__assign || function() {
    $0a7356909fc8cd74$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0a7356909fc8cd74$var$__assign.apply(this, arguments);
};
var $0a7356909fc8cd74$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0a7356909fc8cd74$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0a7356909fc8cd74$var$DEFAULT_RETRY_ATTEMPTS = 3;
var $0a7356909fc8cd74$export$a3922aa5f87bae85 = function(_a) {
    var _b = _a.maxAttempts, maxAttempts = _b === void 0 ? $0a7356909fc8cd74$var$DEFAULT_RETRY_ATTEMPTS : _b, retryDecider = _a.retryDecider, computeDelay = _a.computeDelay, abortSignal = _a.abortSignal;
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return function(next, context) {
        return function retryMiddleware(request) {
            var _a;
            return $0a7356909fc8cd74$var$__awaiter(this, void 0, void 0, function() {
                var error, attemptsCount, response, handleTerminalErrorOrResponse, e_1, delay;
                return $0a7356909fc8cd74$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            attemptsCount = (_a = context.attemptsCount) !== null && _a !== void 0 ? _a : 0;
                            handleTerminalErrorOrResponse = function() {
                                if (response) {
                                    $0a7356909fc8cd74$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                                    return response;
                                } else {
                                    $0a7356909fc8cd74$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                                    throw error;
                                }
                            };
                            _b.label = 1;
                        case 1:
                            if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts)) return [
                                3 /*break*/ ,
                                11
                            ];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 3:
                            response = _b.sent();
                            error = undefined;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            e_1 = _b.sent();
                            error = e_1;
                            response = undefined;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                            attemptsCount = context.attemptsCount > attemptsCount ? context.attemptsCount : attemptsCount + 1;
                            context.attemptsCount = attemptsCount;
                            return [
                                4 /*yield*/ ,
                                retryDecider(response, error)
                            ];
                        case 6:
                            if (!_b.sent()) return [
                                3 /*break*/ ,
                                9
                            ];
                            if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts)) return [
                                3 /*break*/ ,
                                8
                            ];
                            delay = computeDelay(attemptsCount);
                            return [
                                4 /*yield*/ ,
                                $0a7356909fc8cd74$var$cancellableSleep(delay, abortSignal)
                            ];
                        case 7:
                            _b.sent();
                            _b.label = 8;
                        case 8:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 9:
                            return [
                                2 /*return*/ ,
                                handleTerminalErrorOrResponse()
                            ];
                        case 10:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 11:
                            if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) throw new Error("Request aborted.");
                            else return [
                                2 /*return*/ ,
                                handleTerminalErrorOrResponse()
                            ];
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
};
var $0a7356909fc8cd74$var$cancellableSleep = function(timeoutMs, abortSignal) {
    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) return Promise.resolve();
    var timeoutId;
    var sleepPromiseResolveFn;
    var sleepPromise = new Promise(function(resolve) {
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal === null || abortSignal === void 0 || abortSignal.addEventListener("abort", function cancelSleep(event) {
        clearTimeout(timeoutId);
        abortSignal === null || abortSignal === void 0 || abortSignal.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
var $0a7356909fc8cd74$var$addOrIncrementMetadataAttempts = function(nextHandlerOutput, attempts) {
    var _a;
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput["$metadata"] = $0a7356909fc8cd74$var$__assign($0a7356909fc8cd74$var$__assign({}, (_a = nextHandlerOutput["$metadata"]) !== null && _a !== void 0 ? _a : {}), {
        attempts: attempts
    });
};


var $9d24749afa2ae842$exports = {};

$parcel$export($9d24749afa2ae842$exports, "userAgentMiddleware", () => $9d24749afa2ae842$export$62c460923941c0b0);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9d24749afa2ae842$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9d24749afa2ae842$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9d24749afa2ae842$export$62c460923941c0b0 = function(_a) {
    var _b = _a.userAgentHeader, userAgentHeader = _b === void 0 ? "x-amz-user-agent" : _b, _c = _a.userAgentValue, userAgentValue = _c === void 0 ? "" : _c;
    return function(next) {
        return function userAgentMiddleware(request) {
            return $9d24749afa2ae842$var$__awaiter(this, void 0, void 0, function() {
                var result, headerName, response;
                return $9d24749afa2ae842$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(userAgentValue.trim().length === 0)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 1:
                            result = _a.sent();
                            return [
                                2 /*return*/ ,
                                result
                            ];
                        case 2:
                            headerName = userAgentHeader.toLowerCase();
                            request.headers[headerName] = request.headers[headerName] ? "".concat(request.headers[headerName], " ").concat(userAgentValue) : userAgentValue;
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 3:
                            response = _a.sent();
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ var $98f474706da408e6$export$f074d76e52925468 = function(coreHandler, middleware) {
    return function(request, options) {
        var context = {};
        var composedHandler = function(request) {
            return coreHandler(request, options);
        };
        for(var i = middleware.length - 1; i >= 0; i--){
            var m = middleware[i];
            var resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };
};


var $a692e336715f2ad6$exports = {};

$parcel$export($a692e336715f2ad6$exports, "fetchTransferHandler", () => $a692e336715f2ad6$export$d2573baf35521e4c);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $436950a2454b4407$exports = {};


$436950a2454b4407$exports = self.fetch || (self.fetch = (parcelRequire("laOt8")).default || (parcelRequire("laOt8")));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ var $46b901c9e9e7b1ef$export$580ad1ce15092b15 = function(payloadAccessor) {
    var cached;
    return function() {
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};


var $a692e336715f2ad6$var$__assign = undefined && undefined.__assign || function() {
    $a692e336715f2ad6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a692e336715f2ad6$var$__assign.apply(this, arguments);
};
var $a692e336715f2ad6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a692e336715f2ad6$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $a692e336715f2ad6$var$shouldSendBody = function(method) {
    return ![
        "HEAD",
        "GET",
        "DELETE"
    ].includes(method.toUpperCase());
};
var $a692e336715f2ad6$export$d2573baf35521e4c = function(_a, _b) {
    var url = _a.url, method = _a.method, headers = _a.headers, body = _a.body;
    var abortSignal = _b.abortSignal;
    return $a692e336715f2ad6$var$__awaiter(void 0, void 0, void 0, function() {
        var resp, e_1, responseHeaders, httpResponse, bodyWithMixin;
        var _c, _d;
        return $a692e336715f2ad6$var$__generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    _e.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch(url, {
                            method: method,
                            headers: headers,
                            body: $a692e336715f2ad6$var$shouldSendBody(method) ? body : undefined,
                            signal: abortSignal
                        })
                    ];
                case 1:
                    resp = _e.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    e_1 = _e.sent();
                    // TODO: needs to revise error handling in v6
                    // For now this is a thin wrapper over original fetch error similar to cognito-identity-js package.
                    // Ref: https://github.com/aws-amplify/amplify-js/blob/4fbc8c0a2be7526aab723579b4c95b552195a80b/packages/amazon-cognito-identity-js/src/Client.js#L103-L108
                    if (e_1 instanceof TypeError) throw new Error("Network error");
                    throw e_1;
                case 3:
                    responseHeaders = {};
                    (_c = resp.headers) === null || _c === void 0 || _c.forEach(function(value, key) {
                        responseHeaders[key.toLowerCase()] = value;
                    });
                    httpResponse = {
                        statusCode: resp.status,
                        headers: responseHeaders,
                        body: null
                    };
                    bodyWithMixin = Object.assign((_d = resp.body) !== null && _d !== void 0 ? _d : {}, {
                        text: (0, $46b901c9e9e7b1ef$export$580ad1ce15092b15)(function() {
                            return resp.text();
                        }),
                        blob: (0, $46b901c9e9e7b1ef$export$580ad1ce15092b15)(function() {
                            return resp.blob();
                        }),
                        json: (0, $46b901c9e9e7b1ef$export$580ad1ce15092b15)(function() {
                            return resp.json();
                        })
                    });
                    return [
                        2 /*return*/ ,
                        $a692e336715f2ad6$var$__assign($a692e336715f2ad6$var$__assign({}, httpResponse), {
                            body: bodyWithMixin
                        })
                    ];
            }
        });
    });
};


var $417cacb6cb01f2e9$export$ed7e1ccf00f39c4a = (0, $98f474706da408e6$export$f074d76e52925468)((0, $a692e336715f2ad6$exports.fetchTransferHandler), [
    (0, $9d24749afa2ae842$exports.userAgentMiddleware),
    (0, $0a7356909fc8cd74$exports.retryMiddleware)
]);



var $68e0a688cacb6184$exports = {};

$parcel$export($68e0a688cacb6184$exports, "getRetryDecider", () => $68e0a688cacb6184$export$b919d98317a7685f);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
var $d6ce5dfc8c2948f7$var$CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
var $d6ce5dfc8c2948f7$export$7b87435661177a94 = function(errorCode) {
    return $d6ce5dfc8c2948f7$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);
};


var $68e0a688cacb6184$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $68e0a688cacb6184$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $68e0a688cacb6184$export$b919d98317a7685f = function(errorParser) {
    return function(response, error) {
        return $68e0a688cacb6184$var$__awaiter(void 0, void 0, void 0, function() {
            var errorCode, _a, statusCode;
            var _b;
            return $68e0a688cacb6184$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!(error !== null && error !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = error;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            errorParser(response)
                        ];
                    case 2:
                        _a = _c.sent();
                        _c.label = 3;
                    case 3:
                        errorCode = ((_b = _a) !== null && _b !== void 0 ? _b : {}).name;
                        statusCode = response === null || response === void 0 ? void 0 : response.statusCode;
                        return [
                            2 /*return*/ ,
                            $68e0a688cacb6184$var$isConnectionError(error) || $68e0a688cacb6184$var$isThrottlingError(statusCode, errorCode) || (0, $d6ce5dfc8c2948f7$export$7b87435661177a94)(errorCode) || $68e0a688cacb6184$var$isServerSideError(statusCode, errorCode)
                        ];
                }
            });
        });
    };
};
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
var $68e0a688cacb6184$var$THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
var $68e0a688cacb6184$var$TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var $68e0a688cacb6184$var$isThrottlingError = function(statusCode, errorCode) {
    return statusCode === 429 || $68e0a688cacb6184$var$THROTTLING_ERROR_CODES.includes(errorCode);
};
var $68e0a688cacb6184$var$isConnectionError = function(error) {
    return (error === null || error === void 0 ? void 0 : error.name) === "Network error";
};
var $68e0a688cacb6184$var$isServerSideError = function(statusCode, errorCode) {
    return [
        500,
        502,
        503,
        504
    ].includes(statusCode) || $68e0a688cacb6184$var$TIMEOUT_ERROR_CODES.includes(errorCode);
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.

var $3a687094a6372c5a$var$DEFAULT_MAX_DELAY_MS = 300000;
var $3a687094a6372c5a$export$caea50bde345f648 = function(attempt) {
    var delayFunction = (0, $f37409221557361a$exports.jitteredBackoff)($3a687094a6372c5a$var$DEFAULT_MAX_DELAY_MS);
    var delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? $3a687094a6372c5a$var$DEFAULT_MAX_DELAY_MS : delay;
};




var $85b20ddd52b1cbb7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $85b20ddd52b1cbb7$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * The service name used to sign requests if the API requires authentication.
 */ var $85b20ddd52b1cbb7$var$SERVICE_NAME = "cognito-identity";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ var $85b20ddd52b1cbb7$var$endpointResolver = function(_a) {
    var region = _a.region;
    return {
        url: new URL("https://cognito-identity.".concat(region, ".").concat((0, $f0197382527bf92d$exports.getDnsSuffix)(region)))
    };
};
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ var $85b20ddd52b1cbb7$var$disableCacheMiddleware = function() {
    return function(next, context) {
        return function disableCacheMiddleware(request) {
            return $85b20ddd52b1cbb7$var$__awaiter(this, void 0, void 0, function() {
                return $85b20ddd52b1cbb7$var$__generator(this, function(_a) {
                    request.headers["cache-control"] = "no-store";
                    return [
                        2 /*return*/ ,
                        next(request)
                    ];
                });
            });
        };
    };
};
var $85b20ddd52b1cbb7$export$8029646671d2c482 = (0, $98f474706da408e6$export$f074d76e52925468)((0, $417cacb6cb01f2e9$export$ed7e1ccf00f39c4a), [
    $85b20ddd52b1cbb7$var$disableCacheMiddleware
]);
var $85b20ddd52b1cbb7$export$f84bd70098573c5c = {
    service: $85b20ddd52b1cbb7$var$SERVICE_NAME,
    endpointResolver: $85b20ddd52b1cbb7$var$endpointResolver,
    retryDecider: (0, $68e0a688cacb6184$exports.getRetryDecider)((0, $ac57f732d4b6941f$exports.parseJsonError)),
    computeDelay: (0, $3a687094a6372c5a$export$caea50bde345f648),
    userAgentValue: (0, $2c4730a78a7bdcd6$exports.getAmplifyUserAgent)()
};
(0, $2f2ed3122ffc90d4$export$5d5c467ce0b213f)(function() {
    $85b20ddd52b1cbb7$export$f84bd70098573c5c.userAgentValue = (0, $2c4730a78a7bdcd6$exports.getAmplifyUserAgent)();
});
var $85b20ddd52b1cbb7$export$a46bbeaba09f7285 = function(operation) {
    return {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "AWSCognitoIdentityService.".concat(operation)
    };
};
var $85b20ddd52b1cbb7$export$a692bdb7eb624f96 = function(_a, headers, body) {
    var url = _a.url;
    return {
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    };
};



var $39a490cfef2b29d8$exports = {};

$parcel$export($39a490cfef2b29d8$exports, "composeServiceApi", () => $39a490cfef2b29d8$export$880429a8ae983d4d);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $39a490cfef2b29d8$var$__assign = undefined && undefined.__assign || function() {
    $39a490cfef2b29d8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $39a490cfef2b29d8$var$__assign.apply(this, arguments);
};
var $39a490cfef2b29d8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $39a490cfef2b29d8$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $39a490cfef2b29d8$export$880429a8ae983d4d = function(transferHandler, serializer, deserializer, defaultConfig) {
    return function(config, input) {
        return $39a490cfef2b29d8$var$__awaiter(void 0, void 0, void 0, function() {
            var resolvedConfig, endpoint, request, response;
            return $39a490cfef2b29d8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        resolvedConfig = $39a490cfef2b29d8$var$__assign($39a490cfef2b29d8$var$__assign({}, defaultConfig), config);
                        return [
                            4 /*yield*/ ,
                            resolvedConfig.endpointResolver(resolvedConfig, input)
                        ];
                    case 1:
                        endpoint = _a.sent();
                        return [
                            4 /*yield*/ ,
                            serializer(input, endpoint)
                        ];
                    case 2:
                        request = _a.sent();
                        return [
                            4 /*yield*/ ,
                            transferHandler(request, $39a490cfef2b29d8$var$__assign({}, resolvedConfig))
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            deserializer(response)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
};


var $3d3b0b28ac1269dd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3d3b0b28ac1269dd$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $3d3b0b28ac1269dd$var$getCredentialsForIdentitySerializer = function(input, endpoint) {
    var headers = (0, $85b20ddd52b1cbb7$exports.getSharedHeaders)("GetCredentialsForIdentity");
    var body = JSON.stringify(input);
    return (0, $85b20ddd52b1cbb7$exports.buildHttpRpcRequest)(endpoint, headers, body);
};
var $3d3b0b28ac1269dd$var$getCredentialsForIdentityDeserializer = function(response) {
    return $3d3b0b28ac1269dd$var$__awaiter(void 0, void 0, void 0, function() {
        var error, body;
        return $3d3b0b28ac1269dd$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $ac57f732d4b6941f$exports.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, $ac57f732d4b6941f$exports.parseJsonBody)(response)
                    ];
                case 3:
                    body = _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            IdentityId: body.IdentityId,
                            Credentials: $3d3b0b28ac1269dd$var$deserializeCredentials(body.Credentials),
                            $metadata: (0, $66eccda658cfd950$exports.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var $3d3b0b28ac1269dd$var$deserializeCredentials = function(output) {
    if (output === void 0) output = {};
    return {
        AccessKeyId: output["AccessKeyId"],
        SecretKey: output["SecretKey"],
        SessionToken: output["SessionToken"],
        Expiration: new Date(output["Expiration"] * 1000)
    };
};
var $3d3b0b28ac1269dd$export$a49c1c173ab96b58 = (0, $39a490cfef2b29d8$exports.composeServiceApi)((0, $85b20ddd52b1cbb7$exports.cognitoIdentityTransferHandler), $3d3b0b28ac1269dd$var$getCredentialsForIdentitySerializer, $3d3b0b28ac1269dd$var$getCredentialsForIdentityDeserializer, (0, $85b20ddd52b1cbb7$exports.defaultConfig));

var $dca8104771d1fcbb$exports = {};

$parcel$export($dca8104771d1fcbb$exports, "getId", () => $dca8104771d1fcbb$export$218c8c3169c024d2);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $dca8104771d1fcbb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $dca8104771d1fcbb$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $dca8104771d1fcbb$var$getIdSerializer = function(input, endpoint) {
    var headers = (0, $85b20ddd52b1cbb7$exports.getSharedHeaders)("GetId");
    var body = JSON.stringify(input);
    return (0, $85b20ddd52b1cbb7$exports.buildHttpRpcRequest)(endpoint, headers, body);
};
var $dca8104771d1fcbb$var$getIdDeserializer = function(response) {
    return $dca8104771d1fcbb$var$__awaiter(void 0, void 0, void 0, function() {
        var error, body;
        return $dca8104771d1fcbb$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $ac57f732d4b6941f$exports.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, $ac57f732d4b6941f$exports.parseJsonBody)(response)
                    ];
                case 3:
                    body = _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            IdentityId: body.IdentityId,
                            $metadata: (0, $66eccda658cfd950$exports.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var $dca8104771d1fcbb$export$218c8c3169c024d2 = (0, $39a490cfef2b29d8$exports.composeServiceApi)((0, $85b20ddd52b1cbb7$exports.cognitoIdentityTransferHandler), $dca8104771d1fcbb$var$getIdSerializer, $dca8104771d1fcbb$var$getIdDeserializer, (0, $85b20ddd52b1cbb7$exports.defaultConfig));




var $de9f45d92f772164$var$__assign = undefined && undefined.__assign || function() {
    $de9f45d92f772164$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $de9f45d92f772164$var$__assign.apply(this, arguments);
};
var $de9f45d92f772164$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $de9f45d92f772164$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $de9f45d92f772164$var$logger = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("Credentials");
var $de9f45d92f772164$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
var $de9f45d92f772164$var$COGNITO_IDENTITY_KEY_PREFIX = "CognitoIdentityId-";
var $de9f45d92f772164$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $de9f45d92f772164$var$dispatchCredentialsEvent = function(event, data, message) {
    (0, $1a908fb961b3fa6b$exports.Hub).dispatch("core", {
        event: event,
        data: data,
        message: message
    }, "Credentials", $de9f45d92f772164$var$AMPLIFY_SYMBOL);
};
var $de9f45d92f772164$export$9be509043bd0c09a = /** @class */ function() {
    function CredentialsClass(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        // Allow `Auth` to be injected for SSR, but Auth isn't a required dependency for Credentials
        this.Auth = undefined;
        this.configure(config);
        this._refreshHandlers["google"] = (0, $7dd2573c500c67b1$export$75ace714083c1340).refreshGoogleToken;
        this._refreshHandlers["facebook"] = (0, $7dd2573c500c67b1$export$1b6b8b5328e38349).refreshFacebookToken;
    }
    CredentialsClass.prototype.getModuleName = function() {
        return "Credentials";
    };
    CredentialsClass.prototype.getCredSource = function() {
        return this._credentials_source;
    };
    CredentialsClass.prototype.configure = function(config) {
        if (!config) return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) this._refreshHandlers = $de9f45d92f772164$var$__assign($de9f45d92f772164$var$__assign({}, this._refreshHandlers), refreshHandlers);
        this._storage = this._config.storage;
        if (!this._storage) this._storage = new (0, $7a47fb194d2f9787$export$a2bd19c49e4760e8)().getStorage();
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        $de9f45d92f772164$var$dispatchCredentialsEvent("credentials_configured", null, "Credentials has been configured successfully");
        return this._config;
    };
    CredentialsClass.prototype.get = function() {
        $de9f45d92f772164$var$logger.debug("getting credentials");
        return this._pickupCredentials();
    };
    // currently we only store the guest identity in local storage
    CredentialsClass.prototype._getCognitoIdentityIdStorageKey = function(identityPoolId) {
        return "".concat($de9f45d92f772164$var$COGNITO_IDENTITY_KEY_PREFIX).concat(identityPoolId);
    };
    CredentialsClass.prototype._pickupCredentials = function() {
        $de9f45d92f772164$var$logger.debug("picking up credentials");
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            $de9f45d92f772164$var$logger.debug("getting new cred promise");
            this._gettingCredPromise = (0, $28ca6f9027b485a7$export$8f33cb495ca11832)(this._keepAlive());
        } else $de9f45d92f772164$var$logger.debug("getting old cred promise");
        return this._gettingCredPromise;
    };
    CredentialsClass.prototype._keepAlive = function() {
        return $de9f45d92f772164$var$__awaiter(this, void 0, void 0, function() {
            var cred, _a, Auth, user_1, session, refreshToken_1, refreshRequest, err_1;
            return $de9f45d92f772164$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $de9f45d92f772164$var$logger.debug("checking if credentials exists and not expired");
                        cred = this._credentials;
                        if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                            $de9f45d92f772164$var$logger.debug("credentials not changed and not expired, directly return");
                            return [
                                2 /*return*/ ,
                                Promise.resolve(cred)
                            ];
                        }
                        $de9f45d92f772164$var$logger.debug("need to get a new credential or refresh the existing one");
                        _a = this.Auth, Auth = _a === void 0 ? (0, $36606c730099e1c8$exports.Amplify).Auth : _a;
                        if (!Auth || typeof Auth.currentUserCredentials !== "function") // If Auth module is not imported, do a best effort to get guest credentials
                        return [
                            2 /*return*/ ,
                            this._setCredentialsForGuest()
                        ];
                        if (!(!this._isExpired(cred) && this._isPastTTL())) return [
                            3 /*break*/ ,
                            6
                        ];
                        $de9f45d92f772164$var$logger.debug("ttl has passed but token is not yet expired");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            Auth.currentUserPoolUser()
                        ];
                    case 2:
                        user_1 = _b.sent();
                        return [
                            4 /*yield*/ ,
                            Auth.currentSession()
                        ];
                    case 3:
                        session = _b.sent();
                        refreshToken_1 = session.refreshToken;
                        refreshRequest = new Promise(function(res, rej) {
                            user_1.refreshSession(refreshToken_1, function(err, data) {
                                return err ? rej(err) : res(data);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            refreshRequest
                        ];
                    case 4:
                        _b.sent(); // note that rejections will be caught and handled in the catch block.
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _b.sent();
                        // should not throw because user might just be on guest access or is authenticated through federation
                        $de9f45d92f772164$var$logger.debug("Error attempting to refreshing the session", err_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            Auth.currentUserCredentials()
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype.refreshFederatedToken = function(federatedInfo) {
        $de9f45d92f772164$var$logger.debug("Getting federated credentials");
        var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
        var expires_at = federatedInfo.expires_at;
        // Make sure expires_at is in millis
        expires_at = new Date(expires_at).getFullYear() === 1970 ? expires_at * 1000 : expires_at;
        var that = this;
        $de9f45d92f772164$var$logger.debug("checking if federated jwt token expired");
        if (expires_at > new Date().getTime()) {
            // if not expired
            $de9f45d92f772164$var$logger.debug("token not expired");
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at
            });
        } else // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === "function") {
            $de9f45d92f772164$var$logger.debug("getting refreshed jwt token from federation provider");
            return this._providerRefreshWithRetry({
                refreshHandler: that._refreshHandlers[provider],
                provider: provider,
                user: user
            });
        } else {
            $de9f45d92f772164$var$logger.debug("no refresh handler for provider:", provider);
            this.clear();
            return Promise.reject("no refresh handler for provider");
        }
    };
    CredentialsClass.prototype._providerRefreshWithRetry = function(_a) {
        var _this = this;
        var refreshHandler = _a.refreshHandler, provider = _a.provider, user = _a.user;
        var MAX_DELAY_MS = 10000;
        // refreshHandler will retry network errors, otherwise it will
        // return NonRetryableError to break out of jitteredExponentialRetry
        return (0, $f37409221557361a$exports.jitteredExponentialRetry)(refreshHandler, [], MAX_DELAY_MS).then(function(data) {
            $de9f45d92f772164$var$logger.debug("refresh federated token sucessfully", data);
            return _this._setCredentialsFromFederation({
                provider: provider,
                token: data.token,
                user: user,
                identity_id: data.identity_id,
                expires_at: data.expires_at
            });
        }).catch(function(e) {
            var isNetworkError = typeof e === "string" && e.toLowerCase().lastIndexOf("network error", e.length) === 0;
            if (!isNetworkError) _this.clear();
            $de9f45d92f772164$var$logger.debug("refresh federated token failed", e);
            return Promise.reject("refreshing federation token failed: " + e);
        });
    };
    CredentialsClass.prototype._isExpired = function(credentials) {
        if (!credentials) {
            $de9f45d92f772164$var$logger.debug("no credentials for expiration check");
            return true;
        }
        $de9f45d92f772164$var$logger.debug("are these credentials expired?", credentials);
        var ts = Date.now();
        /* returns date object.
            https://github.com/aws/aws-sdk-js-v3/blob/v1.0.0-beta.1/packages/types/src/credentials.ts#L26
        */ var expiration = credentials.expiration;
        return expiration.getTime() <= ts;
    };
    CredentialsClass.prototype._isPastTTL = function() {
        return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass.prototype._setCredentialsForGuest = function() {
        var _a;
        return $de9f45d92f772164$var$__awaiter(this, void 0, void 0, function() {
            var _b, identityPoolId, region, mandatorySignIn, identityPoolRegion, identityId, _c, cognitoConfig, guestCredentialsProvider, credentials;
            var _this = this;
            return $de9f45d92f772164$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        $de9f45d92f772164$var$logger.debug("setting credentials for guest");
                        if (!((_a = this._config) === null || _a === void 0 ? void 0 : _a.identityPoolId)) // If Credentials are not configured thru Auth module,
                        // doing best effort to check if the library was configured
                        this._config = Object.assign({}, this._config, (0, $f0d1ba27142d0e07$exports.parseAWSExports)(this._config || {}).Auth);
                        _b = this._config, identityPoolId = _b.identityPoolId, region = _b.region, mandatorySignIn = _b.mandatorySignIn, identityPoolRegion = _b.identityPoolRegion;
                        if (mandatorySignIn) return [
                            2 /*return*/ ,
                            Promise.reject("cannot get guest credentials when mandatory signin enabled")
                        ];
                        if (!identityPoolId) {
                            $de9f45d92f772164$var$logger.debug("No Cognito Identity pool provided for unauthenticated access");
                            return [
                                2 /*return*/ ,
                                Promise.reject("No Cognito Identity pool provided for unauthenticated access")
                            ];
                        }
                        if (!identityPoolRegion && !region) {
                            $de9f45d92f772164$var$logger.debug("region is not configured for getting the credentials");
                            return [
                                2 /*return*/ ,
                                Promise.reject("region is not configured for getting the credentials")
                            ];
                        }
                        _c = this;
                        return [
                            4 /*yield*/ ,
                            this._getGuestIdentityId()
                        ];
                    case 1:
                        identityId = _c._identityId = _d.sent();
                        cognitoConfig = {
                            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
                        };
                        guestCredentialsProvider = function() {
                            return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                                var IdentityId, Credentials;
                                return $de9f45d92f772164$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!!identityId) return [
                                                3 /*break*/ ,
                                                2
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                (0, $dca8104771d1fcbb$exports.getId)(cognitoConfig, {
                                                    IdentityPoolId: identityPoolId
                                                })
                                            ];
                                        case 1:
                                            IdentityId = _a.sent().IdentityId;
                                            this._identityId = IdentityId;
                                            _a.label = 2;
                                        case 2:
                                            return [
                                                4 /*yield*/ ,
                                                (0, $3d3b0b28ac1269dd$exports.getCredentialsForIdentity)(cognitoConfig, {
                                                    IdentityId: this._identityId
                                                })
                                            ];
                                        case 3:
                                            Credentials = _a.sent().Credentials;
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    identityId: this._identityId,
                                                    accessKeyId: Credentials.AccessKeyId,
                                                    secretAccessKey: Credentials.SecretKey,
                                                    sessionToken: Credentials.SessionToken,
                                                    expiration: Credentials.Expiration
                                                }
                                            ];
                                    }
                                });
                            });
                        };
                        credentials = guestCredentialsProvider().catch(function(err) {
                            return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                                return $de9f45d92f772164$var$__generator(this, function(_a) {
                                    throw err;
                                });
                            });
                        });
                        return [
                            2 /*return*/ ,
                            this._loadCredentials(credentials, "guest", false, null).then(function(res) {
                                return res;
                            }).catch(function(e) {
                                return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                                    var guestCredentialsProvider_1;
                                    var _this = this;
                                    return $de9f45d92f772164$var$__generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!(e.name === "ResourceNotFoundException" && e.message === "Identity '".concat(identityId, "' not found."))) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                $de9f45d92f772164$var$logger.debug("Failed to load guest credentials");
                                                return [
                                                    4 /*yield*/ ,
                                                    this._removeGuestIdentityId()
                                                ];
                                            case 1:
                                                _a.sent();
                                                guestCredentialsProvider_1 = function() {
                                                    return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                                                        var IdentityId, Credentials;
                                                        return $de9f45d92f772164$var$__generator(this, function(_a) {
                                                            switch(_a.label){
                                                                case 0:
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        (0, $dca8104771d1fcbb$exports.getId)(cognitoConfig, {
                                                                            IdentityPoolId: identityPoolId
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    IdentityId = _a.sent().IdentityId;
                                                                    this._identityId = IdentityId;
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        (0, $3d3b0b28ac1269dd$exports.getCredentialsForIdentity)(cognitoConfig, {
                                                                            IdentityId: IdentityId
                                                                        })
                                                                    ];
                                                                case 2:
                                                                    Credentials = _a.sent().Credentials;
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        {
                                                                            identityId: IdentityId,
                                                                            accessKeyId: Credentials.AccessKeyId,
                                                                            secretAccessKey: Credentials.SecretKey,
                                                                            sessionToken: Credentials.SessionToken,
                                                                            expiration: Credentials.Expiration
                                                                        }
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                };
                                                credentials = guestCredentialsProvider_1().catch(function(err) {
                                                    return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                                                        return $de9f45d92f772164$var$__generator(this, function(_a) {
                                                            throw err;
                                                        });
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ ,
                                                    this._loadCredentials(credentials, "guest", false, null)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    e
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setCredentialsFromFederation = function(params) {
        var _this = this;
        var provider = params.provider, token = params.token;
        var identity_id = params.identity_id;
        var domains = {
            google: "accounts.google.com",
            facebook: "graph.facebook.com",
            amazon: "www.amazon.com",
            developer: "cognito-identity.amazonaws.com"
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) return Promise.reject("You must specify a federated provider");
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, identityPoolRegion = _a.identityPoolRegion;
        if (!identityPoolId) {
            $de9f45d92f772164$var$logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        if (!identityPoolRegion && !region) {
            $de9f45d92f772164$var$logger.debug("region is not configured for getting the credentials");
            return Promise.reject("region is not configured for getting the credentials");
        }
        var cognitoConfig = {
            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
        };
        var authenticatedCredentialsProvider = function() {
            return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                var IdentityId, Credentials;
                return $de9f45d92f772164$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!identity_id) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $dca8104771d1fcbb$exports.getId)(cognitoConfig, {
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                })
                            ];
                        case 1:
                            IdentityId = _a.sent().IdentityId;
                            identity_id = IdentityId;
                            _a.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                (0, $3d3b0b28ac1269dd$exports.getCredentialsForIdentity)(cognitoConfig, {
                                    IdentityId: identity_id,
                                    Logins: logins
                                })
                            ];
                        case 3:
                            Credentials = _a.sent().Credentials;
                            return [
                                2 /*return*/ ,
                                {
                                    identityId: identity_id,
                                    accessKeyId: Credentials.AccessKeyId,
                                    secretAccessKey: Credentials.SecretKey,
                                    sessionToken: Credentials.SessionToken,
                                    expiration: Credentials.Expiration
                                }
                            ];
                    }
                });
            });
        };
        var credentials = authenticatedCredentialsProvider().catch(function(err) {
            return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                return $de9f45d92f772164$var$__generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, "federated", true, params);
    };
    CredentialsClass.prototype._setCredentialsFromSession = function(session) {
        var _this = this;
        $de9f45d92f772164$var$logger.debug("set credentials from session");
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId, identityPoolRegion = _a.identityPoolRegion;
        if (!identityPoolId) {
            $de9f45d92f772164$var$logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        if (!identityPoolRegion && !region) {
            $de9f45d92f772164$var$logger.debug("region is not configured for getting the credentials");
            return Promise.reject("region is not configured for getting the credentials");
        }
        var key = "cognito-idp." + region + ".amazonaws.com/" + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var cognitoConfig = {
            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
        };
        /*
            Retreiving identityId with GetIdCommand to mimic the behavior in the following code in aws-sdk-v3:
            https://git.io/JeDxU

            Note: Retreive identityId from CredentialsProvider once aws-sdk-js v3 supports this.
        */ var credentialsProvider = function() {
            return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                var guestIdentityId, generatedOrRetrievedIdentityId, IdentityId, _a, _b, AccessKeyId, Expiration, SecretKey, SessionToken, primaryIdentityId;
                return $de9f45d92f772164$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this._getGuestIdentityId()
                            ];
                        case 1:
                            guestIdentityId = _c.sent();
                            if (!!guestIdentityId) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $dca8104771d1fcbb$exports.getId)(cognitoConfig, {
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                })
                            ];
                        case 2:
                            IdentityId = _c.sent().IdentityId;
                            generatedOrRetrievedIdentityId = IdentityId;
                            _c.label = 3;
                        case 3:
                            return [
                                4 /*yield*/ ,
                                (0, $3d3b0b28ac1269dd$exports.getCredentialsForIdentity)(cognitoConfig, {
                                    IdentityId: guestIdentityId || generatedOrRetrievedIdentityId,
                                    Logins: logins
                                })
                            ];
                        case 4:
                            _a = _c.sent(), _b = _a.Credentials, AccessKeyId = _b.AccessKeyId, Expiration = _b.Expiration, SecretKey = _b.SecretKey, SessionToken = _b.SessionToken, primaryIdentityId = _a.IdentityId;
                            this._identityId = primaryIdentityId;
                            if (!guestIdentityId) return [
                                3 /*break*/ ,
                                6
                            ];
                            // if guestIdentity is found and used by GetCredentialsForIdentity
                            // it will be linked to the logins provided, and disqualified as an unauth identity
                            $de9f45d92f772164$var$logger.debug("The guest identity ".concat(guestIdentityId, " has been successfully linked to the logins"));
                            if (guestIdentityId === primaryIdentityId) $de9f45d92f772164$var$logger.debug("The guest identity ".concat(guestIdentityId, " has become the primary identity"));
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            return [
                                4 /*yield*/ ,
                                this._removeGuestIdentityId()
                            ];
                        case 5:
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            _c.sent();
                            _c.label = 6;
                        case 6:
                            // https://github.com/aws/aws-sdk-js-v3/blob/main/packages/credential-provider-cognito-identity/src/fromCognitoIdentity.ts#L40
                            return [
                                2 /*return*/ ,
                                {
                                    accessKeyId: AccessKeyId,
                                    secretAccessKey: SecretKey,
                                    sessionToken: SessionToken,
                                    expiration: Expiration,
                                    identityId: primaryIdentityId
                                }
                            ];
                    }
                });
            });
        };
        var credentials = credentialsProvider().catch(function(err) {
            return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                return $de9f45d92f772164$var$__generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, "userPool", true, null);
    };
    CredentialsClass.prototype._loadCredentials = function(credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            credentials.then(function(credentials) {
                return $de9f45d92f772164$var$__awaiter(_this, void 0, void 0, function() {
                    var user, provider, token, expires_at, identity_id;
                    return $de9f45d92f772164$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $de9f45d92f772164$var$logger.debug("Load credentials successfully", credentials);
                                if (this._identityId && !credentials.identityId) credentials["identityId"] = this._identityId;
                                that._credentials = credentials;
                                that._credentials.authenticated = authenticated;
                                that._credentials_source = source;
                                that._nextCredentialsRefresh = new Date().getTime() + $de9f45d92f772164$var$CREDENTIALS_TTL;
                                if (source === "federated") {
                                    user = Object.assign({
                                        id: this._credentials.identityId
                                    }, info.user);
                                    provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                    try {
                                        this._storage.setItem("aws-amplify-federatedInfo", JSON.stringify({
                                            provider: provider,
                                            token: token,
                                            user: user,
                                            expires_at: expires_at,
                                            identity_id: identity_id
                                        }));
                                    } catch (e) {
                                        $de9f45d92f772164$var$logger.debug("Failed to put federated info into auth storage", e);
                                    }
                                }
                                if (!(source === "guest")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this._setGuestIdentityId(credentials.identityId)
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                res(that._credentials);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(err) {
                if (err) {
                    $de9f45d92f772164$var$logger.debug("Failed to load credentials", credentials);
                    $de9f45d92f772164$var$logger.debug("Error loading credentials", err);
                    rej(err);
                    return;
                }
            });
        });
    };
    CredentialsClass.prototype.set = function(params, source) {
        if (source === "session") return this._setCredentialsFromSession(params);
        else if (source === "federation") return this._setCredentialsFromFederation(params);
        else if (source === "guest") return this._setCredentialsForGuest();
        else {
            $de9f45d92f772164$var$logger.debug("no source specified for setting credentials");
            return Promise.reject("invalid source");
        }
    };
    CredentialsClass.prototype.clear = function() {
        return $de9f45d92f772164$var$__awaiter(this, void 0, void 0, function() {
            return $de9f45d92f772164$var$__generator(this, function(_a) {
                this._credentials = null;
                this._credentials_source = null;
                $de9f45d92f772164$var$logger.debug("removing aws-amplify-federatedInfo from storage");
                this._storage.removeItem("aws-amplify-federatedInfo");
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /* operations on local stored guest identity */ CredentialsClass.prototype._getGuestIdentityId = function() {
        return $de9f45d92f772164$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_1;
            return $de9f45d92f772164$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            this._storage.getItem(this._getCognitoIdentityIdStorageKey(identityPoolId))
                        ];
                    case 3:
                        e_1 = _a.sent();
                        $de9f45d92f772164$var$logger.debug("Failed to get the cached guest identityId", e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setGuestIdentityId = function(identityId) {
        return $de9f45d92f772164$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_2;
            return $de9f45d92f772164$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        this._storage.setItem(this._getCognitoIdentityIdStorageKey(identityPoolId), identityId);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_2 = _a.sent();
                        $de9f45d92f772164$var$logger.debug("Failed to cache guest identityId", e_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._removeGuestIdentityId = function() {
        return $de9f45d92f772164$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId;
            return $de9f45d92f772164$var$__generator(this, function(_a) {
                identityPoolId = this._config.identityPoolId;
                $de9f45d92f772164$var$logger.debug("removing ".concat(this._getCognitoIdentityIdStorageKey(identityPoolId), " from storage"));
                this._storage.removeItem(this._getCognitoIdentityIdStorageKey(identityPoolId));
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ CredentialsClass.prototype.shear = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    return CredentialsClass;
}();
var $de9f45d92f772164$export$a9627919734faa48 = new $de9f45d92f772164$export$9be509043bd0c09a(null);
(0, $36606c730099e1c8$exports.Amplify).register($de9f45d92f772164$export$a9627919734faa48);




var $68a581920a34423d$exports = {};

$parcel$export($68a581920a34423d$exports, "UniversalStorage", () => $68a581920a34423d$export$ded9c57084144144);
var $1563e9259f492e76$exports = {};

$parcel$export($1563e9259f492e76$exports, "default", () => $1563e9259f492e76$export$2e2bcd8739ae039);
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $b8b4115605c878ec$export$98e6a39c04603d36;
var $b8b4115605c878ec$export$dfdc1655ccc5b9cb;
"use strict";
$b8b4115605c878ec$export$98e6a39c04603d36 = $b8b4115605c878ec$var$parse;
$b8b4115605c878ec$export$dfdc1655ccc5b9cb = $b8b4115605c878ec$var$serialize;
/**
 * Module variables.
 * @private
 */ var $b8b4115605c878ec$var$decode = decodeURIComponent;
var $b8b4115605c878ec$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $b8b4115605c878ec$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $b8b4115605c878ec$var$parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var pairs = str.split(";");
    var dec = opt.decode || $b8b4115605c878ec$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf("=");
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $b8b4115605c878ec$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $b8b4115605c878ec$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $b8b4115605c878ec$var$encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!$b8b4115605c878ec$var$fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !$b8b4115605c878ec$var$fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError("option maxAge is invalid");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$b8b4115605c878ec$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$b8b4115605c878ec$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $b8b4115605c878ec$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}



function $fdf7998ace1a9ccf$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === "object" && typeof document.cookie === "string";
}
function $fdf7998ace1a9ccf$export$bfce569af136abdc() {
    document.cookie.split(";").forEach(function(c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
}
function $fdf7998ace1a9ccf$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === "string") return $b8b4115605c878ec$export$98e6a39c04603d36(cookies, options);
    else if (typeof cookies === "object" && cookies !== null) return cookies;
    else return {};
}
function $fdf7998ace1a9ccf$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === "undefined") // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== "{" && value[0] !== "[" && value[0] !== '"';
    return !doNotParse;
}
function $fdf7998ace1a9ccf$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $fdf7998ace1a9ccf$var$cleanupCookieValue(value);
    if ($fdf7998ace1a9ccf$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $fdf7998ace1a9ccf$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === "j" && value[1] === ":") return value.substr(2);
    return value;
}


var $1563e9259f492e76$var$__assign = undefined && undefined.__assign || function() {
    $1563e9259f492e76$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1563e9259f492e76$var$__assign.apply(this, arguments);
};
var $1563e9259f492e76$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $fdf7998ace1a9ccf$export$d2e637738f5e6ae8)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $fdf7998ace1a9ccf$export$56232575010ba89)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $b8b4115605c878ec$export$98e6a39c04603d36(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $fdf7998ace1a9ccf$export$bead674655ff515d)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $fdf7998ace1a9ccf$export$bead674655ff515d)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === "object") value = JSON.stringify(value);
        this.cookies = $1563e9259f492e76$var$__assign($1563e9259f492e76$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $b8b4115605c878ec$export$dfdc1655ccc5b9cb(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $1563e9259f492e76$var$__assign($1563e9259f492e76$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $1563e9259f492e76$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $b8b4115605c878ec$export$dfdc1655ccc5b9cb(name, "", finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $1563e9259f492e76$export$2e2bcd8739ae039 = $1563e9259f492e76$var$Cookies;


var $9814bc57a8c0985e$export$2e2bcd8739ae039 = (0, $1563e9259f492e76$exports.default);



var $68a581920a34423d$var$__assign = undefined && undefined.__assign || function() {
    $68a581920a34423d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $68a581920a34423d$var$__assign.apply(this, arguments);
};
var $68a581920a34423d$var$isBrowser = (0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser;
var $68a581920a34423d$var$ONE_YEAR_IN_MS = 31536000000;
var $68a581920a34423d$export$ded9c57084144144 = /** @class */ function() {
    function UniversalStorage(context) {
        if (context === void 0) context = {};
        this.cookies = new (0, $9814bc57a8c0985e$export$2e2bcd8739ae039)();
        this.store = $68a581920a34423d$var$isBrowser ? window.localStorage : Object.create(null);
        this.cookies = context.req ? new (0, $9814bc57a8c0985e$export$2e2bcd8739ae039)(context.req.headers.cookie) : new (0, $9814bc57a8c0985e$export$2e2bcd8739ae039)();
        Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage.prototype, "length", {
        get: function() {
            return Object.entries(this.store).length;
        },
        enumerable: false,
        configurable: true
    });
    UniversalStorage.prototype.clear = function() {
        var _this = this;
        Array.from(new Array(this.length)).map(function(_, i) {
            return _this.key(i);
        }).forEach(function(key) {
            return _this.removeItem(key);
        });
    };
    UniversalStorage.prototype.getItem = function(key) {
        return this.getLocalItem(key);
    };
    UniversalStorage.prototype.getLocalItem = function(key) {
        return Object.prototype.hasOwnProperty.call(this.store, key) ? this.store[key] : null;
    };
    UniversalStorage.prototype.getUniversalItem = function(key) {
        return this.cookies.get(key);
    };
    UniversalStorage.prototype.key = function(index) {
        return Object.keys(this.store)[index];
    };
    UniversalStorage.prototype.removeItem = function(key) {
        this.removeLocalItem(key);
        this.removeUniversalItem(key);
    };
    UniversalStorage.prototype.removeLocalItem = function(key) {
        delete this.store[key];
    };
    UniversalStorage.prototype.removeUniversalItem = function(key) {
        this.cookies.remove(key, {
            path: "/"
        });
    };
    UniversalStorage.prototype.setItem = function(key, value) {
        this.setLocalItem(key, value);
        // keys take the shape:
        //  1. `${ProviderPrefix}.${userPoolClientId}.${username}.${tokenType}
        //  2. `${ProviderPrefix}.${userPoolClientId}.LastAuthUser
        var tokenType = key.split(".").pop();
        var sessionTokenTypes = [
            "LastAuthUser",
            "accessToken",
            // refreshToken originates on the client, but SSR pages won't fail when this expires
            // Note: the new `accessToken` will also be refreshed on the client (since Amplify doesn't set server-side cookies)
            "refreshToken",
            // Required for CognitoUserSession
            "idToken"
        ];
        if (sessionTokenTypes.includes(tokenType !== null && tokenType !== void 0 ? tokenType : "")) this.setUniversalItem(key, value, {
            expires: new Date(Date.now() + $68a581920a34423d$var$ONE_YEAR_IN_MS)
        });
    };
    UniversalStorage.prototype.setLocalItem = function(key, value) {
        this.store[key] = value;
    };
    UniversalStorage.prototype.setUniversalItem = function(key, value, options) {
        if (options === void 0) options = {};
        this.cookies.set(key, value, $68a581920a34423d$var$__assign($68a581920a34423d$var$__assign({}, options), {
            path: "/",
            // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
            sameSite: true,
            // Allow unsecure requests to http://localhost:3000/ when in development.
            secure: $68a581920a34423d$var$isBrowser && window.location.hostname === "localhost" ? false : true
        }));
    };
    return UniversalStorage;
}();



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This Symbol is used to reference an internal-only PubSub provider that
 * is used for AppSync/GraphQL subscriptions in the API category.
 */ var $71cdefe265dec49d$var$hasSymbol = typeof Symbol !== "undefined" && typeof Symbol.for === "function";
var $71cdefe265dec49d$export$ea26e09ecef8d08d = $71cdefe265dec49d$var$hasSymbol ? Symbol.for("INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER") : "@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER";
var $71cdefe265dec49d$export$16032fc466434892 = "x-amz-user-agent";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $571068c73bf08655$export$b855308a44508212(str) {
    return str.split("").map(function(char) {
        return char.charCodeAt(0).toString(16).padStart(2, "0");
    }).join("");
}
function $571068c73bf08655$export$a7ea17e93539f9a5(hex) {
    return hex.match(/.{2}/g).map(function(char) {
        return String.fromCharCode(parseInt(char, 16));
    }).join("");
}


var $1a573b73ffb0f9d8$export$a002182e51710d39 = {
    userAgent: (0, $2c4730a78a7bdcd6$exports.Platform).userAgent
};
var /**
 * @deprecated use named import
 */ $1a573b73ffb0f9d8$export$2e2bcd8739ae039 = (0, $36606c730099e1c8$exports.Amplify);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $d71e9f4e74f3bfef$export$eeb013770cb92342;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})($d71e9f4e74f3bfef$export$eeb013770cb92342 || ($d71e9f4e74f3bfef$export$eeb013770cb92342 = {}));
function $d71e9f4e74f3bfef$export$9b905d6895bdc426(obj) {
    var keys = [
        "provider"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $d71e9f4e74f3bfef$export$828f8efbdf71714b(obj) {
    var keys = [
        "customProvider"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $d71e9f4e74f3bfef$export$6bae5520ca265d22(obj) {
    var keys = [
        "customState"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $d71e9f4e74f3bfef$export$b380f8ec78ef17c8(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var $d71e9f4e74f3bfef$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
})($d71e9f4e74f3bfef$export$edb367c0a140d3db || ($d71e9f4e74f3bfef$export$edb367c0a140d3db = {}));
function $d71e9f4e74f3bfef$export$ad34f09783c4cb16(obj) {
    return !!obj.username;
}
var $d71e9f4e74f3bfef$export$cfce9c15015bef96;
(function(GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    GRAPHQL_AUTH_MODE["AWS_LAMBDA"] = "AWS_LAMBDA";
})($d71e9f4e74f3bfef$export$cfce9c15015bef96 || ($d71e9f4e74f3bfef$export$cfce9c15015bef96 = {}));



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $010becf709f0452a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $7fb856e564cccfe9$export$a143d493d941bafc;
var $7fb856e564cccfe9$export$e4cf37d7f6fb9e0a;
var $7fb856e564cccfe9$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $7fb856e564cccfe9$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $52af415c3a3d4253$exports = {};
var $52af415c3a3d4253$var$toString = {}.toString;
$52af415c3a3d4253$exports = Array.isArray || function(arr) {
    return $52af415c3a3d4253$var$toString.call(arr) == "[object Array]";
};


$7fb856e564cccfe9$export$a143d493d941bafc = $7fb856e564cccfe9$var$Buffer;
$7fb856e564cccfe9$export$e4cf37d7f6fb9e0a = $7fb856e564cccfe9$var$SlowBuffer;
$7fb856e564cccfe9$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $7fb856e564cccfe9$var$typedArraySupport();
$7fb856e564cccfe9$export$599f31c3813fae4d = $7fb856e564cccfe9$var$kMaxLength();
function $7fb856e564cccfe9$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $7fb856e564cccfe9$var$kMaxLength() {
    return $7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $7fb856e564cccfe9$var$createBuffer(that, length) {
    if ($7fb856e564cccfe9$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $7fb856e564cccfe9$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $7fb856e564cccfe9$var$Buffer(arg, encodingOrOffset, length) {
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $7fb856e564cccfe9$var$Buffer)) return new $7fb856e564cccfe9$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $7fb856e564cccfe9$var$allocUnsafe(this, arg);
    }
    return $7fb856e564cccfe9$var$from(this, arg, encodingOrOffset, length);
}
$7fb856e564cccfe9$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$7fb856e564cccfe9$var$Buffer._augment = function(arr) {
    arr.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    return arr;
};
function $7fb856e564cccfe9$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $7fb856e564cccfe9$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $7fb856e564cccfe9$var$fromString(that, value, encodingOrOffset);
    return $7fb856e564cccfe9$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $7fb856e564cccfe9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $7fb856e564cccfe9$var$from(null, value, encodingOrOffset, length);
};
if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $7fb856e564cccfe9$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $7fb856e564cccfe9$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $7fb856e564cccfe9$var$Buffer[Symbol.species] === $7fb856e564cccfe9$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($7fb856e564cccfe9$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $7fb856e564cccfe9$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $7fb856e564cccfe9$var$alloc(that, size, fill, encoding) {
    $7fb856e564cccfe9$var$assertSize(size);
    if (size <= 0) return $7fb856e564cccfe9$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $7fb856e564cccfe9$var$createBuffer(that, size).fill(fill, encoding) : $7fb856e564cccfe9$var$createBuffer(that, size).fill(fill);
    return $7fb856e564cccfe9$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $7fb856e564cccfe9$var$Buffer.alloc = function(size, fill, encoding) {
    return $7fb856e564cccfe9$var$alloc(null, size, fill, encoding);
};
function $7fb856e564cccfe9$var$allocUnsafe(that, size) {
    $7fb856e564cccfe9$var$assertSize(size);
    that = $7fb856e564cccfe9$var$createBuffer(that, size < 0 ? 0 : $7fb856e564cccfe9$var$checked(size) | 0);
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $7fb856e564cccfe9$var$Buffer.allocUnsafe = function(size) {
    return $7fb856e564cccfe9$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $7fb856e564cccfe9$var$Buffer.allocUnsafeSlow = function(size) {
    return $7fb856e564cccfe9$var$allocUnsafe(null, size);
};
function $7fb856e564cccfe9$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$7fb856e564cccfe9$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $7fb856e564cccfe9$var$byteLength(string, encoding) | 0;
    that = $7fb856e564cccfe9$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $7fb856e564cccfe9$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $7fb856e564cccfe9$var$checked(array.length) | 0;
    that = $7fb856e564cccfe9$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $7fb856e564cccfe9$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $7fb856e564cccfe9$var$fromArrayLike(that, array);
    return that;
}
function $7fb856e564cccfe9$var$fromObject(that, obj) {
    if ($7fb856e564cccfe9$var$Buffer.isBuffer(obj)) {
        var len = $7fb856e564cccfe9$var$checked(obj.length) | 0;
        that = $7fb856e564cccfe9$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $7fb856e564cccfe9$var$isnan(obj.length)) return $7fb856e564cccfe9$var$createBuffer(that, 0);
            return $7fb856e564cccfe9$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $52af415c3a3d4253$exports(obj.data)) return $7fb856e564cccfe9$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $7fb856e564cccfe9$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $7fb856e564cccfe9$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $7fb856e564cccfe9$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $7fb856e564cccfe9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $7fb856e564cccfe9$var$Buffer.alloc(+length);
}
$7fb856e564cccfe9$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$7fb856e564cccfe9$var$Buffer.compare = function compare(a, b) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(a) || !$7fb856e564cccfe9$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$7fb856e564cccfe9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$7fb856e564cccfe9$var$Buffer.concat = function concat(list, length) {
    if (!$52af415c3a3d4253$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $7fb856e564cccfe9$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $7fb856e564cccfe9$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$7fb856e564cccfe9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $7fb856e564cccfe9$var$byteLength(string, encoding) {
    if ($7fb856e564cccfe9$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $7fb856e564cccfe9$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $7fb856e564cccfe9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $7fb856e564cccfe9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$7fb856e564cccfe9$var$Buffer.byteLength = $7fb856e564cccfe9$var$byteLength;
function $7fb856e564cccfe9$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $7fb856e564cccfe9$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $7fb856e564cccfe9$var$utf8Slice(this, start, end);
        case "ascii":
            return $7fb856e564cccfe9$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $7fb856e564cccfe9$var$latin1Slice(this, start, end);
        case "base64":
            return $7fb856e564cccfe9$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $7fb856e564cccfe9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$7fb856e564cccfe9$var$Buffer.prototype._isBuffer = true;
function $7fb856e564cccfe9$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$7fb856e564cccfe9$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$7fb856e564cccfe9$var$swap(this, i, i + 1);
    return this;
};
$7fb856e564cccfe9$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $7fb856e564cccfe9$var$swap(this, i, i + 3);
        $7fb856e564cccfe9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$7fb856e564cccfe9$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $7fb856e564cccfe9$var$swap(this, i, i + 7);
        $7fb856e564cccfe9$var$swap(this, i + 1, i + 6);
        $7fb856e564cccfe9$var$swap(this, i + 2, i + 5);
        $7fb856e564cccfe9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$7fb856e564cccfe9$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $7fb856e564cccfe9$var$utf8Slice(this, 0, length);
    return $7fb856e564cccfe9$var$slowToString.apply(this, arguments);
};
$7fb856e564cccfe9$var$Buffer.prototype.equals = function equals(b) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $7fb856e564cccfe9$var$Buffer.compare(this, b) === 0;
};
$7fb856e564cccfe9$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $7fb856e564cccfe9$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$7fb856e564cccfe9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $7fb856e564cccfe9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $7fb856e564cccfe9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($7fb856e564cccfe9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $7fb856e564cccfe9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $7fb856e564cccfe9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $7fb856e564cccfe9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$7fb856e564cccfe9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$7fb856e564cccfe9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $7fb856e564cccfe9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$7fb856e564cccfe9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $7fb856e564cccfe9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $7fb856e564cccfe9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $7fb856e564cccfe9$var$utf8Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $7fb856e564cccfe9$var$asciiWrite(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$asciiToBytes(string), buf, offset, length);
}
function $7fb856e564cccfe9$var$latin1Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$asciiWrite(buf, string, offset, length);
}
function $7fb856e564cccfe9$var$base64Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$base64ToBytes(string), buf, offset, length);
}
function $7fb856e564cccfe9$var$ucs2Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$7fb856e564cccfe9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $7fb856e564cccfe9$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $7fb856e564cccfe9$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $7fb856e564cccfe9$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $7fb856e564cccfe9$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $7fb856e564cccfe9$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $7fb856e564cccfe9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$7fb856e564cccfe9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $7fb856e564cccfe9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $7fb856e564cccfe9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $7fb856e564cccfe9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $7fb856e564cccfe9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $7fb856e564cccfe9$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $7fb856e564cccfe9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $7fb856e564cccfe9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $7fb856e564cccfe9$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $7fb856e564cccfe9$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $7fb856e564cccfe9$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $7fb856e564cccfe9$var$toHex(buf[i]);
    return out;
}
function $7fb856e564cccfe9$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$7fb856e564cccfe9$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $7fb856e564cccfe9$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $7fb856e564cccfe9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$7fb856e564cccfe9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$7fb856e564cccfe9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$7fb856e564cccfe9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$7fb856e564cccfe9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$7fb856e564cccfe9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$7fb856e564cccfe9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $7fb856e564cccfe9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$7fb856e564cccfe9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $7fb856e564cccfe9$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $7fb856e564cccfe9$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $7fb856e564cccfe9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $7fb856e564cccfe9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeFloat(this, value, offset, true, noAssert);
};
$7fb856e564cccfe9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeFloat(this, value, offset, false, noAssert);
};
function $7fb856e564cccfe9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeDouble(this, value, offset, true, noAssert);
};
$7fb856e564cccfe9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$7fb856e564cccfe9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$7fb856e564cccfe9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$7fb856e564cccfe9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $7fb856e564cccfe9$var$Buffer.isBuffer(val) ? val : $7fb856e564cccfe9$var$utf8ToBytes(new $7fb856e564cccfe9$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $7fb856e564cccfe9$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $7fb856e564cccfe9$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $7fb856e564cccfe9$var$stringtrim(str).replace($7fb856e564cccfe9$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $7fb856e564cccfe9$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $7fb856e564cccfe9$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $7fb856e564cccfe9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $7fb856e564cccfe9$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $7fb856e564cccfe9$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $7fb856e564cccfe9$var$base64ToBytes(str) {
    return $kuxul.toByteArray($7fb856e564cccfe9$var$base64clean(str));
}
function $7fb856e564cccfe9$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $7fb856e564cccfe9$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}


var $b1d17d9b5b43e6ab$var$crypto;
// Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) $b1d17d9b5b43e6ab$var$crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!$b1d17d9b5b43e6ab$var$crypto && typeof window !== "undefined" && window.msCrypto) $b1d17d9b5b43e6ab$var$crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!$b1d17d9b5b43e6ab$var$crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) $b1d17d9b5b43e6ab$var$crypto = $parcel$global.crypto;

// Native crypto import via require (NodeJS)
if (!$b1d17d9b5b43e6ab$var$crypto && true) try {
    $b1d17d9b5b43e6ab$var$crypto = (parcelRequire("kjyEk"));
} catch (err) {}
function $b1d17d9b5b43e6ab$export$2e2bcd8739ae039() {
    if ($b1d17d9b5b43e6ab$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $b1d17d9b5b43e6ab$var$crypto.getRandomValues === "function") try {
            return $b1d17d9b5b43e6ab$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof $b1d17d9b5b43e6ab$var$crypto.randomBytes === "function") try {
            return $b1d17d9b5b43e6ab$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}


/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $604987de3d14fe69$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var $604987de3d14fe69$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $b1d17d9b5b43e6ab$export$2e2bcd8739ae039)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $604987de3d14fe69$var$hexStringify(this);
    };
    return WordArray;
}();


var $cf1b63b8461dcf91$exports = {};
"use strict";
Object.defineProperty($cf1b63b8461dcf91$exports, "__esModule", {
    value: true
});

var $hOJwo = parcelRequire("hOJwo");

(0, $hOJwo.__exportStar)((parcelRequire("5PPry")), $cf1b63b8461dcf91$exports);


// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $4cdeaf8f1e22336b$export$2e2bcd8739ae039 = $4cdeaf8f1e22336b$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $4cdeaf8f1e22336b$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $4cdeaf8f1e22336b$var$nbi() {
    return new $4cdeaf8f1e22336b$var$BigInteger(null);
}
// Bits per digit
var $4cdeaf8f1e22336b$var$dbits;
// JavaScript engine analysis
var $4cdeaf8f1e22336b$var$canary = 0xdeadbeefcafe;
var $4cdeaf8f1e22336b$var$j_lm = ($4cdeaf8f1e22336b$var$canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $4cdeaf8f1e22336b$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $4cdeaf8f1e22336b$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $4cdeaf8f1e22336b$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $4cdeaf8f1e22336b$var$inBrowser = typeof navigator !== "undefined";
if ($4cdeaf8f1e22336b$var$inBrowser && $4cdeaf8f1e22336b$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $4cdeaf8f1e22336b$var$BigInteger.prototype.am = $4cdeaf8f1e22336b$var$am2;
    $4cdeaf8f1e22336b$var$dbits = 30;
} else if ($4cdeaf8f1e22336b$var$inBrowser && $4cdeaf8f1e22336b$var$j_lm && navigator.appName != "Netscape") {
    $4cdeaf8f1e22336b$var$BigInteger.prototype.am = $4cdeaf8f1e22336b$var$am1;
    $4cdeaf8f1e22336b$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $4cdeaf8f1e22336b$var$BigInteger.prototype.am = $4cdeaf8f1e22336b$var$am3;
    $4cdeaf8f1e22336b$var$dbits = 28;
}
$4cdeaf8f1e22336b$var$BigInteger.prototype.DB = $4cdeaf8f1e22336b$var$dbits;
$4cdeaf8f1e22336b$var$BigInteger.prototype.DM = (1 << $4cdeaf8f1e22336b$var$dbits) - 1;
$4cdeaf8f1e22336b$var$BigInteger.prototype.DV = 1 << $4cdeaf8f1e22336b$var$dbits;
var $4cdeaf8f1e22336b$var$BI_FP = 52;
$4cdeaf8f1e22336b$var$BigInteger.prototype.FV = Math.pow(2, $4cdeaf8f1e22336b$var$BI_FP);
$4cdeaf8f1e22336b$var$BigInteger.prototype.F1 = $4cdeaf8f1e22336b$var$BI_FP - $4cdeaf8f1e22336b$var$dbits;
$4cdeaf8f1e22336b$var$BigInteger.prototype.F2 = 2 * $4cdeaf8f1e22336b$var$dbits - $4cdeaf8f1e22336b$var$BI_FP;
// Digit conversions
var $4cdeaf8f1e22336b$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $4cdeaf8f1e22336b$var$BI_RC = new Array();
var $4cdeaf8f1e22336b$var$rr, $4cdeaf8f1e22336b$var$vv;
$4cdeaf8f1e22336b$var$rr = "0".charCodeAt(0);
for($4cdeaf8f1e22336b$var$vv = 0; $4cdeaf8f1e22336b$var$vv <= 9; ++$4cdeaf8f1e22336b$var$vv)$4cdeaf8f1e22336b$var$BI_RC[$4cdeaf8f1e22336b$var$rr++] = $4cdeaf8f1e22336b$var$vv;
$4cdeaf8f1e22336b$var$rr = "a".charCodeAt(0);
for($4cdeaf8f1e22336b$var$vv = 10; $4cdeaf8f1e22336b$var$vv < 36; ++$4cdeaf8f1e22336b$var$vv)$4cdeaf8f1e22336b$var$BI_RC[$4cdeaf8f1e22336b$var$rr++] = $4cdeaf8f1e22336b$var$vv;
$4cdeaf8f1e22336b$var$rr = "A".charCodeAt(0);
for($4cdeaf8f1e22336b$var$vv = 10; $4cdeaf8f1e22336b$var$vv < 36; ++$4cdeaf8f1e22336b$var$vv)$4cdeaf8f1e22336b$var$BI_RC[$4cdeaf8f1e22336b$var$rr++] = $4cdeaf8f1e22336b$var$vv;
function $4cdeaf8f1e22336b$var$int2char(n) {
    return $4cdeaf8f1e22336b$var$BI_RM.charAt(n);
}
function $4cdeaf8f1e22336b$var$intAt(s, i) {
    var c = $4cdeaf8f1e22336b$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $4cdeaf8f1e22336b$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $4cdeaf8f1e22336b$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $4cdeaf8f1e22336b$var$nbv(i) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $4cdeaf8f1e22336b$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $4cdeaf8f1e22336b$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $4cdeaf8f1e22336b$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $4cdeaf8f1e22336b$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $4cdeaf8f1e22336b$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $4cdeaf8f1e22336b$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $4cdeaf8f1e22336b$var$bnNegate() {
    var r = $4cdeaf8f1e22336b$var$nbi();
    $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $4cdeaf8f1e22336b$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $4cdeaf8f1e22336b$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $4cdeaf8f1e22336b$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $4cdeaf8f1e22336b$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $4cdeaf8f1e22336b$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $4cdeaf8f1e22336b$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $4cdeaf8f1e22336b$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $4cdeaf8f1e22336b$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $4cdeaf8f1e22336b$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $4cdeaf8f1e22336b$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $4cdeaf8f1e22336b$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $4cdeaf8f1e22336b$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $4cdeaf8f1e22336b$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $4cdeaf8f1e22336b$var$nbi();
    var y = $4cdeaf8f1e22336b$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $4cdeaf8f1e22336b$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $4cdeaf8f1e22336b$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $4cdeaf8f1e22336b$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $4cdeaf8f1e22336b$var$bnMod(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($4cdeaf8f1e22336b$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $4cdeaf8f1e22336b$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $4cdeaf8f1e22336b$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function $4cdeaf8f1e22336b$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $4cdeaf8f1e22336b$var$bnAdd(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $4cdeaf8f1e22336b$var$bnSubtract(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $4cdeaf8f1e22336b$var$bnMultiply(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $4cdeaf8f1e22336b$var$bnDivide(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $4cdeaf8f1e22336b$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $4cdeaf8f1e22336b$var$montConvert(x) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($4cdeaf8f1e22336b$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $4cdeaf8f1e22336b$var$montRevert(x) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $4cdeaf8f1e22336b$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $4cdeaf8f1e22336b$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $4cdeaf8f1e22336b$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$4cdeaf8f1e22336b$var$Montgomery.prototype.convert = $4cdeaf8f1e22336b$var$montConvert;
$4cdeaf8f1e22336b$var$Montgomery.prototype.revert = $4cdeaf8f1e22336b$var$montRevert;
$4cdeaf8f1e22336b$var$Montgomery.prototype.reduce = $4cdeaf8f1e22336b$var$montReduce;
$4cdeaf8f1e22336b$var$Montgomery.prototype.mulTo = $4cdeaf8f1e22336b$var$montMulTo;
$4cdeaf8f1e22336b$var$Montgomery.prototype.sqrTo = $4cdeaf8f1e22336b$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $4cdeaf8f1e22336b$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $4cdeaf8f1e22336b$var$nbv(1), z = new $4cdeaf8f1e22336b$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $4cdeaf8f1e22336b$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $4cdeaf8f1e22336b$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $4cdeaf8f1e22336b$var$nbi(), t;
    i = $4cdeaf8f1e22336b$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$4cdeaf8f1e22336b$var$BigInteger.prototype.copyTo = $4cdeaf8f1e22336b$var$bnpCopyTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.fromInt = $4cdeaf8f1e22336b$var$bnpFromInt;
$4cdeaf8f1e22336b$var$BigInteger.prototype.fromString = $4cdeaf8f1e22336b$var$bnpFromString;
$4cdeaf8f1e22336b$var$BigInteger.prototype.clamp = $4cdeaf8f1e22336b$var$bnpClamp;
$4cdeaf8f1e22336b$var$BigInteger.prototype.dlShiftTo = $4cdeaf8f1e22336b$var$bnpDLShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.drShiftTo = $4cdeaf8f1e22336b$var$bnpDRShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.lShiftTo = $4cdeaf8f1e22336b$var$bnpLShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.rShiftTo = $4cdeaf8f1e22336b$var$bnpRShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.subTo = $4cdeaf8f1e22336b$var$bnpSubTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.multiplyTo = $4cdeaf8f1e22336b$var$bnpMultiplyTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.squareTo = $4cdeaf8f1e22336b$var$bnpSquareTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.divRemTo = $4cdeaf8f1e22336b$var$bnpDivRemTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.invDigit = $4cdeaf8f1e22336b$var$bnpInvDigit;
$4cdeaf8f1e22336b$var$BigInteger.prototype.addTo = $4cdeaf8f1e22336b$var$bnpAddTo;
// public
$4cdeaf8f1e22336b$var$BigInteger.prototype.toString = $4cdeaf8f1e22336b$var$bnToString;
$4cdeaf8f1e22336b$var$BigInteger.prototype.negate = $4cdeaf8f1e22336b$var$bnNegate;
$4cdeaf8f1e22336b$var$BigInteger.prototype.abs = $4cdeaf8f1e22336b$var$bnAbs;
$4cdeaf8f1e22336b$var$BigInteger.prototype.compareTo = $4cdeaf8f1e22336b$var$bnCompareTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.bitLength = $4cdeaf8f1e22336b$var$bnBitLength;
$4cdeaf8f1e22336b$var$BigInteger.prototype.mod = $4cdeaf8f1e22336b$var$bnMod;
$4cdeaf8f1e22336b$var$BigInteger.prototype.equals = $4cdeaf8f1e22336b$var$bnEquals;
$4cdeaf8f1e22336b$var$BigInteger.prototype.add = $4cdeaf8f1e22336b$var$bnAdd;
$4cdeaf8f1e22336b$var$BigInteger.prototype.subtract = $4cdeaf8f1e22336b$var$bnSubtract;
$4cdeaf8f1e22336b$var$BigInteger.prototype.multiply = $4cdeaf8f1e22336b$var$bnMultiply;
$4cdeaf8f1e22336b$var$BigInteger.prototype.divide = $4cdeaf8f1e22336b$var$bnDivide;
$4cdeaf8f1e22336b$var$BigInteger.prototype.modPow = $4cdeaf8f1e22336b$var$bnModPow;
// "constants"
$4cdeaf8f1e22336b$var$BigInteger.ZERO = $4cdeaf8f1e22336b$var$nbv(0);
$4cdeaf8f1e22336b$var$BigInteger.ONE = $4cdeaf8f1e22336b$var$nbv(1);


/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $80fee53f057853d0$var$randomBytes(nBytes) {
    return (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(new (0, $604987de3d14fe69$export$2e2bcd8739ae039)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $80fee53f057853d0$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $80fee53f057853d0$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $80fee53f057853d0$var$newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var $80fee53f057853d0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)($80fee53f057853d0$var$initN, 16);
        this.g = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)("2", 16);
        this.k = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $7fb856e564cccfe9$export$a143d493d941bafc).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $80fee53f057853d0$var$randomBytes(128).toString("hex");
        var randomBigInt = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return $80fee53f057853d0$var$randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $80fee53f057853d0$var$randomBytes(16).toString("hex");
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(hexRandom, 16));
        this.g.modPow(new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var awsCryptoHash = new (0, $cf1b63b8461dcf91$exports.Sha256)();
        awsCryptoHash.update(buf);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var hashHex = (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("hex");
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $7fb856e564cccfe9$export$a143d493d941bafc).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsBuffer = (0, $7fb856e564cccfe9$export$a143d493d941bafc).concat([
            this.infoBits,
            (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(String.fromCharCode(1), "utf8")
        ]);
        var awsCryptoHash = new (0, $cf1b63b8461dcf91$exports.Sha256)(salt);
        awsCryptoHash.update(ikm);
        var resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
        var awsCryptoHashHmac = new (0, $cf1b63b8461dcf91$exports.Sha256)(resultFromAWSCryptoPrk);
        awsCryptoHashHmac.update(infoBitsBuffer);
        var resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
        var hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
        var currentHex = hashHexFromAWSCrypto.slice(0, 16);
        return currentHex;
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this4.padHex(sValue), "hex"), (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $80fee53f057853d0$var$newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $80fee53f057853d0$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
/** @class */ var $3ebef4e0e2340f79$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, $7fb856e564cccfe9$export$a143d493d941bafc).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();


function $8281217ccf88c1bf$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8281217ccf88c1bf$var$_setPrototypeOf(subClass, superClass);
}
function $8281217ccf88c1bf$var$_setPrototypeOf(o, p) {
    $8281217ccf88c1bf$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8281217ccf88c1bf$var$_setPrototypeOf(o, p);
}
/** @class */ var $8281217ccf88c1bf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $8281217ccf88c1bf$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    return CognitoAccessToken;
}((0, $3ebef4e0e2340f79$export$2e2bcd8739ae039));



function $8eb7209a41983bfc$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8eb7209a41983bfc$var$_setPrototypeOf(subClass, superClass);
}
function $8eb7209a41983bfc$var$_setPrototypeOf(o, p) {
    $8eb7209a41983bfc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8eb7209a41983bfc$var$_setPrototypeOf(o, p);
}
/** @class */ var $8eb7209a41983bfc$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $8eb7209a41983bfc$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    return CognitoIdToken;
}((0, $3ebef4e0e2340f79$export$2e2bcd8739ae039));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $c59d7f07074bc9f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $82508fd376aeac3c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $38555859a52f4863$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // generated by genversion
var $09728a2d1518e4a6$export$83d89fbfd8236492 = "5.0.4";


var $d09126a5f5299c10$var$BASE_USER_AGENT = "aws-amplify/" + (0, $09728a2d1518e4a6$export$83d89fbfd8236492);
var $d09126a5f5299c10$export$2dffd0b5373a4389 = {
    userAgent: $d09126a5f5299c10$var$BASE_USER_AGENT,
    isReactNative: typeof navigator !== "undefined" && navigator.product === "ReactNative"
};
var $d09126a5f5299c10$export$7935961ef7719cb0 = function getUserAgent() {
    return $d09126a5f5299c10$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $d09126a5f5299c10$export$2e2bcd8739ae039 = $d09126a5f5299c10$export$2dffd0b5373a4389;


var $f24f2df1be71c20d$export$c388c654f0be37f3 = {
    None: "0",
    ReactNative: "1"
};
var $f24f2df1be71c20d$export$2ef00488675027c = "auth";


// constructor
function $68caf4bd6c7da8b9$var$UserAgent() {}
// public
$68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent = (0, $d09126a5f5299c10$export$7935961ef7719cb0)();
var $68caf4bd6c7da8b9$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent && !$68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent.includes(content)) $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent = $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent.concat(" ", content);
    if (!$68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent || $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent === "") $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent = content;
};
var $68caf4bd6c7da8b9$export$523857f9fc06cb0d = function addAuthCategoryToCognitoUserAgent() {
    $68caf4bd6c7da8b9$var$UserAgent.category = (0, $f24f2df1be71c20d$export$2ef00488675027c);
};
var $68caf4bd6c7da8b9$export$972f94ce7a888cac = function addFrameworkToCognitoUserAgent(framework) {
    $68caf4bd6c7da8b9$var$UserAgent.framework = framework;
};
var $68caf4bd6c7da8b9$export$ede38edb26c0bfdf = function getAmplifyUserAgent(action) {
    var uaCategoryAction = $68caf4bd6c7da8b9$var$UserAgent.category ? " " + $68caf4bd6c7da8b9$var$UserAgent.category : "";
    var uaFramework = $68caf4bd6c7da8b9$var$UserAgent.framework ? " framework/" + $68caf4bd6c7da8b9$var$UserAgent.framework : "";
    var userAgent = "" + $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent + uaCategoryAction + uaFramework;
    return userAgent;
};
var // class for defining the amzn user-agent
$68caf4bd6c7da8b9$export$2e2bcd8739ae039 = $68caf4bd6c7da8b9$var$UserAgent;


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 








/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $a942b99a35e53a72$var$monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $a942b99a35e53a72$var$weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var $a942b99a35e53a72$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $a942b99a35e53a72$var$weekNames[now.getUTCDay()];
        var month = $a942b99a35e53a72$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $a337e11db75e0691$var$dataMemory = {};
var $a337e11db75e0691$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $a337e11db75e0691$var$dataMemory[key] = value;
        return $a337e11db75e0691$var$dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($a337e11db75e0691$var$dataMemory, key) ? $a337e11db75e0691$var$dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $a337e11db75e0691$var$dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        $a337e11db75e0691$var$dataMemory = {};
        return $a337e11db75e0691$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $a337e11db75e0691$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = $a337e11db75e0691$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();


/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $4058d38c717354d0$var$isNavigatorAvailable = typeof navigator !== "undefined";
var $4058d38c717354d0$var$userAgent = $4058d38c717354d0$var$isNavigatorAvailable ? (0, $d09126a5f5299c10$export$2dffd0b5373a4389).isReactNative ? "react-native" : navigator.userAgent : "nodejs";
var $4058d38c717354d0$export$4831c8ceb87486f4 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function InternalCognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, $a337e11db75e0691$export$2e2bcd8739ae039)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = InternalCognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback, userAgentValue) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        }, userAgentValue);
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback, userAgentValue) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback, userAgentValue);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback, userAgentValue);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback, userAgentValue) {
        var _this2 = this;
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var dateHelper = new (0, $a942b99a35e53a72$export$2e2bcd8739ae039)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                salt = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $7fb856e564cccfe9$export$a143d493d941bafc).concat([
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this2.pool.getUserPoolName(), "utf8"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this2.username, "utf8"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $cf1b63b8461dcf91$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        }, userAgentValue);
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback, userAgentValue);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            }, userAgentValue);
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback, userAgentValue) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback, userAgentValue);
        }, userAgentValue);
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback, userAgentValue) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback, undefined, userAgentValue);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $4058d38c717354d0$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            }, userAgentValue);
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata, userAgentValue) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback, userAgentValue);
        }, userAgentValue);
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata, userAgentValue) {
        var _this6 = this;
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.deviceGroupKey);
        var dateHelper = new (0, $a942b99a35e53a72$export$2e2bcd8739ae039)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                var salt = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $7fb856e564cccfe9$export$a143d493d941bafc).concat([
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this6.deviceGroupKey, "utf8"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this6.deviceKey, "utf8"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $cf1b63b8461dcf91$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    }, userAgentValue);
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            }, userAgentValue);
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata, userAgentValue) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        }, userAgentValue);
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata, userAgentValue) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback, userAgentValue);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata, userAgentValue) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback, undefined, userAgentValue);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $4058d38c717354d0$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                }, userAgentValue);
                return undefined;
            });
            return undefined;
        }, userAgentValue);
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata, userAgentValue) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        }, userAgentValue);
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback, userAgentValue) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        }, userAgentValue);
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback, userAgentValue) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        }, userAgentValue);
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback, userAgentValue) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        }, userAgentValue);
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata, userAgentValue) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        }, userAgentValue);
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata, userAgentValue) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err, result) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS", result);
            }, {
                bypassCache: true
            }, userAgentValue);
        }, userAgentValue);
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback, userAgentValue) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $38555859a52f4863$export$2e2bcd8739ae039)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        }, userAgentValue);
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback, userAgentValue) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        }, userAgentValue);
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {Promise<object>}
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest(userAgentValue) {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, userAgentValue);
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} options
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {Promise<any>}
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options, userAgentValue) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata, userAgentValue);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params, userAgentValue) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params, userAgentValue).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {string} userAgentValue Optional string containing custom user agent value
   */ ;
    _proto.fetchUserData = function fetchUserData(userAgentValue) {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        }, userAgentValue);
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback, userAgentValue) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            }, userAgentValue);
        }, userAgentValue);
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata, userAgentValue) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        }, userAgentValue);
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options, userAgentValue) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $8eb7209a41983bfc$export$2e2bcd8739ae039)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $8281217ccf88c1bf$export$2e2bcd8739ae039)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $c59d7f07074bc9f5$export$2e2bcd8739ae039)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $82508fd376aeac3c$export$2e2bcd8739ae039)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata, userAgentValue);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata, userAgentValue) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        }, userAgentValue);
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $8eb7209a41983bfc$export$2e2bcd8739ae039)(authResult);
        var accessToken = new (0, $8281217ccf88c1bf$export$2e2bcd8739ae039)(authResult);
        var refreshToken = new (0, $c59d7f07074bc9f5$export$2e2bcd8739ae039)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $82508fd376aeac3c$export$2e2bcd8739ae039)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata, userAgentValue) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        }, userAgentValue);
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata, userAgentValue) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        }, userAgentValue);
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata, userAgentValue) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        }, userAgentValue);
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback, userAgentValue) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        }, userAgentValue);
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback, userAgentValue) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        }, userAgentValue);
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback, userAgentValue) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        }, userAgentValue);
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback, userAgentValue) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        }, userAgentValue);
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback, userAgentValue) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        }, userAgentValue);
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback, userAgentValue) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        }, userAgentValue);
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback, userAgentValue) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        }, userAgentValue);
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback, userAgentValue) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        }, userAgentValue);
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @param revokeTokenCallback
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback, userAgentValue) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            }, userAgentValue);
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback, userAgentValue) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            }, userAgentValue);
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2, userAgentValue) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        }, userAgentValue);
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback, userAgentValue) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        }, userAgentValue);
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback, userAgentValue) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        }, userAgentValue);
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        }, userAgentValue);
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback, userAgentValue) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            }, userAgentValue);
            return undefined;
        }, userAgentValue);
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        }, userAgentValue);
    };
    return InternalCognitoUser;
}();


/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

function $bb0b3502dd43cbf5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $bb0b3502dd43cbf5$var$_setPrototypeOf(subClass, superClass);
}
function $bb0b3502dd43cbf5$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $bb0b3502dd43cbf5$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$bb0b3502dd43cbf5$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $bb0b3502dd43cbf5$var$_construct(Class, arguments, $bb0b3502dd43cbf5$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $bb0b3502dd43cbf5$var$_setPrototypeOf(Wrapper, Class);
    };
    return $bb0b3502dd43cbf5$var$_wrapNativeSuper(Class);
}
function $bb0b3502dd43cbf5$var$_construct(Parent, args, Class) {
    if ($bb0b3502dd43cbf5$var$_isNativeReflectConstruct()) $bb0b3502dd43cbf5$var$_construct = Reflect.construct.bind();
    else $bb0b3502dd43cbf5$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $bb0b3502dd43cbf5$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $bb0b3502dd43cbf5$var$_construct.apply(null, arguments);
}
function $bb0b3502dd43cbf5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bb0b3502dd43cbf5$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $bb0b3502dd43cbf5$var$_setPrototypeOf(o, p) {
    $bb0b3502dd43cbf5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bb0b3502dd43cbf5$var$_setPrototypeOf(o, p);
}
function $bb0b3502dd43cbf5$var$_getPrototypeOf(o) {
    $bb0b3502dd43cbf5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bb0b3502dd43cbf5$var$_getPrototypeOf(o);
}
var $bb0b3502dd43cbf5$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $bb0b3502dd43cbf5$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $bb0b3502dd43cbf5$var$_wrapNativeSuper(Error));
/** @class */ var $bb0b3502dd43cbf5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params, userAgentValue) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $bb0b3502dd43cbf5$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            }, userAgentValue);
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback, userAgentValue) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        $bb0b3502dd43cbf5$var$jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                }, userAgentValue);
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback, userAgentValue) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": userAgentValue || (0, $68caf4bd6c7da8b9$export$ede38edb26c0bfdf)(),
            "Cache-Control": "no-store"
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var $bb0b3502dd43cbf5$var$logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var $bb0b3502dd43cbf5$var$NonRetryableError = /*#__PURE__*/ function(_Error2) {
    $bb0b3502dd43cbf5$var$_inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ $bb0b3502dd43cbf5$var$_wrapNativeSuper(Error));
var $bb0b3502dd43cbf5$var$isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $bb0b3502dd43cbf5$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    $bb0b3502dd43cbf5$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        $bb0b3502dd43cbf5$var$logger.debug("error on " + functionToRetry.name, err);
        if ($bb0b3502dd43cbf5$var$isNonRetryableError(err)) {
            $bb0b3502dd43cbf5$var$logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        $bb0b3502dd43cbf5$var$logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return $bb0b3502dd43cbf5$var$retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function $bb0b3502dd43cbf5$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $bb0b3502dd43cbf5$var$MAX_DELAY_MS = 300000;
function $bb0b3502dd43cbf5$var$jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $bb0b3502dd43cbf5$var$MAX_DELAY_MS;
    return $bb0b3502dd43cbf5$var$retry(functionToRetry, args, $bb0b3502dd43cbf5$var$jitteredBackoff(maxDelayMs));
}




var $a700663c6f64bc9d$var$USER_POOL_ID_MAX_LENGTH = 55;
var $a700663c6f64bc9d$export$76537da238efc00f = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function InternalCognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > $a700663c6f64bc9d$var$USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $bb0b3502dd43cbf5$export$2e2bcd8739ae039)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $a337e11db75e0691$export$2e2bcd8739ae039)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = InternalCognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split("_")[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @param {string} userAgentValue Optional string containing custom user agent value
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata, userAgentValue) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $737214f2f07cda56$export$2e2bcd8739ae039)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        }, userAgentValue);
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $737214f2f07cda56$export$2e2bcd8739ae039)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return InternalCognitoUserPool;
}();




function $737214f2f07cda56$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $737214f2f07cda56$var$_setPrototypeOf(subClass, superClass);
}
function $737214f2f07cda56$var$_setPrototypeOf(o, p) {
    $737214f2f07cda56$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $737214f2f07cda56$var$_setPrototypeOf(o, p);
}
/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ /** @class */ var $737214f2f07cda56$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_InternalCognitoUser) {
    $737214f2f07cda56$var$_inheritsLoose(CognitoUser, _InternalCognitoUser);
    function CognitoUser() {
        return _InternalCognitoUser.apply(this, arguments) || this;
    }
    var _proto = CognitoUser.prototype;
    /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        _InternalCognitoUser.prototype.initiateAuth.call(this, authDetails, callback);
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        _InternalCognitoUser.prototype.authenticateUser.call(this, authDetails, callback);
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        _InternalCognitoUser.prototype.completeNewPasswordChallenge.call(this, newPassword, requiredAttributeData, callback, clientMetadata);
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        _InternalCognitoUser.prototype.getDeviceResponse.call(this, callback, clientMetadata);
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        _InternalCognitoUser.prototype.confirmRegistration.call(this, confirmationCode, forceAliasCreation, callback, clientMetadata);
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        _InternalCognitoUser.prototype.sendCustomChallengeAnswer.call(this, answerChallenge, callback, clientMetadata);
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        _InternalCognitoUser.prototype.sendMFACode.call(this, confirmationCode, callback, mfaType, clientMetadata);
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        _InternalCognitoUser.prototype.changePassword.call(this, oldUserPassword, newUserPassword, callback, clientMetadata);
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        _InternalCognitoUser.prototype.enableMFA.call(this, callback);
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        _InternalCognitoUser.prototype.setUserMfaPreference.call(this, smsMfaSettings, softwareTokenMfaSettings, callback);
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        _InternalCognitoUser.prototype.disableMFA.call(this, callback);
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        _InternalCognitoUser.prototype.deleteUser.call(this, callback, clientMetadata);
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        _InternalCognitoUser.prototype.updateAttributes.call(this, attributes, callback, clientMetadata);
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        _InternalCognitoUser.prototype.getUserAttributes.call(this, callback);
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        _InternalCognitoUser.prototype.getMFAOptions.call(this, callback);
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        _InternalCognitoUser.prototype.getUserData.call(this, callback, params);
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        _InternalCognitoUser.prototype.deleteAttributes.call(this, attributeList, callback);
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        _InternalCognitoUser.prototype.resendConfirmationCode.call(this, callback, clientMetadata);
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        _InternalCognitoUser.prototype.getSession.call(this, callback, options);
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        _InternalCognitoUser.prototype.refreshSession.call(this, refreshToken, callback, clientMetadata);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        _InternalCognitoUser.prototype.forgotPassword.call(this, callback, clientMetadata);
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        _InternalCognitoUser.prototype.confirmPassword.call(this, confirmationCode, newPassword, callback, clientMetadata);
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        _InternalCognitoUser.prototype.getAttributeVerificationCode.call(this, attributeName, callback, clientMetadata);
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        _InternalCognitoUser.prototype.verifyAttribute.call(this, attributeName, confirmationCode, callback);
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        _InternalCognitoUser.prototype.getDevice.call(this, callback);
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        _InternalCognitoUser.prototype.forgetSpecificDevice.call(this, deviceKey, callback);
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        _InternalCognitoUser.prototype.forgetDevice.call(this, callback);
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        _InternalCognitoUser.prototype.setDeviceStatusRemembered.call(this, callback);
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        _InternalCognitoUser.prototype.setDeviceStatusNotRemembered.call(this, callback);
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        _InternalCognitoUser.prototype.listDevices.call(this, limit, paginationToken, callback);
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        _InternalCognitoUser.prototype.globalSignOut.call(this, callback);
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        _InternalCognitoUser.prototype.signOut.call(this, revokeTokenCallback);
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        _InternalCognitoUser.prototype.revokeTokens.call(this, revokeTokenCallback);
    };
    _proto.revokeToken = function revokeToken(_ref) {
        var token = _ref.token, callback = _ref.callback;
        _InternalCognitoUser.prototype.revokeToken.call(this, {
            token: token,
            callback: callback
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        _InternalCognitoUser.prototype.sendMFASelectionAnswer.call(this, answerChallenge, callback);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        _InternalCognitoUser.prototype.associateSoftwareToken.call(this, callback);
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        _InternalCognitoUser.prototype.verifySoftwareToken.call(this, totpCode, friendlyDeviceName, callback);
    };
    return CognitoUser;
}((0, $4058d38c717354d0$export$4831c8ceb87486f4));





function $b355f5e976985f5d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $b355f5e976985f5d$var$_setPrototypeOf(subClass, superClass);
}
function $b355f5e976985f5d$var$_setPrototypeOf(o, p) {
    $b355f5e976985f5d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b355f5e976985f5d$var$_setPrototypeOf(o, p);
}
var $b355f5e976985f5d$var$USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var $b355f5e976985f5d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_InternalCognitoUserP) {
    $b355f5e976985f5d$var$_inheritsLoose(CognitoUserPool, _InternalCognitoUserP);
    function CognitoUserPool() {
        return _InternalCognitoUserP.apply(this, arguments) || this;
    }
    var _proto = CognitoUserPool.prototype;
    /**
   * @typedef {object} SignUpResult
   * @property {CognitoUser} user New user.
   * @property {bool} userConfirmed If the user is already confirmed.
   */ /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        return _InternalCognitoUserP.prototype.signUp.call(this, username, password, userAttributes, validationData, callback, clientMetadata);
    };
    return CognitoUserPool;
}((0, $a700663c6f64bc9d$export$76537da238efc00f));



var $77d90cc1928dbf34$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $77d90cc1928dbf34$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


/** @class */ var $d2150fd716ee36a9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (default: domain of the page
   * 				where the cookie was created, excluding subdomains)
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behavior (default: null)
   */ function CookieStorage(data) {
        if (data === void 0) data = {};
        if (data.domain) this.domain = data.domain;
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $77d90cc1928dbf34$exports.set(key, value, options);
        return $77d90cc1928dbf34$exports.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return $77d90cc1928dbf34$exports.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $77d90cc1928dbf34$exports.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = $77d90cc1928dbf34$exports.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();








// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $8be3844318649839$export$98e6a39c04603d36;
var $8be3844318649839$export$f7ad0328861e2f03;
var $8be3844318649839$export$7daf1a5d2f4dd018;
var $8be3844318649839$export$d9468344d3651243;
var $8be3844318649839$export$59d795186a5d3f58;
"use strict";

var $dNdRi = parcelRequire("dNdRi");
var $b2232fc703e03f09$exports = {};
"use strict";
$b2232fc703e03f09$exports = {
    isString: function(arg) {
        return typeof arg === "string";
    },
    isObject: function(arg) {
        return typeof arg === "object" && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};


$8be3844318649839$export$98e6a39c04603d36 = $8be3844318649839$var$urlParse;
$8be3844318649839$export$f7ad0328861e2f03 = $8be3844318649839$var$urlResolve;
$8be3844318649839$export$7daf1a5d2f4dd018 = $8be3844318649839$var$urlResolveObject;
$8be3844318649839$export$d9468344d3651243 = $8be3844318649839$var$urlFormat;
$8be3844318649839$export$59d795186a5d3f58 = $8be3844318649839$var$Url;
function $8be3844318649839$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $8be3844318649839$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $8be3844318649839$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$8be3844318649839$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$8be3844318649839$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
$8be3844318649839$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($8be3844318649839$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$8be3844318649839$var$autoEscape = [
    "'"
].concat($8be3844318649839$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$8be3844318649839$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($8be3844318649839$var$autoEscape), $8be3844318649839$var$hostEndingChars = [
    "/",
    "?",
    "#"
], $8be3844318649839$var$hostnameMaxLen = 255, $8be3844318649839$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $8be3844318649839$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
$8be3844318649839$var$unsafeProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that never have a hostname.
$8be3844318649839$var$hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
$8be3844318649839$var$slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};
var $6fccb246f9bde9ce$export$2f872c0f2117be69;
var $6fccb246f9bde9ce$export$98e6a39c04603d36;
var $6fccb246f9bde9ce$export$c564cdbbe6da493;
var $6fccb246f9bde9ce$export$fac44ee5b035f737;
"use strict";

$6fccb246f9bde9ce$export$2f872c0f2117be69 = $6fccb246f9bde9ce$export$98e6a39c04603d36 = (parcelRequire("kzGqM"));

$6fccb246f9bde9ce$export$c564cdbbe6da493 = $6fccb246f9bde9ce$export$fac44ee5b035f737 = (parcelRequire("kWD7b"));


function $8be3844318649839$var$urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $b2232fc703e03f09$exports.isObject(url) && url instanceof $8be3844318649839$var$Url) return url;
    var u = new $8be3844318649839$var$Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
$8be3844318649839$var$Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$b2232fc703e03f09$exports.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = $8be3844318649839$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $6fccb246f9bde9ce$export$98e6a39c04603d36(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = $8be3844318649839$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $8be3844318649839$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$8be3844318649839$var$hostlessProtocol[proto] && (slashes || proto && !$8be3844318649839$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < $8be3844318649839$var$hostEndingChars.length; i++){
            var hec = rest.indexOf($8be3844318649839$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < $8be3844318649839$var$nonHostChars.length; i++){
            var hec = rest.indexOf($8be3844318649839$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($8be3844318649839$var$hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($8be3844318649839$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($8be3844318649839$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $8be3844318649839$var$hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $dNdRi.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!$8be3844318649839$var$unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = $8be3844318649839$var$autoEscape.length; i < l; i++){
        var ae = $8be3844318649839$var$autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $6fccb246f9bde9ce$export$98e6a39c04603d36(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if ($8be3844318649839$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function $8be3844318649839$var$urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($b2232fc703e03f09$exports.isString(obj)) obj = $8be3844318649839$var$urlParse(obj);
    if (!(obj instanceof $8be3844318649839$var$Url)) return $8be3844318649839$var$Url.prototype.format.call(obj);
    return obj.format();
}
$8be3844318649839$var$Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && $b2232fc703e03f09$exports.isObject(this.query) && Object.keys(this.query).length) query = $6fccb246f9bde9ce$export$fac44ee5b035f737(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || $8be3844318649839$var$slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function $8be3844318649839$var$urlResolve(source, relative) {
    return $8be3844318649839$var$urlParse(source, false, true).resolve(relative);
}
$8be3844318649839$var$Url.prototype.resolve = function(relative) {
    return this.resolveObject($8be3844318649839$var$urlParse(relative, false, true)).format();
};
function $8be3844318649839$var$urlResolveObject(source, relative) {
    if (!source) return relative;
    return $8be3844318649839$var$urlParse(source, false, true).resolveObject(relative);
}
$8be3844318649839$var$Url.prototype.resolveObject = function(relative) {
    if ($b2232fc703e03f09$exports.isString(relative)) {
        var rel = new $8be3844318649839$var$Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new $8be3844318649839$var$Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if ($8be3844318649839$var$slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!$8be3844318649839$var$slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !$8be3844318649839$var$hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !$8be3844318649839$var$slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$b2232fc703e03f09$exports.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$b2232fc703e03f09$exports.isNull(result.pathname) || !$b2232fc703e03f09$exports.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join("/");
    //to support request.http
    if (!$b2232fc703e03f09$exports.isNull(result.pathname) || !$b2232fc703e03f09$exports.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
$8be3844318649839$var$Url.prototype.parseHost = function() {
    var host = this.host;
    var port = $8be3844318649839$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $32e7ded170a35dd0$var$SELF = "_self";
var $32e7ded170a35dd0$export$9b38228bd9928080 = function(url) {
    var windowProxy = window.open(url, $32e7ded170a35dd0$var$SELF);
    if (windowProxy) return Promise.resolve(windowProxy);
    else return Promise.reject();
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $eb5688ac97e97bd7$export$42fffed799c298bb = function(state) {
    window.sessionStorage.setItem("oauth_state", state);
};
var $eb5688ac97e97bd7$export$50fdfeece43146fd = function() {
    var oauth_state = window.sessionStorage.getItem("oauth_state");
    window.sessionStorage.removeItem("oauth_state");
    return oauth_state;
};
var $eb5688ac97e97bd7$export$14934cb45d589fa1 = function(private_key) {
    window.sessionStorage.setItem("ouath_pkce_key", private_key);
};
var $eb5688ac97e97bd7$export$742ac7ded61fbfce = function() {
    var ouath_pkce_key = window.sessionStorage.getItem("ouath_pkce_key");
    window.sessionStorage.removeItem("ouath_pkce_key");
    return ouath_pkce_key;
};
var $eb5688ac97e97bd7$export$1042faa6df30c26 = function() {
    window.sessionStorage.removeItem("ouath_pkce_key");
    window.sessionStorage.removeItem("oauth_state");
};


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $dc3afe83899352e5$export$a143d493d941bafc;
var $dc3afe83899352e5$export$e4cf37d7f6fb9e0a;
var $dc3afe83899352e5$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $dc3afe83899352e5$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");

$dc3afe83899352e5$export$a143d493d941bafc = $dc3afe83899352e5$var$Buffer;
$dc3afe83899352e5$export$e4cf37d7f6fb9e0a = $dc3afe83899352e5$var$SlowBuffer;
$dc3afe83899352e5$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $dc3afe83899352e5$var$typedArraySupport();
$dc3afe83899352e5$export$599f31c3813fae4d = $dc3afe83899352e5$var$kMaxLength();
function $dc3afe83899352e5$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $dc3afe83899352e5$var$kMaxLength() {
    return $dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $dc3afe83899352e5$var$createBuffer(that, length) {
    if ($dc3afe83899352e5$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $dc3afe83899352e5$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $dc3afe83899352e5$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $dc3afe83899352e5$var$Buffer(arg, encodingOrOffset, length) {
    if (!$dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $dc3afe83899352e5$var$Buffer)) return new $dc3afe83899352e5$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $dc3afe83899352e5$var$allocUnsafe(this, arg);
    }
    return $dc3afe83899352e5$var$from(this, arg, encodingOrOffset, length);
}
$dc3afe83899352e5$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$dc3afe83899352e5$var$Buffer._augment = function(arr) {
    arr.__proto__ = $dc3afe83899352e5$var$Buffer.prototype;
    return arr;
};
function $dc3afe83899352e5$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $dc3afe83899352e5$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $dc3afe83899352e5$var$fromString(that, value, encodingOrOffset);
    return $dc3afe83899352e5$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $dc3afe83899352e5$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $dc3afe83899352e5$var$from(null, value, encodingOrOffset, length);
};
if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $dc3afe83899352e5$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $dc3afe83899352e5$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $dc3afe83899352e5$var$Buffer[Symbol.species] === $dc3afe83899352e5$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($dc3afe83899352e5$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $dc3afe83899352e5$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $dc3afe83899352e5$var$alloc(that, size, fill, encoding) {
    $dc3afe83899352e5$var$assertSize(size);
    if (size <= 0) return $dc3afe83899352e5$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $dc3afe83899352e5$var$createBuffer(that, size).fill(fill, encoding) : $dc3afe83899352e5$var$createBuffer(that, size).fill(fill);
    return $dc3afe83899352e5$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $dc3afe83899352e5$var$Buffer.alloc = function(size, fill, encoding) {
    return $dc3afe83899352e5$var$alloc(null, size, fill, encoding);
};
function $dc3afe83899352e5$var$allocUnsafe(that, size) {
    $dc3afe83899352e5$var$assertSize(size);
    that = $dc3afe83899352e5$var$createBuffer(that, size < 0 ? 0 : $dc3afe83899352e5$var$checked(size) | 0);
    if (!$dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $dc3afe83899352e5$var$Buffer.allocUnsafe = function(size) {
    return $dc3afe83899352e5$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $dc3afe83899352e5$var$Buffer.allocUnsafeSlow = function(size) {
    return $dc3afe83899352e5$var$allocUnsafe(null, size);
};
function $dc3afe83899352e5$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$dc3afe83899352e5$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $dc3afe83899352e5$var$byteLength(string, encoding) | 0;
    that = $dc3afe83899352e5$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $dc3afe83899352e5$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $dc3afe83899352e5$var$checked(array.length) | 0;
    that = $dc3afe83899352e5$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $dc3afe83899352e5$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $dc3afe83899352e5$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $dc3afe83899352e5$var$fromArrayLike(that, array);
    return that;
}
function $dc3afe83899352e5$var$fromObject(that, obj) {
    if ($dc3afe83899352e5$var$Buffer.isBuffer(obj)) {
        var len = $dc3afe83899352e5$var$checked(obj.length) | 0;
        that = $dc3afe83899352e5$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $dc3afe83899352e5$var$isnan(obj.length)) return $dc3afe83899352e5$var$createBuffer(that, 0);
            return $dc3afe83899352e5$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $52af415c3a3d4253$exports(obj.data)) return $dc3afe83899352e5$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $dc3afe83899352e5$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $dc3afe83899352e5$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $dc3afe83899352e5$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $dc3afe83899352e5$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $dc3afe83899352e5$var$Buffer.alloc(+length);
}
$dc3afe83899352e5$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$dc3afe83899352e5$var$Buffer.compare = function compare(a, b) {
    if (!$dc3afe83899352e5$var$Buffer.isBuffer(a) || !$dc3afe83899352e5$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$dc3afe83899352e5$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$dc3afe83899352e5$var$Buffer.concat = function concat(list, length) {
    if (!$52af415c3a3d4253$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $dc3afe83899352e5$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $dc3afe83899352e5$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$dc3afe83899352e5$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $dc3afe83899352e5$var$byteLength(string, encoding) {
    if ($dc3afe83899352e5$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $dc3afe83899352e5$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $dc3afe83899352e5$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $dc3afe83899352e5$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$dc3afe83899352e5$var$Buffer.byteLength = $dc3afe83899352e5$var$byteLength;
function $dc3afe83899352e5$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $dc3afe83899352e5$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $dc3afe83899352e5$var$utf8Slice(this, start, end);
        case "ascii":
            return $dc3afe83899352e5$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $dc3afe83899352e5$var$latin1Slice(this, start, end);
        case "base64":
            return $dc3afe83899352e5$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $dc3afe83899352e5$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$dc3afe83899352e5$var$Buffer.prototype._isBuffer = true;
function $dc3afe83899352e5$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$dc3afe83899352e5$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$dc3afe83899352e5$var$swap(this, i, i + 1);
    return this;
};
$dc3afe83899352e5$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $dc3afe83899352e5$var$swap(this, i, i + 3);
        $dc3afe83899352e5$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$dc3afe83899352e5$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $dc3afe83899352e5$var$swap(this, i, i + 7);
        $dc3afe83899352e5$var$swap(this, i + 1, i + 6);
        $dc3afe83899352e5$var$swap(this, i + 2, i + 5);
        $dc3afe83899352e5$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$dc3afe83899352e5$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $dc3afe83899352e5$var$utf8Slice(this, 0, length);
    return $dc3afe83899352e5$var$slowToString.apply(this, arguments);
};
$dc3afe83899352e5$var$Buffer.prototype.equals = function equals(b) {
    if (!$dc3afe83899352e5$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $dc3afe83899352e5$var$Buffer.compare(this, b) === 0;
};
$dc3afe83899352e5$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $dc3afe83899352e5$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$dc3afe83899352e5$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$dc3afe83899352e5$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $dc3afe83899352e5$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $dc3afe83899352e5$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($dc3afe83899352e5$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $dc3afe83899352e5$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $dc3afe83899352e5$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $dc3afe83899352e5$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$dc3afe83899352e5$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$dc3afe83899352e5$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $dc3afe83899352e5$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$dc3afe83899352e5$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $dc3afe83899352e5$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $dc3afe83899352e5$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $dc3afe83899352e5$var$utf8Write(buf, string, offset, length) {
    return $dc3afe83899352e5$var$blitBuffer($dc3afe83899352e5$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $dc3afe83899352e5$var$asciiWrite(buf, string, offset, length) {
    return $dc3afe83899352e5$var$blitBuffer($dc3afe83899352e5$var$asciiToBytes(string), buf, offset, length);
}
function $dc3afe83899352e5$var$latin1Write(buf, string, offset, length) {
    return $dc3afe83899352e5$var$asciiWrite(buf, string, offset, length);
}
function $dc3afe83899352e5$var$base64Write(buf, string, offset, length) {
    return $dc3afe83899352e5$var$blitBuffer($dc3afe83899352e5$var$base64ToBytes(string), buf, offset, length);
}
function $dc3afe83899352e5$var$ucs2Write(buf, string, offset, length) {
    return $dc3afe83899352e5$var$blitBuffer($dc3afe83899352e5$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$dc3afe83899352e5$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $dc3afe83899352e5$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $dc3afe83899352e5$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $dc3afe83899352e5$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $dc3afe83899352e5$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $dc3afe83899352e5$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $dc3afe83899352e5$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$dc3afe83899352e5$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $dc3afe83899352e5$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $dc3afe83899352e5$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $dc3afe83899352e5$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $dc3afe83899352e5$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $dc3afe83899352e5$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $dc3afe83899352e5$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $dc3afe83899352e5$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $dc3afe83899352e5$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $dc3afe83899352e5$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $dc3afe83899352e5$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $dc3afe83899352e5$var$toHex(buf[i]);
    return out;
}
function $dc3afe83899352e5$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$dc3afe83899352e5$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $dc3afe83899352e5$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $dc3afe83899352e5$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $dc3afe83899352e5$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$dc3afe83899352e5$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$dc3afe83899352e5$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$dc3afe83899352e5$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$dc3afe83899352e5$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$dc3afe83899352e5$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$dc3afe83899352e5$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$dc3afe83899352e5$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$dc3afe83899352e5$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$dc3afe83899352e5$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$dc3afe83899352e5$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$dc3afe83899352e5$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$dc3afe83899352e5$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$dc3afe83899352e5$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$dc3afe83899352e5$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$dc3afe83899352e5$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$dc3afe83899352e5$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$dc3afe83899352e5$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$dc3afe83899352e5$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $dc3afe83899352e5$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$dc3afe83899352e5$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$dc3afe83899352e5$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $dc3afe83899352e5$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$dc3afe83899352e5$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $dc3afe83899352e5$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$dc3afe83899352e5$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $dc3afe83899352e5$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$dc3afe83899352e5$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $dc3afe83899352e5$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$dc3afe83899352e5$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $dc3afe83899352e5$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $dc3afe83899352e5$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$dc3afe83899352e5$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $dc3afe83899352e5$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$dc3afe83899352e5$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $dc3afe83899352e5$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$dc3afe83899352e5$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $dc3afe83899352e5$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$dc3afe83899352e5$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $dc3afe83899352e5$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$dc3afe83899352e5$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$dc3afe83899352e5$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $dc3afe83899352e5$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$dc3afe83899352e5$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $dc3afe83899352e5$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$dc3afe83899352e5$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $dc3afe83899352e5$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$dc3afe83899352e5$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $dc3afe83899352e5$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $dc3afe83899352e5$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $dc3afe83899352e5$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $dc3afe83899352e5$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$dc3afe83899352e5$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $dc3afe83899352e5$var$writeFloat(this, value, offset, true, noAssert);
};
$dc3afe83899352e5$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $dc3afe83899352e5$var$writeFloat(this, value, offset, false, noAssert);
};
function $dc3afe83899352e5$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $dc3afe83899352e5$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$dc3afe83899352e5$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $dc3afe83899352e5$var$writeDouble(this, value, offset, true, noAssert);
};
$dc3afe83899352e5$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $dc3afe83899352e5$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$dc3afe83899352e5$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$dc3afe83899352e5$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$dc3afe83899352e5$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$dc3afe83899352e5$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $dc3afe83899352e5$var$Buffer.isBuffer(val) ? val : $dc3afe83899352e5$var$utf8ToBytes(new $dc3afe83899352e5$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $dc3afe83899352e5$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $dc3afe83899352e5$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $dc3afe83899352e5$var$stringtrim(str).replace($dc3afe83899352e5$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $dc3afe83899352e5$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $dc3afe83899352e5$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $dc3afe83899352e5$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $dc3afe83899352e5$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $dc3afe83899352e5$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $dc3afe83899352e5$var$base64ToBytes(str) {
    return $kuxul.toByteArray($dc3afe83899352e5$var$base64clean(str));
}
function $dc3afe83899352e5$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $dc3afe83899352e5$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}





var $f5a1b2886f9afa8c$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $f5a1b2886f9afa8c$var$dispatchAuthEvent = function(event, data, message) {
    (0, $1a908fb961b3fa6b$exports.Hub).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", $f5a1b2886f9afa8c$var$AMPLIFY_SYMBOL);
};
var $f5a1b2886f9afa8c$var$logger = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("OAuth");
var $f5a1b2886f9afa8c$var$OAuth = /** @class */ function() {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || (0, $32e7ded170a35dd0$export$9b38228bd9928080);
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        if (!this.isValidScopes(scopes)) throw Error("scopes must be a String Array");
        this._scopes = scopes;
    }
    OAuth.prototype.isValidScopes = function(scopes) {
        return Array.isArray(scopes) && scopes.every(function(scope) {
            return typeof scope === "string";
        });
    };
    OAuth.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) responseType = "code";
        if (provider === void 0) provider = (0, $d71e9f4e74f3bfef$export$eeb013770cb92342).Cognito;
        var generatedState = this._generateState(32);
        /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
        single-encodes/decodes url on first sign in and double-encodes/decodes url
        when user already signed in. Using encodeURIComponent, Base32, Base64 add
        characters % or = which on further encoding becomes unsafe. '=' create issue
        for parsing query params.
        Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ var state = customState ? generatedState + "-" + (0, $571068c73bf08655$export$b855308a44508212)(customState) : generatedState;
        $eb5688ac97e97bd7$export$42fffed799c298bb(state);
        var pkce_key = this._generateRandom(128);
        $eb5688ac97e97bd7$export$14934cb45d589fa1(pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = "S256";
        var scopesString = this._scopes.join(" ");
        var queryString = Object.entries((0, $9a4e52c79a7a812d$export$18ce0697a983be9b)((0, $9a4e52c79a7a812d$export$18ce0697a983be9b)({
            redirect_uri: redirectSignIn,
            response_type: responseType,
            client_id: clientId,
            identity_provider: provider,
            scope: scopesString,
            state: state
        }, responseType === "code" ? {
            code_challenge: code_challenge
        } : {}), responseType === "code" ? {
            code_challenge_method: code_challenge_method
        } : {})).map(function(_a) {
            var _b = (0, $9a4e52c79a7a812d$export$8d051b38c9118094)(_a, 2), k = _b[0], v = _b[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        }).join("&");
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        $f5a1b2886f9afa8c$var$logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function(currentUrl) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var code, currentUrlPathname, redirectSignInPathname, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, customUserAgentDetails, _a, access_token, refresh_token, id_token, error;
            var _b;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        code = ((0, $8be3844318649839$export$98e6a39c04603d36)(currentUrl).query || "").split("&").map(function(pairings) {
                            return pairings.split("=");
                        }).reduce(function(accum, _a) {
                            var _b;
                            var _c = (0, $9a4e52c79a7a812d$export$8d051b38c9118094)(_a, 2), k = _c[0], v = _c[1];
                            return (0, $9a4e52c79a7a812d$export$18ce0697a983be9b)((0, $9a4e52c79a7a812d$export$18ce0697a983be9b)({}, accum), (_b = {}, _b[k] = v, _b));
                        }, {
                            code: undefined
                        }).code;
                        currentUrlPathname = (0, $8be3844318649839$export$98e6a39c04603d36)(currentUrl).pathname || "/";
                        redirectSignInPathname = (0, $8be3844318649839$export$98e6a39c04603d36)(this._config.redirectSignIn).pathname || "/";
                        if (!code || currentUrlPathname !== redirectSignInPathname) return [
                            2 /*return*/ 
                        ];
                        oAuthTokenEndpoint = "https://" + this._config.domain + "/oauth2/token";
                        $f5a1b2886f9afa8c$var$dispatchAuthEvent("codeFlow", {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config) ? this._cognitoClientId : this._config.clientID;
                        redirect_uri = (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
                        code_verifier = $eb5688ac97e97bd7$export$742ac7ded61fbfce();
                        oAuthTokenBody = (0, $9a4e52c79a7a812d$export$18ce0697a983be9b)({
                            grant_type: "authorization_code",
                            code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri
                        }, code_verifier ? {
                            code_verifier: code_verifier
                        } : {});
                        $f5a1b2886f9afa8c$var$logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody).map(function(_a) {
                            var _b = (0, $9a4e52c79a7a812d$export$8d051b38c9118094)(_a, 2), k = _b[0], v = _b[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        }).join("&");
                        customUserAgentDetails = {
                            category: (0, $6cb1e15d3e9d75a2$export$3a8840c5b2ecf003).Auth,
                            action: (0, $6cb1e15d3e9d75a2$export$900b1436d7e65f4).FederatedSignIn
                        };
                        return [
                            4 /*yield*/ ,
                            fetch(oAuthTokenEndpoint, {
                                method: "POST",
                                headers: (_b = {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                }, _b[0, $71cdefe265dec49d$export$16032fc466434892] = (0, $2c4730a78a7bdcd6$exports.getAmplifyUserAgent)(customUserAgentDetails), _b),
                                body: body
                            })
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _c.sent().json()
                        ];
                    case 2:
                        _a = _c.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) throw new Error(error);
                        return [
                            2 /*return*/ ,
                            {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token
                            }
                        ];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function(currentUrl) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, id_token, access_token;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_b) {
                _a = ((0, $8be3844318649839$export$98e6a39c04603d36)(currentUrl).hash || "#").substr(1) // Remove # from returned code
                .split("&").map(function(pairings) {
                    return pairings.split("=");
                }).reduce(function(accum, _a) {
                    var _b;
                    var _c = (0, $9a4e52c79a7a812d$export$8d051b38c9118094)(_a, 2), k = _c[0], v = _c[1];
                    return (0, $9a4e52c79a7a812d$export$18ce0697a983be9b)((0, $9a4e52c79a7a812d$export$18ce0697a983be9b)({}, accum), (_b = {}, _b[k] = v, _b));
                }, {
                    id_token: undefined,
                    access_token: undefined
                }), id_token = _a.id_token, access_token = _a.access_token;
                $f5a1b2886f9afa8c$var$dispatchAuthEvent("implicitFlow", {}, "Got tokens from " + currentUrl);
                $f5a1b2886f9afa8c$var$logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [
                    2 /*return*/ ,
                    {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null
                    }
                ];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function(currentUrl) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        urlParams = currentUrl ? (0, $9a4e52c79a7a812d$export$18ce0697a983be9b)((0, $9a4e52c79a7a812d$export$18ce0697a983be9b)({}, ((0, $8be3844318649839$export$98e6a39c04603d36)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var _b = (0, $9a4e52c79a7a812d$export$8d051b38c9118094)(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})), ((0, $8be3844318649839$export$98e6a39c04603d36)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var _b = (0, $9a4e52c79a7a812d$export$8d051b38c9118094)(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})) : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) throw new Error(error_description);
                        state = this._validateState(urlParams);
                        $f5a1b2886f9afa8c$var$logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === "code")) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleCodeFlow(currentUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (0, $9a4e52c79a7a812d$export$18ce0697a983be9b).apply(void 0, [
                                (0, $9a4e52c79a7a812d$export$18ce0697a983be9b).apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 2:
                        _b = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleImplicitFlow(currentUrl)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            (0, $9a4e52c79a7a812d$export$18ce0697a983be9b).apply(void 0, [
                                (0, $9a4e52c79a7a812d$export$18ce0697a983be9b).apply(void 0, _b.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_1 = _c.sent();
                        $f5a1b2886f9afa8c$var$logger.debug("Error handling auth response.", e_1);
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    OAuth.prototype._validateState = function(urlParams) {
        if (!urlParams) return;
        var savedState = $eb5688ac97e97bd7$export$50fdfeece43146fd();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) throw new Error("Invalid state in OAuth flow");
        return returnedState;
    };
    OAuth.prototype.signOut = function() {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                oAuthLogoutEndpoint = "https://" + this._config.domain + "/logout?";
                client_id = (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
                signout_uri = (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config) ? this._config.redirectSignOut : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri)
                }).map(function(_a) {
                    var _b = (0, $9a4e52c79a7a812d$export$8d051b38c9118094)(_a, 2), k = _b[0], v = _b[1];
                    return k + "=" + v;
                }).join("&");
                $f5a1b2886f9afa8c$var$dispatchAuthEvent("oAuthSignOut", {
                    oAuth: "signOut"
                }, "Signing out from " + oAuthLogoutEndpoint);
                $f5a1b2886f9afa8c$var$logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [
                    2 /*return*/ ,
                    this._urlOpener(oAuthLogoutEndpoint, signout_uri)
                ];
            });
        });
    };
    OAuth.prototype._generateState = function(length) {
        var result = "";
        var i = length;
        var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for(; i > 0; --i)result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function(code) {
        var awsCryptoHash = new (0, $cf1b63b8461dcf91$exports.Sha256)();
        awsCryptoHash.update(code);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var b64 = (0, $dc3afe83899352e5$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
        var base64URLFromAWSCrypto = this._base64URL(b64);
        return base64URLFromAWSCrypto;
    };
    OAuth.prototype._base64URL = function(string) {
        return string.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
    OAuth.prototype._generateRandom = function(size) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
        var buffer = new Uint8Array(size);
        if (typeof window !== "undefined" && !!window.crypto) window.crypto.getRandomValues(buffer);
        else for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * CHARSET.length | 0;
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function(buffer) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var state = [];
        for(var i = 0; i < buffer.byteLength; i += 1){
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join("");
    };
    return OAuth;
}();
var $f5a1b2886f9afa8c$export$2e2bcd8739ae039 = $f5a1b2886f9afa8c$var$OAuth;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $4fc5cb59076d8792$export$2e2bcd8739ae039 = function(callback) {
    if ((0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser && window.location) {
        var url = window.location.href;
        callback({
            url: url
        });
    } else if ((0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isNode) ;
    else throw new Error("Not supported");
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $7814ae8782f2f7db$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
})($7814ae8782f2f7db$export$c3070468b9d65120 || ($7814ae8782f2f7db$export$c3070468b9d65120 = {}));


var $dab9793fb28d116e$var$logger = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("AuthError");
var $dab9793fb28d116e$export$145273558d58e0ac = /** @class */ function(_super) {
    (0, $9a4e52c79a7a812d$export$a8ba968b8961cb8a)(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = $dab9793fb28d116e$export$d8113b8d790509a4[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = "AuthError";
        _this.log = log || message;
        $dab9793fb28d116e$var$logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error);
var $dab9793fb28d116e$export$71192787e041818c = /** @class */ function(_super) {
    (0, $9a4e52c79a7a812d$export$a8ba968b8961cb8a)(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = "NoUserPoolError";
        return _this;
    }
    return NoUserPoolError;
}($dab9793fb28d116e$export$145273558d58e0ac);
var $dab9793fb28d116e$export$d8113b8d790509a4 = {
    noConfig: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of amplify packages in your node_modules.\n				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)\n        "
    },
    missingAuthConfig: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties.\n            This error is typically caused by one of the following scenarios:\n\n            1. Did you run `amplify push` after adding auth via `amplify add auth`?\n                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n\n            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.\n        "
    },
    emptyUsername: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).EMPTY_CODE
    },
    signUpError: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).SIGN_UP_ERROR,
        log: "The first parameter should either be non-null string or object"
    },
    noMFA: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).NO_MFA
    },
    invalidMFA: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).DEVICE_CONFIG
    },
    networkError: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, $7814ae8782f2f7db$export$c3070468b9d65120).DEFAULT_MSG
    }
};



var $19ad19b4d46b0179$var$logger = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("AuthClass");
var $19ad19b4d46b0179$var$USER_ADMIN_SCOPE = "aws.cognito.signin.user.admin";
// 10 sec, following this guide https://www.nngroup.com/articles/response-times-3-important-limits/
var $19ad19b4d46b0179$var$OAUTH_FLOW_MS_TIMEOUT = 10000;
var $19ad19b4d46b0179$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $19ad19b4d46b0179$var$dispatchAuthEvent = function(event, data, message) {
    (0, $1a908fb961b3fa6b$exports.Hub).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", $19ad19b4d46b0179$var$AMPLIFY_SYMBOL);
};
// Cognito Documentation for max device
// tslint:disable-next-line:max-line-length
// https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ListDevices.html#API_ListDevices_RequestSyntax
var $19ad19b4d46b0179$var$MAX_DEVICES = 60;
var $19ad19b4d46b0179$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
/**
 * Provide authentication steps
 */ var $19ad19b4d46b0179$export$a660349e9f03ecf6 = /** @class */ function() {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */ function InternalAuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.oAuthFlowInProgress = false;
        this.autoSignInInitiated = false;
        this.inflightSessionPromise = null;
        this.inflightSessionPromiseCounter = 0;
        this.Credentials = (0, $de9f45d92f772164$exports.Credentials);
        this.wrapRefreshSessionCallback = function(callback) {
            var wrapped = function(error, data) {
                if (data) $19ad19b4d46b0179$var$dispatchAuthEvent("tokenRefresh", undefined, "New token retrieved");
                else $19ad19b4d46b0179$var$dispatchAuthEvent("tokenRefresh_failure", error, "Failed to retrieve new token");
                return callback(error, data);
            };
            return wrapped;
        }; // prettier-ignore
        this.configure(config);
        this.currentCredentials = this.currentCredentials.bind(this);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        (0, $1a908fb961b3fa6b$exports.Hub).listen("auth", function(_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch(event){
                case "verify":
                case "signIn":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "false");
                    break;
                case "signOut":
                    _this._storage.removeItem("amplify-signin-with-hostedUI");
                    break;
                case "cognitoHostedUI":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "true");
                    break;
            }
        });
        (0, $68caf4bd6c7da8b9$export$523857f9fc06cb0d)();
        (0, $68caf4bd6c7da8b9$export$972f94ce7a888cac)((0, $2c4730a78a7bdcd6$exports.Platform).framework);
        (0, $2c4730a78a7bdcd6$exports.Platform).observeFrameworkChanges(function() {
            (0, $68caf4bd6c7da8b9$export$972f94ce7a888cac)((0, $2c4730a78a7bdcd6$exports.Platform).framework);
        });
    }
    InternalAuthClass.prototype.getModuleName = function() {
        return "InternalAuth";
    };
    InternalAuthClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config || {};
        $19ad19b4d46b0179$var$logger.debug("configure Auth");
        var conf = Object.assign({}, this._config, (0, $f0d1ba27142d0e07$exports.parseAWSExports)(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata, endpoint = _a.endpoint, storage = _a.storage;
        if (!storage) {
            // backward compatability
            if (cookieStorage) this._storage = new (0, $d2150fd716ee36a9$export$2e2bcd8739ae039)(cookieStorage);
            else this._storage = config.ssr ? new (0, $68a581920a34423d$exports.UniversalStorage)() : new (0, $7a47fb194d2f9787$export$a2bd19c49e4760e8)().getStorage();
        } else {
            if (!this._isValidAuthStorage(storage)) {
                $19ad19b4d46b0179$var$logger.error("The storage in the Auth config is not valid!");
                throw new Error("Empty storage object");
            }
            this._storage = storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
                endpoint: endpoint
            };
            userPoolData.Storage = this._storage;
            this.userPool = new (0, $b355f5e976985f5d$export$2e2bcd8739ae039)(userPoolData, this.wrapRefreshSessionCallback);
        }
        this.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage,
            identityPoolRegion: identityPoolRegion
        });
        // initialize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config.oauth) ? oauth : oauth.awsCognito : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig["domain"],
                scopes: cognitoHostedUIConfig["scope"],
                redirectSignIn: cognitoHostedUIConfig["redirectSignIn"],
                redirectSignOut: cognitoHostedUIConfig["redirectSignOut"],
                responseType: cognitoHostedUIConfig["responseType"],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig["urlOpener"],
                clientMetadata: clientMetadata
            }, cognitoHostedUIConfig["options"]);
            this._oAuthHandler = new (0, $f5a1b2886f9afa8c$export$2e2bcd8739ae039)({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            (0, $4fc5cb59076d8792$export$2e2bcd8739ae039)(function(_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) return;
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        $19ad19b4d46b0179$var$dispatchAuthEvent("configured", null, "The Auth category has been configured successfully");
        if (!this.autoSignInInitiated && typeof this._storage["getItem"] === "function") {
            var pollingInitiated = this.isTrueStorageValue("amplify-polling-started");
            if (pollingInitiated) {
                $19ad19b4d46b0179$var$dispatchAuthEvent("autoSignIn_failure", null, (0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).AutoSignInError);
                this._storage.removeItem("amplify-auto-sign-in");
            }
            this._storage.removeItem("amplify-polling-started");
        }
        return this._config;
    };
    InternalAuthClass.prototype.signUp = function(params, restOfAttrs, customUserAgentDetails) {
        var _this = this;
        var _a, _b, _c;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        var autoSignIn = {
            enabled: false
        };
        var autoSignInValidationData = {};
        var autoSignInClientMetaData = {};
        if (params && typeof params === "string") {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email) attributes.push(new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
                Name: "email",
                Value: email
            }));
            if (phone_number) attributes.push(new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
                Name: "phone_number",
                Value: phone_number
            }));
        } else if (params && typeof params === "object") {
            username = params["username"];
            password = params["password"];
            if (params && params.clientMetadata) clientMetadata = params.clientMetadata;
            else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
            var attrs_1 = params["attributes"];
            if (attrs_1) Object.keys(attrs_1).map(function(key) {
                attributes.push(new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
                    Name: key,
                    Value: attrs_1[key]
                }));
            });
            var validationDataObject_1 = params["validationData"];
            if (validationDataObject_1) {
                validationData = [];
                Object.keys(validationDataObject_1).map(function(key) {
                    validationData.push(new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
                        Name: key,
                        Value: validationDataObject_1[key]
                    }));
                });
            }
            autoSignIn = (_a = params.autoSignIn) !== null && _a !== void 0 ? _a : {
                enabled: false
            };
            if (autoSignIn.enabled) {
                this._storage.setItem("amplify-auto-sign-in", "true");
                autoSignInValidationData = (_b = autoSignIn.validationData) !== null && _b !== void 0 ? _b : {};
                autoSignInClientMetaData = (_c = autoSignIn.clientMetaData) !== null && _c !== void 0 ? _c : {};
            }
        } else return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).SignUpError);
        if (!username) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyUsername);
        if (!password) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyPassword);
        $19ad19b4d46b0179$var$logger.debug("signUp attrs:", attributes);
        $19ad19b4d46b0179$var$logger.debug("signUp validation data:", validationData);
        return new Promise(function(resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
                if (err) {
                    $19ad19b4d46b0179$var$dispatchAuthEvent("signUp_failure", err, username + " failed to signup");
                    reject(err);
                } else {
                    $19ad19b4d46b0179$var$dispatchAuthEvent("signUp", data, username + " has signed up successfully");
                    if (autoSignIn.enabled) _this.handleAutoSignIn(username, password, autoSignInValidationData, autoSignInClientMetaData, data);
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    InternalAuthClass.prototype.handleAutoSignIn = function(username, password, validationData, clientMetadata, data) {
        this.autoSignInInitiated = true;
        var authDetails = new (0, $010becf709f0452a$export$2e2bcd8739ae039)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (data.userConfirmed) this.signInAfterUserConfirmed(authDetails);
        else if (this._config.signUpVerificationMethod === "link") this.handleLinkAutoSignIn(authDetails);
        else this.handleCodeAutoSignIn(authDetails);
    };
    InternalAuthClass.prototype.handleCodeAutoSignIn = function(authDetails) {
        var _this = this;
        var listenEvent = function(_a) {
            var payload = _a.payload;
            if (payload.event === "confirmSignUp") _this.signInAfterUserConfirmed(authDetails, listenEvent);
        };
        (0, $1a908fb961b3fa6b$exports.Hub).listen("auth", listenEvent);
    };
    InternalAuthClass.prototype.handleLinkAutoSignIn = function(authDetails) {
        var _this = this;
        this._storage.setItem("amplify-polling-started", "true");
        var start = Date.now();
        var autoSignInPollingIntervalId = setInterval(function() {
            if (Date.now() - start > $19ad19b4d46b0179$var$MAX_AUTOSIGNIN_POLLING_MS) {
                clearInterval(autoSignInPollingIntervalId);
                $19ad19b4d46b0179$var$dispatchAuthEvent("autoSignIn_failure", null, "Please confirm your account and use your credentials to sign in.");
                _this._storage.removeItem("amplify-auto-sign-in");
            } else _this.signInAfterUserConfirmed(authDetails, null, autoSignInPollingIntervalId);
        }, 5000);
    };
    InternalAuthClass.prototype.signInAfterUserConfirmed = function(authDetails, listenEvent, autoSignInPollingIntervalId) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var user, error_1;
            var _this = this;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user = this.createCognitoUser(authDetails.getUsername());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            user.authenticateUser(authDetails, this.authCallbacks(user, function(value) {
                                $19ad19b4d46b0179$var$dispatchAuthEvent("autoSignIn", value, authDetails.getUsername() + " has signed in successfully");
                                if (listenEvent) (0, $1a908fb961b3fa6b$exports.Hub).remove("auth", listenEvent);
                                if (autoSignInPollingIntervalId) {
                                    clearInterval(autoSignInPollingIntervalId);
                                    _this._storage.removeItem("amplify-polling-started");
                                }
                                _this._storage.removeItem("amplify-auto-sign-in");
                            }, function(error) {
                                $19ad19b4d46b0179$var$logger.error(error);
                                _this._storage.removeItem("amplify-auto-sign-in");
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        $19ad19b4d46b0179$var$logger.error(error_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Send the verification code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves callback data if success
     */ InternalAuthClass.prototype.confirmSignUp = function(username, code, options, customUserAgentDetails) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyCode);
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === "boolean" ? options.forceAliasCreation : true;
        var clientMetadata;
        if (options && options.clientMetadata) clientMetadata = options.clientMetadata;
        else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function(err, data) {
                if (err) reject(err);
                else {
                    $19ad19b4d46b0179$var$dispatchAuthEvent("confirmSignUp", data, username + " has been confirmed successfully");
                    var autoSignIn = _this.isTrueStorageValue("amplify-auto-sign-in");
                    if (autoSignIn && !_this.autoSignInInitiated) {
                        $19ad19b4d46b0179$var$dispatchAuthEvent("autoSignIn_failure", null, (0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).AutoSignInError);
                        _this._storage.removeItem("amplify-auto-sign-in");
                    }
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    InternalAuthClass.prototype.isTrueStorageValue = function(value) {
        var item = this._storage.getItem(value);
        return item ? item === "true" : false;
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves code delivery details if successful
     */ InternalAuthClass.prototype.resendSignUp = function(username, clientMetadata, customUserAgentDetails) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.resendConfirmationCode(function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} pw - The password of the username
     * @param {ClientMetaData} clientMetadata - Client metadata for custom workflows
     * @return - A promise resolves the CognitoUser
     */ InternalAuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata, customUserAgentDetails) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === "string") {
            username = usernameOrSignInOpts;
            password = pw;
        } else if ((0, $d71e9f4e74f3bfef$export$ad34f09783c4cb16)(usernameOrSignInOpts)) {
            if (typeof pw !== "undefined") $19ad19b4d46b0179$var$logger.warn("The password should be defined under the first parameter object!");
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        } else return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).InvalidUsername);
        if (!username) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyUsername);
        var authDetails = new (0, $010becf709f0452a$export$2e2bcd8739ae039)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (password) return this.signInWithPassword(authDetails);
        else return this.signInWithoutPassword(authDetails);
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */ InternalAuthClass.prototype.authCallbacks = function(user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function(session) {
                return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var cred, e_1, currentUser, e_2;
                    return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $19ad19b4d46b0179$var$logger.debug(session);
                                delete user["challengeName"];
                                delete user["challengeParam"];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    4,
                                    5,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.set(session, "session")
                                ];
                            case 3:
                                cred = _a.sent();
                                $19ad19b4d46b0179$var$logger.debug("succeed to get cognito credentials", cred);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 4:
                                e_1 = _a.sent();
                                $19ad19b4d46b0179$var$logger.debug("cannot get cognito credentials", e_1);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 5:
                                _a.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.currentUserPoolUser()
                                ];
                            case 6:
                                currentUser = _a.sent();
                                that.user = currentUser;
                                $19ad19b4d46b0179$var$dispatchAuthEvent("signIn", currentUser, "A user " + user.getUsername() + " has been signed in");
                                resolve(currentUser);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                e_2 = _a.sent();
                                $19ad19b4d46b0179$var$logger.error("Failed to get the signed in user", e_2);
                                reject(e_2);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    7 /*endfinally*/ 
                                ];
                            case 9:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            onFailure: function(err) {
                $19ad19b4d46b0179$var$logger.debug("signIn failure", err);
                $19ad19b4d46b0179$var$dispatchAuthEvent("signIn_failure", err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function(challengeParam) {
                $19ad19b4d46b0179$var$logger.debug("signIn custom challenge answer required");
                user["challengeName"] = "CUSTOM_CHALLENGE";
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaRequired: function(challengeName, challengeParam) {
                $19ad19b4d46b0179$var$logger.debug("signIn MFA required");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaSetup: function(challengeName, challengeParam) {
                $19ad19b4d46b0179$var$logger.debug("signIn mfa setup", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function(userAttributes, requiredAttributes) {
                $19ad19b4d46b0179$var$logger.debug("signIn new password");
                user["challengeName"] = "NEW_PASSWORD_REQUIRED";
                user["challengeParam"] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function(challengeName, challengeParam) {
                $19ad19b4d46b0179$var$logger.debug("signIn totpRequired");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            selectMFAType: function(challengeName, challengeParam) {
                $19ad19b4d46b0179$var$logger.debug("signIn selectMFAType", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ InternalAuthClass.prototype.signInWithPassword = function(authDetails) {
        var _this = this;
        if (this.pendingSignIn) throw new Error("Pending sign-in attempt already in progress");
        var user = this.createCognitoUser(authDetails.getUsername());
        this.pendingSignIn = new Promise(function(resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, function(value) {
                _this.pendingSignIn = null;
                resolve(value);
            }, function(error) {
                _this.pendingSignIn = null;
                reject(error);
            }));
        });
        return this.pendingSignIn;
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ InternalAuthClass.prototype.signInWithoutPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType("CUSTOM_AUTH");
        return new Promise(function(resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * This was previously used by an authenticated user to get MFAOptions,
     * but no longer returns a meaningful response. Refer to the documentation for
     * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves the current preferred mfa option if success
     */ InternalAuthClass.prototype.getMFAOptions = function(user, customUserAgentDetails) {
        return new Promise(function(res, rej) {
            user.getMFAOptions(function(err, mfaOptions) {
                if (err) {
                    $19ad19b4d46b0179$var$logger.debug("get MFA Options failed", err);
                    rej(err);
                    return;
                }
                $19ad19b4d46b0179$var$logger.debug("get MFA options success", mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     */ InternalAuthClass.prototype.getPreferredMFA = function(user, params, customUserAgentDetails) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function(err, data) {
                return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var cleanUpError_1, mfaType;
                    return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                $19ad19b4d46b0179$var$logger.debug("getting preferred mfa failed", err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_1 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_1.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                mfaType = that._getMfaTypeFromUserData(data);
                                if (!mfaType) {
                                    rej("invalid MFA Type");
                                    return [
                                        2 /*return*/ 
                                    ];
                                } else {
                                    res(mfaType);
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, {
                bypassCache: bypassCache,
                clientMetadata: clientMetadata
            });
        });
    };
    InternalAuthClass.prototype._getMfaTypeFromUserData = function(data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) ret = preferredMFA;
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) ret = "SMS_MFA";
                else ret = "NOMFA";
            } else if (mfaList.length === 0) ret = "NOMFA";
            else $19ad19b4d46b0179$var$logger.debug("invalid case for getPreferredMFA", data);
        }
        return ret;
    };
    InternalAuthClass.prototype._getUserData = function(user, params) {
        var _this = this;
        return new Promise(function(res, rej) {
            user.getUserData(function(err, data) {
                return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var cleanUpError_2;
                    return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                $19ad19b4d46b0179$var$logger.debug("getting user data failed", err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_2 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_2.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                res(data);
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolve if success
     */ InternalAuthClass.prototype.setPreferredMFA = function(user, mfaMethod, customUserAgentDetails) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var clientMetadata, userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            var _this = this;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        clientMetadata = this._config.clientMetadata;
                        return [
                            4 /*yield*/ ,
                            this._getUserData(user, {
                                bypassCache: true,
                                clientMetadata: clientMetadata
                            })
                        ];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch(_a){
                            case "TOTP":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SOFTWARE_TOKEN_MFA":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SMS":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "SMS_MFA":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "NOMFA":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        mfaList = userData["UserMFASettingList"];
                        return [
                            4 /*yield*/ ,
                            this._getMfaTypeFromUserData(userData)
                        ];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === "NOMFA") return [
                            2 /*return*/ ,
                            Promise.resolve("No change for mfa type")
                        ];
                        else if (currentMFAType === "SMS_MFA") smsMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else if (currentMFAType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).InvalidMFA)
                        ];
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) // to disable SMS or TOTP if exists in that list
                        mfaList.forEach(function(mfaType) {
                            if (mfaType === "SMS_MFA") smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                            else if (mfaType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        $19ad19b4d46b0179$var$logger.debug("no validmfa method provided");
                        return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).NoMFA)
                        ];
                    case 7:
                        that = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                                    if (err) {
                                        $19ad19b4d46b0179$var$logger.debug("Set user mfa preference error", err);
                                        return rej(err);
                                    }
                                    $19ad19b4d46b0179$var$logger.debug("Set user mfa success", result);
                                    $19ad19b4d46b0179$var$logger.debug("Caching the latest user data into local");
                                    // cache the latest result into user data
                                    user.getUserData(function(err, data) {
                                        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                            var cleanUpError_3;
                                            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        $19ad19b4d46b0179$var$logger.debug("getting user data failed", err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_3 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_3.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        return [
                                                            2 /*return*/ ,
                                                            res(result)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        bypassCache: true,
                                        clientMetadata: clientMetadata
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * disable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves is success
     */ InternalAuthClass.prototype.disableSMS = function(user, customUserAgentDetails) {
        return new Promise(function(res, rej) {
            user.disableMFA(function(err, data) {
                if (err) {
                    $19ad19b4d46b0179$var$logger.debug("disable mfa failed", err);
                    rej(err);
                    return;
                }
                $19ad19b4d46b0179$var$logger.debug("disable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves is success
     */ InternalAuthClass.prototype.enableSMS = function(user, customUserAgentDetails) {
        return new Promise(function(res, rej) {
            user.enableMFA(function(err, data) {
                if (err) {
                    $19ad19b4d46b0179$var$logger.debug("enable mfa failed", err);
                    rej(err);
                    return;
                }
                $19ad19b4d46b0179$var$logger.debug("enable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves with the secret code if success
     */ InternalAuthClass.prototype.setupTOTP = function(user, customUserAgentDetails) {
        return new Promise(function(res, rej) {
            user.associateSoftwareToken({
                onFailure: function(err) {
                    $19ad19b4d46b0179$var$logger.debug("associateSoftwareToken failed", err);
                    rej(err);
                    return;
                },
                associateSecretCode: function(secretCode) {
                    $19ad19b4d46b0179$var$logger.debug("associateSoftwareToken success", secretCode);
                    res(secretCode);
                    return;
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves is success
     */ InternalAuthClass.prototype.verifyTotpToken = function(user, challengeAnswer, customUserAgentDetails) {
        $19ad19b4d46b0179$var$logger.debug("verification totp token", user, challengeAnswer);
        var signInUserSession;
        if (user && typeof user.getSignInUserSession === "function") signInUserSession = user.getSignInUserSession();
        var isLoggedIn = signInUserSession === null || signInUserSession === void 0 ? void 0 : signInUserSession.isValid();
        return new Promise(function(res, rej) {
            user.verifySoftwareToken(challengeAnswer, "My TOTP device", {
                onFailure: function(err) {
                    $19ad19b4d46b0179$var$logger.debug("verifyTotpToken failed", err);
                    rej(err);
                    return;
                },
                onSuccess: function(data) {
                    if (!isLoggedIn) $19ad19b4d46b0179$var$dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                    $19ad19b4d46b0179$var$dispatchAuthEvent("verify", user, "A user " + user.getUsername() + " has been verified");
                    $19ad19b4d46b0179$var$logger.debug("verifyTotpToken success", data);
                    res(data);
                    return;
                }
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     * @param {string} mfaType - optional mfaType: 'SMS_MFA' | 'SOFTWARE_TOKEN_MFA'
     * @param {ClientMetaData} clientMetadata - optional client metadata defaults to config
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     */ InternalAuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata, customUserAgentDetails) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!code) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyCode);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function(session) {
                    return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var cred, e_3, currentUser, e_4;
                        return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $19ad19b4d46b0179$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        10
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $19ad19b4d46b0179$var$logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        10
                                    ];
                                case 4:
                                    e_3 = _a.sent();
                                    $19ad19b4d46b0179$var$logger.debug("cannot get cognito credentials", e_3);
                                    return [
                                        3 /*break*/ ,
                                        10
                                    ];
                                case 5:
                                    that.user = user;
                                    _a.label = 6;
                                case 6:
                                    _a.trys.push([
                                        6,
                                        8,
                                        ,
                                        9
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.currentUserPoolUser()
                                    ];
                                case 7:
                                    currentUser = _a.sent();
                                    user.attributes = currentUser.attributes;
                                    return [
                                        3 /*break*/ ,
                                        9
                                    ];
                                case 8:
                                    e_4 = _a.sent();
                                    $19ad19b4d46b0179$var$logger.debug("cannot get updated Cognito User", e_4);
                                    return [
                                        3 /*break*/ ,
                                        9
                                    ];
                                case 9:
                                    $19ad19b4d46b0179$var$dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 10:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $19ad19b4d46b0179$var$logger.debug("confirm signIn failure", err);
                    reject(err);
                }
            }, mfaType, clientMetadata);
        });
    };
    InternalAuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata, customUserAgentDetails) {
        var _this = this;
        if (requiredAttributes === void 0) requiredAttributes = {};
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!password) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyPassword);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function(session) {
                    return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var cred, e_5;
                        return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $19ad19b4d46b0179$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $19ad19b4d46b0179$var$logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_5 = _a.sent();
                                    $19ad19b4d46b0179$var$logger.debug("cannot get cognito credentials", e_5);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $19ad19b4d46b0179$var$dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $19ad19b4d46b0179$var$logger.debug("completeNewPassword failure", err);
                    $19ad19b4d46b0179$var$dispatchAuthEvent("completeNewPassword_failure", err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function(challengeName, challengeParam) {
                    $19ad19b4d46b0179$var$logger.debug("signIn MFA required");
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function(challengeName, challengeParam) {
                    $19ad19b4d46b0179$var$logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                totpRequired: function(challengeName, challengeParam) {
                    $19ad19b4d46b0179$var$logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     * @param {ClientMetaData} clientMetadata - optional client metadata defaults to config
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     */ InternalAuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata, customUserAgentDetails) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!challengeResponses) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyChallengeResponse);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Delete an authenticated users' attributes
     * @param {CognitoUser} user - The currently logged in user object
     * @param {string[]} attributeNames - Attributes to delete
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return {Promise}
     **/ InternalAuthClass.prototype.deleteUserAttributes = function(user, attributeNames, customUserAgentDetails) {
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                user.deleteAttributes(attributeNames, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                });
            });
        });
    };
    /**
     * Delete the current authenticated user
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return {Promise}
     **/ // TODO: Check return type void
    InternalAuthClass.prototype.deleteUser = function(customUserAgentDetails) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_6, isSignedInHostedUI;
            var _this = this;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_6 = _a.sent();
                        $19ad19b4d46b0179$var$logger.debug("Failed to sync cache info into memory", e_6);
                        throw new Error(e_6);
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                    var user_1;
                                    var _this = this;
                                    return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                                        if (this.userPool) {
                                            user_1 = this.userPool.getCurrentUser();
                                            if (!user_1) {
                                                $19ad19b4d46b0179$var$logger.debug("Failed to get user from user pool");
                                                return [
                                                    2 /*return*/ ,
                                                    rej(new Error("No current user."))
                                                ];
                                            } else user_1.getSession(function(err, session) {
                                                return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                                    var cleanUpError_4;
                                                    var _this = this;
                                                    return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                                                        switch(_a.label){
                                                            case 0:
                                                                if (!err) return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                                $19ad19b4d46b0179$var$logger.debug("Failed to get the user session", err);
                                                                if (!this.isSessionInvalid(err)) return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                                _a.label = 1;
                                                            case 1:
                                                                _a.trys.push([
                                                                    1,
                                                                    3,
                                                                    ,
                                                                    4
                                                                ]);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this.cleanUpInvalidSession(user_1)
                                                                ];
                                                            case 2:
                                                                _a.sent();
                                                                return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                            case 3:
                                                                cleanUpError_4 = _a.sent();
                                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_4.message));
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                            case 4:
                                                                return [
                                                                    2 /*return*/ ,
                                                                    rej(err)
                                                                ];
                                                            case 5:
                                                                user_1.deleteUser(function(err, result) {
                                                                    if (err) rej(err);
                                                                    else {
                                                                        $19ad19b4d46b0179$var$dispatchAuthEvent("userDeleted", result, "The authenticated user has been deleted.");
                                                                        user_1.signOut();
                                                                        _this.user = null;
                                                                        try {
                                                                            _this.cleanCachedItems(); // clean aws credentials
                                                                        } catch (e) {
                                                                            // TODO: change to rejects in refactor
                                                                            $19ad19b4d46b0179$var$logger.debug("failed to clear cached items");
                                                                        }
                                                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                        else {
                                                                            $19ad19b4d46b0179$var$dispatchAuthEvent("signOut", _this.user, "A user has been signed out");
                                                                            res(result);
                                                                        }
                                                                    }
                                                                });
                                                                _a.label = 6;
                                                            case 6:
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                });
                                            });
                                        } else {
                                            $19ad19b4d46b0179$var$logger.debug("no Congito User pool");
                                            rej(new Error("Cognito User pool does not exist"));
                                        }
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} user - The currently logged in user object
     * @param {object} attributes - attributes to update
     * @param {ClientMetaData} clientMetadata - optional client metadata, defaults to config
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return {Promise}
     **/ InternalAuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata, customUserAgentDetails) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        var attributeList = [];
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                for(var key in attributes)if (key !== "sub" && key.indexOf("_verified") < 0) {
                    var attr = {
                        Name: key,
                        Value: attributes[key]
                    };
                    attributeList.push(attr);
                }
                user.updateAttributes(attributeList, function(err, result, details) {
                    if (err) {
                        $19ad19b4d46b0179$var$dispatchAuthEvent("updateUserAttributes_failure", err, "Failed to update attributes");
                        return reject(err);
                    } else {
                        var attrs = _this.createUpdateAttributesResultList(attributes, details === null || details === void 0 ? void 0 : details.CodeDeliveryDetailsList);
                        $19ad19b4d46b0179$var$dispatchAuthEvent("updateUserAttributes", attrs, "Attributes successfully updated");
                        return resolve(result);
                    }
                }, clientMetadata);
            });
        });
    };
    InternalAuthClass.prototype.createUpdateAttributesResultList = function(attributes, codeDeliveryDetailsList) {
        var attrs = {};
        Object.keys(attributes).forEach(function(key) {
            attrs[key] = {
                isUpdated: true
            };
            var codeDeliveryDetails = codeDeliveryDetailsList === null || codeDeliveryDetailsList === void 0 ? void 0 : codeDeliveryDetailsList.find(function(value) {
                return value.AttributeName === key;
            });
            if (codeDeliveryDetails) {
                attrs[key].isUpdated = false;
                attrs[key].codeDeliveryDetails = codeDeliveryDetails;
            }
        });
        return attrs;
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves to user attributes if success
     */ InternalAuthClass.prototype.userAttributes = function(user, customUserAgentDetails) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.getUserAttributes(function(err, attributes) {
                    if (err) reject(err);
                    else resolve(attributes);
                });
            });
        });
    };
    InternalAuthClass.prototype.verifiedContact = function(user, customUserAgentDetails) {
        var that = this;
        return this.userAttributes(user).then(function(attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs["email"]) {
                if (attrs["email_verified"]) verified["email"] = attrs["email"];
                else unverified["email"] = attrs["email"];
            }
            if (attrs["phone_number"]) {
                if (attrs["phone_number_verified"]) verified["phone_number"] = attrs["phone_number"];
                else unverified["phone_number"] = attrs["phone_number"];
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    InternalAuthClass.prototype.isErrorWithMessage = function(err) {
        return typeof err === "object" && Object.prototype.hasOwnProperty.call(err, "message");
    };
    // Session revoked by another app
    InternalAuthClass.prototype.isTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Access Token has been revoked";
    };
    InternalAuthClass.prototype.isRefreshTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Refresh Token has been revoked";
    };
    InternalAuthClass.prototype.isUserDisabledError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "User is disabled.";
    };
    InternalAuthClass.prototype.isUserDoesNotExistError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "User does not exist.";
    };
    InternalAuthClass.prototype.isRefreshTokenExpiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Refresh Token has expired";
    };
    InternalAuthClass.prototype.isPasswordResetRequiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Password reset required for the user";
    };
    InternalAuthClass.prototype.isSignedInHostedUI = function() {
        return this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
    };
    InternalAuthClass.prototype.isSessionInvalid = function(err) {
        return this.isUserDisabledError(err) || this.isUserDoesNotExistError(err) || this.isTokenRevokedError(err) || this.isRefreshTokenRevokedError(err) || this.isRefreshTokenExpiredError(err) || this.isPasswordResetRequiredError(err);
    };
    InternalAuthClass.prototype.cleanUpInvalidSession = function(user) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_7;
            var _this = this;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user.signOut();
                        this.user = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 2:
                        _a.sent(); // clean aws credentials
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_7 = _a.sent();
                        $19ad19b4d46b0179$var$logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (this.isSignedInHostedUI()) return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                _this.oAuthSignOutRedirect(res, rej);
                            })
                        ];
                        else $19ad19b4d46b0179$var$dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} params - options for getting the current user
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ InternalAuthClass.prototype.currentUserPoolUser = function(params, customUserAgentDetails) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        return new Promise(function(res, rej) {
            _this._storageSync.then(function() {
                return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var user, session, bypassCache, clientMetadata, _a, scope, err_1;
                    var _this = this;
                    return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                if (!this.isOAuthInProgress()) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                $19ad19b4d46b0179$var$logger.debug("OAuth signIn in progress, waiting for resolution...");
                                return [
                                    4 /*yield*/ ,
                                    new Promise(function(res) {
                                        var timeoutId = setTimeout(function() {
                                            $19ad19b4d46b0179$var$logger.debug("OAuth signIn in progress timeout");
                                            (0, $1a908fb961b3fa6b$exports.Hub).remove("auth", hostedUISignCallback);
                                            res();
                                        }, $19ad19b4d46b0179$var$OAUTH_FLOW_MS_TIMEOUT);
                                        (0, $1a908fb961b3fa6b$exports.Hub).listen("auth", hostedUISignCallback);
                                        function hostedUISignCallback(_a) {
                                            var payload = _a.payload;
                                            var event = payload.event;
                                            if (event === "cognitoHostedUI" || event === "cognitoHostedUI_failure") {
                                                $19ad19b4d46b0179$var$logger.debug("OAuth signIn resolved: " + event);
                                                clearTimeout(timeoutId);
                                                (0, $1a908fb961b3fa6b$exports.Hub).remove("auth", hostedUISignCallback);
                                                res();
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _b.sent();
                                _b.label = 2;
                            case 2:
                                user = this.userPool.getCurrentUser();
                                if (!user) {
                                    $19ad19b4d46b0179$var$logger.debug("Failed to get user from user pool");
                                    rej("No current user");
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                _b.label = 3;
                            case 3:
                                _b.trys.push([
                                    3,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this._userSession(user)
                                ];
                            case 4:
                                session = _b.sent();
                                bypassCache = params ? params.bypassCache : false;
                                if (!bypassCache) return [
                                    3 /*break*/ ,
                                    6
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 5:
                                _b.sent();
                                _b.label = 6;
                            case 6:
                                clientMetadata = this._config.clientMetadata;
                                _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? "" : _a;
                                if (scope.split(" ").includes($19ad19b4d46b0179$var$USER_ADMIN_SCOPE)) user.getUserData(function(err, data) {
                                    return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                        var cleanUpError_5, preferredMFA, attributeList, i, attribute, userAttribute, attributes;
                                        return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    if (!err) return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                    $19ad19b4d46b0179$var$logger.debug("getting user data failed", err);
                                                    if (!this.isSessionInvalid(err)) return [
                                                        3 /*break*/ ,
                                                        5
                                                    ];
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.cleanUpInvalidSession(user)
                                                    ];
                                                case 2:
                                                    _a.sent();
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    cleanUpError_5 = _a.sent();
                                                    rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_5.message));
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 4:
                                                    rej(err);
                                                    return [
                                                        3 /*break*/ ,
                                                        6
                                                    ];
                                                case 5:
                                                    res(user);
                                                    _a.label = 6;
                                                case 6:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 7:
                                                    preferredMFA = data.PreferredMfaSetting || "NOMFA";
                                                    attributeList = [];
                                                    for(i = 0; i < data.UserAttributes.length; i++){
                                                        attribute = {
                                                            Name: data.UserAttributes[i].Name,
                                                            Value: data.UserAttributes[i].Value
                                                        };
                                                        userAttribute = new (0, $38555859a52f4863$export$2e2bcd8739ae039)(attribute);
                                                        attributeList.push(userAttribute);
                                                    }
                                                    attributes = this.attributesToObject(attributeList);
                                                    Object.assign(user, {
                                                        attributes: attributes,
                                                        preferredMFA: preferredMFA
                                                    });
                                                    return [
                                                        2 /*return*/ ,
                                                        res(user)
                                                    ];
                                            }
                                        });
                                    });
                                }, {
                                    bypassCache: bypassCache,
                                    clientMetadata: clientMetadata
                                });
                                else {
                                    $19ad19b4d46b0179$var$logger.debug("Unable to get the user data because the " + $19ad19b4d46b0179$var$USER_ADMIN_SCOPE + " " + "is not in the scopes of the access token");
                                    return [
                                        2 /*return*/ ,
                                        res(user)
                                    ];
                                }
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                err_1 = _b.sent();
                                rej(err_1);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(e) {
                $19ad19b4d46b0179$var$logger.debug("Failed to sync cache info into memory", e);
                return rej(e);
            });
        });
    };
    InternalAuthClass.prototype.isOAuthInProgress = function() {
        return this.oAuthFlowInProgress;
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ InternalAuthClass.prototype.currentAuthenticatedUser = function(params, customUserAgentDetails) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var federatedUser, e_8, federatedInfo, user, e_9;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $19ad19b4d46b0179$var$logger.debug("getting current authenticated user");
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_8 = _a.sent();
                        $19ad19b4d46b0179$var$logger.debug("Failed to sync cache info into memory", e_8);
                        throw e_8;
                    case 4:
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                            if (federatedInfo) federatedUser = (0, $9a4e52c79a7a812d$export$18ce0697a983be9b)((0, $9a4e52c79a7a812d$export$18ce0697a983be9b)({}, federatedInfo.user), {
                                token: federatedInfo.token
                            });
                        } catch (e) {
                            $19ad19b4d46b0179$var$logger.debug("cannot load federated user from auth storage");
                        }
                        if (!federatedUser) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.user = federatedUser;
                        $19ad19b4d46b0179$var$logger.debug("get current authenticated federated user", this.user);
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                    case 5:
                        $19ad19b4d46b0179$var$logger.debug("get current authenticated userpool user");
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser(params)
                        ];
                    case 7:
                        user = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        e_9 = _a.sent();
                        if (e_9 === "No userPool") $19ad19b4d46b0179$var$logger.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
                        $19ad19b4d46b0179$var$logger.debug("The user is not authenticated by the error", e_9);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 9:
                        this.user = user;
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves to session object if success
     */ InternalAuthClass.prototype.currentSession = function(customUserAgentDetails) {
        var that = this;
        $19ad19b4d46b0179$var$logger.debug("Getting current session");
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) return Promise.reject(new Error("No User Pool in the configuration."));
        return new Promise(function(res, rej) {
            that.currentUserPoolUser().then(function(user) {
                that.userSession(user).then(function(session) {
                    res(session);
                    return;
                }).catch(function(e) {
                    $19ad19b4d46b0179$var$logger.debug("Failed to get the current session", e);
                    rej(e);
                    return;
                });
            }).catch(function(e) {
                $19ad19b4d46b0179$var$logger.debug("Failed to get the current user", e);
                rej(e);
                return;
            });
        });
    };
    InternalAuthClass.prototype._userSession = function(user) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var clientMetadata, userSession;
            var _this = this;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!user) {
                            $19ad19b4d46b0179$var$logger.debug("the user is null");
                            return [
                                2 /*return*/ ,
                                this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).NoUserSession)
                            ];
                        }
                        clientMetadata = this._config.clientMetadata;
                        // Debouncing the concurrent userSession calls by caching the promise.
                        // This solution assumes users will always call this function with the same CognitoUser instance.
                        if (this.inflightSessionPromiseCounter === 0) this.inflightSessionPromise = new Promise(function(res, rej) {
                            user.getSession(function(err, session) {
                                return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                    var cleanUpError_6;
                                    return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!err) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                $19ad19b4d46b0179$var$logger.debug("Failed to get the session from user", user);
                                                if (!this.isSessionInvalid(err)) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.cleanUpInvalidSession(user)
                                                ];
                                            case 2:
                                                _a.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                            case 3:
                                                cleanUpError_6 = _a.sent();
                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_6.message));
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 4:
                                                rej(err);
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 5:
                                                $19ad19b4d46b0179$var$logger.debug("Succeed to get the user session", session);
                                                res(session);
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, {
                                clientMetadata: clientMetadata
                            });
                        });
                        this.inflightSessionPromiseCounter++;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.inflightSessionPromise
                        ];
                    case 2:
                        userSession = _a.sent();
                        // Set private member. Avoid user.setSignInUserSession() to prevent excessive localstorage refresh.
                        // @ts-ignore
                        user.signInUserSession = userSession;
                        return [
                            2 /*return*/ ,
                            userSession
                        ];
                    case 3:
                        this.inflightSessionPromiseCounter--;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves to the session
     */ InternalAuthClass.prototype.userSession = function(user, customUserAgentDetails) {
        return this._userSession(user);
    };
    /**
     * Get authenticated credentials of current user.
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves to be current user's credentials
     */ InternalAuthClass.prototype.currentUserCredentials = function(customUserAgentDetails) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_10, federatedInfo;
            var _this = this;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $19ad19b4d46b0179$var$logger.debug("Getting current user credentials");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_10 = _a.sent();
                        $19ad19b4d46b0179$var$logger.debug("Failed to sync cache info into memory", e_10);
                        throw e_10;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                        } catch (e) {
                            $19ad19b4d46b0179$var$logger.debug("failed to get or parse item aws-amplify-federatedInfo", e);
                        }
                        if (federatedInfo) // refresh the jwt token here if necessary
                        return [
                            2 /*return*/ ,
                            this.Credentials.refreshFederatedToken(federatedInfo)
                        ];
                        else return [
                            2 /*return*/ ,
                            this.currentSession().then(function(session) {
                                $19ad19b4d46b0179$var$logger.debug("getting session success", session);
                                return _this.Credentials.set(session, "session");
                            }).catch(function() {
                                $19ad19b4d46b0179$var$logger.debug("getting guest credentials");
                                return _this.Credentials.set(null, "guest");
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    InternalAuthClass.prototype.currentCredentials = function(customUserAgentDetails) {
        $19ad19b4d46b0179$var$logger.debug("getting current credentials");
        return this.Credentials.get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ InternalAuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata, customUserAgentDetails) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function(success) {
                    return resolve(success);
                },
                onFailure: function(err) {
                    return reject(err);
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves to callback data if success
     */ InternalAuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code, customUserAgentDetails) {
        if (!code) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyCode);
        return new Promise(function(resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function(data) {
                    resolve(data);
                    return;
                },
                onFailure: function(err) {
                    reject(err);
                    return;
                }
            });
        });
    };
    InternalAuthClass.prototype.verifyCurrentUserAttribute = function(attr, customUserAgentDetails) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttribute(user, attr);
        });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves to callback data if success
     */ InternalAuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code, customUserAgentDetails) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttributeSubmit(user, attr, code);
        });
    };
    InternalAuthClass.prototype.cognitoIdentitySignOut = function(opts, user) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_11, isSignedInHostedUI;
            var _this = this;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_11 = _a.sent();
                        $19ad19b4d46b0179$var$logger.debug("Failed to sync cache info into memory", e_11);
                        throw e_11;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                if (opts && opts.global) {
                                    $19ad19b4d46b0179$var$logger.debug("user global sign out", user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
                                    user.getSession(function(err, result) {
                                        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                            var cleanUpError_7;
                                            var _this = this;
                                            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        $19ad19b4d46b0179$var$logger.debug("failed to get the user session", err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_7 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_7.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        user.globalSignOut({
                                                            onSuccess: function(data) {
                                                                $19ad19b4d46b0179$var$logger.debug("global sign out success");
                                                                if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                else return res();
                                                            },
                                                            onFailure: function(err) {
                                                                $19ad19b4d46b0179$var$logger.debug("global sign out failed", err);
                                                                return rej(err);
                                                            }
                                                        });
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        clientMetadata: clientMetadata
                                    });
                                } else {
                                    $19ad19b4d46b0179$var$logger.debug("user sign out", user);
                                    user.signOut(function() {
                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                        else return res();
                                    });
                                }
                            })
                        ];
                }
            });
        });
    };
    InternalAuthClass.prototype.oAuthSignOutRedirect = function(resolve, reject) {
        var isBrowser = (0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser;
        if (isBrowser) this.oAuthSignOutRedirectOrReject(reject);
        else this.oAuthSignOutAndResolve(resolve);
    };
    InternalAuthClass.prototype.oAuthSignOutAndResolve = function(resolve) {
        this._oAuthHandler.signOut();
        resolve();
    };
    InternalAuthClass.prototype.oAuthSignOutRedirectOrReject = function(reject) {
        this._oAuthHandler.signOut(); // this method redirects url
        // App should be redirected to another url otherwise it will reject
        setTimeout(function() {
            return reject(Error("Signout timeout fail"));
        }, 3000);
    };
    /**
     * Sign out method
     * @param {SignOutOpts} opts - options for sign out
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolved if success
     */ InternalAuthClass.prototype.signOut = function(opts, customUserAgentDetails) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_12, user;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_12 = _a.sent();
                        $19ad19b4d46b0179$var$logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        if (!this.userPool) return [
                            3 /*break*/ ,
                            7
                        ];
                        user = this.userPool.getCurrentUser();
                        if (!user) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cognitoIdentitySignOut(opts, user)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        $19ad19b4d46b0179$var$logger.debug("no current Cognito user");
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        $19ad19b4d46b0179$var$logger.debug("no Cognito User pool");
                        _a.label = 8;
                    case 8:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */ $19ad19b4d46b0179$var$dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        this.user = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    InternalAuthClass.prototype.cleanCachedItems = function() {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // clear cognito cached item
                        return [
                            4 /*yield*/ ,
                            this.Credentials.clear()
                        ];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @param {ClientMetaData} clientMetadata - optional client metadata, defaults to config
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves if success
     */ InternalAuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata, customUserAgentDetails) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.changePassword(oldPassword, newPassword, function(err, data) {
                    if (err) {
                        $19ad19b4d46b0179$var$logger.debug("change password failure", err);
                        return reject(err);
                    } else return resolve(data);
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @param {ClientMetaData} clientMetadata - optional client metadata, defaults to config
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise resolves if success
     */ InternalAuthClass.prototype.forgotPassword = function(username, clientMetadata, customUserAgentDetails) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.forgotPassword({
                onSuccess: function() {
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $19ad19b4d46b0179$var$logger.debug("forgot password failure", err);
                    $19ad19b4d46b0179$var$dispatchAuthEvent("forgotPassword_failure", err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function(data) {
                    $19ad19b4d46b0179$var$dispatchAuthEvent("forgotPassword", user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @param {ClientMetaData} clientMetadata - optional client metadata, defaults to config
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return - A promise that resolves if success
     */ InternalAuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata, customUserAgentDetails) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyCode);
        if (!password) return this.rejectAuthError((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).EmptyPassword);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function(success) {
                    $19ad19b4d46b0179$var$dispatchAuthEvent("forgotPasswordSubmit", user, username + " forgotPasswordSubmit successful");
                    resolve(success);
                    return;
                },
                onFailure: function(err) {
                    $19ad19b4d46b0179$var$dispatchAuthEvent("forgotPasswordSubmit_failure", err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @param {CustomUserAgentDetails} customUserAgentDetails - Optional parameter to send user agent details
     * @return {Object }- current User's information
     */ InternalAuthClass.prototype.currentUserInfo = function(customUserAgentDetails) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var source, user, attributes, userAttrs, credentials, e_13, info, err_2, user;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        source = this.Credentials.getCredSource();
                        if (!(!source || source === "aws" || source === "userPool")) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser().catch(function(err) {
                                return $19ad19b4d46b0179$var$logger.error(err);
                            })
                        ];
                    case 1:
                        user = _a.sent();
                        if (!user) return [
                            2 /*return*/ ,
                            null
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.userAttributes(user)
                        ];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentCredentials()
                        ];
                    case 5:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_13 = _a.sent();
                        $19ad19b4d46b0179$var$logger.debug("Failed to retrieve credentials while getting current user info", e_13);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs
                        };
                        return [
                            2 /*return*/ ,
                            info
                        ];
                    case 8:
                        err_2 = _a.sent();
                        $19ad19b4d46b0179$var$logger.error("currentUserInfo error", err_2);
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                    case 9:
                        if (source === "federated") {
                            user = this.user;
                            return [
                                2 /*return*/ ,
                                user ? user : {}
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    InternalAuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user, customUserAgentDetails) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === "undefined") {
                            if (this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                        }
                        if (!((0, $d71e9f4e74f3bfef$export$9b905d6895bdc426)(providerOrOptions) || (0, $d71e9f4e74f3bfef$export$828f8efbdf71714b)(providerOrOptions) || (0, $d71e9f4e74f3bfef$export$6bae5520ca265d22)(providerOrOptions) || typeof providerOrOptions === "undefined")) return [
                            3 /*break*/ ,
                            1
                        ];
                        options = providerOrOptions || {
                            provider: (0, $d71e9f4e74f3bfef$export$eeb013770cb92342).Cognito
                        };
                        provider = (0, $d71e9f4e74f3bfef$export$9b905d6895bdc426)(options) ? options.provider : options.customProvider;
                        customState = (0, $d71e9f4e74f3bfef$export$9b905d6895bdc426)(options) ? options.customState : options.customState;
                        if (this._config.userPoolId) {
                            client_id = (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                            redirect_uri = (0, $d71e9f4e74f3bfef$export$b380f8ec78ef17c8)(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user);
                            if (loggedInUser) $19ad19b4d46b0179$var$logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n																	You should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        } catch (e) {}
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set({
                                provider: provider,
                                token: token,
                                identity_id: identity_id,
                                user: user,
                                expires_at: expires_at
                            }, "federation")
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _a.sent();
                        $19ad19b4d46b0179$var$dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.username + " has been signed in");
                        $19ad19b4d46b0179$var$logger.debug("federated sign in credentials", credentials);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */ InternalAuthClass.prototype._handleAuthResponse = function(URL) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_3;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.oAuthFlowInProgress) {
                            $19ad19b4d46b0179$var$logger.debug("Skipping URL " + URL + " current flow in progress");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            8,
                            9
                        ]);
                        this.oAuthFlowInProgress = true;
                        if (!this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                        $19ad19b4d46b0179$var$dispatchAuthEvent("parsingCallbackUrl", {
                            url: URL
                        }, "The callback url is being parsed");
                        currentUrl = URL || ((0, $28ca6f9027b485a7$export$a2708fdb45cd35f)().isBrowser ? window.location.href : "");
                        hasCodeOrError = !!((0, $8be3844318649839$export$98e6a39c04603d36)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var _b = (0, $9a4e52c79a7a812d$export$8d051b38c9118094)(_a, 1), k = _b[0];
                            return k === "code" || k === "error";
                        });
                        hasTokenOrError = !!((0, $8be3844318649839$export$98e6a39c04603d36)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var _b = (0, $9a4e52c79a7a812d$export$8d051b38c9118094)(_a, 1), k = _b[0];
                            return k === "access_token" || k === "error";
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this._storage.setItem("amplify-redirected-from-hosted-ui", "true");
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._oAuthHandler.handleAuthResponse(currentUrl)
                        ];
                    case 3:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new (0, $82508fd376aeac3c$export$2e2bcd8739ae039)({
                            IdToken: new (0, $8eb7209a41983bfc$export$2e2bcd8739ae039)({
                                IdToken: idToken
                            }),
                            RefreshToken: new (0, $c59d7f07074bc9f5$export$2e2bcd8739ae039)({
                                RefreshToken: refreshToken
                            }),
                            AccessToken: new (0, $8281217ccf88c1bf$export$2e2bcd8739ae039)({
                                AccessToken: accessToken
                            })
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set(session, "session")
                        ];
                    case 4:
                        credentials = _b.sent();
                        $19ad19b4d46b0179$var$logger.debug("AWS credentials", credentials);
                        _b.label = 5;
                    case 5:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()["cognito:username"]);
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        if (window && typeof window.history !== "undefined") window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $19ad19b4d46b0179$var$dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        $19ad19b4d46b0179$var$dispatchAuthEvent("cognitoHostedUI", currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state.split("-").splice(1).join("-");
                            $19ad19b4d46b0179$var$dispatchAuthEvent("customOAuthState", (0, $571068c73bf08655$export$a7ea17e93539f9a5)(customState), "State for user " + currentUser.getUsername());
                        }
                        //#endregion
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 6:
                        err_3 = _b.sent();
                        $19ad19b4d46b0179$var$logger.debug("Error in cognito hosted auth response", err_3);
                        // Just like a successful handling of `?code`, replace the window history to "dispose" of the `code`.
                        // Otherwise, reloading the page will throw errors as the `code` has already been spent.
                        if (window && typeof window.history !== "undefined") window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $19ad19b4d46b0179$var$dispatchAuthEvent("signIn_failure", err_3, "The OAuth response flow failed");
                        $19ad19b4d46b0179$var$dispatchAuthEvent("cognitoHostedUI_failure", err_3, "A failure occurred when returning to the Cognito Hosted UI");
                        $19ad19b4d46b0179$var$dispatchAuthEvent("customState_failure", err_3, "A failure occurred when returning state");
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        this.oAuthFlowInProgress = false;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ InternalAuthClass.prototype.essentialCredentials = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    InternalAuthClass.prototype.attributesToObject = function(attributes) {
        var _this = this;
        var obj = {};
        if (attributes) attributes.map(function(attribute) {
            if (attribute.Name === "email_verified" || attribute.Name === "phone_number_verified") obj[attribute.Name] = _this.isTruthyString(attribute.Value) || attribute.Value === true;
            else obj[attribute.Name] = attribute.Value;
        });
        return obj;
    };
    InternalAuthClass.prototype.isTruthyString = function(value) {
        return typeof value.toLowerCase === "function" && value.toLowerCase() === "true";
    };
    InternalAuthClass.prototype.createCognitoUser = function(username) {
        var userData = {
            Username: username,
            Pool: this.userPool
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new (0, $737214f2f07cda56$export$2e2bcd8739ae039)(userData);
        if (authenticationFlowType) user.setAuthenticationFlowType(authenticationFlowType);
        return user;
    };
    InternalAuthClass.prototype._isValidAuthStorage = function(obj) {
        // We need to check if the obj has the functions of Storage
        return !!obj && typeof obj.getItem === "function" && typeof obj.setItem === "function" && typeof obj.removeItem === "function" && typeof obj.clear === "function";
    };
    InternalAuthClass.prototype.noUserPoolErrorHandler = function(config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) return (0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).MissingAuthConfig;
        }
        return (0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).NoConfig;
    };
    InternalAuthClass.prototype.rejectAuthError = function(type) {
        return Promise.reject(new (0, $dab9793fb28d116e$export$145273558d58e0ac)(type));
    };
    InternalAuthClass.prototype.rejectNoUserPool = function() {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new (0, $dab9793fb28d116e$export$71192787e041818c)(type));
    };
    InternalAuthClass.prototype.rememberDevice = function(customUserAgentDetails) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var currUser, error_2;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_2 = _a.sent();
                        $19ad19b4d46b0179$var$logger.debug("The user is not authenticated by the error", error_2);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.setDeviceStatusRemembered({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, $dab9793fb28d116e$export$145273558d58e0ac)((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, $dab9793fb28d116e$export$145273558d58e0ac)((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    InternalAuthClass.prototype.forgetDevice = function(customUserAgentDetails) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var currUser, error_3;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        $19ad19b4d46b0179$var$logger.debug("The user is not authenticated by the error", error_3);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.forgetDevice({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, $dab9793fb28d116e$export$145273558d58e0ac)((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, $dab9793fb28d116e$export$145273558d58e0ac)((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    InternalAuthClass.prototype.fetchDevices = function(customUserAgentDetails) {
        return (0, $9a4e52c79a7a812d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var currUser, error_4;
            return (0, $9a4e52c79a7a812d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_4 = _a.sent();
                        $19ad19b4d46b0179$var$logger.debug("The user is not authenticated by the error", error_4);
                        throw new Error("The user is not authenticated");
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                var cb = {
                                    onSuccess: function(data) {
                                        var deviceList = data.Devices.map(function(device) {
                                            var deviceName = device.DeviceAttributes.find(function(_a) {
                                                var Name = _a.Name;
                                                return Name === "device_name";
                                            }) || {};
                                            var deviceInfo = {
                                                id: device.DeviceKey,
                                                name: deviceName.Value
                                            };
                                            return deviceInfo;
                                        });
                                        res(deviceList);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, $dab9793fb28d116e$export$145273558d58e0ac)((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, $dab9793fb28d116e$export$145273558d58e0ac)((0, $d71e9f4e74f3bfef$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                };
                                currUser.listDevices($19ad19b4d46b0179$var$MAX_DEVICES, null, cb);
                            })
                        ];
                }
            });
        });
    };
    return InternalAuthClass;
}();
var $19ad19b4d46b0179$export$f22c1cd168339a3d = new $19ad19b4d46b0179$export$a660349e9f03ecf6(null);
(0, $36606c730099e1c8$exports.Amplify).register($19ad19b4d46b0179$export$f22c1cd168339a3d);


/**
 * Provide authentication steps
 */ var $cc420cb14b670b2a$export$eeff9d1a8b8c057b = /** @class */ function(_super) {
    (0, $9a4e52c79a7a812d$export$a8ba968b8961cb8a)(AuthClass, _super);
    function AuthClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthClass.prototype.getModuleName = function() {
        return "Auth";
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.signUp = function(params) {
        var restOfAttrs = [];
        for(var _i = 1; _i < arguments.length; _i++)restOfAttrs[_i - 1] = arguments[_i];
        return _super.prototype.signUp.call(this, params, restOfAttrs);
    };
    /**
     * Send the verification code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.confirmSignUp = function(username, code, options) {
        return _super.prototype.confirmSignUp.call(this, username, code, options);
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */ AuthClass.prototype.resendSignUp = function(username, clientMetadata) {
        return _super.prototype.resendSignUp.call(this, username, clientMetadata);
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} pw - The password of the username
     * @param {ClientMetaData} clientMetadata - Client metadata for custom workflows
     * @return - A promise resolves the CognitoUser
     */ AuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
        return _super.prototype.signIn.call(this, usernameOrSignInOpts, pw, clientMetadata);
    };
    /**
     * This was previously used by an authenticated user to get MFAOptions,
     * but no longer returns a meaningful response. Refer to the documentation for
     * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */ AuthClass.prototype.getMFAOptions = function(user) {
        return _super.prototype.getMFAOptions.call(this, user);
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */ AuthClass.prototype.getPreferredMFA = function(user, params) {
        return _super.prototype.getPreferredMFA.call(this, user, params);
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */ AuthClass.prototype.setPreferredMFA = function(user, mfaMethod) {
        return _super.prototype.setPreferredMFA.call(this, user, mfaMethod);
    };
    /**
     * disable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.disableSMS = function(user) {
        return _super.prototype.disableSMS.call(this, user);
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.enableSMS = function(user) {
        return _super.prototype.enableSMS.call(this, user);
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */ AuthClass.prototype.setupTOTP = function(user) {
        return _super.prototype.setupTOTP.call(this, user);
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */ AuthClass.prototype.verifyTotpToken = function(user, challengeAnswer) {
        return _super.prototype.verifyTotpToken.call(this, user, challengeAnswer);
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */ AuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
        return _super.prototype.confirmSignIn.call(this, user, code, mfaType, clientMetadata);
    };
    AuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
        if (requiredAttributes === void 0) requiredAttributes = {};
        return _super.prototype.completeNewPassword.call(this, user, password, requiredAttributes, clientMetadata);
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */ AuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
        return _super.prototype.sendCustomChallengeAnswer.call(this, user, challengeResponses, clientMetadata);
    };
    /**
     * Delete an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.deleteUserAttributes = function(user, attributeNames) {
        return _super.prototype.deleteUserAttributes.call(this, user, attributeNames);
    };
    /**
     * Delete the current authenticated user
     * @return {Promise}
     **/ // TODO: Check return type void
    AuthClass.prototype.deleteUser = function() {
        return _super.prototype.deleteUser.call(this);
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
        return _super.prototype.updateUserAttributes.call(this, user, attributes, clientMetadata);
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */ AuthClass.prototype.userAttributes = function(user) {
        return _super.prototype.userAttributes.call(this, user);
    };
    AuthClass.prototype.verifiedContact = function(user) {
        return _super.prototype.verifiedContact.call(this, user);
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentUserPoolUser = function(params) {
        return _super.prototype.currentUserPoolUser.call(this, params);
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentAuthenticatedUser = function(params) {
        return _super.prototype.currentAuthenticatedUser.call(this, params);
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */ AuthClass.prototype.currentSession = function() {
        return _super.prototype.currentSession.call(this);
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */ AuthClass.prototype.userSession = function(user) {
        return _super.prototype.userSession.call(this, user);
    };
    /**
     * Get authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */ AuthClass.prototype.currentUserCredentials = function() {
        return _super.prototype.currentUserCredentials.call(this);
    };
    AuthClass.prototype.currentCredentials = function() {
        return _super.prototype.currentCredentials.call(this);
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
        return _super.prototype.verifyUserAttribute.call(this, user, attr, clientMetadata);
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
        return _super.prototype.verifyUserAttributeSubmit.call(this, user, attr, code);
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function(attr) {
        return _super.prototype.verifyCurrentUserAttribute.call(this, attr);
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
        return _super.prototype.verifyCurrentUserAttributeSubmit.call(this, attr, code);
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */ AuthClass.prototype.signOut = function(opts) {
        return _super.prototype.signOut.call(this, opts);
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */ AuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
        return _super.prototype.changePassword.call(this, user, oldPassword, newPassword, clientMetadata);
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */ AuthClass.prototype.forgotPassword = function(username, clientMetadata) {
        return _super.prototype.forgotPassword.call(this, username, clientMetadata);
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */ AuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
        return _super.prototype.forgotPasswordSubmit.call(this, username, code, password, clientMetadata);
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */ AuthClass.prototype.currentUserInfo = function() {
        return _super.prototype.currentUserInfo.call(this);
    };
    AuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user) {
        return _super.prototype.federatedSignIn.call(this, providerOrOptions, response, user);
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ AuthClass.prototype.essentialCredentials = function(credentials) {
        return _super.prototype.essentialCredentials.call(this, credentials);
    };
    AuthClass.prototype.rememberDevice = function() {
        return _super.prototype.rememberDevice.call(this);
    };
    AuthClass.prototype.forgetDevice = function() {
        return _super.prototype.forgetDevice.call(this);
    };
    AuthClass.prototype.fetchDevices = function() {
        return _super.prototype.fetchDevices.call(this);
    };
    return AuthClass;
}((0, $19ad19b4d46b0179$export$a660349e9f03ecf6));
var $cc420cb14b670b2a$export$334c29725a78c21d = new $cc420cb14b670b2a$export$eeff9d1a8b8c057b(null);
(0, $36606c730099e1c8$exports.Amplify).register($cc420cb14b670b2a$export$334c29725a78c21d);





var /**
 * @deprecated use named import
 */ $ebb48d86fd8997a4$export$2e2bcd8739ae039 = (0, $cc420cb14b670b2a$export$334c29725a78c21d);


const $15a7c5986a3f06c2$export$fa356a32a7b5bee2 = (t)=>{
    var n;
    const r = Object.assign({
        default: void 0
    }, t);
    return null !== (n = r.default) && void 0 !== n ? n : r;
};
function $15a7c5986a3f06c2$export$a6cdc56e425d0d0a(t) {
    return null != t && !Array.isArray(t) && "object" == typeof t;
}
function $15a7c5986a3f06c2$export$844ec244b1367d54(t) {
    return "string" == typeof t || "object" == typeof t && "[object String]" === Object.prototype.toString.call(t);
}
function $15a7c5986a3f06c2$export$5c90113a285f2241(t) {
    return $15a7c5986a3f06c2$export$a6cdc56e425d0d0a(t) && "[object Map]" === Object.prototype.toString.call(t);
}
function $15a7c5986a3f06c2$export$6750766a7c7ec627(t) {
    return $15a7c5986a3f06c2$export$a6cdc56e425d0d0a(t) && "[object Set]" === Object.prototype.toString.call(t);
}
function $15a7c5986a3f06c2$export$fce6876652108ab(t) {
    return void 0 === t;
}
function $15a7c5986a3f06c2$export$984f70f9382f5d27(t) {
    return null == t;
}
function $15a7c5986a3f06c2$export$dd1bc94b04021eeb(t) {
    if (null == t) return !0;
    if ($15a7c5986a3f06c2$export$a6cdc56e425d0d0a(t) && ($15a7c5986a3f06c2$export$5c90113a285f2241(t) || $15a7c5986a3f06c2$export$6750766a7c7ec627(t))) return !t.size;
    if ($15a7c5986a3f06c2$export$a6cdc56e425d0d0a(t) && ($15a7c5986a3f06c2$export$844ec244b1367d54(t) || Array.isArray(t))) return !t.length;
    for(const n in t)if ($15a7c5986a3f06c2$export$a4f4bb6b1453fff5(t, n)) return !1;
    return !0;
}
function $15a7c5986a3f06c2$var$f(t) {
    return Array.isArray(t) && $15a7c5986a3f06c2$export$dd1bc94b04021eeb(t);
}
function $15a7c5986a3f06c2$export$2c02be4a78959098(...t) {
    return t.every($15a7c5986a3f06c2$var$f);
}
function $15a7c5986a3f06c2$var$a(t) {
    return $15a7c5986a3f06c2$export$a6cdc56e425d0d0a(t) && $15a7c5986a3f06c2$export$dd1bc94b04021eeb(t);
}
function $15a7c5986a3f06c2$export$d6708a3543c32fe4(...t) {
    return t.every($15a7c5986a3f06c2$var$a);
}
function $15a7c5986a3f06c2$export$9a00dee1beb8f576(t) {
    return $15a7c5986a3f06c2$export$844ec244b1367d54(t) ? t.charAt(0).toUpperCase() + t.slice(1) : "";
}
function $15a7c5986a3f06c2$export$a4f4bb6b1453fff5(t, n) {
    return null != t && Object.prototype.hasOwnProperty.call(t, n);
}
function $15a7c5986a3f06c2$export$f6e2535fb5126e54(t) {
    return "function" == typeof t;
}
const $15a7c5986a3f06c2$export$1d6fb99b5e148be8 = (t, n)=>n ? `${t}--${n}` : "", $15a7c5986a3f06c2$export$3c152e7b97c7496c = (t, n, r)=>r ? `${t}--${n}` : "";
function $15a7c5986a3f06c2$export$669248cdfeac1c30(t) {
    return $15a7c5986a3f06c2$export$f6e2535fb5126e54(t);
}
function $15a7c5986a3f06c2$export$41f379f522580228(t, n) {
    return t.reduce((t, e)=>`${t}${$15a7c5986a3f06c2$export$844ec244b1367d54(e) ? n(e) : ""}`, "");
}
function $15a7c5986a3f06c2$export$8793edee2d425525(...t) {}


const $192735b175258082$export$43a753047a354e27 = [
    "birthdate",
    "email",
    "family_name",
    "given_name",
    "middle_name",
    "name",
    "nickname",
    "phone_number",
    "preferred_username",
    "profile",
    "website"
], $192735b175258082$export$a263a0ca54f86170 = [
    "address",
    "gender",
    "locale",
    "picture",
    "updated_at",
    "zoneinfo"
], $192735b175258082$export$c3f13f1789f7946b = [
    "username",
    "email",
    "phone_number"
], $192735b175258082$export$ee5f111526f572af = [
    ...$192735b175258082$export$c3f13f1789f7946b,
    ...$192735b175258082$export$43a753047a354e27,
    "confirmation_code",
    "password",
    "confirm_password"
], $192735b175258082$export$fed672849e2dd0ad = (e)=>$192735b175258082$export$ee5f111526f572af.includes(e);




const $f077a85279c81c4a$export$a51e8cda1526c737 = [
    "+1",
    "+7",
    "+20",
    "+27",
    "+30",
    "+31",
    "+32",
    "+33",
    "+34",
    "+36",
    "+39",
    "+40",
    "+41",
    "+43",
    "+44",
    "+45",
    "+46",
    "+47",
    "+48",
    "+49",
    "+51",
    "+52",
    "+53",
    "+54",
    "+55",
    "+56",
    "+57",
    "+58",
    "+60",
    "+61",
    "+62",
    "+63",
    "+64",
    "+65",
    "+66",
    "+81",
    "+82",
    "+84",
    "+86",
    "+90",
    "+91",
    "+92",
    "+93",
    "+94",
    "+95",
    "+98",
    "+212",
    "+213",
    "+216",
    "+218",
    "+220",
    "+221",
    "+222",
    "+223",
    "+224",
    "+225",
    "+226",
    "+227",
    "+228",
    "+229",
    "+230",
    "+231",
    "+232",
    "+233",
    "+234",
    "+235",
    "+236",
    "+237",
    "+238",
    "+239",
    "+240",
    "+241",
    "+242",
    "+243",
    "+244",
    "+245",
    "+246",
    "+248",
    "+249",
    "+250",
    "+251",
    "+252",
    "+253",
    "+254",
    "+255",
    "+256",
    "+257",
    "+258",
    "+260",
    "+261",
    "+262",
    "+263",
    "+264",
    "+265",
    "+266",
    "+267",
    "+268",
    "+269",
    "+290",
    "+291",
    "+297",
    "+298",
    "+299",
    "+345",
    "+350",
    "+351",
    "+352",
    "+353",
    "+354",
    "+355",
    "+356",
    "+357",
    "+358",
    "+359",
    "+370",
    "+371",
    "+372",
    "+373",
    "+374",
    "+375",
    "+376",
    "+377",
    "+378",
    "+379",
    "+380",
    "+381",
    "+382",
    "+385",
    "+386",
    "+387",
    "+389",
    "+420",
    "+421",
    "+423",
    "+500",
    "+501",
    "+502",
    "+503",
    "+504",
    "+505",
    "+506",
    "+507",
    "+508",
    "+509",
    "+537",
    "+590",
    "+591",
    "+593",
    "+594",
    "+595",
    "+596",
    "+597",
    "+598",
    "+599",
    "+670",
    "+672",
    "+673",
    "+674",
    "+675",
    "+676",
    "+677",
    "+678",
    "+679",
    "+680",
    "+681",
    "+682",
    "+683",
    "+685",
    "+686",
    "+687",
    "+688",
    "+689",
    "+690",
    "+691",
    "+692",
    "+850",
    "+852",
    "+853",
    "+855",
    "+856",
    "+872",
    "+880",
    "+886",
    "+960",
    "+961",
    "+962",
    "+963",
    "+964",
    "+965",
    "+966",
    "+967",
    "+968",
    "+970",
    "+971",
    "+972",
    "+973",
    "+974",
    "+975",
    "+976",
    "+977",
    "+992",
    "+993",
    "+994",
    "+995",
    "+996",
    "+998"
];



const $5c28317e8c66931c$export$1222d357a3c2c47f = {
    birthdate: {
        label: "Birthdate",
        placeholder: "Enter your Birthdate",
        type: "date",
        autocomplete: "bday",
        isRequired: !0
    },
    confirmation_code: {
        label: "Confirmation Code",
        placeholder: "Enter your Confirmation Code",
        type: "number",
        autocomplete: "one-time-code",
        isRequired: !0
    },
    confirm_password: {
        label: "Confirm Password",
        placeholder: "Please confirm your Password",
        type: "password",
        autocomplete: "new-password",
        isRequired: !0
    },
    email: {
        label: "Email",
        placeholder: "Enter your Email",
        type: "email",
        autocomplete: "username",
        isRequired: !0
    },
    family_name: {
        label: "Family Name",
        placeholder: "Enter your Family Name",
        type: "text",
        autocomplete: "family-name",
        isRequired: !0
    },
    given_name: {
        label: "Given Name",
        placeholder: "Enter your Given Name",
        type: "text",
        autocomplete: "given-name",
        isRequired: !0
    },
    middle_name: {
        label: "Middle Name",
        placeholder: "Enter your Middle Name",
        type: "text",
        autocomplete: "additional-name",
        isRequired: !0
    },
    name: {
        label: "Name",
        placeholder: "Enter your Name",
        type: "text",
        autocomplete: "name",
        isRequired: !0
    },
    nickname: {
        label: "Nickname",
        placeholder: "Enter your Nickname",
        type: "text",
        autocomplete: "tel",
        isRequired: !0
    },
    password: {
        label: "Password",
        placeholder: "Enter your Password",
        type: "password",
        autocomplete: "new-password",
        isRequired: !0
    },
    phone_number: {
        label: "Phone Number",
        placeholder: "Enter your Phone Number",
        type: "tel",
        autocomplete: "tel",
        dialCode: "+1",
        dialCodeList: (0, $f077a85279c81c4a$export$a51e8cda1526c737),
        isRequired: !0
    },
    preferred_username: {
        label: "Preferred Username",
        placeholder: "Enter your Preferred Username",
        type: "text",
        isRequired: !0
    },
    profile: {
        label: "Profile",
        placeholder: "Add your Profile",
        type: "url",
        autocomplete: "url",
        isRequired: !0
    },
    website: {
        label: "Website",
        placeholder: "Add your Website",
        type: "url",
        autocomplete: "url",
        isRequired: !0
    },
    username: {
        label: "Username",
        placeholder: "Enter your Username",
        type: "text",
        autocomplete: "username",
        isRequired: !0
    }
}, $5c28317e8c66931c$export$4223938282102ea7 = [
    "^",
    "$",
    "*",
    ".",
    "[",
    "]",
    "{",
    "}",
    "(",
    ")",
    "?",
    '"',
    "!",
    "@",
    "#",
    "%",
    "&",
    "/",
    "\\",
    ",",
    ">",
    "<",
    "'",
    ":",
    ";",
    "|",
    "_",
    "~",
    "`",
    "=",
    "+",
    "-",
    " "
], $5c28317e8c66931c$export$976c37132e9c6a10 = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;







const $34381a1811dc897d$export$65f2c683ca9e9a02 = (t)=>{
    var i;
    const s = null === (i = null == t ? void 0 : t.context.config) || void 0 === i ? void 0 : i.loginMechanisms, [n] = null != s ? s : [
        "username"
    ];
    return n;
}, $34381a1811dc897d$export$961a103988e4c668 = (i)=>{
    var s;
    const n = (null === (s = i.config) || void 0 === s ? void 0 : s.loginMechanisms).filter((i)=>(0, $192735b175258082$export$c3f13f1789f7946b).includes(i)), [o, ...e] = n;
    return {
        primaryAlias: o,
        secondaryAliases: e
    };
};





const $2227b0b05b5cd59e$export$e29bbbec84471f66 = (r)=>{
    const t = new FormData(r.target);
    return Object.fromEntries(t);
}, $2227b0b05b5cd59e$export$b5859dd113079414 = (r, t)=>{
    let e = [];
    return r && (e = Object.keys(r).reduce((t, e)=>{
        var o;
        return t.push([
            e,
            null === (o = r[e]) || void 0 === o ? void 0 : o.order
        ]), t;
    }, []).sort((r, t)=>r[1] - t[1]).filter((r)=>void 0 !== r[1]).map((r)=>r[0])), Array.from(new Set([
        ...e,
        ...t
    ]));
}, $2227b0b05b5cd59e$export$3237178b1c616b9f = (t)=>(0, $192735b175258082$export$ee5f111526f572af).includes(t), $2227b0b05b5cd59e$export$501239432719417d = (r)=>{
    var t;
    return r ? (t = r, Array.isArray(t) ? r : [
        r
    ]) : null;
};


const $ed1bf37d7912eeb0$var$n = (s, r)=>{
    const { country_code: t } = (0, $1b0fbba0bcf650b5$export$c39505fa2700473f)(s);
    let n = (0, $5c28317e8c66931c$export$1222d357a3c2c47f)[r];
    const { type: a } = n;
    return "tel" === a && (n = Object.assign(Object.assign({}, n), {
        dialCode: t
    })), n;
}, $ed1bf37d7912eeb0$export$447e18c20e391f9 = (o)=>{
    const s = (0, $34381a1811dc897d$export$65f2c683ca9e9a02)(o);
    return Object.assign(Object.assign({}, $ed1bf37d7912eeb0$var$n(o, s)), {
        autocomplete: "username"
    });
}, $ed1bf37d7912eeb0$var$c = (o)=>({
        confirmation_code: Object.assign(Object.assign({}, $ed1bf37d7912eeb0$var$n(o, "confirmation_code")), {
            label: "Code *",
            placeholder: "Code"
        })
    }), $ed1bf37d7912eeb0$export$9bcaa03841470ad7 = {
    signIn: (o)=>({
            username: Object.assign({}, $ed1bf37d7912eeb0$export$447e18c20e391f9(o)),
            password: Object.assign(Object.assign({}, $ed1bf37d7912eeb0$var$n(o, "password")), {
                autocomplete: "current-password"
            })
        }),
    signUp: (o)=>{
        const { loginMechanisms: s, signUpAttributes: e } = o.context.config, c = (0, $34381a1811dc897d$export$65f2c683ca9e9a02)(o), i = Array.from(new Set([
            ...s,
            "password",
            "confirm_password",
            ...e
        ])), d = {};
        for (const s of i)if ((0, $2227b0b05b5cd59e$export$3237178b1c616b9f)(s)) {
            const e = s === c ? $ed1bf37d7912eeb0$export$447e18c20e391f9(o) : $ed1bf37d7912eeb0$var$n(o, s);
            d[s] = Object.assign({}, e);
        } else console.debug(`Authenticator does not have a default implementation for ${s}. Customize SignUp FormFields to add your own.`);
        return d;
    },
    confirmSignUp: (o)=>({
            confirmation_code: Object.assign(Object.assign({}, $ed1bf37d7912eeb0$var$n(o, "confirmation_code")), {
                placeholder: "Enter your code"
            })
        }),
    confirmSignIn: $ed1bf37d7912eeb0$var$c,
    forceNewPassword: (o)=>{
        const e = (0, $1b0fbba0bcf650b5$export$99a4282e2c3b772d)(o), { requiredAttributes: r } = e.context, a = Array.from(new Set([
            "password",
            "confirm_password",
            ...r
        ])), c = {};
        for (const s of a)(0, $2227b0b05b5cd59e$export$3237178b1c616b9f)(s) ? c[s] = Object.assign({}, $ed1bf37d7912eeb0$var$n(o, s)) : console.debug(`Authenticator does not have a default implementation for ${s}. Customize ForceNewPassword FormFields to add your own.`);
        return c;
    },
    resetPassword: (o)=>{
        const s = (0, $34381a1811dc897d$export$65f2c683ca9e9a02)(o), { label: t } = (0, $5c28317e8c66931c$export$1222d357a3c2c47f)[s];
        return {
            username: Object.assign(Object.assign({}, $ed1bf37d7912eeb0$export$447e18c20e391f9(o)), {
                label: `Enter your ${t.toLowerCase()}`,
                placeholder: `Enter your ${t.toLowerCase()}`
            })
        };
    },
    confirmResetPassword: (o)=>Object.assign(Object.assign({}, $ed1bf37d7912eeb0$var$c(o)), {
            password: Object.assign(Object.assign({}, $ed1bf37d7912eeb0$var$n(o, "password")), {
                label: "New Password",
                placeholder: "New Password"
            }),
            confirm_password: Object.assign(Object.assign({}, $ed1bf37d7912eeb0$var$n(o, "confirm_password")), {
                label: "Confirm Password",
                placeholder: "Confirm Password"
            })
        }),
    confirmVerifyUser: $ed1bf37d7912eeb0$var$c,
    setupTOTP: $ed1bf37d7912eeb0$var$c
};



const $cec93b89401f2ac4$export$cca4a41bdb910c51 = {
    "Account recovery requires verified contact information": "Zur\xfccksetzen des Account ben\xf6tigt einen verifizierten Account",
    "Back to Sign In": "Zur\xfcck zur Anmeldung",
    "Change Password": "Passwort \xe4ndern",
    Changing: "\xc4ndern von",
    Code: "Code",
    "Confirm Password": "Passwort best\xe4tigen",
    "Please confirm your Password": "Bitte best\xe4tigen Sie Ihr Passwort",
    "Confirm Sign Up": "Registrierung best\xe4tigen",
    "Confirm SMS Code": "SMS-Code best\xe4tigen",
    "Confirm TOTP Code": "TOTP-Code best\xe4tigen",
    Confirm: "Best\xe4tigen",
    "Confirmation Code": "Best\xe4tigungs-Code",
    Confirming: "Wird best\xe4tigt",
    "Create a new account": "Einen neuen Account erstellen",
    "Create Account": "Account erstellen",
    "Creating Account": "Account wird erstellt",
    "Dismiss alert": "Warnung verwerfen",
    Email: "Email",
    "Enter your code": "Geben Sie Ihren Code ein",
    "Enter your Email": "Geben Sie Ihre E-Mail ein",
    "Enter your phone number": "Geben Sie Ihre Telefonnummer ein",
    "Enter your username": "Geben Sie Ihren Benutzernamen ein",
    "Forgot your password?": "Passwort vergessen? ",
    "Hide password": "Passwort verbergen",
    "It may take a minute to arrive": "Es kann eine Minute dauern, bis er ankommt",
    Loading: "Wird geladen",
    "New password": "Neues Passwort",
    or: "oder",
    Password: "Passwort",
    "Phone Number": "Telefonnummer",
    "Resend Code": "Code erneut senden",
    "Reset your Password": "Zur\xfccksetzen des Passwort",
    "Reset your password": "Zur\xfccksetzen des passwort",
    "Send code": "Code senden",
    "Send Code": "Code senden",
    Sending: "Wird gesendet",
    "Setup TOTP": "TOTP einrichten",
    "Show password": "Passwort anzeigen",
    "Sign in to your account": "Melden Sie sich mit Ihrem Account an",
    "Sign In with Amazon": "Mit Amazon anmelden",
    "Sign In with Apple": "Mit Apple anmelden",
    "Sign In with Facebook": "Mit Facebook anmelden",
    "Sign In with Google": "Mit Google anmelden",
    "Sign in": "Anmelden",
    "Sign In": "Anmelden",
    "Signing in": "Wird angemeldet",
    Skip: "\xdcberspringen",
    Submit: "Abschicken",
    Submitting: "Wird gesendet",
    Username: "Benutzername",
    "Verify Contact": "Kontakt verifizieren",
    Verify: "Verifizieren",
    "We Sent A Code": "Wir haben einen Code gesendet",
    "We Texted You": "Wir haben Ihnen eine SMS gesendet",
    "Your code is on the way. To log in, enter the code we sent you": "Ihr Code ist unterwegs. Um sich anzumelden, geben Sie den Code ein, den wir Ihnen gesendet haben",
    "An account with the given email already exists.": "Ein Account mit dieser Email existiert bereits.",
    "Confirm a Code": "Code best\xe4tigen",
    "Confirm Sign In": "Anmeldung best\xe4tigen",
    "Create account": "Hier registrieren",
    "Enter your password": "Geben Sie Ihr Passwort ein",
    "Enter your Password": "Geben Sie Ihr Passwort ein",
    "Sign Up with Facebook": "Mit Facebook registrieren",
    "Sign Up with Google": "Mit Google registrieren",
    "Forgot Password": "Passwort vergessen",
    "Have an account? ": "Schon registriert? ",
    "Incorrect username or password": "Falscher Benutzername oder falsches Passwort",
    "Invalid password format": "Ung\xfcltiges Passwort-Format",
    "Invalid phone number format": "Ung\xfcltiges Telefonummern-Format. Benutze eine Nummer im Format: +12345678900",
    "It may take a minute to arrive.": "Es k\xf6nnte eine Minute dauern, bis der Code eintrifft.",
    "Lost your code? ": "Code verloren? ",
    "New Password": "Neues Passwort",
    "No account? ": "Kein Account? ",
    "Password attempts exceeded": "Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht",
    "Reset password": "Passwort zur\xfccksetzen",
    "Sign Out": "Abmelden",
    "Sign Up": "Registrieren",
    "User already exists": "Dieser Benutzer existiert bereits",
    "User does not exist": "Dieser Benutzer existiert nicht",
    "Username cannot be empty": "Benutzername darf nicht leer sein",
    "We Emailed You": "Email wurde versendet",
    "Your code is on the way. To log in, enter the code we emailed to": "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an",
    "Your code is on the way. To log in, enter the code we texted to": "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an"
};


const $13df23282510920f$export$eb91f595f110d703 = {
    "Account recovery requires verified contact information": "Account recovery requires verified contact information",
    "Add your Profile": "Add your Profile",
    "Add your Website": "Add your Website",
    "Back to Sign In": "Back to Sign In",
    "Change Password": "Change Password",
    Changing: "Changing",
    Code: "Code",
    "Confirm Password": "Confirm Password",
    "Confirm Sign Up": "Confirm Sign Up",
    "Confirm SMS Code": "Confirm SMS Code",
    "Confirm TOTP Code": "Confirm TOTP Code",
    Confirm: "Confirm",
    "Confirmation Code": "Confirmation Code",
    Confirming: "Confirming",
    "Create a new account": "Create a new account",
    "Create Account": "Create Account",
    "Creating Account": "Creating Account",
    "Dismiss alert": "Dismiss alert",
    Email: "Email",
    "Enter your Birthdate": "Enter your Birthdate",
    "Enter your code": "Enter your code",
    "Enter your Confirmation Code": "Enter your Confirmation Code",
    "Enter your Email": "Enter your Email",
    "Enter your Family Name": "Enter your Family Name",
    "Enter your Given Name": "Enter your Given Name",
    "Enter your Middle Name": "Enter your Middle Name",
    "Enter your Name": "Enter your Name",
    "Enter your Nickname": "Enter your Nickname",
    "Enter your Password": "Enter your Password",
    "Enter your phone number": "Enter your phone number",
    "Enter your Preferred Username": "Enter your Preferred Username",
    "Enter your username": "Enter your username",
    "Forgot password?": "Forgot password?",
    "Forgot your password?": "Forgot your password?",
    "Hide password": "Hide password",
    "It may take a minute to arrive": "It may take a minute to arrive",
    Loading: "Loading",
    "New password": "New password",
    or: "or",
    Password: "Password",
    "Phone Number": "Phone Number",
    "Please confirm your Password": "Please confirm your Password",
    "Resend Code": "Resend Code",
    "Reset your password": "Reset your password",
    "Reset your Password": "Reset your Password",
    "Send code": "Send code",
    "Send Code": "Send Code",
    Sending: "Sending",
    "Setup TOTP": "Setup TOTP",
    "Show password": "Show password",
    "Sign in to your account": "Sign in to your account",
    "Sign In with Amazon": "Sign In with Amazon",
    "Sign In with Apple": "Sign In with Apple",
    "Sign In with Facebook": "Sign In with Facebook",
    "Sign In with Google": "Sign In with Google",
    "Sign in": "Sign in",
    "Sign In": "Sign In",
    "Signing in": "Signing in",
    Skip: "Skip",
    Submit: "Submit",
    Submitting: "Submitting",
    Username: "Username",
    "Verify Contact": "Verify Contact",
    Verify: "Verify",
    "We Emailed You": "We Emailed You",
    "We Sent A Code": "We Sent A Code",
    "We Texted You": "We Texted You",
    "Your code is on the way. To log in, enter the code we emailed to": "Your code is on the way. To log in, enter the code we emailed to",
    "Your code is on the way. To log in, enter the code we sent you": "Your code is on the way. To log in, enter the code we sent you",
    "Your code is on the way. To log in, enter the code we texted to": "Your code is on the way. To log in, enter the code we texted to"
};


const $bc0cbe1bca826ee5$export$1d204a99f5862ba9 = {
    "Account recovery requires verified contact information": "La recuperaci\xf3n de la cuenta requiere informaci\xf3n de contacto verificada",
    "Back to Sign In": "Volver a inicio de sesi\xf3n",
    "Change Password": "Cambiar contrase\xf1a",
    Changing: "Cambiando",
    Code: "C\xf3digo",
    "Confirm Password": "Confirmar contrase\xf1a",
    "Confirm Sign Up": "Confirmar registro",
    "Confirm SMS Code": "Confirmar el c\xf3digo de SMS",
    "Confirm TOTP Code": "Confirmar c\xf3digo TOTP",
    Confirm: "Confirmar",
    "Confirmation Code": "C\xf3digo de confirmaci\xf3n",
    Confirming: "Confirmando",
    "Create a new account": "Crear una cuenta nueva",
    "Create Account": "Crear cuenta",
    "Creating Account": "Creando cuenta",
    "Dismiss alert": "Descartar alerta",
    Email: "Email",
    "Enter your code": "Ingrese el c\xf3digo",
    "Enter your Email": "Escriba su Email",
    "Enter your Password": "Escriba su Contrase\xf1a",
    "Enter your phone number": "Ingrese el n\xfamero de tel\xe9fono",
    "Enter your username": "Ingrese el nombre de usuario",
    "Forgot your password?": "\xbfOlvid\xf3 su contrase\xf1a?",
    "Hide password": "Ocultar contrase\xf1a",
    "It may take a minute to arrive": "Es posible que tarde un minuto en llegar",
    Loading: "Cargando",
    "New password": "Nueva contrase\xf1a",
    or: "o",
    Password: "Contrase\xf1a",
    "Phone Number": "N\xfamero de tel\xe9fono",
    "Resend Code": "Reenviar c\xf3digo",
    "Reset your password": "Restablecer su contrase\xf1a",
    "Reset your Password": "Restablecer su Contrase\xf1a",
    "Send code": "Enviar c\xf3digo",
    "Send Code": "Enviar c\xf3digo",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar contrase\xf1a",
    "Sign in to your account": "Iniciar sesi\xf3n en tu cuenta",
    "Sign In with Amazon": "Iniciar Sesi\xf3n con Amazon",
    "Sign In with Apple": "Iniciar Sesi\xf3n con Apple",
    "Sign In with Facebook": "Iniciar Sesi\xf3n con Facebook",
    "Sign In with Google": "Iniciar Sesi\xf3n con Google",
    "Sign in": "Iniciar sesi\xf3n",
    "Sign In": "Iniciar Sesi\xf3n",
    "Signing in": "Iniciando sesi\xf3n",
    Skip: "Omitir",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nombre de usuario",
    "Verify Contact": "Verificar contacto",
    Verify: "Verificar",
    "We Emailed You": "Le hemos enviado un correo electr\xf3nico",
    "We Sent A Code": "Hemos enviado un c\xf3digo",
    "We Texted You": "Le hemos enviado un mensaje de texto",
    "Your code is on the way. To log in, enter the code we emailed to": "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que hemos enviado por correo electr\xf3nico a",
    "Your code is on the way. To log in, enter the code we sent you": "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que le hemos enviado",
    "Your code is on the way. To log in, enter the code we texted to": "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que hemos enviado por mensaje de texto a",
    "An account with the given email already exists.": "Ya existe una cuenta con el correo ingresado.",
    "Confirm a Code": "Confirmar un c\xf3digo",
    "Confirm Sign In": "Confirmar inicio de sesi\xf3n",
    "Forgot Password": "Olvid\xe9 mi contrase\xf1a",
    "Incorrect username or password.": "Nombre de usuario o contrase\xf1a incorrecta",
    "Invalid password format": "Formato de contrase\xf1a inv\xe1lido",
    "Invalid phone number format": "Formato de n\xfamero de tel\xe9fono inv\xe1lido",
    "Loading...": "Cargando...",
    "New Password": "Nueva contrase\xf1a",
    "Resend a Code": "Reenviar un c\xf3digo",
    "Sign Out": "Cerrar sesi\xf3n",
    "Sign Up with Amazon": "Crear cuenta con Amazon",
    "Sign Up with Apple": "Crear cuenta con Apple",
    "Sign Up with Facebook": "Crear cuenta con Facebook",
    "Sign Up with Google": "Crear cuenta con Google",
    "Sign Up": "Crear cuenta",
    "User already exists": "El usuario ya existe",
    "User does not exist": "El usuario no existe",
    "Username cannot be empty": "El nombre de usuario no puede estar vac\xedo",
    "Your passwords must match": "Las contrase\xf1as deben coincidir"
};


const $52a47444632ab115$export$8cfa91bfcf8d11c8 = {
    "Account recovery requires verified contact information": "La r\xe9cup\xe9ration du compte n\xe9cessite des informations de contact v\xe9rifi\xe9es",
    "Back to Sign In": "Retour \xe0 la connexion",
    "Change Password": "Modifier le mot de passe",
    Changing: "Modification en cours",
    Code: "Code",
    "Confirm Password": "Confirmez le mot de passe",
    "Confirm Sign Up": "Confirmer l'inscription",
    "Confirm SMS Code": "Confirmer le code SMS",
    "Confirm TOTP Code": "Confirmer le code TOTP",
    Confirm: "Confirmer",
    "Confirmation Code": "Code de confirmation",
    Confirming: "Confirmation",
    "Create a new account": "Cr\xe9er un nouveau compte",
    "Create Account": "Cr\xe9er un compte",
    "Creating Account": "Cr\xe9ation d'un compte",
    "Dismiss alert": "Supprimer l'alerte",
    Email: "Email",
    "Enter your code": "Saisissez cotre code de confirmation",
    "Enter your Email": "Saisissez votre adresse email",
    "Enter your phone number": "Saisissez votre num\xe9ro de t\xe9l\xe9phone",
    "Enter your username": "Saisissez votre nom d'utilisateur",
    "Forgot your password?": "Mot de passe oubli\xe9 ? ",
    "Hide password": "Masquer le mot de passe",
    "It may take a minute to arrive": "Cela peut prendre une minute",
    Loading: "Chargement en cours",
    "New password": "Nouveau mot de passe",
    or: "ou",
    Password: "Mot de passe",
    "Phone Number": "Num\xe9ro de t\xe9l\xe9phone",
    "Resend Code": "Renvoyer le code",
    "Reset your Password": "R\xe9initialiser votre mot de passe",
    "Reset your password": "R\xe9initialisez votre mot de passe",
    "Send code": "Envoyer le code",
    "Send Code": "M'envoyer un code",
    Sending: "Envoi en cours",
    "Setup TOTP": "Configuration de TOTP",
    "Show password": "Afficher le mot de passe",
    "Sign in to your account": "Connexion \xe0 votre compte",
    "Sign In with Amazon": "Se connecter avec Amazon",
    "Sign In with Apple": "Se connecter avec Apple",
    "Sign In with Facebook": "Se connecter avec Facebook",
    "Sign In with Google": "Se connecter avec Google",
    "Sign in": "Se connecter",
    "Sign In": "Se connecter",
    "Signing in": "Connexion en cours",
    Skip: "Passer",
    Submit: "Soumettre",
    Submitting: "Envoi en cours",
    Username: "Nom d'utilisateur",
    "Verify Contact": "V\xe9rifier le contact",
    Verify: "V\xe9rifier",
    "We Sent A Code": "Nous avons envoy\xe9 un code",
    "We Texted You": "Nous vous avons envoy\xe9 un SMS",
    "Your code is on the way. To log in, enter the code we sent you": "Votre code est en cours d'envoi. Pour vous connecter, saisissez le code que nous vous avons envoy\xe9",
    "An account with the given email already exists.": "Un utilisateur avec cette adresse email existe d\xe9j\xe0.",
    Change: "Modifier",
    "Confirm a Code": "Confirmer un code",
    "Confirm Sign In": "Confirmer la connexion",
    "Create account": "Cr\xe9er un compte",
    "Enter your password": "Saisissez votre mot de passe",
    "Forgot Password": "Mot de passe oubli\xe9",
    "Have an account? ": "D\xe9j\xe0 un compte ? ",
    Hello: "Bonjour",
    "Incorrect username or password": "Identifiant ou mot de passe incorrect",
    "Invalid password format": "Format de mot de passe invalide",
    "Invalid phone number format": "Format de num\xe9ro de t\xe9l\xe9phone invalide. Veuillez utiliser un format +12345678900",
    "Loading...": "Chargement...",
    "Lost your code? ": "Vous avez perdu votre code ? ",
    "Network error": "Erreur r\xe9seau",
    "New Password": "Nouveau mot de passe",
    "No account? ": "Pas de compte ? ",
    "Resend a Code": "Renvoyer un code",
    "Reset password": "R\xe9initialisez votre mot de passe",
    Send: "Envoyer",
    "Sign In with AWS": "Se connecter avec AWS",
    "Sign Out": "D\xe9connexion",
    "Sign Up": "S'inscrire",
    SMS: "SMS",
    "User already exists": "L'utilisateur existe d\xe9j\xe0",
    "User does not exist": "L'utilisateur n'existe pas",
    "Username cannot be empty": "Le nom d'utilisateur doit \xeatre renseign\xe9",
    "Username/client id combination not found.": "L'utilisateur n'existe pas",
    "We Emailed You": "Nous vous avons envoy\xe9 un code",
    "Your code is on the way. To log in, enter the code we emailed to": "Votre code est en route. Pour vous connecter entrez le code re\xe7u sur cette adresse email",
    "Your code is on the way. To log in, enter the code we texted to": "Votre code est en route. Pour vous connecter entrez le code re\xe7u sur ce num\xe9ro de t\xe9l\xe9phone",
    "Your passwords must match": "Vos mots de passe doivent \xeatre identiques",
    "It may take a minute to arrive.": "Cela peut prendre quelques minutes."
};


const $717e9293ca4c2e82$export$5c8da73de176fccc = {
    "Account recovery requires verified contact information": "Il ripristino dell'account richiede informazioni di contatto verificate",
    "Back to Sign In": "Torna alla schermata di accesso",
    "Change Password": "Cambia la password",
    Changing: "Modifica in corso",
    Code: "Codice",
    "Confirm Password": "Conferma la password",
    "Confirm Sign Up": "Conferma registrazione",
    "Confirm SMS Code": "Conferma codice SMS",
    "Confirm TOTP Code": "Conferma codice TOTP",
    Confirm: "Conferma",
    "Confirmation Code": "Codice di verifica",
    Confirming: "Conferma in corso",
    "Create a new account": "Crea un nuovo account",
    "Create Account": "Crea Account",
    "Creating Account": "Creazione account in corso",
    "Dismiss alert": "Ignora l'avviso",
    Email: "Email",
    "Enter your code": "Inserisci il tuo codice",
    "Enter your Email": "Inserisci la tua e-mail",
    "Enter your phone number": 'Inserisci il tuo numero di telefono"',
    "Enter your username": "Inserisci il tuo nome utente",
    "Forgot your password?": "Password dimenticata?",
    "Hide password": "Nascondi password",
    "It may take a minute to arrive": "L'arrivo potrebbe richiedere qualche minuto",
    Loading: "Caricamento in corso",
    "New password": "Nuova password",
    or: "oppure",
    Password: "Password",
    "Phone Number": "Numero di telefono",
    "Resend Code": "Invia nuovamente il codice",
    "Reset your Password": "Reimposta la tua Password",
    "Reset your password": "Reimposta la tua password",
    "Send code": "Invia codice",
    "Send Code": "Invia codice",
    Sending: "Invio in corso",
    "Setup TOTP": "Configura TOTP",
    "Show password": "Mostra password",
    "Sign in to your account": "Accedi al tuo account",
    "Sign In with Amazon": "Accedi con Amazon",
    "Sign In with Apple": "Accedi con Apple",
    "Sign In with Facebook": "Accedi con Facebook",
    "Sign In with Google": "Accedi con Google",
    "Sign in": "Accedi",
    "Sign In": "Accedi",
    "Signing in": "Accesso in corso",
    Skip: "Salta",
    Submit: "Invia",
    Submitting: "Invio in corso",
    Username: "Nome utente",
    "Verify Contact": "Verifica contatto",
    Verify: "Verifica",
    "We Emailed You": "Ti abbiamo inviato un'e-mail",
    "We Sent A Code": "Ti abbiamo inviato un codice",
    "We Texted You": "Ti abbiamo inviato un SMS",
    "Your code is on the way. To log in, enter the code we emailed to": "Il codice \xe8 in arrivo. Per effettuare l'accesso, immetti il codice che ti abbiamo inviato via e-mail",
    "Your code is on the way. To log in, enter the code we sent you": "Il codice \xe8 in arrivo. Per accedere, immetti il codice che ti abbiamo inviato",
    "Your code is on the way. To log in, enter the code we texted to": "Il codice \xe8 in arrivo. Per accedere, immetti il codice che abbiamo inviato tramite SMS",
    "An account with the given email already exists.": "Questa email \xe8 gi\xe0 utilizzata da un altro account.",
    "Confirm a Code": "Conferma un codice",
    "Confirm Sign In": "Conferma l'accesso",
    "Create account": "Crea account",
    "Enter your password": "Inserisci la tua password",
    "Forgot Password?": "Password dimenticata?",
    "Have an account? ": "Gi\xe0 registrato?",
    "Incorrect username or password": "Nome utente o password errati",
    "Invalid password format": "Formato della password non valido",
    "Invalid phone number format": "Formato del numero di telefono non valido",
    "Lost your code?": "Codice smarrito?",
    "New Password": "Nuova password",
    "No account? ": "Non hai un account?",
    "Password attempts exceeded": "Il numero massimo di tentativi di accesso falliti \xe8 stato raggiunto",
    "Reset password": "Reimposta password",
    "Sign Out": "Esci",
    "Sign Up": "Registrati",
    "User already exists": "Utente gi\xe0 esistente",
    "User does not exist": "Utente inesistente",
    "Username cannot be empty": "Il nome utente non pu\xf2 essere vuoto"
};


const $9e673c60e47bada7$export$c416809cd76fbf21 = {
    "Account recovery requires verified contact information": "アカウントの復旧には確認済みの連絡先が必要です",
    "Back to Sign In": "サインインに戻る",
    "Change Password": "パスワードを変える ",
    Changing: "変更中",
    Code: "コード",
    "Confirm Password": "パスワードの確認",
    "Confirm Sign Up": "登録する",
    "Confirm SMS Code": "SMS コードを確認",
    "Confirm TOTP Code": "TOTP コードを確認",
    Confirm: "確定",
    "Confirmation Code": "確認コード",
    Confirming: "確認中",
    "Create a new account": "新しいアカウントを作る",
    "Create Account": "アカウントを作る",
    "Creating Account": "アカウントの作成中",
    "Dismiss alert": "アラートを閉じる",
    Email: "メールアドレス",
    "Enter your code": "コードを入力",
    "Enter your Email": "メールアドレスを入力",
    "Enter your phone number": "電話番号を入力",
    "Enter your username": "ユーザー名を入力 ",
    "Forgot your password?": "パスワードを忘れましたか？ ",
    "Hide password": "パスワードを非表示",
    "It may take a minute to arrive": "到着するまでに 1 分かかることがあります。",
    Loading: "ロード中",
    "New password": "新しいパスワード",
    or: "又は",
    Password: "パスワード ",
    "Phone Number": "電話番号",
    "Resend Code": "コードを再送信",
    "Reset your Password": "パスワードをリセット",
    "Reset your password": "パスワードをリセットする",
    "Send code": "コードを送信",
    "Send Code": "コードを送信",
    Sending: "送信中",
    "Setup TOTP": "TOTP をセットアップ",
    "Show password": "パスワードを表示",
    "Sign in to your account": "アカウントにサインイン ",
    "Sign In with Amazon": "Amazonでサインイン",
    "Sign In with Apple": "Apple でサインイン",
    "Sign In with Facebook": "Facebookでサインイン",
    "Sign In with Google": "Googleでサインイン",
    "Sign In": "サインイン ",
    "Sign in": "サインイン",
    "Signing in": "サインイン中",
    Skip: "スキップ",
    Submit: "送信",
    Submitting: "送信中",
    Username: "ユーザー名 ",
    "Verify Contact": "連絡先を確認",
    Verify: "確認",
    "We Sent A Code": "コードが送信されました",
    "We Texted You": "テキストが送信されました",
    "Your code is on the way. To log in, enter the code we sent you": "コードが途中です。ログインするには、送信したコードを入力してください。",
    "An account with the given email already exists.": "入力されたメールアドレスのアカウントが既に存在します",
    "Confirm a Code": "コードを確認",
    "Confirm Sign In": "サインインする",
    "Create account": "アカウントを作る ",
    "Enter your password": "パスワードを入力 ",
    "Enter your Password": "パスワードを入力",
    "Please confirm your Password": "パスワードを入力",
    "Forgot Password": "パスワードを忘れた ",
    "Have an account? ": "アカウントを持っていますか？",
    "Incorrect username or password": "ユーザー名かパスワードが異なります ",
    "Invalid password format": "パスワードの形式が無効です ",
    "Invalid phone number format": "不正な電話番号の形式です。\n+12345678900 の形式で入力してください",
    "It may take a minute to arrive.": "コードを受信するまで数分かかる場合があります。",
    "Lost your code? ": "コードを失くしましたか？",
    "New Password": "新しいパスワード",
    "No account? ": "アカウントが無いとき ",
    "Password attempts exceeded": "サインインの試行回数が上限に達しました",
    "Reset password": "パスワードをリセット ",
    "Reset Password": "パスワードをリセット",
    "Sign Out": "サインアウト ",
    "Sign Up": "登録 ",
    "User already exists": "既にユーザーが存在しています ",
    "User does not exist": "ユーザーが存在しません ",
    "Username cannot be empty": "ユーザー名は入力必須です",
    "We Emailed You": "コードを送信しました",
    "Your code is on the way. To log in, enter the code we emailed to": "ログインするには、メールに記載されたコードを入力してください。送信先:",
    "Your code is on the way. To log in, enter the code we texted to": "ログインするには、テキストメッセージに記載されたコードを入力してください。送信先:"
};


const $6477146b757640a2$export$fb1930c2b96707b2 = {
    "Account recovery requires verified contact information": "계정 복구를 위해 연락처 확인이 필요합니다",
    "Back to Sign In": "로그인으로 돌아가기",
    "Change Password": "비밀번호 변경하기",
    Changing: "변경중",
    Code: "코드",
    "Confirm Password": "비밀번호 재확인",
    "Confirm Sign Up": "회원가입 확인",
    "Confirm SMS Code": "휴대폰 본인 확인",
    "Confirm TOTP Code": "TOTP 인증번호 확인",
    Confirm: "확인",
    "Confirmation Code": "인증번호",
    Confirming: "확인중",
    "Create a new account": "회원가입",
    "Create Account": "회원가입",
    "Creating Account": "회원가입중",
    "Dismiss alert": "알림 무시",
    Email: "이메일",
    "Enter your code": "인증번호를 입력해주세요",
    "Enter your Email": "이메일 입력",
    "Enter your phone number": "전화번호 입력",
    "Enter your username": "아이디를 입력해주세요",
    "Hide password": "비밀번호 숨기기",
    "It may take a minute to arrive": "도착하는 데 1분 정도 걸릴 수 있습니다",
    Loading: "로딩중",
    "New password": "새 비밀번호",
    or: "또는",
    Password: "비밀번호",
    "Phone Number": "전화번호",
    "Resend Code": "인증번호 재전송",
    "Reset your password": "비밀번호 재설정",
    "Reset your Password": "비밀번호 재설정",
    "Send code": "인증코드 보내기",
    "Send Code": "코드 전송",
    Sending: "전송중",
    "Setup TOTP": "TOTP 설정하기",
    "Show password": "비밀번호 보이기",
    "Sign in to your account": "로그인",
    "Sign In with Amazon": "Amazon 로그인",
    "Sign In with Apple": "Apple 로그인",
    "Sign In with Facebook": "Facebook 로그인",
    "Sign In with Google": "Google 로그인",
    "Sign in": "로그인",
    "Sign In": "로그인",
    "Signing in": "로그인중",
    Skip: "다음에 하기",
    Submit: "확인",
    Submitting: "확인중",
    Username: "아이디",
    "Verify Contact": "연락처 확인",
    Verify: "인증",
    "We Emailed You": "이메일을 보냄",
    "We Sent A Code": "코드를 보냄",
    "We Texted You": "문자 메시지를 보냄",
    "Your code is on the way. To log in, enter the code we emailed to": "코드가 전송 중입니다. 로그인하려면 이메일로 전송한 코드를 입력하세요",
    "Your code is on the way. To log in, enter the code we sent you": "코드가 전송 중입니다. 로그인하려면 전송한 코드를 입력하세요",
    "Your code is on the way. To log in, enter the code we texted to": "코드가 전송 중입니다. 로그인하려면 문자 메시지로 전송한 코드를 입력하세요",
    Birthdate: "생년월일",
    "Family Name": "성",
    "Forgot your password?": "비밀번호를 잊으셨나요?",
    "Given Name": "이름",
    Name: "성함",
    Nickname: "닉네임",
    "Preferred Username": "닉네임",
    Profile: "프로필",
    "Reset Password": "비밀번호 재설정",
    Website: "웹사이트"
};


const $a4749e521de863ab$export$c27bce1749452052 = {
    "Account recovery requires verified contact information": "Gjenoppretting av konto krever verifisert kontaktinformajson",
    "Add your Profile": "Legg til profilen din",
    "Add your Website": "Legg til nettsiden din",
    "Back to Sign In": "Tilbake til innlogging",
    "Change Password": "Bytt passord",
    Changing: "Endre",
    Code: "Kode",
    "Confirm Password": "Bekreft passordet",
    "Confirm Sign Up": "Bekreft registrering",
    "Confirm SMS Code": "Bekreft SMS-kode",
    "Confirm TOTP Code": "Bekreft TOTP-kode",
    Confirm: "Bekreft",
    "Confirmation Code": "Bekreftelseskode",
    Confirming: "Bekrefter",
    "Create a new account": "Opprett en ny konto",
    "Create Account": "Opprett konto",
    "Creating Account": "Oppretter konto",
    "Dismiss alert": "Avvis varsel",
    Email: "E-post",
    "Enter your Birthdate": "Skriv inn f\xf8dselsdatoen din",
    "Enter your code": "Skriv inn koden din",
    "Enter your Confirmation Code": "Skriv inn bekreftelseskoden din",
    "Enter your Email": "Skriv inn e-postadressen din",
    "Enter your Family Name": "Skriv inn etternavnet ditt",
    "Enter your Given Name": "Skriv inn fornavnet ditt",
    "Enter your Middle Name": "Skriv inn mellomnavnet ditt",
    "Enter your Name": "Skriv inn navnet ditt",
    "Enter your Nickname": "Skriv inn kallenavnet ditt",
    "Enter your Password": "Skriv inn passordet ditt",
    "Enter your phone number": "Skriv inn telefonnummeret ditt",
    "Enter your Preferred Username": "Skriv inn det foretrukne brukernavnet ditt",
    "Enter your username": "Skriv inn brukernavnet ditt",
    "Forgot password?": "Glemt passord?",
    "Forgot your password?": "Glemt passordet ditt?",
    "Hide password": "Skjul passordet",
    "It may take a minute to arrive": "Det kan ta et minutt for \xe5 komme frem",
    Loading: "Laster inn",
    "New password": "Nytt passord",
    or: "eller",
    Password: "Passord",
    "Phone Number": "Telefonnummer",
    "Please confirm your Password": "Vennligst bekreft passordet ditt",
    "Resend Code": "Send koden p\xe5 nytt",
    "Reset your password": "Nullstill passordet ditt",
    "Reset your Password": "Nullstill passordet ditt",
    "Send code": "Send kode",
    "Send Code": "Send kode",
    Sending: "Sender",
    "Setup TOTP": "Konfigurer TOTP",
    "Show password": "Vis passordet",
    "Sign in to your account": "Logg inn p\xe5 kontoen din",
    "Sign In with Amazon": "Logg inn med Amazon",
    "Sign In with Apple": "Logg inn med Apple",
    "Sign In with Facebook": "Logg inn med Facebook",
    "Sign In with Google": "Logg inn med Google",
    "Sign in": "Logg inn",
    "Sign In": "Logg inn",
    "Signing in": "Logger inn",
    Skip: "Hopp over",
    Submit: "Send inn",
    Submitting: "Sender inn",
    Username: "Brukernavn",
    "Verify Contact": "Bekreft kontakt",
    Verify: "Bekreft",
    "We Emailed You": "Vi sendte deg en e-post",
    "We Sent A Code": "Vi sendte en kode",
    "We Texted You": "Vi sendte deg en tekstmelding",
    "Your code is on the way. To log in, enter the code we emailed to": "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte e-post til",
    "Your code is on the way. To log in, enter the code we sent you": "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte deg",
    "Your code is on the way. To log in, enter the code we texted to": "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte tekstmelding til",
    "An account with the given email already exists.": "Det finnes allerede en konto med denne e-postadressen",
    "Confirm a Code": "Bekreft koden",
    "Confirm Sign In": "Bekreft innlogging",
    "Create account": "Opprett konto",
    "Enter your password": "Skriv inn passordet ditt",
    "Forgot Password": "Glemt passordet",
    "Have an account? ": "Har en konto allerede? ",
    "Incorrect username or password": "Feil brukernavn eller passord",
    "Invalid password format": "Ugyldig passordformat",
    "Invalid phone number format": "Ugyldig telefonnummerformat",
    "Lost your code? ": "Mistet koden? ",
    "New Password": "Nytt passord",
    "No account? ": "Ingen konto? ",
    "Password attempts exceeded": "For mange mislykkede passordfors\xf8k",
    "Reset password": "Nullstill passord",
    "Sign Out": "Logg ut",
    "Sign Up": "Registrering",
    "User already exists": "Brukeren finnes allerede",
    "User does not exist": "Brukeren finnes ikke",
    "Username cannot be empty": "Brukernavnet kan ikke v\xe6re tomt"
};


const $e63da870d1f88394$export$8569df33fbaae243 = {
    "Account recovery requires verified contact information": "Accountherstel vereist geverifieerde contactgegevens",
    "Back to Sign In": "Terug naar inloggen",
    "Change Password": "Wachtwoord wijzigen",
    Changing: "Wordt aangepast",
    Code: "Code",
    "Confirm Password": "Bevestig Wachtwoord",
    "Confirm Sign Up": "Bevestig inschrijving",
    "Confirm SMS Code": "Bevestig SMS Code",
    "Confirm TOTP Code": "Bevestig TOTP Code",
    Confirm: "Bevestig",
    "Confirmation Code": "Bevestigingscode",
    Confirming: "Bevestigen",
    "Create a new account": "Nieuw account aanmaken",
    "Create Account": "Account aanmaken",
    "Creating Account": "Account wordt aangemaakt",
    "Dismiss alert": "Waarschuwing sluiten",
    Email: "E-mail",
    "Enter your code": "Vul je code in",
    "Enter your Email": "Vul je e-mail in",
    "Enter your Password": "Vul je wachtwoord in",
    "Enter your phone number": "Vul je telefoonnummer in",
    "Enter your username": "Vul je gebruikersnaam in",
    "Enter your Username": "Vul je gebruikersnaam in",
    "Forgot your password?": "Wachtwoord vergeten? ",
    "Hide password": "Verberg wachtwoord",
    "It may take a minute to arrive": "Het kan even duren voordat deze aankomt",
    Loading: "Laden",
    "New password": "Nieuw wachtwoord",
    "New Password": "Nieuw Wachtwoord",
    or: "of",
    Password: "Wachtwoord",
    "Phone Number": "Telefoonnummer",
    "Please confirm your Password": "Bevestig je wachtwoord",
    "Resend Code": "Verstuur code nogmaals",
    "Reset Password": "Wachtwoord resetten",
    "Reset your password": "Reset je wachtwoord",
    "Reset your Password": "Wachtwoord resetten",
    "Send code": "Verstuur code",
    "Send Code": "Verstuur Code",
    Sending: "Versturen",
    "Setup TOTP": "TOTP Instellingen",
    "Show password": "Toon wachtwoord",
    "Sign in to your account": "Inloggen op je account",
    "Sign In with Amazon": "Inloggen met Amazon",
    "Sign In with Apple": "Inloggen met Apple",
    "Sign In with Facebook": "Inloggen met Facebook",
    "Sign In with Google": "Inloggen met Google",
    "Sign in": "Inloggen",
    "Sign In": "Inloggen",
    "Signing in": "Inloggen",
    Skip: "Overslaan",
    Submit: "Versturen",
    Submitting: "Wordt verstuurd",
    Username: "Gebruikersnaam",
    "Verify Contact": "Verifieer Contact",
    Verify: "Verifieer",
    "We Emailed You": "We hebben u een e-mail gestuurd",
    "We Sent A Code": "We hebben een code gestuurd",
    "We Texted You": "We hebben u een sms gestuurd",
    "Your code is on the way. To log in, enter the code we emailed to": "Uw code is onderweg. Om in te loggen, voer de code in die we gemaild hebben naar",
    "Your code is on the way. To log in, enter the code we sent you": "Uw code is onderweg. Om in te loggen, voer de code in die we u hebben gestuurd",
    "Your code is on the way. To log in, enter the code we texted to": "Uw code is onderweg. Om in te loggen, voer de code in die we hebben gestuurd naar",
    "Your passwords must match": "Je wachtwoorden moeten overeenkomen"
};


const $5c4e8b51540d3bc2$export$6fb0e8139f7ef98d = {
    "Account recovery requires verified contact information": "Odzyskanie konta wymaga zweryfikowanych danych kontaktowych",
    "Back to Sign In": "Powr\xf3t do logowania",
    "Change Password": "Zmień hasło",
    Changing: "Zmienianie",
    Code: "Kod",
    "Confirm Password": "Potwierdź Hasło",
    "Confirm Sign Up": "Potwierdź rejestrację",
    "Confirm SMS Code": "Potwierdź kod SMS",
    "Confirm TOTP Code": "Potwierdź hasło jednorazowe",
    Confirm: "Potwierdź",
    "Confirmation Code": "Kod potwierdzenia",
    Confirming: "Potwierdzanie",
    "Create a new account": "Utw\xf3rz nowe konto",
    "Create Account": "Utw\xf3rz konto",
    "Creating Account": "Tworzenie konta",
    "Dismiss alert": "Odrzuć alert",
    Email: "E-mail",
    "Enter your code": "Wprowadź sw\xf3j kod",
    "Enter your Email": "Wpisz sw\xf3j adres e-mail",
    "Enter your phone number": "Wpisz sw\xf3j numer telefonu",
    "Enter your username": "Wprowadź swoją nazwę użytkownika",
    "Forgot your password?": "Zapomniałeś hasła? ",
    "Hide password": "Ukryj hasło",
    "It may take a minute to arrive": "Może to chwilę potrwać",
    Loading: "Ładowanie",
    "New password": "Nowe hasło",
    or: "albo",
    Password: "Hasło",
    "Phone Number": "Numer telefonu",
    "Resend Code": "Wyślij kod ponownie",
    "Reset your password": "Zresetuj swoje hasło",
    "Reset your Password": "Zresetuj swoje hasło",
    "Send code": "Wyślij kod",
    "Send Code": "Zresetuj hasło",
    Sending: "Wysyłanie",
    "Setup TOTP": "Konfiguruj TOTP",
    "Show password": "Pokaż hasło",
    "Sign in to your account": "Zaloguj się na swoje konto",
    "Sign In with Amazon": "Zaloguj z Amazon",
    "Sign In with Apple": "Zaloguj z Apple",
    "Sign In with Facebook": "Zaloguj z Facebook",
    "Sign In with Google": "Zaloguj z Google",
    "Sign In": "Logowanie",
    "Sign in": "Zaloguj",
    "Signing in": "Logowanie",
    Skip: "Pomiń",
    Submit: "Wyślij",
    Submitting: "Wysyłanie",
    Username: "Nazwa użytkownika",
    "Verify Contact": "Weryfikacja danych kontaktowych",
    Verify: "Zweryfikuj",
    Birthdate: "Data urodzenia",
    "Family Name": "Nazwisko",
    "Given Name": "Pierwsze imię",
    "Middle Name": "Drugie imię",
    Name: "Imię i nazwisko",
    Nickname: "Pseudonim",
    "Preferred Username": "Preferowana nazwa użytkownika",
    Profile: "Profil",
    Website: "Strona internetowa",
    "We Emailed You": "Wysłaliśmy Ci wiadomość e-mail",
    "We Sent A Code": "Wysłaliśmy kod",
    "We Texted You": "Wysłaliśmy Ci wiadomość SMS",
    "Your code is on the way. To log in, enter the code we emailed to": "Tw\xf3j kod został wysłany. Aby się zalogować, wprowadź kod wysłany na adres e-mail",
    "Your code is on the way. To log in, enter the code we sent you": "Tw\xf3j kod został wysłany. Aby się zalogować, wprowadź wysłany do Ciebie kod",
    "Your code is on the way. To log in, enter the code we texted to": "Tw\xf3j kod został wysłany. Aby się zalogować, wprowadź kod wysłany do Ciebie w wiadomości SMS pod numer"
};


const $9d399419f4d4e971$export$c7dddbf179b434d1 = {
    "Account recovery requires verified contact information": "A recupera\xe7\xe3o da conta requer informa\xe7\xf5es de contato verificadas",
    "Back to Sign In": "Voltar para Entrar",
    "Change Password": "Mudar senha",
    Changing: "Mudando",
    Code: "C\xf3digo",
    "Confirm Password": "Confirme a Senha",
    "Confirm Sign Up": "Confirmar inscri\xe7\xe3o",
    "Confirm SMS Code": "Confirme o c\xf3digo SMS",
    "Confirm TOTP Code": "Confirme o c\xf3digo TOTP",
    Confirm: "confirme",
    "Confirmation Code": "C\xf3digo de confirma\xe7\xe3o",
    Confirming: "Confirmando",
    "Create a new account": "Criar uma nova conta",
    "Create Account": "Criar Conta",
    "Creating Account": "Criando conta",
    "Dismiss alert": "Descartar alerta",
    Email: "O email",
    "Enter your code": "Insira seu c\xf3digo",
    "Enter your Email": "Digite seu e-mail",
    "Enter your phone number": "Digite seu n\xfamero de telefone",
    "Enter your username": "entre com seu nome de usu\xe1rio",
    "Forgot your password?": "Esqueceu sua senha? ",
    "Hide password": "Esconder a senha",
    "It may take a minute to arrive": "Pode levar um minuto para chegar",
    Loading: "Carregando",
    "New password": "Nova Senha",
    or: "ou",
    Password: "Senha",
    "Phone Number": "N\xfamero de telefone",
    "Resend Code": "Reenviar c\xf3digo",
    "Reset your password": "Redefina sua senha",
    "Reset your Password": "Redefina sua senha",
    "Send code": "Enviar c\xf3digo",
    "Send Code": "Enviar c\xf3digo",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar senha",
    "Sign in to your account": "Fa\xe7a login em sua conta",
    "Sign In with Amazon": "Entrar com a Amazon",
    "Sign In with Apple": "Entrar com a Apple",
    "Sign In with Facebook": "Entrar com o Facebook",
    "Sign In with Google": "Fa\xe7a login no Google",
    "Sign in": "Entrar",
    "Sign In": "Entrar",
    "Signing in": "Entrando",
    Skip: "Pular",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nome do usu\xe1rio",
    "Verify Contact": "Verificar contato",
    Verify: "Verificar",
    "We Emailed You": "Enviamos um e-mail para voc\xea",
    "We Sent A Code": "Enviamos um c\xf3digo",
    "We Texted You": "Enviamos um SMS para voc\xea",
    "Your code is on the way. To log in, enter the code we emailed to": "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo para o qual enviamos um e-mail",
    "Your code is on the way. To log in, enter the code we sent you": "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo que enviamos para voc\xea",
    "Your code is on the way. To log in, enter the code we texted to": "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo para o qual enviamos uma mensagem de texto"
};


const $774c9e3bde4b9031$export$2a86dc37ee9734c = {
    "Account recovery requires verified contact information": "账户恢复需要验证过的联系方式",
    "Back to Sign In": "回到登录",
    "Change Password": "更改密码",
    Changing: "正在修改",
    Code: "确认码",
    "Confirm Password": "确认密码",
    "Confirm Sign Up": "确认注册",
    "Confirm SMS Code": "确认短信验证码",
    "Confirm TOTP Code": "确认 TOTP 代码",
    Confirm: "确认",
    "Confirmation Code": "确认码",
    Confirming: "正在确认",
    "Create a new account": "创建新账户",
    "Create Account": "创建账户",
    "Creating Account": "正在创建账户",
    "Dismiss alert": "关闭警报",
    Email: "邮箱",
    "Enter your code": "输入验证码",
    "Enter your Email": "输入电子邮件",
    "Enter your phone number": "输入电话号码",
    "Enter your username": "输入用户名",
    "Forgot your password?": "忘记密码了？",
    "Hide password": "隐藏密码",
    "It may take a minute to arrive": "可能需要一分钟才能到达",
    Loading: "正在加载",
    "New password": "新密码",
    or: "或者",
    Password: "密码",
    "Phone Number": "电话",
    "Resend Code": "重发验证码",
    "Reset your password": "重置密码",
    "Reset your Password": "重置密码",
    "Send Code": "发送确认码",
    "Send code": "发送验证码",
    Sending: "正在发送",
    "Setup TOTP": "设置 TOTP",
    "Show password": "显示密码",
    "Sign in to your account": "登录账户",
    "Sign In with Amazon": "通过 Amazon 登录",
    "Sign In with Apple": "通过 Apple 登录",
    "Sign In with Facebook": "通过 Facebook 登录",
    "Sign In with Google": "通过 Google 登录",
    "Sign in": "登录",
    "Sign In": "登录",
    "Signing in": "正在登录",
    Skip: "跳过",
    Submit: "提交",
    Submitting: "正在提交",
    Username: "用户名",
    "Verify Contact": "验证联系方式",
    Verify: "验证",
    "We Emailed You": "我们给您发送了电子邮件",
    "We Sent A Code": "我们发送了代码",
    "We Texted You": "我们给您发送了短信",
    "Your code is on the way. To log in, enter the code we emailed to": "您的代码正在发送中。要登录，请输入我们通过电子邮件发送给以下人员的代码：",
    "Your code is on the way. To log in, enter the code we sent you": "您的代码正在发送中。要登录，请输入我们发送给您的代码",
    "Your code is on the way. To log in, enter the code we texted to": "您的代码正在发送中。要登录，请输入我们通过短信发送给以下人员的代码：",
    "Confirm a Code": "确认码",
    "Confirm Sign In": "确认登录",
    "Forgot Password": "忘记密码",
    "Incorrect username or password": "用户名或密码错误",
    "Invalid password format": "密码格式错误",
    "Invalid phone number format": "电话格式错误，请使用格式 +12345678900",
    "New Password": "新密码",
    "Resend a Code": "重发确认码",
    "Sign Out": "退出",
    "Sign Up": "注册",
    "User already exists": "用户已经存在",
    "User does not exist": "用户不存在"
};


const $a31d1351f89f754f$export$9f1a61f9baaa2d2e = {
    "Account recovery requires verified contact information": "F\xf6r att \xe5terst\xe4lla kontot beh\xf6ver du ett verifierat konto",
    "Back to Sign In": "Tillbaka till inloggningen",
    "Change Password": "Byt l\xf6senord",
    Changing: "\xc4ndra",
    Code: "Kod",
    "Confirm Password": "Bekr\xe4fta l\xf6senord",
    "Confirm Sign Up": "Bekr\xe4fta registrering",
    "Confirm SMS Code": "Bekr\xe4fta SMS-kod",
    "Confirm TOTP Code": "Bekr\xe4fta TOTP-kod",
    Confirm: "Bekr\xe4fta",
    "Confirmation Code": "Verifikationskod",
    Confirming: "Bekr\xe4ftar",
    "Create a new account": "Skapa ett nytt konto",
    "Create Account": "Skapa konto",
    "Creating Account": "Skapar konto",
    "Dismiss alert": "Avvisa varning",
    Email: "E-post",
    "Enter your code": "Skriv din kod",
    "Enter your Email": "Fyll i din e-post",
    "Enter your phone number": "Ange ditt telefonnummer",
    "Enter your username": "Ange ditt anv\xe4ndarnamn",
    "Forgot your password?": "Gl\xf6mt ditt l\xf6senord? ",
    "Hide password": "D\xf6lj l\xf6senord",
    "It may take a minute to arrive": "Det kan ta en minut att komma fram",
    Loading: "Laddar",
    "New password": "Nytt l\xf6senord",
    or: "eller",
    Password: "L\xf6senord",
    "Phone Number": "Telefonnummer",
    "Resend Code": "Skicka koden igen",
    "Reset your password": "\xc5terst\xe4ll ditt l\xf6senord",
    "Reset your Password": "\xc5terst\xe4ll ditt l\xf6senord",
    "Send code": "Skicka kod",
    "Send Code": "Skicka kod",
    Sending: "Skickar",
    "Setup TOTP": "Konfigurera TOTP",
    "Show password": "Visa l\xf6senord",
    "Sign in to your account": "Logga in till ditt konto",
    "Sign In with Amazon": "Logga in med Amazon",
    "Sign In with Apple": "Logga in med Apple",
    "Sign In with Facebook": "Logga in med Facebook",
    "Sign In with Google": "Logga in med Google",
    "Sign in": "Logga in",
    "Sign In": "Logga in",
    "Signing in": "Loggar in",
    Skip: "Hoppa \xf6ver",
    Submit: "Skicka",
    Submitting: "Skickar in",
    Username: "Anv\xe4ndarnamn",
    "Verify Contact": "Verifiera kontakt",
    Verify: "Verifiera",
    "We Sent A Code": "Vi skickade en kod",
    "We Texted You": "Vi sms:ade dig",
    "Your code is on the way. To log in, enter the code we emailed to": "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi mejlade till",
    "Your code is on the way. To log in, enter the code we sent you": "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi skickade till dig",
    "Your code is on the way. To log in, enter the code we texted to": "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi sms:ade till",
    "An account with the given email already exists.": "Det finns redan ett konto med denna e-postadress",
    "Confirm a Code": "Bekr\xe4fta koden",
    "Confirm Sign In": "Bekr\xe4fta inloggning",
    "Create account": "Skapa konto",
    "Enter your password": "Ange ditt l\xf6senord",
    "Forgot Password": "Gl\xf6mt l\xf6senordet",
    "Have an account? ": "Redan registrerad? ",
    "Incorrect username or password": "Felaktigt anv\xe4ndarnamn eller l\xf6senord",
    "Invalid password format": "Ogiltigt l\xf6senordsformat",
    "Invalid phone number format": "Ogiltigt format f\xf6r telefonnummer",
    "Lost your code? ": "F\xf6rlorat koden? ",
    "New Password": "Nytt l\xf6senord",
    "No account? ": "Inget konto? ",
    "Password attempts exceeded": "Maximalt antal felaktiga inloggningsf\xf6rs\xf6k har uppn\xe5tts",
    "Reset password": "\xc5terst\xe4ll l\xf6senord",
    "Sign Out": "Logga ut",
    "Sign Up": "Registrering",
    "User already exists": "Anv\xe4ndaren finns redan",
    "User does not exist": "Anv\xe4ndaren finns inte",
    "Username cannot be empty": "Anv\xe4ndarnamnet kan inte vara tomt",
    "We Emailed You": "Vi har skickat e-post till dig"
};


const $ce078a1076ca272b$export$710642024bfcbd8f = {
    "Account recovery requires verified contact information": "Pemulihan akun memerlukan informasi kontak terverifikasi",
    "Back to Sign In": "Kembali ke Masuk",
    "Change Password": "Ubah kata sandi",
    Changing: "Mengubah",
    Code: "Kode",
    "Confirm Password": "Konfirmasi kata sandi",
    "Confirm Sign Up": "Konfirmasi Pendaftaran",
    "Confirm SMS Code": "Konfirmasi Kode SMS",
    "Confirm TOTP Code": "Konfirmasi Kode TOTP",
    Confirm: "Konfirmasi",
    "Confirmation Code": "Kode Konfirmasi",
    Confirming: "Mengkonfirmasi",
    "Create a new account": "Buat akun baru",
    "Create Account": "Buat Akun",
    "Creating Account": "Membuat Akun",
    "Dismiss alert": "Hentikan pemberitahuan",
    Email: "Email",
    "Enter your code": "Masukkan kode anda",
    "Enter your Email": "Masukkan email anda",
    "Enter your phone number": "Masukkan nomor telepon anda",
    "Enter your username": "Masukkan nama akun anda",
    "Forgot your password?": "Lupa kata sandi? ",
    "Hide password": "Sembunyikan kata sandi",
    "It may take a minute to arrive": "Mungkin perlu waktu satu menit untuk tiba",
    Loading: "Memuat",
    "New password": "Kata sandi baru",
    or: "atau",
    Password: "Kata sandi",
    "Phone Number": "Nomor telepon",
    "Resend Code": "Kirim ulang kodenya",
    "Reset your Password": "Reset Kata Sandi",
    "Reset your password": "Ubah kata sandi anda",
    "Send code": "Kirim kode",
    "Send Code": "Kirim Kode",
    Sending: "Mengirim",
    "Setup TOTP": "Siapkan TOTP",
    "Show password": "Tampilkan kata sandi",
    "Sign in to your account": "Masuk akun anda",
    "Sign In with Amazon": "Masuk dengan Amazon",
    "Sign In with Apple": "Masuk dengan Apple",
    "Sign In with Facebook": "Masuk dengan Facebook",
    "Sign In with Google": "Masuk dengan Google",
    "Sign in": "Masuk",
    "Sign In": "Masuk",
    "Signing in": "Memasuki",
    Skip: "Lewati",
    Submit: "Ajukan",
    Submitting: "Mengajukan",
    Username: "Nama akun",
    "Verify Contact": "Verifikasi Kontak",
    Verify: "Verifikasi",
    "We Sent A Code": "Kami Mengirim Kode",
    "We Texted You": "Kami mengirim SMS kepada Anda",
    "Your code is on the way. To log in, enter the code we sent you": "Kode Anda segera hadir. Untuk masuk, masukkan kode yang kami kirimkan kepada Anda",
    "An account with the given email already exists.": "Akun dengan email tersebut sudah terdaftar.",
    "Attempt limit exceeded, please try after some time.": "Batas percobaan terlampaui, mohon coba lagi setelah beberapa waktu.",
    "Cannot reset password for the user as there is no registered/verified email or phone_number": "Tidak dapat mengatur ulang kata sandi karena tidak ada email terdaftar / terverifikasi atau nomor telepon",
    Change: "Ubah",
    "Confirm a Code": "Konfirmasi kode",
    "Create account": "Buat akun",
    "Enter your password": "Masukkan kata sandi anda",
    "Forgot Password": "Lupa kata sandi",
    "Have an account? ": "Sudah punya akun? ",
    Hello: "Halo",
    "Incorrect username or password.": "Nama akun atau kata sandi salah.",
    "Invalid phone number format": "Nomor telepon tidak sesuai dengan format.",
    "Invalid verification code provided, please try again.": "Kode verifikasi tidak sesuai, mohon coba lagi.",
    "It may take a minute to arrive.": "Mungkin perlu beberapa waktu untuk tiba.",
    "Lost your code? ": "Kode anda hilang?",
    Name: "Nama",
    "Network error": "Galat jaringan",
    "No account? ": "Tidak ada akun?",
    "Password did not conform with policy: Password not long enough": "Kata sandi tidak sesuai dengan aturan: Kata sandi kurang panjang",
    "Resend a Code": "Renvoyer un code",
    "Reset password": "Ubah kata sandi anda",
    Send: "Kirim",
    "Sign In with AWS": "Masuk dengan AWS",
    "Sign Up with Amazon": "Daftar dengan Amazon",
    "Sign Up with AWS": "Daftar dengan AWS",
    "Sign Up with Facebook": "Daftar dengan Facebook",
    "Sign Up with Google": "Daftar dengan Google",
    SMS: "SMS",
    "User already exists": "Akun sudah terdaftar",
    "User does not exist.": "Akun tidak terdaftar.",
    "User is disabled.": "Akun dinonaktifkan.",
    "Username cannot be empty": "Nama akun tidak boleh kosong",
    "Username/client id combination not found.": "Nama akun atau id tidak ditemukan.",
    "We Emailed You": "Kami mengirimkanmu email",
    "Your code is on the way. To log in, enter the code we emailed to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami emailkan ke",
    "Your code is on the way. To log in, enter the code we texted to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami tuliskan ke",
    "Your passwords must match": "Kata sandi harus sama"
};


const $3d7f382f0e68fb29$export$6961fa2059aeacf0 = {
    "Account recovery requires verified contact information": "Hesap kurtarma, doğrulanmış iletişim bilgilerini gerektirir",
    "Back to Sign In": "Oturum A\xe7maya Geri D\xf6n",
    "Change Password": "Şifreyi Değiştir",
    Changing: "Değiştiriliyor",
    Code: "Kod",
    "Confirm Password": "Şifreyi Doğrula",
    "Confirm Sign Up": "Kayıt İşlemini Doğrula",
    "Confirm SMS Code": "SMS Kodunu Doğrula",
    "Confirm TOTP Code": "Tek Kullanımlık Şifreyi Doğrula",
    Confirm: "Doğrula",
    "Confirmation Code": "Doğrulama Kodu",
    Confirming: "Doğrulanıyor",
    "Create a new account": "Yeni bir hesap oluştur",
    "Create Account": "Hesap Oluştur",
    "Creating Account": "Hesap Oluşturuluyor",
    "Dismiss alert": "Uyarıyı reddet",
    Email: "E-posta",
    "Enter your code": "Kodu girin",
    "Enter your Email": "E-posta adresinizi girin",
    "Enter your phone number": "Telefon numaranızı girin",
    "Enter your username": "Kullanıcı adınızı girin",
    "Forgot your password?": "Şifrenizi mi unuttunuz?",
    "Hide password": "Şifreyi gizle",
    "It may take a minute to arrive": "Kodun gelmesi bir dakika s\xfcrebilir",
    Loading: "Y\xfckleniyor",
    "New password": "Yeni şifre",
    or: "veya",
    Password: "Şifre",
    "Phone Number": "Telefon Numarası",
    "Resend Code": "Kodu Yeniden G\xf6nder",
    "Reset your password": "Şifrenizi sıfırlayın",
    "Reset your Password": "Şifrenizi Sıfırlayın",
    "Send code": "Kod g\xf6nder",
    "Send Code": "Kod G\xf6nder",
    Sending: "G\xf6nderiliyor",
    "Setup TOTP": "Tek kullanımlık şifre kurulumu yap",
    "Show password": "Şifreyi g\xf6ster",
    "Sign in to your account": "Hesabınızda oturum a\xe7ın",
    "Sign In with Amazon": "Amazon ile Oturum A\xe7",
    "Sign In with Apple": "Apple ile Oturum A\xe7",
    "Sign In with Facebook": "Facebook ile Oturum A\xe7",
    "Sign In with Google": "Google ile Oturum A\xe7",
    "Sign in": "Oturum a\xe7",
    "Sign In": "Oturum A\xe7",
    "Signing in": "Oturum a\xe7ılıyor",
    Skip: "Atla",
    Submit: "G\xf6nder",
    Submitting: "G\xf6nderiliyor",
    Username: "Kullanıcı adı",
    "Verify Contact": "Kişiyi Doğrula",
    Verify: "Doğrula",
    "We Emailed You": "Size E-posta G\xf6nderdik",
    "We Sent A Code": "Bir Kod G\xf6nderdik",
    "We Texted You": "Size Mesaj G\xf6nderdik",
    "Your code is on the way. To log in, enter the code we emailed to": "Kodunuz yolda. Oturum a\xe7mak i\xe7in, g\xf6nderdiğimiz e-postadaki kodu girin",
    "Your code is on the way. To log in, enter the code we sent you": "Kodunuz yolda. Oturum a\xe7mak i\xe7in, size g\xf6nderdiğimiz kodu girin",
    "Your code is on the way. To log in, enter the code we texted to": "Kodunuz yolda. Oturum a\xe7mak i\xe7in, g\xf6nderdiğimiz mesajdaki kodu girin",
    "An account with the given email already exists.": "Bu e-postaya ait zaten bir hesap var.",
    "Confirm Sign In": "Oturum A\xe7mayı Doğrula",
    "Have an account? ": "Hesabınız var mı? ",
    "Incorrect username or password": "Yanlış kullanıcı adı ya da şifre",
    "Invalid password format": "Ge\xe7ersiz parola formatı",
    "Invalid phone number format": "Ge\xe7ersiz telefon numarası formatı",
    "Lost your code? ": "Kodu mu kaybettiniz? ",
    "No account? ": "Hesabınız yok mu? ",
    "Password attempts exceeded": "Maksimum oturum a\xe7ma girişimi aşıldı",
    "Sign Out": "\xc7ıkış yap",
    "Sign Up": "Kayıt Ol",
    "User already exists": "Bu kullanıcı zaten var",
    "User does not exist": "B\xf6yle bir kullanıcı mevcut değil",
    "Username cannot be empty": "Kullanıcı adı boş olamaz"
};


const $b9ed182f9ed1e43d$export$6240aeddf7c74bb8 = {
    "Account recovery requires verified contact information": "Восстановление учетной записи требует проверки контактной информации",
    "Back to Sign In": "Назад, чтобы войти",
    "Change Password": "изменять пароль",
    Changing: "Изменение",
    Code: "Код",
    "Confirm Password": "Подтверждение пароля",
    "Confirm Sign Up": "Подтверждение зарегистрироваться",
    "Confirm SMS Code": "Подтверждение CMC-Код",
    "Confirm TOTP Code": "Подтверждение TOTP-Код",
    Confirm: "Подтверждать",
    "Confirmation Code": "код подтверждения",
    Confirming: "подтверждение",
    "Create a new account": "Создавать новую учетную запись",
    "Create Account": "Создать учетную запись",
    "Creating Account": "создание учетная запись",
    "Dismiss alert": "Закрыть оповещение",
    Email: "электронная почта",
    "Enter your code": "ввести ваш Код",
    "Enter your Email": "ввести ваш электронная почта",
    "Enter your phone number": "ввести ваш номер телефона",
    "Enter your username": "ввести ваш имя пользователя",
    "Forgot your password?": "Забыли ваш пароль?",
    "Hide password": "Скрывать пароль",
    "It may take a minute to arrive": "Доставка может занять некоторое время",
    Loading: "Загрузка",
    "New password": "Новый пароль",
    or: "или",
    Password: "Пароль",
    "Phone Number": "Номер телефона",
    "Resend Code": "Отправь еще раз Код",
    "Reset your password": "сброс ваш пароль",
    "Reset your Password": "сброс ваш Пароль",
    "Send code": "Отправлять Код",
    "Send Code": "Отправлять Код",
    Sending: "отправка",
    "Setup TOTP": "Настраивать TOTP",
    "Show password": "Показывать пароль",
    "Sign in to your account": "знак в свой аккаунт",
    "Sign In with Amazon": "знак в с Amazon",
    "Sign In with Apple": "знак в с Apple",
    "Sign In with Facebook": "знак в с Facebook",
    "Sign In with Google": "знак в с Google",
    "Sign in": "знак в",
    "Sign In": "знак в",
    "Signing in": "подписание в",
    Skip: "Пропускать",
    Submit: "Представлять на рассмотрение",
    Submitting: "Представив",
    Username: "Имя пользователя",
    "Verify Contact": "Проверить контакт",
    Verify: "Проверить",
    "We Emailed You": "Мы отправили вам электронное письмо",
    "We Sent A Code": "Мы отправили код",
    "We Texted You": "Мы отправили вам текстовое сообщение",
    "Your code is on the way. To log in, enter the code we emailed to": "Ваш код отправлен. Чтобы войти в систему, введите код, который мы отправили по электронной почте",
    "Your code is on the way. To log in, enter the code we sent you": "Ваш код отправлен. Чтобы войти в систему, введите код, который мы послали вам",
    "Your code is on the way. To log in, enter the code we texted to": "Ваш код отправлен. Чтобы войти в систему, введите код, который мы отправили текстовым сообщением"
};


const $0e46c8b46934ddf9$export$b2ba232c100e7a36 = {
    "Account recovery requires verified contact information": "שחזור לקוח דורש עוד מידע",
    "Back to Sign In": "חזור להרשמה",
    "Change Password": "עדכון סיסמא",
    Changing: "מעדכן",
    Code: "קוד",
    "Confirm Password": "אשר סיסמא",
    "Confirm Sign Up": "אשר הרשמה",
    "Confirm SMS Code": "אשר sms קוד",
    "Confirm TOTP Code": "אשר totp קוד",
    Confirm: "אישור",
    "Confirmation Code": "אישור קוד",
    Confirming: "מאשר",
    "Create a new account": "צור משתמש חדש",
    "Create Account": "צור משתמש",
    "Creating Account": "יצירת משתמש",
    "Dismiss alert": "הסר התראה",
    Email: "אימייל",
    "Enter your code": "הכנס את הקוד",
    "Enter your Email": "הכנס את המייל שלך",
    "Enter your phone number": "הכנס את מספר הטלפון שלך",
    "Enter your username": "הכנס את שם המתמש שלך",
    "Forgot your password?": "שחכת סיסמא ?",
    "Hide password": "הסתר סיסמא",
    Loading: "טוען",
    "New password": "סיסמא חדשה",
    or: "אוֹ",
    Password: "סיסמא",
    "Phone Number": "מספר טלפון",
    "Resend Code": "שלח קוד שוב",
    "Reset your password": "אפס סיסמא",
    "Reset your Password": "אפס סיסמא",
    "Send code": "שלח קוד",
    "Send Code": "שלח קוד",
    Sending: "שולח",
    "Setup TOTP": "Setup TOTP",
    "Show password": "הצג סיסמא",
    "Sign in to your account": "התחבר לחשבון שלך",
    "Sign In with Amazon": "Sign In with Amazon",
    "Sign In with Apple": "Sign In with Apple",
    "Sign In with Facebook": "Sign In with Facebook",
    "Sign In with Google": "Sign In with Google",
    "Sign in": "התחבר",
    "Sign In": "התחבר",
    "Signing in": "מתחבר",
    Skip: "דלג",
    Submit: "שלח",
    Submitting: "שולח",
    Username: "שם משתמש",
    "Verify Contact": "אמת איש קשר",
    Verify: "אמת"
};


const $bb6b084d8388e57a$export$373d6304c6310960 = {
    "Account recovery requires verified contact information": "Відновлення облікового запису потребує контактної інформації",
    "Back to Sign In": "Назад на сторінку входу",
    "Change Password": "Змінити пароль",
    Changing: "Змінюємо",
    Code: "Код",
    "Confirm Password": "Підтвердіть пароль",
    "Confirm Sign Up": "Підтвердіть реєстрацію",
    "Confirm SMS Code": "Підтвердіть SMS код",
    "Confirm TOTP Code": "Підтвердіть TOTP код",
    Confirm: "Підтвердити",
    "Confirmation Code": "Код підтвердження",
    Confirming: "Підтверджуємо",
    "Create a new account": "Зареєструватися",
    "Create Account": "Зареєструватися",
    "Creating Account": "Реєструємо",
    "Dismiss alert": "Відхилити сповіщення",
    Email: "Email",
    "Enter your code": "Введіть код",
    "Enter your Email": "Введіть ваш email",
    "Enter your phone number": "Введіть ваш номер телефону",
    "Enter your username": "Введіть ваше імʼя користувача",
    "Forgot password?": "Забули пароль?",
    "Forgot your password?": "Забули ваш пароль?",
    "Hide password": "Сховати пароль",
    "It may take a minute to arrive": "Доставка може тривати хвилину",
    Loading: "Загружаємо",
    "New password": "Новий пароль",
    or: "або",
    Password: "Пароль",
    "Phone Number": "Номер Телефону",
    "Resend Code": "Відправити код повторно",
    "Reset your password": "Скинути пароль",
    "Reset your Password": "Скинути пароль",
    "Send code": "Відправити код",
    "Send Code": "Відправити код",
    Sending: "Відправляємо",
    "Setup TOTP": "Налаштувати TOTP",
    "Show password": "Показати пароль",
    "Sign in to your account": "Увійти у ваш обліковий запис",
    "Sign In with Amazon": "Увійти з Amazon",
    "Sign In with Apple": "Увійти з Apple",
    "Sign In with Facebook": "Увійти з Facebook",
    "Sign In with Google": "Увійти з Google",
    "Sign in": "Увійти",
    "Sign In": "Увійти",
    "Signing in": "Входимо",
    Skip: "Пропустити",
    Submit: "Відправити",
    Submitting: "Відправляємо",
    Username: "Імʼя користувача",
    "Verify Contact": "Підтвердити Контакт",
    Verify: "Підтвердити",
    "We Emailed You": "Ми відправили вам Email",
    "We Sent A Code": "Ми відправили код",
    "We Texted You": "Ми відправили вам текстове повідомлення",
    "Your code is on the way. To log in, enter the code we emailed to": "Ваш код вже в дорозі. Щоб увійти, введіть код, що ми відправили вам на Email",
    "Your code is on the way. To log in, enter the code we sent you": "Ваш код вже в дорозі. Щоб увійти, введіть код, що ми вам відправили",
    "Your code is on the way. To log in, enter the code we texted to": "Ваш код вже в дорозі. Щоб увійти, введіть код, що ми відправили вам текстовим повідомленням",
    "An account with the given email already exists.": "Обліковий запис з цим Email вже існує.",
    "Confirm a Code": "Підтвердіть код",
    "Confirm Sign In": "Підтвердіть вхід",
    "Forgot Password": "Забули пароль",
    "Incorrect username or password.": "Невірне імʼя користувача або пароль",
    "Invalid password format": "Невірний формат паролю",
    "Invalid phone number format": "Невірний формат номеру телефону",
    "Loading...": "Загружаємо...",
    "New Password": "Новий пароль",
    "Resend a Code": "Відправити код повторно",
    "Reset Password": "Скинути пароль",
    "Sign Out": "Вийти",
    "Sign Up with Amazon": "Зареєструватися з Amazon",
    "Sign Up with Apple": "Зареєструватися з Apple",
    "Sign Up with Facebook": "Зареєструватися з Facebook",
    "Sign Up with Google": "Зареєструватися з Google",
    "Sign Up": "Зареєструватися",
    "User already exists": "Користувач вже існує",
    "User does not exist": "Такий користувач не існує",
    "Username cannot be empty": "Імʼя користувача не може бути пустим",
    "Your passwords must match": "Паролі мають збігатися"
};


const $1eee138ac3691b0e$export$320d289eca4cc695 = {
    ADD_PROFILE: "Add your Profile",
    ADD_WEBSITE: "Add your Website",
    BACK_SIGN_IN: "Back to Sign In",
    BIRTHDATE: "Birthdate",
    CHANGE_PASSWORD: "Change Password",
    CHANGING_PASSWORD: "Changing",
    CODE: "Code",
    CODE_ARRIVAL: "It may take a minute to arrive",
    CODE_EMAILED: "Your code is on the way. To log in, enter the code we emailed to",
    CODE_SENT: "Your code is on the way. To log in, enter the code we sent you",
    CODE_TEXTED: "Your code is on the way. To log in, enter the code we texted to",
    CONFIRM_PASSWORD: "Confirm Password",
    CONFIRM_PASSWORD_PLACEHOLDER: "Please confirm your Password",
    CONFIRM_RESET_PASSWORD_HEADING: "Reset your Password",
    CONFIRM_SIGNUP_HEADING: "Confirm Sign Up",
    CONFIRM_SMS: "Confirm SMS Code",
    CONFIRM_TOTP: "Confirm TOTP Code",
    CONFIRM: "Confirm",
    CONFIRMATION_CODE: "Confirmation Code",
    CONFIRMING: "Confirming",
    CREATE_ACCOUNT: "Create Account",
    CREATING_ACCOUNT: "Creating Account",
    EMAIL_ADDRESS: "Email",
    ENTER_BIRTHDATE: "Enter your Birthdate",
    ENTER_CODE: "Enter your code",
    ENTER_CONFIRMATION_CODE: "Enter your Confirmation Code",
    ENTER_EMAIL: "Enter your Email",
    ENTER_FAMILY_NAME: "Enter your Family Name",
    ENTER_GIVEN_NAME: "Enter your Given Name",
    ENTER_MIDDLE_NAME: "Enter your Middle Name",
    ENTER_NAME: "Enter your Name",
    ENTER_NICK_NAME: "Enter your Nickname",
    ENTER_PASSWORD: "Enter your Password",
    ENTER_PHONE_NUMBER: "Enter your Phone Number",
    ENTER_PREFERRED_USERNAME: "Enter your Preferred Username",
    ENTER_USERNAME: "Enter your username",
    FAMILY_NAME: "Family Name",
    GIVEN_NAME: "Given Name",
    FORGOT_PASSWORD: "Forgot Password?",
    FORGOT_YOUR_PASSWORD: "Forgot your password?",
    HIDE_PASSWORD: "Hide password",
    LOADING: "Loading",
    LOGIN_NAME: "Username",
    MIDDLE_NAME: "Middle Name",
    NAME: "Name",
    NICKNAME: "Nickname",
    NEW_PASSWORD: "New password",
    OR: "or",
    PASSWORD: "Password",
    PHONE_NUMBER: "Phone Number",
    PREFERRED_USERNAME: "Preferred Username",
    PROFILE: "Profile",
    RESEND_CODE: "Resend Code",
    RESET_PASSWORD_HEADING: "Reset your password",
    RESET_PASSWORD: "Reset Password",
    SEND_CODE: "Send code",
    SENDING: "Sending",
    SETUP_TOTP: "Setup TOTP",
    SHOW_PASSWORD: "Show password",
    SIGN_IN_BUTTON: "Sign in",
    SIGN_IN_TAB: "Sign In",
    SIGN_IN_WITH_AMAZON: "Sign In with Amazon",
    SIGN_IN_WITH_APPLE: "Sign In with Apple",
    SIGN_IN_WITH_FACEBOOK: "Sign In with Facebook",
    SIGN_IN_WITH_GOOGLE: "Sign In with Google",
    SIGN_IN: "Sign in to your account",
    SIGN_UP_BUTTON: "Create a new account",
    SIGNING_IN_BUTTON: "Signing in",
    SKIP: "Skip",
    SUBMIT: "Submit",
    SUBMITTING: "Submitting",
    UPPERCASE_COPY: "COPY",
    VERIFY_CONTACT: "Verify Contact",
    VERIFY_HEADING: "Account recovery requires verified contact information",
    VERIFY: "Verify",
    WE_EMAILED: "We Emailed You",
    WE_SENT_CODE: "We Sent A Code",
    WE_TEXTED: "We Texted You",
    WEBSITE: "Website"
};


const $e7da1c6b71f2277a$export$cca4a41bdb910c51 = Object.assign({}, (0, $cec93b89401f2ac4$export$cca4a41bdb910c51)), $e7da1c6b71f2277a$export$eb91f595f110d703 = Object.assign({}, (0, $13df23282510920f$export$eb91f595f110d703)), $e7da1c6b71f2277a$export$1d204a99f5862ba9 = Object.assign({}, (0, $bc0cbe1bca826ee5$export$1d204a99f5862ba9)), $e7da1c6b71f2277a$export$8cfa91bfcf8d11c8 = Object.assign({}, (0, $52a47444632ab115$export$8cfa91bfcf8d11c8)), $e7da1c6b71f2277a$export$5c8da73de176fccc = Object.assign({}, (0, $717e9293ca4c2e82$export$5c8da73de176fccc)), $e7da1c6b71f2277a$export$c416809cd76fbf21 = Object.assign({}, (0, $9e673c60e47bada7$export$c416809cd76fbf21)), $e7da1c6b71f2277a$export$fb1930c2b96707b2 = Object.assign({}, (0, $6477146b757640a2$export$fb1930c2b96707b2)), $e7da1c6b71f2277a$export$c27bce1749452052 = Object.assign({}, (0, $a4749e521de863ab$export$c27bce1749452052)), $e7da1c6b71f2277a$export$8569df33fbaae243 = Object.assign({}, (0, $e63da870d1f88394$export$8569df33fbaae243)), $e7da1c6b71f2277a$export$6fb0e8139f7ef98d = Object.assign({}, (0, $5c4e8b51540d3bc2$export$6fb0e8139f7ef98d)), $e7da1c6b71f2277a$export$c7dddbf179b434d1 = Object.assign({}, (0, $9d399419f4d4e971$export$c7dddbf179b434d1)), $e7da1c6b71f2277a$export$2a86dc37ee9734c = Object.assign({}, (0, $774c9e3bde4b9031$export$2a86dc37ee9734c)), $e7da1c6b71f2277a$export$9f1a61f9baaa2d2e = Object.assign({}, (0, $a31d1351f89f754f$export$9f1a61f9baaa2d2e)), $e7da1c6b71f2277a$export$710642024bfcbd8f = Object.assign({}, (0, $ce078a1076ca272b$export$710642024bfcbd8f)), $e7da1c6b71f2277a$export$6961fa2059aeacf0 = Object.assign({}, (0, $3d7f382f0e68fb29$export$6961fa2059aeacf0)), $e7da1c6b71f2277a$export$6240aeddf7c74bb8 = Object.assign({}, (0, $b9ed182f9ed1e43d$export$6240aeddf7c74bb8)), $e7da1c6b71f2277a$export$b2ba232c100e7a36 = Object.assign({}, (0, $0e46c8b46934ddf9$export$b2ba232c100e7a36)), $e7da1c6b71f2277a$export$373d6304c6310960 = Object.assign({}, (0, $bb6b084d8388e57a$export$373d6304c6310960)), $e7da1c6b71f2277a$export$320d289eca4cc695 = Object.assign({}, (0, $1eee138ac3691b0e$export$320d289eca4cc695));


const $237c4f1f3df38a24$export$6ba37fd455cdd594 = Object.assign({}, (0, $e7da1c6b71f2277a$export$320d289eca4cc695));
function $237c4f1f3df38a24$export$d73ee8ef04f5226a(n) {
    return (0, $a204f73577cd8409$export$dbe3113d60765c1a).get(n);
}
function $237c4f1f3df38a24$export$8a4bbd9646545970(n) {
    return (0, $a204f73577cd8409$export$dbe3113d60765c1a).get(n) !== n;
}
const $237c4f1f3df38a24$export$150b732325d14d04 = {
    de: (0, $e7da1c6b71f2277a$export$cca4a41bdb910c51),
    en: (0, $e7da1c6b71f2277a$export$eb91f595f110d703),
    es: (0, $e7da1c6b71f2277a$export$1d204a99f5862ba9),
    fr: (0, $e7da1c6b71f2277a$export$8cfa91bfcf8d11c8),
    id: (0, $e7da1c6b71f2277a$export$710642024bfcbd8f),
    it: (0, $e7da1c6b71f2277a$export$5c8da73de176fccc),
    ja: (0, $e7da1c6b71f2277a$export$c416809cd76fbf21),
    kr: (0, $e7da1c6b71f2277a$export$fb1930c2b96707b2),
    ko: (0, $e7da1c6b71f2277a$export$fb1930c2b96707b2),
    nb: (0, $e7da1c6b71f2277a$export$c27bce1749452052),
    nl: (0, $e7da1c6b71f2277a$export$8569df33fbaae243),
    pl: (0, $e7da1c6b71f2277a$export$6fb0e8139f7ef98d),
    pt: (0, $e7da1c6b71f2277a$export$c7dddbf179b434d1),
    zh: (0, $e7da1c6b71f2277a$export$2a86dc37ee9734c),
    sv: (0, $e7da1c6b71f2277a$export$9f1a61f9baaa2d2e),
    tr: (0, $e7da1c6b71f2277a$export$6961fa2059aeacf0),
    ru: (0, $e7da1c6b71f2277a$export$6240aeddf7c74bb8),
    he: (0, $e7da1c6b71f2277a$export$b2ba232c100e7a36),
    ua: (0, $e7da1c6b71f2277a$export$373d6304c6310960)
};


const $36731f3be083bc16$export$850c34c1087496e6 = (r)=>{
    const o = Object.assign({}, r);
    for (const [t, s] of Object.entries(r)){
        const { label: r, placeholder: n } = s;
        o[t] = Object.assign(Object.assign({}, s), {
            label: r ? (0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)(r) : void 0,
            placeholder: n ? (0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)(n) : void 0
        });
    }
    return o;
}, $36731f3be083bc16$export$c610ae674f32e5d9 = (e)=>Object.entries(e).sort((e, r)=>(e[1].order || Number.MAX_VALUE) - (r[1].order || Number.MAX_VALUE)).filter((e)=>void 0 !== e[1]);


const $25596f583072a9fa$export$bafc1c085dad2945 = (s, t)=>(0, (0, $ed1bf37d7912eeb0$export$9bcaa03841470ad7)[s])(t), $25596f583072a9fa$export$40c1faef715b9f52 = (r, i)=>{
    var o, a;
    const c = null === (a = null === (o = (0, $1b0fbba0bcf650b5$export$c39505fa2700473f)(i)) || void 0 === o ? void 0 : o.formFields) || void 0 === a ? void 0 : a[r];
    return c && 0 !== Object.keys(c).length ? Object.entries(c).reduce((t, [o, a])=>{
        if ("signIn" !== r && "resetPassword" !== r || "username" !== o) {
            if ((0, $192735b175258082$export$fed672849e2dd0ad)(o)) {
                const s = (0, $5c28317e8c66931c$export$1222d357a3c2c47f)[o], r = Object.assign(Object.assign({}, s), a);
                return Object.assign(Object.assign({}, t), {
                    [o]: r
                });
            }
            return Object.assign(Object.assign({}, t), {
                [o]: a
            });
        }
        {
            const s = (0, $ed1bf37d7912eeb0$export$447e18c20e391f9)(i), e = Object.assign(Object.assign({}, s), a);
            return Object.assign(Object.assign({}, t), {
                [o]: e
            });
        }
    }, {}) : {};
}, $25596f583072a9fa$export$5e097831852eb087 = (s, t)=>{
    const e = $25596f583072a9fa$export$bafc1c085dad2945(s, t), r = $25596f583072a9fa$export$40c1faef715b9f52(s, t), n = Object.assign(Object.assign({}, e), r);
    return delete n.QR, (0, $36731f3be083bc16$export$850c34c1087496e6)(n);
}, $25596f583072a9fa$export$8f6c429ad9970441 = (s)=>s.map((s)=>[
            s[0],
            Object.assign(Object.assign({}, s[1]), {
                order: void 0
            })
        ]), $25596f583072a9fa$export$2fcee3580f06a0ca = (s, t)=>{
    const e = $25596f583072a9fa$export$5e097831852eb087(s, t);
    return $25596f583072a9fa$export$8f6c429ad9970441((0, $36731f3be083bc16$export$c610ae674f32e5d9)(e));
};


const $6a1c2365d32daf45$export$297d226dd86a0de7 = [
    "confirmResetPassword",
    "confirmSignIn",
    "confirmSignUp",
    "confirmVerifyUser",
    "forceNewPassword",
    "resetPassword",
    "setupTOTP",
    "signIn",
    "signUp",
    "verifyUser"
];
const $6a1c2365d32daf45$export$8ccdb5ff21fda761 = [
    "ConfirmResetPassword",
    "ConfirmSignIn",
    "ConfirmSignUp",
    "ConfirmVerifyUser",
    "ForceNewPassword",
    "ResetPassword",
    "SetupTOTP",
    "SignIn",
    "SignUp",
    "VerifyUser"
];


const $9fa087fb07001a5e$export$65443658c81b32cc = (route)=>(0, $6a1c2365d32daf45$export$297d226dd86a0de7).some((componentRoute)=>componentRoute === route);
function $9fa087fb07001a5e$export$a909c85e22b33d81(defaults, overrides) {
    if (!overrides) return defaults;
    return (0, $6a1c2365d32daf45$export$8ccdb5ff21fda761).reduce((components, route)=>{
        const Default = defaults[route];
        const Override = overrides[route];
        if (typeof Override !== "function") return Object.assign(Object.assign({}, components), {
            [route]: Default
        });
        const { Footer: Footer, FormFields: FormFields, Header: Header } = Default;
        // cast to allow assigning of component slots
        const Component = Override;
        Component.Footer = Footer;
        Component.FormFields = FormFields;
        Component.Header = Header;
        return Object.assign(Object.assign({}, components), {
            [route]: Component
        });
    }, {});
}


const $6e995d800410e71d$export$6756c954b2014a15 = ()=>false;
/**
 * Does an ordering and shallow comparison of each array value,
 * plus a value equality check for empty objects and arrays.
 */ function $6e995d800410e71d$export$6d39b5fae5236692(currentDeps, nextDeps) {
    if (currentDeps.length !== nextDeps.length) return false;
    return currentDeps.every((currentDep, index)=>{
        const nextDep = nextDeps[index];
        if ((0, $15a7c5986a3f06c2$export$2c02be4a78959098)(currentDep, nextDep) || (0, $15a7c5986a3f06c2$export$d6708a3543c32fe4)(currentDep, nextDep)) return true;
        return currentDep === nextDep;
    });
}
const $6e995d800410e71d$export$1f14d6e84ea4650a = (selector)=>(currentFacade, nextFacade)=>{
        const currentSelectorDeps = selector(currentFacade);
        const nextSelectorDeps = selector(nextFacade);
        // Shallow compare the array values
        return $6e995d800410e71d$export$6d39b5fae5236692(currentSelectorDeps, nextSelectorDeps);
    };
const $6e995d800410e71d$export$4680a6e0cbf2b7d7 = (state)=>{
    var _a, _b, _c;
    return Object.assign({}, (_c = (_b = (_a = (0, $1b0fbba0bcf650b5$export$c39505fa2700473f)(state)) === null || _a === void 0 ? void 0 : _a.formFields) === null || _b === void 0 ? void 0 : _b.setupTOTP) === null || _c === void 0 ? void 0 : _c.QR);
};
const $6e995d800410e71d$export$bc28d83edeb430b5 = (user)=>function getTotpSecretCode() {
        return (0, $41adf626f46b9a45$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return yield (0, $cc420cb14b670b2a$export$334c29725a78c21d).setupTOTP(user);
        });
    };
const $6e995d800410e71d$var$flattenFormFields = (fields)=>fields.flatMap(([name, options])=>Object.assign({
            name: name
        }, options));
const $6e995d800410e71d$var$convertContactMethodsToFields = (unverifiedContactMethods)=>{
    return unverifiedContactMethods && Object.entries(unverifiedContactMethods).map(([name, value])=>{
        const valueIsString = (0, $15a7c5986a3f06c2$export$844ec244b1367d54)(value);
        if (!valueIsString || !name) return {};
        return {
            name: name,
            label: value,
            type: "radio",
            value: value
        };
    });
};
/**
 * Retrieves default and custom (RWA only, to be updated) form field values from state machine
 * for subcomponent routes that render fields
 */ const $6e995d800410e71d$export$e72db6842cb587a1 = (route, state, unverifiedContactMethods)=>{
    if ((0, $9fa087fb07001a5e$export$65443658c81b32cc)(route)) return route === "verifyUser" ? $6e995d800410e71d$var$convertContactMethodsToFields(unverifiedContactMethods) : $6e995d800410e71d$var$flattenFormFields((0, $25596f583072a9fa$export$2fcee3580f06a0ca)(route, state));
    return [];
};


/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/connected-components/authenticator/headless#useauthenticator-hook)
 */ function $636ff7311f818a38$export$2e2bcd8739ae039(selector) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $cde51257bc807626$export$2254a7bd02a5abf7));
    if (!context) throw new Error((0, $ffecdd06c91dc243$export$7e92b2e9f0809b11));
    const { service: service } = context;
    const { send: send } = service;
    const xstateSelector = (0, $acw62.useCallback)((state)=>Object.assign({}, (0, $df90a4e3a95e1de7$export$5f925d5954b1c10b)({
            send: send,
            state: state
        })), [
        send
    ]);
    const comparator = selector ? (0, $6e995d800410e71d$export$1f14d6e84ea4650a)(selector) : (0, $6e995d800410e71d$export$6756c954b2014a15);
    // the purpose of `context.authStatus`is to intentionally override `facade.authStatus`. `facade.authStatus` does
    // not update on external sign in events (for example when a user is not using the `Authenticator`).
    const { authStatus: authStatus } = context;
    const facade = (0, $9b3a0cd13590dfd2$export$2105062e25df4afe)(service, xstateSelector, comparator);
    const { route: route, totpSecretCode: totpSecretCode, unverifiedContactMethods: unverifiedContactMethods, user: user } = facade, rest = (0, $41adf626f46b9a45$export$3c9a16f847548506)(facade, [
        "route",
        "totpSecretCode",
        "unverifiedContactMethods",
        "user"
    ]);
    // do not memoize output. `service.getSnapshot` reference remains stable preventing
    // `fields` from updating with current form state on value changes
    const serviceSnapshot = service.getSnapshot();
    // legacy `QRFields` values only used for SetupTOTP page to retrieve issuer information, will be removed in future
    const QRFields = route === "setupTOTP" ? (0, $6e995d800410e71d$export$4680a6e0cbf2b7d7)(serviceSnapshot) : null;
    // legacy `formFields` values required until form state is removed from state machine
    const fields = (0, $6e995d800410e71d$export$e72db6842cb587a1)(route, serviceSnapshot, unverifiedContactMethods);
    return Object.assign(Object.assign({}, rest), {
        authStatus: authStatus,
        route: route,
        totpSecretCode: totpSecretCode,
        unverifiedContactMethods: unverifiedContactMethods,
        user: user,
        fields: /** @deprecated For internal use only */ fields,
        getTotpSecretCode: (0, $6e995d800410e71d$export$bc28d83edeb430b5)(user),
        QRFields: QRFields
    });
}



var $a3478a115f13707d$exports = {};
"use client";
"use strict";
var $a3478a115f13707d$var$Y = Object.create;
var $a3478a115f13707d$var$E = Object.defineProperty;
var $a3478a115f13707d$var$q = Object.getOwnPropertyDescriptor;
var $a3478a115f13707d$var$G = Object.getOwnPropertyNames;
var $a3478a115f13707d$var$K = Object.getPrototypeOf, $a3478a115f13707d$var$Z = Object.prototype.hasOwnProperty;
var $a3478a115f13707d$var$ee = (e, t)=>{
    for(var o in t)$a3478a115f13707d$var$E(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $a3478a115f13707d$var$j = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let r of $a3478a115f13707d$var$G(t))!$a3478a115f13707d$var$Z.call(e, r) && r !== o && $a3478a115f13707d$var$E(e, r, {
        get: ()=>t[r],
        enumerable: !(s = $a3478a115f13707d$var$q(t, r)) || s.enumerable
    });
    return e;
};
var $a3478a115f13707d$var$W = (e, t, o)=>(o = e != null ? $a3478a115f13707d$var$Y($a3478a115f13707d$var$K(e)) : {}, $a3478a115f13707d$var$j(t || !e || !e.__esModule ? $a3478a115f13707d$var$E(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $a3478a115f13707d$var$te = (e)=>$a3478a115f13707d$var$j($a3478a115f13707d$var$E({}, "__esModule", {
        value: !0
    }), e);
var $a3478a115f13707d$var$Ve = {};
$a3478a115f13707d$var$ee($a3478a115f13707d$var$Ve, {
    CheckmarkIcon: ()=>$a3478a115f13707d$var$F,
    ErrorIcon: ()=>$a3478a115f13707d$var$w,
    LoaderIcon: ()=>$a3478a115f13707d$var$M,
    ToastBar: ()=>$a3478a115f13707d$var$$,
    ToastIcon: ()=>$a3478a115f13707d$var$U,
    Toaster: ()=>$a3478a115f13707d$var$J,
    default: ()=>$a3478a115f13707d$var$_e,
    resolveValue: ()=>$a3478a115f13707d$var$u,
    toast: ()=>$a3478a115f13707d$var$n,
    useToaster: ()=>$a3478a115f13707d$var$V,
    useToasterStore: ()=>$a3478a115f13707d$var$_
});
$a3478a115f13707d$exports = $a3478a115f13707d$var$te($a3478a115f13707d$var$Ve);
var $a3478a115f13707d$var$oe = (e)=>typeof e == "function", $a3478a115f13707d$var$u = (e, t)=>$a3478a115f13707d$var$oe(e) ? e(t) : e;
var $a3478a115f13707d$var$Q = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $a3478a115f13707d$var$R = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $a3478a115f13707d$var$re = 20;
var $a3478a115f13707d$var$v = new Map, $a3478a115f13707d$var$se = 1e3, $a3478a115f13707d$var$X = (e)=>{
    if ($a3478a115f13707d$var$v.has(e)) return;
    let t = setTimeout(()=>{
        $a3478a115f13707d$var$v.delete(e), $a3478a115f13707d$var$l({
            type: 4,
            toastId: e
        });
    }, $a3478a115f13707d$var$se);
    $a3478a115f13707d$var$v.set(e, t);
}, $a3478a115f13707d$var$ae = (e)=>{
    let t = $a3478a115f13707d$var$v.get(e);
    t && clearTimeout(t);
}, $a3478a115f13707d$var$H = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $a3478a115f13707d$var$re)
            };
        case 1:
            return t.toast.id && $a3478a115f13707d$var$ae(t.toast.id), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === t.toast.id ? {
                        ...a,
                        ...t.toast
                    } : a)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((a)=>a.id === o.id) ? $a3478a115f13707d$var$H(e, {
                type: 1,
                toast: o
            }) : $a3478a115f13707d$var$H(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $a3478a115f13707d$var$X(s) : e.toasts.forEach((a)=>{
                $a3478a115f13707d$var$X(a.id);
            }), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === s || s === void 0 ? {
                        ...a,
                        visible: !1
                    } : a)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((a)=>a.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let r = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((a)=>({
                        ...a,
                        pauseDuration: a.pauseDuration + r
                    }))
            };
    }
}, $a3478a115f13707d$var$I = [], $a3478a115f13707d$var$D = {
    toasts: [],
    pausedAt: void 0
}, $a3478a115f13707d$var$l = (e)=>{
    $a3478a115f13707d$var$D = $a3478a115f13707d$var$H($a3478a115f13707d$var$D, e), $a3478a115f13707d$var$I.forEach((t)=>{
        t($a3478a115f13707d$var$D);
    });
}, $a3478a115f13707d$var$ie = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $a3478a115f13707d$var$_ = (e = {})=>{
    let [t, o] = (0, (parcelRequire("acw62")).useState)($a3478a115f13707d$var$D);
    (0, (parcelRequire("acw62")).useEffect)(()=>($a3478a115f13707d$var$I.push(o), ()=>{
            let r = $a3478a115f13707d$var$I.indexOf(o);
            r > -1 && $a3478a115f13707d$var$I.splice(r, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((r)=>{
        var a, c;
        return {
            ...e,
            ...e[r.type],
            ...r,
            duration: r.duration || ((a = e[r.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || $a3478a115f13707d$var$ie[r.type],
            style: {
                ...e.style,
                ...(c = e[r.type]) == null ? void 0 : c.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $a3478a115f13707d$var$ce = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $a3478a115f13707d$var$Q()
    }), $a3478a115f13707d$var$S = (e)=>(t, o)=>{
        let s = $a3478a115f13707d$var$ce(t, e, o);
        return $a3478a115f13707d$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $a3478a115f13707d$var$n = (e, t)=>$a3478a115f13707d$var$S("blank")(e, t);
$a3478a115f13707d$var$n.error = $a3478a115f13707d$var$S("error");
$a3478a115f13707d$var$n.success = $a3478a115f13707d$var$S("success");
$a3478a115f13707d$var$n.loading = $a3478a115f13707d$var$S("loading");
$a3478a115f13707d$var$n.custom = $a3478a115f13707d$var$S("custom");
$a3478a115f13707d$var$n.dismiss = (e)=>{
    $a3478a115f13707d$var$l({
        type: 3,
        toastId: e
    });
};
$a3478a115f13707d$var$n.remove = (e)=>$a3478a115f13707d$var$l({
        type: 4,
        toastId: e
    });
$a3478a115f13707d$var$n.promise = (e, t, o)=>{
    let s = $a3478a115f13707d$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((r)=>($a3478a115f13707d$var$n.success($a3478a115f13707d$var$u(t.success, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), r)).catch((r)=>{
        $a3478a115f13707d$var$n.error($a3478a115f13707d$var$u(t.error, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};

var $a3478a115f13707d$var$pe = (e, t)=>{
    $a3478a115f13707d$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $a3478a115f13707d$var$de = ()=>{
    $a3478a115f13707d$var$l({
        type: 5,
        time: Date.now()
    });
}, $a3478a115f13707d$var$V = (e)=>{
    let { toasts: t, pausedAt: o } = $a3478a115f13707d$var$_(e);
    (0, (parcelRequire("acw62")).useEffect)(()=>{
        if (o) return;
        let a = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (a - i.createdAt);
            if (d < 0) {
                i.visible && $a3478a115f13707d$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$a3478a115f13707d$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("acw62")).useCallback)(()=>{
        o && $a3478a115f13707d$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), r = (0, (parcelRequire("acw62")).useCallback)((a, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (a.position || p) && m.height), z = g.findIndex((m)=>m.id === a.id), O = g.filter((m, B)=>B < z && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            O + 1
        ] : [
            0,
            O
        ]).reduce((m, B)=>m + (B.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $a3478a115f13707d$var$pe,
            startPause: $a3478a115f13707d$var$de,
            endPause: s,
            calculateOffset: r
        }
    };
};

var $a3478a115f13707d$var$T = $a3478a115f13707d$var$W((parcelRequire("acw62")));
let $59bacf62d0c4a6b9$var$e = {
    data: ""
}, $59bacf62d0c4a6b9$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $59bacf62d0c4a6b9$var$e, $59bacf62d0c4a6b9$export$54aba348a7896325 = (e)=>{
    let r = $59bacf62d0c4a6b9$var$t(e), l = r.data;
    return r.data = "", l;
}, $59bacf62d0c4a6b9$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $59bacf62d0c4a6b9$var$a = /\/\*[^]*?\*\/|  +/g, $59bacf62d0c4a6b9$var$n = /\n+/g, $59bacf62d0c4a6b9$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $59bacf62d0c4a6b9$var$o(c, n) : n + "{" + $59bacf62d0c4a6b9$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $59bacf62d0c4a6b9$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $59bacf62d0c4a6b9$var$o.p ? $59bacf62d0c4a6b9$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $59bacf62d0c4a6b9$var$c = {}, $59bacf62d0c4a6b9$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $59bacf62d0c4a6b9$var$s(e[r]);
        return t;
    }
    return e;
}, $59bacf62d0c4a6b9$var$i = (e, t, r, i, p)=>{
    let u = $59bacf62d0c4a6b9$var$s(e), d = $59bacf62d0c4a6b9$var$c[u] || ($59bacf62d0c4a6b9$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$59bacf62d0c4a6b9$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $59bacf62d0c4a6b9$var$l.exec(e.replace($59bacf62d0c4a6b9$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($59bacf62d0c4a6b9$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($59bacf62d0c4a6b9$var$n, " ").trim();
            return o[0];
        })(e);
        $59bacf62d0c4a6b9$var$c[d] = $59bacf62d0c4a6b9$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $59bacf62d0c4a6b9$var$c.g ? $59bacf62d0c4a6b9$var$c.g : null;
    return r && ($59bacf62d0c4a6b9$var$c.g = $59bacf62d0c4a6b9$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($59bacf62d0c4a6b9$var$c[d], t, i, f), d;
}, $59bacf62d0c4a6b9$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $59bacf62d0c4a6b9$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $59bacf62d0c4a6b9$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $59bacf62d0c4a6b9$var$i(l.unshift ? l.raw ? $59bacf62d0c4a6b9$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $59bacf62d0c4a6b9$var$t(r.target), r.g, r.o, r.k);
}
let $59bacf62d0c4a6b9$var$d, $59bacf62d0c4a6b9$var$f, $59bacf62d0c4a6b9$var$g, $59bacf62d0c4a6b9$export$442f1a04865e4790 = $59bacf62d0c4a6b9$export$dbf350e5966cf602.bind({
    g: 1
}), $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e = $59bacf62d0c4a6b9$export$dbf350e5966cf602.bind({
    k: 1
});
function $59bacf62d0c4a6b9$export$de27182ff8187d6c(e, t, r, l) {
    $59bacf62d0c4a6b9$var$o.p = t, $59bacf62d0c4a6b9$var$d = e, $59bacf62d0c4a6b9$var$f = r, $59bacf62d0c4a6b9$var$g = l;
}
function $59bacf62d0c4a6b9$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $59bacf62d0c4a6b9$var$f && $59bacf62d0c4a6b9$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $59bacf62d0c4a6b9$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $59bacf62d0c4a6b9$var$g && i[0] && $59bacf62d0c4a6b9$var$g(c), $59bacf62d0c4a6b9$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}



var $a3478a115f13707d$var$y = $a3478a115f13707d$var$W((parcelRequire("acw62")));


var $a3478a115f13707d$var$me = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $a3478a115f13707d$var$ue = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $a3478a115f13707d$var$le = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $a3478a115f13707d$var$w = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$a3478a115f13707d$var$me} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$a3478a115f13707d$var$ue} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$a3478a115f13707d$var$le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var $a3478a115f13707d$var$Te = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $a3478a115f13707d$var$M = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$a3478a115f13707d$var$Te} 1s linear infinite;
`;

var $a3478a115f13707d$var$fe = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $a3478a115f13707d$var$ye = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $a3478a115f13707d$var$F = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$a3478a115f13707d$var$fe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$a3478a115f13707d$var$ye} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $a3478a115f13707d$var$ge = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: absolute;
`, $a3478a115f13707d$var$he = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $a3478a115f13707d$var$xe = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $a3478a115f13707d$var$be = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$a3478a115f13707d$var$xe} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $a3478a115f13707d$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$be, null, t) : t : o === "blank" ? null : $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$he, null, $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$M, {
        ...s
    }), o !== "loading" && $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$ge, null, o === "error" ? $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$w, {
        ...s
    }) : $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$F, {
        ...s
    })));
};
var $a3478a115f13707d$var$Se = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $a3478a115f13707d$var$Ae = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $a3478a115f13707d$var$Pe = "0%{opacity:0;} 100%{opacity:1;}", $a3478a115f13707d$var$Oe = "0%{opacity:1;} 100%{opacity:0;}", $a3478a115f13707d$var$Ee = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $a3478a115f13707d$var$Re = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $a3478a115f13707d$var$ve = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [r, a] = $a3478a115f13707d$var$R() ? [
        $a3478a115f13707d$var$Pe,
        $a3478a115f13707d$var$Oe
    ] : [
        $a3478a115f13707d$var$Se(s),
        $a3478a115f13707d$var$Ae(s)
    ];
    return {
        animation: t ? `${(0, $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e)(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e)(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $a3478a115f13707d$var$$ = $a3478a115f13707d$var$T.memo(({ toast: e, position: t, style: o, children: s })=>{
    let r = e.height ? $a3478a115f13707d$var$ve(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, a = $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$U, {
        toast: e
    }), c = $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$Re, {
        ...e.ariaProps
    }, $a3478a115f13707d$var$u(e.message, e));
    return $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$Ee, {
        className: e.className,
        style: {
            ...r,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: a,
        message: c
    }) : $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$T.Fragment, null, a, c));
});


var $a3478a115f13707d$var$f = $a3478a115f13707d$var$W((parcelRequire("acw62")));
(0, $59bacf62d0c4a6b9$export$de27182ff8187d6c)($a3478a115f13707d$var$f.createElement);
var $a3478a115f13707d$var$Ie = ({ id: e, className: t, style: o, onHeightUpdate: s, children: r })=>{
    let a = $a3478a115f13707d$var$f.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $a3478a115f13707d$var$f.createElement("div", {
        ref: a,
        className: t,
        style: o
    }, r);
}, $a3478a115f13707d$var$De = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, r = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $a3478a115f13707d$var$R() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...r
    };
}, $a3478a115f13707d$var$ke = $59bacf62d0c4a6b9$export$dbf350e5966cf602`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $a3478a115f13707d$var$L = 16, $a3478a115f13707d$var$J = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: r, containerStyle: a, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $a3478a115f13707d$var$V(o);
    return $a3478a115f13707d$var$f.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $a3478a115f13707d$var$L,
            left: $a3478a115f13707d$var$L,
            right: $a3478a115f13707d$var$L,
            bottom: $a3478a115f13707d$var$L,
            pointerEvents: "none",
            ...a
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, z = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), O = $a3478a115f13707d$var$De(g, z);
        return $a3478a115f13707d$var$f.createElement($a3478a115f13707d$var$Ie, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $a3478a115f13707d$var$ke : "",
            style: O
        }, p.type === "custom" ? $a3478a115f13707d$var$u(p.message, p) : r ? r(p) : $a3478a115f13707d$var$f.createElement($a3478a115f13707d$var$$, {
            toast: p,
            position: g
        }));
    }));
};
var $a3478a115f13707d$var$_e = $a3478a115f13707d$var$n;



const $06daed6f3dfa6bfa$var$UPPERCASE = /[\p{Lu}]/u;
const $06daed6f3dfa6bfa$var$LOWERCASE = /[\p{Ll}]/u;
const $06daed6f3dfa6bfa$var$LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu;
const $06daed6f3dfa6bfa$var$IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u;
const $06daed6f3dfa6bfa$var$SEPARATORS = /[_.\- ]+/;
const $06daed6f3dfa6bfa$var$LEADING_SEPARATORS = new RegExp("^" + $06daed6f3dfa6bfa$var$SEPARATORS.source);
const $06daed6f3dfa6bfa$var$SEPARATORS_AND_IDENTIFIER = new RegExp($06daed6f3dfa6bfa$var$SEPARATORS.source + $06daed6f3dfa6bfa$var$IDENTIFIER.source, "gu");
const $06daed6f3dfa6bfa$var$NUMBERS_AND_IDENTIFIER = new RegExp("\\d+" + $06daed6f3dfa6bfa$var$IDENTIFIER.source, "gu");
const $06daed6f3dfa6bfa$var$preserveCamelCase = (string, toLowerCase, toUpperCase, preserveConsecutiveUppercase)=>{
    let isLastCharLower = false;
    let isLastCharUpper = false;
    let isLastLastCharUpper = false;
    let isLastLastCharPreserved = false;
    for(let index = 0; index < string.length; index++){
        const character = string[index];
        isLastLastCharPreserved = index > 2 ? string[index - 3] === "-" : true;
        if (isLastCharLower && $06daed6f3dfa6bfa$var$UPPERCASE.test(character)) {
            string = string.slice(0, index) + "-" + string.slice(index);
            isLastCharLower = false;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = true;
            index++;
        } else if (isLastCharUpper && isLastLastCharUpper && $06daed6f3dfa6bfa$var$LOWERCASE.test(character) && (!isLastLastCharPreserved || preserveConsecutiveUppercase)) {
            string = string.slice(0, index - 1) + "-" + string.slice(index - 1);
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = false;
            isLastCharLower = true;
        } else {
            isLastCharLower = toLowerCase(character) === character && toUpperCase(character) !== character;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = toUpperCase(character) === character && toLowerCase(character) !== character;
        }
    }
    return string;
};
const $06daed6f3dfa6bfa$var$preserveConsecutiveUppercase = (input, toLowerCase)=>{
    $06daed6f3dfa6bfa$var$LEADING_CAPITAL.lastIndex = 0;
    return input.replaceAll($06daed6f3dfa6bfa$var$LEADING_CAPITAL, (match)=>toLowerCase(match));
};
const $06daed6f3dfa6bfa$var$postProcess = (input, toUpperCase)=>{
    $06daed6f3dfa6bfa$var$SEPARATORS_AND_IDENTIFIER.lastIndex = 0;
    $06daed6f3dfa6bfa$var$NUMBERS_AND_IDENTIFIER.lastIndex = 0;
    return input.replaceAll($06daed6f3dfa6bfa$var$NUMBERS_AND_IDENTIFIER, (match, pattern, offset)=>[
            "_",
            "-"
        ].includes(input.charAt(offset + match.length)) ? match : toUpperCase(match)).replaceAll($06daed6f3dfa6bfa$var$SEPARATORS_AND_IDENTIFIER, (_, identifier)=>toUpperCase(identifier));
};
function $06daed6f3dfa6bfa$export$2e2bcd8739ae039(input, options) {
    if (!(typeof input === "string" || Array.isArray(input))) throw new TypeError("Expected the input to be `string | string[]`");
    options = {
        pascalCase: false,
        preserveConsecutiveUppercase: false,
        ...options
    };
    if (Array.isArray(input)) input = input.map((x)=>x.trim()).filter((x)=>x.length).join("-");
    else input = input.trim();
    if (input.length === 0) return "";
    const toLowerCase = options.locale === false ? (string)=>string.toLowerCase() : (string)=>string.toLocaleLowerCase(options.locale);
    const toUpperCase = options.locale === false ? (string)=>string.toUpperCase() : (string)=>string.toLocaleUpperCase(options.locale);
    if (input.length === 1) {
        if ($06daed6f3dfa6bfa$var$SEPARATORS.test(input)) return "";
        return options.pascalCase ? toUpperCase(input) : toLowerCase(input);
    }
    const hasUpperCase = input !== toLowerCase(input);
    if (hasUpperCase) input = $06daed6f3dfa6bfa$var$preserveCamelCase(input, toLowerCase, toUpperCase, options.preserveConsecutiveUppercase);
    input = input.replace($06daed6f3dfa6bfa$var$LEADING_SEPARATORS, "");
    input = options.preserveConsecutiveUppercase ? $06daed6f3dfa6bfa$var$preserveConsecutiveUppercase(input, toLowerCase) : toLowerCase(input);
    if (options.pascalCase) input = toUpperCase(input.charAt(0)) + input.slice(1);
    return $06daed6f3dfa6bfa$var$postProcess(input, toUpperCase);
}



var $666bc8f27f76152a$exports = {};
(function(global, factory) {
    $666bc8f27f76152a$exports = factory();
})($666bc8f27f76152a$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


function $3b479ead6613d9c6$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $3b479ead6613d9c6$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $3b479ead6613d9c6$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
const $3b479ead6613d9c6$export$a6cdc56e425d0d0a = (value)=>{
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !$3b479ead6613d9c6$export$43bee75e5e14138e(value);
};
const $3b479ead6613d9c6$export$630801d484da15df = (value)=>value == null;
function $3b479ead6613d9c6$export$2de9850507a2d6ef(value) {
    // @ts-ignore
    return !isNaN(new Date(value));
}
function $3b479ead6613d9c6$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(...args) {
        fns.forEach((fn)=>{
            if ($3b479ead6613d9c6$export$f6e2535fb5126e54(fn)) fn?.(...args);
        });
    };
}
function $3b479ead6613d9c6$export$9d1611c77c2fe928(...args) {
    const result = {};
    for (const props of args){
        for(const key in result){
            if (/^on[A-Z]/.test(key) && typeof result[key] === "function" && typeof props[key] === "function") result[key] = $3b479ead6613d9c6$export$9dd9a52f2dd5b9ce(result[key], props[key]);
            else if (key === "className" && typeof result.className === "string" && typeof props.className === "string") result[key] = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(result.className, props.className);
            else result[key] = props[key] !== undefined ? props[key] : result[key];
        }
        // Add props from b that are not in a
        for(const key in props)if (result[key] === undefined) result[key] = props[key];
    }
    return result;
}
const $3b479ead6613d9c6$export$acc031eeb74f06a6 = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).set(`spa`, "1", {
        expires: 7
    });
    setTimeout(()=>window.location.reload(), 500);
};
function $3b479ead6613d9c6$export$c383cdd2a518017a(input) {
    return input?.replace(/\W/g, "_");
}
function $3b479ead6613d9c6$export$e7493836a310b8ae(event) {
    const target = event.target;
    const key = event.key;
    const tabs = Array.prototype.slice.call(target?.closest('[role="tablist"]')?.querySelectorAll('[role="tab"]'));
    let index = tabs.indexOf(target);
    if (key.includes("Arrow")) {
        switch(key){
            case "ArrowLeft":
            case "ArrowUp":
                index = index > 0 ? index - 1 : tabs.length - 1;
                break;
            case "ArrowRight":
            case "ArrowDown":
                index = index < tabs.length - 1 ? index + 1 : 0;
                break;
        }
        tabs[index].click();
        tabs[index].focus();
        event.preventDefault();
    }
}
function $3b479ead6613d9c6$export$f5d3771428a1f489() {
    document.documentElement.scrollTop = 0;
}
function $3b479ead6613d9c6$export$5daebee201e83c0c(bytes) {
    if (!$3b479ead6613d9c6$export$7e4aa119212bc614(bytes)) return "0 B";
    const giga = bytes / 1024 / 1024 / 1024;
    return giga >= 0.5 ? `${giga}GB` : `${giga * 1024}MB`;
}


const $0b89d474933103bc$export$40edfb7eeb78c4e8 = false // TODO: DEBUG
;
const $0b89d474933103bc$export$51eecb37fb2685e = $0b89d474933103bc$export$40edfb7eeb78c4e8 ? {
    region: "us-east-2",
    userPoolId: "us-east-2_kAqZcxIeM",
    userPoolWebClientId: "1qi1uijg8b6ra70nejvbptis0q",
    oauthProviders: []
} : {
    region: "us-east-1",
    userPoolId: "us-east-1_dtagLnju8",
    userPoolWebClientId: "69cs1lgme7p8kbgld8n5kseii6",
    oauthProviders: []
};
function $0b89d474933103bc$var$getAuthValueFromStorage(key) {
    const prefix = `CognitoIdentityServiceProvider.${$0b89d474933103bc$export$51eecb37fb2685e.userPoolWebClientId}`;
    const authUser = localStorage.getItem(`${prefix}.${$0b89d474933103bc$export$51eecb37fb2685e.userPoolWebClientId}.LastAuthUser`);
    if (!authUser) return;
    return localStorage.getItem(`${prefix}.${$0b89d474933103bc$export$51eecb37fb2685e.userPoolWebClientId}.${authUser}.${key?.trim()}`);
}
const $0b89d474933103bc$export$6dc2f20681470473 = ()=>{
    return (visualViewport?.width || document.documentElement.clientWidth) <= 640;
};
const $0b89d474933103bc$var$defaultAppState = {
    isDev: $0b89d474933103bc$export$40edfb7eeb78c4e8,
    os: $3f953c817c94cd75$export$2e2bcd8739ae039,
    isMobile: (0, $3f953c817c94cd75$export$2e2bcd8739ae039).android || (0, $3f953c817c94cd75$export$2e2bcd8739ae039).ios,
    sm: $0b89d474933103bc$export$6dc2f20681470473(),
    userInfo: {
        pending: false,
        username: null,
        signInUserSession: null,
        attributes: null,
        signOut: ()=>Promise.resolve()
    },
    releases: {
        fetching: false,
        downloads: {},
        e: false
    },
    discord: {
        guild: null,
        approximate_member_count: 0,
        approximate_presence_count: 0
    }
};
const $0b89d474933103bc$var$appState = (0, $2f66ed5559a61356$export$4af2f85fc25cecbb)($0b89d474933103bc$var$defaultAppState);
const $0b89d474933103bc$var$proState = (0, $2f66ed5559a61356$export$4af2f85fc25cecbb)({});
const $0b89d474933103bc$var$modalsState = (0, $2f66ed5559a61356$export$4af2f85fc25cecbb)({
    modals: []
});
const $0b89d474933103bc$var$releasesEndpoint = "https://api.github.com/repos/logseq/logseq/releases";
const $0b89d474933103bc$var$discordEndpoint = "https://discord.com/api/v9/invites/VNfUaTtdFb?with_counts=true&with_expiration=true";
const $0b89d474933103bc$var$fileSyncEndpoint = "https://api-dev.logseq.com/file-sync";
const $0b89d474933103bc$var$logseqEndpoint = $0b89d474933103bc$export$40edfb7eeb78c4e8 ? "https://api-dev.logseq.com/logseq" : "https://api.logseq.com/logseq";
const $0b89d474933103bc$export$5121340c35540c56 = $0b89d474933103bc$export$40edfb7eeb78c4e8 ? "https://logseq.lemonsqueezy.com/checkout/buy/f9a3c7cb-b8eb-42b5-b22a-7dfafad8dc09" : "https://logseq.lemonsqueezy.com/checkout/buy/4828e0c2-e189-4102-9a90-c7101e53d525";
let $0b89d474933103bc$var$appliedLogin = false;
function $0b89d474933103bc$export$37b049f4acd59173(user, t) {
    // for logout
    if ($0b89d474933103bc$var$appliedLogin && !user && t.routeLocation.pathname.startsWith("/account") && t.routeLocation.pathname !== "/login") {
        t.navigate("/login");
        return;
    }
    if (user?.username && user?.pool && user?.signInUserSession) {
        $0b89d474933103bc$var$appState.userInfo.set({
            signOut: async ()=>{
                console.time();
                $0b89d474933103bc$var$appState.userInfo.pending.set(true);
                await (0, $cc420cb14b670b2a$export$334c29725a78c21d).signOut();
                $0b89d474933103bc$var$appState.userInfo.pending.set(false);
                $0b89d474933103bc$var$proState.set({});
                console.timeEnd();
                $0b89d474933103bc$var$appState.userInfo.set({});
            },
            username: user.username,
            signInUserSession: user.signInUserSession,
            attributes: user.attributes,
            pending: false
        });
        // TODO: debug
        if (!t.inComponent) (0, (/*@__PURE__*/$parcel$interopDefault($a3478a115f13707d$exports))).success(`Hi, ${user.username} !`, {
            position: "top-center"
        });
        if (t.routeLocation.pathname === "/login") t.navigate("/account", {
            replace: true
        });
    }
    $0b89d474933103bc$var$appliedLogin = true;
}
function $0b89d474933103bc$export$b8798340c9b3a9aa(attachedState) {
    const userInfo = $0b89d474933103bc$export$9973955de2bf96cf().userInfo.get();
    async function loadAPI(type, setState = false, opts = {}) {
        try {
            // @ts-ignore
            const idToken = userInfo.signInUserSession?.idToken?.jwtToken;
            const res = await fetch(`${$0b89d474933103bc$var$logseqEndpoint}/${type}`, Object.assign(opts.init || {}, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    ...opts.init?.headers || {}
                }
            }));
            const json = await res.json();
            if (setState) {
                if (setState === true) attachedState?.[(0, $06daed6f3dfa6bfa$export$2e2bcd8739ae039)(type)].set(json);
                else setState?.[(0, $06daed6f3dfa6bfa$export$2e2bcd8739ae039)(type)].set(json);
            }
            return json;
        } catch (e) {
            !opts.notShowErrMsg && (0, (/*@__PURE__*/$parcel$interopDefault($a3478a115f13707d$exports))).error(e.message);
            return e;
        }
    }
    return {
        loadAPI: loadAPI
    };
}
function $0b89d474933103bc$export$85179ee6899ffd85() {
    const { user: user } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)(({ user: user })=>[
            user
        ]);
    const routeLocation = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { proState: proState, loadProInfo: loadProInfo } = $0b89d474933103bc$export$40ee919bcae6be56();
    const userInfoValue = $0b89d474933103bc$var$appState.userInfo.get();
    // @ts-ignore
    const idToken = userInfoValue.signInUserSession?.idToken?.jwtToken;
    (0, $acw62.useEffect)(()=>{
        if (!idToken) proState.set({});
        else if (!proState.get().info) loadProInfo().catch(null);
    }, [
        idToken
    ]);
    (0, $acw62.useEffect)(()=>{
        $0b89d474933103bc$export$37b049f4acd59173(user, {
            navigate: navigate,
            routeLocation: routeLocation
        });
    }, [
        user?.username
    ]);
}
function $0b89d474933103bc$export$f4699e7eb4dbacec() {
    const state = $0b89d474933103bc$export$9973955de2bf96cf();
    (0, $acw62.useEffect)(()=>{
        if (!state.releases.fetching.value) {
            state.releases.fetching.set(true);
            fetch($0b89d474933103bc$var$releasesEndpoint).then((res)=>res.json()).then((json)=>{
                // TODO: parse downloads
                let latestRelease = null;
                if (json && Array.isArray(json)) {
                    json.some((it)=>{
                        if (it.hasOwnProperty("tag_name") && it.tag_name?.toLowerCase() !== "nightly" && Array.isArray(it.assets)) {
                            const platformMappings = {
                                "macos-x64": (it)=>it.includes("x64") && it.endsWith(".dmg"),
                                "macos-arm64": (it)=>it.includes("arm64") && it.endsWith(".dmg"),
                                "android": (it)=>it.endsWith(".apk"),
                                "linux": (it)=>it.endsWith(".AppImage"),
                                "windows": (it)=>it.endsWith(".exe")
                            };
                            latestRelease = it.assets.reduce((a, b)=>{
                                Object.entries(platformMappings).some(([label, validator])=>{
                                    if (validator(b.name)) {
                                        a[label] = b;
                                        return true;
                                    }
                                });
                                return a;
                            }, {});
                            return true;
                        }
                    });
                    state.releases.downloads.set(latestRelease);
                }
                if (!latestRelease) throw new Error("Parse latest release failed!");
            }).catch((e)=>{
                state.releases.e.set(e);
            }).finally(()=>{
                state.releases.fetching.set(false);
            });
        }
    }, []);
    return state.releases;
}
function $0b89d474933103bc$export$b948d46d7006ea9f() {
    const state = $0b89d474933103bc$export$9973955de2bf96cf();
    (0, $acw62.useEffect)(()=>{
        fetch($0b89d474933103bc$var$discordEndpoint).then((res)=>res.json()).then((json)=>{
            if (json && json.guild) state.discord.set(json);
        }).catch((e)=>{
            console.debug("[Fetch Discord Err]", e);
        });
    }, []);
    return state.discord;
}
function $0b89d474933103bc$export$9973955de2bf96cf() {
    return (0, $2f66ed5559a61356$export$7a18e83a30d41594)($0b89d474933103bc$var$appState);
}
function $0b89d474933103bc$export$40ee919bcae6be56() {
    const appState = $0b89d474933103bc$export$9973955de2bf96cf();
    const userInfo = appState.value.userInfo;
    const hookProState = (0, $2f66ed5559a61356$export$7a18e83a30d41594)($0b89d474933103bc$var$proState);
    const proStateValue = hookProState.get({
        noproxy: true
    });
    const proFreeTrialEndsAt = proStateValue?.info?.FreeTrialEndsAt?.LogseqPro;
    const inTrial = proFreeTrialEndsAt && new Date(proFreeTrialEndsAt).getTime() > Date.now() && proStateValue.info?.LemonStatus?.LogseqPro !== "active";
    // @ts-ignore
    const idToken = userInfo.signInUserSession?.idToken?.jwtToken;
    async function loadProInfo() {
        try {
            hookProState.infoFetching?.set(true);
            const resp = await fetch(`${$0b89d474933103bc$var$logseqEndpoint}/user_info`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${idToken}`
                }
            });
            if (resp.status !== 200) throw new Error(resp.statusText);
            const info = await resp.json();
            // normalize info
            info.FileSyncStorageLimit.currentFormatted = (0, $3b479ead6613d9c6$export$5daebee201e83c0c)(info.FileSyncStorageLimit?.current);
            info.FileSyncStorageLimit.proFormatted = (0, $3b479ead6613d9c6$export$5daebee201e83c0c)(info.FileSyncStorageLimit?.pro);
            info.FileSyncStorageLimit.freeFormatted = (0, $3b479ead6613d9c6$export$5daebee201e83c0c)(info.FileSyncStorageLimit?.free);
            hookProState.info.set(info);
        } catch (e) {
            console.error("[Request ProState] ", e);
            hookProState.e.set(e);
        } finally{
            hookProState.infoFetching?.set(false);
        }
    }
    return {
        proState: hookProState,
        proStateValue: proStateValue,
        inTrial: inTrial,
        loadProInfo: loadProInfo
    };
}
function $0b89d474933103bc$export$2572ce01b45dd98c() {
    const { proState: proState } = $0b89d474933103bc$export$40ee919bcae6be56();
    const { loadAPI: loadAPI } = $0b89d474933103bc$export$b8798340c9b3a9aa(proState);
    return {
        getSubscriptions: ()=>proState.lemonListSubscriptions.get({
                noproxy: true
            }),
        subscriptionsFetching: proState.subscriptionsFetching.get(),
        loadSubscriptions: async ()=>{
            proState.subscriptionsFetching.set(true);
            return loadAPI("lemon_list_subscriptions", true).finally(()=>proState.subscriptionsFetching.set(false));
        },
        cancelSubscription: async (subId)=>{
            await loadAPI("lemon_cancel_subscription", false, {
                init: {
                    body: JSON.stringify({
                        "subscription-id": subId
                    })
                }
            });
        },
        pauseSubscription: async (subId, resumesAt)=>{
            const body = {
                "subscription-id": parseInt(subId),
                "mode": "free"
            };
            if (resumesAt) {
                if (!(0, $3b479ead6613d9c6$export$2de9850507a2d6ef)(resumesAt)) throw new Error(`Invalid resumes at date input! #${resumesAt}`);
                body["resumes-at"] = new Date(resumesAt).toISOString();
            }
            await loadAPI("lemon_pause_subscription", false, {
                init: {
                    body: JSON.stringify(body)
                }
            });
        },
        unpauseSubscription: async (subId)=>{
            const body = {
                "subscription-id": parseInt(subId)
            };
            await loadAPI("lemon_unpause_subscription", false, {
                init: {
                    body: JSON.stringify(body)
                }
            });
        },
        startFreeTrial: async ()=>{
            if (proState.value?.info?.ProUser) return;
            await loadAPI("start_free_trial", false, {
                init: {
                    body: JSON.stringify({
                        project: "LogseqPro"
                    })
                }
            });
        },
        getSubscriptionRelatedInfo: async (subId, resources = [
            "subscription-invoices"
        ])=>{
            const body = {
                "subscription-id": parseInt(subId),
                "related-resources": resources
            };
            try {
                proState.subscriptionRelatedInfo.merge({
                    [subId]: {
                        pending: true
                    }
                });
                await new Promise((resolve)=>setTimeout(resolve, 5000));
                const ret = await loadAPI("lemon_get_subscription_related_resources", false, {
                    init: {
                        body: JSON.stringify(body)
                    }
                });
                for(let k in ret){
                    if (typeof ret[k]?.body === "string") try {
                        ret[k].body = JSON.parse(ret[k].body);
                    } catch (e) {
                        console.error(e);
                    }
                }
                proState.subscriptionRelatedInfo.merge({
                    [subId]: ret
                });
                return ret;
            } catch (e) {
                console.error(e);
                proState.subscriptionRelatedInfo.merge({
                    [subId]: (0, $2f66ed5559a61356$export$f883a24d5edde77c)
                });
            }
        }
    };
}
const $0b89d474933103bc$export$e04651bb69aab204 = (ms)=>{
    const m = {
        modals: ms.modals,
        topmost: ()=>{
            if (!m.modals?.length) return;
            let it;
            // @ts-ignore
            while(it = m.modals.get({
                noproxy: true
            }).pop()){
                if (it.visible) return it;
            }
        },
        remove: (id)=>ms.modals.set((v)=>{
                const i = v.findIndex((m)=>m.id === id);
                if (i != -1) v.splice(i, 1);
                return v;
            }),
        create: (contentFn, props)=>{
            const id = Date.now();
            const idx = ms.modals.length;
            ms.modals.set((v)=>{
                v.push({
                    id: id,
                    visible: false,
                    content: contentFn(()=>m.remove(id)),
                    props: props
                });
                return v;
            });
            return {
                id: id,
                show: ()=>ms.modals[idx].visible.set(true),
                hide: ()=>ms.modals[idx].visible.set(false),
                destroy: ()=>m.remove(id)
            };
        }
    };
    return m;
};
const $0b89d474933103bc$export$92e2981dd294f32 = $0b89d474933103bc$export$e04651bb69aab204($0b89d474933103bc$var$modalsState);
function $0b89d474933103bc$export$1a159e6ed632e23b() {
    const hookModalsState = (0, $2f66ed5559a61356$export$7a18e83a30d41594)($0b89d474933103bc$var$modalsState);
    return $0b89d474933103bc$export$e04651bb69aab204(hookModalsState);
}
// @ts-ignore
window.__appState = $0b89d474933103bc$var$appState;
// @ts-ignore
window.__proState = $0b89d474933103bc$var$proState;
// @ts-ignore
window.__modalFacade = $0b89d474933103bc$export$92e2981dd294f32;





var $acw62 = parcelRequire("acw62");

const $e0d8a96345a359ae$export$931cbfb6bfb85fc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { className: className, children: children, wrapItems: wrapItems, subItemClassName: subItemClassName, items: items, triggerType: triggerType, ...dropdownProps } = props;
    const triggerProps = {};
    const [active, setActive] = (0, $acw62.useState)(false);
    ref = ref || (0, $acw62.useRef)(null);
    const triggerClickable = triggerType === "click";
    if (triggerClickable) {
        triggerProps.onClick = ()=>setActive(!active);
        const _onClick = dropdownProps.onClick;
        dropdownProps.onClick = (e)=>{
            const target = e.target;
            if (!target?.closest(".sub-items")) return;
            setActive(false);
            _onClick?.(e);
        };
    } else {
        dropdownProps.onMouseEnter = ()=>setActive(true);
        dropdownProps.onMouseLeave = ()=>setActive(false);
    }
    // outside click effect
    (0, $acw62.useEffect)(()=>{
        const host = document.documentElement;
        const handler = (e)=>{
            const target = e.target;
            // @ts-ignore
            if (ref?.current?.contains(target)) return;
            setActive(false);
        };
        if (triggerClickable) host.addEventListener("mouseup", handler, false);
        else host.removeEventListener("mouseup", handler);
        return ()=>host.removeEventListener("mouseup", handler);
    }, [
        triggerClickable
    ]);
    const wrapSubItems = (children)=>wrapItems === false ? children : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("sub-items flex flex-col absolute top-5 right-0 w-full", triggerClickable ? "mt-6" : "pt-6", subItemClassName),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sub-items-inner",
                children: children
            })
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("ui-dropdown", className, active && "is-active"),
        ref: ref,
        ...dropdownProps,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "trigger",
                ...triggerProps,
                children: children
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(items) ? wrapSubItems(items) : items?.length > 0 && wrapSubItems(items.map((it, idx)=>{
                const { className: className, ...rest } = it.props || {};
                if (it.render) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("ui-menu-item", className),
                    ...rest,
                    children: typeof it.render === "function" ? it.render(it) : it.render
                }, it.key || idx);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("block ui-menu-item", className),
                    ...rest,
                    children: it.text
                }, it.key || idx);
            }))
        ]
    });
});


var $c8c7f30e4318e2ae$exports = {};

$c8c7f30e4318e2ae$exports = new URL((parcelRequire("27Lyk")).resolve("dnCB2"), import.meta.url).toString();


const $6b83dbd58d0bae96$var$iosImageQr = new URL($c8c7f30e4318e2ae$exports);
var $4b3eab3a8e490a8a$exports = {};

$4b3eab3a8e490a8a$exports = new URL((parcelRequire("27Lyk")).resolve("2CJz7"), import.meta.url).toString();


const $6b83dbd58d0bae96$var$intelImageIcon = new URL($4b3eab3a8e490a8a$exports);
var $ed71448354072f7b$exports = {};

$ed71448354072f7b$exports = new URL((parcelRequire("27Lyk")).resolve("5lxRr"), import.meta.url).toString();


const $6b83dbd58d0bae96$var$M1ImageIcon = new URL($ed71448354072f7b$exports);
var $3826e538175db949$exports = {};

$3826e538175db949$exports = new URL((parcelRequire("27Lyk")).resolve("1ST8Z"), import.meta.url).toString();


const $6b83dbd58d0bae96$var$WindowsImageIcon = new URL($3826e538175db949$exports);
var $69afcbb2967f414e$exports = {};

$69afcbb2967f414e$exports = new URL((parcelRequire("27Lyk")).resolve("01gZy"), import.meta.url).toString();


const $6b83dbd58d0bae96$var$LinuxImageIcon = new URL($69afcbb2967f414e$exports);
var $a103f82ae7bb1f54$exports = {};

$a103f82ae7bb1f54$exports = new URL((parcelRequire("27Lyk")).resolve("VVesg"), import.meta.url).toString();


const $6b83dbd58d0bae96$var$GooglePlayImageIcon = new URL($a103f82ae7bb1f54$exports);
var $a87621c8d027316e$exports = {};

$a87621c8d027316e$exports = new URL((parcelRequire("27Lyk")).resolve("aJ7de"), import.meta.url).toString();


const $6b83dbd58d0bae96$var$AppleImageIcon = new URL($a87621c8d027316e$exports);
var $84aeeeedb9b378cc$exports = {};

$84aeeeedb9b378cc$exports = new URL((parcelRequire("27Lyk")).resolve("czuDQ"), import.meta.url).toString();


var $18ff318295440f18$exports = {};

$18ff318295440f18$exports = new URL((parcelRequire("27Lyk")).resolve("omoo4"), import.meta.url).toString();


var $b6cfb9466d45e2f1$exports = {};

$b6cfb9466d45e2f1$exports = new URL((parcelRequire("27Lyk")).resolve("l2Qaz"), import.meta.url).toString();


var $80a2fb8a6c629845$exports = {};

$80a2fb8a6c629845$exports = new URL((parcelRequire("27Lyk")).resolve("f4g5u"), import.meta.url).toString();


var $9faf952f59bae8c9$exports = {};

$9faf952f59bae8c9$exports = new URL((parcelRequire("27Lyk")).resolve("428fk"), import.meta.url).toString();


const $6b83dbd58d0bae96$var$releaseImages = {
    "macos": new URL($84aeeeedb9b378cc$exports),
    "windows": new URL($18ff318295440f18$exports),
    "linux": new URL($b6cfb9466d45e2f1$exports),
    "ios": new URL($80a2fb8a6c629845$exports),
    "android": new URL($9faf952f59bae8c9$exports)
};
const $6b83dbd58d0bae96$var$IntelIcon = (props)=>{
    const { className: className, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("color-icon flex rounded overflow-hidden items-center justify-center", className),
        ...rest,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: $6b83dbd58d0bae96$var$intelImageIcon,
            className: "w-4/5",
            alt: "intel"
        })
    });
};
const $6b83dbd58d0bae96$var$M1Icon = (props)=>{
    const { className: className, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("color-icon flex rounded overflow-hidden items-center justify-center", className),
        ...rest,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: $6b83dbd58d0bae96$var$M1ImageIcon,
            className: "w-4/5",
            alt: "M1"
        })
    });
};
const $6b83dbd58d0bae96$var$AppleIcon = (props)=>{
    const { className: className, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("color-icon flex rounded overflow-hidden items-center justify-center", className),
        ...rest,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: $6b83dbd58d0bae96$var$AppleImageIcon,
            className: "w-4/5",
            alt: "GooglePlay"
        })
    });
};
const $6b83dbd58d0bae96$var$Windows64Icon = (props)=>{
    const { className: className, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("color-icon flex rounded overflow-hidden items-center justify-center", className),
        ...rest,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: $6b83dbd58d0bae96$var$WindowsImageIcon,
            className: "w-4/5",
            alt: "Windows64"
        })
    });
};
const $6b83dbd58d0bae96$var$LinuxIcon = (props)=>{
    const { className: className, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("color-icon flex rounded overflow-hidden items-center justify-center", className),
        ...rest,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: $6b83dbd58d0bae96$var$LinuxImageIcon,
            className: "w-4/5",
            alt: "GooglePlay"
        })
    });
};
const $6b83dbd58d0bae96$var$GooglePlayIcon = (props)=>{
    const { className: className, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("color-icon flex rounded overflow-hidden items-center justify-center", className),
        ...rest,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: $6b83dbd58d0bae96$var$GooglePlayImageIcon,
            className: "w-4/5",
            alt: "GooglePlay"
        })
    });
};
const $6b83dbd58d0bae96$var$releases = [
    [
        "MacOS",
        (props = {})=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $813e96925f3ecd9f$export$2e2bcd8739ae039), {
                ...props,
                weight: "duotone"
            })
    ],
    [
        "Windows",
        (props = {})=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b85c2e5e1d29b190$export$2e2bcd8739ae039), {
                ...props,
                weight: "duotone"
            })
    ],
    [
        "Linux",
        (props = {})=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $126ba61dfbd934cd$export$2e2bcd8739ae039), {
                ...props,
                weight: "duotone"
            })
    ],
    [
        "iOS",
        (props = {})=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db1c918c88a5ca18$export$2e2bcd8739ae039), {
                ...props,
                weight: "duotone"
            })
    ],
    [
        "Android",
        (props = {})=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $039f66a52898037d$export$2e2bcd8739ae039), {
                ...props,
                weight: "duotone"
            })
    ]
];
const $6b83dbd58d0bae96$var$resolveDownloadHref = (appState, item, isIOS, platform = "")=>{
    const rollback = isIOS ? "https://apps.apple.com/us/app/logseq/id1601013908" : `https://github.com/logseq/logseq/releases`;
    const downloads = appState.releases.downloads.get();
    platform = platform || item?.[0].toString().toLowerCase();
    if (!downloads?.[platform]) return rollback;
    return downloads[platform]?.browser_download_url;
};
function $6b83dbd58d0bae96$export$434a045e59e6bdd3(props = {}) {
    const { className: className, children: children, ...rest } = props;
    const appState = (0, $0b89d474933103bc$export$9973955de2bf96cf)();
    const wrapElRef = (0, $acw62.useRef)(null);
    const os = appState.get().os;
    const [active, setActive] = (0, $acw62.useState)($6b83dbd58d0bae96$var$releases[0]);
    const isIOS = active?.[0] === "iOS";
    const isMacOS = active?.[0] === "MacOS";
    const rightIconFn = isMacOS ? (props = {})=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ded21779901b8c91$export$2e2bcd8739ae039), {
            className: "ml-1 opacity-60",
            ...props
        }) : isIOS ? (props = {})=>appState.sm.get() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30a677830140f77c$export$2e2bcd8739ae039), {
            weight: "duotone",
            className: "ml-1 opacity-60",
            ...props
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c95591d3e0a09a63$export$2e2bcd8739ae039), {
            weight: "duotone",
            className: "ml-1 opacity-60",
            ...props
        }) : null;
    (0, $acw62.useEffect)(()=>{
        $6b83dbd58d0bae96$var$releases.some((it)=>{
            if (os[it?.[0].toString().toLowerCase()]) {
                setActive(it);
                return true;
            }
        });
    }, [
        os
    ]);
    const subItems = isMacOS ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "sub-items flex flex-col absolute top-5 right-0 w-full pt-6",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "sub-items-inner",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: "block",
                    href: $6b83dbd58d0bae96$var$resolveDownloadHref(appState, active, isIOS, "macos-x64"),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex pr-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6b83dbd58d0bae96$var$IntelIcon, {
                                    className: "bg-black w-8 h-8"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "w-full flex flex-col opacity-80",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-sm",
                                        children: "Intel chip"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[11px] opacity-60",
                                        children: "Most common in Macs"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: "block",
                    href: $6b83dbd58d0bae96$var$resolveDownloadHref(appState, active, isIOS, "macos-arm64"),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex pr-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6b83dbd58d0bae96$var$M1Icon, {
                                    className: "bg-black w-8 h-8"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "w-full flex flex-col opacity-80",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-sm",
                                        children: "Apple silicon"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[11px] opacity-60",
                                        children: "Macs from November 2020 and later"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    }) : isIOS ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "sub-items absolute top-6 right-2 z-10 flex justify-center translate-x-4 transition-opacity qr",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: $6b83dbd58d0bae96$var$iosImageQr,
            alt: "qr",
            className: "w-3/4"
        })
    }) : null;
    const activePlatformIcon = active?.[1];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0d8a96345a359ae$export$931cbfb6bfb85fc), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("global-downloads-wrap", className),
        ref: wrapElRef,
        items: subItems,
        wrapItems: false,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
            className: "block",
            target: "_blank",
            href: $6b83dbd58d0bae96$var$resolveDownloadHref(appState, active, isIOS),
            children: children({
                active: active,
                leftIconFn: typeof activePlatformIcon === "function" ? activePlatformIcon : ()=>activePlatformIcon,
                rightIconFn: rightIconFn
            })
        })
    });
}
function $6b83dbd58d0bae96$export$d2eba1b222c37e86(props) {
    const { activeRelease: activeRelease, setActiveRelease: setActiveRelease } = props;
    const activeLabel = activeRelease?.[0];
    let activeIcon = activeRelease?.[1];
    if (typeof activeIcon === "function") activeIcon = activeIcon();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("selects", `active-of-${activeLabel?.toLowerCase()}`),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "app-form-select-wrap",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "icon",
                    children: activeIcon
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                    className: "app-form-select w-full",
                    onChange: (e)=>{
                        const item = $6b83dbd58d0bae96$var$releases.find((it)=>{
                            return it[0] === e.target.value;
                        });
                        setActiveRelease(item);
                    },
                    value: activeLabel,
                    children: $6b83dbd58d0bae96$var$releases.map(([label])=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: label,
                            children: label
                        }, label);
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "arrow",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ded21779901b8c91$export$2e2bcd8739ae039), {
                        weight: "bold"
                    })
                })
            ]
        })
    });
}
function $6b83dbd58d0bae96$export$9bf15ed9d201404b(props) {
    const { activeRelease: activeRelease, setActiveRelease: setActiveRelease } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
        className: "tabs flex space-x-8 justify-around",
        role: "tablist",
        children: $6b83dbd58d0bae96$var$releases.map(([label, icon])=>{
            if (typeof icon === "function") icon = icon();
            const isActive = activeRelease[0] === label;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                    active: isActive
                }, `is-${label.toLowerCase()}`),
                onClick: ()=>{
                    setActiveRelease([
                        label,
                        icon
                    ]);
                },
                tabIndex: isActive ? 0 : -1,
                role: "tab",
                "aria-controls": label,
                id: "tab-" + label,
                "aria-selected": isActive,
                onKeyDown: (0, $3b479ead6613d9c6$export$e7493836a310b8ae),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "opacity-60",
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: label
                    })
                ]
            }, label);
        })
    });
}
function $6b83dbd58d0bae96$export$96b05e2ad54f81d1() {
    const appState = (0, $0b89d474933103bc$export$9973955de2bf96cf)();
    const os = appState.get().os;
    const isSm = appState.sm.get();
    let active = $6b83dbd58d0bae96$var$releases[0];
    $6b83dbd58d0bae96$var$releases.some((it)=>{
        if (os[it?.[0].toString().toLowerCase()]) {
            active = it;
            return true;
        }
    });
    const [activeRelease, setActiveRelease] = (0, $acw62.useState)(active);
    const _getDownloadHref = (platform)=>{
        const isIOS = platform === "ios";
        const item = $6b83dbd58d0bae96$var$releases.find((it)=>{
            return it[0].toLowerCase() === platform;
        });
        return $6b83dbd58d0bae96$var$resolveDownloadHref(appState, item, isIOS, platform);
    };
    const resolvePanel = function([label, icon]) {
        const isWindows = label.toLowerCase() === "windows";
        const isAndroid = label.toLowerCase() === "android";
        const isLinux = label.toLowerCase() === "linux";
        const isIOS = label.toLowerCase() === "ios";
        icon = isWindows ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6b83dbd58d0bae96$var$Windows64Icon, {
            className: "bg-black/50 w-6 h-6 sm:w-8 sm:h-8"
        }) : isAndroid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6b83dbd58d0bae96$var$GooglePlayIcon, {
            className: "bg-black/50 w-6 h-6 sm:w-8 sm:h-8"
        }) : isLinux ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6b83dbd58d0bae96$var$LinuxIcon, {
            className: "bg-black/50 w-6 h-6 sm:w-8 sm:h-8"
        }) : isIOS ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6b83dbd58d0bae96$var$AppleIcon, {
            className: "bg-black/50 w-6 h-6 sm:w-8 sm:h-8"
        }) : icon;
        switch(label){
            case "iOS":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full sm:w-auto flex flex-col items-center is-ios cursor-crosshair",
                    id: label,
                    role: "tabpanel",
                    "aria-labelledby": "tab-" + label,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                            className: "w-full bg-logseq-400 px-3 py-3 sm:px-6 sm:py-4",
                            leftIcon: icon,
                            disabled: !isSm,
                            rightIcon: isSm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30a677830140f77c$export$2e2bcd8739ae039), {
                                className: "opacity-50"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c95591d3e0a09a63$export$2e2bcd8739ae039), {
                                className: "opacity-50"
                            }),
                            href: _getDownloadHref("ios"),
                            asAnchor: true,
                            children: "Download on the App Store"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "absolute top-16 z-10 flex justify-center translate-x-4 transition-opacity qr opacity-0",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: $6b83dbd58d0bae96$var$iosImageQr,
                                alt: "qr",
                                className: "w-1/2"
                            })
                        })
                    ]
                });
            case "MacOS":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full sm:w-auto sm:flex sm:space-x-6",
                    id: label,
                    role: "tabpanel",
                    "aria-labelledby": "tab-" + label,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                                    className: "w-full bg-logseq-400 px-3 py-3 sm:px-6 sm:py-4",
                                    leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6b83dbd58d0bae96$var$IntelIcon, {
                                        className: "w-6 h-6 sm:w-8 sm:h-8 bg-gray-900",
                                        color: "white"
                                    }),
                                    rightIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30a677830140f77c$export$2e2bcd8739ae039), {
                                        className: "opacity-50"
                                    }),
                                    href: _getDownloadHref("macos-x64"),
                                    asAnchor: true,
                                    children: "Download for Intel chip"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-xs opacity-60 py-2",
                                    children: "Most common in Macs"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                                    className: "w-full bg-logseq-600 px-3 py-3 sm:px-6 sm:py-4",
                                    leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6b83dbd58d0bae96$var$M1Icon, {
                                        className: "w-6 h-6 sm:w-8 sm:h-8 bg-gray-900",
                                        color: "white"
                                    }),
                                    rightIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30a677830140f77c$export$2e2bcd8739ae039), {
                                        className: "opacity-50"
                                    }),
                                    href: _getDownloadHref("macos-arm64"),
                                    asAnchor: true,
                                    children: "Download for Apple silicon"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-xs opacity-60 py-2",
                                    children: "Macs from November 2020 and later"
                                })
                            ]
                        })
                    ]
                });
            case "Linux":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full sm:w-auto flex flex-col items-center",
                    id: label,
                    role: "tabpanel",
                    "aria-labelledby": "tab-" + label,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                            leftIcon: icon,
                            rightIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30a677830140f77c$export$2e2bcd8739ae039), {
                                className: "opacity-50"
                            }),
                            className: "w-full sm:w-auto bg-logseq-600 px-3 py-3 sm:px-6 sm:py-4",
                            href: _getDownloadHref("linux"),
                            asAnchor: true,
                            children: "Download Linux release"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "opacity-60 py-3",
                            children: [
                                "You are advised to use ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    className: "text-logseq-100",
                                    target: "_blank",
                                    href: "https://github.com/TheAssassin/AppImageLauncher",
                                    children: "AppImageLauncher"
                                }),
                                " for proper desktop integration"
                            ]
                        })
                    ]
                });
            default:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "w-full sm:w-auto",
                    id: label,
                    role: "tabpanel",
                    "aria-labelledby": "tab-" + label,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                        leftIcon: icon,
                        rightIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30a677830140f77c$export$2e2bcd8739ae039), {
                            className: "opacity-50"
                        }),
                        className: "w-full bg-logseq-600 px-3 py-3 sm:px-6 sm:py-4",
                        href: _getDownloadHref(label.toString().toLowerCase()),
                        asAnchor: true,
                        children: [
                            "Download ",
                            label,
                            " release"
                        ]
                    })
                });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-head-downloads",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col pt-10 sm:items-center sm:pt-20 pb-12 text-slogan",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "text-3xl sm:text-6xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-semibold tracking-wide",
                                children: "Download "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-logseq-50/80",
                                children: "the apps."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "text-xl flex flex-col justify-center sm:items-center pt-2 tracking-wide",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-logseq-50/80",
                                children: "Collect your thoughts and get inspired."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "opacity-90",
                                children: "Your train-of-thought is waiting for you!"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "dl-items",
                children: [
                    appState.sm.get() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6b83dbd58d0bae96$export$d2eba1b222c37e86, {
                        activeRelease: activeRelease,
                        setActiveRelease: setActiveRelease
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6b83dbd58d0bae96$export$9bf15ed9d201404b, {
                        activeRelease: activeRelease,
                        setActiveRelease: setActiveRelease
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "panels flex sm:justify-center pt-6 pb-0 sm:pb-10 sm:pt-10",
                        children: resolvePanel(activeRelease)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "screen-shot sm:-mt-10",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "pt-4 -m-5 sm:m-0 sm:pt-0 sm:mx-24 relative overflow-hidden",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        alt: "Image",
                        src: $6b83dbd58d0bae96$var$releaseImages[activeRelease[0].toString().toLowerCase()],
                        className: "sm:opacity-90 sm:translate-y-28 rounded-md overflow-hidden sm:-mt-24 img-bg"
                    })
                })
            })
        ]
    });
}
function $6b83dbd58d0bae96$export$2cc9cf822bc951d1() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-page pt-20",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "page-inner-full-wrap dl-a",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "page-inner",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6b83dbd58d0bae96$export$96b05e2ad54f81d1, {})
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "page-inner-full-wrap b relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "page-inner footer-desc pt-16",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $717c681f9cec0e89$export$e458e76844d3be8d), {
                            downloadsPage: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "page-inner footer-nav",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "page-inner",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $717c681f9cec0e89$export$314961f1e384fdc0), {})
                        })
                    })
                ]
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");
function $54353c0316b7db10$export$3c3559526665e90c(props) {
    const { className: className, onRefMouseEnter: onRefMouseEnter, onRefMouseLeave: onRefMouseLeave, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $58e8d8f711de3215$export$6732c884469525e1), {
        delay: 2000,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("d", className),
        ...rest,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "outliner-list-demo",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "outliner-list-item",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "content",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "My notes on ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                "data-ref": "book",
                                onMouseEnter: onRefMouseEnter,
                                onMouseLeave: onRefMouseLeave,
                                className: "ref",
                                children: "\uD83D\uDCD6Book / Intertwingled"
                            }),
                            ":"
                        ]
                    })
                })
            })
        })
    });
}
function $54353c0316b7db10$export$30505eaefd6f3577(props) {
    const { className: className, onRefMouseEnter: onRefMouseEnter, onRefMouseLeave: onRefMouseLeave, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $58e8d8f711de3215$export$6732c884469525e1), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("is-card-profile flex mb-2.5 sm:mb-1", className),
        ...rest,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "avatar flex items-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "avatar-img",
                    children: "Image"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "info flex flex-col px-3 text-logseq-100",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-2xl font-semibold text-logseq-50",
                        children: "Jessica"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "py-0.5 opacity-80",
                        children: "\uD83D\uDC65 Person"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "py-0.5 opacity-80",
                        children: "\uD83D\uDC64 Jessica Albert"
                    })
                ]
            })
        ]
    });
}
function $54353c0316b7db10$export$14d49e2bc6e6d31e(props) {
    const { className: className, onRefMouseEnter: onRefMouseEnter, onRefMouseLeave: onRefMouseLeave, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $58e8d8f711de3215$export$6732c884469525e1), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("is-card-book flex mb-2.5 sm:mb-1", className),
        ...rest,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "avatar flex items-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "avatar-img",
                    children: "Image"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "info flex flex-col px-3 text-logseq-100",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-2xl font-semibold text-logseq-50",
                        children: "Intertwingled"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "py-0.5 opacity-80",
                        children: "\uD83D\uDCD6 Book"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "py-0.5 opacity-80",
                        children: "\uD83D\uDC64 Peter Morville"
                    })
                ]
            })
        ]
    });
}
function $54353c0316b7db10$export$c0849f9ab0866363(props) {
    const { className: className, onRefMouseEnter: onRefMouseEnter, onRefMouseLeave: onRefMouseLeave, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $58e8d8f711de3215$export$6732c884469525e1), {
        delay: 500,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("is-card-todo", className),
        ...rest,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "outliner-list-demo",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "outliner-list-item",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "content is-todo",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "marker",
                                children: "NOW"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "Meeting with ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        className: "ref",
                                        "data-ref": "profile",
                                        onMouseLeave: onRefMouseLeave,
                                        onMouseEnter: onRefMouseEnter,
                                        children: "\uD83D\uDC65 Jessica"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "subs",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "outliner-list-item",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "content",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "She mentioned her current read: ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            "data-ref": "book",
                                            className: "ref",
                                            onMouseLeave: onRefMouseLeave,
                                            onMouseEnter: onRefMouseEnter,
                                            children: "\uD83D\uDCD6 Book/Intertwingled"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}
function $54353c0316b7db10$export$a7b2fab40a242d96() {
    const appState = (0, $0b89d474933103bc$export$9973955de2bf96cf)();
    const [activeRef, setActiveRef] = (0, $acw62.useState)("");
    const refMouseEnterHandler = (0, $acw62.useCallback)((e)=>{
        const target = e.target;
        setActiveRef(target.dataset.ref || "");
    }, []);
    const refMouseLeaveHandler = (0, $acw62.useCallback)((e)=>{
        setActiveRef("");
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("app-head-showcase", activeRef && "active-ref-" + activeRef),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "inner flex h-full",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "item-wrap relative flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-1 z-0 w-full flex flex-col tracking-wide pb-[38rem] sm:pb-[32rem]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-4xl sm:text-6xl text-logseq-50/80",
                                children: "Connect your notes, "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "text-3xl sm:text-6xl flex",
                                children: [
                                    "increase understanding.",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("sup", {
                                        className: "hidden opacity-80 text-logseq-100 hover:opacity-60 sm:translate-y-6",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ce0e4ed0f10866c$export$2e2bcd8739ae039), {
                                            size: 28
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "image-2 z-10 thinker absolute",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "absolute bottom-12 w-full h-40 bg-gradient-to-t from-logseq-800 via-logseq-800"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "cards-3 z-20",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "r1 mb-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($54353c0316b7db10$export$c0849f9ab0866363, {
                                    onRefMouseEnter: refMouseEnterHandler,
                                    onRefMouseLeave: refMouseLeaveHandler
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "r2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($54353c0316b7db10$export$30505eaefd6f3577, {
                                        delay: 1300,
                                        animation: appState.sm.get() ? "slide-in-from-left" : null
                                    }),
                                    !appState.sm.get() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($54353c0316b7db10$export$14d49e2bc6e6d31e, {
                                        delay: 1300
                                    }) : null
                                ]
                            }),
                            appState.sm.get() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "r2 is-single",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($54353c0316b7db10$export$14d49e2bc6e6d31e, {
                                    delay: 1600,
                                    animation: "slide-in-from-right"
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "r3 pt-3 sm:px-24",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($54353c0316b7db10$export$3c3559526665e90c, {
                                    onRefMouseEnter: refMouseEnterHandler,
                                    onRefMouseLeave: refMouseLeaveHandler
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative actions-4 z-30",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b83dbd58d0bae96$export$434a045e59e6bdd3), {
                                className: "is-super-button",
                                children: ({ active: active, leftIconFn: leftIconFn, rightIconFn: rightIconFn })=>{
                                    const leftIcon = leftIconFn?.({
                                        weight: "bold",
                                        size: 18
                                    });
                                    const rightIcon = rightIconFn?.({
                                        size: 18
                                    });
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                                        leftIcon: leftIcon,
                                        rightIcon: rightIcon,
                                        children: [
                                            "Download for ",
                                            active?.[0]
                                        ]
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                                leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67aa543a4d20f937$export$2e2bcd8739ae039), {
                                    size: 18,
                                    weight: "duotone"
                                }),
                                rightIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6925feee259dfec9$export$2e2bcd8739ae039), {
                                    size: 18,
                                    className: "opacity-70"
                                }),
                                className: "bg-logseq-600",
                                href: "https://demo.logseq.com",
                                children: "Live Demo"
                            })
                        ]
                    })
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");


var $d83094b996eadb6b$var$Z = Object.defineProperty, $d83094b996eadb6b$var$M = Object.defineProperties;
var $d83094b996eadb6b$var$c = Object.getOwnPropertyDescriptors;
var $d83094b996eadb6b$var$A = Object.getOwnPropertySymbols;
var $d83094b996eadb6b$var$V = Object.prototype.hasOwnProperty, $d83094b996eadb6b$var$h = Object.prototype.propertyIsEnumerable;
var $d83094b996eadb6b$var$n = (t, e, l)=>e in t ? $d83094b996eadb6b$var$Z(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[e] = l, $d83094b996eadb6b$var$m = (t, e)=>{
    for(var l in e || (e = {}))$d83094b996eadb6b$var$V.call(e, l) && $d83094b996eadb6b$var$n(t, l, e[l]);
    if ($d83094b996eadb6b$var$A) for (var l of $d83094b996eadb6b$var$A(e))$d83094b996eadb6b$var$h.call(e, l) && $d83094b996eadb6b$var$n(t, l, e[l]);
    return t;
}, $d83094b996eadb6b$var$r = (t, e)=>$d83094b996eadb6b$var$M(t, $d83094b996eadb6b$var$c(e));
const $d83094b996eadb6b$var$p = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M241,150.65s0,0,0-.05a51.33,51.33,0,0,0-2.53-5.9L196.93,50.18a12,12,0,0,0-2.5-3.65,36,36,0,0,0-50.92,0A12,12,0,0,0,140,55V76H116V55a12,12,0,0,0-3.51-8.48,36,36,0,0,0-50.92,0,12,12,0,0,0-2.5,3.65L17.53,144.7A51.33,51.33,0,0,0,15,150.6s0,0,0,.05A52,52,0,1,0,116,168V100h24v68a52,52,0,1,0,101-17.35ZM80,62.28a12,12,0,0,1,12-1.22v63.15a51.9,51.9,0,0,0-35.9-7.62ZM64,196a28,28,0,1,1,28-28A28,28,0,0,1,64,196ZM164,61.06a12.06,12.06,0,0,1,12,1.22l23.87,54.31a51.9,51.9,0,0,0-35.9,7.62ZM192,196a28,28,0,1,1,28-28A28,28,0,0,1,192,196Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M104,168a40,40,0,1,1-40-40A40,40,0,0,1,104,168Zm88-40a40,40,0,1,0,40,40A40,40,0,0,0,192,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M237.2,151.87v0a47.1,47.1,0,0,0-2.35-5.45L193.26,51.8a7.82,7.82,0,0,0-1.66-2.44,32,32,0,0,0-45.26,0A8,8,0,0,0,144,55V80H112V55a8,8,0,0,0-2.34-5.66,32,32,0,0,0-45.26,0,7.82,7.82,0,0,0-1.66,2.44L21.15,146.4a47.1,47.1,0,0,0-2.35,5.45v0A48,48,0,1,0,112,168V96h32v72a48,48,0,1,0,93.2-16.13ZM76.71,59.75a16,16,0,0,1,19.29-1v73.51a47.9,47.9,0,0,0-46.79-9.92ZM64,200a32,32,0,1,1,32-32A32,32,0,0,1,64,200ZM160,58.74a16,16,0,0,1,19.29,1l27.5,62.58A47.9,47.9,0,0,0,160,132.25ZM192,200a32,32,0,1,1,32-32A32,32,0,0,1,192,200Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M237.22,151.9l0-.1a1.42,1.42,0,0,0-.07-.22,48.46,48.46,0,0,0-2.31-5.3L193.27,51.8a8,8,0,0,0-1.67-2.44,32,32,0,0,0-45.26,0A8,8,0,0,0,144,55V80H112V55a8,8,0,0,0-2.34-5.66,32,32,0,0,0-45.26,0,8,8,0,0,0-1.67,2.44L21.2,146.28a48.46,48.46,0,0,0-2.31,5.3,1.72,1.72,0,0,0-.07.21s0,.08,0,.11a48,48,0,0,0,90.32,32.51,47.49,47.49,0,0,0,2.9-16.59V96h32v71.83a47.49,47.49,0,0,0,2.9,16.59,48,48,0,0,0,90.32-32.51Zm-143.15,27a32,32,0,0,1-60.2-21.71l1.81-4.13A32,32,0,0,1,96,167.88V168h0A32,32,0,0,1,94.07,178.94ZM203,198.07A32,32,0,0,1,160,168h0v-.11a32,32,0,0,1,60.32-14.78l1.81,4.13A32,32,0,0,1,203,198.07Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M233,147.24,191.43,52.6a6,6,0,0,0-1.25-1.83,30,30,0,0,0-42.42,0A6,6,0,0,0,146,55V82H110V55a6,6,0,0,0-1.76-4.25,30,30,0,0,0-42.42,0,6,6,0,0,0-1.25,1.83L23,147.24A46,46,0,1,0,110,168V94h36v74a46,46,0,1,0,87-20.76ZM64,202a34,34,0,1,1,34-34A34,34,0,0,1,64,202Zm0-80a45.77,45.77,0,0,0-18.55,3.92L75.06,58.54A18,18,0,0,1,98,57.71V137A45.89,45.89,0,0,0,64,122Zm94-64.28a18,18,0,0,1,22.94.83l29.61,67.37A45.9,45.9,0,0,0,158,137ZM192,202a34,34,0,1,1,34-34A34,34,0,0,1,192,202Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M237.2,151.87v0a47.1,47.1,0,0,0-2.35-5.45L193.26,51.8a7.82,7.82,0,0,0-1.66-2.44,32,32,0,0,0-45.26,0A8,8,0,0,0,144,55V80H112V55a8,8,0,0,0-2.34-5.66,32,32,0,0,0-45.26,0,7.82,7.82,0,0,0-1.66,2.44L21.15,146.4a47.1,47.1,0,0,0-2.35,5.45v0A48,48,0,1,0,112,168V96h32v72a48,48,0,1,0,93.2-16.13ZM76.71,59.75a16,16,0,0,1,19.29-1v73.51a47.9,47.9,0,0,0-46.79-9.92ZM64,200a32,32,0,1,1,32-32A32,32,0,0,1,64,200ZM160,58.74a16,16,0,0,1,19.29,1l27.5,62.58A47.9,47.9,0,0,0,160,132.25ZM192,200a32,32,0,1,1,32-32A32,32,0,0,1,192,200Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M231.22,148.09,189.6,53.41a3.94,3.94,0,0,0-.83-1.22,28,28,0,0,0-39.6,0A4,4,0,0,0,148,55V84H108V55a4,4,0,0,0-1.17-2.83,28,28,0,0,0-39.6,0,3.94,3.94,0,0,0-.83,1.22L24.78,148.09A44,44,0,1,0,108,168V92h40v76a44,44,0,1,0,83.22-19.91ZM64,204a36,36,0,1,1,36-36A36,36,0,0,1,64,204Zm0-80a43.78,43.78,0,0,0-22.66,6.3L73.4,57.35a20,20,0,0,1,26.6-.59v86A44,44,0,0,0,64,124Zm92-67.23a20,20,0,0,1,26.6.59l32.06,72.94A43.92,43.92,0,0,0,156,142.74ZM192,204a36,36,0,1,1,36-36A36,36,0,0,1,192,204Z"
        }))
    ]
]), $d83094b996eadb6b$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $d83094b996eadb6b$var$r($d83094b996eadb6b$var$m({
        ref: e
    }, t), {
        weights: $d83094b996eadb6b$var$p
    })));
$d83094b996eadb6b$export$2e2bcd8739ae039.displayName = "Binoculars";


var $acw62 = parcelRequire("acw62");


var $92cfd8aa6e9e1dbf$var$A = Object.defineProperty, $92cfd8aa6e9e1dbf$var$r = Object.defineProperties;
var $92cfd8aa6e9e1dbf$var$V = Object.getOwnPropertyDescriptors;
var $92cfd8aa6e9e1dbf$var$t = Object.getOwnPropertySymbols;
var $92cfd8aa6e9e1dbf$var$L = Object.prototype.hasOwnProperty, $92cfd8aa6e9e1dbf$var$M = Object.prototype.propertyIsEnumerable;
var $92cfd8aa6e9e1dbf$var$Z = (l, e, m)=>e in l ? $92cfd8aa6e9e1dbf$var$A(l, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: m
    }) : l[e] = m, $92cfd8aa6e9e1dbf$var$h = (l, e)=>{
    for(var m in e || (e = {}))$92cfd8aa6e9e1dbf$var$L.call(e, m) && $92cfd8aa6e9e1dbf$var$Z(l, m, e[m]);
    if ($92cfd8aa6e9e1dbf$var$t) for (var m of $92cfd8aa6e9e1dbf$var$t(e))$92cfd8aa6e9e1dbf$var$M.call(e, m) && $92cfd8aa6e9e1dbf$var$Z(l, m, e[m]);
    return l;
}, $92cfd8aa6e9e1dbf$var$n = (l, e)=>$92cfd8aa6e9e1dbf$var$r(l, $92cfd8aa6e9e1dbf$var$V(e));
const $92cfd8aa6e9e1dbf$var$o = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M235.57,193.73,202.38,35.93a20,20,0,0,0-23.76-15.48L131.81,30.51a19.82,19.82,0,0,0-11,6.65A20,20,0,0,0,104,28H56A20,20,0,0,0,36,48V208a20,20,0,0,0,20,20h48a20,20,0,0,0,20-20V90.25l25.62,121.82A20,20,0,0,0,169.15,228a20.27,20.27,0,0,0,4.23-.45l46.81-10.06A20.1,20.1,0,0,0,235.57,193.73ZM148.19,88.65l39-8.38,2.53,12-39,8.38Zm7.46,35.5,39-8.38,9.16,43.58-39,8.38Zm24.06-79.39,2.53,12-39,8.38-2.53-12ZM60,88h40v80H60Zm40-36V64H60V52ZM60,204V192h40v12Zm112.29-.76-2.53-12,39-8.38,2.53,12Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M48,72h64V184H48ZM190.64,38.39a8,8,0,0,0-9.5-6.21l-46.81,10a8.07,8.07,0,0,0-6.15,9.57L139.79,107l62.46-13.42Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M231.65,194.55,198.46,36.75a16,16,0,0,0-19-12.39L132.65,34.42a16.08,16.08,0,0,0-12.3,19l33.19,157.8A16,16,0,0,0,169.16,224a16.25,16.25,0,0,0,3.38-.36l46.81-10.06A16.09,16.09,0,0,0,231.65,194.55ZM136,50.15c0-.06,0-.09,0-.09l46.8-10,3.33,15.87L139.33,66Zm6.62,31.47,46.82-10.05,3.34,15.9L146,97.53Zm6.64,31.57,46.82-10.06,13.3,63.24-46.82,10.06ZM216,197.94l-46.8,10-3.33-15.87L212.67,182,216,197.85C216,197.91,216,197.94,216,197.94ZM104,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V48A16,16,0,0,0,104,32ZM56,48h48V64H56Zm0,32h48v96H56Zm48,128H56V192h48v16Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M231.65,194.55,198.46,36.75a16,16,0,0,0-19-12.39L132.65,34.42a16.08,16.08,0,0,0-12.3,19l33.19,157.8A16,16,0,0,0,169.16,224a16.25,16.25,0,0,0,3.38-.36l46.81-10.06A16.09,16.09,0,0,0,231.65,194.55ZM136,50.15c0-.06,0-.09,0-.09l46.8-10,3.33,15.87L139.33,66Zm10,47.38-3.35-15.9,46.82-10.06,3.34,15.9Zm70,100.41-46.8,10-3.33-15.87L212.67,182,216,197.85C216,197.91,216,197.94,216,197.94ZM104,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V48A16,16,0,0,0,104,32ZM56,48h48V64H56Zm48,160H56V192h48v16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M104,34H56A14,14,0,0,0,42,48V208a14,14,0,0,0,14,14h48a14,14,0,0,0,14-14V48A14,14,0,0,0,104,34ZM54,78h52V178H54Zm2-32h48a2,2,0,0,1,2,2V66H54V48A2,2,0,0,1,56,46Zm48,164H56a2,2,0,0,1-2-2V190h52v18A2,2,0,0,1,104,210Zm125.7-15L196.51,37.16a14,14,0,0,0-16.63-10.85L133.07,36.37A14.09,14.09,0,0,0,122.3,53l33.19,157.81a14,14,0,0,0,6.1,8.9,13.85,13.85,0,0,0,7.57,2.26,13.55,13.55,0,0,0,3-.32l46.81-10.05A14.09,14.09,0,0,0,229.7,195Zm-82.81-83.32,50.73-10.9,14.12,67.16L161,178.81Zm-6.63-31.56L191,69.19,195.15,89l-50.73,10.9Zm-4.66-32,46.8-10.05a2.18,2.18,0,0,1,.42,0,1.89,1.89,0,0,1,1.05.32,2,2,0,0,1,.89,1.31l3.75,17.82L137.79,68.34l-3.74-17.78A2.07,2.07,0,0,1,135.6,48.1Zm80.81,151.8L169.6,210a1.92,1.92,0,0,1-1.47-.27,2,2,0,0,1-.89-1.31l-3.75-17.82,50.72-10.9L218,197.43A2.07,2.07,0,0,1,216.41,199.9Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M231.65,194.55,198.46,36.75a16,16,0,0,0-19-12.39L132.65,34.42a16.08,16.08,0,0,0-12.3,19l33.19,157.8A16,16,0,0,0,169.16,224a16.25,16.25,0,0,0,3.38-.36l46.81-10.06A16.09,16.09,0,0,0,231.65,194.55ZM136,50.15c0-.06,0-.09,0-.09l46.8-10,3.33,15.87L139.33,66Zm6.62,31.47,46.82-10.05,3.34,15.9L146,97.53Zm6.64,31.57,46.82-10.06,13.3,63.24-46.82,10.06ZM216,197.94l-46.8,10-3.33-15.87L212.67,182,216,197.85C216,197.91,216,197.94,216,197.94ZM104,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V48A16,16,0,0,0,104,32ZM56,48h48V64H56Zm0,32h48v96H56Zm48,128H56V192h48v16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M104,36H56A12,12,0,0,0,44,48V208a12,12,0,0,0,12,12h48a12,12,0,0,0,12-12V48A12,12,0,0,0,104,36ZM52,76h56V180H52Zm4-32h48a4,4,0,0,1,4,4V68H52V48A4,4,0,0,1,56,44Zm48,168H56a4,4,0,0,1-4-4V188h56v20A4,4,0,0,1,104,212Zm123.74-16.62L194.55,37.57a12,12,0,0,0-14.25-9.3L133.49,38.32a12.1,12.1,0,0,0-9.23,14.3l33.19,157.81a12,12,0,0,0,14.25,9.3l46.81-10.06h0A12.08,12.08,0,0,0,227.74,195.38Zm-83.21-85.27,54.63-11.73,15,71.07-54.63,11.74Zm-6.64-31.56,54.64-11.74,5,23.74-54.64,11.73Zm-2.71-32.4L182,36.09a4,4,0,0,1,.84-.09,3.94,3.94,0,0,1,2.14.64,4,4,0,0,1,1.76,2.58L190.88,59,136.24,70.72,132.09,51A4.07,4.07,0,0,1,135.18,46.15Zm81.65,155.7L170,211.91a4,4,0,0,1-3-.55,4,4,0,0,1-1.76-2.58L161.12,189l54.64-11.73L219.91,197A4.07,4.07,0,0,1,216.83,201.85Z"
        }))
    ]
]), $92cfd8aa6e9e1dbf$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((l, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $92cfd8aa6e9e1dbf$var$n($92cfd8aa6e9e1dbf$var$h({
        ref: e
    }, l), {
        weights: $92cfd8aa6e9e1dbf$var$o
    })));
$92cfd8aa6e9e1dbf$export$2e2bcd8739ae039.displayName = "Books";


var $acw62 = parcelRequire("acw62");


var $d0582f6dc96bba02$var$n = Object.defineProperty, $d0582f6dc96bba02$var$l = Object.defineProperties;
var $d0582f6dc96bba02$var$r = Object.getOwnPropertyDescriptors;
var $d0582f6dc96bba02$var$h = Object.getOwnPropertySymbols;
var $d0582f6dc96bba02$var$Z = Object.prototype.hasOwnProperty, $d0582f6dc96bba02$var$c = Object.prototype.propertyIsEnumerable;
var $d0582f6dc96bba02$var$m = (A, e, t)=>e in A ? $d0582f6dc96bba02$var$n(A, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : A[e] = t, $d0582f6dc96bba02$var$v = (A, e)=>{
    for(var t in e || (e = {}))$d0582f6dc96bba02$var$Z.call(e, t) && $d0582f6dc96bba02$var$m(A, t, e[t]);
    if ($d0582f6dc96bba02$var$h) for (var t of $d0582f6dc96bba02$var$h(e))$d0582f6dc96bba02$var$c.call(e, t) && $d0582f6dc96bba02$var$m(A, t, e[t]);
    return A;
}, $d0582f6dc96bba02$var$V = (A, e)=>$d0582f6dc96bba02$var$l(A, $d0582f6dc96bba02$var$r(e));
const $d0582f6dc96bba02$var$p = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M252,124a60.14,60.14,0,0,0-32-53.08,52,52,0,0,0-92-32.11A52,52,0,0,0,36,70.92a60,60,0,0,0,0,106.14,52,52,0,0,0,92,32.13,52,52,0,0,0,92-32.13A60.05,60.05,0,0,0,252,124ZM88,204a28,28,0,0,1-26.85-20.07c1,0,1.89.07,2.85.07h8a12,12,0,0,0,0-24H64A36,36,0,0,1,52,90.05a12,12,0,0,0,8-11.32V72a28,28,0,0,1,56,0v60.15a52.43,52.43,0,0,0-12.4-5.77,12,12,0,0,0-7.2,22.9A28,28,0,0,1,88,204Zm104-44h-8a12,12,0,0,0,0,24h8c1,0,1.9,0,2.85-.07a28,28,0,1,1-35.18-34.67,12,12,0,0,0-7.13-22.92A52,52,0,0,0,140,132.15V72a28,28,0,0,1,56,0v6.73a12,12,0,0,0,8,11.32,36,36,0,0,1-12,70Zm16-44a12,12,0,0,1-12,12,40,40,0,0,1-40-40V84a12,12,0,0,1,24,0v4a16,16,0,0,0,16,16A12,12,0,0,1,208,116ZM60,128a12,12,0,0,1,0-24A16,16,0,0,0,76,88V84a12,12,0,0,1,24,0v4A40,40,0,0,1,60,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M240,124a48,48,0,0,1-32,45.27h0V176a40,40,0,0,1-80,0,40,40,0,0,1-80,0v-6.73h0a48,48,0,0,1,0-90.54V72a40,40,0,0,1,80,0,40,40,0,0,1,80,0v6.73A48,48,0,0,1,240,124Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M248,124a56.11,56.11,0,0,0-32-50.61V72a48,48,0,0,0-88-26.49A48,48,0,0,0,40,72v1.39a56,56,0,0,0,0,101.2V176a48,48,0,0,0,88,26.49A48,48,0,0,0,216,176v-1.41A56.09,56.09,0,0,0,248,124ZM88,208a32,32,0,0,1-31.81-28.56A55.87,55.87,0,0,0,64,180h8a8,8,0,0,0,0-16H64A40,40,0,0,1,50.67,86.27,8,8,0,0,0,56,78.73V72a32,32,0,0,1,64,0v68.26A47.8,47.8,0,0,0,88,128a8,8,0,0,0,0,16,32,32,0,0,1,0,64Zm104-44h-8a8,8,0,0,0,0,16h8a55.87,55.87,0,0,0,7.81-.56A32,32,0,1,1,168,144a8,8,0,0,0,0-16,47.8,47.8,0,0,0-32,12.26V72a32,32,0,0,1,64,0v6.73a8,8,0,0,0,5.33,7.54A40,40,0,0,1,192,164Zm16-52a8,8,0,0,1-8,8h-4a36,36,0,0,1-36-36V80a8,8,0,0,1,16,0v4a20,20,0,0,0,20,20h4A8,8,0,0,1,208,112ZM60,120H56a8,8,0,0,1,0-16h4A20,20,0,0,0,80,84V80a8,8,0,0,1,16,0v4A36,36,0,0,1,60,120Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M212,76V72a44,44,0,0,0-74.86-31.31,3.93,3.93,0,0,0-1.14,2.8v88.72a4,4,0,0,0,6.2,3.33A47.67,47.67,0,0,1,167.68,128a8.18,8.18,0,0,1,8.31,7.58,8,8,0,0,1-8,8.42,32,32,0,0,0-32,32v33.88a4,4,0,0,0,1.49,3.12,47.92,47.92,0,0,0,74.21-17.16,4,4,0,0,0-4.49-5.56A68.06,68.06,0,0,1,192,192h-7.73a8.18,8.18,0,0,1-8.25-7.47,8,8,0,0,1,8-8.53h8a51.6,51.6,0,0,0,24-5.88v0A52,52,0,0,0,212,76Zm-12,36h-4a36,36,0,0,1-36-36V72a8,8,0,0,1,16,0v4a20,20,0,0,0,20,20h4a8,8,0,0,1,0,16ZM88,28A44.05,44.05,0,0,0,44,72v4a52,52,0,0,0-4,94.12h0A51.6,51.6,0,0,0,64,176h7.73A8.18,8.18,0,0,1,80,183.47,8,8,0,0,1,72,192H64a67.48,67.48,0,0,1-15.21-1.73,4,4,0,0,0-4.5,5.55A47.93,47.93,0,0,0,118.51,213a4,4,0,0,0,1.49-3.12V176a32,32,0,0,0-32-32,8,8,0,0,1-8-8.42A8.18,8.18,0,0,1,88.32,128a47.67,47.67,0,0,1,25.48,7.54,4,4,0,0,0,6.2-3.33V43.49a4,4,0,0,0-1.14-2.81A43.85,43.85,0,0,0,88,28Zm8,48a36,36,0,0,1-36,36H56a8,8,0,0,1,0-16h4A20,20,0,0,0,80,76V72a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M246,124a54.13,54.13,0,0,0-32-49.33V72a46,46,0,0,0-86-22.67A46,46,0,0,0,42,72v2.67a54,54,0,0,0,0,98.63V176a46,46,0,0,0,86,22.67A46,46,0,0,0,214,176v-2.7A54.07,54.07,0,0,0,246,124ZM88,210a34,34,0,0,1-34-32.94A53.67,53.67,0,0,0,64,178h8a6,6,0,0,0,0-12H64A42,42,0,0,1,50,84.39a6,6,0,0,0,4-5.66V72a34,34,0,0,1,68,0v73.05A45.89,45.89,0,0,0,88,130a6,6,0,0,0,0,12,34,34,0,0,1,0,68Zm104-44h-8a6,6,0,0,0,0,12h8a53.67,53.67,0,0,0,10-.94A34,34,0,1,1,168,142a6,6,0,0,0,0-12,45.89,45.89,0,0,0-34,15.05V72a34,34,0,0,1,68,0v6.73a6,6,0,0,0,4,5.66A42,42,0,0,1,192,166Zm14-54a6,6,0,0,1-6,6h-4a34,34,0,0,1-34-34V80a6,6,0,0,1,12,0v4a22,22,0,0,0,22,22h4A6,6,0,0,1,206,112ZM60,118H56a6,6,0,0,1,0-12h4A22,22,0,0,0,82,84V80a6,6,0,0,1,12,0v4A34,34,0,0,1,60,118Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M248,124a56.11,56.11,0,0,0-32-50.61V72a48,48,0,0,0-88-26.49A48,48,0,0,0,40,72v1.39a56,56,0,0,0,0,101.2V176a48,48,0,0,0,88,26.49A48,48,0,0,0,216,176v-1.41A56.09,56.09,0,0,0,248,124ZM88,208a32,32,0,0,1-31.81-28.56A55.87,55.87,0,0,0,64,180h8a8,8,0,0,0,0-16H64A40,40,0,0,1,50.67,86.27,8,8,0,0,0,56,78.73V72a32,32,0,0,1,64,0v68.26A47.8,47.8,0,0,0,88,128a8,8,0,0,0,0,16,32,32,0,0,1,0,64Zm104-44h-8a8,8,0,0,0,0,16h8a55.87,55.87,0,0,0,7.81-.56A32,32,0,1,1,168,144a8,8,0,0,0,0-16,47.8,47.8,0,0,0-32,12.26V72a32,32,0,0,1,64,0v6.73a8,8,0,0,0,5.33,7.54A40,40,0,0,1,192,164Zm16-52a8,8,0,0,1-8,8h-4a36,36,0,0,1-36-36V80a8,8,0,0,1,16,0v4a20,20,0,0,0,20,20h4A8,8,0,0,1,208,112ZM60,120H56a8,8,0,0,1,0-16h4A20,20,0,0,0,80,84V80a8,8,0,0,1,16,0v4A36,36,0,0,1,60,120Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M244,124a52.1,52.1,0,0,0-32-48V72a44,44,0,0,0-84-18.3A44,44,0,0,0,44,72v4a52,52,0,0,0,0,96v4a44,44,0,0,0,84,18.3A44,44,0,0,0,212,176v-4A52.07,52.07,0,0,0,244,124ZM88,212a36,36,0,0,1-36-36v-1.41A52.13,52.13,0,0,0,64,176h8a4,4,0,0,0,0-8H64A44,44,0,0,1,49.33,82.5,4,4,0,0,0,52,78.73V72a36,36,0,0,1,72,0v78.75A44,44,0,0,0,88,132a4,4,0,0,0,0,8,36,36,0,0,1,0,72Zm104-44h-8a4,4,0,0,0,0,8h8a52.13,52.13,0,0,0,12-1.41V176a36,36,0,1,1-36-36,4,4,0,0,0,0-8,44,44,0,0,0-36,18.75V72a36,36,0,0,1,72,0v6.73a4,4,0,0,0,2.67,3.77A44,44,0,0,1,192,168Zm12-56a4,4,0,0,1-4,4h-4a32,32,0,0,1-32-32V80a4,4,0,0,1,8,0v4a24,24,0,0,0,24,24h4A4,4,0,0,1,204,112ZM92,84a32,32,0,0,1-32,32H56a4,4,0,0,1,0-8h4A24,24,0,0,0,84,84V80a4,4,0,0,1,8,0Z"
        }))
    ]
]), $d0582f6dc96bba02$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((A, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $d0582f6dc96bba02$var$V($d0582f6dc96bba02$var$v({
        ref: e
    }, A), {
        weights: $d0582f6dc96bba02$var$p
    })));
$d0582f6dc96bba02$export$2e2bcd8739ae039.displayName = "Brain";


var $acw62 = parcelRequire("acw62");


var $97ed57a3521a6daf$var$n = Object.defineProperty, $97ed57a3521a6daf$var$Z = Object.defineProperties;
var $97ed57a3521a6daf$var$A = Object.getOwnPropertyDescriptors;
var $97ed57a3521a6daf$var$V = Object.getOwnPropertySymbols;
var $97ed57a3521a6daf$var$c = Object.prototype.hasOwnProperty, $97ed57a3521a6daf$var$M = Object.prototype.propertyIsEnumerable;
var $97ed57a3521a6daf$var$m = (H, e, t)=>e in H ? $97ed57a3521a6daf$var$n(H, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : H[e] = t, $97ed57a3521a6daf$var$r = (H, e)=>{
    for(var t in e || (e = {}))$97ed57a3521a6daf$var$c.call(e, t) && $97ed57a3521a6daf$var$m(H, t, e[t]);
    if ($97ed57a3521a6daf$var$V) for (var t of $97ed57a3521a6daf$var$V(e))$97ed57a3521a6daf$var$M.call(e, t) && $97ed57a3521a6daf$var$m(H, t, e[t]);
    return H;
}, $97ed57a3521a6daf$var$l = (H, e)=>$97ed57a3521a6daf$var$Z(H, $97ed57a3521a6daf$var$A(e));
const $97ed57a3521a6daf$var$p = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M220,32H76A20,20,0,0,0,56,52V72H36A20,20,0,0,0,16,92V204a20,20,0,0,0,20,20H180a20,20,0,0,0,20-20V184h20a20,20,0,0,0,20-20V52A20,20,0,0,0,220,32ZM176,96v16H40V96Zm0,104H40V136H176Zm40-40H200V92a20,20,0,0,0-20-20H80V56H216Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,56V168a8,8,0,0,1-8,8H192V88a8,8,0,0,0-8-8H64V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,40H72A16,16,0,0,0,56,56V72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V184h16a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,88H184v16H40ZM184,200H40V120H184v80Zm32-32H200V88a16,16,0,0,0-16-16H72V56H216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,40H72A16,16,0,0,0,56,56V72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V184h16a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM184,88v16H40V88Zm32,80H200V88a16,16,0,0,0-16-16H72V56H216Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,42H72A14,14,0,0,0,58,56V74H40A14,14,0,0,0,26,88V200a14,14,0,0,0,14,14H184a14,14,0,0,0,14-14V182h18a14,14,0,0,0,14-14V56A14,14,0,0,0,216,42ZM40,86H184a2,2,0,0,1,2,2v18H38V88A2,2,0,0,1,40,86ZM186,200a2,2,0,0,1-2,2H40a2,2,0,0,1-2-2V118H186Zm32-32a2,2,0,0,1-2,2H198V88a14,14,0,0,0-14-14H70V56a2,2,0,0,1,2-2H216a2,2,0,0,1,2,2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,40H72A16,16,0,0,0,56,56V72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V184h16a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM184,88v16H40V88Zm0,112H40V120H184v80Zm32-32H200V88a16,16,0,0,0-16-16H72V56H216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,44H72A12,12,0,0,0,60,56V76H40A12,12,0,0,0,28,88V200a12,12,0,0,0,12,12H184a12,12,0,0,0,12-12V180h20a12,12,0,0,0,12-12V56A12,12,0,0,0,216,44ZM40,84H184a4,4,0,0,1,4,4v20H36V88A4,4,0,0,1,40,84ZM188,200a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V116H188Zm32-32a4,4,0,0,1-4,4H196V88a12,12,0,0,0-12-12H68V56a4,4,0,0,1,4-4H216a4,4,0,0,1,4,4Z"
        }))
    ]
]), $97ed57a3521a6daf$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((H, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $97ed57a3521a6daf$var$l($97ed57a3521a6daf$var$r({
        ref: e
    }, H), {
        weights: $97ed57a3521a6daf$var$p
    })));
$97ed57a3521a6daf$export$2e2bcd8739ae039.displayName = "Browsers";


var $acw62 = parcelRequire("acw62");


var $1bb269cb2484cf74$var$m = Object.defineProperty, $1bb269cb2484cf74$var$h = Object.defineProperties;
var $1bb269cb2484cf74$var$Z = Object.getOwnPropertyDescriptors;
var $1bb269cb2484cf74$var$l = Object.getOwnPropertySymbols;
var $1bb269cb2484cf74$var$A = Object.prototype.hasOwnProperty, $1bb269cb2484cf74$var$c = Object.prototype.propertyIsEnumerable;
var $1bb269cb2484cf74$var$H = (V, e, t)=>e in V ? $1bb269cb2484cf74$var$m(V, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : V[e] = t, $1bb269cb2484cf74$var$n = (V, e)=>{
    for(var t in e || (e = {}))$1bb269cb2484cf74$var$A.call(e, t) && $1bb269cb2484cf74$var$H(V, t, e[t]);
    if ($1bb269cb2484cf74$var$l) for (var t of $1bb269cb2484cf74$var$l(e))$1bb269cb2484cf74$var$c.call(e, t) && $1bb269cb2484cf74$var$H(V, t, e[t]);
    return V;
}, $1bb269cb2484cf74$var$r = (V, e)=>$1bb269cb2484cf74$var$h(V, $1bb269cb2484cf74$var$Z(e));
const $1bb269cb2484cf74$var$o = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,28H188V24a12,12,0,0,0-24,0v4H92V24a12,12,0,0,0-24,0v4H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28ZM68,52a12,12,0,0,0,24,0h72a12,12,0,0,0,24,0h16V76H52V52ZM52,204V100H204V204Zm120.49-84.49a12,12,0,0,1,0,17l-48,48a12,12,0,0,1-17,0l-24-24a12,12,0,0,1,17-17L116,159l39.51-39.52A12,12,0,0,1,172.49,119.51Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,48V88H40V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-38.34-85.66a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L116,164.69l42.34-42.35A8,8,0,0,1,169.66,122.34Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM169.66,133.66l-48,48a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L116,164.69l42.34-42.35a8,8,0,0,1,11.32,11.32ZM48,80V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,34H182V24a6,6,0,0,0-12,0V34H86V24a6,6,0,0,0-12,0V34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34ZM48,46H74V56a6,6,0,0,0,12,0V46h84V56a6,6,0,0,0,12,0V46h26a2,2,0,0,1,2,2V82H46V48A2,2,0,0,1,48,46ZM208,210H48a2,2,0,0,1-2-2V94H210V208A2,2,0,0,1,208,210Zm-39.76-86.24a6,6,0,0,1,0,8.48l-48,48a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L116,167.51l43.76-43.75A6,6,0,0,1,168.24,123.76Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-38.34-85.66a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L116,164.69l42.34-42.35A8,8,0,0,1,169.66,122.34Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,36H180V24a4,4,0,0,0-8,0V36H84V24a4,4,0,0,0-8,0V36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36ZM48,44H76V56a4,4,0,0,0,8,0V44h88V56a4,4,0,0,0,8,0V44h28a4,4,0,0,1,4,4V84H44V48A4,4,0,0,1,48,44ZM208,212H48a4,4,0,0,1-4-4V92H212V208A4,4,0,0,1,208,212Zm-41.17-86.83a4,4,0,0,1,0,5.66l-48,48a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L116,170.34l45.17-45.17A4,4,0,0,1,166.83,125.17Z"
        }))
    ]
]), $1bb269cb2484cf74$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((V, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $1bb269cb2484cf74$var$r($1bb269cb2484cf74$var$n({
        ref: e
    }, V), {
        weights: $1bb269cb2484cf74$var$o
    })));
$1bb269cb2484cf74$export$2e2bcd8739ae039.displayName = "CalendarCheck";


var $acw62 = parcelRequire("acw62");


var $ac1ad873514c9884$var$Z = Object.defineProperty, $ac1ad873514c9884$var$A = Object.defineProperties;
var $ac1ad873514c9884$var$o = Object.getOwnPropertyDescriptors;
var $ac1ad873514c9884$var$m = Object.getOwnPropertySymbols;
var $ac1ad873514c9884$var$p = Object.prototype.hasOwnProperty, $ac1ad873514c9884$var$E = Object.prototype.propertyIsEnumerable;
var $ac1ad873514c9884$var$n = (t, a, l)=>a in t ? $ac1ad873514c9884$var$Z(t, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[a] = l, $ac1ad873514c9884$var$r = (t, a)=>{
    for(var l in a || (a = {}))$ac1ad873514c9884$var$p.call(a, l) && $ac1ad873514c9884$var$n(t, l, a[l]);
    if ($ac1ad873514c9884$var$m) for (var l of $ac1ad873514c9884$var$m(a))$ac1ad873514c9884$var$E.call(a, l) && $ac1ad873514c9884$var$n(t, l, a[l]);
    return t;
}, $ac1ad873514c9884$var$c = (t, a)=>$ac1ad873514c9884$var$A(t, $ac1ad873514c9884$var$o(a));
const $ac1ad873514c9884$var$h = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M176.49,95.51a12,12,0,0,1,0,17l-56,56a12,12,0,0,1-17,0l-24-24a12,12,0,1,1,17-17L112,143l47.51-47.52A12,12,0,0,1,176.49,95.51ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M170.83,101.17a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z"
        }))
    ]
]), $ac1ad873514c9884$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $ac1ad873514c9884$var$c($ac1ad873514c9884$var$r({
        ref: a
    }, t), {
        weights: $ac1ad873514c9884$var$h
    })));
$ac1ad873514c9884$export$2e2bcd8739ae039.displayName = "CheckCircle";


var $acw62 = parcelRequire("acw62");


var $72820fc93eb2f5e8$var$A = Object.defineProperty, $72820fc93eb2f5e8$var$o = Object.defineProperties;
var $72820fc93eb2f5e8$var$p = Object.getOwnPropertyDescriptors;
var $72820fc93eb2f5e8$var$n = Object.getOwnPropertySymbols;
var $72820fc93eb2f5e8$var$E = Object.prototype.hasOwnProperty, $72820fc93eb2f5e8$var$C = Object.prototype.propertyIsEnumerable;
var $72820fc93eb2f5e8$var$r = (t, a, l)=>a in t ? $72820fc93eb2f5e8$var$A(t, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[a] = l, $72820fc93eb2f5e8$var$m = (t, a)=>{
    for(var l in a || (a = {}))$72820fc93eb2f5e8$var$E.call(a, l) && $72820fc93eb2f5e8$var$r(t, l, a[l]);
    if ($72820fc93eb2f5e8$var$n) for (var l of $72820fc93eb2f5e8$var$n(a))$72820fc93eb2f5e8$var$C.call(a, l) && $72820fc93eb2f5e8$var$r(t, l, a[l]);
    return t;
}, $72820fc93eb2f5e8$var$c = (t, a)=>$72820fc93eb2f5e8$var$o(t, $72820fc93eb2f5e8$var$p(a));
const $72820fc93eb2f5e8$var$V = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M140,80v41.21l34.17,20.5a12,12,0,1,1-12.34,20.58l-40-24A12,12,0,0,1,116,128V80a12,12,0,0,1,24,0ZM128,28A99.38,99.38,0,0,0,57.24,57.34c-4.69,4.74-9,9.37-13.24,14V64a12,12,0,0,0-24,0v40a12,12,0,0,0,12,12H72a12,12,0,0,0,0-24H57.77C63,86,68.37,80.22,74.26,74.26a76,76,0,1,1,1.58,109,12,12,0,0,0-16.48,17.46A100,100,0,1,0,128,28Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,128a88,88,0,1,1-88-88A88,88,0,0,1,216,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm-8-48A95.44,95.44,0,0,0,60.08,60.15C52.81,67.51,46.35,74.59,40,82V64a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16H49c7.15-8.42,14.27-16.35,22.39-24.57a80,80,0,1,1,1.66,114.75,8,8,0,1,0-11,11.64A96,96,0,1,0,128,32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,128A96,96,0,0,1,62.11,197.82a8,8,0,1,1,11-11.64A80,80,0,1,0,71.43,71.43C67.9,75,64.58,78.51,61.35,82L77.66,98.34A8,8,0,0,1,72,112H32a8,8,0,0,1-8-8V64a8,8,0,0,1,13.66-5.66L50,70.7c3.22-3.49,6.54-7,10.06-10.55A96,96,0,0,1,224,128ZM128,72a8,8,0,0,0-8,8v48a8,8,0,0,0,3.88,6.86l40,24a8,8,0,1,0,8.24-13.72L136,123.47V80A8,8,0,0,0,128,72Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M134,80v44.6l37.09,22.25a6,6,0,0,1-6.18,10.3l-40-24A6,6,0,0,1,122,128V80a6,6,0,0,1,12,0Zm-6-46A93.4,93.4,0,0,0,61.51,61.56c-8.58,8.68-16,17-23.51,25.8V64a6,6,0,0,0-12,0v40a6,6,0,0,0,6,6H72a6,6,0,0,0,0-12H44.73C52.86,88.29,60.79,79.35,70,70a82,82,0,1,1,1.7,117.62,6,6,0,1,0-8.24,8.72A94,94,0,1,0,128,34Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm-8-48A95.44,95.44,0,0,0,60.08,60.15C52.81,67.51,46.35,74.59,40,82V64a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16H49c7.15-8.42,14.27-16.35,22.39-24.57a80,80,0,1,1,1.66,114.75,8,8,0,1,0-11,11.64A96,96,0,1,0,128,32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M132,80v45.74l38.06,22.83a4,4,0,0,1-4.12,6.86l-40-24A4,4,0,0,1,124,128V80a4,4,0,0,1,8,0Zm-4-44A91.42,91.42,0,0,0,62.93,63C53.05,73,44.66,82.47,36,92.86V64a4,4,0,0,0-8,0v40a4,4,0,0,0,4,4H72a4,4,0,0,0,0-8H40.47C49.61,89,58.3,79,68.6,68.6a84,84,0,1,1,1.75,120.49,4,4,0,1,0-5.5,5.82A92,92,0,1,0,128,36Z"
        }))
    ]
]), $72820fc93eb2f5e8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $72820fc93eb2f5e8$var$c($72820fc93eb2f5e8$var$m({
        ref: a
    }, t), {
        weights: $72820fc93eb2f5e8$var$V
    })));
$72820fc93eb2f5e8$export$2e2bcd8739ae039.displayName = "ClockCounterClockwise";


var $acw62 = parcelRequire("acw62");


var $13c232801a25a5b6$var$V = Object.defineProperty, $13c232801a25a5b6$var$m = Object.defineProperties;
var $13c232801a25a5b6$var$A = Object.getOwnPropertyDescriptors;
var $13c232801a25a5b6$var$H = Object.getOwnPropertySymbols;
var $13c232801a25a5b6$var$h = Object.prototype.hasOwnProperty, $13c232801a25a5b6$var$o = Object.prototype.propertyIsEnumerable;
var $13c232801a25a5b6$var$n = (t, e, l)=>e in t ? $13c232801a25a5b6$var$V(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[e] = l, $13c232801a25a5b6$var$c = (t, e)=>{
    for(var l in e || (e = {}))$13c232801a25a5b6$var$h.call(e, l) && $13c232801a25a5b6$var$n(t, l, e[l]);
    if ($13c232801a25a5b6$var$H) for (var l of $13c232801a25a5b6$var$H(e))$13c232801a25a5b6$var$o.call(e, l) && $13c232801a25a5b6$var$n(t, l, e[l]);
    return t;
}, $13c232801a25a5b6$var$r = (t, e)=>$13c232801a25a5b6$var$m(t, $13c232801a25a5b6$var$A(e));
const $13c232801a25a5b6$var$M = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M209.88,77.83A115.19,115.19,0,0,0,128,44h-.41C63.85,44.22,12,96.76,12,161.13V184a20,20,0,0,0,20,20H224a20,20,0,0,0,20-20V160A115.25,115.25,0,0,0,209.88,77.83ZM220,180H127.32l46.44-65A12,12,0,1,0,154.24,101L97.82,180H36V161.13c0-1.72,0-3.43.14-5.13H56a12,12,0,0,0,0-24H40.62c10.91-33.39,40-58.52,75.38-63.21V88a12,12,0,0,0,24,0V68.8A92,92,0,0,1,215.66,132H200a12,12,0,0,0,0,24h19.9c.06,1.33.1,2.66.1,4Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M232,160v24a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V161.13C24,103.65,70.15,56.2,127.63,56A104,104,0,0,1,232,160Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M207.06,80.67A111.24,111.24,0,0,0,128,48h-.4C66.07,48.21,16,99,16,161.13V184a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V160A111.25,111.25,0,0,0,207.06,80.67ZM224,184H119.71l54.76-75.3a8,8,0,0,0-12.94-9.42L99.92,184H32V161.13c0-3.08.15-6.12.43-9.13H56a8,8,0,0,0,0-16H35.27c10.32-38.86,44-68.24,84.73-71.66V88a8,8,0,0,0,16,0V64.33A96.14,96.14,0,0,1,221,136H200a8,8,0,0,0,0,16h23.67c.21,2.65.33,5.31.33,8Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M240,160v24a16,16,0,0,1-16,16H115.93a4,4,0,0,1-3.24-6.35L174.27,109a8.21,8.21,0,0,0-1.37-11.3,8,8,0,0,0-11.37,1.61l-72,99.06A4,4,0,0,1,86.25,200H32a16,16,0,0,1-16-16V161.13c0-1.79,0-3.57.13-5.33a4,4,0,0,1,4-3.8H48a8,8,0,0,0,8-8.53A8.17,8.17,0,0,0,47.73,136H23.92a4,4,0,0,1-3.87-5c12-43.84,49.66-77.13,95.52-82.28a4,4,0,0,1,4.43,4V80a8,8,0,0,0,8.53,8A8.17,8.17,0,0,0,136,79.73V52.67a4,4,0,0,1,4.43-4A112.18,112.18,0,0,1,236.23,131a4,4,0,0,1-3.88,5H208.27a8.17,8.17,0,0,0-8.25,7.47,8,8,0,0,0,8,8.53h27.92a4,4,0,0,1,4,3.86C240,157.23,240,158.61,240,160Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M205.65,82.08A109.26,109.26,0,0,0,128,50h-.39C67.17,50.21,18,100.06,18,161.13V184a14,14,0,0,0,14,14H224a14,14,0,0,0,14-14V160A109.3,109.3,0,0,0,205.65,82.08ZM226,184a2,2,0,0,1-2,2H115.78l57.07-78.47a6,6,0,0,0-9.7-7.06L100.94,186H32a2,2,0,0,1-2-2V161.13A102.36,102.36,0,0,1,30.62,150H56a6,6,0,0,0,0-12H32.71C42.6,96.4,78.53,64.86,122,62.19V88a6,6,0,0,0,12,0V62.19A98.05,98.05,0,0,1,223.53,138H200a6,6,0,0,0,0,12h25.5c.33,3.3.5,6.64.5,10Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M207.06,80.67A111.24,111.24,0,0,0,128,48h-.4C66.07,48.21,16,99,16,161.13V184a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V160A111.25,111.25,0,0,0,207.06,80.67ZM224,184H119.71l54.76-75.3a8,8,0,0,0-12.94-9.42L99.92,184H32V161.13c0-3.08.15-6.12.43-9.13H56a8,8,0,0,0,0-16H35.27c10.32-38.86,44-68.24,84.73-71.66V88a8,8,0,0,0,16,0V64.33A96.14,96.14,0,0,1,221,136H200a8,8,0,0,0,0,16h23.67c.21,2.65.33,5.31.33,8Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M204.23,83.5A107.37,107.37,0,0,0,127.62,52C68.28,52.21,20,101.16,20,161.13V184a12,12,0,0,0,12,12H224a12,12,0,0,0,12-12V160A107.25,107.25,0,0,0,204.23,83.5ZM228,184a4,4,0,0,1-4,4H111.85l59.38-81.65a4,4,0,1,0-6.46-4.7L102,188H32a4,4,0,0,1-4-4V161.13A103.42,103.42,0,0,1,28.84,148H56a4,4,0,0,0,0-8H30.21C39.59,95.66,77.84,61.93,124,60.09V88a4,4,0,0,0,8,0V60.08A100.08,100.08,0,0,1,226,140H200a4,4,0,0,0,0,8h27.29a101.6,101.6,0,0,1,.71,12Z"
        }))
    ]
]), $13c232801a25a5b6$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $13c232801a25a5b6$var$r($13c232801a25a5b6$var$c({
        ref: e
    }, t), {
        weights: $13c232801a25a5b6$var$M
    })));
$13c232801a25a5b6$export$2e2bcd8739ae039.displayName = "Gauge";


var $acw62 = parcelRequire("acw62");


var $abb940cf7ead68bf$var$c = Object.defineProperty, $abb940cf7ead68bf$var$h = Object.defineProperties;
var $abb940cf7ead68bf$var$Z = Object.getOwnPropertyDescriptors;
var $abb940cf7ead68bf$var$m = Object.getOwnPropertySymbols;
var $abb940cf7ead68bf$var$v = Object.prototype.hasOwnProperty, $abb940cf7ead68bf$var$o = Object.prototype.propertyIsEnumerable;
var $abb940cf7ead68bf$var$l = (t, e, A)=>e in t ? $abb940cf7ead68bf$var$c(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: A
    }) : t[e] = A, $abb940cf7ead68bf$var$n = (t, e)=>{
    for(var A in e || (e = {}))$abb940cf7ead68bf$var$v.call(e, A) && $abb940cf7ead68bf$var$l(t, A, e[A]);
    if ($abb940cf7ead68bf$var$m) for (var A of $abb940cf7ead68bf$var$m(e))$abb940cf7ead68bf$var$o.call(e, A) && $abb940cf7ead68bf$var$l(t, A, e[A]);
    return t;
}, $abb940cf7ead68bf$var$r = (t, e)=>$abb940cf7ead68bf$var$h(t, $abb940cf7ead68bf$var$Z(e));
const $abb940cf7ead68bf$var$H = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M180,232a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h80A12,12,0,0,1,180,232Zm40-128a91.51,91.51,0,0,1-35.17,72.35A12.26,12.26,0,0,0,180,186v2a20,20,0,0,1-20,20H96a20,20,0,0,1-20-20v-2a12,12,0,0,0-4.7-9.51A91.57,91.57,0,0,1,36,104.52C35.73,54.69,76,13.2,125.79,12A92,92,0,0,1,220,104Zm-24,0a68,68,0,0,0-69.65-68C89.56,36.88,59.8,67.55,60,104.38a67.71,67.71,0,0,0,26.1,53.19A35.87,35.87,0,0,1,100,184h56.1A36.13,36.13,0,0,1,170,157.49,67.68,67.68,0,0,0,196,104Zm-20.07-5.32a48.5,48.5,0,0,0-31.91-40,12,12,0,0,0-8,22.62,24.31,24.31,0,0,1,16.09,20,12,12,0,0,0,23.86-2.64Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,104a79.86,79.86,0,0,1-30.59,62.92A24.29,24.29,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6a24.11,24.11,0,0,0-9.3-19A79.87,79.87,0,0,1,48,104.45C47.76,61.09,82.72,25,126.07,24A80,80,0,0,1,208,104Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.65,71.65,0,0,0,27.64,56.3A32,32,0,0,1,96,186v6h64v-6a32.15,32.15,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Zm-16.11-9.34a57.6,57.6,0,0,0-46.56-46.55,8,8,0,0,0-2.66,15.78c16.57,2.79,30.63,16.85,33.44,33.45A8,8,0,0,0,176,104a9,9,0,0,0,1.35-.11A8,8,0,0,0,183.89,94.66Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-32.11-9.34a57.6,57.6,0,0,0-46.56-46.55,8,8,0,0,0-2.66,15.78c16.57,2.79,30.63,16.85,33.44,33.45A8,8,0,0,0,176,104a9,9,0,0,0,1.35-.11A8,8,0,0,0,183.89,94.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M174,232a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h80A6,6,0,0,1,174,232Zm40-128a85.56,85.56,0,0,1-32.88,67.64A18.23,18.23,0,0,0,174,186v6a14,14,0,0,1-14,14H96a14,14,0,0,1-14-14v-6a18,18,0,0,0-7-14.23h0a85.59,85.59,0,0,1-33-67.24C41.74,57.91,79.39,19.12,125.93,18A86,86,0,0,1,214,104Zm-12,0a74,74,0,0,0-75.79-74C86.17,31,53.78,64.34,54,104.42a73.67,73.67,0,0,0,28.4,57.87A29.92,29.92,0,0,1,94,186v6a2,2,0,0,0,2,2h64a2,2,0,0,0,2-2v-6a30.18,30.18,0,0,1,11.7-23.78A73.59,73.59,0,0,0,202,104Zm-20.08-9A55.58,55.58,0,0,0,137,50.08a6,6,0,1,0-2,11.84C152.38,64.84,167.13,79.6,170.08,97a6,6,0,0,0,5.91,5,6.87,6.87,0,0,0,1-.08A6,6,0,0,0,181.92,95Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.65,71.65,0,0,0,27.64,56.3A32,32,0,0,1,96,186v6h64v-6a32.15,32.15,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Zm-16.11-9.34a57.6,57.6,0,0,0-46.56-46.55,8,8,0,0,0-2.66,15.78c16.57,2.79,30.63,16.85,33.44,33.45A8,8,0,0,0,176,104a9,9,0,0,0,1.35-.11A8,8,0,0,0,183.89,94.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M172,232a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h80A4,4,0,0,1,172,232Zm40-128a83.59,83.59,0,0,1-32.11,66.06A20.2,20.2,0,0,0,172,186v6a12,12,0,0,1-12,12H96a12,12,0,0,1-12-12v-6a20,20,0,0,0-7.76-15.81A83.58,83.58,0,0,1,44,104.47C43.75,59,80.52,21.09,126,20a84,84,0,0,1,86,84Zm-8,0a76,76,0,0,0-77.83-76C85,29,51.77,63.27,52,104.43a75.62,75.62,0,0,0,29.17,59.43A28,28,0,0,1,92,186v6a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4v-6a28.14,28.14,0,0,1,10.94-22.2A75.62,75.62,0,0,0,204,104ZM136.66,52.06a4,4,0,0,0-1.32,7.88C153.53,63,169,78.45,172.06,96.67A4,4,0,0,0,176,100a3.88,3.88,0,0,0,.67-.06,4,4,0,0,0,3.27-4.61A53.51,53.51,0,0,0,136.66,52.06Z"
        }))
    ]
]), $abb940cf7ead68bf$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $abb940cf7ead68bf$var$r($abb940cf7ead68bf$var$n({
        ref: e
    }, t), {
        weights: $abb940cf7ead68bf$var$H
    })));
$abb940cf7ead68bf$export$2e2bcd8739ae039.displayName = "Lightbulb";


var $acw62 = parcelRequire("acw62");


var $e0551be5b6b0216e$var$L = Object.defineProperty, $e0551be5b6b0216e$var$M = Object.defineProperties;
var $e0551be5b6b0216e$var$c = Object.getOwnPropertyDescriptors;
var $e0551be5b6b0216e$var$n = Object.getOwnPropertySymbols;
var $e0551be5b6b0216e$var$A = Object.prototype.hasOwnProperty, $e0551be5b6b0216e$var$H = Object.prototype.propertyIsEnumerable;
var $e0551be5b6b0216e$var$m = (t, a, l)=>a in t ? $e0551be5b6b0216e$var$L(t, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[a] = l, $e0551be5b6b0216e$var$r = (t, a)=>{
    for(var l in a || (a = {}))$e0551be5b6b0216e$var$A.call(a, l) && $e0551be5b6b0216e$var$m(t, l, a[l]);
    if ($e0551be5b6b0216e$var$n) for (var l of $e0551be5b6b0216e$var$n(a))$e0551be5b6b0216e$var$H.call(a, l) && $e0551be5b6b0216e$var$m(t, l, a[l]);
    return t;
}, $e0551be5b6b0216e$var$Z = (t, a)=>$e0551be5b6b0216e$var$M(t, $e0551be5b6b0216e$var$c(a));
const $e0551be5b6b0216e$var$E = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M230.15,70.54,185.46,25.86a20,20,0,0,0-28.28,0L33.86,149.17A19.86,19.86,0,0,0,28,163.31V208a20,20,0,0,0,20,20H216a12,12,0,0,0,0-24H125L230.15,98.83A20,20,0,0,0,230.15,70.54ZM136,81l11,11L76,163,65,152ZM52,204V173l15.52,15.51h0L83,204Zm52-13L93,180l71-71,11,11Zm88-88L153,64l18.34-18.34,39,39Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M221.66,90.34,192,120,136,64l29.66-29.66a8,8,0,0,1,11.31,0L221.66,79A8,8,0,0,1,221.66,90.34Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM79.32,188,164,103.31,180.69,120,96,204.69ZM68,176.69,51.31,160,136,75.31,152.69,92Zm-20,2.62L76.69,208H48Zm144-70.62L147.32,64l24-24L216,84.69Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM79.32,188l90.34-90.34,16.69,16.68L96,204.69Zm79-101.66h0L68,176.69,51.31,160l90.35-90.34ZM48,179.31,76.69,208H48Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M225.91,74.79,181.22,30.1a14,14,0,0,0-19.8,0L38.1,153.41a13.94,13.94,0,0,0-4.1,9.9V208a14,14,0,0,0,14,14H216a6,6,0,0,0,0-12H110.49L225.91,94.59A14,14,0,0,0,225.91,74.79ZM76.49,188,164,100.48,183.52,120,96,207.51ZM68,179.52,48.49,160,136,72.49,155.52,92ZM46,208V174.48L81.52,210H48A2,2,0,0,1,46,208ZM217.42,86.1,192,111.52,144.49,64,169.9,38.59a2,2,0,0,1,2.83,0l44.69,44.68A2,2,0,0,1,217.42,86.1Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM136,75.31,152.69,92,68,176.69,51.31,160ZM48,208V179.31L76.69,208Zm48-3.31L79.32,188,164,103.31,180.69,120Zm96-96L147.32,64l24-24L216,84.69Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224.49,76.2,179.8,31.51a12,12,0,0,0-17,0L39.51,154.83A12,12,0,0,0,36,163.31V208a12,12,0,0,0,12,12H216a4,4,0,0,0,0-8H105.66L224.49,93.17A12,12,0,0,0,224.49,76.2ZM73.66,188,164,97.66,186.35,120,96,210.34ZM68,182.34,45.66,160,136,69.66,158.35,92ZM44,208V169.66l21.17,21.17h0L86.34,212H48A4,4,0,0,1,44,208ZM218.83,87.51,192,114.34,141.66,64l26.83-26.83a4,4,0,0,1,5.66,0l44.68,44.69A4,4,0,0,1,218.83,87.51Z"
        }))
    ]
]), $e0551be5b6b0216e$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $e0551be5b6b0216e$var$Z($e0551be5b6b0216e$var$r({
        ref: a
    }, t), {
        weights: $e0551be5b6b0216e$var$E
    })));
$e0551be5b6b0216e$export$2e2bcd8739ae039.displayName = "PencilLine";




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
var $9ac152c824b2d089$var$__defProp = Object.defineProperty;
var $9ac152c824b2d089$var$__defNormalProp = (obj, key, value)=>key in obj ? $9ac152c824b2d089$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9ac152c824b2d089$var$__publicField = (obj, key, value)=>{
    $9ac152c824b2d089$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/observe.ts
var $9ac152c824b2d089$var$observerMap = /* @__PURE__ */ new Map();
var $9ac152c824b2d089$var$RootIds = /* @__PURE__ */ new WeakMap();
var $9ac152c824b2d089$var$rootId = 0;
var $9ac152c824b2d089$var$unsupportedValue = void 0;
function $9ac152c824b2d089$export$2ef3a60ee1f37bec(inView) {
    $9ac152c824b2d089$var$unsupportedValue = inView;
}
function $9ac152c824b2d089$var$getRootId(root) {
    if (!root) return "0";
    if ($9ac152c824b2d089$var$RootIds.has(root)) return $9ac152c824b2d089$var$RootIds.get(root);
    $9ac152c824b2d089$var$rootId += 1;
    $9ac152c824b2d089$var$RootIds.set(root, $9ac152c824b2d089$var$rootId.toString());
    return $9ac152c824b2d089$var$RootIds.get(root);
}
function $9ac152c824b2d089$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $9ac152c824b2d089$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $9ac152c824b2d089$var$createObserver(options) {
    let id = $9ac152c824b2d089$var$optionsToId(options);
    let instance = $9ac152c824b2d089$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $9ac152c824b2d089$var$observerMap.set(id, instance);
    }
    return instance;
}
function $9ac152c824b2d089$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $9ac152c824b2d089$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $9ac152c824b2d089$var$createObserver(options);
    let callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $9ac152c824b2d089$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $9ac152c824b2d089$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $9ac152c824b2d089$export$a62107ca74432f44 = class extends $acw62.Component {
    constructor(props){
        super(props);
        $9ac152c824b2d089$var$__publicField(this, "node", null);
        $9ac152c824b2d089$var$__publicField(this, "_unobserveCb", null);
        $9ac152c824b2d089$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $9ac152c824b2d089$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$9ac152c824b2d089$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
        this.node = null;
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $9ac152c824b2d089$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $acw62.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $9ac152c824b2d089$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $acw62.useState(null);
    const callback = $acw62.useRef();
    const [state, setState] = $acw62.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $acw62.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $9ac152c824b2d089$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $acw62.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}


function $7a7a7174f7bc9055$export$1391212d75b2ee65(ms = 1000) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $7a7a7174f7bc9055$export$24fab8e739feba68(props) {
    let { ani: ani, ticks: ticks, children: children, ...rest } = props;
    const [turnState, setTurnState] = (0, $acw62.useState)([]);
    const { ref: ref, inView: inView, entry: entry } = (0, $9ac152c824b2d089$export$2f62ee6831462844)({
        threshold: 0
    });
    children = children(turnState);
    (0, $acw62.useEffect)(()=>{
        const len = children.props?.children?.length;
        if (!len) return;
        const run = async ()=>{
            for(let i = 0; i < len; i++){
                if (inView) await $7a7a7174f7bc9055$export$1391212d75b2ee65(ticks?.[i] || 200);
                turnState[i] = inView ? ani || true : false;
                setTurnState([
                    ...turnState
                ]);
            }
        };
        if (turnState.length || inView) run().catch(console.error);
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        ...rest,
        children: children
    });
}




var $acw62 = parcelRequire("acw62");


const $db27b74bdbc5c721$var$featuresSlideItems = [
    {
        label: "Students",
        icon: "\uD83E\uDDD1‍\uD83C\uDF93",
        notes: [
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72820fc93eb2f5e8$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Review notes",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Capture, structure, and review all of your class notes with ease using the",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            children: " Linked References"
                        }),
                        ", ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/queries",
                            children: "Queries"
                        }),
                        ", and ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/search",
                            children: "Search"
                        }),
                        " features."
                    ]
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0582f6dc96bba02$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Memorize facts",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Remember facts and insights using the ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/flashcards",
                            children: "Flashcards"
                        }),
                        " feature."
                    ]
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0551be5b6b0216e$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Outline essays",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Organize your thoughts and ideas, and quickly turn them into outlines using ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/term%2Fblock%20reference",
                            children: "Block References"
                        }),
                        "."
                    ]
                })
            }
        ]
    },
    {
        label: "Academics",
        icon: "\uD83C\uDF93",
        notes: [
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72820fc93eb2f5e8$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Review notes",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Capture, structure, and review all of your class notes with ease using the",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            children: " Linked References"
                        }),
                        ", ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/queries",
                            children: "Queries"
                        }),
                        ", and ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/search",
                            children: "Search "
                        }),
                        "features."
                    ]
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d83094b996eadb6b$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Investigate claims",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "Spin your web of knowledge and see what evidence supports or contradicts claims."
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92cfd8aa6e9e1dbf$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Manage sources",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Keep track of your research and easily manage your sources using the built-in",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/zotero",
                            children: " Zotero integration"
                        }),
                        "."
                    ]
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0551be5b6b0216e$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Outline papers",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "Manage your writing process and ensure that your papers are well-organized and flow smoothly."
                })
            }
        ]
    },
    {
        label: "Writers",
        icon: "\uD83D\uDD8B",
        notes: [
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72820fc93eb2f5e8$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Review notes",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Capture, structure, and review all of your class notes with ease using the",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            children: " Linked References"
                        }),
                        ", ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/queries",
                            children: "Queries"
                        }),
                        ", and ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/search",
                            children: "Search "
                        }),
                        "features."
                    ]
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1bb269cb2484cf74$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Manage writing stages",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Manage your personal writing process using ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/tasks",
                            children: "Tasks"
                        }),
                        ",",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            children: " Tags"
                        }),
                        ", and ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/queries",
                            children: "Queries"
                        }),
                        " --no matter how simple or complex it is."
                    ]
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $abb940cf7ead68bf$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Combine ideas",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Effortlessly synthesize ideas from across your collection of notes using",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/term%2Fblock%20reference",
                            children: " Block References"
                        }),
                        "."
                    ]
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0551be5b6b0216e$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Outline content",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "Organize your thoughts and reuse ideas in easy-to-manage outlines."
                })
            }
        ]
    },
    {
        label: "Project Managers",
        icon: "\uD83D\uDCC6",
        notes: [
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72820fc93eb2f5e8$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Retrieve notes",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Always find the information where and when you need it using",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            children: " Linked References"
                        }),
                        ", ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/queries",
                            children: "Queries"
                        }),
                        " or ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/search",
                            children: "Search"
                        }),
                        "."
                    ]
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac1ad873514c9884$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Manage tasks",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Manage tasks with Logseq's built-in",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/tasks",
                            children: " Task management system"
                        }),
                        ", including",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/tasks/block/priorities",
                            children: " Priorities"
                        }),
                        ", ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/tasks/block/deadline%20and%20scheduled",
                            children: "Scheduling"
                        }),
                        ", and",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/tasks/block/deadline%20and%20scheduled",
                            children: " Deadlines"
                        }),
                        "."
                    ]
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13c232801a25a5b6$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Create dashboards",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "Easily create dynamic dashboards to separate tasks and notes and keep track of many projects simultaneously."
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0551be5b6b0216e$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Outline documents",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "Quickly pull together information and share it in different formats with stakeholders."
                })
            }
        ]
    },
    {
        label: "Developers",
        icon: "\uD83D\uDCBB",
        notes: [
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72820fc93eb2f5e8$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Retrieve notes",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Quickly find relevant information using the",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            children: " Linked References"
                        }),
                        ", ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/queries",
                            children: "Queries"
                        }),
                        " or ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/search",
                            children: "Search"
                        }),
                        "."
                    ]
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0582f6dc96bba02$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Memorize shortcuts",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "Become a 10x programmer by remembering more of what you need to do repeatedly."
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $abb940cf7ead68bf$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Decide on solutions",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "Find the best solutions to nagging problems by tracking your ideas, decisions, and priorities over time."
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $97ed57a3521a6daf$export$2e2bcd8739ae039), {
                    size: 20,
                    weight: "duotone"
                }),
                title: "Build a personal wiki",
                desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Build your career by building your personal wiki. Easily structure your knowledge and find it back using ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/properties",
                            children: "Properties"
                        }),
                        ", ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            children: "Namespaces"
                        }),
                        ", ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            children: "Linked References"
                        }),
                        ", and ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            target: "_blank",
                            href: "https://docs.logseq.com/#/page/queries",
                            children: "Queries"
                        }),
                        "."
                    ]
                })
            }
        ]
    }
];
function $db27b74bdbc5c721$export$923159eb2cd89f1e(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "desc-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                className: "flex items-center text-[18px] sm:text-[20px]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "scale-90 sm:scale-100 w-[34px] h-[34px] bg-gray-400/40 rounded-full flex items-center justify-center",
                        children: props.icon
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "whitespace-nowrap font-normal pl-[14px]",
                        children: props.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "hidden sm:block pl-12 py-2 text-gray-200/70 leading-6 text-base",
                children: props.desc
            })
        ]
    });
}
function $db27b74bdbc5c721$export$6ce07b02ffb5b9d9(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("app-window-holder animate-in zoom-in-50 duration-500", props.withoutLogo && "without-logo")
    });
}
function $db27b74bdbc5c721$export$4128123974d23094(props) {
    let inner = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "a",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db27b74bdbc5c721$export$6ce07b02ffb5b9d9, {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "b",
                children: props.activeItem?.notes.map((it)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db27b74bdbc5c721$export$923159eb2cd89f1e, {
                        ...it
                    }, it.title);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "c sm:hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db27b74bdbc5c721$export$6ce07b02ffb5b9d9, {
                    withoutLogo: true
                })
            })
        ]
    });
    const labelId = (0, $3b479ead6613d9c6$export$c383cdd2a518017a)(props.activeItem?.label);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "app-tutorial-features-panel relative",
        id: labelId,
        role: "tabpanel",
        "aria-labelledby": "tab-" + labelId,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "bd",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`wrap flex`, `is-${props.activeItem?.label.toLocaleLowerCase()}`),
                children: inner
            })
        })
    });
}
function $db27b74bdbc5c721$export$e63279bb50575332() {
    const [activeIndex, setActiveIndex] = (0, $acw62.useState)(0);
    const activeItem = $db27b74bdbc5c721$var$featuresSlideItems[activeIndex];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "app-tutorial-features-slide",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "inner px-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                    className: "tabs flex space-x-8 justify-around",
                    role: "tablist",
                    children: $db27b74bdbc5c721$var$featuresSlideItems.map((it, idx)=>{
                        const labelId = (0, $3b479ead6613d9c6$export$c383cdd2a518017a)(it.label);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                                active: idx === activeIndex
                            }),
                            onClick: ()=>setActiveIndex(idx),
                            tabIndex: activeIndex === idx ? 0 : -1,
                            role: "tab",
                            "aria-controls": labelId,
                            id: "tab-" + labelId,
                            "aria-selected": activeIndex === idx,
                            onKeyDown: (0, $3b479ead6613d9c6$export$e7493836a310b8ae),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "py-4 px-2 flex flex-col items-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: it.icon
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: it.label
                                    })
                                ]
                            })
                        }, it.label);
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db27b74bdbc5c721$export$4128123974d23094, {
                    activeItem: activeItem
                })
            ]
        })
    });
}
function $db27b74bdbc5c721$export$d814d6ed7ad7e165() {
    const [activeIndex, setActiveIndex] = (0, $acw62.useState)(0);
    const activeItem = $db27b74bdbc5c721$var$featuresSlideItems[activeIndex];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("app-tutorial-features-select", `index-of-${activeIndex}`),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "app-form-select-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "icon",
                        children: activeItem.icon
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                        className: "app-form-select w-full",
                        onChange: (e)=>{
                            setActiveIndex(e.target.selectedIndex);
                        },
                        value: activeIndex,
                        "aria-label": "Select your role",
                        children: $db27b74bdbc5c721$var$featuresSlideItems.map((it, idx)=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: idx,
                                children: it.label
                            }, it.label);
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "arrow",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ded21779901b8c91$export$2e2bcd8739ae039), {
                            weight: "bold"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db27b74bdbc5c721$export$4128123974d23094, {
                activeItem: activeItem
            })
        ]
    });
}
function $db27b74bdbc5c721$export$aed4c85e0e07e0de(props) {
    const appState = (0, $0b89d474933103bc$export$9973955de2bf96cf)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-tutorial-showcase",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a7a7174f7bc9055$export$24fab8e739feba68), {
                ticks: [
                    100,
                    500,
                    1200
                ],
                className: "flex flex-col py-10 px-4 sm:justify-center sm:items-center sm:py-20 hd",
                children: (t)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("text-4xl sm:text-6xl text-logseq-50/80 invisible", t[0] && "ani-slide-in-from-bottom"),
                                children: "Today, everyone is a"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("text-4xl sm:text-6xl font-semibold pt-1 opacity-94 invisible", t[1] && "ani-slide-in-from-bottom"),
                                children: "knowledge worker."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("pt-2 sm:pt-0 sm:flex justify-center sm:flex-col items-center invisible", t[2] && "ani-fade-in"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "inline text-2xl sm:text-4xl font-normal pt-8 text-logseq-50/80",
                                        children: "Logseq is the open toolbox for "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        className: "inline text-2xl sm:text-4xl pt-2 opacity-94",
                                        children: "workflows that deal with lots of information:"
                                    })
                                ]
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: "hidden sub-hd sm:flex justify-center space-x-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: "Task Management"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: "PDF Annotations"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: "Flashcards"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "relative",
                            children: [
                                "Whiteboards",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("sup", {
                                    children: "NEW"
                                })
                            ]
                        })
                    })
                ]
            }),
            appState.sm.get() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db27b74bdbc5c721$export$d814d6ed7ad7e165, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db27b74bdbc5c721$export$e63279bb50575332, {})
        ]
    });
}





/*!
  * PhotoSwipe Lightbox 5.3.8 - https://photoswipe.com
  * (c) 2023 Dmytro Semenov
  */ /** @typedef {import('../photoswipe.js').Point} Point */ /**
 * @template {keyof HTMLElementTagNameMap} T
 * @param {string} className
 * @param {T} tagName
 * @param {Node} [appendToEl]
 * @returns {HTMLElementTagNameMap[T]}
 */ function $12ba7f17b3976b6d$var$createElement(className, tagName, appendToEl) {
    const el = document.createElement(tagName);
    if (className) el.className = className;
    if (appendToEl) appendToEl.appendChild(el);
    return el;
}
/**
 * Get transform string
 *
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 * @returns {string}
 */ function $12ba7f17b3976b6d$var$toTransformString(x, y, scale) {
    let propValue = `translate3d(${x}px,${y || 0}px,0)`;
    if (scale !== undefined) propValue += ` scale3d(${scale},${scale},1)`;
    return propValue;
}
/**
 * Apply width and height CSS properties to element
 *
 * @param {HTMLElement} el
 * @param {string | number} w
 * @param {string | number} h
 */ function $12ba7f17b3976b6d$var$setWidthHeight(el, w, h) {
    el.style.width = typeof w === "number" ? `${w}px` : w;
    el.style.height = typeof h === "number" ? `${h}px` : h;
}
/** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState */ /** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */ const $12ba7f17b3976b6d$var$LOAD_STATE = {
    IDLE: "idle",
    LOADING: "loading",
    LOADED: "loaded",
    ERROR: "error"
};
/**
 * Check if click or keydown event was dispatched
 * with a special key or via mouse wheel.
 *
 * @param {MouseEvent | KeyboardEvent} e
 * @returns {boolean}
 */ function $12ba7f17b3976b6d$var$specialKeyUsed(e) {
    return "button" in e && e.button === 1 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
}
/**
 * Parse `gallery` or `children` options.
 *
 * @param {import('../photoswipe.js').ElementProvider} [option]
 * @param {string} [legacySelector]
 * @param {HTMLElement | Document} [parent]
 * @returns HTMLElement[]
 */ function $12ba7f17b3976b6d$var$getElementsFromOption(option, legacySelector, parent = document) {
    /** @type {HTMLElement[]} */ let elements = [];
    if (option instanceof Element) elements = [
        option
    ];
    else if (option instanceof NodeList || Array.isArray(option)) elements = Array.from(option);
    else {
        const selector = typeof option === "string" ? option : legacySelector;
        if (selector) elements = Array.from(parent.querySelectorAll(selector));
    }
    return elements;
}
/**
 * Check if variable is PhotoSwipe class
 *
 * @param {any} fn
 * @returns {boolean}
 */ function $12ba7f17b3976b6d$var$isPswpClass(fn) {
    return typeof fn === "function" && fn.prototype && fn.prototype.goTo;
}
/**
 * Check if browser is Safari
 *
 * @returns {boolean}
 */ function $12ba7f17b3976b6d$var$isSafari() {
    return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}
/** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').DataSource} DataSource */ /** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData */ /** @typedef {import('../slide/content.js').default} ContentDefault */ /** @typedef {import('../slide/slide.js').default} Slide */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /** @typedef {import('../slide/zoom-level.js').default} ZoomLevel */ /** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds */ /**
 * Allow adding an arbitrary props to the Content
 * https://photoswipe.com/custom-content/#using-webp-image-format
 * @typedef {ContentDefault & Record<string, any>} Content
 */ /** @typedef {{ x?: number; y?: number }} Point */ /**
 * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
 *
 *
 * https://photoswipe.com/adding-ui-elements/
 *
 * @prop {undefined} uiRegister
 * @prop {{ data: UIElementData }} uiElementCreate
 *
 *
 * https://photoswipe.com/events/#initialization-events
 *
 * @prop {undefined} beforeOpen
 * @prop {undefined} firstUpdate
 * @prop {undefined} initialLayout
 * @prop {undefined} change
 * @prop {undefined} afterInit
 * @prop {undefined} bindEvents
 *
 *
 * https://photoswipe.com/events/#opening-or-closing-transition-events
 *
 * @prop {undefined} openingAnimationStart
 * @prop {undefined} openingAnimationEnd
 * @prop {undefined} closingAnimationStart
 * @prop {undefined} closingAnimationEnd
 *
 *
 * https://photoswipe.com/events/#closing-events
 *
 * @prop {undefined} close
 * @prop {undefined} destroy
 *
 *
 * https://photoswipe.com/events/#pointer-and-gesture-events
 *
 * @prop {{ originalEvent: PointerEvent }} pointerDown
 * @prop {{ originalEvent: PointerEvent }} pointerMove
 * @prop {{ originalEvent: PointerEvent }} pointerUp
 * @prop {{ bgOpacity: number }} pinchClose can be default prevented
 * @prop {{ panY: number }} verticalDrag can be default prevented
 *
 *
 * https://photoswipe.com/events/#slide-content-events
 *
 * @prop {{ content: Content }} contentInit
 * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
 * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
 * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
 * @prop {{ content: Content; slide: Slide }} loadError
 * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
 * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
 * @prop {{ content: Content }} contentLazyLoad can be default prevented
 * @prop {{ content: Content }} contentAppend can be default prevented
 * @prop {{ content: Content }} contentActivate can be default prevented
 * @prop {{ content: Content }} contentDeactivate can be default prevented
 * @prop {{ content: Content }} contentRemove can be default prevented
 * @prop {{ content: Content }} contentDestroy can be default prevented
 *
 *
 * undocumented
 *
 * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
 *
 * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
 * @prop {{ x: number; dragging: boolean }} moveMainScroll
 * @prop {{ slide: Slide }} firstZoomPan
 * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
 * @prop {undefined} beforeResize
 * @prop {undefined} resize
 * @prop {undefined} viewportSize
 * @prop {undefined} updateScrollOffset
 * @prop {{ slide: Slide }} slideInit
 * @prop {{ slide: Slide }} afterSetContent
 * @prop {{ slide: Slide }} slideLoad
 * @prop {{ slide: Slide }} appendHeavy can be default prevented
 * @prop {{ slide: Slide }} appendHeavyContent
 * @prop {{ slide: Slide }} slideActivate
 * @prop {{ slide: Slide }} slideDeactivate
 * @prop {{ slide: Slide }} slideDestroy
 * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
 * @prop {{ slide: Slide }} zoomPanUpdate
 * @prop {{ slide: Slide }} initialZoomPan
 * @prop {{ slide: Slide }} calcSlideSize
 * @prop {undefined} resolutionChanged
 * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
 * @prop {{ content: Content }} contentAppendImage can be default prevented
 * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
 * @prop {undefined} lazyLoad
 * @prop {{ slide: Slide }} calcBounds
 * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
 *
 *
 * legacy
 *
 * @prop {undefined} init
 * @prop {undefined} initialZoomIn
 * @prop {undefined} initialZoomOut
 * @prop {undefined} initialZoomInEnd
 * @prop {undefined} initialZoomOutEnd
 * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
 * @prop {{ itemData: SlideData; index: number }} itemData
 * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
 */ /**
 * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
 *
 * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
 * Modify the total amount of slides. Example on Data sources page.
 * https://photoswipe.com/filters/#numitems
 *
 * @prop {(itemData: SlideData, index: number) => SlideData} itemData
 * Modify slide item data. Example on Data sources page.
 * https://photoswipe.com/filters/#itemdata
 *
 * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
 * Modify item data when it's parsed from DOM element. Example on Data sources page.
 * https://photoswipe.com/filters/#domitemdata
 *
 * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
 * Modify clicked gallery item index.
 * https://photoswipe.com/filters/#clickedindex
 *
 * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
 * Modify placeholder image source.
 * https://photoswipe.com/filters/#placeholdersrc
 *
 * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
 * Modify if the content is currently loading.
 * https://photoswipe.com/filters/#iscontentloading
 *
 * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
 * Modify if the content can be zoomed.
 * https://photoswipe.com/filters/#iscontentzoomable
 *
 * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
 * Modify if the placeholder should be used for the content.
 * https://photoswipe.com/filters/#usecontentplaceholder
 *
 * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
 * Modify if the placeholder should be kept after the content is loaded.
 * https://photoswipe.com/filters/#iskeepingplaceholder
 *
 *
 * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
 * Modify an element when the content has error state (for example, if image cannot be loaded).
 * https://photoswipe.com/filters/#contenterrorelement
 *
 * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
 * Modify a UI element that's being created.
 * https://photoswipe.com/filters/#uielement
 *
 * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
 * Modify the thubmnail element from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbel
 *
 * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
 * Modify the thubmnail bounds from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbbounds
 *
 * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
 *
 */ /**
 * @template {keyof PhotoSwipeFiltersMap} T
 * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
 */ /**
 * Base PhotoSwipe event object
 *
 * @template {keyof PhotoSwipeEventsMap} T
 */ class $12ba7f17b3976b6d$var$PhotoSwipeEvent {
    /**
   * @param {T} type
   * @param {PhotoSwipeEventsMap[T]} [details]
   */ constructor(type, details){
        this.type = type;
        this.defaultPrevented = false;
        if (details) Object.assign(this, details);
    }
    preventDefault() {
        this.defaultPrevented = true;
    }
}
/**
 * PhotoSwipe base class that can listen and dispatch for events.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
 */ class $12ba7f17b3976b6d$var$Eventable {
    constructor(){
        /**
     * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
     */ this._listeners = {};
        /**
     * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
     */ this._filters = {};
        /** @type {PhotoSwipe | undefined} */ this.pswp = undefined;
        /** @type {PhotoSwipeOptions | undefined} */ this.options = undefined;
    }
    /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */ addFilter(name, fn, priority = 100) {
        if (!this._filters[name]) this._filters[name] = [];
        this._filters[name]?.push({
            fn: fn,
            priority: priority
        });
        this._filters[name]?.sort((f1, f2)=>f1.priority - f2.priority);
        this.pswp?.addFilter(name, fn, priority);
    }
    /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   */ removeFilter(name, fn) {
        if (this._filters[name]) // @ts-expect-error
        this._filters[name] = this._filters[name].filter((filter)=>filter.fn !== fn);
        if (this.pswp) this.pswp.removeFilter(name, fn);
    }
    /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
   */ applyFilters(name, ...args) {
        this._filters[name]?.forEach((filter)=>{
            // @ts-expect-error
            args[0] = filter.fn.apply(this, args);
        });
        return args[0];
    }
    /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */ on(name, fn) {
        if (!this._listeners[name]) this._listeners[name] = [];
        this._listeners[name]?.push(fn);
        // When binding events to lightbox,
        // also bind events to PhotoSwipe Core,
        // if it's open.
        this.pswp?.on(name, fn);
    }
    /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */ off(name, fn) {
        if (this._listeners[name]) // @ts-expect-error
        this._listeners[name] = this._listeners[name].filter((listener)=>fn !== listener);
        this.pswp?.off(name, fn);
    }
    /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {PhotoSwipeEventsMap[T]} [details]
   * @returns {AugmentedEvent<T>}
   */ dispatch(name, details) {
        if (this.pswp) return this.pswp.dispatch(name, details);
        const event = /** @type {AugmentedEvent<T>} */ new $12ba7f17b3976b6d$var$PhotoSwipeEvent(name, details);
        this._listeners[name]?.forEach((listener)=>{
            listener.call(this, event);
        });
        return event;
    }
}
class $12ba7f17b3976b6d$var$Placeholder {
    /**
   * @param {string | false} imageSrc
   * @param {HTMLElement} container
   */ constructor(imageSrc, container){
        // Create placeholder
        // (stretched thumbnail or simple div behind the main image)
        /** @type {HTMLImageElement | HTMLDivElement | null} */ this.element = $12ba7f17b3976b6d$var$createElement("pswp__img pswp__img--placeholder", imageSrc ? "img" : "div", container);
        if (imageSrc) {
            const imgEl = /** @type {HTMLImageElement} */ this.element;
            imgEl.decoding = "async";
            imgEl.alt = "";
            imgEl.src = imageSrc;
            imgEl.setAttribute("role", "presentation");
        }
        this.element.setAttribute("aria-hidden", "true");
    }
    /**
   * @param {number} width
   * @param {number} height
   */ setDisplayedSize(width, height) {
        if (!this.element) return;
        if (this.element.tagName === "IMG") {
            // Use transform scale() to modify img placeholder size
            // (instead of changing width/height directly).
            // This helps with performance, specifically in iOS15 Safari.
            $12ba7f17b3976b6d$var$setWidthHeight(this.element, 250, "auto");
            this.element.style.transformOrigin = "0 0";
            this.element.style.transform = $12ba7f17b3976b6d$var$toTransformString(0, 0, width / 250);
        } else $12ba7f17b3976b6d$var$setWidthHeight(this.element, width, height);
    }
    destroy() {
        if (this.element?.parentNode) this.element.remove();
        this.element = null;
    }
}
/** @typedef {import('./slide.js').default} Slide */ /** @typedef {import('./slide.js').SlideData} SlideData */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../util/util.js').LoadState} LoadState */ class $12ba7f17b3976b6d$var$Content {
    /**
   * @param {SlideData} itemData Slide data
   * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
   * @param {number} index
   */ constructor(itemData, instance, index){
        this.instance = instance;
        this.data = itemData;
        this.index = index;
        /** @type {HTMLImageElement | HTMLDivElement | undefined} */ this.element = undefined;
        /** @type {Placeholder | undefined} */ this.placeholder = undefined;
        /** @type {Slide | undefined} */ this.slide = undefined;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        /** @type {LoadState} */ this.state = $12ba7f17b3976b6d$var$LOAD_STATE.IDLE;
        if (this.data.type) this.type = this.data.type;
        else if (this.data.src) this.type = "image";
        else this.type = "html";
        this.instance.dispatch("contentInit", {
            content: this
        });
    }
    removePlaceholder() {
        if (this.placeholder && !this.keepPlaceholder()) // With delay, as image might be loaded, but not rendered
        setTimeout(()=>{
            if (this.placeholder) {
                this.placeholder.destroy();
                this.placeholder = undefined;
            }
        }, 1000);
    }
    /**
   * Preload content
   *
   * @param {boolean} isLazy
   * @param {boolean} [reload]
   */ load(isLazy, reload) {
        if (this.slide && this.usePlaceholder()) {
            if (!this.placeholder) {
                const placeholderSrc = this.instance.applyFilters("placeholderSrc", // use  image-based placeholder only for the first slide,
                // as rendering (even small stretched thumbnail) is an expensive operation
                this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false, this);
                this.placeholder = new $12ba7f17b3976b6d$var$Placeholder(placeholderSrc, this.slide.container);
            } else {
                const placeholderEl = this.placeholder.element;
                // Add placeholder to DOM if it was already created
                if (placeholderEl && !placeholderEl.parentElement) this.slide.container.prepend(placeholderEl);
            }
        }
        if (this.element && !reload) return;
        if (this.instance.dispatch("contentLoad", {
            content: this,
            isLazy: isLazy
        }).defaultPrevented) return;
        if (this.isImageContent()) {
            this.element = $12ba7f17b3976b6d$var$createElement("pswp__img", "img");
            // Start loading only after width is defined, as sizes might depend on it.
            // Due to Safari feature, we must define sizes before srcset.
            if (this.displayedImageWidth) this.loadImage(isLazy);
        } else {
            this.element = $12ba7f17b3976b6d$var$createElement("pswp__content", "div");
            this.element.innerHTML = this.data.html || "";
        }
        if (reload && this.slide) this.slide.updateContentSize(true);
    }
    /**
   * Preload image
   *
   * @param {boolean} isLazy
   */ loadImage(isLazy) {
        if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", {
            content: this,
            isLazy: isLazy
        }).defaultPrevented) return;
        const imageElement = /** @type HTMLImageElement */ this.element;
        this.updateSrcsetSizes();
        if (this.data.srcset) imageElement.srcset = this.data.srcset;
        imageElement.src = this.data.src ?? "";
        imageElement.alt = this.data.alt ?? "";
        this.state = $12ba7f17b3976b6d$var$LOAD_STATE.LOADING;
        if (imageElement.complete) this.onLoaded();
        else {
            imageElement.onload = ()=>{
                this.onLoaded();
            };
            imageElement.onerror = ()=>{
                this.onError();
            };
        }
    }
    /**
   * Assign slide to content
   *
   * @param {Slide} slide
   */ setSlide(slide) {
        this.slide = slide;
        this.hasSlide = true;
        this.instance = slide.pswp;
    // todo: do we need to unset slide?
    }
    /**
   * Content load success handler
   */ onLoaded() {
        this.state = $12ba7f17b3976b6d$var$LOAD_STATE.LOADED;
        if (this.slide && this.element) {
            this.instance.dispatch("loadComplete", {
                slide: this.slide,
                content: this
            });
            // if content is reloaded
            if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
                this.append();
                this.slide.updateContentSize(true);
            }
            if (this.state === $12ba7f17b3976b6d$var$LOAD_STATE.LOADED || this.state === $12ba7f17b3976b6d$var$LOAD_STATE.ERROR) this.removePlaceholder();
        }
    }
    /**
   * Content load error handler
   */ onError() {
        this.state = $12ba7f17b3976b6d$var$LOAD_STATE.ERROR;
        if (this.slide) {
            this.displayError();
            this.instance.dispatch("loadComplete", {
                slide: this.slide,
                isError: true,
                content: this
            });
            this.instance.dispatch("loadError", {
                slide: this.slide,
                content: this
            });
        }
    }
    /**
   * @returns {Boolean} If the content is currently loading
   */ isLoading() {
        return this.instance.applyFilters("isContentLoading", this.state === $12ba7f17b3976b6d$var$LOAD_STATE.LOADING, this);
    }
    /**
   * @returns {Boolean} If the content is in error state
   */ isError() {
        return this.state === $12ba7f17b3976b6d$var$LOAD_STATE.ERROR;
    }
    /**
   * @returns {boolean} If the content is image
   */ isImageContent() {
        return this.type === "image";
    }
    /**
   * Update content size
   *
   * @param {Number} width
   * @param {Number} height
   */ setDisplayedSize(width, height) {
        if (!this.element) return;
        if (this.placeholder) this.placeholder.setDisplayedSize(width, height);
        if (this.instance.dispatch("contentResize", {
            content: this,
            width: width,
            height: height
        }).defaultPrevented) return;
        $12ba7f17b3976b6d$var$setWidthHeight(this.element, width, height);
        if (this.isImageContent() && !this.isError()) {
            const isInitialSizeUpdate = !this.displayedImageWidth && width;
            this.displayedImageWidth = width;
            this.displayedImageHeight = height;
            if (isInitialSizeUpdate) this.loadImage(false);
            else this.updateSrcsetSizes();
            if (this.slide) this.instance.dispatch("imageSizeChange", {
                slide: this.slide,
                width: width,
                height: height,
                content: this
            });
        }
    }
    /**
   * @returns {boolean} If the content can be zoomed
   */ isZoomable() {
        return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== $12ba7f17b3976b6d$var$LOAD_STATE.ERROR, this);
    }
    /**
   * Update image srcset sizes attribute based on width and height
   */ updateSrcsetSizes() {
        // Handle srcset sizes attribute.
        //
        // Never lower quality, if it was increased previously.
        // Chrome does this automatically, Firefox and Safari do not,
        // so we store largest used size in dataset.
        if (!this.isImageContent() || !this.element || !this.data.srcset) return;
        const image = /** @type HTMLImageElement */ this.element;
        const sizesWidth = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
        if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
            image.sizes = sizesWidth + "px";
            image.dataset.largestUsedSize = String(sizesWidth);
        }
    }
    /**
   * @returns {boolean} If content should use a placeholder (from msrc by default)
   */ usePlaceholder() {
        return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this);
    }
    /**
   * Preload content with lazy-loading param
   */ lazyLoad() {
        if (this.instance.dispatch("contentLazyLoad", {
            content: this
        }).defaultPrevented) return;
        this.load(true);
    }
    /**
   * @returns {boolean} If placeholder should be kept after content is loaded
   */ keepPlaceholder() {
        return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this);
    }
    /**
   * Destroy the content
   */ destroy() {
        this.hasSlide = false;
        this.slide = undefined;
        if (this.instance.dispatch("contentDestroy", {
            content: this
        }).defaultPrevented) return;
        this.remove();
        if (this.placeholder) {
            this.placeholder.destroy();
            this.placeholder = undefined;
        }
        if (this.isImageContent() && this.element) {
            this.element.onload = null;
            this.element.onerror = null;
            this.element = undefined;
        }
    }
    /**
   * Display error message
   */ displayError() {
        if (this.slide) {
            let errorMsgEl = $12ba7f17b3976b6d$var$createElement("pswp__error-msg", "div");
            errorMsgEl.innerText = this.instance.options?.errorMsg ?? "";
            errorMsgEl = /** @type {HTMLDivElement} */ this.instance.applyFilters("contentErrorElement", errorMsgEl, this);
            this.element = $12ba7f17b3976b6d$var$createElement("pswp__content pswp__error-msg-container", "div");
            this.element.appendChild(errorMsgEl);
            this.slide.container.innerText = "";
            this.slide.container.appendChild(this.element);
            this.slide.updateContentSize(true);
            this.removePlaceholder();
        }
    }
    /**
   * Append the content
   */ append() {
        if (this.isAttached || !this.element) return;
        this.isAttached = true;
        if (this.state === $12ba7f17b3976b6d$var$LOAD_STATE.ERROR) {
            this.displayError();
            return;
        }
        if (this.instance.dispatch("contentAppend", {
            content: this
        }).defaultPrevented) return;
        const supportsDecode = "decode" in this.element;
        if (this.isImageContent()) {
            // Use decode() on nearby slides
            //
            // Nearby slide images are in DOM and not hidden via display:none.
            // However, they are placed offscreen (to the left and right side).
            //
            // Some browsers do not composite the image until it's actually visible,
            // using decode() helps.
            //
            // You might ask "why dont you just decode() and then append all images",
            // that's because I want to show image before it's fully loaded,
            // as browser can render parts of image while it is loading.
            // We do not do this in Safari due to partial loading bug.
            if (supportsDecode && this.slide && (!this.slide.isActive || $12ba7f17b3976b6d$var$isSafari())) {
                this.isDecoding = true;
                // purposefully using finally instead of then,
                // as if srcset sizes changes dynamically - it may cause decode error
                /** @type {HTMLImageElement} */ this.element.decode().catch(()=>{}).finally(()=>{
                    this.isDecoding = false;
                    this.appendImage();
                });
            } else this.appendImage();
        } else if (this.slide && !this.element.parentNode) this.slide.container.appendChild(this.element);
    }
    /**
   * Activate the slide,
   * active slide is generally the current one,
   * meaning the user can see it.
   */ activate() {
        if (this.instance.dispatch("contentActivate", {
            content: this
        }).defaultPrevented || !this.slide) return;
        if (this.isImageContent() && this.isDecoding && !$12ba7f17b3976b6d$var$isSafari()) // add image to slide when it becomes active,
        // even if it's not finished decoding
        this.appendImage();
        else if (this.isError()) this.load(false, true); // try to reload
        if (this.slide.holderElement) this.slide.holderElement.setAttribute("aria-hidden", "false");
    }
    /**
   * Deactivate the content
   */ deactivate() {
        this.instance.dispatch("contentDeactivate", {
            content: this
        });
        if (this.slide && this.slide.holderElement) this.slide.holderElement.setAttribute("aria-hidden", "true");
    }
    /**
   * Remove the content from DOM
   */ remove() {
        this.isAttached = false;
        if (this.instance.dispatch("contentRemove", {
            content: this
        }).defaultPrevented) return;
        if (this.element && this.element.parentNode) this.element.remove();
        if (this.placeholder && this.placeholder.element) this.placeholder.element.remove();
    }
    /**
   * Append the image content to slide container
   */ appendImage() {
        if (!this.isAttached) return;
        if (this.instance.dispatch("contentAppendImage", {
            content: this
        }).defaultPrevented) return;
        // ensure that element exists and is not already appended
        if (this.slide && this.element && !this.element.parentNode) this.slide.container.appendChild(this.element);
        if (this.state === $12ba7f17b3976b6d$var$LOAD_STATE.LOADED || this.state === $12ba7f17b3976b6d$var$LOAD_STATE.ERROR) this.removePlaceholder();
    }
}
/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /**
 * @param {PhotoSwipeOptions} options
 * @param {PhotoSwipeBase} pswp
 * @returns {Point}
 */ function $12ba7f17b3976b6d$var$getViewportSize(options, pswp) {
    if (options.getViewportSizeFn) {
        const newViewportSize = options.getViewportSizeFn(options, pswp);
        if (newViewportSize) return newViewportSize;
    }
    return {
        x: document.documentElement.clientWidth,
        // TODO: height on mobile is very incosistent due to toolbar
        // find a way to improve this
        //
        // document.documentElement.clientHeight - doesn't seem to work well
        y: window.innerHeight
    };
}
/**
 * Parses padding option.
 * Supported formats:
 *
 * // Object
 * padding: {
 *  top: 0,
 *  bottom: 0,
 *  left: 0,
 *  right: 0
 * }
 *
 * // A function that returns the object
 * paddingFn: (viewportSize, itemData, index) => {
 *  return {
 *    top: 0,
 *    bottom: 0,
 *    left: 0,
 *    right: 0
 *  };
 * }
 *
 * // Legacy variant
 * paddingLeft: 0,
 * paddingRight: 0,
 * paddingTop: 0,
 * paddingBottom: 0,
 *
 * @param {'left' | 'top' | 'bottom' | 'right'} prop
 * @param {PhotoSwipeOptions} options PhotoSwipe options
 * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
 * @param {SlideData} itemData Data about the slide
 * @param {number} index Slide index
 * @returns {number}
 */ function $12ba7f17b3976b6d$var$parsePaddingOption(prop, options, viewportSize, itemData, index) {
    let paddingValue = 0;
    if (options.paddingFn) paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
    else if (options.padding) paddingValue = options.padding[prop];
    else {
        const legacyPropName = "padding" + prop[0].toUpperCase() + prop.slice(1);
        // @ts-expect-error
        if (options[legacyPropName]) // @ts-expect-error
        paddingValue = options[legacyPropName];
    }
    return Number(paddingValue) || 0;
}
/**
 * @param {PhotoSwipeOptions} options
 * @param {Point} viewportSize
 * @param {SlideData} itemData
 * @param {number} index
 * @returns {Point}
 */ function $12ba7f17b3976b6d$var$getPanAreaSize(options, viewportSize, itemData, index) {
    return {
        x: viewportSize.x - $12ba7f17b3976b6d$var$parsePaddingOption("left", options, viewportSize, itemData, index) - $12ba7f17b3976b6d$var$parsePaddingOption("right", options, viewportSize, itemData, index),
        y: viewportSize.y - $12ba7f17b3976b6d$var$parsePaddingOption("top", options, viewportSize, itemData, index) - $12ba7f17b3976b6d$var$parsePaddingOption("bottom", options, viewportSize, itemData, index)
    };
}
const $12ba7f17b3976b6d$var$MAX_IMAGE_WIDTH = 4000;
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption */ /**
 * Calculates zoom levels for specific slide.
 * Depends on viewport size and image size.
 */ class $12ba7f17b3976b6d$var$ZoomLevel {
    /**
   * @param {PhotoSwipeOptions} options PhotoSwipe options
   * @param {SlideData} itemData Slide data
   * @param {number} index Slide index
   * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
   */ constructor(options, itemData, index, pswp){
        this.pswp = pswp;
        this.options = options;
        this.itemData = itemData;
        this.index = index;
        /** @type { Point | null } */ this.panAreaSize = null;
        /** @type { Point | null } */ this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
    }
    /**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */ update(maxWidth, maxHeight, panAreaSize) {
        /** @type {Point} */ const elementSize = {
            x: maxWidth,
            y: maxHeight
        };
        this.elementSize = elementSize;
        this.panAreaSize = panAreaSize;
        const hRatio = panAreaSize.x / elementSize.x;
        const vRatio = panAreaSize.y / elementSize.y;
        this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
        this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio);
        // zoom.vFill defines zoom level of the image
        // when it has 100% of viewport vertical space (height)
        this.vFill = Math.min(1, vRatio);
        this.initial = this._getInitial();
        this.secondary = this._getSecondary();
        this.max = Math.max(this.initial, this.secondary, this._getMax());
        this.min = Math.min(this.fit, this.initial, this.secondary);
        if (this.pswp) this.pswp.dispatch("zoomLevelsUpdate", {
            zoomLevels: this,
            slideData: this.itemData
        });
    }
    /**
   * Parses user-defined zoom option.
   *
   * @private
   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
   * @returns { number | undefined }
   */ _parseZoomLevelOption(optionPrefix) {
        const optionName = /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */ optionPrefix + "ZoomLevel";
        const optionValue = this.options[optionName];
        if (!optionValue) return;
        if (typeof optionValue === "function") return optionValue(this);
        if (optionValue === "fill") return this.fill;
        if (optionValue === "fit") return this.fit;
        return Number(optionValue);
    }
    /**
   * Get zoom level to which image will be zoomed after double-tap gesture,
   * or when user clicks on zoom icon,
   * or mouse-click on image itself.
   * If you return 1 image will be zoomed to its original size.
   *
   * @private
   * @return {number}
   */ _getSecondary() {
        let currZoomLevel = this._parseZoomLevelOption("secondary");
        if (currZoomLevel) return currZoomLevel;
        // 3x of "fit" state, but not larger than original
        currZoomLevel = Math.min(1, this.fit * 3);
        if (this.elementSize && currZoomLevel * this.elementSize.x > $12ba7f17b3976b6d$var$MAX_IMAGE_WIDTH) currZoomLevel = $12ba7f17b3976b6d$var$MAX_IMAGE_WIDTH / this.elementSize.x;
        return currZoomLevel;
    }
    /**
   * Get initial image zoom level.
   *
   * @private
   * @return {number}
   */ _getInitial() {
        return this._parseZoomLevelOption("initial") || this.fit;
    }
    /**
   * Maximum zoom level when user zooms
   * via zoom/pinch gesture,
   * via cmd/ctrl-wheel or via trackpad.
   *
   * @private
   * @return {number}
   */ _getMax() {
        // max zoom level is x4 from "fit state",
        // used for zoom gesture and ctrl/trackpad zoom
        return this._parseZoomLevelOption("max") || Math.max(1, this.fit * 4);
    }
}
/**
 * Lazy-load an image
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * @param {SlideData} itemData Data about the slide
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
 * @param {number} index
 * @returns {Content} Image that is being decoded or false.
 */ function $12ba7f17b3976b6d$var$lazyLoadData(itemData, instance, index) {
    const content = instance.createContentFromData(itemData, index);
    /** @type {ZoomLevel | undefined} */ let zoomLevel;
    const { options: options } = instance;
    // We need to know dimensions of the image to preload it,
    // as it might use srcset, and we need to define sizes
    if (options) {
        zoomLevel = new $12ba7f17b3976b6d$var$ZoomLevel(options, itemData, -1);
        let viewportSize;
        if (instance.pswp) viewportSize = instance.pswp.viewportSize;
        else viewportSize = $12ba7f17b3976b6d$var$getViewportSize(options, instance);
        const panAreaSize = $12ba7f17b3976b6d$var$getPanAreaSize(options, viewportSize, itemData, index);
        zoomLevel.update(content.width, content.height, panAreaSize);
    }
    content.lazyLoad();
    if (zoomLevel) content.setDisplayedSize(Math.ceil(content.width * zoomLevel.initial), Math.ceil(content.height * zoomLevel.initial));
    return content;
}
/**
 * Lazy-loads specific slide.
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * By default, it loads image based on viewport size and initial zoom level.
 *
 * @param {number} index Slide index
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
 * @returns {Content | undefined}
 */ function $12ba7f17b3976b6d$var$lazyLoadSlide(index, instance) {
    const itemData = instance.getItemData(index);
    if (instance.dispatch("lazyLoadSlide", {
        index: index,
        itemData: itemData
    }).defaultPrevented) return;
    return $12ba7f17b3976b6d$var$lazyLoadData(itemData, instance, index);
}
/** @typedef {import("../photoswipe.js").default} PhotoSwipe */ /** @typedef {import("../slide/slide.js").SlideData} SlideData */ /**
 * PhotoSwipe base class that can retrieve data about every slide.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
 */ class $12ba7f17b3976b6d$var$PhotoSwipeBase extends $12ba7f17b3976b6d$var$Eventable {
    /**
   * Get total number of slides
   *
   * @returns {number}
   */ getNumItems() {
        let numItems = 0;
        const dataSource = this.options?.dataSource;
        if (dataSource && "length" in dataSource) // may be an array or just object with length property
        numItems = dataSource.length;
        else if (dataSource && "gallery" in dataSource) {
            // query DOM elements
            if (!dataSource.items) dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
            if (dataSource.items) numItems = dataSource.items.length;
        }
        // legacy event, before filters were introduced
        const event = this.dispatch("numItems", {
            dataSource: dataSource,
            numItems: numItems
        });
        return this.applyFilters("numItems", event.numItems, dataSource);
    }
    /**
   * @param {SlideData} slideData
   * @param {number} index
   * @returns {Content}
   */ createContentFromData(slideData, index) {
        return new $12ba7f17b3976b6d$var$Content(slideData, this, index);
    }
    /**
   * Get item data by index.
   *
   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
   * For example, it may contain properties like
   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
   *
   * @param {number} index
   * @returns {SlideData}
   */ getItemData(index) {
        const dataSource = this.options?.dataSource;
        /** @type {SlideData | HTMLElement} */ let dataSourceItem = {};
        if (Array.isArray(dataSource)) // Datasource is an array of elements
        dataSourceItem = dataSource[index];
        else if (dataSource && "gallery" in dataSource) {
            // dataSource has gallery property,
            // thus it was created by Lightbox, based on
            // gallery and children options
            // query DOM elements
            if (!dataSource.items) dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
            dataSourceItem = dataSource.items[index];
        }
        let itemData = dataSourceItem;
        if (itemData instanceof Element) itemData = this._domElementToItemData(itemData);
        // Dispatching the itemData event,
        // it's a legacy verion before filters were introduced
        const event = this.dispatch("itemData", {
            itemData: itemData || {},
            index: index
        });
        return this.applyFilters("itemData", event.itemData, index);
    }
    /**
   * Get array of gallery DOM elements,
   * based on childSelector and gallery element.
   *
   * @param {HTMLElement} galleryElement
   * @returns {HTMLElement[]}
   */ _getGalleryDOMElements(galleryElement) {
        if (this.options?.children || this.options?.childSelector) return $12ba7f17b3976b6d$var$getElementsFromOption(this.options.children, this.options.childSelector, galleryElement) || [];
        return [
            galleryElement
        ];
    }
    /**
   * Converts DOM element to item data object.
   *
   * @param {HTMLElement} element DOM element
   * @returns {SlideData}
   */ _domElementToItemData(element) {
        /** @type {SlideData} */ const itemData = {
            element: element
        };
        const linkEl = /** @type {HTMLAnchorElement} */ element.tagName === "A" ? element : element.querySelector("a");
        if (linkEl) {
            // src comes from data-pswp-src attribute,
            // if it's empty link href is used
            itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
            if (linkEl.dataset.pswpSrcset) itemData.srcset = linkEl.dataset.pswpSrcset;
            itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
            itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0;
            // support legacy w & h properties
            itemData.w = itemData.width;
            itemData.h = itemData.height;
            if (linkEl.dataset.pswpType) itemData.type = linkEl.dataset.pswpType;
            const thumbnailEl = element.querySelector("img");
            if (thumbnailEl) {
                // msrc is URL to placeholder image that's displayed before large image is loaded
                // by default it's displayed only for the first slide
                itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
                itemData.alt = thumbnailEl.getAttribute("alt") ?? "";
            }
            if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) itemData.thumbCropped = true;
        }
        return this.applyFilters("domItemData", itemData, element, linkEl);
    }
    /**
   * Lazy-load by slide data
   *
   * @param {SlideData} itemData Data about the slide
   * @param {number} index
   * @returns {Content} Image that is being decoded or false.
   */ lazyLoadData(itemData, index) {
        return $12ba7f17b3976b6d$var$lazyLoadData(itemData, this, index);
    }
}
/**
 * @template T
 * @typedef {import('../types.js').Type<T>} Type<T>
 */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').DataSource} DataSource */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/content.js').default} Content */ /** @typedef {import('../core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap */ /** @typedef {import('../core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('../core/eventable.js').EventCallback<T>} EventCallback<T>
 */ /**
 * PhotoSwipe Lightbox
 *
 * - If user has unsupported browser it falls back to default browser action (just opens URL)
 * - Binds click event to links that should open PhotoSwipe
 * - parses DOM strcture for PhotoSwipe (retrieves large image URLs and sizes)
 * - Initializes PhotoSwipe
 *
 *
 * Loader options use the same object as PhotoSwipe, and supports such options:
 *
 * gallery - Element | Element[] | NodeList | string selector for the gallery element
 * children - Element | Element[] | NodeList | string selector for the gallery children
 *
 */ class $12ba7f17b3976b6d$export$2e2bcd8739ae039 extends $12ba7f17b3976b6d$var$PhotoSwipeBase {
    /**
   * @param {PhotoSwipeOptions} [options]
   */ constructor(options){
        super();
        /** @type {PhotoSwipeOptions} */ this.options = options || {};
        this._uid = 0;
        this.shouldOpen = false;
        /**
     * @private
     * @type {Content | undefined}
     */ this._preloadedContent = undefined;
        this.onThumbnailsClick = this.onThumbnailsClick.bind(this);
    }
    /**
   * Initialize lightbox, should be called only once.
   * It's not included in the main constructor, so you may bind events before it.
   */ init() {
        // Bind click events to each gallery
        $12ba7f17b3976b6d$var$getElementsFromOption(this.options.gallery, this.options.gallerySelector).forEach((galleryElement)=>{
            galleryElement.addEventListener("click", this.onThumbnailsClick, false);
        });
    }
    /**
   * @param {MouseEvent} e
   */ onThumbnailsClick(e) {
        // Exit and allow default browser action if:
        if ($12ba7f17b3976b6d$var$specialKeyUsed(e) // ... if clicked with a special key (ctrl/cmd...)
         || window.pswp) return;
        // If both clientX and clientY are 0 or not defined,
        // the event is likely triggered by keyboard,
        // so we do not pass the initialPoint
        //
        // Note that some screen readers emulate the mouse position,
        // so it's not the ideal way to detect them.
        //
        /** @type {Point | null} */ let initialPoint = {
            x: e.clientX,
            y: e.clientY
        };
        if (!initialPoint.x && !initialPoint.y) initialPoint = null;
        let clickedIndex = this.getClickedIndex(e);
        clickedIndex = this.applyFilters("clickedIndex", clickedIndex, e, this);
        /** @type {DataSource} */ const dataSource = {
            gallery: /** @type {HTMLElement} */ e.currentTarget
        };
        if (clickedIndex >= 0) {
            e.preventDefault();
            this.loadAndOpen(clickedIndex, dataSource, initialPoint);
        }
    }
    /**
   * Get index of gallery item that was clicked.
   *
   * @param {MouseEvent} e click event
   * @returns {number}
   */ getClickedIndex(e) {
        // legacy option
        if (this.options.getClickedIndexFn) return this.options.getClickedIndexFn.call(this, e);
        const clickedTarget = /** @type {HTMLElement} */ e.target;
        const childElements = $12ba7f17b3976b6d$var$getElementsFromOption(this.options.children, this.options.childSelector, /** @type {HTMLElement} */ e.currentTarget);
        const clickedChildIndex = childElements.findIndex((child)=>child === clickedTarget || child.contains(clickedTarget));
        if (clickedChildIndex !== -1) return clickedChildIndex;
        else if (this.options.children || this.options.childSelector) // click wasn't on a child element
        return -1;
        // There is only one item (which is the gallery)
        return 0;
    }
    /**
   * Load and open PhotoSwipe
   *
   * @param {number} index
   * @param {DataSource} dataSource
   * @param {Point | null} [initialPoint]
   * @returns {boolean}
   */ loadAndOpen(index, dataSource, initialPoint) {
        // Check if the gallery is already open
        if (window.pswp) return false;
        // set initial index
        this.options.index = index;
        // define options for PhotoSwipe constructor
        this.options.initialPointerPos = initialPoint;
        this.shouldOpen = true;
        this.preload(index, dataSource);
        return true;
    }
    /**
   * Load the main module and the slide content by index
   *
   * @param {number} index
   * @param {DataSource} [dataSource]
   */ preload(index, dataSource) {
        const { options: options } = this;
        if (dataSource) options.dataSource = dataSource;
        // Add the main module
        /** @type {Promise<Type<PhotoSwipe>>[]} */ const promiseArray = [];
        const pswpModuleType = typeof options.pswpModule;
        if ($12ba7f17b3976b6d$var$isPswpClass(options.pswpModule)) promiseArray.push(Promise.resolve(/** @type {Type<PhotoSwipe>} */ options.pswpModule));
        else if (pswpModuleType === "string") throw new Error("pswpModule as string is no longer supported");
        else if (pswpModuleType === "function") promiseArray.push(/** @type {() => Promise<Type<PhotoSwipe>>} */ options.pswpModule());
        else throw new Error("pswpModule is not valid");
        // Add custom-defined promise, if any
        if (typeof options.openPromise === "function") // allow developers to perform some task before opening
        promiseArray.push(options.openPromise());
        if (options.preloadFirstSlide !== false && index >= 0) this._preloadedContent = $12ba7f17b3976b6d$var$lazyLoadSlide(index, this);
        // Wait till all promises resolve and open PhotoSwipe
        const uid = ++this._uid;
        Promise.all(promiseArray).then((iterableModules)=>{
            if (this.shouldOpen) {
                const mainModule = iterableModules[0];
                this._openPhotoswipe(mainModule, uid);
            }
        });
    }
    /**
   * @private
   * @param {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} module
   * @param {number} uid
   */ _openPhotoswipe(module, uid) {
        // Cancel opening if UID doesn't match the current one
        // (if user clicked on another gallery item before current was loaded).
        //
        // Or if shouldOpen flag is set to false
        // (developer may modify it via public API)
        if (uid !== this._uid && this.shouldOpen) return;
        this.shouldOpen = false;
        // PhotoSwipe is already open
        if (window.pswp) return;
        /**
     * Pass data to PhotoSwipe and open init
     *
     * @type {PhotoSwipe}
     */ const pswp = typeof module === "object" ? new module.default(this.options) // eslint-disable-line
         : new module(this.options); // eslint-disable-line
        this.pswp = pswp;
        window.pswp = pswp;
        // map listeners from Lightbox to PhotoSwipe Core
        /** @type {(keyof PhotoSwipeEventsMap)[]} */ Object.keys(this._listeners).forEach((name)=>{
            this._listeners[name]?.forEach((fn)=>{
                pswp.on(name, /** @type {EventCallback<typeof name>} */ fn);
            });
        });
        // same with filters
        /** @type {(keyof PhotoSwipeFiltersMap)[]} */ Object.keys(this._filters).forEach((name)=>{
            this._filters[name]?.forEach((filter)=>{
                pswp.addFilter(name, filter.fn, filter.priority);
            });
        });
        if (this._preloadedContent) {
            pswp.contentLoader.addToCache(this._preloadedContent);
            this._preloadedContent = undefined;
        }
        pswp.on("destroy", ()=>{
            // clean up public variables
            this.pswp = undefined;
            delete window.pswp;
        });
        pswp.init();
    }
    /**
   * Unbinds all events, closes PhotoSwipe if it's open.
   */ destroy() {
        this.pswp?.destroy();
        this.shouldOpen = false;
        this._listeners = {};
        $12ba7f17b3976b6d$var$getElementsFromOption(this.options.gallery, this.options.gallerySelector).forEach((galleryElement)=>{
            galleryElement.removeEventListener("click", this.onThumbnailsClick, false);
        });
    }
}


var $158359920d0ab338$exports = {};

$158359920d0ab338$exports = new URL((parcelRequire("27Lyk")).resolve("a0kZn"), import.meta.url).toString();


const $459f452165207905$export$9e8f3cc9e6ea9b76 = new URL($158359920d0ab338$exports);
var $533b1690cd724063$exports = {};

$533b1690cd724063$exports = new URL((parcelRequire("27Lyk")).resolve("3B6Di"), import.meta.url).toString();


const $459f452165207905$export$ebb5d0b228a41799 = new URL($533b1690cd724063$exports);
var $b945f7635146d536$exports = {};

$b945f7635146d536$exports = new URL((parcelRequire("27Lyk")).resolve("SLjkG"), import.meta.url).toString();


const $459f452165207905$export$889fc7266477eb11 = new URL($b945f7635146d536$exports);
var $aa7686de30368005$exports = {};

$aa7686de30368005$exports = new URL((parcelRequire("27Lyk")).resolve("629WQ"), import.meta.url).toString();


const $459f452165207905$export$9f247931755963c6 = new URL($aa7686de30368005$exports);
function $459f452165207905$export$9cef1ad34c46a54e(props) {
    const { href: href, children: children, className: className, ...rest } = props;
    if (href) rest.onClick = ()=>{
        window?.open(href, "_blank");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("glass-btn", className),
        ...rest,
        children: children
    });
}
function $459f452165207905$export$113a612889e1565d(props) {
    const { className: className, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("app-logo", className),
        ...rest,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: $459f452165207905$export$ebb5d0b228a41799,
            alt: "Logseq"
        })
    });
}
function $459f452165207905$export$f7e22c3fd4ab6d59(props) {
    const { className: className, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("app-logo-embossed", className),
        ...rest,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            width: "49",
            height: "46",
            viewBox: "0 0 49 46",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                    rx: "7.02369",
                    ry: "4.42793",
                    transform: "matrix(0.988865 -0.148815 0.0688008 0.99763 27.0473 6.96687)",
                    fill: "#85C8C8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                    rx: "6.30029",
                    ry: "7.20225",
                    transform: "matrix(-0.495846 0.86841 -0.825718 -0.564084 9.07103 10.4006)",
                    fill: "#85C8C8"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                    rx: "16.609",
                    ry: "13.0775",
                    transform: "matrix(0.987073 0.160274 -0.239143 0.970984 28.5105 29.9736)",
                    fill: "#85C8C8"
                })
            ]
        })
    });
}

function $459f452165207905$export$78f5d28b604adfe0(sources, index = 0) {
    const lightbox = new (0, $12ba7f17b3976b6d$export$2e2bcd8739ae039)({
        dataSource: sources,
        wheelToZoom: true,
        pswpModule: ()=>(parcelRequire("Y7YWM"))
    });
    lightbox.init();
    lightbox.loadAndOpen(index);
}



var $acw62 = parcelRequire("acw62");


var $d9f1c3559b497798$var$A = Object.defineProperty, $d9f1c3559b497798$var$Z = Object.defineProperties;
var $d9f1c3559b497798$var$o = Object.getOwnPropertyDescriptors;
var $d9f1c3559b497798$var$m = Object.getOwnPropertySymbols;
var $d9f1c3559b497798$var$p = Object.prototype.hasOwnProperty, $d9f1c3559b497798$var$E = Object.prototype.propertyIsEnumerable;
var $d9f1c3559b497798$var$r = (t, a, l)=>a in t ? $d9f1c3559b497798$var$A(t, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[a] = l, $d9f1c3559b497798$var$n = (t, a)=>{
    for(var l in a || (a = {}))$d9f1c3559b497798$var$p.call(a, l) && $d9f1c3559b497798$var$r(t, l, a[l]);
    if ($d9f1c3559b497798$var$m) for (var l of $d9f1c3559b497798$var$m(a))$d9f1c3559b497798$var$E.call(a, l) && $d9f1c3559b497798$var$r(t, l, a[l]);
    return t;
}, $d9f1c3559b497798$var$c = (t, a)=>$d9f1c3559b497798$var$Z(t, $d9f1c3559b497798$var$o(a));
const $d9f1c3559b497798$var$i = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm52-84a12,12,0,0,1-12,12H117l11.52,11.51a12,12,0,0,1-17,17l-32-32a12,12,0,0,1,0-17l32-32a12,12,0,0,1,17,17L117,116h51A12,12,0,0,1,180,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H107.31l18.35,18.34a8,8,0,0,1-11.32,11.32l-32-32a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,11.32L107.31,120H168A8,8,0,0,1,176,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm40,112H107.31l18.35,18.34a8,8,0,0,1-11.32,11.32l-32-32a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,11.32L107.31,120H168a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm46-90a6,6,0,0,1-6,6H102.49l21.75,21.76a6,6,0,1,1-8.48,8.48l-32-32a6,6,0,0,1,0-8.48l32-32a6,6,0,0,1,8.48,8.48L102.49,122H168A6,6,0,0,1,174,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H107.31l18.35,18.34a8,8,0,0,1-11.32,11.32l-32-32a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,11.32L107.31,120H168A8,8,0,0,1,176,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm44-92a4,4,0,0,1-4,4H97.66l25.17,25.17a4,4,0,0,1-5.66,5.66l-32-32a4,4,0,0,1,0-5.66l32-32a4,4,0,0,1,5.66,5.66L97.66,124H168A4,4,0,0,1,172,128Z"
        }))
    ]
]), $d9f1c3559b497798$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $d9f1c3559b497798$var$c($d9f1c3559b497798$var$n({
        ref: a
    }, t), {
        weights: $d9f1c3559b497798$var$i
    })));
$d9f1c3559b497798$export$2e2bcd8739ae039.displayName = "ArrowCircleLeft";


var $acw62 = parcelRequire("acw62");


var $ffb21843868106ef$var$h = Object.defineProperty, $ffb21843868106ef$var$Z = Object.defineProperties;
var $ffb21843868106ef$var$o = Object.getOwnPropertyDescriptors;
var $ffb21843868106ef$var$m = Object.getOwnPropertySymbols;
var $ffb21843868106ef$var$A = Object.prototype.hasOwnProperty, $ffb21843868106ef$var$p = Object.prototype.propertyIsEnumerable;
var $ffb21843868106ef$var$r = (t, a, l)=>a in t ? $ffb21843868106ef$var$h(t, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[a] = l, $ffb21843868106ef$var$n = (t, a)=>{
    for(var l in a || (a = {}))$ffb21843868106ef$var$A.call(a, l) && $ffb21843868106ef$var$r(t, l, a[l]);
    if ($ffb21843868106ef$var$m) for (var l of $ffb21843868106ef$var$m(a))$ffb21843868106ef$var$p.call(a, l) && $ffb21843868106ef$var$r(t, l, a[l]);
    return t;
}, $ffb21843868106ef$var$c = (t, a)=>$ffb21843868106ef$var$Z(t, $ffb21843868106ef$var$o(a));
const $ffb21843868106ef$var$d = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm48.49-92.49a12,12,0,0,1,0,17l-32,32a12,12,0,1,1-17-17L139,140H88a12,12,0,0,1,0-24h51l-11.52-11.51a12,12,0,1,1,17-17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm45.66-93.66a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32-11.32L148.69,136H88a8,8,0,0,1,0-16h60.69l-18.35-18.34a8,8,0,0,1,11.32-11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,109.66-32,32a8,8,0,0,1-11.32-11.32L148.69,136H88a8,8,0,0,1,0-16h60.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,173.66,133.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm44.24-94.24a6,6,0,0,1,0,8.48l-32,32a6,6,0,0,1-8.48-8.48L153.51,134H88a6,6,0,0,1,0-12h65.51l-21.75-21.76a6,6,0,0,1,8.48-8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm45.66-93.66a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32-11.32L148.69,136H88a8,8,0,0,1,0-16h60.69l-18.35-18.34a8,8,0,0,1,11.32-11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm42.83-94.83a4,4,0,0,1,0,5.66l-32,32a4,4,0,0,1-5.66-5.66L158.34,132H88a4,4,0,0,1,0-8h70.34L133.17,98.83a4,4,0,0,1,5.66-5.66Z"
        }))
    ]
]), $ffb21843868106ef$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $ffb21843868106ef$var$c($ffb21843868106ef$var$n({
        ref: a
    }, t), {
        weights: $ffb21843868106ef$var$d
    })));
$ffb21843868106ef$export$2e2bcd8739ae039.displayName = "ArrowCircleRight";


var $acw62 = parcelRequire("acw62");


var $da620479e4407639$var$c = Object.defineProperty, $da620479e4407639$var$Z = Object.defineProperties;
var $da620479e4407639$var$h = Object.getOwnPropertyDescriptors;
var $da620479e4407639$var$m = Object.getOwnPropertySymbols;
var $da620479e4407639$var$o = Object.prototype.hasOwnProperty, $da620479e4407639$var$p = Object.prototype.propertyIsEnumerable;
var $da620479e4407639$var$n = (l, e, t)=>e in l ? $da620479e4407639$var$c(l, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : l[e] = t, $da620479e4407639$var$r = (l, e)=>{
    for(var t in e || (e = {}))$da620479e4407639$var$o.call(e, t) && $da620479e4407639$var$n(l, t, e[t]);
    if ($da620479e4407639$var$m) for (var t of $da620479e4407639$var$m(e))$da620479e4407639$var$p.call(e, t) && $da620479e4407639$var$n(l, t, e[t]);
    return l;
}, $da620479e4407639$var$A = (l, e)=>$da620479e4407639$var$Z(l, $da620479e4407639$var$h(e));
const $da620479e4407639$var$d = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M236.06,187.69A84,84,0,0,0,172.29,68.9,84,84,0,1,0,19.94,139.69L12.7,165.05A18,18,0,0,0,35,187.3l25.36-7.24a84.27,84.27,0,0,0,23.36,7,84.05,84.05,0,0,0,112,41l25.36,7.24a18,18,0,0,0,22.25-22.25ZM28.36,164.22Zm33.17-9a12,12,0,0,0-3.3.46l-19.49,5.57,5.57-19.49a12,12,0,0,0-1-9.05,60,60,0,1,1,24,24A11.91,11.91,0,0,0,61.53,155.23Zm150.16,34.54,5.57,19.49-19.49-5.57a12,12,0,0,0-9.05,1A60.06,60.06,0,0,1,111,186.63a83.93,83.93,0,0,0,68.55-91.37,60,60,0,0,1,33.16,85.46A12,12,0,0,0,211.69,189.77Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M231.76,216.34a6,6,0,0,1-7.42,7.42l-29.87-8.53A72.05,72.05,0,0,1,92.06,175.89h0c1.3.07,2.61.11,3.93.11a72,72,0,0,0,67.93-95.88h0a72,72,0,0,1,59.29,106.36Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M231.79,187.33A80,80,0,0,0,169.57,72.59,80,80,0,1,0,24.21,139.33l-7.66,26.82a14,14,0,0,0,17.3,17.3l26.82-7.66a80.15,80.15,0,0,0,25.75,7.63,80,80,0,0,0,108.91,40.37l26.82,7.66a14,14,0,0,0,17.3-17.3ZM61.53,159.23a8.22,8.22,0,0,0-2.2.3l-26.41,7.55,7.55-26.41a8,8,0,0,0-.68-6,63.95,63.95,0,1,1,25.57,25.57A7.94,7.94,0,0,0,61.53,159.23Zm154,29.44,7.55,26.41-26.41-7.55a8,8,0,0,0-6,.68,64.06,64.06,0,0,1-86.32-24.64A79.93,79.93,0,0,0,174.7,89.71a64,64,0,0,1,41.51,92.93A8,8,0,0,0,215.53,188.67Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M231.79,187.33A80,80,0,0,0,169.57,72.59,80,80,0,1,0,24.21,139.33l-7.66,26.82a14,14,0,0,0,17.3,17.3l26.82-7.66a80.15,80.15,0,0,0,25.75,7.63,80,80,0,0,0,108.91,40.37l26.82,7.66a14,14,0,0,0,17.3-17.3Zm-16.26,1.34,7.55,26.41-26.41-7.55a8,8,0,0,0-6,.68,64.06,64.06,0,0,1-86.32-24.64A79.93,79.93,0,0,0,174.7,89.71a64,64,0,0,1,41.51,92.93A8,8,0,0,0,215.53,188.67Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M229.66,187.13a78,78,0,0,0-61.5-112.71A78,78,0,1,0,26.34,139.13L18.47,166.7A12,12,0,0,0,33.3,181.53l27.57-7.87a78.25,78.25,0,0,0,26.94,7.9,78.05,78.05,0,0,0,107.32,40.1l27.57,7.87a12,12,0,0,0,14.83-14.83ZM61.53,161.23a5.82,5.82,0,0,0-1.65.23L30,170l8.53-29.87a6,6,0,0,0-.5-4.53A66,66,0,1,1,64.41,162,6.1,6.1,0,0,0,61.53,161.23Zm155.93,26.89L226,218l-29.87-8.53a6,6,0,0,0-4.53.5,66,66,0,0,1-90.48-28.15,77.92,77.92,0,0,0,71-94.68A66,66,0,0,1,218,183.59,6,6,0,0,0,217.46,188.12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M231.79,187.33A80,80,0,0,0,169.57,72.59,80,80,0,1,0,24.21,139.33l-7.66,26.82a14,14,0,0,0,17.3,17.3l26.82-7.66a80.15,80.15,0,0,0,25.75,7.63,80,80,0,0,0,108.91,40.37l26.82,7.66a14,14,0,0,0,17.3-17.3ZM61.53,159.23a8.22,8.22,0,0,0-2.2.3l-26.41,7.55,7.55-26.41a8,8,0,0,0-.68-6,63.95,63.95,0,1,1,25.57,25.57A7.94,7.94,0,0,0,61.53,159.23Zm154,29.44,7.55,26.41-26.41-7.55a8,8,0,0,0-6,.68,64.06,64.06,0,0,1-86.32-24.64A79.93,79.93,0,0,0,174.7,89.71a64,64,0,0,1,41.51,92.93A8,8,0,0,0,215.53,188.67Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M235.6,215.24l-8.09-28.32A76,76,0,0,0,166.76,76.31,76,76,0,1,0,28.49,138.92L20.4,167.24A10,10,0,0,0,30,180a10.08,10.08,0,0,0,2.8-.4l28.32-8.09a76,76,0,0,0,28.13,8.18,76,76,0,0,0,105.71,39.82l28.32,8.09a10.08,10.08,0,0,0,2.8.4,10,10,0,0,0,9.56-12.76Zm-174.07-52a3.75,3.75,0,0,0-1.1.16l-29.87,8.53h0a2,2,0,0,1-2.47-2.47l8.53-29.87a4,4,0,0,0-.33-3,68,68,0,1,1,27.16,27.16A4,4,0,0,0,61.53,163.22ZM227.4,219.4a2,2,0,0,1-2,.51l-29.87-8.53a4,4,0,0,0-3,.33A68,68,0,0,1,98,180a76,76,0,0,0,71.5-95.28,68,68,0,0,1,50.21,99.88,4,4,0,0,0-.33,3l8.53,29.87A2,2,0,0,1,227.4,219.4Z"
        }))
    ]
]), $da620479e4407639$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((l, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $da620479e4407639$var$A($da620479e4407639$var$r({
        ref: e
    }, l), {
        weights: $da620479e4407639$var$d
    })));
$da620479e4407639$export$2e2bcd8739ae039.displayName = "ChatsCircle";


var $acw62 = parcelRequire("acw62");


var $aa33c7059515b2b5$var$n = Object.defineProperty, $aa33c7059515b2b5$var$r = Object.defineProperties;
var $aa33c7059515b2b5$var$Z = Object.getOwnPropertyDescriptors;
var $aa33c7059515b2b5$var$A = Object.getOwnPropertySymbols;
var $aa33c7059515b2b5$var$o = Object.prototype.hasOwnProperty, $aa33c7059515b2b5$var$s = Object.prototype.propertyIsEnumerable;
var $aa33c7059515b2b5$var$L = (e, l, t)=>l in e ? $aa33c7059515b2b5$var$n(e, l, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[l] = t, $aa33c7059515b2b5$var$m = (e, l)=>{
    for(var t in l || (l = {}))$aa33c7059515b2b5$var$o.call(l, t) && $aa33c7059515b2b5$var$L(e, t, l[t]);
    if ($aa33c7059515b2b5$var$A) for (var t of $aa33c7059515b2b5$var$A(l))$aa33c7059515b2b5$var$s.call(l, t) && $aa33c7059515b2b5$var$L(e, t, l[t]);
    return e;
}, $aa33c7059515b2b5$var$c = (e, l)=>$aa33c7059515b2b5$var$r(e, $aa33c7059515b2b5$var$Z(l));
const $aa33c7059515b2b5$var$E = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M108,136a16,16,0,1,1-16-16A16,16,0,0,1,108,136Zm56-16a16,16,0,1,0,16,16A16,16,0,0,0,164,120Zm76.07,76.56-67,29.71A20.15,20.15,0,0,1,146,214.9l-8.54-23.13c-3.13.14-6.27.24-9.45.24s-6.32-.1-9.45-.24L110,214.9a20.19,20.19,0,0,1-27.08,11.37l-67-29.71A19.93,19.93,0,0,1,4.62,173.41L34.15,57A20,20,0,0,1,50.37,42.19l36.06-5.93A20.26,20.26,0,0,1,109.22,51.1l4.41,17.41c4.74-.33,9.52-.51,14.37-.51s9.63.18,14.37.51l4.41-17.41a20.25,20.25,0,0,1,22.79-14.84l36.06,5.93A20,20,0,0,1,221.85,57l29.53,116.38A19.93,19.93,0,0,1,240.07,196.56ZM227.28,176,199.23,65.46l-30.07-4.94-2.84,11.17c2.9.58,5.78,1.2,8.61,1.92a12,12,0,1,1-5.86,23.27A168.43,168.43,0,0,0,128,92a168.43,168.43,0,0,0-41.07,4.88,12,12,0,0,1-5.86-23.27c2.83-.72,5.71-1.34,8.61-1.92L86.85,60.52,56.77,65.46,28.72,176l60.22,26.7,5-13.57c-4.37-.76-8.67-1.65-12.88-2.71a12,12,0,0,1,5.86-23.28A168.43,168.43,0,0,0,128,168a168.43,168.43,0,0,0,41.07-4.88,12,12,0,0,1,5.86,23.28c-4.21,1.06-8.51,1.95-12.88,2.71l5,13.57Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M235.21,185.59l-67,29.7a8.15,8.15,0,0,1-11-4.56L147,183.06a190.5,190.5,0,0,1-19,.94,190.5,190.5,0,0,1-19-.94L98.75,210.73a8.15,8.15,0,0,1-11,4.56l-67-29.7a8,8,0,0,1-4.55-9.24L45.77,60A8.08,8.08,0,0,1,52.31,54l36.06-5.92a8.1,8.1,0,0,1,9.21,6l5,19.63a192.32,192.32,0,0,1,50.88,0l5-19.63a8.1,8.1,0,0,1,9.21-6L203.69,54A8.08,8.08,0,0,1,210.23,60l29.53,116.37A8,8,0,0,1,235.21,185.59Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M104,140a12,12,0,1,1-12-12A12,12,0,0,1,104,140Zm60-12a12,12,0,1,0,12,12A12,12,0,0,0,164,128Zm74.45,64.9-67,29.71a16.17,16.17,0,0,1-21.71-9.1l-8.11-22q-6.72.45-13.63.46t-13.63-.46l-8.11,22a16.18,16.18,0,0,1-21.71,9.1l-67-29.71a15.94,15.94,0,0,1-9.06-18.51L38,58A16.08,16.08,0,0,1,51,46.13l36.06-5.92a16.21,16.21,0,0,1,18.26,11.88l3.26,12.83Q118.11,64,128,64t19.4.92l3.26-12.83a16.22,16.22,0,0,1,18.26-11.88L205,46.13A16.08,16.08,0,0,1,218,58l29.53,116.38A15.94,15.94,0,0,1,238.45,192.9ZM232,178.28,202.47,62s0,0-.08,0L166.33,56a.17.17,0,0,0-.17,0l-2.83,11.14c5,.94,10,2.06,14.83,3.42A8,8,0,0,1,176,86.31a8.09,8.09,0,0,1-2.16-.3A172.25,172.25,0,0,0,128,80a172.25,172.25,0,0,0-45.84,6,8,8,0,1,1-4.32-15.4c4.82-1.36,9.78-2.48,14.82-3.42L89.83,56a.21.21,0,0,0-.12,0h0L53.61,61.92a.24.24,0,0,0-.09,0L24,178.33,91,208a.21.21,0,0,0,.22,0L98,189.72a173.2,173.2,0,0,1-20.14-4.32A8,8,0,0,1,82.16,170,171.85,171.85,0,0,0,128,176a171.85,171.85,0,0,0,45.84-6,8,8,0,0,1,4.32,15.41A173.2,173.2,0,0,1,158,189.72L164.75,208a.22.22,0,0,0,.21,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M247.51,174.39,218,58a16.08,16.08,0,0,0-13-11.88l-36.06-5.92a16.22,16.22,0,0,0-18.26,11.88l-.21.85a4,4,0,0,0,3.27,4.93,155.62,155.62,0,0,1,24.41,5.62,8.2,8.2,0,0,1,5.62,9.7,8,8,0,0,1-10.19,5.64,155.4,155.4,0,0,0-90.8-.1,8.22,8.22,0,0,1-10.28-4.81,8,8,0,0,1,5.08-10.33,156.85,156.85,0,0,1,24.72-5.72,4,4,0,0,0,3.27-4.93l-.21-.85A16.21,16.21,0,0,0,87.08,40.21L51,46.13A16.08,16.08,0,0,0,38,58L8.49,174.39a15.94,15.94,0,0,0,9.06,18.51l67,29.71a16.17,16.17,0,0,0,21.71-9.1l3.49-9.45a4,4,0,0,0-3.27-5.35,158.13,158.13,0,0,1-28.63-6.2,8.2,8.2,0,0,1-5.61-9.67,8,8,0,0,1,10.2-5.66,155.59,155.59,0,0,0,91.12,0,8,8,0,0,1,10.19,5.65,8.19,8.19,0,0,1-5.61,9.68,157.84,157.84,0,0,1-28.62,6.2,4,4,0,0,0-3.27,5.35l3.49,9.45a16.18,16.18,0,0,0,21.71,9.1l67-29.71A15.94,15.94,0,0,0,247.51,174.39ZM92,152a12,12,0,1,1,12-12A12,12,0,0,1,92,152Zm72,0a12,12,0,1,1,12-12A12,12,0,0,1,164,152Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M102,140a10,10,0,1,1-10-10A10,10,0,0,1,102,140Zm62-10a10,10,0,1,0,10,10A10,10,0,0,0,164,130Zm73.64,61.08-67,29.71a14.43,14.43,0,0,1-5.77,1.21,14.13,14.13,0,0,1-13.25-9.18L143,189.43c-4.93.37-9.92.58-15,.58s-10.06-.21-15-.58l-8.63,23.39A14.13,14.13,0,0,1,91.13,222a14.43,14.43,0,0,1-5.77-1.21l-67-29.71a14,14,0,0,1-7.93-16.2L40,58.5A14.07,14.07,0,0,1,51.34,48.11L87.4,42.19a14.19,14.19,0,0,1,16,10.39l3.69,14.53a197.5,197.5,0,0,1,41.82,0l3.69-14.53a14.19,14.19,0,0,1,16-10.39l36.06,5.92A14.07,14.07,0,0,1,216,58.5l29.53,116.38A14,14,0,0,1,237.64,191.08Zm-3.7-13.25L204.41,61.45a2.08,2.08,0,0,0-1.7-1.5L166.65,54a2.13,2.13,0,0,0-2.42,1.5l-3.36,13.24a169.28,169.28,0,0,1,16.75,3.76A6,6,0,0,1,176,84.31a5.71,5.71,0,0,1-1.62-.23A174.26,174.26,0,0,0,128,78a174.26,174.26,0,0,0-46.38,6.08,6,6,0,1,1-3.24-11.55,169.28,169.28,0,0,1,16.75-3.76L91.77,55.53A2.12,2.12,0,0,0,89.35,54L53.29,60a2.08,2.08,0,0,0-1.7,1.5L22.06,177.83a2,2,0,0,0,1.16,2.28l67,29.7a2.19,2.19,0,0,0,1.76,0,2.07,2.07,0,0,0,1.14-1.17l7.58-20.55a171.46,171.46,0,0,1-22.33-4.64,6,6,0,1,1,3.24-11.55A174.26,174.26,0,0,0,128,178a174.26,174.26,0,0,0,46.38-6.08,6,6,0,1,1,3.24,11.55,171.46,171.46,0,0,1-22.33,4.64l7.58,20.55a2.07,2.07,0,0,0,1.14,1.17,2.19,2.19,0,0,0,1.76,0l67-29.7A2,2,0,0,0,233.94,177.83Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M104,140a12,12,0,1,1-12-12A12,12,0,0,1,104,140Zm60-12a12,12,0,1,0,12,12A12,12,0,0,0,164,128Zm74.45,64.9-67,29.71a16.17,16.17,0,0,1-21.71-9.1l-8.11-22q-6.72.45-13.63.46t-13.63-.46l-8.11,22a16.18,16.18,0,0,1-21.71,9.1l-67-29.71a15.93,15.93,0,0,1-9.06-18.51L38,58A16.07,16.07,0,0,1,51,46.14l36.06-5.93a16.22,16.22,0,0,1,18.26,11.88l3.26,12.84Q118.11,64,128,64t19.4.93l3.26-12.84a16.21,16.21,0,0,1,18.26-11.88L205,46.14A16.07,16.07,0,0,1,218,58l29.53,116.38A15.93,15.93,0,0,1,238.45,192.9ZM232,178.28,202.47,62s0,0-.08,0L166.33,56a.17.17,0,0,0-.17,0l-2.83,11.14c5,.94,10,2.06,14.83,3.42A8,8,0,0,1,176,86.31a8.09,8.09,0,0,1-2.16-.3A172.25,172.25,0,0,0,128,80a172.25,172.25,0,0,0-45.84,6,8,8,0,1,1-4.32-15.4c4.82-1.36,9.78-2.48,14.82-3.42L89.83,56s0,0-.12,0h0L53.61,61.93a.17.17,0,0,0-.09,0L24,178.33,91,208a.23.23,0,0,0,.22,0L98,189.72a173.2,173.2,0,0,1-20.14-4.32A8,8,0,0,1,82.16,170,171.85,171.85,0,0,0,128,176a171.85,171.85,0,0,0,45.84-6,8,8,0,0,1,4.32,15.41A173.2,173.2,0,0,1,158,189.72L164.75,208a.22.22,0,0,0,.21,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M100,140a8,8,0,1,1-8-8A8,8,0,0,1,100,140Zm64-8a8,8,0,1,0,8,8A8,8,0,0,0,164,132Zm72.83,57.25-67,29.71a12.36,12.36,0,0,1-5,1,12.13,12.13,0,0,1-11.38-7.88l-9.15-24.81c-5.36.45-10.81.69-16.34.69s-11-.24-16.34-.69l-9.15,24.81A12.13,12.13,0,0,1,91.13,220a12.36,12.36,0,0,1-5-1l-67-29.71a12,12,0,0,1-6.8-13.88L41.9,59a12.06,12.06,0,0,1,9.77-8.91l36.06-5.92a12.18,12.18,0,0,1,13.73,8.91l4.12,16.22a195.47,195.47,0,0,1,44.84,0l4.12-16.22a12.18,12.18,0,0,1,13.73-8.91l36.06,5.92A12.06,12.06,0,0,1,214.1,59l29.53,116.38A12,12,0,0,1,236.83,189.25Zm-1-11.91L206.35,61A4.07,4.07,0,0,0,203,58L167,52.05a4.15,4.15,0,0,0-4.69,3L158.4,70.38a166.74,166.74,0,0,1,18.68,4.08,4,4,0,1,1-2.16,7.7A176.21,176.21,0,0,0,128,76a176.21,176.21,0,0,0-46.92,6.16,4,4,0,1,1-2.16-7.7A166.74,166.74,0,0,1,97.6,70.38L93.71,55a4.15,4.15,0,0,0-4.69-3L53,58a4.07,4.07,0,0,0-3.31,3L20.12,177.34a4,4,0,0,0,2.29,4.59l67,29.71a4.16,4.16,0,0,0,3.35,0A4,4,0,0,0,95,209.35l8.45-22.88a171.49,171.49,0,0,1-24.53-4.92,4,4,0,0,1,2.16-7.71A176.21,176.21,0,0,0,128,180a176.21,176.21,0,0,0,46.92-6.16,4,4,0,0,1,2.16,7.71,171.49,171.49,0,0,1-24.53,4.92L161,209.35a4,4,0,0,0,2.23,2.32,4.16,4.16,0,0,0,3.35,0l67-29.71A4,4,0,0,0,235.88,177.34Z"
        }))
    ]
]), $aa33c7059515b2b5$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((e, l)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $aa33c7059515b2b5$var$c($aa33c7059515b2b5$var$m({
        ref: l
    }, e), {
        weights: $aa33c7059515b2b5$var$E
    })));
$aa33c7059515b2b5$export$2e2bcd8739ae039.displayName = "DiscordLogo";


var $acw62 = parcelRequire("acw62");


var $d38b367288fbdf35$var$H = Object.defineProperty, $d38b367288fbdf35$var$c = Object.defineProperties;
var $d38b367288fbdf35$var$V = Object.getOwnPropertyDescriptors;
var $d38b367288fbdf35$var$n = Object.getOwnPropertySymbols;
var $d38b367288fbdf35$var$M = Object.prototype.hasOwnProperty, $d38b367288fbdf35$var$o = Object.prototype.propertyIsEnumerable;
var $d38b367288fbdf35$var$r = (t, e, l)=>e in t ? $d38b367288fbdf35$var$H(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[e] = l, $d38b367288fbdf35$var$m = (t, e)=>{
    for(var l in e || (e = {}))$d38b367288fbdf35$var$M.call(e, l) && $d38b367288fbdf35$var$r(t, l, e[l]);
    if ($d38b367288fbdf35$var$n) for (var l of $d38b367288fbdf35$var$n(e))$d38b367288fbdf35$var$o.call(e, l) && $d38b367288fbdf35$var$r(t, l, e[l]);
    return t;
}, $d38b367288fbdf35$var$h = (t, e)=>$d38b367288fbdf35$var$c(t, $d38b367288fbdf35$var$V(e));
const $d38b367288fbdf35$var$E = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M144.49,136.49l-40,40a12,12,0,0,1-17-17L107,140H24a12,12,0,0,1,0-24h83L87.51,96.49a12,12,0,0,1,17-17l40,40A12,12,0,0,1,144.49,136.49ZM192,28H136a12,12,0,0,0,0,24h52V204H136a12,12,0,0,0,0,24h56a20,20,0,0,0,20-20V48A20,20,0,0,0,192,28Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M136,128,96,168V88Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M141.66,122.34l-40-40A8,8,0,0,0,88,88v32H24a8,8,0,0,0,0,16H88v32a8,8,0,0,0,13.66,5.66l40-40A8,8,0,0,0,141.66,122.34ZM104,148.69V107.31L124.69,128ZM208,48V208a16,16,0,0,1-16,16H136a8,8,0,0,1,0-16h56V48H136a8,8,0,0,1,0-16h56A16,16,0,0,1,208,48Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M141.66,133.66l-40,40A8,8,0,0,1,88,168V136H24a8,8,0,0,1,0-16H88V88a8,8,0,0,1,13.66-5.66l40,40A8,8,0,0,1,141.66,133.66ZM192,32H136a8,8,0,0,0,0,16h56V208H136a8,8,0,0,0,0,16h56a16,16,0,0,0,16-16V48A16,16,0,0,0,192,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M140.24,132.24l-40,40a6,6,0,0,1-8.48-8.48L121.51,134H24a6,6,0,0,1,0-12h97.51L91.76,92.24a6,6,0,0,1,8.48-8.48l40,40A6,6,0,0,1,140.24,132.24ZM192,34H136a6,6,0,0,0,0,12h56a2,2,0,0,1,2,2V208a2,2,0,0,1-2,2H136a6,6,0,0,0,0,12h56a14,14,0,0,0,14-14V48A14,14,0,0,0,192,34Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M141.66,133.66l-40,40a8,8,0,0,1-11.32-11.32L116.69,136H24a8,8,0,0,1,0-16h92.69L90.34,93.66a8,8,0,0,1,11.32-11.32l40,40A8,8,0,0,1,141.66,133.66ZM192,32H136a8,8,0,0,0,0,16h56V208H136a8,8,0,0,0,0,16h56a16,16,0,0,0,16-16V48A16,16,0,0,0,192,32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M138.83,130.83l-40,40a4,4,0,0,1-5.66-5.66L126.34,132H24a4,4,0,0,1,0-8H126.34L93.17,90.83a4,4,0,0,1,5.66-5.66l40,40A4,4,0,0,1,138.83,130.83ZM192,36H136a4,4,0,0,0,0,8h56a4,4,0,0,1,4,4V208a4,4,0,0,1-4,4H136a4,4,0,0,0,0,8h56a12,12,0,0,0,12-12V48A12,12,0,0,0,192,36Z"
        }))
    ]
]), $d38b367288fbdf35$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $d38b367288fbdf35$var$h($d38b367288fbdf35$var$m({
        ref: e
    }, t), {
        weights: $d38b367288fbdf35$var$E
    })));
$d38b367288fbdf35$export$2e2bcd8739ae039.displayName = "SignIn";


var $acw62 = parcelRequire("acw62");


var $1c5ddedbf5394646$var$c = Object.defineProperty, $1c5ddedbf5394646$var$o = Object.defineProperties;
var $1c5ddedbf5394646$var$p = Object.getOwnPropertyDescriptors;
var $1c5ddedbf5394646$var$r = Object.getOwnPropertySymbols;
var $1c5ddedbf5394646$var$E = Object.prototype.hasOwnProperty, $1c5ddedbf5394646$var$d = Object.prototype.propertyIsEnumerable;
var $1c5ddedbf5394646$var$n = (e, l, t)=>l in e ? $1c5ddedbf5394646$var$c(e, l, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[l] = t, $1c5ddedbf5394646$var$m = (e, l)=>{
    for(var t in l || (l = {}))$1c5ddedbf5394646$var$E.call(l, t) && $1c5ddedbf5394646$var$n(e, t, l[t]);
    if ($1c5ddedbf5394646$var$r) for (var t of $1c5ddedbf5394646$var$r(l))$1c5ddedbf5394646$var$d.call(l, t) && $1c5ddedbf5394646$var$n(e, t, l[t]);
    return e;
}, $1c5ddedbf5394646$var$L = (e, l)=>$1c5ddedbf5394646$var$o(e, $1c5ddedbf5394646$var$p(l));
const $1c5ddedbf5394646$var$u = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M230.86,109.25,169.18,86.82,146.75,25.14a19.95,19.95,0,0,0-37.5,0L86.82,86.82,25.14,109.25a19.95,19.95,0,0,0,0,37.5l61.68,22.43,22.43,61.68a19.95,19.95,0,0,0,37.5,0l22.43-61.68,61.68-22.43a19.95,19.95,0,0,0,0-37.5Zm-71.65,38a19.92,19.92,0,0,0-11.94,11.94l-19.27,53-19.27-53a19.92,19.92,0,0,0-11.94-11.94L43.79,128l53-19.27a19.92,19.92,0,0,0,11.94-11.94l19.27-53,19.27,53a19.92,19.92,0,0,0,11.94,11.94l53,19.27Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M226.76,135.48l-63.45,23.07a8,8,0,0,0-4.76,4.76l-23.07,63.45a8,8,0,0,1-15,0L97.45,163.31a8,8,0,0,0-4.76-4.76L29.24,135.48a8,8,0,0,1,0-15L92.69,97.45a8,8,0,0,0,4.76-4.76l23.07-63.45a8,8,0,0,1,15,0l23.07,63.45a8,8,0,0,0,4.76,4.76l63.45,23.07A8,8,0,0,1,226.76,135.48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M229.5,113,166.07,90,143,26.5a16,16,0,0,0-30,0L90,89.93,26.5,113a16,16,0,0,0,0,30l63.43,23L113,229.5a16,16,0,0,0,30,0l23.07-63.44L229.5,143a16,16,0,0,0,0-30Zm-68.93,38a16,16,0,0,0-9.54,9.54L128,223.9l-23-63.33A16,16,0,0,0,95.43,151L32.1,128l63.33-23A16,16,0,0,0,105,95.43L128,32.1l23,63.33a16,16,0,0,0,9.54,9.54l63.33,23Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M240,128a15.79,15.79,0,0,1-10.5,15l-63.44,23.07L143,229.5a16,16,0,0,1-30,0L89.93,166,26.5,143a16,16,0,0,1,0-30L90,89.93,113,26.5a16,16,0,0,1,30,0L166.07,90,229.5,113A15.79,15.79,0,0,1,240,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M228.81,114.89,165.36,91.81a1.94,1.94,0,0,1-1.17-1.17L141.11,27.19a13.95,13.95,0,0,0-26.22,0L91.81,90.64a1.94,1.94,0,0,1-1.17,1.17L27.19,114.89a13.95,13.95,0,0,0,0,26.22l63.45,23.08a1.94,1.94,0,0,1,1.17,1.17l23.08,63.45a13.95,13.95,0,0,0,26.22,0l23.08-63.45h0a1.94,1.94,0,0,1,1.17-1.17l63.45-23.08a13.95,13.95,0,0,0,0-26.22Zm-4.1,15-63.45,23.07a14,14,0,0,0-8.35,8.35l-23.07,63.45a2,2,0,0,1-3.68,0l-23.07-63.45a14,14,0,0,0-8.35-8.35L31.29,129.84a2,2,0,0,1,0-3.68l63.45-23.07a14,14,0,0,0,8.35-8.35l23.07-63.45a2,2,0,0,1,3.68,0l23.07,63.45a14,14,0,0,0,8.35,8.35l63.45,23.07a2,2,0,0,1,0,3.68Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M229.5,113,166.07,90,143,26.5a16,16,0,0,0-30,0L90,89.93,26.5,113a16,16,0,0,0,0,30l63.43,23L113,229.5a16,16,0,0,0,30,0l23.07-63.44L229.5,143a16,16,0,0,0,0-30Zm-68.93,38a16,16,0,0,0-9.54,9.54L128,223.9l-23-63.33A16,16,0,0,0,95.43,151L32.1,128l63.33-23A16,16,0,0,0,105,95.43L128,32.1l23,63.33a16,16,0,0,0,9.54,9.54l63.33,23Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M228.13,116.77,164.67,93.69a3.94,3.94,0,0,1-2.36-2.36L139.23,27.87a11.95,11.95,0,0,0-22.46,0L93.69,91.33a3.94,3.94,0,0,1-2.36,2.36L27.87,116.77a11.95,11.95,0,0,0,0,22.46l63.46,23.08a3.94,3.94,0,0,1,2.36,2.36l23.08,63.46a11.95,11.95,0,0,0,22.46,0l23.08-63.46h0a3.94,3.94,0,0,1,2.36-2.36l63.46-23.08a11.95,11.95,0,0,0,0-22.46Zm-2.73,15-63.46,23.07a11.93,11.93,0,0,0-7.15,7.15L131.72,225.4a4,4,0,0,1-7.44,0l-23.07-63.46a11.93,11.93,0,0,0-7.15-7.15L30.6,131.72a4,4,0,0,1,0-7.44l63.46-23.07a11.93,11.93,0,0,0,7.15-7.15L124.28,30.6a4,4,0,0,1,7.44,0l23.07,63.46a11.93,11.93,0,0,0,7.15,7.15l63.46,23.07a4,4,0,0,1,0,7.44Z"
        }))
    ]
]), $1c5ddedbf5394646$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((e, l)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $1c5ddedbf5394646$var$L($1c5ddedbf5394646$var$m({
        ref: l
    }, e), {
        weights: $1c5ddedbf5394646$var$u
    })));
$1c5ddedbf5394646$export$2e2bcd8739ae039.displayName = "StarFour";





/**
 * Swiper 10.1.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 1, 2023
 */ /**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $0868fe5596dee114$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $0868fe5596dee114$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($0868fe5596dee114$var$isObject(src[key]) && $0868fe5596dee114$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $0868fe5596dee114$var$extend(target[key], src[key]);
    });
}
const $0868fe5596dee114$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $0868fe5596dee114$export$39b482c5e57630a8() {
    const doc = typeof document !== "undefined" ? document : {};
    $0868fe5596dee114$var$extend(doc, $0868fe5596dee114$var$ssrDocument);
    return doc;
}
const $0868fe5596dee114$var$ssrWindow = {
    document: $0868fe5596dee114$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $0868fe5596dee114$export$407448d2b89b1813() {
    const win = typeof window !== "undefined" ? window : {};
    $0868fe5596dee114$var$extend(win, $0868fe5596dee114$var$ssrWindow);
    return win;
}



function $f97f33853a605dba$export$43caf9889c228507(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $f97f33853a605dba$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $f97f33853a605dba$export$4368d992c4eafac0() {
    return Date.now();
}
function $f97f33853a605dba$var$getComputedStyle(el) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $f97f33853a605dba$export$dda1d9f60106f0e9(el, axis) {
    if (axis === void 0) axis = "x";
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $f97f33853a605dba$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $f97f33853a605dba$export$35e795649ee09318(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $f97f33853a605dba$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $f97f33853a605dba$export$9e5f44173e64f162() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$f97f33853a605dba$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($f97f33853a605dba$export$35e795649ee09318(to[nextKey]) && $f97f33853a605dba$export$35e795649ee09318(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $f97f33853a605dba$export$9e5f44173e64f162(to[nextKey], nextSource[nextKey]);
                    } else if (!$f97f33853a605dba$export$35e795649ee09318(to[nextKey]) && $f97f33853a605dba$export$35e795649ee09318(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $f97f33853a605dba$export$9e5f44173e64f162(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $f97f33853a605dba$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $f97f33853a605dba$export$ffb5f4729a158638(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $f97f33853a605dba$export$342063e11d6c3cad(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function $f97f33853a605dba$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = "";
    return [
        ...element.children
    ].filter((el)=>el.matches(selector));
}
function $f97f33853a605dba$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : [
        classes
    ]);
    return el;
}
function $f97f33853a605dba$export$8b22cf2602fb60ce(el) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $f97f33853a605dba$export$ae1af26003f05816(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $f97f33853a605dba$export$953cecd6e717a553(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $f97f33853a605dba$export$882b5998b3b9117c(el, prop) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $f97f33853a605dba$export$39b482c5e57630a8(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $f97f33853a605dba$export$407448d2b89b1813(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $f97f33853a605dba$export$23f2a1d2818174ef(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $f97f33853a605dba$export$2d1720544b23b823(el, size, includeMargins) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}


let $1262f2e38e280703$var$support;
function $1262f2e38e280703$var$calcSupport() {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $1262f2e38e280703$var$getSupport() {
    if (!$1262f2e38e280703$var$support) $1262f2e38e280703$var$support = $1262f2e38e280703$var$calcSupport();
    return $1262f2e38e280703$var$support;
}
let $1262f2e38e280703$var$deviceCached;
function $1262f2e38e280703$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $1262f2e38e280703$var$getSupport();
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $1262f2e38e280703$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$1262f2e38e280703$var$deviceCached) $1262f2e38e280703$var$deviceCached = $1262f2e38e280703$var$calcDevice(overrides);
    return $1262f2e38e280703$var$deviceCached;
}
let $1262f2e38e280703$var$browser;
function $1262f2e38e280703$var$calcBrowser() {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    return {
        isSafari: needPerspectiveFix || isSafari(),
        needPerspectiveFix: needPerspectiveFix,
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent)
    };
}
function $1262f2e38e280703$var$getBrowser() {
    if (!$1262f2e38e280703$var$browser) $1262f2e38e280703$var$browser = $1262f2e38e280703$var$calcBrowser();
    return $1262f2e38e280703$var$browser;
}
function $1262f2e38e280703$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function $1262f2e38e280703$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $f97f33853a605dba$export$407448d2b89b1813)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var $1262f2e38e280703$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $1262f2e38e280703$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $f97f33853a605dba$export$882b5998b3b9117c)(el, "padding-left") || 0, 10) - parseInt((0, $f97f33853a605dba$export$882b5998b3b9117c)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $f97f33853a605dba$export$882b5998b3b9117c)(el, "padding-top") || 0, 10) - parseInt((0, $f97f33853a605dba$export$882b5998b3b9117c)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $1262f2e38e280703$var$updateSlides() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slides[i] && (0, $f97f33853a605dba$export$882b5998b3b9117c)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $f97f33853a605dba$export$2d1720544b23b823)(slide, "width", true) : (0, $f97f33853a605dba$export$2d1720544b23b823)(slide, "height", true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $1262f2e38e280703$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $1262f2e38e280703$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
function $1262f2e38e280703$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideVisibleClass);
    });
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides[i].classList.add(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $1262f2e38e280703$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
function $1262f2e38e280703$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const getFilteredSlide = (selector)=>{
        return (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
    });
    let activeSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        // Active classes
        activeSlide.classList.add(params.slideActiveClass);
        // Next Slide
        let nextSlide = (0, $f97f33853a605dba$export$953cecd6e717a553)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        if (params.loop && !nextSlide) nextSlide = slides[0];
        if (nextSlide) nextSlide.classList.add(params.slideNextClass);
        // Prev Slide
        let prevSlide = (0, $f97f33853a605dba$export$ae1af26003f05816)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        params.loop;
        if (prevSlide) prevSlide.classList.add(params.slidePrevClass);
    }
    swiper.emitSlidesClasses();
}
const $1262f2e38e280703$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        const lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (lazyEl) lazyEl.remove();
    }
};
const $1262f2e38e280703$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
const $1262f2e38e280703$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $1262f2e38e280703$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $1262f2e38e280703$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $1262f2e38e280703$var$unlazy(swiper, i);
    }
};
function $1262f2e38e280703$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $1262f2e38e280703$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $1262f2e38e280703$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (swiper.slides[activeIndex]) realIndex = parseInt(swiper.slides[activeIndex].getAttribute("data-swiper-slide-index") || activeIndex, 10);
    else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $1262f2e38e280703$var$preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}
function $1262f2e38e280703$var$updateClickedSlide(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = e.closest(`.${params.slideClass}, swiper-slide`);
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $1262f2e38e280703$var$update = {
    updateSize: $1262f2e38e280703$var$updateSize,
    updateSlides: $1262f2e38e280703$var$updateSlides,
    updateAutoHeight: $1262f2e38e280703$var$updateAutoHeight,
    updateSlidesOffset: $1262f2e38e280703$var$updateSlidesOffset,
    updateSlidesProgress: $1262f2e38e280703$var$updateSlidesProgress,
    updateProgress: $1262f2e38e280703$var$updateProgress,
    updateSlidesClasses: $1262f2e38e280703$var$updateSlidesClasses,
    updateActiveIndex: $1262f2e38e280703$var$updateActiveIndex,
    updateClickedSlide: $1262f2e38e280703$var$updateClickedSlide
};
function $1262f2e38e280703$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $f97f33853a605dba$export$dda1d9f60106f0e9)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $1262f2e38e280703$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function $1262f2e38e280703$var$minTranslate() {
    return -this.snapGrid[0];
}
function $1262f2e38e280703$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $1262f2e38e280703$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $f97f33853a605dba$export$ffb5f4729a158638)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $1262f2e38e280703$var$translate = {
    getTranslate: $1262f2e38e280703$var$getSwiperTranslate,
    setTranslate: $1262f2e38e280703$var$setTranslate,
    minTranslate: $1262f2e38e280703$var$minTranslate,
    maxTranslate: $1262f2e38e280703$var$maxTranslate,
    translateTo: $1262f2e38e280703$var$translateTo
};
function $1262f2e38e280703$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
    swiper.emit("setTransition", duration, byController);
}
function $1262f2e38e280703$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $1262f2e38e280703$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $1262f2e38e280703$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}
function $1262f2e38e280703$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $1262f2e38e280703$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}
var $1262f2e38e280703$var$transition = {
    setTransition: $1262f2e38e280703$var$setTransition,
    transitionStart: $1262f2e38e280703$var$transitionStart,
    transitionEnd: $1262f2e38e280703$var$transitionEnd
};
function $1262f2e38e280703$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $f97f33853a605dba$export$ffb5f4729a158638)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $1262f2e38e280703$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else newIndex = swiper.getSlideIndexByData(newIndex);
    }
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $1262f2e38e280703$var$slideNext(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $1262f2e38e280703$var$slidePrev(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled) return swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $1262f2e38e280703$var$slideReset(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $1262f2e38e280703$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $1262f2e38e280703$var$slideToClickedSlide() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $1262f2e38e280703$var$slide = {
    slideTo: $1262f2e38e280703$var$slideTo,
    slideToLoop: $1262f2e38e280703$var$slideToLoop,
    slideNext: $1262f2e38e280703$var$slideNext,
    slidePrev: $1262f2e38e280703$var$slidePrev,
    slideReset: $1262f2e38e280703$var$slideReset,
    slideToClosest: $1262f2e38e280703$var$slideToClosest,
    slideToClickedSlide: $1262f2e38e280703$var$slideToClickedSlide
};
function $1262f2e38e280703$var$loopCreate(slideRealIndex) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    slides.forEach((el, index)=>{
        el.setAttribute("data-swiper-slide-index", index);
    });
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}
function $1262f2e38e280703$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10));
    let loopedSlides = params.loopedSlides || slidesPerView;
    if (loopedSlides % params.slidesPerGroup !== 0) loopedSlides += params.slidesPerGroup - loopedSlides % params.slidesPerGroup;
    swiper.loopedSlides = loopedSlides;
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    let activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(swiper.slides.filter((el)=>el.classList.contains(params.slideActiveClass))[0]);
    else activeIndex = activeSlideIndex;
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    // prepend last slides before start
    if (activeSlideIndex < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeSlideIndex, params.slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeSlideIndex; i += 1){
            const index = i - Math.floor(i / slides.length) * slides.length;
            prependSlidesIndexes.push(slides.length - index - 1);
        }
    } else if (activeSlideIndex /* + slidesPerView */  > swiper.slides.length - loopedSlides * 2) {
        slidesAppended = Math.max(activeSlideIndex - (swiper.slides.length - loopedSlides * 2), params.slidesPerGroup);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / slides.length) * slides.length;
            appendSlidesIndexes.push(index);
        }
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
                    if (setTranslate) {
                        swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
                        swiper.touchEventsData.currentTranslate = swiper.translate;
                    }
                }
            } else if (setTranslate) {
                swiper.slideToLoop(slideRealIndex, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
                        swiper.touchEventsData.currentTranslate = swiper.translate;
                    }
                }
            } else swiper.slideToLoop(slideRealIndex, 0, false, true);
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            slideTo: false,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix(loopParams);
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix(loopParams);
    }
    swiper.emit("loopFix");
}
function $1262f2e38e280703$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $1262f2e38e280703$var$loop = {
    loopCreate: $1262f2e38e280703$var$loopCreate,
    loopFix: $1262f2e38e280703$var$loopFix,
    loopDestroy: $1262f2e38e280703$var$loopDestroy
};
function $1262f2e38e280703$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $1262f2e38e280703$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $1262f2e38e280703$var$grabCursor = {
    setGrabCursor: $1262f2e38e280703$var$setGrabCursor,
    unsetGrabCursor: $1262f2e38e280703$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $1262f2e38e280703$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $0868fe5596dee114$export$39b482c5e57630a8)() || el === (0, $0868fe5596dee114$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $1262f2e38e280703$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const data = swiper.touchEventsData;
    data.evCache.push(event);
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!swiper.wrapperEl.contains(targetEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $1262f2e38e280703$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $f97f33853a605dba$export$4368d992c4eafac0)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function $1262f2e38e280703$var$onTouchMove(event) {
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    const pointerIndex = data.evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
    if (pointerIndex >= 0) data.evCache[pointerIndex] = e;
    const targetTouch = data.evCache.length > 1 ? data.evCache[0] : e;
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                prevX: swiper.touches.currentX,
                prevY: swiper.touches.currentY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $f97f33853a605dba$export$4368d992c4eafac0)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || swiper.zoom && swiper.params.zoom && swiper.params.zoom.enabled && data.evCache.length > 1) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    if (!data.isMoved) {
        if (isLoop) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    if (data.isMoved && prevTouchesDirection !== swiper.touchesDirection && isLoop && Math.abs(diff) >= 1) {
        // need another loop fix
        swiper.loopFix({
            direction: swiper.swipeDirection,
            setTranslate: true
        });
        loopFixed = true;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && !loopFixed && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.size / 2 : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && !loopFixed && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.size / 2 : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $1262f2e38e280703$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const pointerIndex = data.evCache.findIndex((cachedEv)=>cachedEv.pointerId === event.pointerId);
    if (pointerIndex >= 0) data.evCache.splice(pointerIndex, 1);
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave"
    ].includes(event.type)) {
        const proceed = event.type === "pointercancel" && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $f97f33853a605dba$export$4368d992c4eafac0)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $f97f33853a605dba$export$4368d992c4eafac0)();
    (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $1262f2e38e280703$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $1262f2e38e280703$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $1262f2e38e280703$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function $1262f2e38e280703$var$onLoad(e) {
    const swiper = this;
    $1262f2e38e280703$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
let $1262f2e38e280703$var$dummyEventAttached = false;
function $1262f2e38e280703$var$dummyEventListener() {}
const $1262f2e38e280703$var$events = (swiper, method)=>{
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    // Touch Events
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $1262f2e38e280703$var$onResize, true);
    else swiper[swiperMethod]("observerUpdate", $1262f2e38e280703$var$onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $1262f2e38e280703$var$attachEvents() {
    const swiper = this;
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const { params: params } = swiper;
    swiper.onTouchStart = $1262f2e38e280703$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $1262f2e38e280703$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $1262f2e38e280703$var$onTouchEnd.bind(swiper);
    if (params.cssMode) swiper.onScroll = $1262f2e38e280703$var$onScroll.bind(swiper);
    swiper.onClick = $1262f2e38e280703$var$onClick.bind(swiper);
    swiper.onLoad = $1262f2e38e280703$var$onLoad.bind(swiper);
    if (!$1262f2e38e280703$var$dummyEventAttached) {
        document1.addEventListener("touchstart", $1262f2e38e280703$var$dummyEventListener);
        $1262f2e38e280703$var$dummyEventAttached = true;
    }
    $1262f2e38e280703$var$events(swiper, "on");
}
function $1262f2e38e280703$var$detachEvents() {
    const swiper = this;
    $1262f2e38e280703$var$events(swiper, "off");
}
var $1262f2e38e280703$var$events$1 = {
    attachEvents: $1262f2e38e280703$var$attachEvents,
    detachEvents: $1262f2e38e280703$var$detachEvents
};
const $1262f2e38e280703$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $1262f2e38e280703$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $1262f2e38e280703$var$isGridEnabled(swiper, params);
    const isMultiRow = $1262f2e38e280703$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === "undefined") return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $f97f33853a605dba$export$9e5f44173e64f162)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate(realIndex);
        swiper.updateSlides();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function $1262f2e38e280703$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var $1262f2e38e280703$var$breakpoints = {
    setBreakpoint: $1262f2e38e280703$var$setBreakpoint,
    getBreakpoint: $1262f2e38e280703$var$getBreakpoint
};
function $1262f2e38e280703$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $1262f2e38e280703$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $1262f2e38e280703$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $1262f2e38e280703$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $1262f2e38e280703$var$classes = {
    addClasses: $1262f2e38e280703$var$addClasses,
    removeClasses: $1262f2e38e280703$var$removeClasses
};
function $1262f2e38e280703$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $1262f2e38e280703$var$checkOverflow$1 = {
    checkOverflow: $1262f2e38e280703$var$checkOverflow
};
var $1262f2e38e280703$export$4368d992c4eafac0 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopedSlides: null,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $1262f2e38e280703$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $f97f33853a605dba$export$9e5f44173e64f162)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $f97f33853a605dba$export$9e5f44173e64f162)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $f97f33853a605dba$export$9e5f44173e64f162)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $1262f2e38e280703$var$prototypes = {
    eventsEmitter: $1262f2e38e280703$var$eventsEmitter,
    update: $1262f2e38e280703$var$update,
    translate: $1262f2e38e280703$var$translate,
    transition: $1262f2e38e280703$var$transition,
    slide: $1262f2e38e280703$var$slide,
    loop: $1262f2e38e280703$var$loop,
    grabCursor: $1262f2e38e280703$var$grabCursor,
    events: $1262f2e38e280703$var$events$1,
    breakpoints: $1262f2e38e280703$var$breakpoints,
    checkOverflow: $1262f2e38e280703$var$checkOverflow$1,
    classes: $1262f2e38e280703$var$classes
};
const $1262f2e38e280703$var$extendedDefaults = {};
class $1262f2e38e280703$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $f97f33853a605dba$export$9e5f44173e64f162)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $f97f33853a605dba$export$9e5f44173e64f162)({}, params, {
                    el: containerEl
                });
                swipers.push(new $1262f2e38e280703$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $1262f2e38e280703$var$getSupport();
        swiper.device = $1262f2e38e280703$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $1262f2e38e280703$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $1262f2e38e280703$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $f97f33853a605dba$export$9e5f44173e64f162)({}, $1262f2e38e280703$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $f97f33853a605dba$export$9e5f44173e64f162)({}, swiperParams, $1262f2e38e280703$var$extendedDefaults, params);
        swiper.originalParams = (0, $f97f33853a605dba$export$9e5f44173e64f162)({}, swiper.params);
        swiper.passedParams = (0, $f97f33853a605dba$export$9e5f44173e64f162)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                evCache: []
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $f97f33853a605dba$export$39b482c5e57630a8)(slides[0]);
        return (0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = "current";
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? slides[activeIndex].swiperSlideSize : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $1262f2e38e280703$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === "string") el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === "SWIPER-CONTAINER") swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $f97f33853a605dba$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)("div", swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $f97f33853a605dba$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || (0, $f97f33853a605dba$export$882b5998b3b9117c)(el, "direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $f97f33853a605dba$export$882b5998b3b9117c)(el, "direction") === "rtl"),
            wrongRTL: (0, $f97f33853a605dba$export$882b5998b3b9117c)(wrapperEl, "display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit");
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate();
        // Attach events
        swiper.attachEvents();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $1262f2e38e280703$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener("load", (e)=>{
                $1262f2e38e280703$var$processLazyPreloader(swiper, e.target);
            });
        });
        $1262f2e38e280703$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $1262f2e38e280703$var$preload(swiper);
        // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy");
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            el.removeAttribute("style");
            wrapperEl.removeAttribute("style");
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute("style");
                slideEl.removeAttribute("data-swiper-slide-index");
            });
        }
        swiper.emit("destroy");
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.el.swiper = null;
            (0, $f97f33853a605dba$export$43caf9889c228507)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $f97f33853a605dba$export$9e5f44173e64f162)($1262f2e38e280703$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $1262f2e38e280703$var$extendedDefaults;
    }
    static get defaults() {
        return $1262f2e38e280703$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$1262f2e38e280703$export$25ce5a424b770e84.prototype.__modules__) $1262f2e38e280703$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $1262f2e38e280703$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$1262f2e38e280703$export$25ce5a424b770e84.installModule(m));
            return $1262f2e38e280703$export$25ce5a424b770e84;
        }
        $1262f2e38e280703$export$25ce5a424b770e84.installModule(module);
        return $1262f2e38e280703$export$25ce5a424b770e84;
    }
}
Object.keys($1262f2e38e280703$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($1262f2e38e280703$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $1262f2e38e280703$export$25ce5a424b770e84.prototype[protoMethod] = $1262f2e38e280703$var$prototypes[prototypeGroup][protoMethod];
    });
});
$1262f2e38e280703$export$25ce5a424b770e84.use([
    $1262f2e38e280703$var$Resize,
    $1262f2e38e280703$var$Observer
]);







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $9a9dd0b0fb5253bc$export$bce3bfec9f56c837 = ()=>{
    const mounted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return mounted;
};




function $27b68f2c8db94444$export$61b434322957fdac(props) {
    const { inActive: inActive, headEmoji: headEmoji, headTitle: headTitle, content: content, className: className, tips: tips, complete: complete, activeTipChanged: activeTipChanged, isSm: isSm, ...rest } = props;
    const [activeTip, setActiveTip] = (0, $acw62.useState)({
        active: 0,
        progress: 0
    });
    const [_tipProgressTimer, setProgressTimer] = (0, $acw62.useState)(0) // interval timer
    ;
    const isMounted = (0, $9a9dd0b0fb5253bc$export$bce3bfec9f56c837)();
    const resetState = ()=>{
        setActiveTip({
            active: 0,
            progress: 0
        });
        setProgressTimer(0);
    };
    const updateActiveNum = (active)=>{
        setActiveTip(()=>{
            return {
                active: active,
                progress: 0
            };
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (!isMounted.current) return;
        if (!inActive) {
            clear();
            resetState();
            return;
        }
        function clear() {
            setProgressTimer((timer)=>{
                clearInterval(timer);
                return 0;
            });
        }
        const tickHandler = ()=>{
            // async
            setActiveTip(({ active: active, progress: progress })=>{
                let toProgress = progress + 0.4;
                let toActive = active;
                if (toProgress > 100) {
                    if (active) {
                        clear();
                        complete?.();
                        toProgress = 100;
                    } else {
                        toProgress = 0;
                        toActive = 1;
                    }
                }
                return {
                    active: toActive,
                    progress: toProgress
                };
            });
        };
        function run() {
            clear();
            const timer = setInterval(tickHandler, 60);
            setProgressTimer(timer);
        }
        console.log("run ....");
        run();
        return clear;
    }, [
        inActive
    ]);
    (0, $acw62.useEffect)(()=>{
        inActive && activeTipChanged?.(activeTip.active.toString());
    }, [
        activeTip.active,
        inActive
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("item swiper-slide a", className),
        ...rest,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-3xl pr-4",
                        children: headEmoji
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                        className: "text-sm cursor-text",
                        leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c5ddedbf5394646$export$2e2bcd8739ae039), {
                            size: 16
                        }),
                        children: headTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "pt-2 text-[20px] sm:text-3xl text-gray-300",
                children: content
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                className: "progress",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        onClick: ()=>updateActiveNum(0),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                            style: {
                                width: (!activeTip.active ? activeTip.progress : 100) + "%"
                            },
                            children: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        onClick: ()=>updateActiveNum(1),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                            style: {
                                width: (!activeTip.active ? 0 : activeTip.progress) + "%"
                            },
                            children: "2"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "flex text-sm sm:text-lg space-x-2 px-1 py-2 tracking-wide",
                children: tips.map((it, idx)=>{
                    if (activeTip.active !== idx) return;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "animate-in duration-1000 fade-in-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    "Tip ",
                                    idx + 1,
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-gray-300/90",
                                children: it
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
}
function $27b68f2c8db94444$export$912807921f43ced2() {
    const appState = (0, $0b89d474933103bc$export$9973955de2bf96cf)();
    const swiperElRef = (0, $acw62.useRef)(null);
    const swiperRef = (0, $acw62.useRef)(null);
    const bdRef = (0, $acw62.useRef)(null);
    const [activeIndex, setActiveIndex] = (0, $acw62.useState)(0);
    const [activeTipTag, setActiveTipTag] = (0, $acw62.useState)("00");
    const sidesLen = 3;
    const isSm = appState.sm.get();
    (0, $acw62.useEffect)(()=>{
        if (swiperRef.current) return;
        // @ts-ignore
        const sw = swiperRef.current = new (0, $1262f2e38e280703$export$25ce5a424b770e84)(swiperElRef.current, {
            loop: false
        });
        sw.on("activeIndexChange", ()=>{
            setActiveIndex(sw.realIndex);
        });
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-tutorial-tips",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a7a7174f7bc9055$export$24fab8e739feba68), {
                ticks: [
                    500,
                    1,
                    300,
                    1
                ],
                className: "hd flex flex-col justify-center items-center",
                children: (t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("invisible pb-4 sm:pb-0 sm:flex items-center", t[0] && "ani-slide-in-from-bottom"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "pr-5 text-logseq-50/80 inline",
                                                children: "Braindump everything into"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "dockify-app-logo inline-block",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $459f452165207905$export$f7e22c3fd4ab6d59), {
                                                    className: "w-16 h-16"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "pl-2 text-logseq-50/80 inline",
                                                children: "."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "inline-block sm:!hidden",
                                        children: "New ideas will pop up with time."
                                    })
                                ]
                            }),
                            appState.sm.get() ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("invisible", t[1] && "ani-slide-in-from-bottom"),
                                children: "New ideas will pop up with time."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("invisible", t[2] && "ani-fade-in"),
                                children: "Using Logseq helps you organize your thoughts and ideas"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("invisible", t[3] && "ani-fade-in"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-logseq-50/80",
                                        children: "so that you can "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "opacity-100 pl-1",
                                        children: "come up with new outputs more easily."
                                    })
                                ]
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bd sm:grid grid-cols-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bd-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                ref: swiperElRef,
                                className: "bd-slides swiper",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "items swiper-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($27b68f2c8db94444$export$61b434322957fdac, {
                                            isSm: isSm,
                                            inActive: activeIndex === 0,
                                            headEmoji: "✍️",
                                            headTitle: "Beginner",
                                            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Get in the habit of writing ",
                                                    isSm ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                    "thoughts down every day."
                                                ]
                                            }),
                                            tips: [
                                                "Think in sections, use indentation.",
                                                "Use links & hashtags."
                                            ],
                                            complete: ()=>{
                                                swiperRef.current?.slideNext();
                                            },
                                            activeTipChanged: (tag)=>{
                                                setActiveTipTag?.(`0${tag}`);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($27b68f2c8db94444$export$61b434322957fdac, {
                                            isSm: isSm,
                                            inActive: activeIndex === 1,
                                            headEmoji: "\uD83D\uDD0D️",
                                            headTitle: "Intermediate",
                                            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Always find what you’re ",
                                                    isSm ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                    " looking for."
                                                ]
                                            }),
                                            tips: [
                                                "Use CMD-K to search with ease.",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "sm:text-lg",
                                                    children: "Go through linked references to find valuable information nuggets from the past."
                                                })
                                            ],
                                            complete: ()=>{
                                                swiperRef.current?.slideNext();
                                            },
                                            activeTipChanged: (tag)=>{
                                                setActiveTipTag?.(`1${tag}`);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($27b68f2c8db94444$export$61b434322957fdac, {
                                            isSm: isSm,
                                            inActive: activeIndex === 2,
                                            headEmoji: "\uD83D\uDCBC️",
                                            headTitle: "Expert",
                                            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Create your own processes."
                                            }),
                                            tips: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        "Use queries to generate tables of ",
                                                        isSm ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                        " relevant information."
                                                    ]
                                                }),
                                                "Install plugins and customize the app around your workflow needs."
                                            ],
                                            complete: ()=>{
                                                swiperRef.current?.slideTo(0);
                                            },
                                            activeTipChanged: (tag)=>{
                                                setActiveTipTag?.(`2${tag}`);
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bd-actions flex",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "prev",
                                        title: "Previous",
                                        onClick: ()=>{
                                            if (activeIndex == 0) return swiperRef.current?.slideTo(2);
                                            swiperRef.current?.slidePrev();
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9f1c3559b497798$export$2e2bcd8739ae039), {
                                            size: 26
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "dots flex space-x-3 rounded-2xl bg-gray-700/40 py-2 px-4 items-center",
                                        children: Array(sidesLen).fill(0).map((_, i)=>{
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("w-2 h-2 bg-logseq-100/50 rounded-2xl cursor-pointer select-none hover:opacity-80", i === activeIndex && "!bg-white/90"),
                                                onClick: ()=>{
                                                    swiperRef.current?.slideTo(i);
                                                }
                                            }, i);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "next",
                                        title: "Next",
                                        onClick: ()=>{
                                            if (activeIndex == 2) return swiperRef.current?.slideTo(0);
                                            swiperRef.current?.slideNext();
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffb21843868106ef$export$2e2bcd8739ae039), {
                                            size: 26
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bd-info",
                        ref: bdRef,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex image-wrap",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "animate-in fade-in-0 duration-1000",
                                src: (0, $db0bad02d0b0ecf1$export$8e734e9a19552f8b)[activeTipTag],
                                alt: "image"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ft mt-14 sm:flex sm:h-28 sm:mt-28",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex-1 sm:flex flex-col justify-center items-center sm:border-l sm:border-l-logseq-500",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-xl sm:text-2xl mt-2 sm:-mt-8",
                            children: "A helpful community"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "sm:flex sm:space-x-6 py-5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                                            className: "bg-[#5865F2]/75 px-4 sm:px-8",
                                            leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa33c7059515b2b5$export$2e2bcd8739ae039), {
                                                size: 20,
                                                weight: "duotone"
                                            }),
                                            rightIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d38b367288fbdf35$export$2e2bcd8739ae039), {
                                                className: "opacity-40",
                                                size: 20,
                                                weight: "duotone"
                                            }),
                                            href: `https://discord.gg/VNfUaTtdFb`,
                                            children: "Join our Discord"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-[12px] flex items-center pt-2 sm:justify-center text-gray-400/80",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    className: "h-2 w-2 bg-green-600 rounded"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    className: "pl-2 pr-1",
                                                    children: appState.discord?.approximate_presence_count.get() || "-"
                                                }),
                                                "users online currently"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col mt-3 sm:mt-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                                            leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da620479e4407639$export$2e2bcd8739ae039), {
                                                size: 24,
                                                weight: "duotone"
                                            }),
                                            rightIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d38b367288fbdf35$export$2e2bcd8739ae039), {
                                                className: "opacity-40",
                                                size: 20,
                                                weight: "duotone"
                                            }),
                                            href: `https://discuss.logseq.com`,
                                            className: "bg-logseq-700 w-full sm:w-auto",
                                            children: "Join our forum"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "hidden sm:inline-block text-[11px] pt-2 text-center w-full text-gray-400/80",
                                            children: "Feature requests, bugs, discussions"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


var $14c232b27ec1fd04$var$A = Object.defineProperty, $14c232b27ec1fd04$var$h = Object.defineProperties;
var $14c232b27ec1fd04$var$Z = Object.getOwnPropertyDescriptors;
var $14c232b27ec1fd04$var$m = Object.getOwnPropertySymbols;
var $14c232b27ec1fd04$var$o = Object.prototype.hasOwnProperty, $14c232b27ec1fd04$var$d = Object.prototype.propertyIsEnumerable;
var $14c232b27ec1fd04$var$n = (t, a, l)=>a in t ? $14c232b27ec1fd04$var$A(t, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[a] = l, $14c232b27ec1fd04$var$r = (t, a)=>{
    for(var l in a || (a = {}))$14c232b27ec1fd04$var$o.call(a, l) && $14c232b27ec1fd04$var$n(t, l, a[l]);
    if ($14c232b27ec1fd04$var$m) for (var l of $14c232b27ec1fd04$var$m(a))$14c232b27ec1fd04$var$d.call(a, l) && $14c232b27ec1fd04$var$n(t, l, a[l]);
    return t;
}, $14c232b27ec1fd04$var$c = (t, a)=>$14c232b27ec1fd04$var$h(t, $14c232b27ec1fd04$var$Z(a));
const $14c232b27ec1fd04$var$u = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M160,36A92.09,92.09,0,0,0,79,84.36,68,68,0,1,0,72,220h88a92,92,0,0,0,0-184Zm0,160H72a44,44,0,0,1-1.82-88A91.86,91.86,0,0,0,68,128a12,12,0,0,0,24,0,68,68,0,1,1,68,68Zm40.49-92.49a12,12,0,0,1,0,17l-48,48a12,12,0,0,1-17,0l-24-24a12,12,0,1,1,17-17L144,143l39.51-39.52A12,12,0,0,1,200.49,103.51Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M240,128a80,80,0,0,1-80,80H72A56,56,0,1,1,85.92,97.74l0,.1A80,80,0,0,1,240,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M160,40A88.09,88.09,0,0,0,81.29,88.67,64,64,0,1,0,72,216h88a88,88,0,0,0,0-176Zm0,160H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.11A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,72,72Zm37.66-93.66a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L144,148.69l42.34-42.35A8,8,0,0,1,197.66,106.34Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M247.93,124.52C246.11,77.54,207.07,40,160.06,40A88.1,88.1,0,0,0,81.29,88.67h0A87.48,87.48,0,0,0,72,127.73,8.18,8.18,0,0,1,64.57,136,8,8,0,0,1,56,128a103.66,103.66,0,0,1,5.34-32.92,4,4,0,0,0-4.75-5.18A64.09,64.09,0,0,0,8,152c0,35.19,29.75,64,65,64H160A88.09,88.09,0,0,0,247.93,124.52Zm-50.27-6.86-48,48a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L144,148.69l42.34-42.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M160,42A86.11,86.11,0,0,0,82.43,90.88,62,62,0,1,0,72,214h88a86,86,0,0,0,0-172Zm0,160H72a50,50,0,0,1,0-100,50.67,50.67,0,0,1,5.91.35A85.61,85.61,0,0,0,74,128a6,6,0,0,0,12,0,74,74,0,1,1,74,74Zm36.24-94.24a6,6,0,0,1,0,8.48l-48,48a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L144,151.51l43.76-43.75A6,6,0,0,1,196.24,107.76Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M160,40A88.09,88.09,0,0,0,81.29,88.67,64,64,0,1,0,72,216h88a88,88,0,0,0,0-176Zm0,160H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.11A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,72,72Zm37.66-93.66a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L144,148.69l42.34-42.35A8,8,0,0,1,197.66,106.34Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M160,44A84.11,84.11,0,0,0,83.59,93.12,60.71,60.71,0,0,0,72,92a60,60,0,0,0,0,120h88a84,84,0,0,0,0-168Zm0,160H72a52,52,0,1,1,8.55-103.3A83.66,83.66,0,0,0,76,128a4,4,0,0,0,8,0,76,76,0,1,1,76,76Zm34.83-94.83a4,4,0,0,1,0,5.66l-48,48a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L144,154.34l45.17-45.17A4,4,0,0,1,194.83,109.17Z"
        }))
    ]
]), $14c232b27ec1fd04$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $14c232b27ec1fd04$var$c($14c232b27ec1fd04$var$r({
        ref: a
    }, t), {
        weights: $14c232b27ec1fd04$var$u
    })));
$14c232b27ec1fd04$export$2e2bcd8739ae039.displayName = "CloudCheck";


var $acw62 = parcelRequire("acw62");


var $2919880f556a2439$var$r = Object.defineProperty, $2919880f556a2439$var$A = Object.defineProperties;
var $2919880f556a2439$var$Z = Object.getOwnPropertyDescriptors;
var $2919880f556a2439$var$m = Object.getOwnPropertySymbols;
var $2919880f556a2439$var$h = Object.prototype.hasOwnProperty, $2919880f556a2439$var$c = Object.prototype.propertyIsEnumerable;
var $2919880f556a2439$var$H = (t, a, l)=>a in t ? $2919880f556a2439$var$r(t, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[a] = l, $2919880f556a2439$var$n = (t, a)=>{
    for(var l in a || (a = {}))$2919880f556a2439$var$h.call(a, l) && $2919880f556a2439$var$H(t, l, a[l]);
    if ($2919880f556a2439$var$m) for (var l of $2919880f556a2439$var$m(a))$2919880f556a2439$var$c.call(a, l) && $2919880f556a2439$var$H(t, l, a[l]);
    return t;
}, $2919880f556a2439$var$V = (t, a)=>$2919880f556a2439$var$A(t, $2919880f556a2439$var$Z(a));
const $2919880f556a2439$var$p = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M176,12H80A28,28,0,0,0,52,40V216a28,28,0,0,0,28,28h96a28,28,0,0,0,28-28V40A28,28,0,0,0,176,12ZM76,76H180V180H76Zm4-40h96a4,4,0,0,1,4,4V52H76V40A4,4,0,0,1,80,36Zm96,184H80a4,4,0,0,1-4-4V204H180v12A4,4,0,0,1,176,220Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M192,56V200H64V56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16ZM72,64H184V192H72Zm8-32h96a8,8,0,0,1,8,8v8H72V40A8,8,0,0,1,80,32Zm96,192H80a8,8,0,0,1-8-8v-8H184v8A8,8,0,0,1,176,224Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16ZM80,32h96a8,8,0,0,1,8,8v8H72V40A8,8,0,0,1,80,32Zm96,192H80a8,8,0,0,1-8-8v-8H184v8A8,8,0,0,1,176,224Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M176,18H80A22,22,0,0,0,58,40V216a22,22,0,0,0,22,22h96a22,22,0,0,0,22-22V40A22,22,0,0,0,176,18ZM70,62H186V194H70ZM80,30h96a10,10,0,0,1,10,10V50H70V40A10,10,0,0,1,80,30Zm96,196H80a10,10,0,0,1-10-10V206H186v10A10,10,0,0,1,176,226Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16ZM72,64H184V192H72Zm8-32h96a8,8,0,0,1,8,8v8H72V40A8,8,0,0,1,80,32Zm96,192H80a8,8,0,0,1-8-8v-8H184v8A8,8,0,0,1,176,224Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M176,20H80A20,20,0,0,0,60,40V216a20,20,0,0,0,20,20h96a20,20,0,0,0,20-20V40A20,20,0,0,0,176,20ZM68,60H188V196H68ZM80,28h96a12,12,0,0,1,12,12V52H68V40A12,12,0,0,1,80,28Zm96,200H80a12,12,0,0,1-12-12V204H188v12A12,12,0,0,1,176,228Z"
        }))
    ]
]), $2919880f556a2439$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $2919880f556a2439$var$V($2919880f556a2439$var$n({
        ref: a
    }, t), {
        weights: $2919880f556a2439$var$p
    })));
$2919880f556a2439$export$2e2bcd8739ae039.displayName = "DeviceMobile";


var $acw62 = parcelRequire("acw62");


var $23b4a1964f570797$var$r = Object.defineProperty, $23b4a1964f570797$var$A = Object.defineProperties;
var $23b4a1964f570797$var$Z = Object.getOwnPropertyDescriptors;
var $23b4a1964f570797$var$m = Object.getOwnPropertySymbols;
var $23b4a1964f570797$var$V = Object.prototype.hasOwnProperty, $23b4a1964f570797$var$c = Object.prototype.propertyIsEnumerable;
var $23b4a1964f570797$var$H = (t, e, l)=>e in t ? $23b4a1964f570797$var$r(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[e] = l, $23b4a1964f570797$var$h = (t, e)=>{
    for(var l in e || (e = {}))$23b4a1964f570797$var$V.call(e, l) && $23b4a1964f570797$var$H(t, l, e[l]);
    if ($23b4a1964f570797$var$m) for (var l of $23b4a1964f570797$var$m(e))$23b4a1964f570797$var$c.call(e, l) && $23b4a1964f570797$var$H(t, l, e[l]);
    return t;
}, $23b4a1964f570797$var$n = (t, e)=>$23b4a1964f570797$var$A(t, $23b4a1964f570797$var$Z(e));
const $23b4a1964f570797$var$p = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216.49,79.52l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.52ZM160,57l23,23H160ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Zm112-80a12,12,0,0,1-12,12H96a12,12,0,0,1,0-24h64A12,12,0,0,1,172,132Zm0,40a12,12,0,0,1-12,12H96a12,12,0,0,1,0-24h64A12,12,0,0,1,172,172Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,88H152V32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-32-80a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,136Zm0,32a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,168Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,176H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm-8-56V44l44,44Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Zm-34-82a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,136Zm0,32a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,168Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-32-80a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,136Zm0,32a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,168Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Zm-36-84a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,136Zm0,32a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,168Z"
        }))
    ]
]), $23b4a1964f570797$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $23b4a1964f570797$var$n($23b4a1964f570797$var$h({
        ref: e
    }, t), {
        weights: $23b4a1964f570797$var$p
    })));
$23b4a1964f570797$export$2e2bcd8739ae039.displayName = "FileText";


var $acw62 = parcelRequire("acw62");


var $26d7a770d1c2ac27$var$m = Object.defineProperty, $26d7a770d1c2ac27$var$H = Object.defineProperties;
var $26d7a770d1c2ac27$var$h = Object.getOwnPropertyDescriptors;
var $26d7a770d1c2ac27$var$v = Object.getOwnPropertySymbols;
var $26d7a770d1c2ac27$var$c = Object.prototype.hasOwnProperty, $26d7a770d1c2ac27$var$o = Object.prototype.propertyIsEnumerable;
var $26d7a770d1c2ac27$var$l = (t, e, A)=>e in t ? $26d7a770d1c2ac27$var$m(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: A
    }) : t[e] = A, $26d7a770d1c2ac27$var$n = (t, e)=>{
    for(var A in e || (e = {}))$26d7a770d1c2ac27$var$c.call(e, A) && $26d7a770d1c2ac27$var$l(t, A, e[A]);
    if ($26d7a770d1c2ac27$var$v) for (var A of $26d7a770d1c2ac27$var$v(e))$26d7a770d1c2ac27$var$o.call(e, A) && $26d7a770d1c2ac27$var$l(t, A, e[A]);
    return t;
}, $26d7a770d1c2ac27$var$r = (t, e)=>$26d7a770d1c2ac27$var$H(t, $26d7a770d1c2ac27$var$h(e));
const $26d7a770d1c2ac27$var$M = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M212.62,75.17A63.7,63.7,0,0,0,206.39,26,12,12,0,0,0,196,20a63.71,63.71,0,0,0-50,24H126A63.71,63.71,0,0,0,76,20a12,12,0,0,0-10.39,6,63.7,63.7,0,0,0-6.23,49.17A61.5,61.5,0,0,0,52,104v8a60.1,60.1,0,0,0,45.76,58.28A43.66,43.66,0,0,0,92,192v4H76a20,20,0,0,1-20-20,44.05,44.05,0,0,0-44-44,12,12,0,0,0,0,24,20,20,0,0,1,20,20,44.05,44.05,0,0,0,44,44H92v12a12,12,0,0,0,24,0V192a20,20,0,0,1,40,0v40a12,12,0,0,0,24,0V192a43.66,43.66,0,0,0-5.76-21.72A60.1,60.1,0,0,0,220,112v-8A61.5,61.5,0,0,0,212.62,75.17ZM196,112a36,36,0,0,1-36,36H112a36,36,0,0,1-36-36v-8a37.87,37.87,0,0,1,6.13-20.12,11.65,11.65,0,0,0,1.58-11.49,39.9,39.9,0,0,1-.4-27.72,39.87,39.87,0,0,1,26.41,17.8A12,12,0,0,0,119.82,68h32.35a12,12,0,0,0,10.11-5.53,39.84,39.84,0,0,1,26.41-17.8,39.9,39.9,0,0,1-.4,27.72,12,12,0,0,0,1.61,11.53A37.85,37.85,0,0,1,196,104Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,104v8a48,48,0,0,1-48,48H136a32,32,0,0,1,32,32v40H104V192a32,32,0,0,1,32-32H112a48,48,0,0,1-48-48v-8a49.28,49.28,0,0,1,8.51-27.3A51.92,51.92,0,0,1,76,32a52,52,0,0,1,43.83,24h32.34A52,52,0,0,1,196,32a51.92,51.92,0,0,1,3.49,44.7A49.28,49.28,0,0,1,208,104Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208.3,75.68A59.74,59.74,0,0,0,202.93,28,8,8,0,0,0,196,24a59.75,59.75,0,0,0-48,24H124A59.75,59.75,0,0,0,76,24a8,8,0,0,0-6.93,4,59.78,59.78,0,0,0-5.38,47.68A58.14,58.14,0,0,0,56,104v8a56.06,56.06,0,0,0,48.44,55.47A39.8,39.8,0,0,0,96,192v8H72a24,24,0,0,1-24-24A40,40,0,0,0,8,136a8,8,0,0,0,0,16,24,24,0,0,1,24,24,40,40,0,0,0,40,40H96v16a8,8,0,0,0,16,0V192a24,24,0,0,1,48,0v40a8,8,0,0,0,16,0V192a39.8,39.8,0,0,0-8.44-24.53A56.06,56.06,0,0,0,216,112v-8A58,58,0,0,0,208.3,75.68ZM200,112a40,40,0,0,1-40,40H112a40,40,0,0,1-40-40v-8a41.74,41.74,0,0,1,6.9-22.48A8,8,0,0,0,80,73.83a43.81,43.81,0,0,1,.79-33.58,43.88,43.88,0,0,1,32.32,20.06A8,8,0,0,0,119.82,64h32.35a8,8,0,0,0,6.74-3.69,43.87,43.87,0,0,1,32.32-20.06A43.81,43.81,0,0,1,192,73.83a8.09,8.09,0,0,0,1,7.65A41.76,41.76,0,0,1,200,104Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,104v8a56.06,56.06,0,0,1-48.44,55.47A39.8,39.8,0,0,1,176,192v40a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V216H72a40,40,0,0,1-40-40A24,24,0,0,0,8,152a8,8,0,0,1,0-16,40,40,0,0,1,40,40,24,24,0,0,0,24,24H96v-8a39.8,39.8,0,0,1,8.44-24.53A56.06,56.06,0,0,1,56,112v-8a58.14,58.14,0,0,1,7.69-28.32A59.78,59.78,0,0,1,69.07,28,8,8,0,0,1,76,24a59.75,59.75,0,0,1,48,24h24a59.75,59.75,0,0,1,48-24,8,8,0,0,1,6.93,4,59.74,59.74,0,0,1,5.37,47.68A58,58,0,0,1,216,104Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M206.13,75.92A57.79,57.79,0,0,0,201.2,29a6,6,0,0,0-5.2-3,57.77,57.77,0,0,0-47,24H123A57.77,57.77,0,0,0,76,26a6,6,0,0,0-5.2,3,57.79,57.79,0,0,0-4.93,46.92A55.88,55.88,0,0,0,58,104v8a54.06,54.06,0,0,0,50.45,53.87A37.85,37.85,0,0,0,98,192v10H72a26,26,0,0,1-26-26A38,38,0,0,0,8,138a6,6,0,0,0,0,12,26,26,0,0,1,26,26,38,38,0,0,0,38,38H98v18a6,6,0,0,0,12,0V192a26,26,0,0,1,52,0v40a6,6,0,0,0,12,0V192a37.85,37.85,0,0,0-10.45-26.13A54.06,54.06,0,0,0,214,112v-8A55.88,55.88,0,0,0,206.13,75.92ZM202,112a42,42,0,0,1-42,42H112a42,42,0,0,1-42-42v-8a43.86,43.86,0,0,1,7.3-23.69,6,6,0,0,0,.81-5.76,45.85,45.85,0,0,1,1.43-36.42,45.85,45.85,0,0,1,35.23,21.1A6,6,0,0,0,119.83,62h32.34a6,6,0,0,0,5.06-2.76,45.83,45.83,0,0,1,35.23-21.11,45.85,45.85,0,0,1,1.43,36.42,6,6,0,0,0,.79,5.74A43.78,43.78,0,0,1,202,104Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208.31,75.68A59.78,59.78,0,0,0,202.93,28,8,8,0,0,0,196,24a59.75,59.75,0,0,0-48,24H124A59.75,59.75,0,0,0,76,24a8,8,0,0,0-6.93,4,59.78,59.78,0,0,0-5.38,47.68A58.14,58.14,0,0,0,56,104v8a56.06,56.06,0,0,0,48.44,55.47A39.8,39.8,0,0,0,96,192v8H72a24,24,0,0,1-24-24A40,40,0,0,0,8,136a8,8,0,0,0,0,16,24,24,0,0,1,24,24,40,40,0,0,0,40,40H96v16a8,8,0,0,0,16,0V192a24,24,0,0,1,48,0v40a8,8,0,0,0,16,0V192a39.8,39.8,0,0,0-8.44-24.53A56.06,56.06,0,0,0,216,112v-8A58.14,58.14,0,0,0,208.31,75.68ZM200,112a40,40,0,0,1-40,40H112a40,40,0,0,1-40-40v-8a41.74,41.74,0,0,1,6.9-22.48A8,8,0,0,0,80,73.83a43.81,43.81,0,0,1,.79-33.58,43.88,43.88,0,0,1,32.32,20.06A8,8,0,0,0,119.82,64h32.35a8,8,0,0,0,6.74-3.69,43.87,43.87,0,0,1,32.32-20.06A43.81,43.81,0,0,1,192,73.83a8.09,8.09,0,0,0,1,7.65A41.72,41.72,0,0,1,200,104Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M203.94,76.16A55.73,55.73,0,0,0,199.46,30,4,4,0,0,0,196,28a55.78,55.78,0,0,0-46,24H122A55.78,55.78,0,0,0,76,28a4,4,0,0,0-3.46,2,55.73,55.73,0,0,0-4.48,46.16A53.78,53.78,0,0,0,60,104v8a52.06,52.06,0,0,0,52,52h1.41A36,36,0,0,0,100,192v12H72a28,28,0,0,1-28-28A36,36,0,0,0,8,140a4,4,0,0,0,0,8,28,28,0,0,1,28,28,36,36,0,0,0,36,36h28v20a4,4,0,0,0,8,0V192a28,28,0,0,1,56,0v40a4,4,0,0,0,8,0V192a36,36,0,0,0-13.41-28H160a52.06,52.06,0,0,0,52-52v-8A53.78,53.78,0,0,0,203.94,76.16ZM204,112a44.05,44.05,0,0,1-44,44H112a44.05,44.05,0,0,1-44-44v-8a45.76,45.76,0,0,1,7.71-24.89,4,4,0,0,0,.53-3.84,47.82,47.82,0,0,1,2.1-39.21,47.8,47.8,0,0,1,38.12,22.1A4,4,0,0,0,119.83,60h32.34a4,4,0,0,0,3.37-1.84,47.8,47.8,0,0,1,38.12-22.1,47.82,47.82,0,0,1,2.1,39.21,4,4,0,0,0,.53,3.83A45.85,45.85,0,0,1,204,104Z"
        }))
    ]
]), $26d7a770d1c2ac27$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $26d7a770d1c2ac27$var$r($26d7a770d1c2ac27$var$n({
        ref: e
    }, t), {
        weights: $26d7a770d1c2ac27$var$M
    })));
$26d7a770d1c2ac27$export$2e2bcd8739ae039.displayName = "GithubLogo";


var $acw62 = parcelRequire("acw62");


var $a4da17066235214a$var$l = Object.defineProperty, $a4da17066235214a$var$h = Object.defineProperties;
var $a4da17066235214a$var$n = Object.getOwnPropertyDescriptors;
var $a4da17066235214a$var$m = Object.getOwnPropertySymbols;
var $a4da17066235214a$var$r = Object.prototype.hasOwnProperty, $a4da17066235214a$var$c = Object.prototype.propertyIsEnumerable;
var $a4da17066235214a$var$A = (Z, e, t)=>e in Z ? $a4da17066235214a$var$l(Z, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : Z[e] = t, $a4da17066235214a$var$H = (Z, e)=>{
    for(var t in e || (e = {}))$a4da17066235214a$var$r.call(e, t) && $a4da17066235214a$var$A(Z, t, e[t]);
    if ($a4da17066235214a$var$m) for (var t of $a4da17066235214a$var$m(e))$a4da17066235214a$var$c.call(e, t) && $a4da17066235214a$var$A(Z, t, e[t]);
    return Z;
}, $a4da17066235214a$var$M = (Z, e)=>$a4da17066235214a$var$h(Z, $a4da17066235214a$var$n(e));
const $a4da17066235214a$var$E = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20ZM107.07,172h41.86A115.75,115.75,0,0,1,128,209.85,115.75,115.75,0,0,1,107.07,172Zm-5.66-24a142.55,142.55,0,0,1,0-40h53.18a142.55,142.55,0,0,1,0,40ZM44,128a83.49,83.49,0,0,1,2.43-20H77.22a164.54,164.54,0,0,0,0,40H46.43A83.49,83.49,0,0,1,44,128ZM148.93,84H107.07A115.75,115.75,0,0,1,128,46.15,115.75,115.75,0,0,1,148.93,84Zm29.85,24h30.79a83.52,83.52,0,0,1,0,40H178.78a164.54,164.54,0,0,0,0-40Zm20.74-24H174a148.59,148.59,0,0,0-13.95-33.63A84.5,84.5,0,0,1,199.52,84ZM96,50.37A148.59,148.59,0,0,0,82,84H56.48A84.5,84.5,0,0,1,96,50.37ZM56.48,172H82a148.59,148.59,0,0,0,14,33.63A84.5,84.5,0,0,1,56.48,172Zm103.57,33.63A148.59,148.59,0,0,0,174,172h25.52A84.5,84.5,0,0,1,160.05,205.63Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM101.63,168h52.74C149,186.34,140,202.87,128,215.89,116,202.87,107,186.34,101.63,168ZM98,152a145.72,145.72,0,0,1,0-48h60a145.72,145.72,0,0,1,0,48ZM40,128a87.61,87.61,0,0,1,3.33-24H81.79a161.79,161.79,0,0,0,0,48H43.33A87.61,87.61,0,0,1,40,128ZM154.37,88H101.63C107,69.66,116,53.13,128,40.11,140,53.13,149,69.66,154.37,88Zm19.84,16h38.46a88.15,88.15,0,0,1,0,48H174.21a161.79,161.79,0,0,0,0-48Zm32.16-16H170.94a142.39,142.39,0,0,0-20.26-45A88.37,88.37,0,0,1,206.37,88ZM105.32,43A142.39,142.39,0,0,0,85.06,88H49.63A88.37,88.37,0,0,1,105.32,43ZM49.63,168H85.06a142.39,142.39,0,0,0,20.26,45A88.37,88.37,0,0,1,49.63,168Zm101.05,45a142.39,142.39,0,0,0,20.26-45h35.43A88.37,88.37,0,0,1,150.68,213Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm78.37,64H170.94a142.39,142.39,0,0,0-20.26-45A88.37,88.37,0,0,1,206.37,88ZM128,40.11c12,13,21,29.55,26.37,47.89H101.63C107,69.66,116,53.13,128,40.11ZM96,128a145.29,145.29,0,0,1,2-24h60a145.72,145.72,0,0,1,0,48H98A145.29,145.29,0,0,1,96,128Zm5.63,40h52.74C149,186.34,140,202.87,128,215.89,116,202.87,107,186.34,101.63,168Zm49.05,45a142.39,142.39,0,0,0,20.26-45h35.43A88.37,88.37,0,0,1,150.68,213Zm23.53-61a161.79,161.79,0,0,0,0-48h38.46a88.15,88.15,0,0,1,0,48Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm81.57,64H169.39a139.15,139.15,0,0,0-23.45-50.2A90.32,90.32,0,0,1,209.57,90ZM218,128a89.7,89.7,0,0,1-3.83,26H171.86a159,159,0,0,0,0-52h42.31A89.7,89.7,0,0,1,218,128Zm-90,90a1.75,1.75,0,0,1-1.32-.59C113.8,203.54,104.34,185.73,99,166h58c-5.34,19.73-14.8,37.54-27.68,51.41A1.75,1.75,0,0,1,128,218ZM96.31,154a147.48,147.48,0,0,1,0-52h63.38a147.48,147.48,0,0,1,0,52ZM38,128a89.7,89.7,0,0,1,3.83-26H84.14a159,159,0,0,0,0,52H41.83A89.7,89.7,0,0,1,38,128Zm90-90a1.75,1.75,0,0,1,1.32.59C142.2,52.46,151.66,70.27,157,90H99c5.34-19.73,14.8-37.54,27.68-51.41A1.75,1.75,0,0,1,128,38Zm-17.94,1.8A139.15,139.15,0,0,0,86.61,90H46.43A90.32,90.32,0,0,1,110.06,39.8ZM46.43,166H86.61a139.15,139.15,0,0,0,23.45,50.2A90.32,90.32,0,0,1,46.43,166Zm99.51,50.2A139.15,139.15,0,0,0,169.39,166h40.18A90.32,90.32,0,0,1,145.94,216.2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM101.63,168h52.74C149,186.34,140,202.87,128,215.89,116,202.87,107,186.34,101.63,168ZM98,152a145.72,145.72,0,0,1,0-48h60a145.72,145.72,0,0,1,0,48ZM40,128a87.61,87.61,0,0,1,3.33-24H81.79a161.79,161.79,0,0,0,0,48H43.33A87.61,87.61,0,0,1,40,128ZM154.37,88H101.63C107,69.66,116,53.13,128,40.11,140,53.13,149,69.66,154.37,88Zm19.84,16h38.46a88.15,88.15,0,0,1,0,48H174.21a161.79,161.79,0,0,0,0-48Zm32.16-16H170.94a142.39,142.39,0,0,0-20.26-45A88.37,88.37,0,0,1,206.37,88ZM105.32,43A142.39,142.39,0,0,0,85.06,88H49.63A88.37,88.37,0,0,1,105.32,43ZM49.63,168H85.06a142.39,142.39,0,0,0,20.26,45A88.37,88.37,0,0,1,49.63,168Zm101.05,45a142.39,142.39,0,0,0,20.26-45h35.43A88.37,88.37,0,0,1,150.68,213Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm87.64,128H169.49a157.43,157.43,0,0,0,0-56h46.15a92.09,92.09,0,0,1,0,56ZM128,220a3.76,3.76,0,0,1-2.78-1.23c-13.65-14.7-23.52-33.72-28.81-54.77h63.18c-5.29,21.05-15.16,40.07-28.81,54.77A3.76,3.76,0,0,1,128,220ZM94.65,156a149.25,149.25,0,0,1,0-56h66.7a149.25,149.25,0,0,1,0,56ZM128,36a3.76,3.76,0,0,1,2.78,1.23C144.43,51.93,154.3,71,159.59,92H96.41c5.29-21,15.16-40.07,28.81-54.77A3.76,3.76,0,0,1,128,36Zm84.66,56H167.81c-4.91-20.73-14-39.72-26.66-55.06A92.3,92.3,0,0,1,212.66,92ZM114.85,36.94C102.22,52.28,93.1,71.27,88.19,92H43.34A92.3,92.3,0,0,1,114.85,36.94ZM40.36,100H86.51a157.43,157.43,0,0,0,0,56H40.36a92.09,92.09,0,0,1,0-56Zm3,64H88.19c4.91,20.73,14,39.72,26.66,55.06A92.3,92.3,0,0,1,43.34,164Zm97.81,55.06c12.63-15.34,21.75-34.33,26.66-55.06h44.85A92.3,92.3,0,0,1,141.15,219.06Z"
        }))
    ]
]), $a4da17066235214a$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((Z, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $a4da17066235214a$var$M($a4da17066235214a$var$H({
        ref: e
    }, Z), {
        weights: $a4da17066235214a$var$E
    })));
$a4da17066235214a$export$2e2bcd8739ae039.displayName = "Globe";


var $acw62 = parcelRequire("acw62");


var $1f0d0c76fe0c1fd0$var$A = Object.defineProperty, $1f0d0c76fe0c1fd0$var$Z = Object.defineProperties;
var $1f0d0c76fe0c1fd0$var$M = Object.getOwnPropertyDescriptors;
var $1f0d0c76fe0c1fd0$var$c = Object.getOwnPropertySymbols;
var $1f0d0c76fe0c1fd0$var$d = Object.prototype.hasOwnProperty, $1f0d0c76fe0c1fd0$var$o = Object.prototype.propertyIsEnumerable;
var $1f0d0c76fe0c1fd0$var$n = (e, l, t)=>l in e ? $1f0d0c76fe0c1fd0$var$A(e, l, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[l] = t, $1f0d0c76fe0c1fd0$var$m = (e, l)=>{
    for(var t in l || (l = {}))$1f0d0c76fe0c1fd0$var$d.call(l, t) && $1f0d0c76fe0c1fd0$var$n(e, t, l[t]);
    if ($1f0d0c76fe0c1fd0$var$c) for (var t of $1f0d0c76fe0c1fd0$var$c(l))$1f0d0c76fe0c1fd0$var$o.call(l, t) && $1f0d0c76fe0c1fd0$var$n(e, t, l[t]);
    return e;
}, $1f0d0c76fe0c1fd0$var$r = (e, l)=>$1f0d0c76fe0c1fd0$var$Z(e, $1f0d0c76fe0c1fd0$var$M(l));
const $1f0d0c76fe0c1fd0$var$L = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M81.61,247.27a12,12,0,0,1-16.8,2.41A131.23,131.23,0,0,1,29.67,210a12,12,0,1,1,20.79-12,107.45,107.45,0,0,0,28.73,32.48A12,12,0,0,1,81.61,247.27ZM223.66,98A92,92,0,0,1,64.31,190l-38-65.82A32,32,0,0,1,45.46,77.33L45,76.46A32,32,0,0,1,81,29.55,31.7,31.7,0,0,1,90.62,34,32,32,0,0,1,143,38.31L155.52,60a32,32,0,0,1,50.14,6.84Zm-20.78,12-18-31.18a8,8,0,0,0-13.87,8h0l10,17.31a12,12,0,0,1-4.39,16.39,28,28,0,0,0-10.25,38.25,12,12,0,0,1-20.79,12A52.09,52.09,0,0,1,154.93,107L122.24,50.31a8,8,0,0,0-13.86,8l26,45a12,12,0,0,1-20.79,12l-34-58.89a8,8,0,0,0-10.92-2.93,8,8,0,0,0-2.93,10.93l38,65.81a12,12,0,1,1-20.79,12l-22-38.1a8,8,0,1,0-13.85,8L85.1,178a68,68,0,0,0,117.78-68ZM240.3,46.81a71.5,71.5,0,0,0-43.72-33.55,12,12,0,0,0-6.21,23.19,47.65,47.65,0,0,1,29.15,22.36,12,12,0,1,0,20.78-12Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M213.27,104l-18-31.18a20,20,0,0,0-34.64,20l-28-48.5A20,20,0,0,0,98,64.31L90,50.46a20,20,0,0,0-34.64,20l12,20.83-1.17,1A20,20,0,0,0,36.7,118.17L74.7,184a80,80,0,0,0,138.57-80Zm-57.59,60.64.17-.1.14.24Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M220.2,100l-18-31.18a28,28,0,0,0-47.3-1.92L139.56,40.31a28,28,0,0,0-48.12-.63,28,28,0,0,0-43,34.78l3.34,5.79a28,28,0,0,0-22,41.92l38,65.82a87.46,87.46,0,0,0,53.43,41,88.56,88.56,0,0,0,22.92,3A88,88,0,0,0,220.2,100Zm-6.67,62.63A72,72,0,0,1,81.63,180l-38-65.82a12,12,0,0,1,20.79-12l22,38.1a8,8,0,1,0,13.85-8l-38-65.81a12,12,0,0,1,13.5-17.59,11.9,11.9,0,0,1,7.29,5.59l34,58.89a8,8,0,0,0,13.85-8l-26-45h0a12,12,0,0,1,20.78-12L160,107.78a48.08,48.08,0,0,0-11,61,8,8,0,0,0,13.86-8,32,32,0,0,1,11.71-43.71,8,8,0,0,0,2.93-10.93l-10-17.32a12,12,0,0,1,20.78-12l18,31.18A71.49,71.49,0,0,1,213.53,162.62ZM184.27,29.93a8,8,0,0,1,9.8-5.66c15.91,4.27,29,14.11,36.86,27.73a8,8,0,0,1-13.86,8c-5.72-9.92-15.36-17.12-27.14-20.27A8,8,0,0,1,184.27,29.93ZM80.91,237a8,8,0,0,1-11.24,1.33c-11-8.69-20.11-19.58-28.6-34.28a8,8,0,0,1,13.86-8c7.44,12.88,15.27,22.32,24.65,29.72A8,8,0,0,1,80.91,237Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M184.27,29.93a8,8,0,0,1,9.8-5.66c15.9,4.27,29,14.11,36.86,27.73a8,8,0,0,1-13.86,8c-5.72-9.92-15.36-17.12-27.14-20.27A8,8,0,0,1,184.27,29.93ZM79.58,225.72c-9.38-7.4-17.22-16.84-24.65-29.72a8,8,0,0,0-13.86,8c8.49,14.7,17.57,25.59,28.6,34.28a8,8,0,0,0,9.91-12.56ZM196.19,58.42a16,16,0,1,0-27.71,16l16,27.71a8,8,0,0,1-2.93,10.93,32,32,0,0,0-11.71,43.71,8,8,0,0,1-13.86,8,48.07,48.07,0,0,1,11-61L126.63,33.92a16,16,0,0,0-27.72,16l32,55.43a8,8,0,0,1-13.85,8l-40-69.29a16,16,0,0,0-27.72,16l44,76.21a8,8,0,1,1-13.85,8l-28-48.49a16,16,0,1,0-27.72,16l44,76.21a88,88,0,0,0,152.42-88Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M186.2,30.45a6,6,0,0,1,7.35-4.24c15.39,4.12,28,13.64,35.65,26.79a6,6,0,0,1-10.4,6c-6-10.38-16.06-17.91-28.35-21.2A6,6,0,0,1,186.2,30.45ZM78.34,227.29C68.75,219.73,60.76,210.11,53.2,197a6,6,0,0,0-10.4,6c8.36,14.47,17.29,25.18,28.11,33.71a6,6,0,1,0,7.43-9.42Zm148.72-61A86.12,86.12,0,0,1,144.13,230a86.71,86.71,0,0,1-22.4-3A85.45,85.45,0,0,1,69.51,187l-38-65.82a26,26,0,0,1,23.68-39l-5-8.73A26,26,0,0,1,91.92,43a26,26,0,0,1,45.9-1.67l17.05,29.52a26,26,0,0,1,45.59-1l18,31.18A85.45,85.45,0,0,1,227.06,166.25Zm-19-59.26-18-31.18a14,14,0,1,0-24.25,14l10,17.32a6,6,0,0,1-2.19,8.2,34,34,0,0,0-12.45,46.44,6,6,0,1,1-10.39,6,46.08,46.08,0,0,1,11.84-59.5l-35.2-61a14,14,0,0,0-24.25,14l26,45a6,6,0,1,1-10.39,6l-34-58.89a14,14,0,1,0-24.25,14l38,65.81a6,6,0,1,1-10.39,6l-22-38.1a14,14,0,1,0-24.25,14L79.9,181a74,74,0,0,0,128.17-74Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M220.2,100l-18-31.18a28,28,0,0,0-47.3-1.92L139.56,40.31a28,28,0,0,0-48.12-.63,28,28,0,0,0-43,34.78l3.34,5.79a28,28,0,0,0-22,41.92l38,65.82a87.46,87.46,0,0,0,53.43,41,88.56,88.56,0,0,0,22.92,3A88,88,0,0,0,220.2,100Zm-6.67,62.63A72,72,0,0,1,81.63,180l-38-65.82a12,12,0,0,1,20.79-12l22,38.1a8,8,0,1,0,13.85-8l-38-65.81a12,12,0,0,1,13.5-17.59,11.9,11.9,0,0,1,7.29,5.59l34,58.89a8,8,0,0,0,13.85-8l-26-45h0a12,12,0,0,1,20.78-12L160,107.78a48.08,48.08,0,0,0-11,61,8,8,0,0,0,13.86-8,32,32,0,0,1,11.71-43.71,8,8,0,0,0,2.93-10.93l-10-17.32a12,12,0,0,1,20.78-12l18,31.18A71.49,71.49,0,0,1,213.53,162.62ZM184.27,29.93a8,8,0,0,1,9.8-5.66c15.91,4.27,29,14.11,36.86,27.73a8,8,0,0,1-13.86,8c-5.72-9.92-15.36-17.12-27.14-20.27A8,8,0,0,1,184.27,29.93ZM80.91,237a8,8,0,0,1-11.24,1.33c-11-8.69-20.11-19.58-28.6-34.28a8,8,0,0,1,13.86-8c7.44,12.88,15.27,22.32,24.65,29.72A8,8,0,0,1,80.91,237Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M188.14,31a4,4,0,0,1,4.9-2.83c14.87,4,27.1,13.17,34.42,25.86a4,4,0,1,1-6.92,4C214.28,47.16,203.77,39.3,191,35.86A4,4,0,0,1,188.14,31ZM77.1,228.86c-9.79-7.72-17.94-17.53-25.64-30.86a4,4,0,0,0-6.92,4c8.22,14.24,17,24.77,27.61,33.14a4,4,0,0,0,2.47.86,4,4,0,0,0,2.48-7.14Zm148-63.13a84.09,84.09,0,0,1-81,62.29,84.37,84.37,0,0,1-21.87-2.9,83.41,83.41,0,0,1-51-39.13l-38-65.82a24,24,0,0,1,25.7-35.49L51.88,72.46A24,24,0,0,1,92.48,47a24,24,0,0,1,43.61-4.64l19.08,33a24,24,0,0,1,43.56-4.54l18,31.18A83.43,83.43,0,0,1,225.12,165.73ZM209.8,106l-18-31.18a16,16,0,1,0-27.71,16l10,17.32a4,4,0,0,1-1.46,5.47,36,36,0,0,0-13.18,49.17,4,4,0,1,1-6.93,4,44.07,44.07,0,0,1,12.73-58L129.16,46.31a16,16,0,0,0-27.71,16l26,45a4,4,0,0,1-6.93,4l-34-58.89a16,16,0,1,0-27.71,16l38,65.81a4,4,0,1,1-6.93,4l-22-38.1a16,16,0,1,0-27.71,16l38,65.82A76,76,0,1,0,209.8,106Z"
        }))
    ]
]), $1f0d0c76fe0c1fd0$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((e, l)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $1f0d0c76fe0c1fd0$var$r($1f0d0c76fe0c1fd0$var$m({
        ref: l
    }, e), {
        weights: $1f0d0c76fe0c1fd0$var$L
    })));
$1f0d0c76fe0c1fd0$export$2e2bcd8739ae039.displayName = "HandWaving";


var $acw62 = parcelRequire("acw62");


var $ded3ebfcc172d710$var$Z = Object.defineProperty, $ded3ebfcc172d710$var$c = Object.defineProperties;
var $ded3ebfcc172d710$var$h = Object.getOwnPropertyDescriptors;
var $ded3ebfcc172d710$var$m = Object.getOwnPropertySymbols;
var $ded3ebfcc172d710$var$o = Object.prototype.hasOwnProperty, $ded3ebfcc172d710$var$p = Object.prototype.propertyIsEnumerable;
var $ded3ebfcc172d710$var$n = (t, a, l)=>a in t ? $ded3ebfcc172d710$var$Z(t, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[a] = l, $ded3ebfcc172d710$var$r = (t, a)=>{
    for(var l in a || (a = {}))$ded3ebfcc172d710$var$o.call(a, l) && $ded3ebfcc172d710$var$n(t, l, a[l]);
    if ($ded3ebfcc172d710$var$m) for (var l of $ded3ebfcc172d710$var$m(a))$ded3ebfcc172d710$var$p.call(a, l) && $ded3ebfcc172d710$var$n(t, l, a[l]);
    return t;
}, $ded3ebfcc172d710$var$A = (t, a)=>$ded3ebfcc172d710$var$c(t, $ded3ebfcc172d710$var$h(a));
const $ded3ebfcc172d710$var$L = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm0-144a44,44,0,0,0-32.94,73.16l-9.92,24.92A16,16,0,0,0,100,188h56a16,16,0,0,0,14.86-21.92l-9.92-24.92A44,44,0,0,0,128,68Zm7.59,74.38L144.2,164H111.8l8.61-21.62a12,12,0,0,0-4.11-14.16,20,20,0,1,1,23.4,0A12,12,0,0,0,135.59,142.38Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M156,176H100a4,4,0,0,1-3.71-5.48l13-32.58a32,32,0,1,1,37.48,0l13,32.58A4,4,0,0,1,156,176Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm0-144a40,40,0,0,0-28.28,68.28L88.86,167.56A12,12,0,0,0,100,184h56a12,12,0,0,0,11.14-16.44l-10.86-27.28A40,40,0,0,0,128,72Zm11.31,68.9L150.1,168H105.9l10.79-27.1a8,8,0,0,0-2.74-9.44,24,24,0,1,1,28.1,0A8,8,0,0,0,139.31,140.9Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm22.58-80,12.56,31.55A12,12,0,0,1,152,184H104a12,12,0,0,1-11.14-16.44L105.42,136a36,36,0,1,1,45.16,0Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm38-106a38,38,0,1,0-63.93,27.78L90.71,168.3A10,10,0,0,0,100,182h56a10,10,0,0,0,9.29-13.7l-11.36-28.52A38.14,38.14,0,0,0,166,112Zm-22.78,21.08a6,6,0,0,0-2.06,7.08L153.05,170H103l11.89-29.84a6,6,0,0,0-2.06-7.08,26,26,0,1,1,30.44,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm0-144a40,40,0,0,0-28.28,68.28L88.86,167.56A12,12,0,0,0,100,184h56a12,12,0,0,0,11.14-16.44l-10.86-27.28A40,40,0,0,0,128,72Zm11.31,68.9L150.1,168H105.9l10.79-27.1a8,8,0,0,0-2.74-9.44,24,24,0,1,1,28.1,0A8,8,0,0,0,139.31,140.9Zm13,32.58Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm36-108a36,36,0,1,0-59.55,27.22L92.57,169A8,8,0,0,0,100,180h56a8,8,0,0,0,7.43-11l-11.88-29.82A36.11,36.11,0,0,0,164,112Zm-21,27.42L156,172H100l13-32.58a4,4,0,0,0-1.37-4.72,28,28,0,1,1,32.78,0A4,4,0,0,0,143,139.42Z"
        }))
    ]
]), $ded3ebfcc172d710$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $ded3ebfcc172d710$var$A($ded3ebfcc172d710$var$r({
        ref: a
    }, t), {
        weights: $ded3ebfcc172d710$var$L
    })));
$ded3ebfcc172d710$export$2e2bcd8739ae039.displayName = "Keyhole";


var $acw62 = parcelRequire("acw62");


var $8354377a48be5e84$var$V = Object.defineProperty, $8354377a48be5e84$var$m = Object.defineProperties;
var $8354377a48be5e84$var$c = Object.getOwnPropertyDescriptors;
var $8354377a48be5e84$var$l = Object.getOwnPropertySymbols;
var $8354377a48be5e84$var$h = Object.prototype.hasOwnProperty, $8354377a48be5e84$var$o = Object.prototype.propertyIsEnumerable;
var $8354377a48be5e84$var$n = (t, e, A)=>e in t ? $8354377a48be5e84$var$V(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: A
    }) : t[e] = A, $8354377a48be5e84$var$r = (t, e)=>{
    for(var A in e || (e = {}))$8354377a48be5e84$var$h.call(e, A) && $8354377a48be5e84$var$n(t, A, e[A]);
    if ($8354377a48be5e84$var$l) for (var A of $8354377a48be5e84$var$l(e))$8354377a48be5e84$var$o.call(e, A) && $8354377a48be5e84$var$n(t, A, e[A]);
    return t;
}, $8354377a48be5e84$var$H = (t, e)=>$8354377a48be5e84$var$m(t, $8354377a48be5e84$var$c(e));
const $8354377a48be5e84$var$E = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M222.41,155.16a12,12,0,0,0-11.56-.69A16,16,0,0,1,188,139,16.2,16.2,0,0,1,202.8,124a15.83,15.83,0,0,1,8,1.5A12,12,0,0,0,228,114.7V72a20,20,0,0,0-20-20H176a40.15,40.15,0,0,0-12.62-29.16,39.67,39.67,0,0,0-29.94-10.76,40.08,40.08,0,0,0-37.34,37C96,50.07,96,51,96,52H64A20,20,0,0,0,44,72v28a40.15,40.15,0,0,0-29.16,12.62A40,40,0,0,0,41.1,179.9a28.3,28.3,0,0,0,2.9.1v28a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V165.31A12,12,0,0,0,222.41,155.16ZM204,204H68V165.31a12,12,0,0,0-17.15-10.84A15.9,15.9,0,0,1,42.8,156,16.2,16.2,0,0,1,28,141.06a16,16,0,0,1,22.82-15.52A12,12,0,0,0,68,114.7V76h42.7a12,12,0,0,0,10.83-17.15A15.9,15.9,0,0,1,120,50.8,16.19,16.19,0,0,1,134.94,36a16,16,0,0,1,15.53,22.81A12,12,0,0,0,161.31,76H204v24c-1,0-1.93,0-2.9.11A40,40,0,0,0,204,180h0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M204,168a28,28,0,0,0,12-2.69V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V165.31a28,28,0,1,1,0-50.62V72a8,8,0,0,1,8-8h46.69a28,28,0,1,1,50.61,0H208a8,8,0,0,1,8,8v42.69A28,28,0,1,0,204,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M220.27,158.54a8,8,0,0,0-7.7-.46,20,20,0,1,1,0-36.16A8,8,0,0,0,224,114.69V72a16,16,0,0,0-16-16H171.78a35.36,35.36,0,0,0,.22-4,36.15,36.15,0,0,0-11.36-26.25,36,36,0,0,0-60.55,23.63,36.56,36.56,0,0,0,.14,6.62H64A16,16,0,0,0,48,72v32.22a35.36,35.36,0,0,0-4-.22,36.12,36.12,0,0,0-26.24,11.36,35.7,35.7,0,0,0-9.69,27,36.08,36.08,0,0,0,33.31,33.6,36.56,36.56,0,0,0,6.62-.14V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V165.31A8,8,0,0,0,220.27,158.54ZM208,208H64V165.31a8,8,0,0,0-11.43-7.23,20,20,0,1,1,0-36.16A8,8,0,0,0,64,114.69V72h46.69a8,8,0,0,0,7.23-11.43,20,20,0,1,1,36.16,0A8,8,0,0,0,161.31,72H208v32.23a35.68,35.68,0,0,0-6.62-.14A36,36,0,0,0,204,176a35.36,35.36,0,0,0,4-.22Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M165.78,224H208a16,16,0,0,0,16-16V170.35A8,8,0,0,0,212.94,163a23.37,23.37,0,0,1-8.94,1.77c-13.23,0-24-11.1-24-24.73s10.77-24.73,24-24.73a23.37,23.37,0,0,1,8.94,1.77A8,8,0,0,0,224,109.65V72a16,16,0,0,0-16-16H171.78a35.36,35.36,0,0,0,.22-4,36,36,0,0,0-72,0,35.36,35.36,0,0,0,.22,4H64A16,16,0,0,0,48,72v32.22a35.36,35.36,0,0,0-4-.22,36,36,0,0,0,0,72,35.36,35.36,0,0,0,4-.22V208a16,16,0,0,0,16,16h42.22"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M219.21,160.24a6,6,0,0,0-5.78-.35,22,22,0,1,1-11.05-41.83,22.15,22.15,0,0,1,11.05,2.06A6,6,0,0,0,222,114.7V72a14,14,0,0,0-14-14H169.48a35,35,0,0,0,.52-6,34.1,34.1,0,0,0-10.73-24.78,33.64,33.64,0,0,0-25.45-9.15A34,34,0,0,0,102.54,58H64A14,14,0,0,0,50,72v34.53a34,34,0,0,0-30.79,10.2,34,34,0,0,0,22.31,57.18,34.34,34.34,0,0,0,8.48-.44V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V165.31A6,6,0,0,0,219.21,160.24ZM210,208a2,2,0,0,1-2,2H64a2,2,0,0,1-2-2V165.31a6,6,0,0,0-6-6,5.92,5.92,0,0,0-2.57.58,22,22,0,0,1-31.38-18.46,22,22,0,0,1,31.38-21.31A6,6,0,0,0,62,114.7V72a2,2,0,0,1,2-2h46.69a6,6,0,0,0,5.42-8.57,22.25,22.25,0,0,1-2-11,22,22,0,1,1,41.83,11A6,6,0,0,0,161.3,70H208a2,2,0,0,1,2,2v34.54a34,34,0,0,0-39.93,31.28,33.71,33.71,0,0,0,9.14,25.45A34.15,34.15,0,0,0,210,173.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M220.27,158.54a8,8,0,0,0-7.7-.46,20,20,0,1,1,0-36.16A8,8,0,0,0,224,114.69V72a16,16,0,0,0-16-16H171.78a35.36,35.36,0,0,0,.22-4,36.11,36.11,0,0,0-11.36-26.24,36,36,0,0,0-60.55,23.62,36.56,36.56,0,0,0,.14,6.62H64A16,16,0,0,0,48,72v32.22a35.36,35.36,0,0,0-4-.22,36.12,36.12,0,0,0-26.24,11.36,35.7,35.7,0,0,0-9.69,27,36.08,36.08,0,0,0,33.31,33.6,35.68,35.68,0,0,0,6.62-.14V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V165.31A8,8,0,0,0,220.27,158.54ZM208,208H64V165.31a8,8,0,0,0-11.43-7.23,20,20,0,1,1,0-36.16A8,8,0,0,0,64,114.69V72h46.69a8,8,0,0,0,7.23-11.43,20,20,0,1,1,36.16,0A8,8,0,0,0,161.31,72H208v32.23a35.68,35.68,0,0,0-6.62-.14A36,36,0,0,0,204,176a35.36,35.36,0,0,0,4-.22Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M218.14,161.93a4,4,0,0,0-3.86-.24,24,24,0,0,1-34.23-23.25,24,24,0,0,1,34.23-20.13A4,4,0,0,0,220,114.7V72a12,12,0,0,0-12-12H167a32,32,0,1,0-62.91-10.33A32.57,32.57,0,0,0,105,60H64A12,12,0,0,0,52,72v37a32,32,0,1,0-10.33,62.91A32.28,32.28,0,0,0,52,171v37a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V165.31A4,4,0,0,0,218.14,161.93ZM212,208a4,4,0,0,1-4,4H64a4,4,0,0,1-4-4V165.31a4,4,0,0,0-1.86-3.38,4,4,0,0,0-3.85-.24,24,24,0,0,1-34.24-20.13,24,24,0,0,1,34.24-23.25A4,4,0,0,0,60,114.7V72a4,4,0,0,1,4-4h46.69a4,4,0,0,0,3.62-5.71,24,24,0,0,1,20.13-34.24,24,24,0,0,1,23.25,34.24A4,4,0,0,0,161.31,68H208a4,4,0,0,1,4,4v37a32.57,32.57,0,0,0-10.33-.94A32,32,0,1,0,212,171Z"
        }))
    ]
]), $8354377a48be5e84$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $8354377a48be5e84$var$H($8354377a48be5e84$var$r({
        ref: e
    }, t), {
        weights: $8354377a48be5e84$var$E
    })));
$8354377a48be5e84$export$2e2bcd8739ae039.displayName = "PuzzlePiece";


var $acw62 = parcelRequire("acw62");


var $f2ed8375f15450ed$var$m = Object.defineProperty, $f2ed8375f15450ed$var$o = Object.defineProperties;
var $f2ed8375f15450ed$var$p = Object.getOwnPropertyDescriptors;
var $f2ed8375f15450ed$var$l = Object.getOwnPropertySymbols;
var $f2ed8375f15450ed$var$E = Object.prototype.hasOwnProperty, $f2ed8375f15450ed$var$Z = Object.prototype.propertyIsEnumerable;
var $f2ed8375f15450ed$var$n = (t, a, c)=>a in t ? $f2ed8375f15450ed$var$m(t, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: c
    }) : t[a] = c, $f2ed8375f15450ed$var$r = (t, a)=>{
    for(var c in a || (a = {}))$f2ed8375f15450ed$var$E.call(a, c) && $f2ed8375f15450ed$var$n(t, c, a[c]);
    if ($f2ed8375f15450ed$var$l) for (var c of $f2ed8375f15450ed$var$l(a))$f2ed8375f15450ed$var$Z.call(a, c) && $f2ed8375f15450ed$var$n(t, c, a[c]);
    return t;
}, $f2ed8375f15450ed$var$C = (t, a)=>$f2ed8375f15450ed$var$o(t, $f2ed8375f15450ed$var$p(a));
const $f2ed8375f15450ed$var$i = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M248.9,152c-1.33-1.47-23.75-25.85-60.21-40.69-2.15-18.28-9.1-34.9-20.1-47.71C153.12,45.52,130.79,36,104,36,50.44,36,15.69,83.79,14.24,85.82a12,12,0,0,0,19.53,14C34.05,99.38,62.65,60,104,60c19.85,0,35.45,6.45,46.38,19.18a61.35,61.35,0,0,1,12.4,24A143.6,143.6,0,0,0,132.61,100c-27,0-49.79,7.13-65.85,20.63C52.3,132.79,44,149.78,44,167.25,44,193.46,63.44,220,100.61,220c51.93,0,82.34-40.28,87.87-82.43a156.46,156.46,0,0,1,42.62,30.48A12,12,0,1,0,248.9,152ZM148.37,173.74C140.09,183.9,125.09,196,100.61,196,78.08,196,68,181.56,68,167.25,68,146.42,88.22,124,132.61,124a119.85,119.85,0,0,1,32.64,4.62C164.24,145.44,158.21,161.66,148.37,173.74Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M100.6,208c-64,0-64-96,32-96a134.44,134.44,0,0,1,44.73,7.83h0C179,162.36,151.88,208,100.6,208Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M245.93,154.63c-1.32-1.46-24.09-26.22-61-40.56-1.72-18.42-8.46-35.17-19.41-47.92C150.87,49,129.58,40,104,40,52.48,40,18.89,86.18,17.49,88.15a8,8,0,0,0,13,9.31C30.8,97.05,60.81,56,104,56c20.77,0,37.86,7.11,49.41,20.57,7.42,8.64,12.44,19.69,14.67,32A140.87,140.87,0,0,0,132.6,104c-26.06,0-47.93,6.81-63.26,19.69C55.78,135.09,48,151,48,167.25A47.59,47.59,0,0,0,61.87,201.3c9.66,9.62,23.06,14.7,38.73,14.7,51.81,0,81.18-42.13,84.49-84.42a161.43,161.43,0,0,1,49,33.79,8,8,0,1,0,11.86-10.74Zm-94.46,21.64C142.64,187.09,126.66,200,100.6,200,75.32,200,64,183.55,64,167.25,64,144.49,85.47,120,132.6,120a124.34,124.34,0,0,1,36.78,5.68C168.93,144.44,162.46,162.78,151.47,176.27Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,128a81.4,81.4,0,0,1,25.69,4.28C151.56,154.87,137.33,176,112,176c-15.8,0-24.06-10.85-24.06-21.58,0-6.59,3-12.75,8.56-17.35C103.62,131.14,114.52,128,128,128Zm96-80V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48Zm-18.11,98.59a120.21,120.21,0,0,0-36.08-25.21c-.9-14.35-5.75-27.54-13.89-37.55C145.38,70.86,130.19,64,112,64,76.44,64,50.68,97.76,49.6,99.2a8,8,0,0,0,12.79,9.62C62.61,108.53,84.51,80,112,80c13.4,0,24,4.68,31.5,13.92a47.54,47.54,0,0,1,9.48,21.4A96.75,96.75,0,0,0,128,112c-17.27,0-31.71,4.42-41.74,12.78C77,132.47,71.94,143,71.94,154.42,71.94,172.64,86,192,112,192a54,54,0,0,0,43.53-21.23A70,70,0,0,0,169,138.89a106.24,106.24,0,0,1,25.13,18.52,8,8,0,1,0,11.78-10.82Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M244.45,156c-1.32-1.46-24.27-26.42-61.37-40.5-1.5-18.49-8.13-35.31-19-48C149.74,50.8,129,42,104,42,53.49,42,20.5,87.38,19.12,89.31a6,6,0,1,0,9.76,7C29.18,95.87,59.75,54,104,54c21.37,0,39,7.35,50.93,21.27,8.26,9.62,13.64,22.14,15.62,36.06a139,139,0,0,0-38-5.33c-25.58,0-47,6.65-62,19.22-13.1,11-20.62,26.34-20.62,42a45.65,45.65,0,0,0,13.28,32.64C72.56,209.12,85.47,214,100.6,214c51.73,0,80.55-43.09,82.68-85.38,32.05,13.49,52,35.09,52.27,35.4a6,6,0,0,0,8.9-8ZM153,177.53C143.92,188.69,127.44,202,100.6,202,82,202,62,191.12,62,167.25,62,143.53,84.09,118,132.6,118a126.74,126.74,0,0,1,38.8,6.22C171.26,143.94,164.58,163.34,153,177.53Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M245.93,154.63c-1.32-1.46-24.09-26.22-61-40.56-1.72-18.42-8.46-35.17-19.41-47.92C150.87,49,129.58,40,104,40,52.48,40,18.89,86.18,17.49,88.15a8,8,0,0,0,13,9.31C30.8,97.05,60.81,56,104,56c20.77,0,37.86,7.11,49.41,20.57,7.42,8.64,12.44,19.69,14.67,32A140.87,140.87,0,0,0,132.6,104c-26.06,0-47.93,6.81-63.26,19.69C55.78,135.09,48,151,48,167.25A47.59,47.59,0,0,0,61.87,201.3c9.66,9.62,23.06,14.7,38.73,14.7,51.81,0,81.18-42.13,84.49-84.42a161.43,161.43,0,0,1,49,33.79,8,8,0,1,0,11.86-10.74Zm-94.46,21.64C142.64,187.09,126.66,200,100.6,200,75.32,200,64,183.55,64,167.25,64,144.49,85.47,120,132.6,120a124.34,124.34,0,0,1,36.78,5.68C168.93,144.44,162.46,162.78,151.47,176.27Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M243,157.32c-1.32-1.46-24.47-26.63-61.79-40.43-1.26-18.56-7.78-35.45-18.66-48.13C148.62,52.56,128.38,44,104,44,54.51,44,22.1,88.58,20.74,90.48a4,4,0,0,0,6.51,4.65C27.56,94.7,58.68,52,104,52c22,0,40.11,7.6,52.45,22,9.11,10.61,14.81,24.62,16.46,40.13A137.84,137.84,0,0,0,132.6,108c-25.1,0-46.09,6.48-60.69,18.75C59.26,137.39,52,152.15,52,167.25a43.64,43.64,0,0,0,12.69,31.22C73.59,207.32,86,212,100.6,212c51.63,0,79.87-44.08,80.78-86.32,34.07,13.58,55.36,36.67,55.65,37a4,4,0,1,0,5.94-5.36Zm-88.4,21.47c-9.37,11.5-26.34,25.21-54,25.21C72.71,204,60,185,60,167.25,60,142.57,82.72,116,132.6,116a129.23,129.23,0,0,1,40.8,6.77v.81C173.4,144,166.54,164.1,154.57,178.79Z"
        }))
    ]
]), $f2ed8375f15450ed$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $f2ed8375f15450ed$var$C($f2ed8375f15450ed$var$r({
        ref: a
    }, t), {
        weights: $f2ed8375f15450ed$var$i
    })));
$f2ed8375f15450ed$export$2e2bcd8739ae039.displayName = "ScribbleLoop";


var $acw62 = parcelRequire("acw62");


var $0dc430bb0d6de255$var$A = Object.defineProperty, $0dc430bb0d6de255$var$M = Object.defineProperties;
var $0dc430bb0d6de255$var$c = Object.getOwnPropertyDescriptors;
var $0dc430bb0d6de255$var$m = Object.getOwnPropertySymbols;
var $0dc430bb0d6de255$var$L = Object.prototype.hasOwnProperty, $0dc430bb0d6de255$var$h = Object.prototype.propertyIsEnumerable;
var $0dc430bb0d6de255$var$n = (l, e, t)=>e in l ? $0dc430bb0d6de255$var$A(l, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : l[e] = t, $0dc430bb0d6de255$var$r = (l, e)=>{
    for(var t in e || (e = {}))$0dc430bb0d6de255$var$L.call(e, t) && $0dc430bb0d6de255$var$n(l, t, e[t]);
    if ($0dc430bb0d6de255$var$m) for (var t of $0dc430bb0d6de255$var$m(e))$0dc430bb0d6de255$var$h.call(e, t) && $0dc430bb0d6de255$var$n(l, t, e[t]);
    return l;
}, $0dc430bb0d6de255$var$Z = (l, e)=>$0dc430bb0d6de255$var$M(l, $0dc430bb0d6de255$var$c(e));
const $0dc430bb0d6de255$var$E = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M234.79,149.32,215.7,97.11A20,20,0,0,0,190.12,85.2l-61.31,22.22L139.7,45.18A20,20,0,0,0,123.55,22L68.87,12.31A19.94,19.94,0,0,0,45.76,28.55l-25,143.13A48,48,0,0,0,59.4,227.26a51.19,51.19,0,0,0,8.7.74H216a20,20,0,0,0,20-20V156.19A21.74,21.74,0,0,0,234.79,149.32ZM91,184.18a23.84,23.84,0,0,1-9.86,15.56,23.28,23.28,0,0,1-17.56,3.89,24,24,0,0,1-19.23-27.82L68.71,36.66,115.37,45,91,184.18Zm23.64,4.13,9.39-53.64,70.49-25.54,16.3,44.59-96.23,34.87C114.62,188.5,114.65,188.41,114.66,188.31ZM212,204H142.52L212,178.82ZM81.22,174.07l-1.4,8A12,12,0,0,1,68,192a12.35,12.35,0,0,1-2.08-.18,12,12,0,0,1-9.75-13.89l1.4-8a12,12,0,0,1,23.64,4.14Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M127.88,43.11l-25,143.14a35.71,35.71,0,0,1-41.34,29.2h0a36,36,0,0,1-28.95-41.71l25-143.13a8,8,0,0,1,9.19-6.49l54.67,9.73A8,8,0,0,1,127.88,43.11Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M80,180a12,12,0,1,1-12-12A12,12,0,0,1,80,180Zm152-23.81V208a16,16,0,0,1-16,16H68a46.36,46.36,0,0,1-7.94-.68,44,44,0,0,1-35.43-50.95l25-143.13a15.94,15.94,0,0,1,18.47-13L122.84,26a16,16,0,0,1,12.92,18.52l-12.08,69L191.49,89a16,16,0,0,1,20.45,9.52L231,150.69A18.35,18.35,0,0,1,232,156.19ZM95,184.87,120,41.74,65.46,32l-25,143.1A28,28,0,0,0,62.9,207.57,27.29,27.29,0,0,0,83.46,203,27.84,27.84,0,0,0,95,184.87ZM108.78,195,216,156.11,196.92,104,120.5,131.7l-9.78,55.92A44.63,44.63,0,0,1,108.78,195ZM216,173.12,119.74,208H216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M232,155.91a16,16,0,0,0-1-5.22L211.94,98.48A16,16,0,0,0,191.49,89l-67.81,24.57,12.08-69A16,16,0,0,0,122.84,26L68.17,16.25a15.94,15.94,0,0,0-18.47,13l-25,143.12A43.82,43.82,0,0,0,67.78,224H216a16,16,0,0,0,16-16ZM68,196a16,16,0,1,1,16-16A16,16,0,0,1,68,196Zm42.72-8.38,9.78-55.92L196.92,104,216,156.11,108.78,195A44.89,44.89,0,0,0,110.72,187.62ZM216,208H119.74L216,173.11Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M78,180a10,10,0,1,1-10-10A10,10,0,0,1,78,180Zm152-23.81V208a14,14,0,0,1-14,14H68a44.18,44.18,0,0,1-7.58-.65,42,42,0,0,1-33.81-48.64l25-143.13A13.94,13.94,0,0,1,67.82,18.22l54.67,9.72a14,14,0,0,1,11.3,16.21l-12.67,72.44,71-25.75a14,14,0,0,1,17.89,8.32l19.09,52.22A15.66,15.66,0,0,1,230,156.19Zm-133.07,29L122,42.08a2,2,0,0,0-1.58-2.32L65.72,30l-.34,0a1.84,1.84,0,0,0-1.07.35,2,2,0,0,0-.82,1.3l-25,143.13a30,30,0,0,0,24.09,34.76,29.25,29.25,0,0,0,22-4.89,29.81,29.81,0,0,0,12.33-19.44Zm8.25,13.17L216.71,158a2,2,0,0,0,1.11-1,1.86,1.86,0,0,0,.06-1.46l-19.09-52.21a2,2,0,0,0-2.53-1.17l-77.53,28.09-10,57.07A41.9,41.9,0,0,1,105.18,198.38ZM218,170.27,108.35,210H216a2,2,0,0,0,2-2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M80,180a12,12,0,1,1-12-12A12,12,0,0,1,80,180Zm152-23.81V208a16,16,0,0,1-16,16H68a46.36,46.36,0,0,1-7.94-.68,44,44,0,0,1-35.43-50.95l25-143.13a15.94,15.94,0,0,1,18.47-13L122.84,26a16,16,0,0,1,12.92,18.52l-12.08,69L191.49,89a16,16,0,0,1,20.45,9.52L231,150.69A18.35,18.35,0,0,1,232,156.19ZM95,184.87,120,41.74,65.46,32l-25,143.1A28,28,0,0,0,62.9,207.57,27.29,27.29,0,0,0,83.46,203,27.84,27.84,0,0,0,95,184.87ZM108.78,195,216,156.11,196.92,104,120.5,131.7l-9.78,55.92A44.63,44.63,0,0,1,108.78,195ZM216,173.12,119.74,208H216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M227.27,152.07,208.19,99.85a12,12,0,0,0-15.34-7.13l-74.3,26.92,13.27-75.83a12,12,0,0,0-9.68-13.9L67.47,20.19a11.75,11.75,0,0,0-8.89,2,11.9,11.9,0,0,0-4.94,7.77l-25,143.13A40,40,0,0,0,60.8,219.39,42.68,42.68,0,0,0,68,220H216a12,12,0,0,0,12-12V156.19A14,14,0,0,0,227.27,152.07Zm-31.7-51.83a4,4,0,0,1,5.1,2.36l19.09,52.21a3.9,3.9,0,0,1-.13,3,3.94,3.94,0,0,1-2.24,2L100.78,202.11a40,40,0,0,0,6-15.17L117,128.73ZM85.75,206.29a31.25,31.25,0,0,1-23.55,5.22,32,32,0,0,1-25.71-37.08l25-143.13a4,4,0,0,1,1.64-2.59A3.85,3.85,0,0,1,65.38,28a4,4,0,0,1,.69.06l54.67,9.73a4,4,0,0,1,3.2,4.64l-25,143.13h0A31.79,31.79,0,0,1,85.75,206.29ZM220,208a4,4,0,0,1-4,4H97l123-44.59ZM76,180a8,8,0,1,1-8-8A8,8,0,0,1,76,180Z"
        }))
    ]
]), $0dc430bb0d6de255$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((l, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $0dc430bb0d6de255$var$Z($0dc430bb0d6de255$var$r({
        ref: e
    }, l), {
        weights: $0dc430bb0d6de255$var$E
    })));
$0dc430bb0d6de255$export$2e2bcd8739ae039.displayName = "Swatches";


var $acw62 = parcelRequire("acw62");


var $022a4e84fc180583$var$m = Object.defineProperty, $022a4e84fc180583$var$C = Object.defineProperties;
var $022a4e84fc180583$var$o = Object.getOwnPropertyDescriptors;
var $022a4e84fc180583$var$l = Object.getOwnPropertySymbols;
var $022a4e84fc180583$var$h = Object.prototype.hasOwnProperty, $022a4e84fc180583$var$p = Object.prototype.propertyIsEnumerable;
var $022a4e84fc180583$var$A = (c, e, t)=>e in c ? $022a4e84fc180583$var$m(c, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : c[e] = t, $022a4e84fc180583$var$n = (c, e)=>{
    for(var t in e || (e = {}))$022a4e84fc180583$var$h.call(e, t) && $022a4e84fc180583$var$A(c, t, e[t]);
    if ($022a4e84fc180583$var$l) for (var t of $022a4e84fc180583$var$l(e))$022a4e84fc180583$var$p.call(e, t) && $022a4e84fc180583$var$A(c, t, e[t]);
    return c;
}, $022a4e84fc180583$var$r = (c, e)=>$022a4e84fc180583$var$C(c, $022a4e84fc180583$var$o(e));
const $022a4e84fc180583$var$Z = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M251.09,67.41A12,12,0,0,0,240,60H211.82a52.73,52.73,0,0,0-43.67-24,50.85,50.85,0,0,0-36.6,14.85A51.87,51.87,0,0,0,116,88v.78c-36.83-11.57-66.38-40.9-66.7-41.23a12,12,0,0,0-20.47,7.38C22.52,125.1,53.48,162.72,70.89,178.05,56.4,192.83,36,200.68,35.8,200.76A12,12,0,0,0,30,218.66C32,221.55,43.44,236,80,236c72.25,0,132.7-55.26,139.6-126.63l28.88-28.88A12,12,0,0,0,251.09,67.41ZM199.52,95.52a11.93,11.93,0,0,0-3.49,7.72C192.14,164.23,141.18,212,80,212a90.78,90.78,0,0,1-12.49-.79C78,204.55,89.72,195.07,98,182.66a12,12,0,0,0-3.9-17c-.12-.07-12.33-7.49-23.43-24.42s-17.26-37-18.46-59.78C69.37,94.4,96,110.79,126,115.84A12,12,0,0,0,140,104V88a28,28,0,0,1,8.41-20.07A27.07,27.07,0,0,1,167.86,60a28.83,28.83,0,0,1,25.82,16.81,12,12,0,0,0,11,7.19H211Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M240,72l-32,32c-4.26,66.84-60.08,120-128,120-32,0-40-12-40-12s32-12,48-36c0,0-55.15-32-47.22-120,0,0,39.66,40,87.22,48V88c0-22,18-40.27,40-40a40.74,40.74,0,0,1,36.67,24Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M247.39,68.94A8,8,0,0,0,240,64H209.57A48.65,48.65,0,0,0,168.1,40a46.87,46.87,0,0,0-33.74,13.7A47.87,47.87,0,0,0,120,88v6.09C79.74,83.47,46.81,50.72,46.46,50.37a8,8,0,0,0-13.65,4.92c-4.3,47.79,9.57,79.77,22,98.18a110.92,110.92,0,0,0,21.89,24.2C61.43,195.2,37.45,204.41,37.2,204.51a8,8,0,0,0-3.85,11.93c.74,1.12,3.75,5.05,11.08,8.72C53.51,229.7,65.48,232,80,232c70.68,0,129.72-54.42,135.76-124.44l29.9-29.9A8,8,0,0,0,247.39,68.94Zm-45,29.41a8,8,0,0,0-2.32,5.14C196,166.58,143.28,216,80,216c-10.56,0-18-1.4-23.22-3.08,11.52-6.25,27.56-17,37.88-32.48a8,8,0,0,0-2.61-11.34c-.13-.08-12.86-7.74-24.48-25.29C54.54,124.11,48,100.38,48,73.09c16,13,45.25,33.18,78.69,38.8A8,8,0,0,0,136,104V88a32,32,0,0,1,9.6-22.92A30.89,30.89,0,0,1,167.9,56c12.66.16,24.49,7.88,29.44,19.21A8,8,0,0,0,204.67,80h16Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M245.66,77.66l-29.9,29.9C209.72,177.58,150.67,232,80,232c-14.52,0-26.49-2.3-35.58-6.84-7.33-3.67-10.33-7.6-11.08-8.72a8,8,0,0,1,3.85-11.93c.26-.1,24.24-9.31,39.47-26.84a110.93,110.93,0,0,1-21.88-24.2c-12.4-18.41-26.28-50.39-22-98.18a8,8,0,0,1,13.65-4.92c.35.35,33.28,33.1,73.54,43.72V88a47.87,47.87,0,0,1,14.36-34.3A46.87,46.87,0,0,1,168.1,40a48.66,48.66,0,0,1,41.47,24H240a8,8,0,0,1,5.66,13.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M245.54,69.71A6,6,0,0,0,240,66H208.4a46.6,46.6,0,0,0-40.33-24,44.93,44.93,0,0,0-32.31,13.12A45.92,45.92,0,0,0,122,88v8.66c-42-10-76.6-44.52-77-44.88A6,6,0,0,0,34.8,55.46c-4.25,47.22,9.42,78.75,21.64,96.89a107.71,107.71,0,0,0,23.07,25c-15.49,19-41.34,28.89-41.62,29a6,6,0,0,0-2.88,9C36,216.83,45.78,230,80,230c69.88,0,128.23-54,133.82-123.34l30.42-30.41A6,6,0,0,0,245.54,69.71ZM203.76,99.76a6,6,0,0,0-1.75,3.86C197.93,167.76,144.33,218,80,218c-14,0-22.76-2.41-28.06-4.8,11.3-5.68,29.72-16.88,41.05-33.87a6,6,0,0,0,.85-4.67A6,6,0,0,0,91,170.82c-.13-.08-13.13-7.86-25-25.72C52,124,45.31,98.43,46,68.88c14.88,12.6,45.57,35.09,81,41a6,6,0,0,0,7-5.92V88a34,34,0,0,1,10.19-24.34A33.05,33.05,0,0,1,167.93,54c13.43.17,26,8.37,31.24,20.4a6,6,0,0,0,5.5,3.6h20.84Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M247.39,68.94A8,8,0,0,0,240,64H209.57A48.66,48.66,0,0,0,168.1,40a46.91,46.91,0,0,0-33.75,13.7A47.9,47.9,0,0,0,120,88v6.09C79.74,83.47,46.81,50.72,46.46,50.37a8,8,0,0,0-13.65,4.92c-4.31,47.79,9.57,79.77,22,98.18a110.93,110.93,0,0,0,21.88,24.2c-15.23,17.53-39.21,26.74-39.47,26.84a8,8,0,0,0-3.85,11.93c.75,1.12,3.75,5.05,11.08,8.72C53.51,229.7,65.48,232,80,232c70.67,0,129.72-54.42,135.75-124.44l29.91-29.9A8,8,0,0,0,247.39,68.94Zm-45,29.41a8,8,0,0,0-2.32,5.14C196,166.58,143.28,216,80,216c-10.56,0-18-1.4-23.22-3.08,11.51-6.25,27.56-17,37.88-32.48A8,8,0,0,0,92,169.08c-.47-.27-43.91-26.34-44-96,16,13,45.25,33.17,78.67,38.79A8,8,0,0,0,136,104V88a32,32,0,0,1,9.6-22.92A30.94,30.94,0,0,1,167.9,56c12.66.16,24.49,7.88,29.44,19.21A8,8,0,0,0,204.67,80h16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M243.7,70.47A4,4,0,0,0,240,68H207.2a44.57,44.57,0,0,0-39.15-24,42.76,42.76,0,0,0-30.88,12.55A43.85,43.85,0,0,0,124,88V99.16c-43.65-9.39-80-45.6-80.39-46a4,4,0,0,0-4.19-.95,4,4,0,0,0-2.63,3.41c-4.2,46.62,9.27,77.71,21.31,95.59A103.68,103.68,0,0,0,82.35,177c-15.68,20.49-43.46,31.13-43.75,31.24a4,4,0,0,0-1.93,6c.27.4,2.79,4,9.54,7.36C54.73,225.84,66.1,228,80,228c69.09,0,126.73-53.56,131.89-122.23l30.94-30.94A4,4,0,0,0,243.7,70.47Zm-38.53,30.7a4,4,0,0,0-1.16,2.58C199.85,168.94,145.38,220,80,220c-17.85,0-27.63-3.89-32.5-6.87,10.37-4.82,31.45-16.34,43.83-34.91a4,4,0,0,0,.56-3.12A3.93,3.93,0,0,0,90,172.55c-.13-.08-13.39-8-25.52-26.15C54,130.71,42.39,104.11,44.19,64.65c13.17,11.62,45.48,37,83.15,43.3a4,4,0,0,0,4.66-4V88a36,36,0,0,1,10.79-25.76A35,35,0,0,1,168,52c14.2.18,27.49,8.86,33.06,21.61A4,4,0,0,0,204.67,76h25.67Z"
        }))
    ]
]), $022a4e84fc180583$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((c, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $022a4e84fc180583$var$r($022a4e84fc180583$var$n({
        ref: e
    }, c), {
        weights: $022a4e84fc180583$var$Z
    })));
$022a4e84fc180583$export$2e2bcd8739ae039.displayName = "TwitterLogo";


var $acw62 = parcelRequire("acw62");


var $21eb1c93bcc80625$var$V = Object.defineProperty, $21eb1c93bcc80625$var$Z = Object.defineProperties;
var $21eb1c93bcc80625$var$h = Object.getOwnPropertyDescriptors;
var $21eb1c93bcc80625$var$A = Object.getOwnPropertySymbols;
var $21eb1c93bcc80625$var$c = Object.prototype.hasOwnProperty, $21eb1c93bcc80625$var$o = Object.prototype.propertyIsEnumerable;
var $21eb1c93bcc80625$var$l = (t, e, m)=>e in t ? $21eb1c93bcc80625$var$V(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: m
    }) : t[e] = m, $21eb1c93bcc80625$var$r = (t, e)=>{
    for(var m in e || (e = {}))$21eb1c93bcc80625$var$c.call(e, m) && $21eb1c93bcc80625$var$l(t, m, e[m]);
    if ($21eb1c93bcc80625$var$A) for (var m of $21eb1c93bcc80625$var$A(e))$21eb1c93bcc80625$var$o.call(e, m) && $21eb1c93bcc80625$var$l(t, m, e[m]);
    return t;
}, $21eb1c93bcc80625$var$n = (t, e)=>$21eb1c93bcc80625$var$Z(t, $21eb1c93bcc80625$var$h(e));
const $21eb1c93bcc80625$var$M = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M164,56a12,12,0,0,1,12-12h12V32a12,12,0,0,1,24,0V44h12a12,12,0,0,1,0,24H212V80a12,12,0,0,1-24,0V68H176A12,12,0,0,1,164,56Zm70.51,54A107.88,107.88,0,1,1,146,21.49a12,12,0,0,1-4,23.67A85,85,0,0,0,128,44,83.94,83.94,0,0,0,62.05,179.94a83.48,83.48,0,0,1,29-23.42,52,52,0,1,1,74,0,83.36,83.36,0,0,1,29,23.42A83.52,83.52,0,0,0,212,128a85.2,85.2,0,0,0-1.16-14,12,12,0,0,1,23.67-4ZM128,148a28,28,0,1,0-28-28A28,28,0,0,0,128,148Zm0,64a83.53,83.53,0,0,0,48.43-15.43,60,60,0,0,0-96.86,0A83.53,83.53,0,0,0,128,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,128a95.76,95.76,0,0,1-31.8,71.37A72,72,0,0,0,128,160a40,40,0,1,0-40-40,40,40,0,0,0,40,40,72,72,0,0,0-64.2,39.37h0A96,96,0,1,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M168,56a8,8,0,0,1,8-8h16V32a8,8,0,0,1,16,0V48h16a8,8,0,0,1,0,16H208V80a8,8,0,0,1-16,0V64H176A8,8,0,0,1,168,56Zm62.56,54.68a103.92,103.92,0,1,1-85.24-85.24,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A87.62,87.62,0,0,0,216,128a88.85,88.85,0,0,0-1.22-14.68,8,8,0,1,1,15.78-2.64ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm48-12h16V80a8,8,0,0,0,16,0V64h16a8,8,0,0,0,0-16H208V32a8,8,0,0,0-16,0V48H176a8,8,0,0,0,0,16Zm45.35,40.11a8,8,0,0,0-6.57,9.21A88.85,88.85,0,0,1,216,128a87.62,87.62,0,0,1-22.24,58.41A79.86,79.86,0,0,0,172,165.1a4,4,0,0,0-4.84.32,59.81,59.81,0,0,1-78.27,0A4,4,0,0,0,84,165.1a79.71,79.71,0,0,0-21.79,21.31A88,88,0,0,1,128,40a88.76,88.76,0,0,1,14.68,1.22,8,8,0,0,0,2.64-15.78,103.92,103.92,0,1,0,85.24,85.24A8,8,0,0,0,221.35,104.11Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M170,56a6,6,0,0,1,6-6h18V32a6,6,0,0,1,12,0V50h18a6,6,0,0,1,0,12H206V80a6,6,0,0,1-12,0V62H176A6,6,0,0,1,170,56Zm58.59,55A101.9,101.9,0,1,1,145,27.41a6,6,0,1,1-2,11.83A91.66,91.66,0,0,0,128,38,89.95,89.95,0,0,0,62.49,189.64a77.53,77.53,0,0,1,40-31.38,46,46,0,1,1,51,0,77.53,77.53,0,0,1,40,31.38A89.65,89.65,0,0,0,218,128a91.76,91.76,0,0,0-1.24-15,6,6,0,1,1,11.83-2ZM128,154a34,34,0,1,0-34-34A34,34,0,0,0,128,154Zm0,64A89.58,89.58,0,0,0,184.56,198a66,66,0,0,0-113.12,0A89.58,89.58,0,0,0,128,218Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M168,56a8,8,0,0,1,8-8h16V32a8,8,0,0,1,16,0V48h16a8,8,0,0,1,0,16H208V80a8,8,0,0,1-16,0V64H176A8,8,0,0,1,168,56Zm62.56,54.68a103.92,103.92,0,1,1-85.24-85.24,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A87.62,87.62,0,0,0,216,128a88.85,88.85,0,0,0-1.22-14.68,8,8,0,1,1,15.78-2.64ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M172,56a4,4,0,0,1,4-4h20V32a4,4,0,0,1,8,0V52h20a4,4,0,0,1,0,8H204V80a4,4,0,0,1-8,0V60H176A4,4,0,0,1,172,56Zm54.62,55.34a99.89,99.89,0,1,1-82-82,4,4,0,0,1-1.32,7.89A93.4,93.4,0,0,0,128,36,92,92,0,0,0,62.83,192.87a75.61,75.61,0,0,1,44.51-34,44,44,0,1,1,41.32,0,75.61,75.61,0,0,1,44.51,34A91.69,91.69,0,0,0,220,128a93.58,93.58,0,0,0-1.27-15.34,4,4,0,0,1,7.89-1.32ZM128,156a36,36,0,1,0-36-36A36,36,0,0,0,128,156Zm0,64a91.61,91.61,0,0,0,59.14-21.58,68,68,0,0,0-118.27,0A91.56,91.56,0,0,0,128,220Z"
        }))
    ]
]), $21eb1c93bcc80625$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $21eb1c93bcc80625$var$n($21eb1c93bcc80625$var$r({
        ref: e
    }, t), {
        weights: $21eb1c93bcc80625$var$M
    })));
$21eb1c93bcc80625$export$2e2bcd8739ae039.displayName = "UserCirclePlus";







function $717c681f9cec0e89$export$7546fd8828239c7(props) {
    const { icon: icon, title: title, desc: desc } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "item pb-4 sm:p-2 flex items-stretch justify-stretch",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "inner flex flex-1 opacity-90 backdrop-blur-lg",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "w-[40px] h-[40px] flex items-center justify-center",
                    children: icon
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex-1 pl-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-sm font-semibold",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-xs pt-1",
                            children: desc
                        })
                    ]
                })
            ]
        })
    });
}
function $717c681f9cec0e89$export$d4189403d0df3716() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-features-boards",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "board-item hidden sm:block",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "inner",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "l info-wrap flex-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $14c232b27ec1fd04$export$2e2bcd8739ae039), {
                                        size: 38,
                                        weight: "duotone"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                    children: [
                                        "Logseq Sync ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("sup", {
                                            children: "BETA"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Always up-to-date notes"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-logseq-50/80",
                                            children: "between all your devices."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    className: "hidden sm:block",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-logseq-50/80",
                                            children: [
                                                "With encrypted file syncing, you'll always have your ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                " notes "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "backed up and securely available in real-time ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                " on any device. "
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "r img-wrap flex-1 hidden sm:block"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "board-item hidden sm:block",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "inner whiteboard",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "l img-wrap flex-1 hidden sm:flex"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "r info-wrap flex-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2ed8375f15450ed$export$2e2bcd8739ae039), {
                                        size: 38,
                                        weight: "duotone"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                    children: [
                                        "Whiteboards ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("sup", {
                                            children: "BETA"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "A new canvas"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-logseq-50/80",
                                            children: "for your thoughts."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    className: "hidden sm:block",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-logseq-50/80",
                                            children: [
                                                "Place any of your thoughts from the knowledge base ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                "or new ones next to each other on an infinite canvas"
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "to connect, associate and understand in new ways."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $717c681f9cec0e89$export$5608306d67ce35b7() {
    const appState = (0, $0b89d474933103bc$export$9973955de2bf96cf)();
    const itemWhiteboard = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "board-item whiteboard flex-1",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "inner",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "r info-wrap flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2ed8375f15450ed$export$2e2bcd8739ae039), {
                            size: 38,
                            weight: "duotone"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        children: [
                            "Whiteboards ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("sup", {
                                children: "BETA"
                            })
                        ]
                    }),
                    appState.sm.get() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "A new canvas "
                            }),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-logseq-50/80",
                                children: "for your thoughts."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "A new canvas "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-logseq-50/80",
                                children: [
                                    "for your",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "thoughts."
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-features-boards dl-page hidden sm:block",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "board-item-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "board-item file-sync",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "inner",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "l info-wrap flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $14c232b27ec1fd04$export$2e2bcd8739ae039), {
                                            size: 38,
                                            weight: "duotone"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                        children: [
                                            "Logseq Sync ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("sup", {
                                                children: "BETA"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Always up-to-date notes"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-logseq-50/80",
                                                children: "between all your devices."
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    appState.sm.get() && itemWhiteboard,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "board-item rtc-collaboration",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "inner",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "l info-wrap flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21eb1c93bcc80625$export$2e2bcd8739ae039), {
                                            size: 38,
                                            weight: "duotone"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                        children: [
                                            "Real-time collaboration",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("sup", {
                                                children: " COMING SOON"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-logseq-50/80",
                                                children: "Great knowledge is"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "a result of collaboration."
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            !appState.sm.get() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "board-item-wrap flex w-full",
                children: itemWhiteboard
            })
        ]
    });
}
function $717c681f9cec0e89$export$e458e76844d3be8d(props) {
    const appState = (0, $0b89d474933103bc$export$9973955de2bf96cf)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-landing-footer-desc",
        children: [
            !props.hideFeaturesSection && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-radial from-logseq-800 via-logseq-800/50 to-logseq-800/0",
                children: props.downloadsPage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                            className: "text-4xl -mt-[230px] leading-9 tracking-wide pb-2 sm:mt-0 sm:leading-[1em] sm:text-6xl sm:text-center sm:pt-20 sm:pb-15",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-logseq-50/80",
                                    children: "Get ready for"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "font-semibold",
                                    children: "knowledge work reimagined."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                            className: "text-lg leading-9 tracking-wide sm:text-[32px] sm:px-60 sm:py-6 sm:text-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-logseq-50/80",
                                    children: "By downloading Logseq, you are embarking on a journey. We are constantly trying to make it even more useful for all kinds of workflows."
                                }),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "font-normal",
                                    children: "These exciting features are coming soon:"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                            className: "text-4xl -mt-[230px] leading-9 pb-2 sm:mt-0 sm:text-6xl sm:text-center sm:py-10 bg-radial",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "font-semibold",
                                    children: "A safe space for "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-logseq-50/80",
                                    children: "your thoughts."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                            className: "text-lg sm:text-[24px] sm:px-60 sm:text-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-logseq-50/80",
                                    children: "Designed to store your "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "font-normal",
                                    children: "interests, questions, ideas, favorite quotes, reminders, reading and meeting notes "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-logseq-50/80",
                                    children: "easily and future-proof:"
                                })
                            ]
                        })
                    ]
                })
            }),
            !props.hideFeaturesSection && (props.downloadsPage ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "cards",
                children: [
                    [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26d7a770d1c2ac27$export$2e2bcd8739ae039), {
                            size: 34,
                            weight: "duotone"
                        }),
                        "Open source",
                        "Free forever for personal use"
                    ],
                    [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ded3ebfcc172d710$export$2e2bcd8739ae039), {
                            size: 34,
                            weight: "duotone"
                        }),
                        "Privacy first",
                        "You own your data locally forever"
                    ],
                    [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2919880f556a2439$export$2e2bcd8739ae039), {
                            weight: "duotone",
                            size: 34
                        }),
                        "Mobile apps",
                        "Available for iOS & Android"
                    ],
                    [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $23b4a1964f570797$export$2e2bcd8739ae039), {
                            size: 34,
                            weight: "duotone"
                        }),
                        "Markdown files",
                        "Open your notes in other tools"
                    ],
                    [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f0d0c76fe0c1fd0$export$2e2bcd8739ae039), {
                            size: 34,
                            weight: "duotone"
                        }),
                        "Strong community",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "flex space-x-2 items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "w-[6px] h-[6px] bg-green-600 rounded-2xl"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "opacity-50",
                                    children: [
                                        appState.discord?.approximate_presence_count.get() || "-",
                                        " users online currently"
                                    ]
                                })
                            ]
                        })
                    ],
                    [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4da17066235214a$export$2e2bcd8739ae039), {
                            size: 34,
                            weight: "duotone"
                        }),
                        "Localization",
                        "Translated in many languages"
                    ],
                    [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8354377a48be5e84$export$2e2bcd8739ae039), {
                            size: 34,
                            weight: "duotone"
                        }),
                        "150+ Plugins",
                        "Extend functionality to your needs"
                    ],
                    [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0dc430bb0d6de255$export$2e2bcd8739ae039), {
                            size: 34,
                            weight: "duotone"
                        }),
                        "30+ Themes",
                        "Customize look and feel"
                    ]
                ].map(([icon, title, desc])=>{
                    if (typeof desc === "string") desc = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "opacity-50",
                        children: desc
                    });
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($717c681f9cec0e89$export$7546fd8828239c7, {
                        icon: icon,
                        title: title,
                        desc: desc
                    }, title);
                })
            })),
            !props.hideFeaturesSection && (props.downloadsPage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($717c681f9cec0e89$export$5608306d67ce35b7, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($717c681f9cec0e89$export$d4189403d0df3716, {})),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "actions",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "text-4xl leading-10 sm:leading-normal sm:text-6xl tracking-wide",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "opacity-70",
                                children: "Think faster, "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-semibold",
                                children: "think better!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "text-lg mt-4 sm:mt-0 sm:text-3xl sm:text-center sm:tracking-wide",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "opacity-70 font-normal",
                                children: "By thinking and writing with Logseq, you'll "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "",
                                children: [
                                    "gain confidence in what you know and ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    "stop worrying about forgetting "
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "opacity-70 font-normal",
                                children: "anything"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "actions-4 sm:flex sm:space-x-4 pt-10 pb-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b83dbd58d0bae96$export$434a045e59e6bdd3), {
                                className: "is-super-button",
                                children: ({ active: active, leftIconFn: leftIconFn, rightIconFn: rightIconFn })=>{
                                    const leftIcon = leftIconFn?.({
                                        weight: "bold",
                                        size: 18
                                    });
                                    const rightIcon = rightIconFn?.({
                                        size: 18
                                    });
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                                        leftIcon: leftIcon,
                                        rightIcon: rightIcon,
                                        className: "w-full sm:w-auto",
                                        children: [
                                            "Download for ",
                                            active?.[0]
                                        ]
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                                leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67aa543a4d20f937$export$2e2bcd8739ae039), {
                                    size: 18,
                                    weight: "duotone"
                                }),
                                rightIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6925feee259dfec9$export$2e2bcd8739ae039), {
                                    size: 18,
                                    className: "opacity-70"
                                }),
                                className: "w-full bg-logseq-600 mt-4 sm:w-auto sm:mt-0",
                                href: "https://demo.logseq.com",
                                children: "Live Demo"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $717c681f9cec0e89$export$314961f1e384fdc0() {
    const appState = (0, $0b89d474933103bc$export$9973955de2bf96cf)();
    const links = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "links flex flex-col justify-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "flex space-x-4 text-xs text-gray-300/90 pb-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/privacy-policy",
                        children: "Privacy"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/terms",
                        children: "Terms"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "mailto:hi@logseq.com",
                        children: "Contact Us"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-xs opacity-40 py-1",
                children: [
                    "\xa9 ",
                    new Date().getFullYear(),
                    " Logseq, Inc."
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-landing-footer-navs",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-1 justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $459f452165207905$export$f7e22c3fd4ab6d59), {
                                className: "w-16 h-16"
                            }),
                            appState.sm.get() ? null : links
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex space-x-4 pl-[14px] py-[8px] sm:pr-[14px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://github.com/logseq/logseq",
                                className: "glass-btn !px-3",
                                "aria-label": "GitHub (opens a new window)",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26d7a770d1c2ac27$export$2e2bcd8739ae039), {
                                    size: 26,
                                    weight: "duotone"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://twitter.com/logseq",
                                className: "glass-btn !px-3",
                                "aria-label": "Twitter (opens a new window)",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $022a4e84fc180583$export$2e2bcd8739ae039), {
                                    size: 26,
                                    weight: "duotone"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pt-4 sm:pt-0 sm:flex sm:space-x-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0190bc205d696513$export$353f5b6fc5456de1), {
                    leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "w-10",
                        src: (0, $459f452165207905$export$9f247931755963c6),
                        alt: "image"
                    }),
                    rightIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6925feee259dfec9$export$2e2bcd8739ae039), {
                        className: "opacity-50"
                    }),
                    className: "w-full !py-1 !px-3 bg-transparent border-2 border-logseq-400",
                    href: "https://www.producthunt.com/products/logseq",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "opacity-90",
                        children: [
                            "Review us on ProductHunt",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "sr-only",
                                children: " (opens a new window)"
                            })
                        ]
                    })
                })
            }),
            appState.sm.get() ? links : null
        ]
    });
}


var $fee05eabc7fd6ce0$exports = {};

$fee05eabc7fd6ce0$exports = new URL((parcelRequire("27Lyk")).resolve("24UWo"), import.meta.url).toString();


const $db0bad02d0b0ecf1$export$6429944a9ed86acc = new URL($fee05eabc7fd6ce0$exports);
var $425562e449f5e786$exports = {};

$425562e449f5e786$exports = new URL((parcelRequire("27Lyk")).resolve("2L24i"), import.meta.url).toString();


const $db0bad02d0b0ecf1$export$4fab7e31df46e124 = new URL($425562e449f5e786$exports);
var $ed1ef1401e520323$exports = {};

$ed1ef1401e520323$exports = new URL((parcelRequire("27Lyk")).resolve("jt4Jz"), import.meta.url).toString();


var $80bd90bcba8e46b5$exports = {};

$80bd90bcba8e46b5$exports = new URL((parcelRequire("27Lyk")).resolve("kCcVO"), import.meta.url).toString();


var $03ce17b36c3f49f4$exports = {};

$03ce17b36c3f49f4$exports = new URL((parcelRequire("27Lyk")).resolve("6QgVQ"), import.meta.url).toString();


var $59125eb1cf2f0b34$exports = {};

$59125eb1cf2f0b34$exports = new URL((parcelRequire("27Lyk")).resolve("2pnyO"), import.meta.url).toString();


var $66280315dfa9b81f$exports = {};

$66280315dfa9b81f$exports = new URL((parcelRequire("27Lyk")).resolve("1Zh67"), import.meta.url).toString();


var $7395b419e38df1bc$exports = {};

$7395b419e38df1bc$exports = new URL((parcelRequire("27Lyk")).resolve("kA2a9"), import.meta.url).toString();


const $db0bad02d0b0ecf1$export$8e734e9a19552f8b = {
    "00": new URL($ed1ef1401e520323$exports),
    "01": new URL($80bd90bcba8e46b5$exports),
    "10": new URL($03ce17b36c3f49f4$exports),
    "11": new URL($59125eb1cf2f0b34$exports),
    "20": new URL($66280315dfa9b81f$exports),
    "21": new URL($7395b419e38df1bc$exports)
};






var $acw62 = parcelRequire("acw62");





var $2511fc977b7830ff$exports = {};

$2511fc977b7830ff$exports = new URL((parcelRequire("27Lyk")).resolve("dLZBe"), import.meta.url).toString();


const $1ccba936592c25c2$var$IconImageRelations = new URL($2511fc977b7830ff$exports);
var $a3f3900ae46c7d85$exports = {};

$a3f3900ae46c7d85$exports = new URL((parcelRequire("27Lyk")).resolve("9bhZL"), import.meta.url).toString();


const $1ccba936592c25c2$var$IconImageDailyPlan = new URL($a3f3900ae46c7d85$exports);
var $d33031f92a2f94f5$exports = {};

$d33031f92a2f94f5$exports = new URL((parcelRequire("27Lyk")).resolve("2CJGE"), import.meta.url).toString();


const $1ccba936592c25c2$var$IconImageJournals = new URL($d33031f92a2f94f5$exports);
var $ab71b74c321a893f$exports = {};

$ab71b74c321a893f$exports = new URL((parcelRequire("27Lyk")).resolve("64Mwr"), import.meta.url).toString();


const $1ccba936592c25c2$var$IconImageDataControl = new URL($ab71b74c321a893f$exports);
var $ca9fd2e2c9a3c8ce$exports = {};

$ca9fd2e2c9a3c8ce$exports = new URL((parcelRequire("27Lyk")).resolve("2rlxs"), import.meta.url).toString();


var $7d993faf6a991d4a$exports = {};

$7d993faf6a991d4a$exports = new URL((parcelRequire("27Lyk")).resolve("hXPpN"), import.meta.url).toString();


var $2c08151872ef9cec$exports = {};

$2c08151872ef9cec$exports = new URL((parcelRequire("27Lyk")).resolve("cqfdp"), import.meta.url).toString();


var $b52137f59c45fd71$exports = {};

$b52137f59c45fd71$exports = new URL((parcelRequire("27Lyk")).resolve("hUxoi"), import.meta.url).toString();


const $1ccba936592c25c2$var$showcases = [
    {
        label: "Relationships",
        iconUrl: $1ccba936592c25c2$var$IconImageRelations,
        descImgUrl: new URL($ca9fd2e2c9a3c8ce$exports),
        refLink: "https://discord.com/channels/725182569297215569/725188616695054356/1045646531090448436",
        userName: "oskr",
        refType: "discord",
        desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                "Communicate better. ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "opacity-70",
                    children: [
                        "Stay on top of your ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "relationships, conversations, and meetings."
                    ]
                })
            ]
        }),
        feedback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "“I mostly use it for work: keeping "
                }),
                "daily notes & meeting notes. It's the best solution I've found to managing my tasks",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: " (and I only use a fraction of the features there).”"
                })
            ]
        })
    },
    {
        label: "Daily Plan",
        iconUrl: $1ccba936592c25c2$var$IconImageDailyPlan,
        descImgUrl: new URL($7d993faf6a991d4a$exports),
        refLink: "https://discord.com/channels/725182569297215569/918889676071374889/1050520429258887320",
        refType: "discord",
        userName: "breadchris",
        desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "Channel your attention, "
                }),
                "reduce stress."
            ]
        }),
        feedback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "“I used to hate taking notes. "
                }),
                "If I told my past self that I wouldn't just like taking notes, but that I would become addicted to it, I wouldn't believe it.",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: " Logseq has changed my life \uD83D\uDD25\uD83D\uDD25\uD83D\uDD25”"
                })
            ]
        })
    },
    {
        label: "Journaling",
        iconUrl: $1ccba936592c25c2$var$IconImageJournals,
        descImgUrl: new URL($2c08151872ef9cec$exports),
        refLink: "https://discord.com/channels/725182569297215569/766475028978991104/965786173148627044",
        refType: "discord",
        userName: "Kiernan",
        desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            children: "Understand yourself better."
        }),
        feedback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            children: "“Before Logseq, I didn't use to write a daily journal, now I feel that it has a great value!”"
        })
    },
    {
        label: "Data Control",
        iconUrl: $1ccba936592c25c2$var$IconImageDataControl,
        descImgUrl: new URL($b52137f59c45fd71$exports),
        refLink: "https://twitter.com/15777984/status/1522601138738151427",
        userName: "@b05crypto",
        desc: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "Do all this without lock-in."
                }),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                "And without risking your privacy."
            ]
        }),
        feedback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "“Logseq does tracking everything in my life "
                }),
                "better than any tool I've ever used, including Roam and I have control of my data.”"
            ]
        })
    }
];
function $1ccba936592c25c2$export$ea3d65784f353414(props) {
    const { activeShowcase: activeShowcase, setActiveShowcase: setActiveShowcase } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "tablist",
        className: "tabs flex justify-between space-x-8 px-6",
        children: $1ccba936592c25c2$var$showcases.map((it)=>{
            const labelId = (0, $3b479ead6613d9c6$export$c383cdd2a518017a)(it.label);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("it flex flex-col flex-1", {
                    active: it.label === activeShowcase
                }),
                role: "tab",
                "aria-controls": labelId,
                "aria-selected": activeShowcase === it.label,
                id: "tab-" + labelId,
                tabIndex: activeShowcase === it.label ? 0 : -1,
                onClick: ()=>{
                    setActiveShowcase(it.label);
                },
                onKeyDown: (0, $3b479ead6613d9c6$export$e7493836a310b8ae),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "py-6 flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "icon",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: it.iconUrl,
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "pt-2.5 font-normal text-[20px] opacity-60 tracking-wide",
                            children: it.label
                        })
                    ]
                })
            }, it.label);
        })
    });
}
function $1ccba936592c25c2$export$77bcde9f64dabce1(props) {
    const { activeShowcase: activeShowcase, setActiveShowcase: setActiveShowcase } = props;
    const activeIndex = $1ccba936592c25c2$var$showcases.findIndex((it)=>it.label === activeShowcase);
    const activeItem = $1ccba936592c25c2$var$showcases[activeIndex];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("selects", `index-of-${activeIndex}`),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "app-form-select-wrap",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "icon",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        alt: activeItem.label,
                        src: activeItem.iconUrl
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                    className: "app-form-select w-full",
                    onChange: (e)=>{
                        setActiveShowcase(e.target.value);
                    },
                    value: activeShowcase,
                    "aria-label": "Select your use case",
                    children: $1ccba936592c25c2$var$showcases.map((it)=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: it.label,
                            children: it.label
                        }, it.label);
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "arrow",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ded21779901b8c91$export$2e2bcd8739ae039), {
                        weight: "bold"
                    })
                })
            ]
        })
    });
}
function $1ccba936592c25c2$export$d2efe51c2d0e6c45() {
    const appState = (0, $0b89d474933103bc$export$9973955de2bf96cf)();
    const [showcase, setShowcase] = (0, $acw62.useState)(0);
    const [activeShowcase, setActiveShowcase] = (0, $acw62.useState)($1ccba936592c25c2$var$showcases[0].label);
    const [sizeCache, setSizeCache] = (0, $acw62.useState)([
        0,
        0
    ]);
    const [progress, setProgress] = (0, $acw62.useState)(0);
    const bdRef = (0, $acw62.useRef)(null);
    const nextShowcase = (0, $acw62.useCallback)(()=>{
        const total = $1ccba936592c25c2$var$showcases.length;
        const currentIndex = $1ccba936592c25c2$var$showcases.findIndex((it)=>it.label === activeShowcase);
        let nextIndex = currentIndex + 1;
        if (nextIndex >= total) nextIndex = 0;
        setActiveShowcase($1ccba936592c25c2$var$showcases[nextIndex]?.label);
        setShowcase(nextIndex);
    }, [
        activeShowcase
    ]);
    (0, $acw62.useEffect)(()=>{
        setProgress(0);
    }, [
        activeShowcase
    ]);
    (0, $acw62.useEffect)(()=>{
        const timer = setInterval(()=>{
            setProgress((progress)=>{
                let nextProgress = progress + 0.4;
                if (nextProgress > 100) {
                    nextShowcase();
                    nextProgress = 0;
                }
                return nextProgress;
            });
        }, 60);
        return ()=>clearInterval(timer);
    }, [
        activeShowcase
    ]);
    (0, $acw62.useEffect)(()=>{
        const handler = ()=>setSizeCache([]);
        window.addEventListener("resize", handler);
        return ()=>window.removeEventListener("resize", handler);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-daily-showcase",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a7a7174f7bc9055$export$24fab8e739feba68), {
                ticks: [
                    500,
                    500
                ],
                className: "flex flex-col sm:justify-center sm:items-center pb-8",
                children: (t)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("text-2xl sm:text-[36px] sm:leading-10 tracking-wide invisible", t[0] && "ani-fade-in"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-logseq-50/80",
                                        children: "Logseq helps you"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: " turn this daily mess into structured information."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("text-4xl leading-10 sm:py-10 sm:text-6xl py-3 invisible", t[1] && "ani-slide-in-from-bottom"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Gain clarity"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-logseq-50/80",
                                        children: " in your everyday life:"
                                    })
                                ]
                            })
                        ]
                    });
                }
            }),
            appState.sm.get() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1ccba936592c25c2$export$77bcde9f64dabce1, {
                activeShowcase: activeShowcase,
                setActiveShowcase: setActiveShowcase
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1ccba936592c25c2$export$ea3d65784f353414, {
                activeShowcase: activeShowcase,
                setActiveShowcase: setActiveShowcase
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "panels",
                ref: bdRef,
                children: $1ccba936592c25c2$var$showcases.map((it)=>{
                    if (it.label !== activeShowcase) return null;
                    const labelId = (0, $3b479ead6613d9c6$export$c383cdd2a518017a)(it.label);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "panel",
                        id: labelId,
                        role: "tabpanel",
                        "aria-labelledby": "tab-" + labelId,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "desc",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "animate-in fade-in",
                                    children: it.desc
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "card sm:flex",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "l relative animate-in fade-in",
                                        style: {
                                            width: sizeCache[0] ? sizeCache[0] + "px" : "auto",
                                            height: sizeCache[1] ? sizeCache[1] + "px" : "auto"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: it.descImgUrl,
                                                alt: "image",
                                                onLoad: (e)=>{
                                                    const { width: width, height: height } = e.target;
                                                    !sizeCache?.[0] && setSizeCache([
                                                        width,
                                                        height
                                                    ]);
                                                },
                                                style: {
                                                    width: "100%",
                                                    objectFit: "cover"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "ft absolute bottom-6 right-6"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "r",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "inner",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "t",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "progress flex rounded-full bg-gray-700/50 w-full h-[6px] mt-1 overflow-hidden",
                                                        onClick: nextShowcase,
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "inner bg-logseq-100 rounded-full transition-all",
                                                            style: {
                                                                width: `${progress}%`
                                                            }
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "b",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "fd",
                                                            children: it.feedback
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "ft",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "flex flex-col",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            className: "font-normal opacity-60",
                                                                            children: "User Feedback"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "font-normal opacity-60 pr-2",
                                                                                    children: "by"
                                                                                }),
                                                                                it.userName
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "flex items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "opacity-60",
                                                                            children: "Via "
                                                                        }),
                                                                        it.refType === "discord" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa33c7059515b2b5$export$2e2bcd8739ae039), {
                                                                                    className: "mx-2",
                                                                                    size: 30,
                                                                                    weight: "duotone"
                                                                                }),
                                                                                " ",
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "opacity-60",
                                                                                    children: "Discord"
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $022a4e84fc180583$export$2e2bcd8739ae039), {
                                                                                    className: "mx-2",
                                                                                    size: 30,
                                                                                    weight: "duotone"
                                                                                }),
                                                                                " ",
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "opacity-60",
                                                                                    children: "Twitter"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "border rounded p-1 border-gray-600 ml-3 bg-gray-500/20 cursor-pointer active:opacity-80",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                                target: "_blank",
                                                                                href: it.refLink,
                                                                                "aria-label": `${it.userName}'s comment in ${it.refType}`,
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6925feee259dfec9$export$2e2bcd8739ae039), {
                                                                                    size: 18,
                                                                                    weight: "duotone"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }, it.label);
                })
            })
        ]
    });
}



function $1ddabedec9b02645$export$36d69433c4f81145() {
    const appState = (0, $0b89d474933103bc$export$9973955de2bf96cf)();
    // useEffect(() => {
    //   setTimeout(() => {
    //     // @ts-ignore
    //     particlesJS.load('particles-bg', './particlesjs-config.json', () => {
    //     })
    //   }, 1000)
    // }, [])
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-page min-h-screen",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "page-inner",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54353c0316b7db10$export$a7b2fab40a242d96), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db27b74bdbc5c721$export$aed4c85e0e07e0de), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27b68f2c8db94444$export$912807921f43ced2), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "page-inner-full-wrap a",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "page-inner",
                    children: [
                        appState.sm.get() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, $db0bad02d0b0ecf1$export$4fab7e31df46e124),
                            className: "w-full",
                            alt: "image"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, $db0bad02d0b0ecf1$export$6429944a9ed86acc),
                            className: "w-full",
                            alt: "image"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a7a7174f7bc9055$export$24fab8e739feba68), {
                            ticks: [
                                500,
                                600
                            ],
                            className: "text-slogan",
                            children: (t)=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("text-4xl sm:text-[60px] sm:flex sm:flex-col justify-center sm:text-center pb-6 invisible", t[0] && "ani-slide-in-from-bottom"),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-logseq-50/80",
                                                    children: "Overwhelmed and constantly "
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    className: "opacity-90",
                                                    children: "afraid of losing your thoughts?"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("sm:flex flex-col justify-center sm:text-center text-2xl tracking-wide invisible", t[1] && "ani-fade-in"),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-logseq-50/80",
                                                    children: "Everyday you’re bombarded with information."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-logseq-50/80",
                                                    children: "Your non-connected notes lead to missing context when "
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                    className: "font-normal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-logseq-50/80",
                                                            children: "you need it. "
                                                        }),
                                                        "That gets future-you into trouble."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "page-inner",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ccba936592c25c2$export$d2efe51c2d0e6c45), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "page-inner-full-wrap b relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "page-inner footer-desc",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $717c681f9cec0e89$export$e458e76844d3be8d), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "page-inner footer-nav",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "page-inner",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $717c681f9cec0e89$export$314961f1e384fdc0), {})
                        })
                    })
                ]
            })
        ]
    });
}






var $acw62 = parcelRequire("acw62");


var $25389f4a90a3ea51$var$c = Object.defineProperty, $25389f4a90a3ea51$var$Z = Object.defineProperties;
var $25389f4a90a3ea51$var$M = Object.getOwnPropertyDescriptors;
var $25389f4a90a3ea51$var$l = Object.getOwnPropertySymbols;
var $25389f4a90a3ea51$var$o = Object.prototype.hasOwnProperty, $25389f4a90a3ea51$var$p = Object.prototype.propertyIsEnumerable;
var $25389f4a90a3ea51$var$n = (t, e, H)=>e in t ? $25389f4a90a3ea51$var$c(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: H
    }) : t[e] = H, $25389f4a90a3ea51$var$r = (t, e)=>{
    for(var H in e || (e = {}))$25389f4a90a3ea51$var$o.call(e, H) && $25389f4a90a3ea51$var$n(t, H, e[H]);
    if ($25389f4a90a3ea51$var$l) for (var H of $25389f4a90a3ea51$var$l(e))$25389f4a90a3ea51$var$p.call(e, H) && $25389f4a90a3ea51$var$n(t, H, e[H]);
    return t;
}, $25389f4a90a3ea51$var$m = (t, e)=>$25389f4a90a3ea51$var$Z(t, $25389f4a90a3ea51$var$M(e));
const $25389f4a90a3ea51$var$i = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM40,76H216a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24ZM216,180H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,64V192H40V64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,120v16a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120a8,8,0,0,1,8-8H216A8,8,0,0,1,224,120Zm-8,56H40a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V184A8,8,0,0,0,216,176Zm0-128H40a8,8,0,0,0-8,8V72a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM40,70H216a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12ZM216,186H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM40,68H216a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8ZM216,188H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Z"
        }))
    ]
]), $25389f4a90a3ea51$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $25389f4a90a3ea51$var$m($25389f4a90a3ea51$var$r({
        ref: e
    }, t), {
        weights: $25389f4a90a3ea51$var$i
    })));
$25389f4a90a3ea51$export$2e2bcd8739ae039.displayName = "List";


var $acw62 = parcelRequire("acw62");


var $f884a897a9f987c7$var$c = Object.defineProperty, $f884a897a9f987c7$var$o = Object.defineProperties;
var $f884a897a9f987c7$var$p = Object.getOwnPropertyDescriptors;
var $f884a897a9f987c7$var$n = Object.getOwnPropertySymbols;
var $f884a897a9f987c7$var$E = Object.prototype.hasOwnProperty, $f884a897a9f987c7$var$d = Object.prototype.propertyIsEnumerable;
var $f884a897a9f987c7$var$r = (t, a, l)=>a in t ? $f884a897a9f987c7$var$c(t, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[a] = l, $f884a897a9f987c7$var$m = (t, a)=>{
    for(var l in a || (a = {}))$f884a897a9f987c7$var$E.call(a, l) && $f884a897a9f987c7$var$r(t, l, a[l]);
    if ($f884a897a9f987c7$var$n) for (var l of $f884a897a9f987c7$var$n(a))$f884a897a9f987c7$var$d.call(a, l) && $f884a897a9f987c7$var$r(t, l, a[l]);
    return t;
}, $f884a897a9f987c7$var$L = (t, a)=>$f884a897a9f987c7$var$o(t, $f884a897a9f987c7$var$p(a));
const $f884a897a9f987c7$var$i = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z"
        }))
    ]
]), $f884a897a9f987c7$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $f884a897a9f987c7$var$L($f884a897a9f987c7$var$m({
        ref: a
    }, t), {
        weights: $f884a897a9f987c7$var$i
    })));
$f884a897a9f987c7$export$2e2bcd8739ae039.displayName = "X";



var $acw62 = parcelRequire("acw62");


var $5fcba42db413158c$exports = {};

$5fcba42db413158c$exports = new URL((parcelRequire("27Lyk")).resolve("knCKW"), import.meta.url).toString();


const $92499cee72729839$var$logo = new URL($5fcba42db413158c$exports);
function $92499cee72729839$export$a7b7352682465020(props) {
    const { items: items, className: className, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("links-group sm:ml-6 h-full", className),
        ...rest,
        children: items.map((it)=>{
            const inner = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    it.label,
                    it.icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "pl-2 opacity-40 group-hover:opacity-80",
                                children: it.icon
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "sr-only",
                                children: " (opens a new window)"
                            })
                        ]
                    })
                ]
            });
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                className: "flex items-center",
                "data-link": it.link?.toString().toLowerCase(),
                children: it.link.startsWith("http") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: it.link,
                    target: "_blank",
                    className: "h-full flex items-center group transition-colors",
                    children: inner
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                    to: it.link,
                    className: ({ isActive: isActive })=>{
                        return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("h-full flex items-center group transition-colors", isActive && "app-link-active");
                    },
                    children: inner
                })
            }, it.label.toString());
        })
    });
}
function $92499cee72729839$export$15e4adf56d9cf619() {
    const [rightActive, setRightActive] = (0, $acw62.useState)(false);
    const [urlParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    // without header
    if (urlParams.has("x")) return;
    (0, $acw62.useEffect)(()=>{
        const outsideHandler = (e)=>{
            const target = e.target;
            const isToggle = !!target.closest("a.nav-toggle");
            if (isToggle) return setRightActive(!rightActive);
            rightActive && setRightActive(false);
        };
        document.body.addEventListener("click", outsideHandler);
        return ()=>{
            document.body.removeEventListener("click", outsideHandler);
        };
    }, [
        rightActive
    ]);
    (0, $acw62.useEffect)(()=>{
        if (rightActive) document.body.classList.add("is-nav-open");
        else document.body.classList.remove("is-nav-open");
    }, [
        rightActive
    ]);
    const leftLinks = [
        {
            label: "Home",
            link: "/"
        },
        // {
        //   label: (<>
        //     <span>Pro</span>
        //     <sup className={'pl-1 opacity-90 group-hover:opacity-100 text-xs font-medium text-pro-500'}>New</sup>
        //   </>), link: '/pro'
        // },
        {
            label: "Downloads",
            link: "/downloads"
        }
    ];
    const rightLinks = [
        {
            label: "Forum",
            link: "https://discuss.logseq.com",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6925feee259dfec9$export$2e2bcd8739ae039), {
                size: 15,
                weight: "bold"
            })
        },
        {
            label: "Docs",
            link: "https://docs.logseq.com/",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6925feee259dfec9$export$2e2bcd8739ae039), {
                size: 15,
                weight: "bold"
            })
        },
        {
            label: "Github",
            link: "https://github.com/logseq",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6925feee259dfec9$export$2e2bcd8739ae039), {
                size: 15,
                weight: "bold"
            })
        },
        {
            label: "Blog",
            link: "https://blog.logseq.com",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6925feee259dfec9$export$2e2bcd8739ae039), {
                size: 15,
                weight: "bold"
            })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "app-headbar h-14 flex justify-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-center justify-between w-full",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center h-full flex-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: "/",
                            className: "app-logo-link mr-2",
                            "aria-label": `Home`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: $92499cee72729839$var$logo,
                                alt: "Logseq"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($92499cee72729839$export$a7b7352682465020, {
                            className: "justify-center sm:justify-start",
                            items: leftLinks
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("right-group flex items-center h-full", {
                        ["is-active"]: rightActive
                    }),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            className: "nav-toggle flex h-full items-center sm:hidden",
                            children: rightActive ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f884a897a9f987c7$export$2e2bcd8739ae039), {
                                size: 24,
                                weight: "bold"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25389f4a90a3ea51$export$2e2bcd8739ae039), {
                                size: 24,
                                weight: "bold"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "right-group-inner",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($92499cee72729839$export$a7b7352682465020, {
                                    className: "justify-center space-x-2 py-6 w-full mx-1 border-t border-t-logseq-500 sm:mr-0",
                                    items: rightLinks
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "downloads-select mt-2 sm:ml-8 sm:mt-0",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b83dbd58d0bae96$export$434a045e59e6bdd3), {
                                        children: ({ active: active, rightIconFn: rightIconFn, leftIconFn: leftIconFn })=>{
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                className: "flex items-center bg-sky-700 px-2 py-1 rounded text-sm hover:opacity-80 select-none cursor-pointer",
                                                children: [
                                                    typeof leftIconFn === "function" ? leftIconFn({
                                                        weight: "bold"
                                                    }) : leftIconFn,
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "pl-2",
                                                        children: [
                                                            "Download for ",
                                                            active?.[0]
                                                        ]
                                                    }),
                                                    rightIconFn?.()
                                                ]
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $a84d7efb22587ccc$var$L = Object.defineProperty, $a84d7efb22587ccc$var$Z = Object.defineProperties;
var $a84d7efb22587ccc$var$o = Object.getOwnPropertyDescriptors;
var $a84d7efb22587ccc$var$m = Object.getOwnPropertySymbols;
var $a84d7efb22587ccc$var$p = Object.prototype.hasOwnProperty, $a84d7efb22587ccc$var$E = Object.prototype.propertyIsEnumerable;
var $a84d7efb22587ccc$var$n = (t, a, l)=>a in t ? $a84d7efb22587ccc$var$L(t, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: l
    }) : t[a] = l, $a84d7efb22587ccc$var$r = (t, a)=>{
    for(var l in a || (a = {}))$a84d7efb22587ccc$var$p.call(a, l) && $a84d7efb22587ccc$var$n(t, l, a[l]);
    if ($a84d7efb22587ccc$var$m) for (var l of $a84d7efb22587ccc$var$m(a))$a84d7efb22587ccc$var$E.call(a, l) && $a84d7efb22587ccc$var$n(t, l, a[l]);
    return t;
}, $a84d7efb22587ccc$var$c = (t, a)=>$a84d7efb22587ccc$var$Z(t, $a84d7efb22587ccc$var$o(a));
const $a84d7efb22587ccc$var$A = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M168.49,104.49,145,128l23.52,23.51a12,12,0,0,1-17,17L128,145l-23.51,23.52a12,12,0,0,1-17-17L111,128,87.51,104.49a12,12,0,0,1,17-17L128,111l23.51-23.52a12,12,0,0,1,17,17ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm37.66,130.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M164.24,100.24,136.48,128l27.76,27.76a6,6,0,1,1-8.48,8.48L128,136.48l-27.76,27.76a6,6,0,0,1-8.48-8.48L119.52,128,91.76,100.24a6,6,0,0,1,8.48-8.48L128,119.52l27.76-27.76a6,6,0,0,1,8.48,8.48ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M162.83,98.83,133.66,128l29.17,29.17a4,4,0,0,1-5.66,5.66L128,133.66,98.83,162.83a4,4,0,0,1-5.66-5.66L122.34,128,93.17,98.83a4,4,0,0,1,5.66-5.66L128,122.34l29.17-29.17a4,4,0,1,1,5.66,5.66ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z"
        }))
    ]
]), $a84d7efb22587ccc$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((t, a)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a51719eb0f3aa1eb$export$2e2bcd8739ae039), $a84d7efb22587ccc$var$c($a84d7efb22587ccc$var$r({
        ref: a
    }, t), {
        weights: $a84d7efb22587ccc$var$A
    })));
$a84d7efb22587ccc$export$2e2bcd8739ae039.displayName = "XCircle";



var $acw62 = parcelRequire("acw62");
function $90331d9be87f723f$export$2b77a92f1a5ad772(props) {
    const { id: id, visible: visible, destroy: destroy, className: className, hasClose: hasClose, children: children, onClick: onClick, ...rest } = props;
    const refInner = (0, $acw62.useRef)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("ui-modal", className, visible ? "" : "hidden"),
        onClick: ({ target: target })=>{
            if (target && refInner.current?.contains(target)) return;
            destroy();
        },
        ...rest,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "ui-modal-inner",
            ref: refInner,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ui-modal-content",
                    children: children
                }),
                hasClose !== false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: "ui-modal-close",
                    onClick: destroy,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a84d7efb22587ccc$export$2e2bcd8739ae039), {
                        size: 30,
                        weight: "duotone"
                    })
                })
            ]
        })
    });
}





// @ts-ignore

var $097b58d437797c3f$export$2e2bcd8739ae039 = '<h1>Terms of Use</h1>\n<p>Logseq, Inc., a Delaware corporation (“we” “our” or “us”), welcomes you to our website (the “<strong><em>Site</em></strong>”) and the applications and services available from us, through the Site or other platforms (collectively with the Site, the “<strong><em>Services</em></strong>”). Your use of the Site and the Services are governed by these Terms of Use (these “<strong><em>Terms</em></strong>”). Any time you browse the Site or use the Services in any way, you agree to be bound by these Terms. If you don’t agree to these Terms, do not use the Site or the Services.</p>\n<p>Your use of the Services is also subject to our Privacy Policy, which is located on the Site, as well as any policies and procedures we publish from time to time (collectively, the “<strong><em>Policies</em></strong>”). We reserve the right to modify these Terms at any time, with such changes becoming effective when we post the modified Terms to the Site. We also reserve the right to make any changes to the Site and Services in any manner and to deny or terminate your access to the Site and Services, even if you have an Account, in our sole discretion.</p>\n<p>Each time you use the Site or the Services, the then-current version of the Terms will apply. If you use the Site or the Services after a modification of these Terms, you agree to be bound by the Terms as modified.</p>\n<p><strong><em>These Terms contain important information regarding your rights with respect to the Site and the Services, including your relationship with us, and include an arbitration provision that may limit your ability to pursue claims against us in court. Please read them carefully and review them regularly.</em></strong></p>\n<p><strong>1. Eligibility</strong><br>When you use the Services, you represent that you are (i) at least the age of majority in the jurisdiction where you reside or (ii) if you have not reached the age of majority in the jurisdiction where you reside, that you have received permission to use the Services from your parent or legal guardian.</p>\n<p>You represent that any information you submit to us when using the Services is accurate, truthful, and current. You also represent that your use of the Services does not violate any applicable law or regulation.</p>\n<p><strong>2. Registration &amp; Account</strong><br>Certain of the Services or portions of the Site may require you to register for an account (“<strong><em>Account</em></strong>”), becoming a “<strong><em>Registered User</em></strong>”. As part of the Account creation process, you may be asked to provide a username and password unique to the Account (“<strong><em>Login Information</em></strong>”). You are responsible for the confidentiality and use of your Login Information and agree not to transfer or disclose your Login Information to any third party other than an individual with express authority to act on your behalf. If you suspect any unauthorized use of your Account, you agree to notify us immediately. You are solely responsible for any activities occurring under your Account. You have no ownership right to your Account.  If you are registering an Account as the authorized user of an organization, that organization may have administrator rights to access your account and any information provided under your Account.</p>\n<p><strong>3. Organizational Accounts</strong><br>If you register for the Services on behalf of an organization, you may grant access to the Services to certain authorized users, subject to the limits of any plan for which you enroll. We may require that each authorized user have unique Login Information. When registering for an Account and accessing the Services, you represent or warrant that the information you enter for your organization is correct. You acknowledge and agree that (i) the organizational account owner is responsible for all activity under authorized user accounts and (ii) organizational administrators may have access to all activity/data under all authorized users’ accounts.</p>\n<p><strong>4. Permitted Uses/License</strong><br>You are authorized to access the Site for the sole purpose of viewing and using the Services on your computer or device. We authorize you to copy materials from the Services to your hard drive solely for the purpose of viewing and using the Services on your computer.</p>\n<p>You may not decompile, disassemble, rent, lease, loan, sell, sublicense, or create derivative works from the Site, the Services, or any data thereon. You may not use any robot, spider, or other automatic device or manual process to monitor or copy the Site or its content without our prior written permission. Your failure to abide by these conditions will immediately terminate your right to access the Site or to use the Services and may violate our intellectual property rights or the intellectual property rights of third parties.</p>\n<p><strong>5. Third Party Software</strong><br>Some of the Services may include the ability to integrate or connect with third party software (“<strong><em>Third Party Software</em></strong>”). You acknowledge and agree that we do not operate, control, or maintain any Third Party Software and we make no representation or warranty in respect to the Third Party Software or how our Services function with any Third Party Software. Your use of any Third Party Software will be governed by the End User License Agreement, Terms of Use, or other applicable agreement with the relevant third party, and you acknowledge and agree that your use of the Third Party Software is contingent upon your review of and consenting to the applicable agreement prior to such use.</p>\n<p><strong>6. Third Party Sites</strong><br>The Site may contain links to websites we do not operate, control, or maintain (“<strong><em>Third Party Websites</em></strong>”). We do not endorse any Third Party Websites, and we make no representation or warranty in any respect regarding the Third Party Websites. Any links to Third Party Websites on the Site are provided solely for your convenience. If you do access any Third Party Websites, you do so at your own risk and waive any and all claims against us regarding the Third Party Websites or our links thereto.</p>\n<p><strong>7. User Content Generally</strong><br>When you post content and information to the Site or in connection with the Services (“<strong><em>User Content</em></strong>”), you represent and warrant to us that (i) you own or have rights to use the User Content, (ii) the posting of the User Content does not violate any rights of any person or entity, and (iii) you have no agreement with or obligations to any third party that would prohibit your use of the Site or Services in the manner so used. You agree to pay all royalties, fees, and any other monies owing to any person or entity by reason of any User Content posted by you to the Site or through the Services.</p>\n<p>By posting User Content in a publicly-accessible portion of the Services, you give us and our affiliates a perpetual, nonexclusive, irrevocable, royalty-free, sublicensable and transferable worldwide license to all intellectual property rights you own or control to use, transmit, reproduce, commercialize, distribute, modify, create derivative works from, and otherwise exploit such User Content for any and all purposes and without further notice to you, attribution, and without the requirement of any permission or payment to you or any other person or entity. You also authorize and appoint us as your attorney in fact and agent with full power to enter into and execute any document or undertake any action we may consider appropriate to use or enforce the grant of rights and waivers set forth in these Terms.</p>\n<p><strong>8. User Conduct</strong><br>You agree not to use the Site or the Services to take any action or actions that (including with respect to any User Content): (i) are patently offensive in any manner (as determined in our sole discretion), (ii) involve commercial activities without our prior written consent, such as contests or sweepstakes, (iii) are contrary to our public image, goodwill, or reputation, (iv) infringe on our or any third party’s intellectual property rights, (v) violate any law or any third party’s legal rights, or (vi) “frame” or “mirror” any part of the Site without our prior written consent.</p>\n<p><strong>9. Data</strong><br>You agree that we have the right to collect and analyze data and other information relating to the provision, use and performance of various aspects of the Site and Services, and related systems (for example, anonymous and aggregated information concerning user behavior and use of the Services), and we will be free (during and after the term hereof) to (i) use such information and data to improve and enhance the Site Services and for other development, diagnostic and corrective purposes in connection with the Site and Services and other of our offerings, and (ii) disclose such data solely in aggregate or other de-identified form in connection with its business.</p>\n<p><strong>10. Paid Services</strong><br>We may require Services to be paid for on a recurring basis (“<strong><em>Subscription Services</em></strong>”) or on an as-used basis (“<strong><em>A La Carte Services</em></strong>” and, together with the Subscription Services, “<strong><em>Paid Services</em></strong>”). We have the right to change, delete, discontinue or impose conditions on Paid Services or any feature or aspect of a Paid Service. Subscription Services may subject you to recurring fees and/or terms. By signing up for a Subscription Service, including after any free trial period, you agree to pay us the subscription fee and any applicable taxes as set forth in your Account settings or as otherwise agreed in writing (“<strong><em>Subscription Fee</em></strong>”). A La Carte Services may subject you to fees charged per usage and/or terms. By using an A La Carte Service, you agree to pay the fees and any taxes incurred at the time of usage (“<strong><em>A La Carte Fees</em></strong>” and, together with Subscription Fees, the “<strong><em>Paid Service Fees</em></strong>”).</p>\n<p>Paid Service Fees may be paid by credit card, debit card, or other payment forms we may permit. If you link a debit or credit card to your Account, you authorize us to collect Paid Service Fees by debit from your linked debit card or charge to your linked credit card.</p>\n<p>Unless otherwise provided in a Subscription Service’s terms, Subscription Fees will be charged every month on the day that the subscription was started, until cancelled. You may cancel a Subscription Service at any time from your Account settings. If you cancel a Subscription Service, you will continue to have access to that Subscription Service through the end of your then current billing period, but you will not be entitled to a refund or credit for any Subscription Fee already due or paid. We reserve the right to change our Subscription Fee upon thirty (30) days’ advance notice. Your continued use of Subscription Services after notice of a change to our Subscription Fee will constitute your agreement to such changes.</p>\n<p><strong>11. Copyright Infringement</strong><br>We respect the intellectual property rights of others. The Digital Millennium Copyright Act of 1998 (the “<strong><em>DMCA</em></strong>”) provides a complaint procedure for copyright owners who believe that website material infringes their rights under U.S. copyright law. If you believe that your work has been improperly copied and posted on the website, please provide us with the following information: (i) name, address, telephone number, email address and an electronic or physical signature of the copyright owner or of the person authorized to act on his/her behalf; (ii) a description of the copyrighted work that you claim has been infringed; (iii) a description of where on the Site the material that you claim is infringing is located; (iv) a written statement that you have a good faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law; and (v) a statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright owner or authorized to act on the copyright owner’s behalf. These requirements must be followed to give us legally sufficient notice of infringement. Send copyright infringement complaints to the following email address: <a href="mailto:support@logseq.com">support@logseq.com</a>. We suggest that you consult your legal advisor before filing a DMCA notice with our copyright agent. There can be penalties for false claims under the DMCA.</p>\n<p><strong>12. Warranty Disclaimer</strong><br><strong>You agree that the Services are available on an “as is” basis, without any warranty, and that you use the Services at your own risk. We disclaim, to the maximum extent permitted by law, any and all warranties, whether express or implied, including, without limitation, (a) warranties of merchantability or fitness for a particular purpose, (b) warranties against infringement of any third party intellectual property or proprietary rights, (c) warranties relating to delays, interruptions, errors, or omissions in the Services or on the Site, (d) warranties relating to the accuracy or correctness of data on the Services, and (e) any other warranties otherwise relating to our performance, nonperformance, or other acts or omissions.</strong></p>\n<p><strong>We do not warrant that the Site or the Services will operate error-free or that the Site is free of computer viruses and/or other harmful materials. If your use of the Site or the Services results in the need for servicing or replacing equipment or data, we are not responsible for any such costs.</strong></p>\n<p>Some jurisdictions do not allow the exclusion or limitation of certain categories of damages or implied warranties; therefore, the above limitations may not apply to you. In such jurisdictions, our liability is limited to the greatest extent permitted by law.</p>\n<p><strong>13. Limitation of Liability</strong><br><strong>Any liability we have to you in connection with these Terms, under any cause of action or theory, is strictly limited to, in aggregate for all violations, the amount paid to you by us for your use of the Services in the six-month period immediately preceding the events giving rise to the claim. Without limiting the previous sentence, in no event shall we or any of our affiliates be liable to you for any indirect, special, incidental, consequential, punitive, or exemplary damages arising out of or in connection with these Terms. The foregoing limitations apply whether the alleged liability is based on contract, tort, negligence, strict liability, or any other basis, even if we or our affiliates have been advised of the possibility of such damages.</strong></p>\n<p><strong>You agree to indemnify and hold us harmless for any breach of security or any compromise of your Account.</strong></p>\n<p>Some jurisdictions do not allow the exclusion or limitation of incidental or consequential; therefore, the above limitations may not apply to you. In such jurisdictions, our liability is limited to the greatest extent permitted by law.</p>\n<p><strong>14. Indemnification</strong><br>You agree to indemnify and hold harmless us, our affiliates and our and their officers, directors, partners, agents, and employees from and against any loss, liability, claim, or demand, including reasonable attorneys’ fees (collectively, “<strong><em>Claims</em></strong>”), made by any third party due to or arising out of your use of the Site and Services in violation of these Terms, any breach of the representations and warranties you make in these Terms, or your User Content. You agree to be solely responsible for defending any Claims against or suffered by us, subject to our right to participate with counsel of our own choosing.</p>\n<p><strong>15. Electronic Signatures and Notices</strong><br>Certain activities on the Services may require you to make an electronic signature. You understand and accept that an electronic signature has same legal rights and obligations as a physical signature.</p>\n<p>If you have an Account, you agree that we may provide you any and all required notices electronically through your Account or other electronic means. You agree that we are not responsible for any delivery fees charged to you as a result of your receipt of our electronic notices.</p>\n<p><strong>16. Governing Law</strong><br>These Terms are governed by New York law, without giving effect to conflicts of law principles. You agree that, to the extent applicable and expressly subject to the dispute resolution provisions below, to submit to the exclusive jurisdiction of the state and federal courts located in New York in circumstances where these Terms permit litigation in court.</p>\n<p><strong>17. Dispute Resolution</strong><br><strong>Please read this section carefully. It contains procedures for mandatory binding arbitration and a class action waiver.</strong></p>\n<p><em>Notice Requirement and Informal Dispute Resolution</em>.\xa0\xa0Before either we or you may seek arbitration, the party seeking arbitration must send the other party a written Notice of Dispute (“<strong><em>Notice</em></strong>”) describing the nature and basis of the claim or dispute and the requested relief.\xa0\xa0A Notice to us should be sent to: Logseq, Inc., 228 Park Avenue South, PMB 76315, New York, NY 10003, United States.\xa0\xa0After the Notice is received, you and we may attempt to resolve the claim or dispute informally.\xa0\xa0If we do not resolve the claim or dispute within thirty (30) days after the Notice is received, either party may begin an arbitration proceeding.\xa0The amount of any settlement offer made by any party may not be disclosed to the arbitrator until after the arbitrator has determined the amount of the award, if any, to which either party is entitled.</p>\n<p><em>Arbitration Rules</em>.\xa0\xa0Arbitration shall be initiated through the American Arbitration Association (“<strong><em>AAA</em></strong>”), an established alternative dispute resolution provider (“<strong><em>ADR Provider</em></strong>”) that offers arbitration as set forth in this section.\xa0\xa0If AAA is not available to arbitrate, the parties shall agree to select an alternative ADR Provider.\xa0\xa0The rules of the ADR Provider shall govern all aspects of the arbitration, including but not limited to the method of initiating and/or demanding arbitration, except to the extent such rules are in conflict with the Terms.\xa0\xa0The AAA Commercial Arbitration Rules (the “<strong><em>Arbitration Rules</em></strong>”) governing the arbitration are available online at\xa0<a href="http://www.adr.org/">www.adr.org</a>\xa0or by calling the AAA at 1-800-778-7879.\xa0\xa0The arbitration shall be conducted by a single, neutral arbitrator.\xa0\xa0Any claims or disputes where the total amount of the award sought is less than Ten Thousand U.S. Dollars (US $10,000.00) shall be resolved through binding non-appearance-based arbitration.\xa0\xa0For claims or disputes where the total amount of the award sought is Ten Thousand U.S. Dollars (US $10,000.00) or more, the right to a hearing will be determined by the Arbitration Rules.\xa0Any hearing will be held in New York, unless the parties agree otherwise. Any judgment on the award rendered by the arbitrator may be entered in any court of competent jurisdiction.\xa0 Each party shall bear its own costs (including attorney’s fees) and disbursements arising out of the arbitration and shall pay an equal share of the fees and costs of the ADR Provider.</p>\n<p><em>Additional Rules for Non-Appearance Based Arbitration</em>.\xa0\xa0The arbitration shall be conducted by telephone, online and/or based solely on written submissions; the specific manner shall be chosen by the party initiating the arbitration.\xa0\xa0The arbitration shall not involve any personal appearance by the parties or witnesses unless otherwise agreed by the parties.</p>\n<p><em>Time Limits.</em>\xa0\xa0If either you or we pursue arbitration, the arbitration action must be initiated and/or demanded within the statute of limitations (i.e., the legal deadline for filing a claim) and within any deadline imposed under the AAA Rules for the pertinent claim.</p>\n<p><em>Authority of Arbitrator</em>.\xa0\xa0If arbitration is initiated, the arbitrator will decide the rights and liabilities, if any, of the parties involved, and the dispute will not be consolidated with any other matters or joined with any other cases or parties.\xa0\xa0The arbitrator shall have the authority to grant motions dispositive of all or part of any claim.\xa0\xa0The arbitrator shall have the authority to award monetary damages, and to grant any non-monetary remedy or relief available to an individual under applicable law, the Arbitration Rules, and these Terms.\xa0\xa0The arbitrator shall issue a written award and statement of decision describing the essential findings and conclusions on which the award is based, including the calculation of any damages awarded.\xa0\xa0The arbitrator has the same authority to award relief on an individual basis that a judge in a court of law would have.\xa0\xa0The award of the arbitrator is final and binding upon you and us.</p>\n<p><em>Waiver of Jury Trial.</em>\xa0\xa0THE PARTIES HEREBY WAIVE THEIR CONSTITUTIONAL AND STATUTORY RIGHTS TO GO TO COURT AND HAVE A TRIAL IN FRONT OF A JUDGE OR A JURY, instead electing that all claims and disputes shall be resolved by arbitration under these terms.\xa0\xa0Arbitration procedures are typically more limited, more efficient and less costly than rules applicable in a court and are subject to very limited review by a court.\xa0\xa0In the event any litigation should arise between you and us in any state or federal court in a suit to vacate or enforce an arbitration award or otherwise, YOU AND WE WAIVE ALL RIGHTS TO A JURY TRIAL, instead electing that the dispute be resolved by a judge.</p>\n<p><em>Waiver of Class or Consolidated Actions</em>.\xa0\xa0ALL CLAIMS AND DISPUTES WITHIN THE SCOPE OF THIS SECTION 17 MUST BE ARBITRATED OR LITIGATED ON AN INDIVIDUAL BASIS AND NOT ON A CLASS BASIS, AND CLAIMS OF MORE THAN ONE USER CANNOT BE ARBITRATED OR LITIGATED JOINTLY OR CONSOLIDATED WITH THOSE OF ANY OTHER USER.\xa0</p>\n<p><em>Confidentiality</em>.\xa0\xa0All aspects of the arbitration proceeding, including but not limited to the award of the arbitrator and compliance therewith, shall be strictly confidential.\xa0\xa0You agree to maintain confidentiality unless otherwise required by law.\xa0\xa0This paragraph shall not prevent a party from submitting to a court of law any information necessary to enforce this Section 17, to enforce an arbitration award, or to seek injunctive or equitable relief.</p>\n<p><em>Severability</em>.\xa0\xa0If any part or parts of this Section 17 are found under the law to be invalid or unenforceable by a court of competent jurisdiction, then such specific part or parts shall be of no force and effect and shall be severed and the remainder of this Section 17 shall continue in full force and effect.</p>\n<p><em>Right to Waive.</em>\xa0\xa0Any or all of the rights and limitations set forth in this Section 17 may be waived by the party against whom the claim is asserted.\xa0\xa0Such waiver shall not waive or affect any other portion of this Section 17.</p>\n<p><em>Survival of Agreement</em>.\xa0\xa0This Section 17 will survive the termination of your relationship with us.\xa0</p>\n<p><em>Small Claims Court.</em>\xa0\xa0Notwithstanding the foregoing, either you or we may bring an individual action in small claims court.</p>\n<p><em>Emergency Equitable Relief</em>.\xa0\xa0Notwithstanding the foregoing, either party may seek emergency equitable relief before a state or federal court in order to maintain the status quo pending arbitration.\xa0\xa0A request for interim measures shall not be deemed a waiver of any other rights or obligations under this Section 17.</p>\n<p>_Claims Not Subject to Arbitration.\xa0_Notwithstanding the foregoing, claims of defamation, violation of the Computer Fraud and Abuse Act, and infringement or misappropriation of our patent, copyright, trademark or trade secrets rights shall not be subject to this Section 17.</p>\n<p><strong>18. Notice for California Users</strong><br>Under California Civil Code Section 1789.3, California Website users are entitled to the following specific consumer rights notice: The Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs may be contacted in writing at 1625 N. Market Blvd., Suite S-202, Sacramento, California 95834, or by telephone at (800) 952-5210.</p>\n<p><strong>19. Miscellaneous</strong><br>We may assign, transfer, delegate, or otherwise hypothecate our rights under these Terms in our sole discretion. If we fail to enforce a provision of these Terms, you agree that such a failure does not constitute a waiver to enforce the provision (or any other provision hereunder). If any provision of these Terms is held or made invalid, the invalidity does not affect the remainder of these Terms. We reserve all rights not expressly granted in these Terms and disclaim all implied licenses.</p>\n';



function $e43251ebe5c4c2be$export$62a48a1dd4f54e59() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "logseq-terms-content page-inner",
        dangerouslySetInnerHTML: {
            __html: (0, $097b58d437797c3f$export$2e2bcd8739ae039)
        }
    });
}
function $e43251ebe5c4c2be$export$da8a3d5194f851ed() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-page app-terms",
        children: [
            $e43251ebe5c4c2be$export$62a48a1dd4f54e59(),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "page-inner-full-wrap b relative",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "page-inner footer-nav",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "page-inner",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $717c681f9cec0e89$export$314961f1e384fdc0), {})
                    })
                })
            })
        ]
    });
}


// @ts-ignore

var $d69ec8df0aa54e6c$export$2e2bcd8739ae039 = '<h1>Privacy Policy</h1>\n<p>Last Updated: July 28, 2023.</p>\n<p><strong>1. Introduction</strong><br>Welcome to our privacy policy. We are Logseq, Inc., a Delaware corporation (“Logseq”, “we”, or “us”). We are responsible for this website and the Logseq applications.</p>\n<p>Logseq respects your privacy and is committed to protecting your personal data. This privacy policy (“<strong><em>Privacy Policy</em></strong>”) governs our collection and use of data in connection with our website (the “<strong><em>Site</em></strong>”), our applications, our website, and any services we offer (collectively, the “<strong><em>Services</em></strong>”). Terms capitalized but not defined in this Privacy Policy shall have the meaning ascribed to them in our Terms of Use.</p>\n<p>This Privacy Policy sets forth the nature, purpose, use and sharing of any information that identifies or can be used to identify you, the visitors to the Site, and users of our Services (“<strong><em>Personal Information</em></strong>”). This website is not intended for children, and we do not knowingly collect data relating to children. If you believe we have information relating to any individual under the age of 13, please notify us using the methods listed in this policy and we will remove such information as soon as possible.</p>\n<p><strong>A. Who We Are</strong></p>\n<ul>\n<li><p>Full name of legal entity: Logseq, Inc.</p>\n</li>\n<li><p>Name of Data Protection Manager: Zhiyuan Chen</p>\n</li>\n<li><p>Email address: <a href="mailto:support@logseq.com">support@logseq.com</a></p>\n</li>\n<li><p>Postal address: 228 Park Avenue South, PMB 76315, New York, NY 10003, United States</p>\n<p>Our website may include links to or integrations with third-party websites, plug-ins and applications. Clicking on those links, accessing such integrated services, or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements. When you leave our website, we encourage you to read the privacy policy of every website you visit.</p>\n</li>\n</ul>\n<p><strong>B. What We Collect</strong></p>\n<p>We act as a data “controller,” meaning that we collect certain Personal Information from you as you engage the website, our services, or contact us. Data privacy and protection laws across the United States and the European Union (“<strong><em>Privacy Laws</em></strong>”) apply to how we collect that information and what we use it for. To help us comply with Privacy Laws, and because we care about being transparent with you, below is a chart detailing what sort of personal information we collect about you, how we collect it, and why. In some cases, we may collect different information from you based on the type of relationship we have with you, and in such cases the differences are noted.</p>\n<table>\n  <tr>\n   <td>\n<strong>Type of Data</strong>\n   </td>\n   <td><strong>Examples of Data Collected</strong>\n   </td>\n   <td><strong>How Collected</strong>\n   </td>\n   <td><strong>Why Collected/Legal Basis for Collection</strong>\n   </td>\n  </tr>\n  <tr>\n   <td><strong>Identity Data</strong>\n   </td>\n   <td>Email address\n<br />\nUsername\n   </td>\n   <td>Provided by user when account is created.\n   </td>\n   <td>Necessary to provide services.\n<br />\nCollected with consent of user\n   </td>\n  </tr>\n  <tr>\n   <td><strong>Contact Data</strong>\n   </td>\n   <td>Billing address\n<br />\nEmail address\n   </td>\n   <td>Provided by user when account is created.\n   </td>\n   <td>Necessary to provide services.\n   </td>\n  </tr>\n  <tr>\n   <td><strong>Transaction Data</strong>\n   </td>\n   <td>Details of payments to and from you and other users, as well as details about products and services purchased by you.\n   </td>\n   <td>Collected at the time of transaction and/or during contract execution.\n   </td>\n   <td>Necessary to provide services.\n<br />\nOur legitimate business interests allow us to collect such non-intrusive data as your purchasing history so we can more effectively market our products.\n   </td>\n  </tr>\n  <tr>\n   <td><strong>Technical Data</strong>\n   </td>\n   <td>Device information\n<br />\nOperating System (OS)\n<br />\nPlatform (Electron/Browser)\n<br />\nLogseq release version\n   </td>\n   <td>Collected automatically through the Logseq app.\n   </td>\n   <td>Our legitimate business interests allow us to collect this non-intrusive data. \n   </td>\n  </tr>\n</table>\n\n<p><strong>C. Contact details</strong><br>You have the right to make a complaint at any time to the supervisory authority for data protection issues in your jurisdiction. We would, however, appreciate the chance to deal with your concerns before you approach such authorities so please contact us in the first instance.</p>\n<p><strong>D. Changes to the privacy policy and your duty to inform us of changes</strong><br>It is important that the personal data we hold about you is accurate and current. Please keep us informed if your personal data changes during your relationship with us.</p>\n<p><strong>E. Third-party privacy practices</strong><br>This website may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements. When you leave our website, we encourage you to read the privacy policy of every website you visit.</p>\n<p><strong>2. The data we collect about you</strong><br><strong>A. Types of data</strong><br>Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data). We have grouped these different kinds of personal data together as follows:</p>\n<ul>\n<li><strong>Identity Data</strong> may include first name, last name, company name, job title, website URL and other demographic data that you provide to us.</li>\n<li><strong>Contact Data</strong> includes billing address, email address and telephone numbers.</li>\n<li><strong>Financial Data</strong> includes bank account and payment card details.</li>\n<li><strong>Transaction Data</strong> includes details about payments to and from you and other details of products and services you have purchased from us.</li>\n<li><strong>Technical Data</strong> includes internet protocol address, your login data, device/browser type and version, time zone setting, location and time, device/software plug-in types and versions, operating system and platform and other technology on the devices you use to access this website.</li>\n<li>**Profile Data <strong>includes</strong> **your username and password, purchases made by you, your preferences, feedback and survey responses.</li>\n<li><strong>Embedded Data</strong> covers the personal data about you which may be added to the Services by a third party.</li>\n<li><strong>Usage Data</strong> includes information about how you use our website, products and services.</li>\n<li><strong>Marketing and Communications Data</strong> includes your preferences in receiving marketing from us and our third parties and your communication preferences.</li>\n</ul>\n<p>We also collect, use and share <strong>Aggregated Data</strong> such as statistical or demographic data for any purpose. Aggregated Data may be derived from your personal data but is not considered personal data in law as this data does <strong>not</strong> directly or indirectly reveal your identity. For example, we may aggregate your Usage Data to calculate the percentage of users accessing a specific website feature. However, if we combine or connect Aggregated Data with your personal data so that it can directly or indirectly identify you, we treat the combined data as personal data which will be used in accordance with this privacy policy.</p>\n<p>We do not collect any <strong>Special Categories of Personal Data</strong> about you (this includes details about your race or ethnicity, religious or philosophical beliefs, sex life, sexual orientation, political opinions, trade union membership, information about your health and genetic and biometric data). Nor do we collect any information about criminal convictions and offences.</p>\n<p><strong>B. If you fail to provide personal data</strong><br>Where we need to collect personal data by law, or under the terms of a contract we have with you and you fail to provide that data when requested, we may not be able to perform the contract we have or are trying to enter into with you (for example, to provide you with goods or services). In this case, we may have to cancel a product or service you have with us, but we will notify you if this is the case at the time.</p>\n<ol start="3">\n<li><strong>How is your personal data collected?</strong><br>We use different methods to collect data from and about you are including through:</li>\n</ol>\n<p><strong>Direct interactions.</strong> You may give us your Identity, Contact, and Financial Data by filling in forms or by corresponding with us by post, phone, email or otherwise. This includes personal data you provide when you: create an account on our website, use our services, request marketing to be sent to you, or give us feedback.</p>\n<p><strong>Automated technologies or interactions.</strong> As you interact with our products, we may automatically collect Technical Data and Usage Data about your equipment, actions and patterns. We may collect this personal data by using cookies, server logs and other similar technologies. We may also receive Technical Data about you if you visit other websites or use other products employing our cookies or technology.</p>\n<p><strong>Third parties or publicly available sources.</strong> We may receive personal data about you from various third parties and public sources as set out below:</p>\n<ul>\n<li>Technical Data from analytics providers, advertising networks, and search information providers.</li>\n<li>Contact, Financial and Transaction Data from providers of technical, payment, distribution and delivery services.</li>\n<li>Identity and Contact Data from data brokers or aggregators.</li>\n<li>Identity and Contact Data from publicly availably sources.</li>\n<li>Contact, Identity, and Embedded Data from other users of our Services.</li>\n</ul>\n<p><strong>4. How we use your personal data</strong><br>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>\n<ul>\n<li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>\n<li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>\n<li>Where we need to comply with a legal or regulatory obligation.</li>\n</ul>\n<p>Generally, we do not rely on consent as a legal basis for processing your personal data other than in relation to sending third party direct marketing communications to you via email or text message. You have the right to withdraw consent to marketing at any time by contacting us.</p>\n<p><strong>A. Purposes for which we will use your personal data</strong><br>We have set out below, in table format, a description of all the ways we plan to use your personal data, and which of the legal bases we rely on to do so. We have also identified what our legitimate interests are where appropriate.</p>\n<p>Note that we may process your personal data for more than one lawful ground depending on the specific purpose for which we are using your data. Please contact us if you need details about the specific legal ground we are relying on to process your personal data where more than one ground has been set out in the table below.</p>\n<table>\n  <tr>\n   <td>\n<strong>Purpose/Activity</strong>\n   </td>\n   <td><strong>Type of data</strong>\n   </td>\n   <td><strong>Lawful basis for processing including basis of legitimate interest</strong>\n   </td>\n  </tr>\n  <tr>\n   <td>To register you as a new customer\n   </td>\n   <td>(a) Identity \n<br />\n(b) Contact\n   </td>\n   <td>Performance of a contract with you.\n   </td>\n  </tr>\n  <tr>\n   <td>To process and deliver your order of services including:\n<br />\n(a) Manage payments, fees and charges\n<br />\n(b) Collect and recover money owed to us\n   </td>\n   <td>(a) Identity \n<br />\n(b) Contact \n<br />\n(c) Financial \n<br />\n(d) Transaction \n<br />\n(e) Marketing and Communications\n   </td>\n   <td>(a) Performance of a contract with you. \n<br />\n(b) Necessary for our legitimate interests (to recover debts due to us).\n   </td>\n  </tr>\n  <tr>\n   <td>To manage our relationship with you which will include:\n<br />\n(a) Notifying you about changes to our terms or privacy policy\n<br />\n(b) Asking you for feedback\n   </td>\n   <td>(a) Identity \n<br />\n(b) Contact \n<br />\n(c) Profile \n<br />\n(d) Marketing and Communications\n   </td>\n   <td>(a) Performance of a contract with you. \n<br />\n(b) Necessary to comply with a legal obligation.\n<br />\n(c) Necessary for our legitimate interests (to keep our records updated and to study how customers use our products/services).\n   </td>\n  </tr>\n  <tr>\n   <td>To administer and protect our business and products (including troubleshooting, data analysis, testing, system maintenance, support, reporting and hosting of data)  \n   </td>\n   <td>(a) Identity\n<br />\n(b) Contact\n<br />\n(c) Technical\n<br />\n(d) Profile\n   </td>\n   <td>(a) Necessary for our legitimate interests (for running our business, provision of administration and IT services, network security, to prevent fraud and in the context of a business reorganization or group restructuring exercise).\n<br />\n(b) Necessary to comply with a legal obligation.\n   </td>\n  </tr>\n  <tr>\n   <td>To use data analytics to improve our website, products/services, marketing, customer relationships and experiences\n   </td>\n   <td>(a) Technical \n<br />\n(b) Usage \n<br />\n(c) Profile\n   </td>\n   <td>Necessary for our legitimate interests (to define types of customers for our products and services, to keep our website updated and relevant, to develop our business and to inform our marketing strategy).\n   </td>\n  </tr>\n  <tr>\n   <td>To make suggestions and recommendations to you about goods or services that may be of interest to you\n   </td>\n   <td>(a) Identity \n<br />\n(b) Contact \n<br />\n(c) Technical \n<br />\n(d) Usage \n<br />\n(e) Profile \n   </td>\n   <td>Necessary for our legitimate interests (to develop our products/services and grow our business).\n   </td>\n  </tr>\n</table>\n\n<p><strong>B. Promotional offers from us</strong><br>We may use your Identity, Contact, Technical, Usage and Profile Data to form a view on what we think you may want or need, or what may be of interest to you. This is how we decide which products, services and offers may be relevant for you (we call this marketing).</p>\n<p>You will receive marketing communications from us if you have requested information from us or purchased goods or services from us and, in each case, you have not opted out of receiving that marketing.</p>\n<p><strong>C. Third-party marketing</strong><br>We will not share your personal data with any third party for marketing purposes.</p>\n<p><strong>D. Opting out</strong><br>You can ask us or third parties to stop sending you marketing messages at any time by logging into the website and checking or unchecking relevant boxes to adjust your marketing preferences or by following the opt-out links on any marketing message sent to you.</p>\n<p>Where you opt out of receiving these marketing messages, this will not apply to personal data provided to us as a result of a product/service purchase or other transaction.</p>\n<p><strong>E. Cookies</strong><br>In order to improve our services and provide more convenient, relevant experiences to our customers, we and our agents may use “cookies,” “web beacons,” and similar devices to track your activities. A cookie is a small amount of data that is transferred to your browser by a web server and can only be read by the server that gave it to you. It functions as your identification card and enables us to record your passwords and preferences. It cannot be executed as code or deliver viruses. A web beacon is a small transparent .gif image that is embedded in an HTML page or email used to track when the page or email has been viewed. Most browsers are initially set to accept cookies, and most services that include similar devices are typically initially activated to collect data. You can set your browser to notify you when you receive a cookie, giving you the chance to decide whether or not to accept it.</p>\n<p><strong>F. Change of purpose</strong><br>We will only use your personal data for the purposes for which we collected it, unless we reasonably consider that we need to use it for another reason and that reason is compatible with the original purpose. If you wish to get an explanation as to how the processing for the new purpose is compatible with the original purpose, please contact us.</p>\n<p>If we need to use your personal data for an unrelated purpose, we will notify you and explain the legal basis which allows us to do so.</p>\n<p>Please note that we may process your personal data without your knowledge or consent, in compliance with the above rules, where this is required or permitted by law.</p>\n<p><strong>5. Disclosures of your personal data</strong><br>We may have to share your personal data with the parties set out below for the purposes set out in the table in section 3 above.</p>\n<ul>\n<li>Internal Third Parties as set out in Section 13.</li>\n<li>External Third Parties as set out in Section 13.</li>\n<li>Third parties to whom we may choose to sell, transfer, or merge parts of our business or our assets. Alternatively, we may seek to acquire other businesses or merge with them. If a change happens to our business, then the new owners may use your personal data in the same way as set out in this privacy policy.</li>\n</ul>\n<p>We require all third parties to respect the security of your personal data and to treat it in accordance with the law. We do not allow our third-party service providers to use your personal data for their own purposes and only permit them to process your personal data for specified purposes and in accordance with our instructions.</p>\n<p><strong>6. Data Processing</strong><br>In submitting any third-party personal data within the context of the Services (“<strong><em>Third-Party Data</em></strong>”), the parties agree that you shall be the Data Controller and you appoint us as a Data Processor of such data, for the purpose of providing the Services. To the extent that we are a “Data Processor” for you in respect of such Third-Party Data, we will:</p>\n<ul>\n<li>Implement appropriate technical and organizational measures to safeguard the Third-Party Data against any unauthorized or unlawful access, loss, destruction, theft, use or disclosure. We implement basic level security in accordance with United States law. If higher levels of security are required, please contact us.</li>\n<li>Limit access to the Third-Party Data only to those employees who need to know it to enable the Processor to perform the Services, and shall take appropriate steps to ensure the reliability of those of our employees or subcontractors who have access to such Third-Party Data.</li>\n<li>Only process the personal data as specified by this Privacy Policy and in accordance with your instructions, and will not use the Third-Party Data for any purposes other than those related to the performance of the Services or pursuant to your written instructions.</li>\n<li>Upon the expiry or termination of this Privacy Policy, or upon your request, cease any and all use of the Third-Party Data and destroy or return it to you.</li>\n<li>Not disclose the Third-Party Data to any third-party without your prior written consent. Such consent is granted on, for example, your instruction to share a dashboard with third parties (public or within a restricted group).</li>\n</ul>\n<p>We as Data Processor may provide access to a subcontractor processor to any such Third-Party Data if we reasonably consider such access and processing necessary to the performance of the Services. In the event of such access and before the access takes place, we will ensure that an agreement with the third-party is in place which is sufficient to require it to treat personal data in accordance with the applicable provisions of this Privacy Policy and applicable law. In particular, you authorize us to subcontract the provision of technology and commercial services to members of our corporate group.</p>\n<p>You represent and warrant that you have all the appropriate consents from data subjects whose personal data are submitted to us in the course of the provision of the Services.\xa0</p>\n<ol start="7">\n<li><strong>International transfers</strong><br>                                                                                                                                                                           The processing of your personal data will involve transferring it outside the European Economic Area (“<strong><em>EEA</em></strong>”). In addition, many of our external third parties are based outside the EEA, so their processing of your personal data will involve a transfer of data outside the EEA.</li>\n</ol>\n<p>Whenever we transfer your personal data out of the EEA, we ensure a similar degree of protection is afforded to it by ensuring at least one of the following safeguards is implemented:</p>\n<ul>\n<li>We will only transfer your personal data to countries that have been deemed to provide an adequate level of protection for personal data by the European Commission. For further details, see European Commission: Adequacy of the protection of personal data in non-EU countries.</li>\n<li>Where we use certain service providers, we may use specific contracts approved by the European Commission which give personal data the same protection it has in Europe. For further details, see European Commission: Model contracts for the transfer of personal data to third countries.</li>\n<li>Where we use providers based in the US, we may transfer data to them if they provide protections pursuant to the European Commission’s standard contractual clauses.</li>\n</ul>\n<p>Please contact us if you want further information on the specific mechanism used by us when transferring your personal data out of the EEA.</p>\n<p><strong>8. Data security</strong><br>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know. They will only process your personal data on our instructions, and they are subject to a duty of confidentiality.</p>\n<p>We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so.</p>\n<p><strong>9. Data retention</strong><br>We will only retain your personal data for as long as necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.</p>\n<p>To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorized use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal requirements.</p>\n<p>In some circumstances you can ask us to delete your data: see <em>Request erasure</em> below for further in some circumstances we may anonymize your personal data (so that it can no longer be associated with you) for research or statistical purposes in which case we may use this information indefinitely without further notice to you.</p>\n<ol start="10">\n<li><strong>GDPR</strong><br>If you are in the European Union or the EEA, you have the following rights in relation to your personal data:</li>\n</ol>\n<ul>\n<li><strong>Request access</strong> to your personal data (commonly known as a “data subject access request”). This enables you to receive a copy of the personal data we hold about you and to check that we are lawfully processing it.</li>\n<li><strong>Request correction</strong> of the personal data that we hold about you. This enables you to have any incomplete or inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new data you provide to us.</li>\n<li><strong>Request erasure</strong> of your personal data. This enables you to ask us to delete or remove personal data where there is no good reason for us continuing to process it. You also have the right to ask us to delete or remove your personal data where you have successfully exercised your right to object to processing (see below), where we may have processed your information unlawfully or where we are required to erase your personal data to comply with local law. Note, however, that we may not always be able to comply with your request of erasure for specific legal reasons which will be notified to you, if applicable, at the time of your request.</li>\n<li><strong>Object to processing</strong> of your personal data where we are relying on a legitimate interest (or those of a third party) and there is something about your particular situation which makes you want to object to processing on this ground as you feel it impacts on your fundamental rights and freedoms. You also have the right to object where we are processing your personal data for direct marketing purposes. In some cases, we may demonstrate that we have compelling legitimate grounds to process your information which override your rights and freedoms.</li>\n<li><strong>Request restriction of processing</strong> of your personal data. This enables you to ask us to suspend the processing of your personal data in the following scenarios: (a) if you want us to establish the data’s accuracy; (b) where our use of the data is unlawful but you do not want us to erase it; (c) where you need us to hold the data even if we no longer require it as you need it to establish, exercise or defend legal claims; or (d) you have objected to our use of your data but we need to verify whether we have overriding legitimate grounds to use it.</li>\n<li><strong>Request the transfer</strong> of your personal data to you or to a third party. We will provide to you, or a third party you have chosen, your personal data in a structured, commonly used, machine-readable format. Note that this right only applies to automated information which you initially provided consent for us to use or where we used the information to perform a contract with you.</li>\n<li><strong>Withdraw consent at any time</strong> where we are relying on consent to process your personal data. However, this will not affect the lawfulness of any processing carried out before you withdraw your consent. If you withdraw your consent, we may not be able to provide certain products or services to you. We will advise you if this is the case at the time you withdraw your consent.</li>\n</ul>\n<p>If you wish to exercise any of the rights set out above, please contact us.</p>\n<p><strong>A. No fee usually required</strong><br>You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we may refuse to comply with your request in these circumstances.</p>\n<p><strong>B. What we may need from you</strong><br>We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response.</p>\n<p><strong>C. Time limit to respond</strong><br>We try to respond to all legitimate requests within one month. Occasionally it may take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated.</p>\n<p><strong>11. Additional Privacy Rights</strong><br>The California Consumer Privacy Act or “<strong><em>CCPA</em></strong>” (Cal. Civ. Code \xa7 1798.100 et. seq.) and similar statutes afford consumers residing in the applicable states certain rights with respect to their Personal Information (the state privacy statute that applies to you, if any, is referred to herein as the “<strong><em>State Privacy Law</em></strong>”). The rights below apply to all United States residents; provided, however, that your State Privacy Law will apply to the extent it affords you rights greater than those provided herein.</p>\n<p>In the preceding 12 months, we have collected the following categories of Personal Information: identifiers, commercial information, internet or other electronic network activity information, and inferences. For details about the precise data points we collect and the categories of sources of such collection, please see the Collection of Information section above. We collect Personal Information for the business and commercial purposes described in the How Your Information is Used and Disclosure to Third Parties sections above. In the preceding 12 months, we have disclosed the following categories of Personal Information for business purposes to the following categories of recipients:</p>\n<table>\n  <tr>\n   <td><strong>Category of Personal Information</strong>\n   </td>\n   <td><strong>Categories of Recipients</strong>\n   </td>\n  </tr>\n  <tr>\n   <td>Identifiers\n   </td>\n   <td>Analytics Providers\n<br />\nCommunication Providers\n<br />\nCustomer Service Providers\n<br />\nFraud Prevention and Security Providers\n<br />\nInfrastructure Providers\n<br />\nMarketing Providers\n<br />\nPayment Processors\n   </td>\n  </tr>\n  <tr>\n   <td>Commercial Information\n   </td>\n   <td>Analytics Providers\n<br />\nInfrastructure Providers\n<br />\nPayment Processors\n   </td>\n  </tr>\n  <tr>\n   <td>Internet or Other Electronic Network Activity Information\n   </td>\n   <td>Analytics Providers\n<br />\nInfrastructure Providers\n   </td>\n  </tr>\n  <tr>\n   <td>Inferences\n   </td>\n   <td>Analytics Providers\n<br />\nInfrastructure Providers\n   </td>\n  </tr>\n</table>\n\n<p>Recipients we currently share Personal Information with include, but are not limited to, AWS (an infrastructure provider).</p>\n<p>We do not sell your Personal Information.</p>\n<p>Subject to certain limitations, you have the right to (1) request to know more about the categories and specific pieces of Personal Information we collect, use, and disclose about you, (2) request deletion of your Personal Information, (3) opt out of any sales of your Personal Information, if we engage in that activity in the future, and (4) not be discriminated against for exercising these rights. You may make these requests by emailing us at: <a href="mailto:support@logseq.com">support@logseq.com</a>. We will verify a webform request by asking you to provide identifying information. We will not discriminate against you if you exercise your rights under a State Privacy Law.</p>\n<p>If we receive your request from an authorized agent, we may ask for evidence that you have provided such agent with a power of attorney or that the agent otherwise has valid written authority to submit requests to exercise rights on your behalf. This may include requiring you to verify your identity. If you are an authorized agent seeking to make a request, please email us at: [email address].</p>\n<p>We do not knowingly collect Personal Information from persons under the age of 18. Data will not be shared with any third parties for their own marketing purposes.</p>\n<p><strong>12. Governing Law</strong><br>The terms of this Privacy Policy are governed by and in accordance with the laws of the state of New York, and, where applicable, the laws of the countries where our servers are located. You should not provide us with any Personal Information unless you consent to the application of United States law and, where applicable, New York law, and to the use and disclosure of your information in accordance with the terms of this Privacy Policy.</p>\n<p><strong>13. Glossary</strong><br><strong>A. Lawful basis</strong><br><strong>Legitimate Interest</strong> means the interest of our business in conducting and managing our business to enable us to give you the best service/product and the best and most secure experience. We make sure we consider and balance any potential impact on you (both positive and negative) and your rights before we process your personal data for our legitimate interests. We do not use your personal data for activities where our interests are overridden by the impact on you (unless we have your consent or are otherwise required or permitted to by law). You can obtain further information about how we assess our legitimate interests against any potential impact on you in respect of specific activities by contacting us.</p>\n<p><strong>Performance of Contract</strong> means processing your data where it is necessary for the performance of a contract to which you are a party or to take steps at your request before entering into such a contract.</p>\n<p><strong>Comply with a legal or regulatory obligation</strong> means processing your personal data where it is necessary for compliance with a legal or regulatory obligation that we are subject to.</p>\n<p><strong>B. Third parties</strong><br><strong>External Third Parties</strong></p>\n<ul>\n<li>Service providers acting as processors who provide IT and system administration services including AWS S3, Dynamodb, Sentry, Engineers, and Posthog.</li>\n<li>Professional advisers including lawyers, bankers, auditors and insurers who provide consultancy, banking, legal, insurance and accounting services.</li>\n<li>Tax regulators and other authorities who require reporting of processing activities in certain circumstances.</li>\n</ul>\n';



function $853aa2fd35eca216$export$76943c29260654ce() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "logseq-terms-content page-inner",
        dangerouslySetInnerHTML: {
            __html: (0, $d69ec8df0aa54e6c$export$2e2bcd8739ae039)
        }
    });
}
function $853aa2fd35eca216$export$d5a29154259e944d() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-page app-terms",
        children: [
            $853aa2fd35eca216$export$76943c29260654ce(),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "page-inner-full-wrap b relative",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "page-inner footer-nav",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "page-inner",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $717c681f9cec0e89$export$314961f1e384fdc0), {})
                    })
                })
            })
        ]
    });
}


function $cd93687958c8007e$export$86fbec116b87613f() {
    const appState = (0, $0b89d474933103bc$export$9973955de2bf96cf)();
    const modalsState = (0, $0b89d474933103bc$export$1a159e6ed632e23b)();
    const userInfoState = appState.userInfo;
    const { pathname: pathname } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const hasActiveModals = modalsState.modals?.some((m)=>m.value.visible);
    (0, $acw62.useEffect)(()=>{
        (0, $3b479ead6613d9c6$export$f5d3771428a1f489)();
    }, [
        pathname
    ]);
    // load global state
    (0, $0b89d474933103bc$export$85179ee6899ffd85)();
    (0, $0b89d474933103bc$export$f4699e7eb4dbacec)();
    (0, $0b89d474933103bc$export$b948d46d7006ea9f)();
    (0, $acw62.useEffect)(()=>{
        const handler = ({ which: which })=>{
            // ESC
            const t = modalsState.topmost();
            if (which === 27 && t) modalsState.remove(t.id);
        };
        document.body.addEventListener("keyup", handler);
        return ()=>document.body.removeEventListener("keyup", handler);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const resizeHandler = ()=>{
            appState.sm.set((0, $0b89d474933103bc$export$6dc2f20681470473)());
        };
        window.addEventListener("resize", resizeHandler);
        return ()=>{
            window.removeEventListener("resize", resizeHandler);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const container = document.documentElement;
        container.classList[hasActiveModals ? "add" : "remove"]("ui-modal-container-locked");
    }, [
        hasActiveModals
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        id: "app",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("flex justify-center"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3478a115f13707d$exports.Toaster), {
                position: "top-right",
                toastOptions: {
                    className: "app-toaster"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: "app-container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92499cee72729839$export$15e4adf56d9cf619), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ddabedec9b02645$export$36d69433c4f81145), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/downloads",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b83dbd58d0bae96$export$2cc9cf822bc951d1), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/terms",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e43251ebe5c4c2be$export$da8a3d5194f851ed), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/privacy-policy",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $853aa2fd35eca216$export$d5a29154259e944d), {})
                            })
                        ]
                    }),
                    modalsState.modals.get({
                        noproxy: true
                    })?.map((m)=>{
                        return /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90331d9be87f723f$export$2b77a92f1a5ad772), {
                            id: m.id,
                            visible: m.visible,
                            destroy: ()=>modalsState.remove(m.id),
                            ...m.props,
                            children: m.content
                        }, m.id), document.body);
                    })
                ]
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $2a754a1c7faca113$var$extendStatics = function(d, b) {
    $2a754a1c7faca113$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $2a754a1c7faca113$var$extendStatics(d, b);
};
function $2a754a1c7faca113$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $2a754a1c7faca113$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2a754a1c7faca113$export$18ce0697a983be9b = function() {
    $2a754a1c7faca113$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2a754a1c7faca113$export$18ce0697a983be9b.apply(this, arguments);
};
function $2a754a1c7faca113$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2a754a1c7faca113$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2a754a1c7faca113$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2a754a1c7faca113$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2a754a1c7faca113$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2a754a1c7faca113$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $2a754a1c7faca113$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $2a754a1c7faca113$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $2a754a1c7faca113$export$45d3717a4c69092e(o, m, p);
}
function $2a754a1c7faca113$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2a754a1c7faca113$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2a754a1c7faca113$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2a754a1c7faca113$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2a754a1c7faca113$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2a754a1c7faca113$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $2a754a1c7faca113$export$10c90e4f7922046c(v) {
    return this instanceof $2a754a1c7faca113$export$10c90e4f7922046c ? (this.v = v, this) : new $2a754a1c7faca113$export$10c90e4f7922046c(v);
}
function $2a754a1c7faca113$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2a754a1c7faca113$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2a754a1c7faca113$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2a754a1c7faca113$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $2a754a1c7faca113$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2a754a1c7faca113$export$19a8beecd37a4c45 === "function" ? $2a754a1c7faca113$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2a754a1c7faca113$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $2a754a1c7faca113$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $2a754a1c7faca113$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2a754a1c7faca113$export$45d3717a4c69092e(result, mod, k);
    }
    $2a754a1c7faca113$var$__setModuleDefault(result, mod);
    return result;
}
function $2a754a1c7faca113$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2a754a1c7faca113$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $2a754a1c7faca113$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $2a754a1c7faca113$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}




var $7739ef36e949e359$exports = {};
"use strict";
Object.defineProperty($7739ef36e949e359$exports, "__esModule", {
    value: true
});
var $a75e40c3098bb17e$exports = {};
"use strict";
Object.defineProperty($a75e40c3098bb17e$exports, "__esModule", {
    value: true
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ $a75e40c3098bb17e$exports.__assign = function() {
    $a75e40c3098bb17e$exports.__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a75e40c3098bb17e$exports.__assign.apply(this, arguments);
};
function $a75e40c3098bb17e$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a75e40c3098bb17e$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a75e40c3098bb17e$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a75e40c3098bb17e$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
$a75e40c3098bb17e$exports.__read = $a75e40c3098bb17e$var$__read;
$a75e40c3098bb17e$exports.__rest = $a75e40c3098bb17e$var$__rest;
$a75e40c3098bb17e$exports.__spreadArray = $a75e40c3098bb17e$var$__spreadArray;
$a75e40c3098bb17e$exports.__values = $a75e40c3098bb17e$var$__values;


var $7739ef36e949e359$var$defaultWaitForOptions = {
    timeout: 10000 // 10 seconds
};
/**
 * Subscribes to an actor ref and waits for its emitted value to satisfy
 * a predicate, and then resolves with that value.
 * Will throw if the desired state is not reached after a timeout
 * (defaults to 10 seconds).
 *
 * @example
 * ```js
 * const state = await waitFor(someService, state => {
 *   return state.hasTag('loaded');
 * });
 *
 * state.hasTag('loaded'); // true
 * ```
 *
 * @param actorRef The actor ref to subscribe to
 * @param predicate Determines if a value matches the condition to wait for
 * @param options
 * @returns A promise that eventually resolves to the emitted value
 * that matches the condition
 */ function $7739ef36e949e359$var$waitFor(actorRef, predicate, options) {
    var resolvedOptions = $a75e40c3098bb17e$exports.__assign($a75e40c3098bb17e$exports.__assign({}, $7739ef36e949e359$var$defaultWaitForOptions), options);
    return new Promise(function(res, rej) {
        var done = false;
        var handle = resolvedOptions.timeout === Infinity ? undefined : setTimeout(function() {
            sub.unsubscribe();
            rej(new Error("Timeout of ".concat(resolvedOptions.timeout, " ms exceeded")));
        }, resolvedOptions.timeout);
        var dispose = function() {
            clearTimeout(handle);
            done = true;
            sub === null || sub === void 0 || sub.unsubscribe();
        };
        var sub = actorRef.subscribe({
            next: function(emitted) {
                if (predicate(emitted)) {
                    dispose();
                    res(emitted);
                }
            },
            error: function(err) {
                dispose();
                rej(err);
            },
            complete: function() {
                dispose();
                rej(new Error("Actor terminated without satisfying predicate"));
            }
        });
        if (done) sub.unsubscribe();
    });
}
$7739ef36e949e359$exports.waitFor = $7739ef36e949e359$var$waitFor;





const $9ad1914df4b6fe69$export$3c7f711f5942602f = ({ packageName: t, version: e })=>{
    (0, $68caf4bd6c7da8b9$export$ad34c5a3baecdb02)(`${t}/${e}`);
}, $9ad1914df4b6fe69$export$655775443891f2b8 = (t)=>{
    const e = t.trim().split("");
    for(let t = 0; t < e.length; t++)t > 0 && t < e.length - 1 && (e[t] = "*");
    return e.join("");
}, $9ad1914df4b6fe69$export$72b2b64445441bf7 = (t)=>{
    if (t.length < 4) return t;
    const e = t.split("");
    for(let t = 0; t < e.length - 4; t++)e[t] = "*";
    return e.join("");
}, $9ad1914df4b6fe69$var$m = (e)=>(0, $2a754a1c7faca113$export$1050f835b63b671e)(void 0, void 0, void 0, function*() {
        try {
            yield (0, $7739ef36e949e359$exports.waitFor)(e, (t)=>(0, $1b0fbba0bcf650b5$export$99a4282e2c3b772d)(t).matches("autoSignIn"));
        } catch (t) {}
    }), $9ad1914df4b6fe69$export$f726708373635d8a = ({ payload: { data: e, event: n } }, i, a)=>(0, $2a754a1c7faca113$export$1050f835b63b671e)(void 0, void 0, void 0, function*() {
        const { send: t } = i, o = i.getSnapshot(), { onSignIn: c, onSignOut: l } = null != a ? a : {};
        switch(n){
            case "tokenRefresh":
                o.matches("authenticated.idle") && t("TOKEN_REFRESH");
                break;
            case "autoSignIn":
                if (!o.matches("authenticated")) {
                    yield $9ad1914df4b6fe69$var$m(i);
                    const n = (0, $1b0fbba0bcf650b5$export$99a4282e2c3b772d)(i.getSnapshot());
                    (null == n ? void 0 : n.matches("autoSignIn")) && t({
                        type: "AUTO_SIGN_IN",
                        data: e
                    });
                }
                break;
            case "autoSignIn_failure":
                {
                    yield $9ad1914df4b6fe69$var$m(i);
                    const n = (0, $1b0fbba0bcf650b5$export$99a4282e2c3b772d)(i.getSnapshot());
                    (null == n ? void 0 : n.matches("autoSignIn")) && t({
                        type: "AUTO_SIGN_IN_FAILURE",
                        data: e
                    });
                    break;
                }
            case "signIn":
                (0, $15a7c5986a3f06c2$export$f6e2535fb5126e54)(c) && c();
                break;
            case "signOut":
            case "tokenRefresh_failure":
                (0, $15a7c5986a3f06c2$export$f6e2535fb5126e54)(l) && l(), o.matches("authenticated.idle") && t("SIGN_OUT");
        }
    }), $9ad1914df4b6fe69$export$4776c363cae9362c = (t, n = $9ad1914df4b6fe69$export$f726708373635d8a)=>(0, $1a908fb961b3fa6b$exports.Hub).listen("auth", ((t, e)=>(n)=>{
            e(n, t);
        })(t, n), "authenticator-hub-handler"), $9ad1914df4b6fe69$export$1ec93875315f071d = (t)=>(0, $5c28317e8c66931c$export$4223938282102ea7).some((e)=>t.includes(e)), $9ad1914df4b6fe69$export$f1f323074be5cac0 = (t, e, n)=>encodeURI(`otpauth://totp/${t}:${e}?secret=${n}&issuer=${t}`);
function $9ad1914df4b6fe69$export$205c000fb676adf6(t, ...e) {
    return Object.entries(t).reduce((t, [n, i])=>Object.assign(Object.assign({}, t), {
            [n]: e.includes(n) ? i : null == i ? void 0 : i.trim()
        }), {});
}
const $9ad1914df4b6fe69$export$371e338370561054 = (t)=>!!t && (0, $5c28317e8c66931c$export$976c37132e9c6a10).test(t);




var $acw62 = parcelRequire("acw62");
var $7999b7c62f1eeee0$exports = {};

$parcel$export($7999b7c62f1eeee0$exports, "useInterpret", () => $7999b7c62f1eeee0$export$d9e9b060fbbae528);

var $acw62 = parcelRequire("acw62");

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $d9c803f633d21408$export$18ce0697a983be9b = function() {
    $d9c803f633d21408$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d9c803f633d21408$export$18ce0697a983be9b.apply(this, arguments);
};
function $d9c803f633d21408$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d9c803f633d21408$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d9c803f633d21408$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d9c803f633d21408$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}


var $b74e93109ba456db$export$1385d81a6c6bbcd4;
(function(ActionTypes) {
    ActionTypes["Start"] = "xstate.start";
    ActionTypes["Stop"] = "xstate.stop";
    ActionTypes["Raise"] = "xstate.raise";
    ActionTypes["Send"] = "xstate.send";
    ActionTypes["Cancel"] = "xstate.cancel";
    ActionTypes["NullEvent"] = "";
    ActionTypes["Assign"] = "xstate.assign";
    ActionTypes["After"] = "xstate.after";
    ActionTypes["DoneState"] = "done.state";
    ActionTypes["DoneInvoke"] = "done.invoke";
    ActionTypes["Log"] = "xstate.log";
    ActionTypes["Init"] = "xstate.init";
    ActionTypes["Invoke"] = "xstate.invoke";
    ActionTypes["ErrorExecution"] = "error.execution";
    ActionTypes["ErrorCommunication"] = "error.communication";
    ActionTypes["ErrorPlatform"] = "error.platform";
    ActionTypes["ErrorCustom"] = "xstate.error";
    ActionTypes["Update"] = "xstate.update";
    ActionTypes["Pure"] = "xstate.pure";
    ActionTypes["Choose"] = "xstate.choose";
})($b74e93109ba456db$export$1385d81a6c6bbcd4 || ($b74e93109ba456db$export$1385d81a6c6bbcd4 = {}));
var $b74e93109ba456db$export$79f5baa747fbdd45;
(function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
})($b74e93109ba456db$export$79f5baa747fbdd45 || ($b74e93109ba456db$export$79f5baa747fbdd45 = {}));



var $9700b9c4f37abdbc$export$b060f3cec92ef5c9 = ".";
var $9700b9c4f37abdbc$export$505a390a702f4a23 = {};
var $9700b9c4f37abdbc$export$656461011b562379 = "xstate.guard";
var $9700b9c4f37abdbc$export$31935b4577455331 = "";




var $41059b6f2e1b7a0a$exports = {};

$parcel$export($41059b6f2e1b7a0a$exports, "start", () => $41059b6f2e1b7a0a$export$b3571188c770cc5a);
$parcel$export($41059b6f2e1b7a0a$exports, "stop", () => $41059b6f2e1b7a0a$export$fa6813432f753b0d);
$parcel$export($41059b6f2e1b7a0a$exports, "raise", () => $41059b6f2e1b7a0a$export$66313c302b2ea154);
$parcel$export($41059b6f2e1b7a0a$exports, "send", () => $41059b6f2e1b7a0a$export$89db4734f6c919c4);
$parcel$export($41059b6f2e1b7a0a$exports, "cancel", () => $41059b6f2e1b7a0a$export$70b61ad426ddbe54);
$parcel$export($41059b6f2e1b7a0a$exports, "nullEvent", () => $41059b6f2e1b7a0a$export$9477ceca5dcd796a);
$parcel$export($41059b6f2e1b7a0a$exports, "assign", () => $41059b6f2e1b7a0a$export$e6e34fd1f2686227);
$parcel$export($41059b6f2e1b7a0a$exports, "after", () => $41059b6f2e1b7a0a$export$742acabee3dd6465);
$parcel$export($41059b6f2e1b7a0a$exports, "doneState", () => $41059b6f2e1b7a0a$export$de2557b5933c9ac6);
$parcel$export($41059b6f2e1b7a0a$exports, "log", () => $41059b6f2e1b7a0a$export$bef1f36f5486a6a3);
$parcel$export($41059b6f2e1b7a0a$exports, "init", () => $41059b6f2e1b7a0a$export$2cd8252107eb640b);
$parcel$export($41059b6f2e1b7a0a$exports, "invoke", () => $41059b6f2e1b7a0a$export$468cda29b159ee5d);
$parcel$export($41059b6f2e1b7a0a$exports, "errorExecution", () => $41059b6f2e1b7a0a$export$aca059ee6fbf94e8);
$parcel$export($41059b6f2e1b7a0a$exports, "errorPlatform", () => $41059b6f2e1b7a0a$export$503a23d0e5cd1226);
$parcel$export($41059b6f2e1b7a0a$exports, "error", () => $41059b6f2e1b7a0a$export$a3bc9b8ed74fc);
$parcel$export($41059b6f2e1b7a0a$exports, "update", () => $41059b6f2e1b7a0a$export$722fbec263ad908a);
$parcel$export($41059b6f2e1b7a0a$exports, "choose", () => $41059b6f2e1b7a0a$export$7877a478dd30fd3d);
$parcel$export($41059b6f2e1b7a0a$exports, "pure", () => $41059b6f2e1b7a0a$export$48ec4a2b1cfc6557);

var $41059b6f2e1b7a0a$export$b3571188c770cc5a = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Start;
var $41059b6f2e1b7a0a$export$fa6813432f753b0d = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Stop;
var $41059b6f2e1b7a0a$export$66313c302b2ea154 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Raise;
var $41059b6f2e1b7a0a$export$89db4734f6c919c4 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Send;
var $41059b6f2e1b7a0a$export$70b61ad426ddbe54 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Cancel;
var $41059b6f2e1b7a0a$export$9477ceca5dcd796a = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).NullEvent;
var $41059b6f2e1b7a0a$export$e6e34fd1f2686227 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Assign;
var $41059b6f2e1b7a0a$export$742acabee3dd6465 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).After;
var $41059b6f2e1b7a0a$export$de2557b5933c9ac6 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).DoneState;
var $41059b6f2e1b7a0a$export$bef1f36f5486a6a3 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Log;
var $41059b6f2e1b7a0a$export$2cd8252107eb640b = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Init;
var $41059b6f2e1b7a0a$export$468cda29b159ee5d = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Invoke;
var $41059b6f2e1b7a0a$export$aca059ee6fbf94e8 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).ErrorExecution;
var $41059b6f2e1b7a0a$export$503a23d0e5cd1226 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).ErrorPlatform;
var $41059b6f2e1b7a0a$export$a3bc9b8ed74fc = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).ErrorCustom;
var $41059b6f2e1b7a0a$export$722fbec263ad908a = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Update;
var $41059b6f2e1b7a0a$export$7877a478dd30fd3d = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Choose;
var $41059b6f2e1b7a0a$export$48ec4a2b1cfc6557 = (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Pure;



var $bb41c361a1818c2b$export$9b5f2e1c20ef6571 = true;


var $0ba2bc18e91bd780$var$_a;
function $0ba2bc18e91bd780$export$ed97f33186d4b816(value) {
    return Object.keys(value);
}
function $0ba2bc18e91bd780$export$2870710bf0eac88e(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = (0, $9700b9c4f37abdbc$export$b060f3cec92ef5c9);
    var parentStateValue = $0ba2bc18e91bd780$export$fb3aecd1d93744e3(parentStateId, delimiter);
    var childStateValue = $0ba2bc18e91bd780$export$fb3aecd1d93744e3(childStateId, delimiter);
    if ($0ba2bc18e91bd780$export$844ec244b1367d54(childStateValue)) {
        if ($0ba2bc18e91bd780$export$844ec244b1367d54(parentStateValue)) return childStateValue === parentStateValue;
         // Parent more specific than child
        return false;
    }
    if ($0ba2bc18e91bd780$export$844ec244b1367d54(parentStateValue)) return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return $0ba2bc18e91bd780$export$2870710bf0eac88e(parentStateValue[key], childStateValue[key]);
    });
}
function $0ba2bc18e91bd780$export$7193fc8c8cd445e9(event) {
    try {
        return $0ba2bc18e91bd780$export$844ec244b1367d54(event) || typeof event === "number" ? "".concat(event) : event.type;
    } catch (e) {
        throw new Error("Events must be strings or objects with a string event.type property.");
    }
}
function $0ba2bc18e91bd780$export$e303144c5506946a(action) {
    try {
        return $0ba2bc18e91bd780$export$844ec244b1367d54(action) || typeof action === "number" ? "".concat(action) : $0ba2bc18e91bd780$export$f6e2535fb5126e54(action) ? action.name : action.type;
    } catch (e) {
        throw new Error("Actions must be strings or objects with a string action.type property.");
    }
}
function $0ba2bc18e91bd780$export$304cde62ecda7af8(stateId, delimiter) {
    try {
        if ($0ba2bc18e91bd780$export$43bee75e5e14138e(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'".concat(stateId, "' is not a valid state path."));
    }
}
function $0ba2bc18e91bd780$export$e080e3931a079c9b(state) {
    return typeof state === "object" && "value" in state && "context" in state && "event" in state && "_event" in state;
}
function $0ba2bc18e91bd780$export$fb3aecd1d93744e3(stateValue, delimiter) {
    if ($0ba2bc18e91bd780$export$e080e3931a079c9b(stateValue)) return stateValue.value;
    if ($0ba2bc18e91bd780$export$43bee75e5e14138e(stateValue)) return $0ba2bc18e91bd780$export$f2ee84fc53c45e74(stateValue);
    if (typeof stateValue !== "string") return stateValue;
    var statePath = $0ba2bc18e91bd780$export$304cde62ecda7af8(stateValue, delimiter);
    return $0ba2bc18e91bd780$export$f2ee84fc53c45e74(statePath);
}
function $0ba2bc18e91bd780$export$f2ee84fc53c45e74(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
function $0ba2bc18e91bd780$export$825e789796ab7275(collection, iteratee) {
    var result = {};
    var collectionKeys = Object.keys(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $0ba2bc18e91bd780$export$2d4204fe9b34204e(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var $0ba2bc18e91bd780$export$bb654e07daaf8c3a = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function $0ba2bc18e91bd780$export$314d0a1a7c835392(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
function $0ba2bc18e91bd780$export$a2618e9e89698dd6(stateValue) {
    if (!stateValue) return [
        []
    ];
    if ($0ba2bc18e91bd780$export$844ec244b1367d54(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = $0ba2bc18e91bd780$export$bffa455ba8c619a6(Object.keys(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== "string" && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return $0ba2bc18e91bd780$export$a2618e9e89698dd6(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
function $0ba2bc18e91bd780$export$c9d3abe59e55cae0(paths) {
    var e_4, _a;
    var result = {};
    if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
    try {
        for(var paths_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var currentPath = paths_1_1.value;
            var marker = result; // tslint:disable-next-line:prefer-for-of
            for(var i = 0; i < currentPath.length; i++){
                var subPath = currentPath[i];
                if (i === currentPath.length - 2) {
                    marker[subPath] = currentPath[i + 1];
                    break;
                }
                marker[subPath] = marker[subPath] || {};
                marker = marker[subPath];
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return result;
}
function $0ba2bc18e91bd780$export$bffa455ba8c619a6(array) {
    var _a;
    return (_a = []).concat.apply(_a, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(array), false));
}
function $0ba2bc18e91bd780$export$2c0b6b2f4faf21e1(value) {
    if ($0ba2bc18e91bd780$export$43bee75e5e14138e(value)) return value;
    return [
        value
    ];
}
function $0ba2bc18e91bd780$export$45b10814cc054894(value) {
    if (value === undefined) return [];
    return $0ba2bc18e91bd780$export$2c0b6b2f4faf21e1(value);
}
function $0ba2bc18e91bd780$export$e756e60189cc2351(mapper, context, _event) {
    var e_5, _a;
    if ($0ba2bc18e91bd780$export$f6e2535fb5126e54(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if ($0ba2bc18e91bd780$export$f6e2535fb5126e54(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
function $0ba2bc18e91bd780$export$479b1b8942fd0b8d(eventType) {
    return /^(done|error)\./.test(eventType);
}
function $0ba2bc18e91bd780$export$ae936b9d47e5870e(value) {
    if (value instanceof Promise) return true;
     // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && ($0ba2bc18e91bd780$export$f6e2535fb5126e54(value) || typeof value === "object") && $0ba2bc18e91bd780$export$f6e2535fb5126e54(value.then)) return true;
    return false;
}
function $0ba2bc18e91bd780$export$42749ebe1e7fdef7(value) {
    return value !== null && typeof value === "object" && "transition" in value && typeof value.transition === "function";
}
function $0ba2bc18e91bd780$export$b29f828819edca8d(items, predicate) {
    var e_6, _a;
    var _b = (0, $d9c803f633d21408$export$8d051b38c9118094)([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $0ba2bc18e91bd780$export$3737909a0074eb1(hist, stateValue) {
    return $0ba2bc18e91bd780$export$825e789796ab7275(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = ($0ba2bc18e91bd780$export$844ec244b1367d54(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: $0ba2bc18e91bd780$export$3737909a0074eb1(subHist, subStateValue)
        };
    });
}
function $0ba2bc18e91bd780$export$240d7cdd99ccb95a(hist, stateValue) {
    return {
        current: stateValue,
        states: $0ba2bc18e91bd780$export$3737909a0074eb1(hist, stateValue)
    };
}
function $0ba2bc18e91bd780$export$d84706064a6e6c1c(context, _event, assignActions, state) {
    if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) $0ba2bc18e91bd780$export$c106dd0671a0fc2d(!!context, "Attempting to update undefined context");
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if ($0ba2bc18e91bd780$export$f6e2535fb5126e54(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = $0ba2bc18e91bd780$export$f6e2535fb5126e54(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
} // tslint:disable-next-line:no-empty
var $0ba2bc18e91bd780$export$c106dd0671a0fc2d = function() {};
if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) $0ba2bc18e91bd780$export$c106dd0671a0fc2d = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: ".concat(message)
        ];
        if (error) args.push(error);
         // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function $0ba2bc18e91bd780$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
} // tslint:disable-next-line:ban-types
function $0ba2bc18e91bd780$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $0ba2bc18e91bd780$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $0ba2bc18e91bd780$export$b0f5a08e0ca47933(condition, guardMap) {
    if (!condition) return undefined;
    if ($0ba2bc18e91bd780$export$844ec244b1367d54(condition)) return {
        type: (0, $9700b9c4f37abdbc$export$656461011b562379),
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if ($0ba2bc18e91bd780$export$f6e2535fb5126e54(condition)) return {
        type: (0, $9700b9c4f37abdbc$export$656461011b562379),
        name: condition.name,
        predicate: condition
    };
    return condition;
}
function $0ba2bc18e91bd780$export$5cd057a6046189f9(value) {
    try {
        return "subscribe" in value && $0ba2bc18e91bd780$export$f6e2535fb5126e54(value.subscribe);
    } catch (e) {
        return false;
    }
}
var $0ba2bc18e91bd780$export$c45ebe72e3b2885 = /*#__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages
var $0ba2bc18e91bd780$export$a6273dafbee7f61e = ($0ba2bc18e91bd780$var$_a = {}, $0ba2bc18e91bd780$var$_a[$0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
    return this;
}, $0ba2bc18e91bd780$var$_a[Symbol.observable] = function() {
    return this;
}, $0ba2bc18e91bd780$var$_a);
function $0ba2bc18e91bd780$export$2163e7903738b5df(value) {
    return !!value && "__xstatenode" in value;
}
function $0ba2bc18e91bd780$export$e769f6913f14f1b7(value) {
    return !!value && typeof value.send === "function";
}
var $0ba2bc18e91bd780$export$8b15d37bc3f197d4 = /*#__PURE__*/ function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function $0ba2bc18e91bd780$export$5a4ea50826a01d14(event, payload // id?: TEvent['type']
) {
    if ($0ba2bc18e91bd780$export$844ec244b1367d54(event) || typeof event === "number") return (0, $d9c803f633d21408$export$18ce0697a983be9b)({
        type: event
    }, payload);
    return event;
}
function $0ba2bc18e91bd780$export$eaf22249b410f633(event, scxmlEvent) {
    if (!$0ba2bc18e91bd780$export$844ec244b1367d54(event) && "$$type" in event && event.$$type === "scxml") return event;
    var eventObject = $0ba2bc18e91bd780$export$5a4ea50826a01d14(event);
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)({
        name: eventObject.type,
        data: eventObject,
        $$type: "scxml",
        type: "external"
    }, scxmlEvent);
}
function $0ba2bc18e91bd780$export$3822a36ea084a4d5(event, configLike) {
    var transitions = $0ba2bc18e91bd780$export$2c0b6b2f4faf21e1(configLike).map(function(transitionLike) {
        if (typeof transitionLike === "undefined" || typeof transitionLike === "string" || $0ba2bc18e91bd780$export$2163e7903738b5df(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
function $0ba2bc18e91bd780$export$2a4fe5c3c80e3288(target) {
    if (target === undefined || target === (0, $9700b9c4f37abdbc$export$31935b4577455331)) return undefined;
    return $0ba2bc18e91bd780$export$45b10814cc054894(target);
}
function $0ba2bc18e91bd780$export$b240b9b7a78b5f3e(originalError, currentError, id) {
    if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : "";
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ""; // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
        }
    }
}
function $0ba2bc18e91bd780$export$91646ab912d254e8(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    }; // TODO: do not hardcode!
    if (guard.type === (0, $9700b9c4f37abdbc$export$656461011b562379)) return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
    var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
    if (!condFn) throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
    return condFn(context, _event.data, guardMeta);
}
function $0ba2bc18e91bd780$export$436e852aa2feda95(src) {
    if (typeof src === "string") return {
        type: src
    };
    return src;
}
function $0ba2bc18e91bd780$export$75b67481063f2f98(nextHandler, errorHandler, completionHandler) {
    var noop = function() {};
    var isObserver = typeof nextHandler === "object";
    var self = isObserver ? nextHandler : null;
    return {
        next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
        error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
        complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
    };
}
function $0ba2bc18e91bd780$export$107b54c5097f9157(stateNodeId, index) {
    return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function $0ba2bc18e91bd780$export$37dc2eda56cb25a5(action) {
    return (action.type === (0, $41059b6f2e1b7a0a$export$66313c302b2ea154) || action.type === (0, $41059b6f2e1b7a0a$export$89db4734f6c919c4) && action.to === (0, $b74e93109ba456db$export$79f5baa747fbdd45).Internal) && typeof action.delay !== "number";
}




var $83ffdf18b0958611$export$335db82b86111fd1 = function(stateNode) {
    return stateNode.type === "atomic" || stateNode.type === "final";
};
function $83ffdf18b0958611$export$ad3d2e38d4deaf6d(stateNode) {
    return Object.keys(stateNode.states).map(function(key) {
        return stateNode.states[key];
    });
}
function $83ffdf18b0958611$export$f8cf48ee793b41be(stateNode) {
    return $83ffdf18b0958611$export$ad3d2e38d4deaf6d(stateNode).filter(function(sn) {
        return sn.type !== "history";
    });
}
function $83ffdf18b0958611$export$3de19bba299e3801(stateNode) {
    var stateNodes = [
        stateNode
    ];
    if ($83ffdf18b0958611$export$335db82b86111fd1(stateNode)) return stateNodes;
    return stateNodes.concat((0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)($83ffdf18b0958611$export$f8cf48ee793b41be(stateNode).map($83ffdf18b0958611$export$3de19bba299e3801)));
}
function $83ffdf18b0958611$export$3de01744a82b21a4(prevStateNodes, stateNodes) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var prevConfiguration = new Set(prevStateNodes);
    var prevAdjList = $83ffdf18b0958611$export$b837d8c2d0189d63(prevConfiguration);
    var configuration = new Set(stateNodes);
    try {
        // add all ancestors
        for(var configuration_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()){
            var s = configuration_1_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    var adjList = $83ffdf18b0958611$export$b837d8c2d0189d63(configuration);
    try {
        // add descendants
        for(var configuration_2 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()){
            var s = configuration_2_1.value; // if previously active, add existing child nodes
            if (s.type === "compound" && (!adjList.get(s) || !adjList.get(s).length)) {
                if (prevAdjList.get(s)) prevAdjList.get(s).forEach(function(sn) {
                    return configuration.add(sn);
                });
                else s.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                });
            } else {
                if (s.type === "parallel") try {
                    for(var _e = (e_3 = void 0, (0, $d9c803f633d21408$export$19a8beecd37a4c45)($83ffdf18b0958611$export$f8cf48ee793b41be(s))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var child = _f.value;
                        if (!configuration.has(child)) {
                            configuration.add(child);
                            if (prevAdjList.get(child)) prevAdjList.get(child).forEach(function(sn) {
                                return configuration.add(sn);
                            });
                            else child.initialStateNodes.forEach(function(sn) {
                                return configuration.add(sn);
                            });
                        }
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    try {
        // add all ancestors
        for(var configuration_3 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()){
            var s = configuration_3_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return configuration;
}
function $83ffdf18b0958611$var$getValueFromAdj(baseNode, adjList) {
    var childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === "compound") {
        var childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($83ffdf18b0958611$export$335db82b86111fd1(childStateNode)) return childStateNode.key;
        } else return {};
    }
    var stateValue = {};
    childStateNodes.forEach(function(csn) {
        stateValue[csn.key] = $83ffdf18b0958611$var$getValueFromAdj(csn, adjList);
    });
    return stateValue;
}
function $83ffdf18b0958611$export$b837d8c2d0189d63(configuration) {
    var e_5, _a;
    var adjList = new Map();
    try {
        for(var configuration_4 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()){
            var s = configuration_4_1.value;
            if (!adjList.has(s)) adjList.set(s, []);
            if (s.parent) {
                if (!adjList.has(s.parent)) adjList.set(s.parent, []);
                adjList.get(s.parent).push(s);
            }
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return adjList;
}
function $83ffdf18b0958611$export$bf7199a9ebcb84a9(rootNode, configuration) {
    var config = $83ffdf18b0958611$export$3de01744a82b21a4([
        rootNode
    ], configuration);
    return $83ffdf18b0958611$var$getValueFromAdj(rootNode, $83ffdf18b0958611$export$b837d8c2d0189d63(config));
}
function $83ffdf18b0958611$export$a4f4bb6b1453fff5(iterable, item) {
    if (Array.isArray(iterable)) return iterable.some(function(member) {
        return member === item;
    });
    if (iterable instanceof Set) return iterable.has(item);
    return false; // TODO: fix
}
function $83ffdf18b0958611$export$c661ab6895e3ed73(configuration) {
    return (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(new Set((0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(configuration.map(function(sn) {
        return sn.ownEvents;
    })), false)))), false);
}
function $83ffdf18b0958611$export$cf3d5dae927fcf63(configuration, stateNode) {
    if (stateNode.type === "compound") return $83ffdf18b0958611$export$f8cf48ee793b41be(stateNode).some(function(s) {
        return s.type === "final" && $83ffdf18b0958611$export$a4f4bb6b1453fff5(configuration, s);
    });
    if (stateNode.type === "parallel") return $83ffdf18b0958611$export$f8cf48ee793b41be(stateNode).every(function(sn) {
        return $83ffdf18b0958611$export$cf3d5dae927fcf63(configuration, sn);
    });
    return false;
}
function $83ffdf18b0958611$export$c47913ca32a5c6f7(configuration) {
    if (configuration === void 0) configuration = [];
    return configuration.reduce(function(acc, stateNode) {
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
}
function $83ffdf18b0958611$export$5301196121335ca0(configuration) {
    return new Set((0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(configuration.map(function(sn) {
        return sn.tags;
    })));
}


var $ab1fe168d053d080$exports = {};

$parcel$export($ab1fe168d053d080$exports, "initEvent", () => $ab1fe168d053d080$export$163c566c60ed2ec9);
$parcel$export($ab1fe168d053d080$exports, "getActionFunction", () => $ab1fe168d053d080$export$c7e5ca927bd4567);
$parcel$export($ab1fe168d053d080$exports, "toActionObject", () => $ab1fe168d053d080$export$b38b66cc2da3ede7);
$parcel$export($ab1fe168d053d080$exports, "toActionObjects", () => $ab1fe168d053d080$export$aa68691f32e6c459);
$parcel$export($ab1fe168d053d080$exports, "toActivityDefinition", () => $ab1fe168d053d080$export$e81fdd8937d44864);
$parcel$export($ab1fe168d053d080$exports, "raise", () => $ab1fe168d053d080$export$66313c302b2ea154);
$parcel$export($ab1fe168d053d080$exports, "resolveRaise", () => $ab1fe168d053d080$export$ed3daf8e935ede01);
$parcel$export($ab1fe168d053d080$exports, "send", () => $ab1fe168d053d080$export$89db4734f6c919c4);
$parcel$export($ab1fe168d053d080$exports, "resolveSend", () => $ab1fe168d053d080$export$f43e8cbb721d72d5);
$parcel$export($ab1fe168d053d080$exports, "sendParent", () => $ab1fe168d053d080$export$408d8d51fa351f53);
$parcel$export($ab1fe168d053d080$exports, "sendTo", () => $ab1fe168d053d080$export$daa976aaff721e41);
$parcel$export($ab1fe168d053d080$exports, "sendUpdate", () => $ab1fe168d053d080$export$7f8b724299523eb6);
$parcel$export($ab1fe168d053d080$exports, "respond", () => $ab1fe168d053d080$export$72b816ae90496f19);
$parcel$export($ab1fe168d053d080$exports, "log", () => $ab1fe168d053d080$export$bef1f36f5486a6a3);
$parcel$export($ab1fe168d053d080$exports, "resolveLog", () => $ab1fe168d053d080$export$12cba28d36be4946);
$parcel$export($ab1fe168d053d080$exports, "cancel", () => $ab1fe168d053d080$export$70b61ad426ddbe54);
$parcel$export($ab1fe168d053d080$exports, "start", () => $ab1fe168d053d080$export$b3571188c770cc5a);
$parcel$export($ab1fe168d053d080$exports, "stop", () => $ab1fe168d053d080$export$fa6813432f753b0d);
$parcel$export($ab1fe168d053d080$exports, "resolveStop", () => $ab1fe168d053d080$export$21aa461f4eb8e82);
$parcel$export($ab1fe168d053d080$exports, "assign", () => $ab1fe168d053d080$export$e6e34fd1f2686227);
$parcel$export($ab1fe168d053d080$exports, "isActionObject", () => $ab1fe168d053d080$export$6e816592f80fc079);
$parcel$export($ab1fe168d053d080$exports, "after", () => $ab1fe168d053d080$export$742acabee3dd6465);
$parcel$export($ab1fe168d053d080$exports, "done", () => $ab1fe168d053d080$export$3df11c9c20e7b288);
$parcel$export($ab1fe168d053d080$exports, "doneInvoke", () => $ab1fe168d053d080$export$c105e588793f70b4);
$parcel$export($ab1fe168d053d080$exports, "error", () => $ab1fe168d053d080$export$a3bc9b8ed74fc);
$parcel$export($ab1fe168d053d080$exports, "pure", () => $ab1fe168d053d080$export$48ec4a2b1cfc6557);
$parcel$export($ab1fe168d053d080$exports, "forwardTo", () => $ab1fe168d053d080$export$eb147b7589db8e8a);
$parcel$export($ab1fe168d053d080$exports, "escalate", () => $ab1fe168d053d080$export$f514678a4137c4d6);
$parcel$export($ab1fe168d053d080$exports, "choose", () => $ab1fe168d053d080$export$7877a478dd30fd3d);
$parcel$export($ab1fe168d053d080$exports, "resolveActions", () => $ab1fe168d053d080$export$b8b9e7ba5b8c7b3e);
$parcel$export($ab1fe168d053d080$exports, "actionTypes", () => $41059b6f2e1b7a0a$exports);





var $ab1fe168d053d080$export$163c566c60ed2ec9 = /*#__PURE__*/ (0, $0ba2bc18e91bd780$export$eaf22249b410f633)({
    type: (0, $41059b6f2e1b7a0a$export$2cd8252107eb640b)
});
function $ab1fe168d053d080$export$c7e5ca927bd4567(actionType, actionFunctionMap) {
    return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function $ab1fe168d053d080$export$b38b66cc2da3ede7(action, actionFunctionMap) {
    var actionObject;
    if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(action) || typeof action === "number") {
        var exec = $ab1fe168d053d080$export$c7e5ca927bd4567(action, actionFunctionMap);
        if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(exec)) actionObject = {
            type: action,
            exec: exec
        };
        else if (exec) actionObject = exec;
        else actionObject = {
            type: action,
            exec: undefined
        };
    } else if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action)) actionObject = {
        // Convert action to string if unnamed
        type: action.name || action.toString(),
        exec: action
    };
    else {
        var exec = $ab1fe168d053d080$export$c7e5ca927bd4567(action.type, actionFunctionMap);
        if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(exec)) actionObject = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, action), {
            exec: exec
        });
        else if (exec) {
            var actionType = exec.type || action.type;
            actionObject = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, exec), action), {
                type: actionType
            });
        } else actionObject = action;
    }
    return actionObject;
}
var $ab1fe168d053d080$export$aa68691f32e6c459 = function(action, actionFunctionMap) {
    if (!action) return [];
    var actions = (0, $0ba2bc18e91bd780$export$43bee75e5e14138e)(action) ? action : [
        action
    ];
    return actions.map(function(subAction) {
        return $ab1fe168d053d080$export$b38b66cc2da3ede7(subAction, actionFunctionMap);
    });
};
function $ab1fe168d053d080$export$e81fdd8937d44864(action) {
    var actionObject = $ab1fe168d053d080$export$b38b66cc2da3ede7(action);
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({
        id: (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(action) ? action : actionObject.id
    }, actionObject), {
        type: actionObject.type
    });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $ab1fe168d053d080$export$66313c302b2ea154(event, options) {
    return {
        type: (0, $41059b6f2e1b7a0a$export$66313c302b2ea154),
        event: typeof event === "function" ? event : (0, $0ba2bc18e91bd780$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        id: options === null || options === void 0 ? void 0 : options.id
    };
}
function $ab1fe168d053d080$export$ed3daf8e935ede01(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    };
    var resolvedEvent = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, action), {
        type: (0, $41059b6f2e1b7a0a$export$66313c302b2ea154),
        _event: resolvedEvent,
        delay: resolvedDelay
    });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */ function $ab1fe168d053d080$export$89db4734f6c919c4(event, options) {
    return {
        to: options ? options.to : undefined,
        type: (0, $41059b6f2e1b7a0a$export$89db4734f6c919c4),
        event: (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(event) ? event : (0, $0ba2bc18e91bd780$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        // TODO: don't auto-generate IDs here like that
        // there is too big chance of the ID collision
        id: options && options.id !== undefined ? options.id : (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(event) ? event.name : (0, $0ba2bc18e91bd780$export$7193fc8c8cd445e9)(event)
    };
}
function $ab1fe168d053d080$export$f43e8cbb721d72d5(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    }; // TODO: helper function for resolving Expr
    var resolvedEvent = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    var resolvedTarget = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action.to) ? action.to(ctx, _event.data, meta) : action.to;
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, action), {
        to: resolvedTarget,
        _event: resolvedEvent,
        event: resolvedEvent.data,
        delay: resolvedDelay
    });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $ab1fe168d053d080$export$408d8d51fa351f53(event, options) {
    return $ab1fe168d053d080$export$89db4734f6c919c4(event, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, options), {
        to: (0, $b74e93109ba456db$export$79f5baa747fbdd45).Parent
    }));
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event to send
 * @param options Send action options
 * @returns An XState send action object
 */ function $ab1fe168d053d080$export$daa976aaff721e41(actor, event, options) {
    return $ab1fe168d053d080$export$89db4734f6c919c4(event, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, options), {
        to: actor
    }));
}
/**
 * Sends an update event to this machine's parent.
 */ function $ab1fe168d053d080$export$7f8b724299523eb6() {
    return $ab1fe168d053d080$export$408d8d51fa351f53((0, $41059b6f2e1b7a0a$export$722fbec263ad908a));
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */ function $ab1fe168d053d080$export$72b816ae90496f19(event, options) {
    return $ab1fe168d053d080$export$89db4734f6c919c4(event, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, options), {
        to: function(_, __, _a) {
            var _event = _a._event;
            return _event.origin; // TODO: handle when _event.origin is undefined
        }
    }));
}
var $ab1fe168d053d080$var$defaultLogExpr = function(context, event) {
    return {
        context: context,
        event: event
    };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */ function $ab1fe168d053d080$export$bef1f36f5486a6a3(expr, label) {
    if (expr === void 0) expr = $ab1fe168d053d080$var$defaultLogExpr;
    return {
        type: (0, $41059b6f2e1b7a0a$export$bef1f36f5486a6a3),
        label: label,
        expr: expr
    };
}
var $ab1fe168d053d080$export$12cba28d36be4946 = function(action, ctx, _event) {
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, action), {
        value: (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(action.expr) ? action.expr : action.expr(ctx, _event.data, {
            _event: _event
        })
    });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */ var $ab1fe168d053d080$export$70b61ad426ddbe54 = function(sendId) {
    return {
        type: (0, $41059b6f2e1b7a0a$export$70b61ad426ddbe54),
        sendId: sendId
    };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */ function $ab1fe168d053d080$export$b3571188c770cc5a(activity) {
    var activityDef = $ab1fe168d053d080$export$e81fdd8937d44864(activity);
    return {
        type: (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Start,
        activity: activityDef,
        exec: undefined
    };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */ function $ab1fe168d053d080$export$fa6813432f753b0d(actorRef) {
    var activity = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(actorRef) ? actorRef : $ab1fe168d053d080$export$e81fdd8937d44864(actorRef);
    return {
        type: (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Stop,
        activity: activity,
        exec: undefined
    };
}
function $ab1fe168d053d080$export$21aa461f4eb8e82(action, context, _event) {
    var actorRefOrString = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(action.activity) ? action.activity(context, _event.data) : action.activity;
    var resolvedActorRef = typeof actorRefOrString === "string" ? {
        id: actorRefOrString
    } : actorRefOrString;
    var actionObject = {
        type: (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Stop,
        activity: resolvedActorRef
    };
    return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */ var $ab1fe168d053d080$export$e6e34fd1f2686227 = function(assignment) {
    return {
        type: (0, $41059b6f2e1b7a0a$export$e6e34fd1f2686227),
        assignment: assignment
    };
};
function $ab1fe168d053d080$export$6e816592f80fc079(action) {
    return typeof action === "object" && "type" in action;
}
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $ab1fe168d053d080$export$742acabee3dd6465(delayRef, id) {
    var idSuffix = id ? "#".concat(id) : "";
    return "".concat((0, $b74e93109ba456db$export$1385d81a6c6bbcd4).After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */ function $ab1fe168d053d080$export$3df11c9c20e7b288(id, data) {
    var type = "".concat((0, $b74e93109ba456db$export$1385d81a6c6bbcd4).DoneState, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */ function $ab1fe168d053d080$export$c105e588793f70b4(id, data) {
    var type = "".concat((0, $b74e93109ba456db$export$1385d81a6c6bbcd4).DoneInvoke, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $ab1fe168d053d080$export$a3bc9b8ed74fc(id, data) {
    var type = "".concat((0, $b74e93109ba456db$export$1385d81a6c6bbcd4).ErrorPlatform, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $ab1fe168d053d080$export$48ec4a2b1cfc6557(getActions) {
    return {
        type: (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Pure,
        get: getActions
    };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $ab1fe168d053d080$export$eb147b7589db8e8a(target, options) {
    if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571) && (!target || typeof target === "function")) {
        var originalTarget_1 = target;
        target = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var resolvedTarget = typeof originalTarget_1 === "function" ? originalTarget_1.apply(void 0, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(args), false)) : originalTarget_1;
            if (!resolvedTarget) throw new Error("Attempted to forward event to undefined actor. This risks an infinite loop in the sender.");
            return resolvedTarget;
        };
    }
    return $ab1fe168d053d080$export$89db4734f6c919c4(function(_, event) {
        return event;
    }, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, options), {
        to: target
    }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */ function $ab1fe168d053d080$export$f514678a4137c4d6(errorData, options) {
    return $ab1fe168d053d080$export$408d8d51fa351f53(function(context, event, meta) {
        return {
            type: (0, $41059b6f2e1b7a0a$export$a3bc9b8ed74fc),
            data: (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(errorData) ? errorData(context, event, meta) : errorData
        };
    }, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, options), {
        to: (0, $b74e93109ba456db$export$79f5baa747fbdd45).Parent
    }));
}
function $ab1fe168d053d080$export$7877a478dd30fd3d(conds) {
    return {
        type: (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Choose,
        conds: conds
    };
}
var $ab1fe168d053d080$var$pluckAssigns = function(actionBlocks) {
    var e_1, _a;
    var assignActions = [];
    try {
        for(var actionBlocks_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
            var block = actionBlocks_1_1.value;
            var i = 0;
            while(i < block.actions.length){
                if (block.actions[i].type === (0, $41059b6f2e1b7a0a$export$e6e34fd1f2686227)) {
                    assignActions.push(block.actions[i]);
                    block.actions.splice(i, 1);
                    continue;
                }
                i++;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return assignActions;
};
function $ab1fe168d053d080$export$b8b9e7ba5b8c7b3e(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
    if (preserveActionOrder === void 0) preserveActionOrder = false;
    var assignActions = preserveActionOrder ? [] : $ab1fe168d053d080$var$pluckAssigns(actionBlocks);
    var updatedContext = assignActions.length ? (0, $0ba2bc18e91bd780$export$d84706064a6e6c1c)(currentContext, _event, assignActions, currentState) : currentContext;
    var preservedContexts = preserveActionOrder ? [
        currentContext
    ] : undefined;
    var deferredToBlockEnd = [];
    function handleAction(blockType, actionObject) {
        var _a;
        switch(actionObject.type){
            case 0, $41059b6f2e1b7a0a$export$66313c302b2ea154:
                var raisedAction = $ab1fe168d053d080$export$ed3daf8e935ede01(actionObject, updatedContext, _event, machine.options.delays);
                if (predictableExec && typeof raisedAction.delay === "number") predictableExec(raisedAction, updatedContext, _event);
                return raisedAction;
            case 0, $41059b6f2e1b7a0a$export$89db4734f6c919c4:
                var sendAction = $ab1fe168d053d080$export$f43e8cbb721d72d5(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init
                if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) {
                    var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here
                    (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!(0, $0ba2bc18e91bd780$export$844ec244b1367d54)(configuredDelay) || typeof sendAction.delay === "number", "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
                }
                if (predictableExec && sendAction.to !== (0, $b74e93109ba456db$export$79f5baa747fbdd45).Internal) {
                    if (blockType === "entry") deferredToBlockEnd.push(sendAction);
                    else predictableExec(sendAction, updatedContext, _event);
                }
                return sendAction;
            case 0, $41059b6f2e1b7a0a$export$bef1f36f5486a6a3:
                var resolved = $ab1fe168d053d080$export$12cba28d36be4946(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, updatedContext, _event);
                return resolved;
            case 0, $41059b6f2e1b7a0a$export$7877a478dd30fd3d:
                var chooseAction = actionObject;
                var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                    var guard = (0, $0ba2bc18e91bd780$export$b0f5a08e0ca47933)(condition.cond, machine.options.guards);
                    return !guard || (0, $0ba2bc18e91bd780$export$91646ab912d254e8)(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
                })) === null || _a === void 0 ? void 0 : _a.actions;
                if (!matchedActions) return [];
                var _b = (0, $d9c803f633d21408$export$8d051b38c9118094)($ab1fe168d053d080$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $ab1fe168d053d080$export$aa68691f32e6c459((0, $0ba2bc18e91bd780$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
                updatedContext = resolvedContextFromChoose;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromChoose;
            case 0, $41059b6f2e1b7a0a$export$48ec4a2b1cfc6557:
                var matchedActions = actionObject.get(updatedContext, _event.data);
                if (!matchedActions) return [];
                var _c = (0, $d9c803f633d21408$export$8d051b38c9118094)($ab1fe168d053d080$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $ab1fe168d053d080$export$aa68691f32e6c459((0, $0ba2bc18e91bd780$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
                updatedContext = resolvedContext;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromPure;
            case 0, $41059b6f2e1b7a0a$export$fa6813432f753b0d:
                var resolved = $ab1fe168d053d080$export$21aa461f4eb8e82(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, currentContext, _event);
                return resolved;
            case 0, $41059b6f2e1b7a0a$export$e6e34fd1f2686227:
                updatedContext = (0, $0ba2bc18e91bd780$export$d84706064a6e6c1c)(updatedContext, _event, [
                    actionObject
                ], !predictableExec ? currentState : undefined);
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                break;
            default:
                var resolvedActionObject = $ab1fe168d053d080$export$b38b66cc2da3ede7(actionObject, machine.options.actions);
                var exec_1 = resolvedActionObject.exec;
                if (predictableExec) predictableExec(resolvedActionObject, updatedContext, _event);
                else if (exec_1 && preservedContexts) {
                    var contextIndex_1 = preservedContexts.length - 1;
                    var wrapped = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, resolvedActionObject), {
                        exec: function(_ctx) {
                            var args = [];
                            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                            exec_1.apply(void 0, (0, $d9c803f633d21408$export$1216008129fb82ed)([
                                preservedContexts[contextIndex_1]
                            ], (0, $d9c803f633d21408$export$8d051b38c9118094)(args), false));
                        }
                    });
                    resolvedActionObject = wrapped;
                }
                return resolvedActionObject;
        }
    }
    function processBlock(block) {
        var e_2, _a;
        var resolvedActions = [];
        try {
            for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(block.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                var resolved = handleAction(block.type, action);
                if (resolved) resolvedActions = resolvedActions.concat(resolved);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        deferredToBlockEnd.forEach(function(action) {
            predictableExec(action, updatedContext, _event);
        });
        deferredToBlockEnd.length = 0;
        return resolvedActions;
    }
    var resolvedActions = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(actionBlocks.map(processBlock));
    return [
        resolvedActions,
        updatedContext
    ];
}



function $db5fc64655327378$export$3a6d15eeb5fb214c(a, b) {
    if (a === b) return true;
    if (a === undefined || b === undefined) return false;
    if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(a) || (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(b)) return a === b;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    return aKeys.length === bKeys.length && aKeys.every(function(key) {
        return $db5fc64655327378$export$3a6d15eeb5fb214c(a[key], b[key]);
    });
}
function $db5fc64655327378$export$4c86eb6450eda77a(state) {
    if (typeof state !== "object" || state === null) return false;
    return "value" in state && "_event" in state;
}
/**
 * @deprecated Use `isStateConfig(object)` or `state instanceof State` instead.
 */ var $db5fc64655327378$export$e5d60a6bbabd36f = $db5fc64655327378$export$4c86eb6450eda77a;
function $db5fc64655327378$export$e42513ad58964418(action, state) {
    var exec = action.exec;
    var boundAction = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, action), {
        exec: exec !== undefined ? function() {
            return exec(state.context, state.event, {
                action: action,
                state: state,
                _event: state._event
            });
        } : undefined
    });
    return boundAction;
}
var $db5fc64655327378$export$7254cc27399e90bd = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */ function State(config) {
        var _this = this;
        var _a;
        this.actions = [];
        this.activities = (0, $9700b9c4f37abdbc$export$505a390a702f4a23);
        this.meta = {};
        this.events = [];
        this.value = config.value;
        this.context = config.context;
        this._event = config._event;
        this._sessionid = config._sessionid;
        this.event = this._event.data;
        this.historyValue = config.historyValue;
        this.history = config.history;
        this.actions = config.actions || [];
        this.activities = config.activities || (0, $9700b9c4f37abdbc$export$505a390a702f4a23);
        this.meta = (0, $83ffdf18b0958611$export$c47913ca32a5c6f7)(config.configuration);
        this.events = config.events || [];
        this.matches = this.matches.bind(this);
        this.toStrings = this.toStrings.bind(this);
        this.configuration = config.configuration;
        this.transitions = config.transitions;
        this.children = config.children;
        this.done = !!config.done;
        this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
        this.machine = config.machine;
        Object.defineProperty(this, "nextEvents", {
            get: function() {
                return (0, $83ffdf18b0958611$export$c661ab6895e3ed73)(_this.configuration);
            }
        });
    }
    /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */ State.from = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (stateValue.context !== context) return new State({
                value: stateValue.value,
                context: context,
                _event: stateValue._event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                actions: [],
                activities: stateValue.activities,
                meta: {},
                events: [],
                configuration: [],
                transitions: [],
                children: {}
            });
            return stateValue;
        }
        var _event = (0, $ab1fe168d053d080$export$163c566c60ed2ec9);
        return new State({
            value: stateValue,
            context: context,
            _event: _event,
            _sessionid: null,
            historyValue: undefined,
            history: undefined,
            actions: [],
            activities: undefined,
            meta: undefined,
            events: [],
            configuration: [],
            transitions: [],
            children: {}
        });
    };
    /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */ State.create = function(config) {
        return new State(config);
    };
    /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */ State.inert = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (!stateValue.actions.length) return stateValue;
            var _event = (0, $ab1fe168d053d080$export$163c566c60ed2ec9);
            return new State({
                value: stateValue.value,
                context: context,
                _event: _event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                activities: stateValue.activities,
                configuration: stateValue.configuration,
                transitions: [],
                children: {}
            });
        }
        return State.from(stateValue, context);
    };
    /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */ State.prototype.toStrings = function(stateValue, delimiter) {
        var _this = this;
        if (stateValue === void 0) stateValue = this.value;
        if (delimiter === void 0) delimiter = ".";
        if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(stateValue)) return [
            stateValue
        ];
        var valueKeys = Object.keys(stateValue);
        return valueKeys.concat.apply(valueKeys, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(valueKeys.map(function(key) {
            return _this.toStrings(stateValue[key], delimiter).map(function(s) {
                return key + delimiter + s;
            });
        })), false));
    };
    State.prototype.toJSON = function() {
        var _a = this;
        _a.configuration;
        _a.transitions;
        var tags = _a.tags;
        _a.machine;
        var jsonValues = (0, $d9c803f633d21408$export$3c9a16f847548506)(_a, [
            "configuration",
            "transitions",
            "tags",
            "machine"
        ]);
        return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, jsonValues), {
            tags: Array.from(tags)
        });
    };
    State.prototype.matches = function(parentStateValue) {
        return (0, $0ba2bc18e91bd780$export$2870710bf0eac88e)(parentStateValue, this.value);
    };
    /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */ State.prototype.hasTag = function(tag) {
        return this.tags.has(tag);
    };
    /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */ State.prototype.can = function(event) {
        var _a;
        if (0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
        var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
        return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
        transitionData.transitions.some(function(t) {
            return t.target !== undefined || t.actions.length;
        });
    };
    return State;
}();







var $d4afdeb7da3b7c9c$var$defaultOptions = {
    deferEvents: false
};
var $d4afdeb7da3b7c9c$export$d3e54bb8584cda7c = /*#__PURE__*/ /** @class */ function() {
    function Scheduler(options) {
        this.processingEvent = false;
        this.queue = [];
        this.initialized = false;
        this.options = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, $d4afdeb7da3b7c9c$var$defaultOptions), options);
    }
    Scheduler.prototype.initialize = function(callback) {
        this.initialized = true;
        if (callback) {
            if (!this.options.deferEvents) {
                this.schedule(callback);
                return;
            }
            this.process(callback);
        }
        this.flushEvents();
    };
    Scheduler.prototype.schedule = function(task) {
        if (!this.initialized || this.processingEvent) {
            this.queue.push(task);
            return;
        }
        if (this.queue.length !== 0) throw new Error("Event queue should be empty when it is not processing events");
        this.process(task);
        this.flushEvents();
    };
    Scheduler.prototype.clear = function() {
        this.queue = [];
    };
    Scheduler.prototype.flushEvents = function() {
        var nextCallback = this.queue.shift();
        while(nextCallback){
            this.process(nextCallback);
            nextCallback = this.queue.shift();
        }
    };
    Scheduler.prototype.process = function(callback) {
        this.processingEvent = true;
        try {
            callback();
        } catch (e) {
            // there is no use to keep the future events
            // as the situation is not anymore the same
            this.clear();
            throw e;
        } finally{
            this.processingEvent = false;
        }
    };
    return Scheduler;
}();




/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */ var $d5fd06e17ea1d0ca$var$serviceStack = [];
var $d5fd06e17ea1d0ca$export$abe1e183e22e10ad = function(service, fn) {
    $d5fd06e17ea1d0ca$var$serviceStack.push(service);
    var result = fn(service);
    $d5fd06e17ea1d0ca$var$serviceStack.pop();
    return result;
};
var $d5fd06e17ea1d0ca$export$e11e6a155c5c4d9d = function(fn) {
    return fn($d5fd06e17ea1d0ca$var$serviceStack[$d5fd06e17ea1d0ca$var$serviceStack.length - 1]);
};


function $4b4d9290e25c7ae7$export$8998449b468dcdad(id) {
    var _a;
    return _a = {
        id: id,
        send: function() {
            return void 0;
        },
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        getSnapshot: function() {
            return undefined;
        },
        toJSON: function() {
            return {
                id: id
            };
        }
    }, _a[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */ function $4b4d9290e25c7ae7$export$78b4a98dcb5ac328(invokeDefinition, machine, context, _event) {
    var _a;
    var invokeSrc = (0, $0ba2bc18e91bd780$export$436e852aa2feda95)(invokeDefinition.src);
    var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
    var resolvedData = invokeDefinition.data ? (0, $0ba2bc18e91bd780$export$e756e60189cc2351)(invokeDefinition.data, context, _event) : undefined;
    var tempActor = serviceCreator ? $4b4d9290e25c7ae7$export$59bcb51d8e40ed48(serviceCreator, invokeDefinition.id, resolvedData) : $4b4d9290e25c7ae7$export$8998449b468dcdad(invokeDefinition.id); // @ts-ignore
    tempActor.meta = invokeDefinition;
    return tempActor;
}
function $4b4d9290e25c7ae7$export$59bcb51d8e40ed48(entity, id, data) {
    var tempActor = $4b4d9290e25c7ae7$export$8998449b468dcdad(id); // @ts-ignore
    tempActor.deferred = true;
    if ((0, $0ba2bc18e91bd780$export$2163e7903738b5df)(entity)) {
        // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
        var initialState_1 = tempActor.state = (0, $d5fd06e17ea1d0ca$export$abe1e183e22e10ad)(undefined, function() {
            return (data ? entity.withContext(data) : entity).initialState;
        });
        tempActor.getSnapshot = function() {
            return initialState_1;
        };
    }
    return tempActor;
}
function $4b4d9290e25c7ae7$export$e769f6913f14f1b7(item) {
    try {
        return typeof item.send === "function";
    } catch (e) {
        return false;
    }
}
function $4b4d9290e25c7ae7$export$b0f989039dc164f9(item) {
    return $4b4d9290e25c7ae7$export$e769f6913f14f1b7(item) && "id" in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now
function $4b4d9290e25c7ae7$export$ccadea5f6b9e9b4e(actorRefLike) {
    var _a;
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((_a = {
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        id: "anonymous",
        getSnapshot: function() {
            return undefined;
        }
    }, _a[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a), actorRefLike);
}


var $9a2b924c76081ce4$var$children = /*#__PURE__*/ new Map();
var $9a2b924c76081ce4$var$sessionIdIndex = 0;
var $9a2b924c76081ce4$export$4bb7493d241fd8a5 = {
    bookId: function() {
        return "x:".concat($9a2b924c76081ce4$var$sessionIdIndex++);
    },
    register: function(id, actor) {
        $9a2b924c76081ce4$var$children.set(id, actor);
        return id;
    },
    get: function(id) {
        return $9a2b924c76081ce4$var$children.get(id);
    },
    free: function(id) {
        $9a2b924c76081ce4$var$children.delete(id);
    }
};



function $4e631aba0bc90519$export$a4e55266d2135a7f() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues");
}
function $4e631aba0bc90519$var$getDevTools() {
    var global1 = $4e631aba0bc90519$export$a4e55266d2135a7f();
    if (global1 && "__xstate__" in global1) return global1.__xstate__;
    return undefined;
}
function $4e631aba0bc90519$export$4d7a7d14704ebc13(service) {
    if (!$4e631aba0bc90519$export$a4e55266d2135a7f()) return;
    var devTools = $4e631aba0bc90519$var$getDevTools();
    if (devTools) devTools.register(service);
}






/**
 * Returns an actor behavior from a reducer and its initial state.
 *
 * @param transition The pure reducer that returns the next state given the current state and event.
 * @param initialState The initial state of the reducer.
 * @returns An actor behavior
 */ function $1a367ba7ff6a0efe$export$fe581ffd4962847b(transition, initialState) {
    return {
        transition: transition,
        initialState: initialState
    };
}
function $1a367ba7ff6a0efe$export$60f45028237c39d1(promiseFn) {
    var initialState = {
        error: undefined,
        data: undefined,
        status: "pending"
    };
    return {
        transition: function(state, event, _a) {
            var parent = _a.parent, id = _a.id, observers = _a.observers;
            switch(event.type){
                case "fulfill":
                    parent === null || parent === void 0 || parent.send((0, $ab1fe168d053d080$export$c105e588793f70b4)(id, event.data));
                    return {
                        error: undefined,
                        data: event.data,
                        status: "fulfilled"
                    };
                case "reject":
                    parent === null || parent === void 0 || parent.send((0, $ab1fe168d053d080$export$a3bc9b8ed74fc)(id, event.error));
                    observers.forEach(function(observer) {
                        observer.error(event.error);
                    });
                    return {
                        error: event.error,
                        data: undefined,
                        status: "rejected"
                    };
                default:
                    return state;
            }
        },
        initialState: initialState,
        start: function(_a) {
            var self = _a.self;
            promiseFn().then(function(data) {
                self.send({
                    type: "fulfill",
                    data: data
                });
            }, function(reason) {
                self.send({
                    type: "reject",
                    error: reason
                });
            });
            return initialState;
        }
    };
}
function $1a367ba7ff6a0efe$export$cc3859917b3feaf8(behavior, options) {
    if (options === void 0) options = {};
    var state = behavior.initialState;
    var observers = new Set();
    var mailbox = [];
    var flushing = false;
    var flush = function() {
        if (flushing) return;
        flushing = true;
        while(mailbox.length > 0){
            var event_1 = mailbox.shift();
            state = behavior.transition(state, event_1, actorCtx);
            observers.forEach(function(observer) {
                return observer.next(state);
            });
        }
        flushing = false;
    };
    var actor = (0, $4b4d9290e25c7ae7$export$ccadea5f6b9e9b4e)({
        id: options.id,
        send: function(event) {
            mailbox.push(event);
            flush();
        },
        getSnapshot: function() {
            return state;
        },
        subscribe: function(next, handleError, complete) {
            var observer = (0, $0ba2bc18e91bd780$export$75b67481063f2f98)(next, handleError, complete);
            observers.add(observer);
            observer.next(state);
            return {
                unsubscribe: function() {
                    observers.delete(observer);
                }
            };
        }
    });
    var actorCtx = {
        parent: options.parent,
        self: actor,
        id: options.id || "anonymous",
        observers: observers
    };
    state = behavior.start ? behavior.start(actorCtx) : state;
    return actor;
}


var $9ab7fd156e8ddce7$var$DEFAULT_SPAWN_OPTIONS = {
    sync: false,
    autoForward: false
};
var $9ab7fd156e8ddce7$export$7a567c9c5088a551;
(function(InterpreterStatus) {
    InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
    InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
    InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})($9ab7fd156e8ddce7$export$7a567c9c5088a551 || ($9ab7fd156e8ddce7$export$7a567c9c5088a551 = {}));
var $9ab7fd156e8ddce7$export$e5b52c46a548ff03 = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */ function Interpreter(machine, options) {
        if (options === void 0) options = Interpreter.defaultOptions;
        var _this = this;
        this.machine = machine;
        this.delayedEventsMap = {};
        this.listeners = new Set();
        this.contextListeners = new Set();
        this.stopListeners = new Set();
        this.doneListeners = new Set();
        this.eventListeners = new Set();
        this.sendListeners = new Set();
        /**
     * Whether the service is started.
     */ this.initialized = false;
        this.status = $9ab7fd156e8ddce7$export$7a567c9c5088a551.NotStarted;
        this.children = new Map();
        this.forwardTo = new Set();
        this._outgoingQueue = [];
        /**
     * Alias for Interpreter.prototype.start
     */ this.init = this.start;
        /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */ this.send = function(event1, payload) {
            if ((0, $0ba2bc18e91bd780$export$43bee75e5e14138e)(event1)) {
                _this.batch(event1);
                return _this.state;
            }
            var _event = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)((0, $0ba2bc18e91bd780$export$5a4ea50826a01d14)(event1, payload));
            if (_this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.Stopped) {
                // do nothing
                if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, 'Event "'.concat(_event.name, '" was sent to stopped service "').concat(_this.machine.id, '". This service has already reached its final state, and will not transition.\nEvent: ').concat(JSON.stringify(_event.data)));
                return _this.state;
            }
            if (_this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running && !_this.options.deferEvents) throw new Error('Event "'.concat(_event.name, '" was sent to uninitialized service "').concat(_this.machine.id // tslint:disable-next-line:max-line-length
            , '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ').concat(JSON.stringify(_event.data)));
            _this.scheduler.schedule(function() {
                // Forward copy of event to child actors
                _this.forward(_event);
                var nextState = _this._nextState(_event);
                _this.update(nextState, _event);
            });
            return _this._state; // TODO: deprecate (should return void)
        // tslint:disable-next-line:semicolon
        };
        this.sendTo = function(event1, to, immediate) {
            var isParent = _this.parent && (to === (0, $b74e93109ba456db$export$79f5baa747fbdd45).Parent || _this.parent.id === to);
            var target = isParent ? _this.parent : (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(to) ? to === (0, $b74e93109ba456db$export$79f5baa747fbdd45).Internal ? _this : _this.children.get(to) || (0, $9a2b924c76081ce4$export$4bb7493d241fd8a5).get(to) : (0, $0ba2bc18e91bd780$export$e769f6913f14f1b7)(to) ? to : undefined;
            if (!target) {
                if (!isParent) throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
                 // tslint:disable-next-line:no-console
                if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event1.type));
                return;
            }
            if ("machine" in target) // perhaps those events should be rejected in the parent
            // but atm it doesn't have easy access to all of the information that is required to do it reliably
            {
                if (_this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
                _this.state.done) {
                    // Send SCXML events to machines
                    var scxmlEvent = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, event1), {
                        name: event1.name === (0, $41059b6f2e1b7a0a$export$a3bc9b8ed74fc) ? "".concat((0, $ab1fe168d053d080$export$a3bc9b8ed74fc)(_this.id)) : event1.name,
                        origin: _this.sessionId
                    });
                    if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                        target,
                        scxmlEvent
                    ]);
                    else target.send(scxmlEvent);
                }
            } else // Send normal events to other targets
            if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                target,
                event1.data
            ]);
            else target.send(event1.data);
        };
        this._exec = function(action, context, _event, actionFunctionMap) {
            if (actionFunctionMap === void 0) actionFunctionMap = _this.machine.options.actions;
            var actionOrExec = action.exec || (0, $ab1fe168d053d080$export$c7e5ca927bd4567)(action.type, actionFunctionMap);
            var exec = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
            if (exec) try {
                return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
                    action: action,
                    state: _this.state,
                    _event: _event
                } : {
                    action: action,
                    _event: _event
                });
            } catch (err) {
                if (_this.parent) _this.parent.send({
                    type: "xstate.error",
                    data: err
                });
                throw err;
            }
            switch(action.type){
                case 0, $41059b6f2e1b7a0a$export$66313c302b2ea154:
                    // if raise action reached the interpreter then it's a delayed one
                    var sendAction_1 = action;
                    _this.defer(sendAction_1);
                    break;
                case 0, $41059b6f2e1b7a0a$export$89db4734f6c919c4:
                    var sendAction = action;
                    if (typeof sendAction.delay === "number") {
                        _this.defer(sendAction);
                        return;
                    } else if (sendAction.to) _this.sendTo(sendAction._event, sendAction.to, _event === (0, $ab1fe168d053d080$export$163c566c60ed2ec9));
                    else _this.send(sendAction._event);
                    break;
                case 0, $41059b6f2e1b7a0a$export$70b61ad426ddbe54:
                    _this.cancel(action.sendId);
                    break;
                case 0, $41059b6f2e1b7a0a$export$b3571188c770cc5a:
                    if (_this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running) return;
                    var activity = action.activity; // If the activity will be stopped right after it's started
                    // (such as in transient states)
                    // don't bother starting the activity.
                    if (!_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) break;
                     // Invoked services
                    if (activity.type === (0, $b74e93109ba456db$export$1385d81a6c6bbcd4).Invoke) {
                        var invokeSource = (0, $0ba2bc18e91bd780$export$436e852aa2feda95)(activity.src);
                        var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
                        var id = activity.id, data = activity.data;
                        if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!("forward" in activity), "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
                        var autoForward = "autoForward" in activity ? activity.autoForward : !!activity.forward;
                        if (!serviceCreator) {
                            // tslint:disable-next-line:no-console
                            if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                            return;
                        }
                        var resolvedData = data ? (0, $0ba2bc18e91bd780$export$e756e60189cc2351)(data, context, _event) : undefined;
                        if (typeof serviceCreator === "string") // TODO: warn
                        return;
                        var source = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(serviceCreator) ? serviceCreator(context, _event.data, {
                            data: resolvedData,
                            src: invokeSource,
                            meta: activity.meta
                        }) : serviceCreator;
                        if (!source) // TODO: warn?
                        return;
                        var options = void 0;
                        if ((0, $0ba2bc18e91bd780$export$2163e7903738b5df)(source)) {
                            source = resolvedData ? source.withContext(resolvedData) : source;
                            options = {
                                autoForward: autoForward
                            };
                        }
                        _this.spawn(source, id, options);
                    } else _this.spawnActivity(activity);
                    break;
                case 0, $41059b6f2e1b7a0a$export$fa6813432f753b0d:
                    _this.stopChild(action.activity.id);
                    break;
                case 0, $41059b6f2e1b7a0a$export$bef1f36f5486a6a3:
                    var _a = action, label = _a.label, value = _a.value;
                    if (label) _this.logger(label, value);
                    else _this.logger(value);
                    break;
                default:
                    if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "No implementation found for action type '".concat(action.type, "'"));
                    break;
            }
        };
        var resolvedOptions = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, Interpreter.defaultOptions), options);
        var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
        var resolvedId = id !== undefined ? id : machine.id;
        this.id = resolvedId;
        this.logger = logger;
        this.clock = clock;
        this.parent = parent;
        this.options = resolvedOptions;
        this.scheduler = new (0, $d4afdeb7da3b7c9c$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
        this.sessionId = (0, $9a2b924c76081ce4$export$4bb7493d241fd8a5).bookId();
    }
    Object.defineProperty(Interpreter.prototype, "initialState", {
        get: function() {
            var _this = this;
            if (this._initialState) return this._initialState;
            return (0, $d5fd06e17ea1d0ca$export$abe1e183e22e10ad)(this, function() {
                _this._initialState = _this.machine.initialState;
                return _this._initialState;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interpreter.prototype, "state", {
        /**
     * @deprecated Use `.getSnapshot()` instead.
     */ get: function() {
            if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */ Interpreter.prototype.execute = function(state, actionsConfig) {
        var e_1, _a;
        try {
            for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(state.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                this.exec(action, state, actionsConfig);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Interpreter.prototype.update = function(state, _event) {
        var e_2, _a, e_3, _b, e_4, _c, e_5, _d;
        var _this = this; // Attach session ID to state
        state._sessionid = this.sessionId; // Update state
        this._state = state; // Execute actions
        if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
        // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
        _event === (0, $ab1fe168d053d080$export$163c566c60ed2ec9)) && this.options.execute) this.execute(this.state);
        else {
            var item = void 0;
            while(item = this._outgoingQueue.shift())item[0].send(item[1]);
        } // Update children
        this.children.forEach(function(child) {
            _this.state.children[child.id] = child;
        }); // Dev tools
        if (this.devTools) this.devTools.send(_event.data, state);
         // Execute listeners
        if (state.event) try {
            for(var _e = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()){
                var listener = _f.value;
                listener(state.event);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var _g = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()){
                var listener = _h.value;
                listener(state, state.event);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        try {
            for(var _j = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()){
                var contextListener = _k.value;
                contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        if (this.state.done) {
            // get final child state node
            var finalChildStateNode = state.configuration.find(function(sn) {
                return sn.type === "final" && sn.parent === _this.machine;
            });
            var doneData = finalChildStateNode && finalChildStateNode.doneData ? (0, $0ba2bc18e91bd780$export$e756e60189cc2351)(finalChildStateNode.doneData, state.context, _event) : undefined;
            this._doneEvent = (0, $ab1fe168d053d080$export$c105e588793f70b4)(this.id, doneData);
            try {
                for(var _l = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()){
                    var listener = _m.value;
                    listener(this._doneEvent);
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            this._stop();
            this._stopChildren();
            (0, $9a2b924c76081ce4$export$4bb7493d241fd8a5).free(this.sessionId);
        }
    };
    /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */ Interpreter.prototype.onTransition = function(listener) {
        this.listeners.add(listener); // Send current state to listener
        if (this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running) listener(this.state, this.state.event);
        return this;
    };
    Interpreter.prototype.subscribe = function(nextListenerOrObserver, _, completeListener) {
        var _this = this;
        var observer = (0, $0ba2bc18e91bd780$export$75b67481063f2f98)(nextListenerOrObserver, _, completeListener);
        this.listeners.add(observer.next); // Send current state to listener
        if (this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.NotStarted) observer.next(this.state);
        var completeOnce = function() {
            _this.doneListeners.delete(completeOnce);
            _this.stopListeners.delete(completeOnce);
            observer.complete();
        };
        if (this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.Stopped) observer.complete();
        else {
            this.onDone(completeOnce);
            this.onStop(completeOnce);
        }
        return {
            unsubscribe: function() {
                _this.listeners.delete(observer.next);
                _this.doneListeners.delete(completeOnce);
                _this.stopListeners.delete(completeOnce);
            }
        };
    };
    /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */ Interpreter.prototype.onEvent = function(listener) {
        this.eventListeners.add(listener);
        return this;
    };
    /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */ Interpreter.prototype.onSend = function(listener) {
        this.sendListeners.add(listener);
        return this;
    };
    /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */ Interpreter.prototype.onChange = function(listener) {
        this.contextListeners.add(listener);
        return this;
    };
    /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */ Interpreter.prototype.onStop = function(listener) {
        this.stopListeners.add(listener);
        return this;
    };
    /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */ Interpreter.prototype.onDone = function(listener) {
        if (this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.Stopped && this._doneEvent) listener(this._doneEvent);
        else this.doneListeners.add(listener);
        return this;
    };
    /**
   * Removes a listener.
   * @param listener The listener to remove
   */ Interpreter.prototype.off = function(listener) {
        this.listeners.delete(listener);
        this.eventListeners.delete(listener);
        this.sendListeners.delete(listener);
        this.stopListeners.delete(listener);
        this.doneListeners.delete(listener);
        this.contextListeners.delete(listener);
        return this;
    };
    /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */ Interpreter.prototype.start = function(initialState) {
        var _this = this;
        if (this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running) // Do not restart the service if it is already started
        return this;
         // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
        // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
        // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
        // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)
        this.machine._init();
        (0, $9a2b924c76081ce4$export$4bb7493d241fd8a5).register(this.sessionId, this);
        this.initialized = true;
        this.status = $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running;
        var resolvedState = initialState === undefined ? this.initialState : (0, $d5fd06e17ea1d0ca$export$abe1e183e22e10ad)(this, function() {
            return (0, $db5fc64655327378$export$4c86eb6450eda77a)(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState((0, $db5fc64655327378$export$7254cc27399e90bd).from(initialState, _this.machine.context));
        });
        if (this.options.devTools) this.attachDev();
        this.scheduler.initialize(function() {
            _this.update(resolvedState, (0, $ab1fe168d053d080$export$163c566c60ed2ec9));
        });
        return this;
    };
    Interpreter.prototype._stopChildren = function() {
        // TODO: think about converting those to actions
        this.children.forEach(function(child) {
            if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(child.stop)) child.stop();
        });
        this.children.clear();
    };
    Interpreter.prototype._stop = function() {
        var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
        try {
            for(var _f = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()){
                var listener = _g.value;
                this.listeners.delete(listener);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        try {
            for(var _h = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()){
                var listener = _j.value; // call listener, then remove
                listener();
                this.stopListeners.delete(listener);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        try {
            for(var _k = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()){
                var listener = _l.value;
                this.contextListeners.delete(listener);
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        try {
            for(var _m = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()){
                var listener = _o.value;
                this.doneListeners.delete(listener);
            }
        } catch (e_9_1) {
            e_9 = {
                error: e_9_1
            };
        } finally{
            try {
                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
            } finally{
                if (e_9) throw e_9.error;
            }
        }
        if (!this.initialized) // Interpreter already stopped; do nothing
        return this;
        this.initialized = false;
        this.status = $9ab7fd156e8ddce7$export$7a567c9c5088a551.Stopped;
        this._initialState = undefined;
        try {
            // we are going to stop within the current sync frame
            // so we can safely just cancel this here as nothing async should be fired anyway
            for(var _p = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()){
                var key = _q.value;
                this.clock.clearTimeout(this.delayedEventsMap[key]);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
            } finally{
                if (e_10) throw e_10.error;
            }
        } // clear everything that might be enqueued
        this.scheduler.clear();
        this.scheduler = new (0, $d4afdeb7da3b7c9c$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
    };
    /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */ Interpreter.prototype.stop = function() {
        // TODO: add warning for stopping non-root interpreters
        var _this = this; // grab the current scheduler as it will be replaced in _stop
        var scheduler = this.scheduler;
        this._stop(); // let what is currently processed to be finished
        scheduler.schedule(function() {
            // it feels weird to handle this here but we need to handle this even slightly "out of band"
            var _event = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)({
                type: "xstate.stop"
            });
            var nextState = (0, $d5fd06e17ea1d0ca$export$abe1e183e22e10ad)(_this, function() {
                var exitActions = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(_this.state.configuration), false).sort(function(a, b) {
                    return b.order - a.order;
                }).map(function(stateNode) {
                    return (0, $ab1fe168d053d080$export$aa68691f32e6c459)(stateNode.onExit, _this.machine.options.actions);
                }));
                var _a = (0, $d9c803f633d21408$export$8d051b38c9118094)((0, $ab1fe168d053d080$export$b8b9e7ba5b8c7b3e)(_this.machine, _this.state, _this.state.context, _event, [
                    {
                        type: "exit",
                        actions: exitActions
                    }
                ], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2), resolvedActions = _a[0], updatedContext = _a[1];
                var newState = new (0, $db5fc64655327378$export$7254cc27399e90bd)({
                    value: _this.state.value,
                    context: updatedContext,
                    _event: _event,
                    _sessionid: _this.sessionId,
                    historyValue: undefined,
                    history: _this.state,
                    actions: resolvedActions.filter(function(action) {
                        return !(0, $0ba2bc18e91bd780$export$37dc2eda56cb25a5)(action);
                    }),
                    activities: {},
                    events: [],
                    configuration: [],
                    transitions: [],
                    children: {},
                    done: _this.state.done,
                    tags: _this.state.tags,
                    machine: _this.machine
                });
                newState.changed = true;
                return newState;
            });
            _this.update(nextState, _event);
            _this._stopChildren();
            (0, $9a2b924c76081ce4$export$4bb7493d241fd8a5).free(_this.sessionId);
        });
        return this;
    };
    Interpreter.prototype.batch = function(events) {
        var _this = this;
        if (this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.NotStarted && this.options.deferEvents) // tslint:disable-next-line:no-console
        {
            if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '" and are deferred. Make sure .start() is called for this service.\nEvent: ').concat(JSON.stringify(event)));
        } else if (this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running) throw new Error("".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.'));
        if (!events.length) return;
        var exec = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
            var e_11, _a;
            var nextState = _this.state;
            var batchChanged = false;
            var batchedActions = [];
            var _loop_1 = function(event_1) {
                var _event = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)(event_1);
                _this.forward(_event);
                nextState = (0, $d5fd06e17ea1d0ca$export$abe1e183e22e10ad)(_this, function() {
                    return _this.machine.transition(nextState, _event, undefined, exec || undefined);
                });
                batchedActions.push.apply(batchedActions, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function(a) {
                    return (0, $db5fc64655327378$export$e42513ad58964418)(a, nextState);
                })), false));
                batchChanged = batchChanged || !!nextState.changed;
            };
            try {
                for(var events_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()){
                    var event_1 = events_1_1.value;
                    _loop_1(event_1);
                }
            } catch (e_11_1) {
                e_11 = {
                    error: e_11_1
                };
            } finally{
                try {
                    if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                } finally{
                    if (e_11) throw e_11.error;
                }
            }
            nextState.changed = batchChanged;
            nextState.actions = batchedActions;
            _this.update(nextState, (0, $0ba2bc18e91bd780$export$eaf22249b410f633)(events[events.length - 1]));
        });
    };
    /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */ Interpreter.prototype.sender = function(event1) {
        return this.send.bind(this, event1);
    };
    Interpreter.prototype._nextState = function(event1, exec) {
        var _this = this;
        if (exec === void 0) exec = !!this.machine.config.predictableActionArguments && this._exec;
        var _event = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)(event1);
        if (_event.name.indexOf((0, $41059b6f2e1b7a0a$export$503a23d0e5cd1226)) === 0 && !this.state.nextEvents.some(function(nextEvent) {
            return nextEvent.indexOf((0, $41059b6f2e1b7a0a$export$503a23d0e5cd1226)) === 0;
        })) throw _event.data.data;
        var nextState = (0, $d5fd06e17ea1d0ca$export$abe1e183e22e10ad)(this, function() {
            return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
        });
        return nextState;
    };
    /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */ Interpreter.prototype.nextState = function(event1) {
        return this._nextState(event1, false);
    };
    Interpreter.prototype.forward = function(event1) {
        var e_12, _a;
        try {
            for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()){
                var id = _c.value;
                var child = this.children.get(id);
                if (!child) throw new Error("Unable to forward event '".concat(event1, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
                child.send(event1);
            }
        } catch (e_12_1) {
            e_12 = {
                error: e_12_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_12) throw e_12.error;
            }
        }
    };
    Interpreter.prototype.defer = function(sendAction) {
        var _this = this;
        var timerId = this.clock.setTimeout(function() {
            if ("to" in sendAction && sendAction.to) _this.sendTo(sendAction._event, sendAction.to, true);
            else _this.send(sendAction._event);
        }, sendAction.delay);
        if (sendAction.id) this.delayedEventsMap[sendAction.id] = timerId;
    };
    Interpreter.prototype.cancel = function(sendId) {
        this.clock.clearTimeout(this.delayedEventsMap[sendId]);
        delete this.delayedEventsMap[sendId];
    };
    Interpreter.prototype.exec = function(action, state, actionFunctionMap) {
        if (actionFunctionMap === void 0) actionFunctionMap = this.machine.options.actions;
        this._exec(action, state.context, state._event, actionFunctionMap);
    };
    Interpreter.prototype.removeChild = function(childId) {
        var _a;
        this.children.delete(childId);
        this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
        // such as when a child is added then removed while initializing the state
        (_a = this.state) === null || _a === void 0 || delete _a.children[childId];
    };
    Interpreter.prototype.stopChild = function(childId) {
        var child = this.children.get(childId);
        if (!child) return;
        this.removeChild(childId);
        if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(child.stop)) child.stop();
    };
    Interpreter.prototype.spawn = function(entity, name, options) {
        if (this.status !== $9ab7fd156e8ddce7$export$7a567c9c5088a551.Running) return (0, $4b4d9290e25c7ae7$export$59bcb51d8e40ed48)(entity, name);
        if ((0, $0ba2bc18e91bd780$export$ae936b9d47e5870e)(entity)) return this.spawnPromise(Promise.resolve(entity), name);
        else if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(entity)) return this.spawnCallback(entity, name);
        else if ((0, $4b4d9290e25c7ae7$export$b0f989039dc164f9)(entity)) return this.spawnActor(entity, name);
        else if ((0, $0ba2bc18e91bd780$export$5cd057a6046189f9)(entity)) return this.spawnObservable(entity, name);
        else if ((0, $0ba2bc18e91bd780$export$2163e7903738b5df)(entity)) return this.spawnMachine(entity, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, options), {
            id: name
        }));
        else if ((0, $0ba2bc18e91bd780$export$42749ebe1e7fdef7)(entity)) return this.spawnBehavior(entity, name);
        else throw new Error('Unable to spawn entity "'.concat(name, '" of type "').concat(typeof entity, '".'));
    };
    Interpreter.prototype.spawnMachine = function(machine, options) {
        var _this = this;
        if (options === void 0) options = {};
        var childService = new Interpreter(machine, (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, this.options), {
            parent: this,
            id: options.id || machine.id
        }));
        var resolvedOptions = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, $9ab7fd156e8ddce7$var$DEFAULT_SPAWN_OPTIONS), options);
        if (resolvedOptions.sync) childService.onTransition(function(state) {
            _this.send((0, $41059b6f2e1b7a0a$export$722fbec263ad908a), {
                state: state,
                id: childService.id
            });
        });
        var actor = childService;
        this.children.set(childService.id, actor);
        if (resolvedOptions.autoForward) this.forwardTo.add(childService.id);
        childService.onDone(function(doneEvent) {
            _this.removeChild(childService.id);
            _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)(doneEvent, {
                origin: childService.id
            }));
        }).start();
        return actor;
    };
    Interpreter.prototype.spawnBehavior = function(behavior, id) {
        var actorRef = (0, $1a367ba7ff6a0efe$export$cc3859917b3feaf8)(behavior, {
            id: id,
            parent: this
        });
        this.children.set(id, actorRef);
        return actorRef;
    };
    Interpreter.prototype.spawnPromise = function(promise, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var resolvedData;
        promise.then(function(response) {
            if (!canceled) {
                resolvedData = response;
                _this.removeChild(id);
                _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)((0, $ab1fe168d053d080$export$c105e588793f70b4)(id, response), {
                    origin: id
                }));
            }
        }, function(errorData) {
            if (!canceled) {
                _this.removeChild(id);
                var errorEvent = (0, $ab1fe168d053d080$export$a3bc9b8ed74fc)(id, errorData);
                try {
                    // Send "error.platform.id" to this (parent).
                    _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)(errorEvent, {
                        origin: id
                    }));
                } catch (error) {
                    (0, $0ba2bc18e91bd780$export$b240b9b7a78b5f3e)(errorData, error, id);
                    if (_this.devTools) _this.devTools.send(errorEvent, _this.state);
                    if (_this.machine.strict) // it would be better to always stop the state machine if unhandled
                    // exception/promise rejection happens but because we don't want to
                    // break existing code so enforce it on strict mode only especially so
                    // because documentation says that onError is optional
                    _this.stop();
                }
            }
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                var observer = (0, $0ba2bc18e91bd780$export$75b67481063f2f98)(next, handleError, complete);
                var unsubscribed = false;
                promise.then(function(response) {
                    if (unsubscribed) return;
                    observer.next(response);
                    if (unsubscribed) return;
                    observer.complete();
                }, function(err) {
                    if (unsubscribed) return;
                    observer.error(err);
                });
                return {
                    unsubscribe: function() {
                        return unsubscribed = true;
                    }
                };
            },
            stop: function() {
                canceled = true;
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return resolvedData;
            }
        }, _a[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnCallback = function(callback, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var receivers = new Set();
        var listeners = new Set();
        var emitted;
        var receive = function(e) {
            emitted = e;
            listeners.forEach(function(listener) {
                return listener(e);
            });
            if (canceled) return;
            _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)(e, {
                origin: id
            }));
        };
        var callbackStop;
        try {
            callbackStop = callback(receive, function(newListener) {
                receivers.add(newListener);
            });
        } catch (err) {
            this.send((0, $ab1fe168d053d080$export$a3bc9b8ed74fc)(id, err));
        }
        if ((0, $0ba2bc18e91bd780$export$ae936b9d47e5870e)(callbackStop)) // it turned out to be an async function, can't reliably check this before calling `callback`
        // because transpiled async functions are not recognizable
        return this.spawnPromise(callbackStop, id);
        var actor = (_a = {
            id: id,
            send: function(event1) {
                return receivers.forEach(function(receiver) {
                    return receiver(event1);
                });
            },
            subscribe: function(next) {
                var observer = (0, $0ba2bc18e91bd780$export$75b67481063f2f98)(next);
                listeners.add(observer.next);
                return {
                    unsubscribe: function() {
                        listeners.delete(observer.next);
                    }
                };
            },
            stop: function() {
                canceled = true;
                if ((0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(callbackStop)) callbackStop();
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return emitted;
            }
        }, _a[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnObservable = function(source, id) {
        var _a;
        var _this = this;
        var emitted;
        var subscription = source.subscribe(function(value) {
            emitted = value;
            _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)(value, {
                origin: id
            }));
        }, function(err) {
            _this.removeChild(id);
            _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)((0, $ab1fe168d053d080$export$a3bc9b8ed74fc)(id, err), {
                origin: id
            }));
        }, function() {
            _this.removeChild(id);
            _this.send((0, $0ba2bc18e91bd780$export$eaf22249b410f633)((0, $ab1fe168d053d080$export$c105e588793f70b4)(id), {
                origin: id
            }));
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                return source.subscribe(next, handleError, complete);
            },
            stop: function() {
                return subscription.unsubscribe();
            },
            getSnapshot: function() {
                return emitted;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnActor = function(actor, name) {
        this.children.set(name, actor);
        return actor;
    };
    Interpreter.prototype.spawnActivity = function(activity) {
        var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;
        if (!implementation) {
            if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "No implementation found for activity '".concat(activity.type, "'"));
             // tslint:disable-next-line:no-console
            return;
        } // Start implementation
        var dispose = implementation(this.state.context, activity);
        this.spawnEffect(activity.id, dispose);
    };
    Interpreter.prototype.spawnEffect = function(id, dispose) {
        var _a;
        this.children.set(id, (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function() {
                return {
                    unsubscribe: function() {
                        return void 0;
                    }
                };
            },
            stop: dispose || undefined,
            getSnapshot: function() {
                return undefined;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a));
    };
    Interpreter.prototype.attachDev = function() {
        var global = (0, $4e631aba0bc90519$export$a4e55266d2135a7f)();
        if (this.options.devTools && global) {
            if (global.__REDUX_DEVTOOLS_EXTENSION__) {
                var devToolsOptions = typeof this.options.devTools === "object" ? this.options.devTools : undefined;
                this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({
                    name: this.id,
                    autoPause: true,
                    stateSanitizer: function(state) {
                        return {
                            value: state.value,
                            context: state.context,
                            actions: state.actions
                        };
                    }
                }, devToolsOptions), {
                    features: (0, $d9c803f633d21408$export$18ce0697a983be9b)({
                        jump: false,
                        skip: false
                    }, devToolsOptions ? devToolsOptions.features : undefined)
                }), this.machine);
                this.devTools.init(this.state);
            } // add XState-specific dev tooling hook
            (0, $4e631aba0bc90519$export$4d7a7d14704ebc13)(this);
        }
    };
    Interpreter.prototype.toJSON = function() {
        return {
            id: this.id
        };
    };
    Interpreter.prototype[0, $0ba2bc18e91bd780$export$c45ebe72e3b2885] = function() {
        return this;
    };
    Interpreter.prototype.getSnapshot = function() {
        if (this.status === $9ab7fd156e8ddce7$export$7a567c9c5088a551.NotStarted) return this.initialState;
        return this._state;
    };
    /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */ Interpreter.defaultOptions = {
        execute: true,
        deferEvents: true,
        clock: {
            setTimeout: function(fn, ms) {
                return setTimeout(fn, ms);
            },
            clearTimeout: function(id) {
                return clearTimeout(id);
            }
        },
        logger: /*#__PURE__*/ console.log.bind(console),
        devTools: false
    };
    Interpreter.interpret = $9ab7fd156e8ddce7$export$67beed298888a38b;
    return Interpreter;
}();
var $9ab7fd156e8ddce7$var$resolveSpawnOptions = function(nameOrOptions) {
    if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(nameOrOptions)) return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, $9ab7fd156e8ddce7$var$DEFAULT_SPAWN_OPTIONS), {
        name: nameOrOptions
    });
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, $9ab7fd156e8ddce7$var$DEFAULT_SPAWN_OPTIONS), {
        name: (0, $0ba2bc18e91bd780$export$8b15d37bc3f197d4)()
    }), nameOrOptions);
};
function $9ab7fd156e8ddce7$export$1713f5ac2bf0caf5(entity, nameOrOptions) {
    var resolvedOptions = $9ab7fd156e8ddce7$var$resolveSpawnOptions(nameOrOptions);
    return (0, $d5fd06e17ea1d0ca$export$e11e6a155c5c4d9d)(function(service) {
        if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) {
            var isLazyEntity = (0, $0ba2bc18e91bd780$export$2163e7903738b5df)(entity) || (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(entity);
            (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!!service || isLazyEntity, 'Attempted to spawn an Actor (ID: "'.concat((0, $0ba2bc18e91bd780$export$2163e7903738b5df)(entity) ? entity.id : "undefined", '") outside of a service. This will have no effect.'));
        }
        if (service) return service.spawn(entity, resolvedOptions.name, resolvedOptions);
        else return (0, $4b4d9290e25c7ae7$export$59bcb51d8e40ed48)(entity, resolvedOptions.name);
    });
}
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */ function $9ab7fd156e8ddce7$export$67beed298888a38b(machine, options) {
    var interpreter = new $9ab7fd156e8ddce7$export$e5b52c46a548ff03(machine, options);
    return interpreter;
}



var $7999b7c62f1eeee0$var$__assign = undefined && undefined.__assign || function() {
    $7999b7c62f1eeee0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7999b7c62f1eeee0$var$__assign.apply(this, arguments);
};
var $7999b7c62f1eeee0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7999b7c62f1eeee0$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $7999b7c62f1eeee0$export$d09836c9e303db57(getMachine, options) {
    var machine = (0, $87f30c26962d1c2f$export$2e2bcd8739ae039)(function() {
        return typeof getMachine === "function" ? getMachine() : getMachine;
    });
    var _a, initialMachine;
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = $7999b7c62f1eeee0$var$__rest(options, [
        "context",
        "guards",
        "actions",
        "activities",
        "services",
        "delays",
        "state"
    ]);
    var service = (0, $87f30c26962d1c2f$export$2e2bcd8739ae039)(function() {
        var machineConfig = {
            context: context,
            guards: guards,
            actions: actions,
            activities: activities,
            services: services,
            delays: delays
        };
        var machineWithConfig = machine.withConfig(machineConfig, function() {
            return $7999b7c62f1eeee0$var$__assign($7999b7c62f1eeee0$var$__assign({}, machine.context), context);
        });
        return (0, $9ab7fd156e8ddce7$export$67beed298888a38b)(machineWithConfig, interpreterOptions);
    });
    // Make sure options are kept updated when they change.
    // This mutation assignment is safe because the service instance is only used
    // in one place -- this hook's caller.
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        Object.assign(service.machine.options.actions, actions);
        Object.assign(service.machine.options.guards, guards);
        Object.assign(service.machine.options.activities, activities);
        Object.assign(service.machine.options.services, services);
        Object.assign(service.machine.options.delays, delays);
    }, [
        actions,
        guards,
        activities,
        services,
        delays
    ]);
    return service;
}
function $7999b7c62f1eeee0$export$d9e9b060fbbae528(getMachine) {
    var _a = [];
    for(var _i = 1; _i < arguments.length; _i++)_a[_i - 1] = arguments[_i];
    var _b = $7999b7c62f1eeee0$var$__read(_a, 2), _c = _b[0], options = _c === void 0 ? {} : _c, observerOrListener = _b[1];
    var service = $7999b7c62f1eeee0$export$d09836c9e303db57(getMachine, options);
    (0, $acw62.useEffect)(function() {
        if (!observerOrListener) return;
        var sub = service.subscribe((0, $0ba2bc18e91bd780$export$75b67481063f2f98)(observerOrListener));
        return function() {
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $acw62.useEffect)(function() {
        var rehydratedState = options.state;
        service.start(rehydratedState ? (0, $db5fc64655327378$export$7254cc27399e90bd).create(rehydratedState) : undefined);
        return function() {
            service.stop();
            service.status = (0, $9ab7fd156e8ddce7$export$7a567c9c5088a551).NotStarted;
        };
    }, []);
    return service;
}





















function $700c0fa66ede1df8$export$436e852aa2feda95(src) {
    if (typeof src === "string") {
        var simpleSrc = {
            type: src
        };
        simpleSrc.toString = function() {
            return src;
        }; // v4 compat - TODO: remove in v5
        return simpleSrc;
    }
    return src;
}
function $700c0fa66ede1df8$export$4c73f685ba879446(invokeConfig) {
    return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({
        type: (0, $41059b6f2e1b7a0a$export$468cda29b159ee5d)
    }, invokeConfig), {
        toJSON: function() {
            invokeConfig.onDone;
            invokeConfig.onError;
            var invokeDef = (0, $d9c803f633d21408$export$3c9a16f847548506)(invokeConfig, [
                "onDone",
                "onError"
            ]);
            return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, invokeDef), {
                type: (0, $41059b6f2e1b7a0a$export$468cda29b159ee5d),
                src: $700c0fa66ede1df8$export$436e852aa2feda95(invokeConfig.src)
            });
        }
    });
}


var $7c7ca11796d1b64f$var$NULL_EVENT = "";
var $7c7ca11796d1b64f$var$STATE_IDENTIFIER = "#";
var $7c7ca11796d1b64f$var$WILDCARD = "*";
var $7c7ca11796d1b64f$var$EMPTY_OBJECT = {};
var $7c7ca11796d1b64f$var$isStateId = function(str) {
    return str[0] === $7c7ca11796d1b64f$var$STATE_IDENTIFIER;
};
var $7c7ca11796d1b64f$var$createDefaultOptions = function() {
    return {
        actions: {},
        guards: {},
        services: {},
        activities: {},
        delays: {}
    };
};
var $7c7ca11796d1b64f$var$validateArrayifiedTransitions = function(stateNode, event, transitions) {
    var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function(transition) {
        return !("cond" in transition) && !("in" in transition) && ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(transition.target) || (0, $0ba2bc18e91bd780$export$2163e7903738b5df)(transition.target));
    });
    var eventText = event === $7c7ca11796d1b64f$var$NULL_EVENT ? "the transient event" : "event '".concat(event, "'");
    (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};
var $7c7ca11796d1b64f$export$342f24f5edd47b1 = /*#__PURE__*/ /** @class */ function() {
    function StateNode(/**
   * The raw config used to create the machine.
   */ config, options, /**
   * The initial extended state
   */ _context, _stateInfo) {
        if (_context === void 0) _context = "context" in config ? config.context : undefined;
        var _this = this;
        var _a;
        this.config = config;
        this._context = _context;
        /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */ this.order = -1;
        this.__xstatenode = true;
        this.__cache = {
            events: undefined,
            relativeValue: new Map(),
            initialStateValue: undefined,
            initialState: undefined,
            on: undefined,
            transitions: undefined,
            candidates: {},
            delayedTransitions: undefined
        };
        this.idMap = {};
        this.tags = [];
        this.options = Object.assign($7c7ca11796d1b64f$var$createDefaultOptions(), options);
        this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
        this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || "(machine)";
        this.machine = this.parent ? this.parent.machine : this;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : (0, $9700b9c4f37abdbc$export$b060f3cec92ef5c9));
        this.id = this.config.id || (0, $d9c803f633d21408$export$1216008129fb82ed)([
            this.machine.key
        ], (0, $d9c803f633d21408$export$8d051b38c9118094)(this.path), false).join(this.delimiter);
        this.version = this.parent ? this.parent.version : this.config.version;
        this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic");
        this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
        this.description = this.config.description;
        if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
        this.initial = this.config.initial;
        this.states = this.config.states ? (0, $0ba2bc18e91bd780$export$825e789796ab7275)(this.config.states, function(stateConfig, key) {
            var _a;
            var stateNode = new StateNode(stateConfig, {}, undefined, {
                parent: _this,
                key: key
            });
            Object.assign(_this.idMap, (0, $d9c803f633d21408$export$18ce0697a983be9b)((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
            return stateNode;
        }) : $7c7ca11796d1b64f$var$EMPTY_OBJECT; // Document order
        var order = 0;
        function dfs(stateNode) {
            var e_1, _a;
            stateNode.order = order++;
            try {
                for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)((0, $83ffdf18b0958611$export$ad3d2e38d4deaf6d)(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var child = _c.value;
                    dfs(child);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        dfs(this); // History config
        this.history = this.config.history === true ? "shallow" : this.config.history || false;
        this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a) {
            var event = _a.event;
            return event === $7c7ca11796d1b64f$var$NULL_EVENT;
        }) : $7c7ca11796d1b64f$var$NULL_EVENT in this.config.on);
        this.strict = !!this.config.strict; // TODO: deprecate (entry)
        this.onEntry = (0, $0ba2bc18e91bd780$export$45b10814cc054894)(this.config.entry || this.config.onEntry).map(function(action) {
            return (0, $ab1fe168d053d080$export$b38b66cc2da3ede7)(action);
        }); // TODO: deprecate (exit)
        this.onExit = (0, $0ba2bc18e91bd780$export$45b10814cc054894)(this.config.exit || this.config.onExit).map(function(action) {
            return (0, $ab1fe168d053d080$export$b38b66cc2da3ede7)(action);
        });
        this.meta = this.config.meta;
        this.doneData = this.type === "final" ? this.config.data : undefined;
        this.invoke = (0, $0ba2bc18e91bd780$export$45b10814cc054894)(this.config.invoke).map(function(invokeConfig, i) {
            var _a, _b;
            if ((0, $0ba2bc18e91bd780$export$2163e7903738b5df)(invokeConfig)) {
                var invokeId = (0, $0ba2bc18e91bd780$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $d9c803f633d21408$export$18ce0697a983be9b)((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
                return (0, $700c0fa66ede1df8$export$4c73f685ba879446)({
                    src: invokeId,
                    id: invokeId
                });
            } else if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $0ba2bc18e91bd780$export$107b54c5097f9157)(_this.id, i);
                return (0, $700c0fa66ede1df8$export$4c73f685ba879446)((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, invokeConfig), {
                    id: invokeId,
                    src: invokeConfig.src
                }));
            } else if ((0, $0ba2bc18e91bd780$export$2163e7903738b5df)(invokeConfig.src) || (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $0ba2bc18e91bd780$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $d9c803f633d21408$export$18ce0697a983be9b)((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
                return (0, $700c0fa66ede1df8$export$4c73f685ba879446)((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({
                    id: invokeId
                }, invokeConfig), {
                    src: invokeId
                }));
            } else {
                var invokeSource = invokeConfig.src;
                return (0, $700c0fa66ede1df8$export$4c73f685ba879446)((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({
                    id: (0, $0ba2bc18e91bd780$export$107b54c5097f9157)(_this.id, i)
                }, invokeConfig), {
                    src: invokeSource
                }));
            }
        });
        this.activities = (0, $0ba2bc18e91bd780$export$45b10814cc054894)(this.config.activities).concat(this.invoke).map(function(activity) {
            return (0, $ab1fe168d053d080$export$e81fdd8937d44864)(activity);
        });
        this.transition = this.transition.bind(this);
        this.tags = (0, $0ba2bc18e91bd780$export$45b10814cc054894)(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
    }
    StateNode.prototype._init = function() {
        if (this.__cache.transitions) return;
        (0, $83ffdf18b0958611$export$3de19bba299e3801)(this).forEach(function(stateNode) {
            return stateNode.on;
        });
    };
    /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */ StateNode.prototype.withConfig = function(options, context) {
        var _a = this.options, actions = _a.actions, activities = _a.activities, guards = _a.guards, services = _a.services, delays = _a.delays;
        return new StateNode(this.config, {
            actions: (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, actions), options.actions),
            activities: (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, activities), options.activities),
            guards: (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, guards), options.guards),
            services: (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, services), options.services),
            delays: (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, delays), options.delays)
        }, context !== null && context !== void 0 ? context : this.context);
    };
    /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */ StateNode.prototype.withContext = function(context) {
        return new StateNode(this.config, this.options, context);
    };
    Object.defineProperty(StateNode.prototype, "context", {
        get: function() {
            return (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(this._context) ? this._context() : this._context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "definition", {
        /**
     * The well-structured state node definition.
     */ get: function() {
            return {
                id: this.id,
                key: this.key,
                version: this.version,
                context: this.context,
                type: this.type,
                initial: this.initial,
                history: this.history,
                states: (0, $0ba2bc18e91bd780$export$825e789796ab7275)(this.states, function(state) {
                    return state.definition;
                }),
                on: this.on,
                transitions: this.transitions,
                entry: this.onEntry,
                exit: this.onExit,
                activities: this.activities || [],
                meta: this.meta,
                order: this.order || -1,
                data: this.doneData,
                invoke: this.invoke,
                description: this.description,
                tags: this.tags
            };
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.toJSON = function() {
        return this.definition;
    };
    Object.defineProperty(StateNode.prototype, "on", {
        /**
     * The mapping of events to transitions.
     */ get: function() {
            if (this.__cache.on) return this.__cache.on;
            var transitions = this.transitions;
            return this.__cache.on = transitions.reduce(function(map, transition) {
                map[transition.eventType] = map[transition.eventType] || [];
                map[transition.eventType].push(transition);
                return map;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "after", {
        get: function() {
            return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "transitions", {
        /**
     * All the transitions that can be taken from this state node.
     */ get: function() {
            return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getCandidates = function(eventName) {
        if (this.__cache.candidates[eventName]) return this.__cache.candidates[eventName];
        var transient = eventName === $7c7ca11796d1b64f$var$NULL_EVENT;
        var candidates = this.transitions.filter(function(transition) {
            var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions
            return transient ? sameEventType : sameEventType || transition.eventType === $7c7ca11796d1b64f$var$WILDCARD;
        });
        this.__cache.candidates[eventName] = candidates;
        return candidates;
    };
    /**
   * All delayed transitions from the config.
   */ StateNode.prototype.getDelayedTransitions = function() {
        var _this = this;
        var afterConfig = this.config.after;
        if (!afterConfig) return [];
        var mutateEntryExit = function(delay, i) {
            var delayRef = (0, $0ba2bc18e91bd780$export$f6e2535fb5126e54)(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
            var eventType = (0, $ab1fe168d053d080$export$742acabee3dd6465)(delayRef, _this.id);
            _this.onEntry.push((0, $ab1fe168d053d080$export$89db4734f6c919c4)(eventType, {
                delay: delay
            }));
            _this.onExit.push((0, $ab1fe168d053d080$export$70b61ad426ddbe54)(eventType));
            return eventType;
        };
        var delayedTransitions = (0, $0ba2bc18e91bd780$export$43bee75e5e14138e)(afterConfig) ? afterConfig.map(function(transition, i) {
            var eventType = mutateEntryExit(transition.delay, i);
            return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, transition), {
                event: eventType
            });
        }) : (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(Object.keys(afterConfig).map(function(delay, i) {
            var configTransition = afterConfig[delay];
            var resolvedTransition = (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(configTransition) ? {
                target: configTransition
            } : configTransition;
            var resolvedDelay = !isNaN(+delay) ? +delay : delay;
            var eventType = mutateEntryExit(resolvedDelay, i);
            return (0, $0ba2bc18e91bd780$export$45b10814cc054894)(resolvedTransition).map(function(transition) {
                return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, transition), {
                    event: eventType,
                    delay: resolvedDelay
                });
            });
        }));
        return delayedTransitions.map(function(delayedTransition) {
            var delay = delayedTransition.delay;
            return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, _this.formatTransition(delayedTransition)), {
                delay: delay
            });
        });
    };
    /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */ StateNode.prototype.getStateNodes = function(state) {
        var _a;
        var _this = this;
        if (!state) return [];
        var stateValue = state instanceof (0, $db5fc64655327378$export$7254cc27399e90bd) ? state.value : (0, $0ba2bc18e91bd780$export$fb3aecd1d93744e3)(state, this.delimiter);
        if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(stateValue)) {
            var initialStateValue = this.getStateNode(stateValue).initial;
            return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [
                this,
                this.states[stateValue]
            ];
        }
        var subStateKeys = Object.keys(stateValue);
        var subStateNodes = [
            this
        ];
        subStateNodes.push.apply(subStateNodes, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)((0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(subStateKeys.map(function(subStateKey) {
            return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
        }))), false));
        return subStateNodes;
    };
    /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */ StateNode.prototype.handles = function(event) {
        var eventType = (0, $0ba2bc18e91bd780$export$7193fc8c8cd445e9)(event);
        return this.events.includes(eventType);
    };
    /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */ StateNode.prototype.resolveState = function(state) {
        var stateFromConfig = state instanceof (0, $db5fc64655327378$export$7254cc27399e90bd) ? state : (0, $db5fc64655327378$export$7254cc27399e90bd).create(state);
        var configuration = Array.from((0, $83ffdf18b0958611$export$3de01744a82b21a4)([], this.getStateNodes(stateFromConfig.value)));
        return new (0, $db5fc64655327378$export$7254cc27399e90bd)((0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, stateFromConfig), {
            value: this.resolve(stateFromConfig.value),
            configuration: configuration,
            done: (0, $83ffdf18b0958611$export$cf3d5dae927fcf63)(configuration, this),
            tags: (0, $83ffdf18b0958611$export$5301196121335ca0)(configuration),
            machine: this.machine
        }));
    };
    StateNode.prototype.transitionLeafNode = function(stateValue, state, _event) {
        var stateNode = this.getStateNode(stateValue);
        var next = stateNode.next(state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionCompoundNode = function(stateValue, state, _event) {
        var subStateKeys = Object.keys(stateValue);
        var stateNode = this.getStateNode(subStateKeys[0]);
        var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionParallelNode = function(stateValue, state, _event) {
        var e_2, _a;
        var transitionMap = {};
        try {
            for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()){
                var subStateKey = _c.value;
                var subStateValue = stateValue[subStateKey];
                if (!subStateValue) continue;
                var subStateNode = this.getStateNode(subStateKey);
                var next = subStateNode._transition(subStateValue, state, _event);
                if (next) transitionMap[subStateKey] = next;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var stateTransitions = Object.keys(transitionMap).map(function(key) {
            return transitionMap[key];
        });
        var enabledTransitions = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(stateTransitions.map(function(st) {
            return st.transitions;
        }));
        var willTransition = stateTransitions.some(function(st) {
            return st.transitions.length > 0;
        });
        if (!willTransition) return this.next(state, _event);
        var configuration = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
            return transitionMap[key].configuration;
        }));
        return {
            transitions: enabledTransitions,
            exitSet: (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(stateTransitions.map(function(t) {
                return t.exitSet;
            })),
            configuration: configuration,
            source: state,
            actions: (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
                return transitionMap[key].actions;
            }))
        };
    };
    StateNode.prototype._transition = function(stateValue, state, _event) {
        // leaf node
        if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(stateValue)) return this.transitionLeafNode(stateValue, state, _event);
         // hierarchical node
        if (Object.keys(stateValue).length === 1) return this.transitionCompoundNode(stateValue, state, _event);
         // orthogonal node
        return this.transitionParallelNode(stateValue, state, _event);
    };
    StateNode.prototype.getTransitionData = function(state, event) {
        return this._transition(state.value, state, (0, $0ba2bc18e91bd780$export$eaf22249b410f633)(event));
    };
    StateNode.prototype.next = function(state, _event) {
        var e_3, _a;
        var _this = this;
        var eventName = _event.name;
        var actions = [];
        var nextStateNodes = [];
        var selectedTransition;
        try {
            for(var _b = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()){
                var candidate = _c.value;
                var cond = candidate.cond, stateIn = candidate.in;
                var resolvedContext = state.context;
                var isInState = stateIn ? (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(stateIn) && $7c7ca11796d1b64f$var$isStateId(stateIn) ? state.matches((0, $0ba2bc18e91bd780$export$fb3aecd1d93744e3)(this.getStateNodeById(stateIn).path, this.delimiter)) : (0, $0ba2bc18e91bd780$export$2870710bf0eac88e)((0, $0ba2bc18e91bd780$export$fb3aecd1d93744e3)(stateIn, this.delimiter), (0, $0ba2bc18e91bd780$export$bb654e07daaf8c3a)(this.path.slice(0, -2))(state.value)) : true;
                var guardPassed = false;
                try {
                    guardPassed = !cond || (0, $0ba2bc18e91bd780$export$91646ab912d254e8)(this.machine, cond, resolvedContext, _event, state);
                } catch (err) {
                    throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
                }
                if (guardPassed && isInState) {
                    if (candidate.target !== undefined) nextStateNodes = candidate.target;
                    actions.push.apply(actions, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(candidate.actions), false));
                    selectedTransition = candidate;
                    break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!selectedTransition) return undefined;
        if (!nextStateNodes.length) return {
            transitions: [
                selectedTransition
            ],
            exitSet: [],
            configuration: state.value ? [
                this
            ] : [],
            source: state,
            actions: actions
        };
        var allNextStateNodes = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(nextStateNodes.map(function(stateNode) {
            return _this.getRelativeStateNodes(stateNode, state.historyValue);
        }));
        var isInternal = !!selectedTransition.internal;
        return {
            transitions: [
                selectedTransition
            ],
            exitSet: isInternal ? [] : (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(nextStateNodes.map(function(targetNode) {
                return _this.getPotentiallyReenteringNodes(targetNode);
            })),
            configuration: allNextStateNodes,
            source: state,
            actions: actions
        };
    }; // even though the name of this function mentions reentry nodes
    // we are pushing its result into `exitSet`
    // that's because what we exit might be reentered (it's an invariant of reentrancy)
    StateNode.prototype.getPotentiallyReenteringNodes = function(targetNode) {
        if (this.order < targetNode.order) return [
            this
        ];
        var nodes = [];
        var marker = this;
        var possibleAncestor = targetNode;
        while(marker && marker !== possibleAncestor){
            nodes.push(marker);
            marker = marker.parent;
        }
        if (marker !== possibleAncestor) // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
        // it's in a different part of the tree so no states will be reentered for such an external transition
        return [];
        nodes.push(possibleAncestor);
        return nodes;
    };
    StateNode.prototype.getActions = function(resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
        var e_4, _a, e_5, _b;
        var _this = this;
        var prevConfig = prevState ? (0, $83ffdf18b0958611$export$3de01744a82b21a4)([], this.getStateNodes(prevState.value)) : [];
        var entrySet = new Set();
        try {
            for(var _c = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Array.from(resolvedConfig).sort(function(a, b) {
                return a.order - b.order;
            })), _d = _c.next(); !_d.done; _d = _c.next()){
                var sn = _d.value;
                if (!(0, $83ffdf18b0958611$export$a4f4bb6b1453fff5)(prevConfig, sn) || (0, $83ffdf18b0958611$export$a4f4bb6b1453fff5)(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) entrySet.add(sn);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        try {
            for(var prevConfig_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()){
                var sn = prevConfig_1_1.value;
                if (!(0, $83ffdf18b0958611$export$a4f4bb6b1453fff5)(resolvedConfig, sn) || (0, $83ffdf18b0958611$export$a4f4bb6b1453fff5)(transition.exitSet, sn.parent)) transition.exitSet.push(sn);
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        transition.exitSet.sort(function(a, b) {
            return b.order - a.order;
        });
        var entryStates = Array.from(entrySet).sort(function(a, b) {
            return a.order - b.order;
        });
        var exitStates = new Set(transition.exitSet);
        var doneEvents = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(entryStates.map(function(sn) {
            var events = [];
            if (sn.type !== "final") return events;
            var parent = sn.parent;
            if (!parent.parent) return events;
            events.push((0, $ab1fe168d053d080$export$3df11c9c20e7b288)(sn.id, sn.doneData), (0, $ab1fe168d053d080$export$3df11c9c20e7b288)(parent.id, sn.doneData ? (0, $0ba2bc18e91bd780$export$e756e60189cc2351)(sn.doneData, currentContext, _event) : undefined));
            var grandparent = parent.parent;
            if (grandparent.type === "parallel") {
                if ((0, $83ffdf18b0958611$export$f8cf48ee793b41be)(grandparent).every(function(parentNode) {
                    return (0, $83ffdf18b0958611$export$cf3d5dae927fcf63)(transition.configuration, parentNode);
                })) events.push((0, $ab1fe168d053d080$export$3df11c9c20e7b288)(grandparent.id));
            }
            return events;
        }));
        var entryActions = entryStates.map(function(stateNode) {
            var entryActions = stateNode.onEntry;
            var invokeActions = stateNode.activities.map(function(activity) {
                return (0, $ab1fe168d053d080$export$b3571188c770cc5a)(activity);
            });
            return {
                type: "entry",
                actions: (0, $ab1fe168d053d080$export$aa68691f32e6c459)(predictableExec ? (0, $d9c803f633d21408$export$1216008129fb82ed)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(entryActions), false), (0, $d9c803f633d21408$export$8d051b38c9118094)(invokeActions), false) : (0, $d9c803f633d21408$export$1216008129fb82ed)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(invokeActions), false), (0, $d9c803f633d21408$export$8d051b38c9118094)(entryActions), false), _this.machine.options.actions)
            };
        }).concat({
            type: "state_done",
            actions: doneEvents.map(function(event) {
                return (0, $ab1fe168d053d080$export$66313c302b2ea154)(event);
            })
        });
        var exitActions = Array.from(exitStates).map(function(stateNode) {
            return {
                type: "exit",
                actions: (0, $ab1fe168d053d080$export$aa68691f32e6c459)((0, $d9c803f633d21408$export$1216008129fb82ed)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(stateNode.onExit), false), (0, $d9c803f633d21408$export$8d051b38c9118094)(stateNode.activities.map(function(activity) {
                    return (0, $ab1fe168d053d080$export$fa6813432f753b0d)(activity);
                })), false), _this.machine.options.actions)
            };
        });
        var actions = exitActions.concat({
            type: "transition",
            actions: (0, $ab1fe168d053d080$export$aa68691f32e6c459)(transition.actions, this.machine.options.actions)
        }).concat(entryActions);
        if (isDone) {
            var stopActions = (0, $ab1fe168d053d080$export$aa68691f32e6c459)((0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(resolvedConfig), false).sort(function(a, b) {
                return b.order - a.order;
            }).map(function(stateNode) {
                return stateNode.onExit;
            })), this.machine.options.actions).filter(function(action) {
                return !(0, $0ba2bc18e91bd780$export$37dc2eda56cb25a5)(action);
            });
            return actions.concat({
                type: "stop",
                actions: stopActions
            });
        }
        return actions;
    };
    /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */ StateNode.prototype.transition = function(state, event, context, exec) {
        if (state === void 0) state = this.initialState;
        var _event = (0, $0ba2bc18e91bd780$export$eaf22249b410f633)(event);
        var currentState;
        if (state instanceof (0, $db5fc64655327378$export$7254cc27399e90bd)) currentState = context === undefined ? state : this.resolveState((0, $db5fc64655327378$export$7254cc27399e90bd).from(state, context));
        else {
            var resolvedStateValue = (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(state) ? this.resolve((0, $0ba2bc18e91bd780$export$f2ee84fc53c45e74)(this.getResolvedPath(state))) : this.resolve(state);
            var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
            currentState = this.resolveState((0, $db5fc64655327378$export$7254cc27399e90bd).from(resolvedStateValue, resolvedContext));
        }
        if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571) && _event.name === $7c7ca11796d1b64f$var$WILDCARD) throw new Error("An event cannot have the wildcard type ('".concat($7c7ca11796d1b64f$var$WILDCARD, "')"));
        if (this.strict) {
            if (!this.events.includes(_event.name) && !(0, $0ba2bc18e91bd780$export$479b1b8942fd0b8d)(_event.name)) throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
        }
        var stateTransition = this._transition(currentState.value, currentState, _event) || {
            transitions: [],
            configuration: [],
            exitSet: [],
            source: currentState,
            actions: []
        };
        var prevConfig = (0, $83ffdf18b0958611$export$3de01744a82b21a4)([], this.getStateNodes(currentState.value));
        var resolvedConfig = stateTransition.configuration.length ? (0, $83ffdf18b0958611$export$3de01744a82b21a4)(prevConfig, stateTransition.configuration) : prevConfig;
        stateTransition.configuration = (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(resolvedConfig), false);
        return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
    };
    StateNode.prototype.resolveRaisedTransition = function(state, _event, originalEvent, predictableExec) {
        var _a;
        var currentActions = state.actions;
        state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
        // TODO: this should be the raised event! Delete in V5 (breaking)
        state._event = originalEvent;
        state.event = originalEvent.data;
        (_a = state.actions).unshift.apply(_a, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(currentActions), false));
        return state;
    };
    StateNode.prototype.resolveTransition = function(stateTransition, currentState, context, predictableExec, _event) {
        var e_6, _a, e_7, _b;
        var _this = this;
        if (_event === void 0) _event = (0, $ab1fe168d053d080$export$163c566c60ed2ec9);
        var configuration = stateTransition.configuration; // Transition will "apply" if:
        // - this is the initial state (there is no current state)
        // - OR there are transitions
        var willTransition = !currentState || stateTransition.transitions.length > 0;
        var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
        var isDone = (0, $83ffdf18b0958611$export$cf3d5dae927fcf63)(resolvedConfiguration, this);
        var resolvedStateValue = willTransition ? (0, $83ffdf18b0958611$export$bf7199a9ebcb84a9)(this.machine, configuration) : undefined;
        var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
        var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
        var activities = currentState ? (0, $d9c803f633d21408$export$18ce0697a983be9b)({}, currentState.activities) : {};
        try {
            for(var actionBlocks_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
                var block = actionBlocks_1_1.value;
                try {
                    for(var _c = (e_7 = void 0, (0, $d9c803f633d21408$export$19a8beecd37a4c45)(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()){
                        var action = _d.value;
                        if (action.type === (0, $41059b6f2e1b7a0a$export$b3571188c770cc5a)) activities[action.activity.id || action.activity.type] = action;
                        else if (action.type === (0, $41059b6f2e1b7a0a$export$fa6813432f753b0d)) activities[action.activity.id || action.activity.type] = false;
                    }
                } catch (e_7_1) {
                    e_7 = {
                        error: e_7_1
                    };
                } finally{
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                }
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var _e = (0, $d9c803f633d21408$export$8d051b38c9118094)((0, $ab1fe168d053d080$export$b8b9e7ba5b8c7b3e)(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), resolvedActions = _e[0], updatedContext = _e[1];
        var _f = (0, $d9c803f633d21408$export$8d051b38c9118094)((0, $0ba2bc18e91bd780$export$b29f828819edca8d)(resolvedActions, (0, $0ba2bc18e91bd780$export$37dc2eda56cb25a5)), 2), raisedEvents = _f[0], nonRaisedActions = _f[1];
        var invokeActions = resolvedActions.filter(function(action) {
            var _a;
            return action.type === (0, $41059b6f2e1b7a0a$export$b3571188c770cc5a) && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === (0, $41059b6f2e1b7a0a$export$468cda29b159ee5d);
        });
        var children = invokeActions.reduce(function(acc, action) {
            acc[action.activity.id] = (0, $4b4d9290e25c7ae7$export$78b4a98dcb5ac328)(action.activity, _this.machine, updatedContext, _event);
            return acc;
        }, currentState ? (0, $d9c803f633d21408$export$18ce0697a983be9b)({}, currentState.children) : {});
        var nextState = new (0, $db5fc64655327378$export$7254cc27399e90bd)({
            value: resolvedStateValue || currentState.value,
            context: updatedContext,
            _event: _event,
            // Persist _sessionid between states
            _sessionid: currentState ? currentState._sessionid : null,
            historyValue: resolvedStateValue ? historyValue ? (0, $0ba2bc18e91bd780$export$240d7cdd99ccb95a)(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
            history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
            actions: resolvedStateValue ? nonRaisedActions : [],
            activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
            events: [],
            configuration: resolvedConfiguration,
            transitions: stateTransition.transitions,
            children: children,
            done: isDone,
            tags: (0, $83ffdf18b0958611$export$5301196121335ca0)(resolvedConfiguration),
            machine: this
        });
        var didUpdateContext = context !== updatedContext;
        nextState.changed = _event.name === (0, $41059b6f2e1b7a0a$export$722fbec263ad908a) || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks
        var history = nextState.history;
        if (history) delete history.history;
         // There are transient transitions if the machine is not in a final state
        // and if some of the state nodes have transient ("always") transitions.
        var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function(stateNode) {
            return stateNode._transient;
        })); // If there are no enabled transitions, check if there are transient transitions.
        // If there are transient transitions, continue checking for more transitions
        // because an transient transition should be triggered even if there are no
        // enabled transitions.
        //
        // If we're already working on an transient transition then stop to prevent an infinite loop.
        //
        // Otherwise, if there are no enabled nor transient transitions, we are done.
        if (!willTransition && (!hasAlwaysTransitions || _event.name === $7c7ca11796d1b64f$var$NULL_EVENT)) return nextState;
        var maybeNextState = nextState;
        if (!isDone) {
            if (hasAlwaysTransitions) maybeNextState = this.resolveRaisedTransition(maybeNextState, {
                type: (0, $41059b6f2e1b7a0a$export$9477ceca5dcd796a)
            }, _event, predictableExec);
            while(raisedEvents.length){
                var raisedEvent = raisedEvents.shift();
                maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
            }
        } // Detect if state changed
        var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !(0, $db5fc64655327378$export$3a6d15eeb5fb214c)(maybeNextState.value, history.value) : undefined);
        maybeNextState.changed = changed; // Preserve original history after raised events
        maybeNextState.history = history;
        return maybeNextState;
    };
    /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */ StateNode.prototype.getStateNode = function(stateKey) {
        if ($7c7ca11796d1b64f$var$isStateId(stateKey)) return this.machine.getStateNodeById(stateKey);
        if (!this.states) throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
        var result = this.states[stateKey];
        if (!result) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return result;
    };
    /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */ StateNode.prototype.getStateNodeById = function(stateId) {
        var resolvedStateId = $7c7ca11796d1b64f$var$isStateId(stateId) ? stateId.slice($7c7ca11796d1b64f$var$STATE_IDENTIFIER.length) : stateId;
        if (resolvedStateId === this.id) return this;
        var stateNode = this.machine.idMap[resolvedStateId];
        if (!stateNode) throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
        return stateNode;
    };
    /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */ StateNode.prototype.getStateNodeByPath = function(statePath) {
        if (typeof statePath === "string" && $7c7ca11796d1b64f$var$isStateId(statePath)) try {
            return this.getStateNodeById(statePath.slice(1));
        } catch (e) {
        // throw e;
        }
        var arrayStatePath = (0, $0ba2bc18e91bd780$export$304cde62ecda7af8)(statePath, this.delimiter).slice();
        var currentStateNode = this;
        while(arrayStatePath.length){
            var key = arrayStatePath.shift();
            if (!key.length) break;
            currentStateNode = currentStateNode.getStateNode(key);
        }
        return currentStateNode;
    };
    /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */ StateNode.prototype.resolve = function(stateValue) {
        var _a;
        var _this = this;
        if (!stateValue) return this.initialStateValue || $7c7ca11796d1b64f$var$EMPTY_OBJECT; // TODO: type-specific properties
        switch(this.type){
            case "parallel":
                return (0, $0ba2bc18e91bd780$export$825e789796ab7275)(this.initialStateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : $7c7ca11796d1b64f$var$EMPTY_OBJECT;
                });
            case "compound":
                if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(stateValue)) {
                    var subStateNode = this.getStateNode(stateValue);
                    if (subStateNode.type === "parallel" || subStateNode.type === "compound") return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
                    return stateValue;
                }
                if (!Object.keys(stateValue).length) return this.initialStateValue || {};
                return (0, $0ba2bc18e91bd780$export$825e789796ab7275)(stateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : $7c7ca11796d1b64f$var$EMPTY_OBJECT;
                });
            default:
                return stateValue || $7c7ca11796d1b64f$var$EMPTY_OBJECT;
        }
    };
    StateNode.prototype.getResolvedPath = function(stateIdentifier) {
        if ($7c7ca11796d1b64f$var$isStateId(stateIdentifier)) {
            var stateNode = this.machine.idMap[stateIdentifier.slice($7c7ca11796d1b64f$var$STATE_IDENTIFIER.length)];
            if (!stateNode) throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
            return stateNode.path;
        }
        return (0, $0ba2bc18e91bd780$export$304cde62ecda7af8)(stateIdentifier, this.delimiter);
    };
    Object.defineProperty(StateNode.prototype, "initialStateValue", {
        get: function() {
            var _a;
            if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
            var initialStateValue;
            if (this.type === "parallel") initialStateValue = (0, $0ba2bc18e91bd780$export$2d4204fe9b34204e)(this.states, function(state) {
                return state.initialStateValue || $7c7ca11796d1b64f$var$EMPTY_OBJECT;
            }, function(stateNode) {
                return !(stateNode.type === "history");
            });
            else if (this.initial !== undefined) {
                if (!this.states[this.initial]) throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
                initialStateValue = (0, $83ffdf18b0958611$export$335db82b86111fd1)(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
            } else // The finite state value of a machine without child states is just an empty object
            initialStateValue = {};
            this.__cache.initialStateValue = initialStateValue;
            return this.__cache.initialStateValue;
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getInitialState = function(stateValue, context) {
        this._init(); // TODO: this should be in the constructor (see note in constructor)
        var configuration = this.getStateNodes(stateValue);
        return this.resolveTransition({
            configuration: configuration,
            exitSet: [],
            transitions: [],
            source: undefined,
            actions: []
        }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
    };
    Object.defineProperty(StateNode.prototype, "initialState", {
        /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */ get: function() {
            var initialStateValue = this.initialStateValue;
            if (!initialStateValue) throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
            return this.getInitialState(initialStateValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "target", {
        /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */ get: function() {
            var target;
            if (this.type === "history") {
                var historyConfig = this.config;
                if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(historyConfig.target)) target = $7c7ca11796d1b64f$var$isStateId(historyConfig.target) ? (0, $0ba2bc18e91bd780$export$f2ee84fc53c45e74)(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
                else target = historyConfig.target;
            }
            return target;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */ StateNode.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
        if (resolve === void 0) resolve = true;
        return resolve ? relativeStateId.type === "history" ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [
            relativeStateId
        ];
    };
    Object.defineProperty(StateNode.prototype, "initialStateNodes", {
        get: function() {
            var _this = this;
            if ((0, $83ffdf18b0958611$export$335db82b86111fd1)(this)) return [
                this
            ];
             // Case when state node is compound but no initial state is defined
            if (this.type === "compound" && !this.initial) {
                if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "Compound state node '".concat(this.id, "' has no initial state."));
                return [
                    this
                ];
            }
            var initialStateNodePaths = (0, $0ba2bc18e91bd780$export$a2618e9e89698dd6)(this.initialStateValue);
            return (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(initialStateNodePaths.map(function(initialPath) {
                return _this.getFromRelativePath(initialPath);
            }));
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */ StateNode.prototype.getFromRelativePath = function(relativePath) {
        if (!relativePath.length) return [
            this
        ];
        var _a = (0, $d9c803f633d21408$export$8d051b38c9118094)(relativePath), stateKey = _a[0], childStatePath = _a.slice(1);
        if (!this.states) throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
        var childStateNode = this.getStateNode(stateKey);
        if (childStateNode.type === "history") return childStateNode.resolveHistory();
        if (!this.states[stateKey]) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return this.states[stateKey].getFromRelativePath(childStatePath);
    };
    StateNode.prototype.historyValue = function(relativeStateValue) {
        if (!Object.keys(this.states).length) return undefined;
        return {
            current: relativeStateValue || this.initialStateValue,
            states: (0, $0ba2bc18e91bd780$export$2d4204fe9b34204e)(this.states, function(stateNode, key) {
                if (!relativeStateValue) return stateNode.historyValue();
                var subStateValue = (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(relativeStateValue) ? undefined : relativeStateValue[key];
                return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
            }, function(stateNode) {
                return !stateNode.history;
            })
        };
    };
    /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */ StateNode.prototype.resolveHistory = function(historyValue) {
        var _this = this;
        if (this.type !== "history") return [
            this
        ];
        var parent = this.parent;
        if (!historyValue) {
            var historyTarget = this.target;
            return historyTarget ? (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)((0, $0ba2bc18e91bd780$export$a2618e9e89698dd6)(historyTarget).map(function(relativeChildPath) {
                return parent.getFromRelativePath(relativeChildPath);
            })) : parent.initialStateNodes;
        }
        var subHistoryValue = (0, $0ba2bc18e91bd780$export$314d0a1a7c835392)(parent.path, "states")(historyValue).current;
        if ((0, $0ba2bc18e91bd780$export$844ec244b1367d54)(subHistoryValue)) return [
            parent.getStateNode(subHistoryValue)
        ];
        return (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)((0, $0ba2bc18e91bd780$export$a2618e9e89698dd6)(subHistoryValue).map(function(subStatePath) {
            return _this.history === "deep" ? parent.getFromRelativePath(subStatePath) : [
                parent.states[subStatePath[0]]
            ];
        }));
    };
    Object.defineProperty(StateNode.prototype, "stateIds", {
        /**
     * All the state node IDs of this state node and its descendant state nodes.
     */ get: function() {
            var _this = this;
            var childStateIds = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(Object.keys(this.states).map(function(stateKey) {
                return _this.states[stateKey].stateIds;
            }));
            return [
                this.id
            ].concat(childStateIds);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "events", {
        /**
     * All the event types accepted by this state node and its descendants.
     */ get: function() {
            var e_8, _a, e_9, _b;
            if (this.__cache.events) return this.__cache.events;
            var states = this.states;
            var events = new Set(this.ownEvents);
            if (states) try {
                for(var _c = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var stateId = _d.value;
                    var state = states[stateId];
                    if (state.states) try {
                        for(var _e = (e_9 = void 0, (0, $d9c803f633d21408$export$19a8beecd37a4c45)(state.events)), _f = _e.next(); !_f.done; _f = _e.next()){
                            var event_1 = _f.value;
                            events.add("".concat(event_1));
                        }
                    } catch (e_9_1) {
                        e_9 = {
                            error: e_9_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                    }
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            return this.__cache.events = Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "ownEvents", {
        /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */ get: function() {
            var events = new Set(this.transitions.filter(function(transition) {
                return !(!transition.target && !transition.actions.length && transition.internal);
            }).map(function(transition) {
                return transition.eventType;
            }));
            return Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.resolveTarget = function(_target) {
        var _this = this;
        if (_target === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
        return undefined;
        return _target.map(function(target) {
            if (!(0, $0ba2bc18e91bd780$export$844ec244b1367d54)(target)) return target;
            var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
            // do not include machine key on target
            if (isInternalTarget && !_this.parent) return _this.getStateNodeByPath(target.slice(1));
            var resolvedTarget = isInternalTarget ? _this.key + target : target;
            if (_this.parent) try {
                var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
                return targetStateNode;
            } catch (err) {
                throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
            }
            else return _this.getStateNodeByPath(resolvedTarget);
        });
    };
    StateNode.prototype.formatTransition = function(transitionConfig) {
        var _this = this;
        var normalizedTarget = (0, $0ba2bc18e91bd780$export$2a4fe5c3c80e3288)(transitionConfig.target);
        var internal = "internal" in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
            return (0, $0ba2bc18e91bd780$export$844ec244b1367d54)(_target) && _target[0] === _this.delimiter;
        }) : true;
        var guards = this.machine.options.guards;
        var target = this.resolveTarget(normalizedTarget);
        var transition = (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, transitionConfig), {
            actions: (0, $ab1fe168d053d080$export$aa68691f32e6c459)((0, $0ba2bc18e91bd780$export$45b10814cc054894)(transitionConfig.actions)),
            cond: (0, $0ba2bc18e91bd780$export$b0f5a08e0ca47933)(transitionConfig.cond, guards),
            target: target,
            source: this,
            internal: internal,
            eventType: transitionConfig.event,
            toJSON: function() {
                return (0, $d9c803f633d21408$export$18ce0697a983be9b)((0, $d9c803f633d21408$export$18ce0697a983be9b)({}, transition), {
                    target: transition.target ? transition.target.map(function(t) {
                        return "#".concat(t.id);
                    }) : undefined,
                    source: "#".concat(_this.id)
                });
            }
        });
        return transition;
    };
    StateNode.prototype.formatTransitions = function() {
        var e_10, _a;
        var _this = this;
        var onConfig;
        if (!this.config.on) onConfig = [];
        else if (Array.isArray(this.config.on)) onConfig = this.config.on;
        else {
            var _b = this.config.on, _c = $7c7ca11796d1b64f$var$WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = (0, $d9c803f633d21408$export$3c9a16f847548506)(_b, [
                typeof _c === "symbol" ? _c : _c + ""
            ]);
            onConfig = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(Object.keys(strictTransitionConfigs_1).map(function(key) {
                if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571) && key === $7c7ca11796d1b64f$var$NULL_EVENT) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(_this.id, '".'));
                var transitionConfigArray = (0, $0ba2bc18e91bd780$export$3822a36ea084a4d5)(key, strictTransitionConfigs_1[key]);
                if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) $7c7ca11796d1b64f$var$validateArrayifiedTransitions(_this, key, transitionConfigArray);
                return transitionConfigArray;
            }).concat((0, $0ba2bc18e91bd780$export$3822a36ea084a4d5)($7c7ca11796d1b64f$var$WILDCARD, wildcardConfigs)));
        }
        var eventlessConfig = this.config.always ? (0, $0ba2bc18e91bd780$export$3822a36ea084a4d5)("", this.config.always) : [];
        var doneConfig = this.config.onDone ? (0, $0ba2bc18e91bd780$export$3822a36ea084a4d5)(String((0, $ab1fe168d053d080$export$3df11c9c20e7b288)(this.id)), this.config.onDone) : [];
        if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571)) (0, $0ba2bc18e91bd780$export$c106dd0671a0fc2d)(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
        var invokeConfig = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)(this.invoke.map(function(invokeDef) {
            var settleTransitions = [];
            if (invokeDef.onDone) settleTransitions.push.apply(settleTransitions, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)((0, $0ba2bc18e91bd780$export$3822a36ea084a4d5)(String((0, $ab1fe168d053d080$export$c105e588793f70b4)(invokeDef.id)), invokeDef.onDone)), false));
            if (invokeDef.onError) settleTransitions.push.apply(settleTransitions, (0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)((0, $0ba2bc18e91bd780$export$3822a36ea084a4d5)(String((0, $ab1fe168d053d080$export$a3bc9b8ed74fc)(invokeDef.id)), invokeDef.onError)), false));
            return settleTransitions;
        }));
        var delayedTransitions = this.after;
        var formattedTransitions = (0, $0ba2bc18e91bd780$export$bffa455ba8c619a6)((0, $d9c803f633d21408$export$1216008129fb82ed)((0, $d9c803f633d21408$export$1216008129fb82ed)((0, $d9c803f633d21408$export$1216008129fb82ed)((0, $d9c803f633d21408$export$1216008129fb82ed)([], (0, $d9c803f633d21408$export$8d051b38c9118094)(doneConfig), false), (0, $d9c803f633d21408$export$8d051b38c9118094)(invokeConfig), false), (0, $d9c803f633d21408$export$8d051b38c9118094)(onConfig), false), (0, $d9c803f633d21408$export$8d051b38c9118094)(eventlessConfig), false).map(function(transitionConfig) {
            return (0, $0ba2bc18e91bd780$export$45b10814cc054894)(transitionConfig).map(function(transition) {
                return _this.formatTransition(transition);
            });
        }));
        try {
            for(var delayedTransitions_1 = (0, $d9c803f633d21408$export$19a8beecd37a4c45)(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()){
                var delayedTransition = delayedTransitions_1_1.value;
                formattedTransitions.push(delayedTransition);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
            } finally{
                if (e_10) throw e_10.error;
            }
        }
        return formattedTransitions;
    };
    return StateNode;
}();



var $c9f97204c6723ccf$var$warned = false;
function $c9f97204c6723ccf$export$f391db14ff2d9279(config, options, initialContext) {
    if (initialContext === void 0) initialContext = config.context;
    return new (0, $7c7ca11796d1b64f$export$342f24f5edd47b1)(config, options, initialContext);
}
function $c9f97204c6723ccf$export$aaa7fa18f8e9b2e8(config, options) {
    if (!(0, $bb41c361a1818c2b$export$9b5f2e1c20ef6571) && !("predictableActionArguments" in config) && !$c9f97204c6723ccf$var$warned) {
        $c9f97204c6723ccf$var$warned = true;
        console.warn("It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html");
    }
    return new (0, $7c7ca11796d1b64f$export$342f24f5edd47b1)(config, options);
}










var $9cec7b12efdda519$export$e6e34fd1f2686227 = (0, $ab1fe168d053d080$export$e6e34fd1f2686227), $9cec7b12efdda519$export$70b61ad426ddbe54 = (0, $ab1fe168d053d080$export$70b61ad426ddbe54), $9cec7b12efdda519$export$89db4734f6c919c4 = (0, $ab1fe168d053d080$export$89db4734f6c919c4), $9cec7b12efdda519$export$daa976aaff721e41 = (0, $ab1fe168d053d080$export$daa976aaff721e41), $9cec7b12efdda519$export$408d8d51fa351f53 = (0, $ab1fe168d053d080$export$408d8d51fa351f53), $9cec7b12efdda519$export$7f8b724299523eb6 = (0, $ab1fe168d053d080$export$7f8b724299523eb6), $9cec7b12efdda519$export$eb147b7589db8e8a = (0, $ab1fe168d053d080$export$eb147b7589db8e8a), $9cec7b12efdda519$export$c105e588793f70b4 = (0, $ab1fe168d053d080$export$c105e588793f70b4), $9cec7b12efdda519$export$66313c302b2ea154 = (0, $ab1fe168d053d080$export$66313c302b2ea154), $9cec7b12efdda519$export$bef1f36f5486a6a3 = (0, $ab1fe168d053d080$export$bef1f36f5486a6a3), $9cec7b12efdda519$export$48ec4a2b1cfc6557 = (0, $ab1fe168d053d080$export$48ec4a2b1cfc6557), $9cec7b12efdda519$export$7877a478dd30fd3d = (0, $ab1fe168d053d080$export$7877a478dd30fd3d), $9cec7b12efdda519$export$fa6813432f753b0d = (0, $ab1fe168d053d080$export$fa6813432f753b0d);











const { assign: $28623b45b974975c$var$o, stop: $28623b45b974975c$var$s } = (0, $ab1fe168d053d080$exports), $28623b45b974975c$export$b6947cfc708251b6 = (e)=>$28623b45b974975c$var$s(e), $28623b45b974975c$export$9faa50368a7b3c89 = $28623b45b974975c$var$o({
    attributeToVerify: (e)=>{}
}), $28623b45b974975c$export$aa3d1e2603b6b393 = $28623b45b974975c$var$o({
    challengeName: (e)=>{}
}), $28623b45b974975c$export$f59683a2f5c65c18 = $28623b45b974975c$var$o({
    requiredAttributes: (e)=>{}
}), $28623b45b974975c$export$a15ba4bdf59dacc9 = $28623b45b974975c$var$o({
    remoteError: (e)=>""
}), $28623b45b974975c$export$bfa16614c507dc4b = $28623b45b974975c$var$o({
    formValues: (e)=>({})
}), $28623b45b974975c$export$c459b227ec8b5bb = $28623b45b974975c$var$o({
    touched: (e)=>({})
}), $28623b45b974975c$export$58692221bc9d7254 = $28623b45b974975c$var$o({
    unverifiedContactMethods: (e)=>{}
}), $28623b45b974975c$export$1d20f61d217c468f = $28623b45b974975c$var$o({
    username: (e)=>{}
}), $28623b45b974975c$export$5270f204082eebfb = $28623b45b974975c$var$o({
    validationError: (e)=>({})
}), $28623b45b974975c$export$623e894a03312e76 = $28623b45b974975c$var$o({
    totpSecretCode: (e, r)=>r.data
}), $28623b45b974975c$export$11d8ed3bd13bb8e3 = $28623b45b974975c$var$o({
    challengeName: (e, r)=>{
        var t;
        return null === (t = r.data) || void 0 === t ? void 0 : t.challengeName;
    }
}), $28623b45b974975c$export$f18efc7fc22567f3 = $28623b45b974975c$var$o({
    requiredAttributes: (e, r)=>{
        var t, a;
        return null === (a = null === (t = r.data) || void 0 === t ? void 0 : t.challengeParam) || void 0 === a ? void 0 : a.requiredAttributes;
    }
}), $28623b45b974975c$export$e574184fef92c521 = $28623b45b974975c$var$o({
    redirectIntent: (e)=>"confirmPasswordReset"
}), $28623b45b974975c$export$95541f1a5e3a994 = $28623b45b974975c$var$o({
    redirectIntent: (e)=>"confirmSignUp"
}), $28623b45b974975c$export$3a6cdb4d139acb5f = $28623b45b974975c$var$o({
    authAttributes: (e, r)=>{
        var t, a;
        const [o] = e.loginMechanisms;
        return {
            username: null !== (t = e.formValues[o]) && void 0 !== t ? t : e.formValues.username,
            password: null === (a = e.formValues) || void 0 === a ? void 0 : a.password
        };
    }
}), $28623b45b974975c$export$6c79f1f160aff8ba = $28623b45b974975c$var$o({
    validationError: (e, r)=>r.data
}), $28623b45b974975c$export$a6a2df750d905c59 = $28623b45b974975c$var$o({
    remoteError: (e, r)=>{
        var t;
        return "NoUserPoolError" === r.data.name ? "Configuration error (see console) – please contact the administrator" : (null === (t = r.data) || void 0 === t ? void 0 : t.message) || r.data;
    }
}), $28623b45b974975c$export$a15839655cde632a = $28623b45b974975c$var$o({
    unverifiedContactMethods: (e, r)=>r.data.unverified
}), $28623b45b974975c$export$8b6bb3dd62a01be2 = $28623b45b974975c$var$o({
    user: (e, r)=>r.data.user || r.data
}), $28623b45b974975c$export$6ae5cbbde4bec733 = $28623b45b974975c$var$o({
    username: (e, r)=>{
        let { formValues: { username: t, country_code: a } } = e;
        return a && (t = `${a}${t}`), t;
    }
}), $28623b45b974975c$export$f9df8f75fe67ab58 = $28623b45b974975c$var$o({
    codeDeliveryDetails: (e, r)=>r.data.codeDeliveryDetails
}), $28623b45b974975c$export$12b5e0d209e80876 = $28623b45b974975c$var$o({
    authAttributes: (e, r)=>({
            username: e.formValues.username
        })
}), $28623b45b974975c$export$412508d679148d5c = $28623b45b974975c$var$o({
    formValues: (e, r)=>{
        const { name: t, value: a } = r.data;
        return Object.assign(Object.assign({}, e.formValues), {
            [t]: a
        });
    }
}), $28623b45b974975c$export$89c2621768820c8b = $28623b45b974975c$var$o({
    formValues: (e, r)=>{
        const t = Object.assign(Object.assign({}, e.formValues), r.data);
        return (0, $9ad1914df4b6fe69$export$205c000fb676adf6)(t, "password");
    }
}), $28623b45b974975c$export$27d5d91e7417534c = $28623b45b974975c$var$o({
    touched: (e, r)=>{
        const { name: t } = r.data;
        return Object.assign(Object.assign({}, e.touched), {
            [`${t}`]: !0
        });
    }
}), $28623b45b974975c$export$90e3d721ed7e24a8 = (t)=>(0, $2a754a1c7faca113$export$1050f835b63b671e)(void 0, void 0, void 0, function*() {
        const { username: e } = t;
        return yield (0, $cc420cb14b670b2a$export$334c29725a78c21d).forgotPassword(e);
    }), $28623b45b974975c$export$da44e4eaa54bc82e = $28623b45b974975c$var$o({
    formValues: (e, r)=>{
        var t;
        const [a = "username"] = e.loginMechanisms;
        if (!e.formValues.phone_number && "phone_number" !== a) return e.formValues;
        const { formValues: o, country_code: s } = e, n = o.phone_number ? "phone_number" : "username", i = `${null !== (t = o.country_code) && void 0 !== t ? t : s}${o[n]}`.replace(/[^A-Z0-9+]/gi, ""), u = Object.assign(Object.assign({}, o), {
            [n]: i
        });
        return delete u.country_code, u;
    }
});




var $d299ac421c05c135$exports = {};
var $fd2d90f592c63519$exports = {};
var $38afcbfab85a0553$exports = {};
var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


var $03e9beb856e9b4cd$exports = {};

var $6b5a5095e0934938$exports = {};
var $a7f8a2555793d7d3$exports = {};
var $3ba72ebe7e4419b5$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = "[object Null]", $a7f8a2555793d7d3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == "symbol" || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($0488fde9aa355453$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $6b5a5095e0934938$exports(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03e9beb856e9b4cd$exports = $03e9beb856e9b4cd$var$isKey;


var $f9135a667399ede4$exports = {};
var $6aae515404bf5dd2$exports = {};
var $17f5c88c594eac51$exports = {};
var $4902f64a16640324$exports = {};
var $df2cd4bc93f21548$exports = {};
var $8d50e526a9e9b7fa$exports = {};
var $80f20c637ba11563$exports = {};
var $e95343b7bf5d617b$exports = {};
var $5037fd2e597c2a03$exports = {};
var $8360225fb63098b3$exports = {};
var $004783abbde551e4$exports = {};

var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = "[object AsyncFunction]", $004783abbde551e4$var$funcTag = "[object Function]", $004783abbde551e4$var$genTag = "[object GeneratorFunction]", $004783abbde551e4$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$f9ff2e983beb6b86$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a7f8a2555793d7d3$exports(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
$004783abbde551e4$exports = $004783abbde551e4$var$isFunction;


var $5e8d211f630cd46d$exports = {};
var $baf78e1246b3b18f$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
$baf78e1246b3b18f$exports = $baf78e1246b3b18f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($baf78e1246b3b18f$exports && $baf78e1246b3b18f$exports.keys && $baf78e1246b3b18f$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
$5e8d211f630cd46d$exports = $5e8d211f630cd46d$var$isMasked;



var $9c6b3ec69362487e$exports = {};
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$9c6b3ec69362487e$exports = $9c6b3ec69362487e$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp("^" + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$f9ff2e983beb6b86$exports(value) || $5e8d211f630cd46d$exports(value)) return false;
    var pattern = $004783abbde551e4$exports(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($9c6b3ec69362487e$exports(value));
}
$8360225fb63098b3$exports = $8360225fb63098b3$var$baseIsNative;


var $d50b255f8680c47a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d50b255f8680c47a$exports = $d50b255f8680c47a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $d50b255f8680c47a$exports(object, key);
    return $8360225fb63098b3$exports(value) ? value : undefined;
}
$5037fd2e597c2a03$exports = $5037fd2e597c2a03$var$getNative;


/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $5037fd2e597c2a03$exports(Object, "create");
$e95343b7bf5d617b$exports = $e95343b7bf5d617b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $e95343b7bf5d617b$exports ? $e95343b7bf5d617b$exports(null) : {};
    this.size = 0;
}
$80f20c637ba11563$exports = $80f20c637ba11563$var$hashClear;


var $60a2188452e03a76$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$60a2188452e03a76$exports = $60a2188452e03a76$var$hashDelete;


var $0ade0ffa62051a98$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($e95343b7bf5d617b$exports) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$0ade0ffa62051a98$exports = $0ade0ffa62051a98$var$hashGet;


var $0d7f9677a17b6bef$exports = {};

/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $e95343b7bf5d617b$exports ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
$0d7f9677a17b6bef$exports = $0d7f9677a17b6bef$var$hashHas;


var $d33db65186b62952$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e95343b7bf5d617b$exports && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
$d33db65186b62952$exports = $d33db65186b62952$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $80f20c637ba11563$exports;
$8d50e526a9e9b7fa$var$Hash.prototype["delete"] = $60a2188452e03a76$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $0ade0ffa62051a98$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $0d7f9677a17b6bef$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $d33db65186b62952$exports;
$8d50e526a9e9b7fa$exports = $8d50e526a9e9b7fa$var$Hash;


var $dd14efc87ba1cd5b$exports = {};
var $83df40714bf7006e$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$83df40714bf7006e$exports = $83df40714bf7006e$var$listCacheClear;


var $d22fe27824ff9351$exports = {};
var $87257b05f5d9ad81$exports = {};
var $50557587dab070a0$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$50557587dab070a0$exports = $50557587dab070a0$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($50557587dab070a0$exports(array[length][0], key)) return length;
    }
    return -1;
}
$87257b05f5d9ad81$exports = $87257b05f5d9ad81$var$assocIndexOf;


/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$d22fe27824ff9351$exports = $d22fe27824ff9351$var$listCacheDelete;


var $b2e6263d81cdc1b3$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$b2e6263d81cdc1b3$exports = $b2e6263d81cdc1b3$var$listCacheGet;


var $29e2bc7b7348833e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $87257b05f5d9ad81$exports(this.__data__, key) > -1;
}
$29e2bc7b7348833e$exports = $29e2bc7b7348833e$var$listCacheHas;


var $ff9311500b60ab72$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$ff9311500b60ab72$exports = $ff9311500b60ab72$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $83df40714bf7006e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype["delete"] = $d22fe27824ff9351$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $b2e6263d81cdc1b3$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $29e2bc7b7348833e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $ff9311500b60ab72$exports;
$dd14efc87ba1cd5b$exports = $dd14efc87ba1cd5b$var$ListCache;


var $19b02faa57603249$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $5037fd2e597c2a03$exports($23YZo, "Map");
$19b02faa57603249$exports = $19b02faa57603249$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $8d50e526a9e9b7fa$exports,
        "map": new ($19b02faa57603249$exports || $dd14efc87ba1cd5b$exports),
        "string": new $8d50e526a9e9b7fa$exports
    };
}
$df2cd4bc93f21548$exports = $df2cd4bc93f21548$var$mapCacheClear;


var $44464964ade29765$exports = {};
var $c0b23e5f03c2595b$exports = {};
var $09c4668903e66c1d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$09c4668903e66c1d$exports = $09c4668903e66c1d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $09c4668903e66c1d$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$c0b23e5f03c2595b$exports = $c0b23e5f03c2595b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $c0b23e5f03c2595b$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$44464964ade29765$exports = $44464964ade29765$var$mapCacheDelete;


var $ba80406da5503086$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $c0b23e5f03c2595b$exports(this, key).get(key);
}
$ba80406da5503086$exports = $ba80406da5503086$var$mapCacheGet;


var $d3abe18ea687dfb7$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $c0b23e5f03c2595b$exports(this, key).has(key);
}
$d3abe18ea687dfb7$exports = $d3abe18ea687dfb7$var$mapCacheHas;


var $347643e3dcfcc207$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $c0b23e5f03c2595b$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$347643e3dcfcc207$exports = $347643e3dcfcc207$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $df2cd4bc93f21548$exports;
$4902f64a16640324$var$MapCache.prototype["delete"] = $44464964ade29765$exports;
$4902f64a16640324$var$MapCache.prototype.get = $ba80406da5503086$exports;
$4902f64a16640324$var$MapCache.prototype.has = $d3abe18ea687dfb7$exports;
$4902f64a16640324$var$MapCache.prototype.set = $347643e3dcfcc207$exports;
$4902f64a16640324$exports = $4902f64a16640324$var$MapCache;


/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $4902f64a16640324$exports);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $4902f64a16640324$exports;
$17f5c88c594eac51$exports = $17f5c88c594eac51$var$memoize;


/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $17f5c88c594eac51$exports(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$6aae515404bf5dd2$exports = $6aae515404bf5dd2$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $6aae515404bf5dd2$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$f9135a667399ede4$exports = $f9135a667399ede4$var$stringToPath;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};

var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + "";
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f16f644742c27c21$var$INFINITY ? "-0" : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? "" : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($0488fde9aa355453$exports(value)) return value;
    return $03e9beb856e9b4cd$exports(value, object) ? [
        value
    ] : $f9135a667399ede4$exports($f5d9385a9cc7e413$exports(value));
}
$38afcbfab85a0553$exports = $38afcbfab85a0553$var$castPath;


var $4d60aa8c33155976$exports = {};

/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == "string" || $6b5a5095e0934938$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$4d60aa8c33155976$var$INFINITY ? "-0" : result;
}
$4d60aa8c33155976$exports = $4d60aa8c33155976$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4d60aa8c33155976$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$fd2d90f592c63519$exports = $fd2d90f592c63519$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $fd2d90f592c63519$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$d299ac421c05c135$exports = $d299ac421c05c135$var$get;




var $4524f833ae45779b$exports = {};
var $34696005ed9b3f30$exports = {};
var $bbb2d98cae25b61a$exports = {};

var $e8ee1d354807980a$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $dd14efc87ba1cd5b$exports;
    this.size = 0;
}
$e8ee1d354807980a$exports = $e8ee1d354807980a$var$stackClear;


var $b2ddb9d63293f3a5$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$b2ddb9d63293f3a5$exports = $b2ddb9d63293f3a5$var$stackDelete;


var $80d0940a423a17dc$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
$80d0940a423a17dc$exports = $80d0940a423a17dc$var$stackGet;


var $010f38d5d914cfa2$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
$010f38d5d914cfa2$exports = $010f38d5d914cfa2$var$stackHas;


var $9280d00f89f25fa9$exports = {};



/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $dd14efc87ba1cd5b$exports) {
        var pairs = data.__data__;
        if (!$19b02faa57603249$exports || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4902f64a16640324$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$9280d00f89f25fa9$exports = $9280d00f89f25fa9$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $dd14efc87ba1cd5b$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $e8ee1d354807980a$exports;
$bbb2d98cae25b61a$var$Stack.prototype["delete"] = $b2ddb9d63293f3a5$exports;
$bbb2d98cae25b61a$var$Stack.prototype.get = $80d0940a423a17dc$exports;
$bbb2d98cae25b61a$var$Stack.prototype.has = $010f38d5d914cfa2$exports;
$bbb2d98cae25b61a$var$Stack.prototype.set = $9280d00f89f25fa9$exports;
$bbb2d98cae25b61a$exports = $bbb2d98cae25b61a$var$Stack;


var $5bab87b519c266a0$exports = {};
var $96b401257ea00d24$exports = {};
var $31e24313ace94404$exports = {};

var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $5037fd2e597c2a03$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$31e24313ace94404$exports = $31e24313ace94404$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $31e24313ace94404$exports) $31e24313ace94404$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$96b401257ea00d24$exports = $96b401257ea00d24$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5bab87b519c266a0$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$50557587dab070a0$exports(object[key], value) || value === undefined && !(key in object)) $96b401257ea00d24$exports(object, key, value);
}
$5bab87b519c266a0$exports = $5bab87b519c266a0$var$assignMergeValue;


var $9f0778b809a8c692$exports = {};
var $e7bbde6376f4568a$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$e7bbde6376f4568a$exports = $e7bbde6376f4568a$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $e7bbde6376f4568a$exports();
$9f0778b809a8c692$exports = $9f0778b809a8c692$var$baseFor;


var $964a7bd734d0fbad$exports = {};


var $uQ1Em = parcelRequire("uQ1Em");
var $42cd9d64f56ec214$exports = {};
var $e0e8a62ea95bc20a$exports = {};
var $facf83d1449a27b8$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
$facf83d1449a27b8$exports = $facf83d1449a27b8$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e0e8a62ea95bc20a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $facf83d1449a27b8$exports(result).set(new $facf83d1449a27b8$exports(arrayBuffer));
    return result;
}
$e0e8a62ea95bc20a$exports = $e0e8a62ea95bc20a$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $42cd9d64f56ec214$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $e0e8a62ea95bc20a$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$42cd9d64f56ec214$exports = $42cd9d64f56ec214$var$cloneTypedArray;


var $7b3d95b0cd9dcb32$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7b3d95b0cd9dcb32$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$7b3d95b0cd9dcb32$exports = $7b3d95b0cd9dcb32$var$copyArray;


var $9f425e619197b80f$exports = {};
var $39ce05228f203f9a$exports = {};

/** Built-in value references. */ var $39ce05228f203f9a$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $39ce05228f203f9a$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$f9ff2e983beb6b86$exports(proto)) return {};
        if ($39ce05228f203f9a$var$objectCreate) return $39ce05228f203f9a$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$39ce05228f203f9a$exports = $39ce05228f203f9a$var$baseCreate;


var $8e492c1d7a7ea307$exports = {};
var $ff813e49bf3cca3d$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ff813e49bf3cca3d$exports = $ff813e49bf3cca3d$var$overArg;


/** Built-in value references. */ var $8e492c1d7a7ea307$var$getPrototype = $ff813e49bf3cca3d$exports(Object.getPrototypeOf, Object);
$8e492c1d7a7ea307$exports = $8e492c1d7a7ea307$var$getPrototype;


var $292432068be14a79$exports = {};
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
$292432068be14a79$exports = $292432068be14a79$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9f425e619197b80f$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$292432068be14a79$exports(object) ? $39ce05228f203f9a$exports($8e492c1d7a7ea307$exports(object)) : {};
}
$9f425e619197b80f$exports = $9f425e619197b80f$var$initCloneObject;


var $7d0c6fd0eb26be0e$exports = {};
var $fb8f823cdc90f511$exports = {};


/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $fb8f823cdc90f511$var$argsTag;
}
$fb8f823cdc90f511$exports = $fb8f823cdc90f511$var$baseIsArguments;



/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $fb8f823cdc90f511$exports(function() {
    return arguments;
}()) ? $fb8f823cdc90f511$exports : function(value) {
    return $61269cf1f3e020be$exports(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, "callee") && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, "callee");
};
$7d0c6fd0eb26be0e$exports = $7d0c6fd0eb26be0e$var$isArguments;



var $e5599ea424e07f76$exports = {};
var $ac2c42592aa05543$exports = {};

var $15d215b19bcf1187$exports = {};
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
$15d215b19bcf1187$exports = $15d215b19bcf1187$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $15d215b19bcf1187$exports(value.length) && !$004783abbde551e4$exports(value);
}
$ac2c42592aa05543$exports = $ac2c42592aa05543$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e5599ea424e07f76$var$isArrayLikeObject(value) {
    return $61269cf1f3e020be$exports(value) && $ac2c42592aa05543$exports(value);
}
$e5599ea424e07f76$exports = $e5599ea424e07f76$var$isArrayLikeObject;



var $f504n = parcelRequire("f504n");


var $0658be17f7793a43$exports = {};



/** `Object#toString` result references. */ var $0658be17f7793a43$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $0658be17f7793a43$var$funcProto = Function.prototype, $0658be17f7793a43$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0658be17f7793a43$var$funcToString = $0658be17f7793a43$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0658be17f7793a43$var$hasOwnProperty = $0658be17f7793a43$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0658be17f7793a43$var$objectCtorString = $0658be17f7793a43$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0658be17f7793a43$var$isPlainObject(value) {
    if (!$61269cf1f3e020be$exports(value) || $a7f8a2555793d7d3$exports(value) != $0658be17f7793a43$var$objectTag) return false;
    var proto = $8e492c1d7a7ea307$exports(value);
    if (proto === null) return true;
    var Ctor = $0658be17f7793a43$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $0658be17f7793a43$var$funcToString.call(Ctor) == $0658be17f7793a43$var$objectCtorString;
}
$0658be17f7793a43$exports = $0658be17f7793a43$var$isPlainObject;


var $156c3727697ab085$exports = {};
var $9d076681a0e29d68$exports = {};



/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = "[object Arguments]", $9d076681a0e29d68$var$arrayTag = "[object Array]", $9d076681a0e29d68$var$boolTag = "[object Boolean]", $9d076681a0e29d68$var$dateTag = "[object Date]", $9d076681a0e29d68$var$errorTag = "[object Error]", $9d076681a0e29d68$var$funcTag = "[object Function]", $9d076681a0e29d68$var$mapTag = "[object Map]", $9d076681a0e29d68$var$numberTag = "[object Number]", $9d076681a0e29d68$var$objectTag = "[object Object]", $9d076681a0e29d68$var$regexpTag = "[object RegExp]", $9d076681a0e29d68$var$setTag = "[object Set]", $9d076681a0e29d68$var$stringTag = "[object String]", $9d076681a0e29d68$var$weakMapTag = "[object WeakMap]";
var $9d076681a0e29d68$var$arrayBufferTag = "[object ArrayBuffer]", $9d076681a0e29d68$var$dataViewTag = "[object DataView]", $9d076681a0e29d68$var$float32Tag = "[object Float32Array]", $9d076681a0e29d68$var$float64Tag = "[object Float64Array]", $9d076681a0e29d68$var$int8Tag = "[object Int8Array]", $9d076681a0e29d68$var$int16Tag = "[object Int16Array]", $9d076681a0e29d68$var$int32Tag = "[object Int32Array]", $9d076681a0e29d68$var$uint8Tag = "[object Uint8Array]", $9d076681a0e29d68$var$uint8ClampedTag = "[object Uint8ClampedArray]", $9d076681a0e29d68$var$uint16Tag = "[object Uint16Array]", $9d076681a0e29d68$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $61269cf1f3e020be$exports(value) && $15d215b19bcf1187$exports(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$a7f8a2555793d7d3$exports(value)];
}
$9d076681a0e29d68$exports = $9d076681a0e29d68$var$baseIsTypedArray;


var $692cb5474f422969$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$692cb5474f422969$exports = $692cb5474f422969$var$baseUnary;



var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $692cb5474f422969$exports($156c3727697ab085$var$nodeIsTypedArray) : $9d076681a0e29d68$exports;
$156c3727697ab085$exports = $156c3727697ab085$var$isTypedArray;


var $121eb86ef7ce6b9c$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $121eb86ef7ce6b9c$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
$121eb86ef7ce6b9c$exports = $121eb86ef7ce6b9c$var$safeGet;


var $eda853de6b056001$exports = {};
var $971be9a5edcd8d07$exports = {};
var $3da413f0b86c10df$exports = {};


/** Used for built-in method references. */ var $3da413f0b86c10df$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da413f0b86c10df$var$hasOwnProperty = $3da413f0b86c10df$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3da413f0b86c10df$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3da413f0b86c10df$var$hasOwnProperty.call(object, key) && $50557587dab070a0$exports(objValue, value)) || value === undefined && !(key in object)) $96b401257ea00d24$exports(object, key, value);
}
$3da413f0b86c10df$exports = $3da413f0b86c10df$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $971be9a5edcd8d07$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $96b401257ea00d24$exports(object, key, newValue);
        else $3da413f0b86c10df$exports(object, key, newValue);
    }
    return object;
}
$971be9a5edcd8d07$exports = $971be9a5edcd8d07$var$copyObject;


var $af87da9a76941740$exports = {};
var $64568844439edb7f$exports = {};
var $b14d62a510ae7f2d$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$b14d62a510ae7f2d$exports = $b14d62a510ae7f2d$var$baseTimes;





var $f504n = parcelRequire("f504n");
var $d83738e053b5eb08$exports = {};
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$d83738e053b5eb08$exports = $d83738e053b5eb08$var$isIndex;



/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $0488fde9aa355453$exports(value), isArg = !isArr && $7d0c6fd0eb26be0e$exports(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $156c3727697ab085$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $b14d62a510ae7f2d$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $d83738e053b5eb08$exports(key, length)))) result.push(key);
    return result;
}
$64568844439edb7f$exports = $64568844439edb7f$var$arrayLikeKeys;


var $363905e043db7569$exports = {};


var $578c86548a505f7a$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $578c86548a505f7a$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$578c86548a505f7a$exports = $578c86548a505f7a$var$nativeKeysIn;


/** Used for built-in method references. */ var $363905e043db7569$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $363905e043db7569$var$hasOwnProperty = $363905e043db7569$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $363905e043db7569$var$baseKeysIn(object) {
    if (!$f9ff2e983beb6b86$exports(object)) return $578c86548a505f7a$exports(object);
    var isProto = $292432068be14a79$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$363905e043db7569$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$363905e043db7569$exports = $363905e043db7569$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $af87da9a76941740$var$keysIn(object) {
    return $ac2c42592aa05543$exports(object) ? $64568844439edb7f$exports(object, true) : $363905e043db7569$exports(object);
}
$af87da9a76941740$exports = $af87da9a76941740$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $eda853de6b056001$var$toPlainObject(value) {
    return $971be9a5edcd8d07$exports(value, $af87da9a76941740$exports(value));
}
$eda853de6b056001$exports = $eda853de6b056001$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $964a7bd734d0fbad$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $121eb86ef7ce6b9c$exports(object, key), srcValue = $121eb86ef7ce6b9c$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $5bab87b519c266a0$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $0488fde9aa355453$exports(srcValue), isBuff = !isArr && $f504n(srcValue), isTyped = !isArr && !isBuff && $156c3727697ab085$exports(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($0488fde9aa355453$exports(objValue)) newValue = objValue;
            else if ($e5599ea424e07f76$exports(objValue)) newValue = $7b3d95b0cd9dcb32$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $uQ1Em(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $42cd9d64f56ec214$exports(srcValue, true);
            } else newValue = [];
        } else if ($0658be17f7793a43$exports(srcValue) || $7d0c6fd0eb26be0e$exports(srcValue)) {
            newValue = objValue;
            if ($7d0c6fd0eb26be0e$exports(objValue)) newValue = $eda853de6b056001$exports(objValue);
            else if (!$f9ff2e983beb6b86$exports(objValue) || $004783abbde551e4$exports(objValue)) newValue = $9f425e619197b80f$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $5bab87b519c266a0$exports(object, key, newValue);
}
$964a7bd734d0fbad$exports = $964a7bd734d0fbad$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $34696005ed9b3f30$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $9f0778b809a8c692$exports(source, function(srcValue, key) {
        stack || (stack = new $bbb2d98cae25b61a$exports);
        if ($f9ff2e983beb6b86$exports(srcValue)) $964a7bd734d0fbad$exports(object, source, key, srcIndex, $34696005ed9b3f30$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($121eb86ef7ce6b9c$exports(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $5bab87b519c266a0$exports(object, key, newValue);
        }
    }, $af87da9a76941740$exports);
}
$34696005ed9b3f30$exports = $34696005ed9b3f30$var$baseMerge;


var $d1e75591f556b111$exports = {};
var $3db9ad8fe1351fef$exports = {};
var $37dff9aa04444f9c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
$37dff9aa04444f9c$exports = $37dff9aa04444f9c$var$identity;


var $81a5758ee0248452$exports = {};
var $e22d8f7aab4ea8e2$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e22d8f7aab4ea8e2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$e22d8f7aab4ea8e2$exports = $e22d8f7aab4ea8e2$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a5758ee0248452$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $81a5758ee0248452$var$overRest(func, start, transform) {
    start = $81a5758ee0248452$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $81a5758ee0248452$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $e22d8f7aab4ea8e2$exports(func, this, otherArgs);
    };
}
$81a5758ee0248452$exports = $81a5758ee0248452$var$overRest;


var $d9b21a2cad7f96c2$exports = {};
var $1dca5cc74bf5ffaf$exports = {};
var $7111863c3c692f0e$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7111863c3c692f0e$var$constant(value) {
    return function() {
        return value;
    };
}
$7111863c3c692f0e$exports = $7111863c3c692f0e$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1dca5cc74bf5ffaf$var$baseSetToString = !$31e24313ace94404$exports ? $37dff9aa04444f9c$exports : function(func, string) {
    return $31e24313ace94404$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $7111863c3c692f0e$exports(string),
        "writable": true
    });
};
$1dca5cc74bf5ffaf$exports = $1dca5cc74bf5ffaf$var$baseSetToString;


var $5c7bd4e931ae22e5$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5c7bd4e931ae22e5$var$HOT_COUNT = 800, $5c7bd4e931ae22e5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c7bd4e931ae22e5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5c7bd4e931ae22e5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5c7bd4e931ae22e5$var$nativeNow(), remaining = $5c7bd4e931ae22e5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5c7bd4e931ae22e5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$5c7bd4e931ae22e5$exports = $5c7bd4e931ae22e5$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b21a2cad7f96c2$var$setToString = $5c7bd4e931ae22e5$exports($1dca5cc74bf5ffaf$exports);
$d9b21a2cad7f96c2$exports = $d9b21a2cad7f96c2$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3db9ad8fe1351fef$var$baseRest(func, start) {
    return $d9b21a2cad7f96c2$exports($81a5758ee0248452$exports(func, start, $37dff9aa04444f9c$exports), func + "");
}
$3db9ad8fe1351fef$exports = $3db9ad8fe1351fef$var$baseRest;


var $81b21e8b41d211e8$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $81b21e8b41d211e8$var$isIterateeCall(value, index, object) {
    if (!$f9ff2e983beb6b86$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $ac2c42592aa05543$exports(object) && $d83738e053b5eb08$exports(index, object.length) : type == "string" && index in object) return $50557587dab070a0$exports(object[index], value);
    return false;
}
$81b21e8b41d211e8$exports = $81b21e8b41d211e8$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $d1e75591f556b111$var$createAssigner(assigner) {
    return $3db9ad8fe1351fef$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $81b21e8b41d211e8$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$d1e75591f556b111$exports = $d1e75591f556b111$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $4524f833ae45779b$var$merge = $d1e75591f556b111$exports(function(object, source, srcIndex) {
    $34696005ed9b3f30$exports(object, source, srcIndex);
});
$4524f833ae45779b$exports = $4524f833ae45779b$var$merge;



const $d2d621530b694cb3$export$59e2b39f02edfada = (e, m, s, t)=>(0, $2a754a1c7faca113$export$1050f835b63b671e)(void 0, void 0, void 0, function*() {
        const o = yield Promise.all(t.map((o)=>o(e, m, s))), l = (0, (/*@__PURE__*/$parcel$interopDefault($4524f833ae45779b$exports)))({}, ...o);
        return (0, $15a7c5986a3f06c2$export$dd1bc94b04021eeb)(l) ? Promise.resolve() : Promise.reject(l);
    });











const $3026204c9959d254$export$7ae2d201ca9520b = {
    getAmplifyConfig () {
        return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $36606c730099e1c8$exports.Amplify).configure();
        });
    },
    getCurrentUser () {
        return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $cc420cb14b670b2a$export$334c29725a78c21d).currentAuthenticatedUser();
        });
    },
    handleSignUp (t) {
        return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $cc420cb14b670b2a$export$334c29725a78c21d).signUp(Object.assign(Object.assign({}, t), {
                autoSignIn: {
                    enabled: !0
                }
            }));
        });
    },
    handleSignIn ({ username: t, password: n }) {
        return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $cc420cb14b670b2a$export$334c29725a78c21d).signIn(t, n);
        });
    },
    handleConfirmSignIn ({ user: t, code: n, mfaType: o }) {
        return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $cc420cb14b670b2a$export$334c29725a78c21d).confirmSignIn(t, n, o);
        });
    },
    handleConfirmSignUp ({ username: t, code: n }) {
        return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return yield (0, $cc420cb14b670b2a$export$334c29725a78c21d).confirmSignUp(t, n);
        });
    },
    handleForgotPasswordSubmit ({ username: t, code: n, password: o }) {
        return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $cc420cb14b670b2a$export$334c29725a78c21d).forgotPasswordSubmit(t, n, o);
        });
    },
    handleForgotPassword (t) {
        return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $cc420cb14b670b2a$export$334c29725a78c21d).forgotPassword(t);
        });
    },
    validateCustomSignUp (t, s) {
        return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {});
    },
    validateFormPassword (t, s, o) {
        return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const { password: r } = t, { password: e } = s;
            if (!e || !o) return null;
            const i = [], a = +(null == o ? void 0 : o.passwordPolicyMinLength);
            r.length < a && i.push(`Password must have at least ${a} characters`);
            const u = null == o ? void 0 : o.passwordPolicyCharacters;
            return null == u || u.forEach((t)=>{
                switch(t){
                    case "REQUIRES_LOWERCASE":
                        /[a-z]/.test(r) || i.push("Password must have lower case letters");
                        break;
                    case "REQUIRES_UPPERCASE":
                        /[A-Z]/.test(r) || i.push("Password must have upper case letters");
                        break;
                    case "REQUIRES_NUMBERS":
                        /[0-9]/.test(r) || i.push("Password must have numbers");
                        break;
                    case "REQUIRES_SYMBOLS":
                        (0, $9ad1914df4b6fe69$export$1ec93875315f071d)(r) || i.push("Password must have special characters");
                }
            }), 0 !== i.length ? {
                password: i
            } : null;
        });
    },
    validateConfirmPassword (t, s) {
        return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const { password: r, confirm_password: n } = t, { confirm_password: o, password: e } = s;
            return r || n ? (r || n) && r !== n && (o && e || (null == r ? void 0 : r.length) >= 6 && (null == n ? void 0 : n.length) >= 6) ? {
                confirm_password: "Your passwords must match"
            } : void 0 : null;
        });
    },
    validatePreferredUsername (t, s) {
        return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {});
    }
};



const $3003bbb4a9472e63$var$_ = [
    "SMS_MFA",
    "SOFTWARE_TOKEN_MFA"
], $3003bbb4a9472e63$var$F = (e)=>(0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(e, "data.challengeName"), $3003bbb4a9472e63$var$O = (e, t)=>e === t, $3003bbb4a9472e63$var$j = (e)=>$3003bbb4a9472e63$var$_.includes(e);
function $3003bbb4a9472e63$export$f9c30eaa77191700({ services: n }) {
    return (0, $c9f97204c6723ccf$export$aaa7fa18f8e9b2e8)({
        initial: "init",
        id: "signInActor",
        predictableActionArguments: !0,
        states: {
            init: {
                always: [
                    {
                        target: "autoSignIn.submit",
                        cond: "shouldAutoSubmit"
                    },
                    {
                        target: "autoSignIn",
                        cond: "shouldAutoSignIn"
                    },
                    {
                        target: "signIn"
                    }
                ]
            },
            signIn: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            FEDERATED_SIGN_IN: "federatedSignIn"
                        }
                    },
                    federatedSignIn: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "sendUpdate",
                            "clearError"
                        ],
                        invoke: {
                            src: "federatedSignIn",
                            onError: {
                                actions: "setRemoteError"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "parsePhoneNumber",
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "signIn",
                            onDone: [
                                {
                                    cond: "shouldSetupTOTP",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.setupTOTP"
                                },
                                {
                                    cond: "shouldConfirmSignIn",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.confirmSignIn"
                                },
                                {
                                    cond: "shouldForceChangePassword",
                                    actions: [
                                        "setUser",
                                        "setChallengeName",
                                        "setRequiredAttributes"
                                    ],
                                    target: "#signInActor.forceNewPassword"
                                },
                                {
                                    actions: "setUser",
                                    target: "verifying"
                                }
                            ],
                            onError: [
                                {
                                    cond: "shouldRedirectToConfirmSignUp",
                                    actions: [
                                        "setCredentials",
                                        "setConfirmSignUpIntent"
                                    ],
                                    target: "rejected"
                                },
                                {
                                    cond: "shouldRedirectToConfirmResetPassword",
                                    actions: [
                                        "setUsernameAuthAttributes",
                                        "setConfirmResetPasswordIntent"
                                    ],
                                    target: "rejected"
                                },
                                {
                                    actions: "setRemoteError",
                                    target: "edit"
                                }
                            ]
                        }
                    },
                    verifying: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "checkVerifiedContact",
                            onDone: [
                                {
                                    cond: "shouldRequestVerification",
                                    target: "#signInActor.verifyUser",
                                    actions: "setUnverifiedContactMethods"
                                },
                                {
                                    target: "resolved"
                                }
                            ],
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    },
                    resolved: {
                        always: "#signInActor.resolved"
                    },
                    rejected: {
                        always: "#signInActor.rejected"
                    }
                }
            },
            autoSignIn: {
                initial: "pending",
                states: {
                    pending: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        on: {
                            AUTO_SIGN_IN: [
                                {
                                    cond: "shouldSetupTOTP",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.setupTOTP"
                                },
                                {
                                    cond: "shouldConfirmSignIn",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.confirmSignIn"
                                },
                                {
                                    cond: "shouldForceChangePassword",
                                    actions: [
                                        "setUser",
                                        "setChallengeName",
                                        "setRequiredAttributes"
                                    ],
                                    target: "#signInActor.forceNewPassword"
                                },
                                {
                                    actions: "setUser",
                                    target: "#signInActor.resolved"
                                }
                            ],
                            AUTO_SIGN_IN_FAILURE: {
                                actions: "setRemoteError",
                                target: "pending"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "signIn",
                            onDone: [
                                {
                                    cond: "shouldSetupTOTP",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.setupTOTP"
                                },
                                {
                                    cond: "shouldConfirmSignIn",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.confirmSignIn"
                                },
                                {
                                    cond: "shouldForceChangePassword",
                                    actions: [
                                        "setUser",
                                        "setChallengeName",
                                        "setRequiredAttributes"
                                    ],
                                    target: "#signInActor.forceNewPassword"
                                },
                                {
                                    actions: "setUser",
                                    target: "#signInActor.resolved"
                                }
                            ],
                            onError: {
                                actions: "setRemoteError",
                                target: "#signInActor.signIn"
                            }
                        }
                    },
                    resolved: {
                        always: "#signInActor.resolved"
                    },
                    rejected: {
                        always: "#signInActor.rejected"
                    }
                }
            },
            confirmSignIn: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "confirmSignIn",
                            onDone: {
                                target: "#signInActor.resolved",
                                actions: [
                                    "setUser",
                                    "clearChallengeName",
                                    "clearRequiredAttributes"
                                ]
                            },
                            onError: {
                                target: "edit",
                                actions: "setRemoteError"
                            }
                        }
                    }
                }
            },
            forceNewPassword: {
                type: "parallel",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submit: {
                        initial: "idle",
                        entry: "clearError",
                        states: {
                            idle: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "pending",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "idle",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            pending: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "forceNewPassword",
                                    onDone: [
                                        {
                                            cond: "shouldConfirmSignIn",
                                            actions: [
                                                "setUser",
                                                "setChallengeName"
                                            ],
                                            target: "#signInActor.confirmSignIn"
                                        },
                                        {
                                            cond: "shouldSetupTOTP",
                                            actions: [
                                                "setUser",
                                                "setChallengeName"
                                            ],
                                            target: "#signInActor.setupTOTP"
                                        },
                                        {
                                            target: "resolved",
                                            actions: [
                                                "setUser",
                                                "setCredentials"
                                            ]
                                        }
                                    ],
                                    onError: {
                                        target: "idle",
                                        actions: "setRemoteError"
                                    }
                                }
                            },
                            resolved: {
                                type: "final",
                                always: "#signInActor.resolved"
                            }
                        }
                    }
                }
            },
            setupTOTP: {
                initial: "getTotpSecretCode",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    getTotpSecretCode: {
                        invoke: {
                            src: "getTotpSecretCode",
                            onDone: {
                                target: "edit",
                                actions: "setTotpSecretCode"
                            },
                            onError: {
                                target: "edit",
                                actions: "setRemoteError"
                            }
                        }
                    },
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "sendUpdate",
                            "clearError"
                        ],
                        invoke: {
                            src: "verifyTotpToken",
                            onDone: {
                                actions: [
                                    "clearChallengeName",
                                    "clearRequiredAttributes"
                                ],
                                target: "#signInActor.resolved"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            verifyUser: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SKIP: "#signInActor.resolved",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: "clearError",
                        invoke: {
                            src: "verifyUser",
                            onDone: {
                                target: "#signInActor.confirmVerifyUser"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            confirmVerifyUser: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearUnverifiedContactMethods",
                    "clearAttributeToVerify",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SKIP: "#signInActor.resolved",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: "clearError",
                        invoke: {
                            src: "confirmVerifyUser",
                            onDone: {
                                target: "#signInActor.resolved"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: (e)=>({
                        user: e.user
                    })
            },
            rejected: {
                type: "final",
                data: (e, t)=>({
                        intent: e.redirectIntent,
                        authAttributes: e.authAttributes
                    })
            }
        }
    }, {
        actions: {
            clearAttributeToVerify: (0, $28623b45b974975c$export$9faa50368a7b3c89),
            clearChallengeName: (0, $28623b45b974975c$export$aa3d1e2603b6b393),
            clearRequiredAttributes: (0, $28623b45b974975c$export$f59683a2f5c65c18),
            clearError: (0, $28623b45b974975c$export$a15ba4bdf59dacc9),
            clearFormValues: (0, $28623b45b974975c$export$bfa16614c507dc4b),
            clearTouched: (0, $28623b45b974975c$export$c459b227ec8b5bb),
            clearUnverifiedContactMethods: (0, $28623b45b974975c$export$58692221bc9d7254),
            clearValidationError: (0, $28623b45b974975c$export$5270f204082eebfb),
            handleInput: (0, $28623b45b974975c$export$412508d679148d5c),
            handleSubmit: (0, $28623b45b974975c$export$89c2621768820c8b),
            handleBlur: (0, $28623b45b974975c$export$27d5d91e7417534c),
            parsePhoneNumber: (0, $28623b45b974975c$export$da44e4eaa54bc82e),
            setChallengeName: (0, $28623b45b974975c$export$11d8ed3bd13bb8e3),
            setConfirmResetPasswordIntent: (0, $28623b45b974975c$export$e574184fef92c521),
            setConfirmSignUpIntent: (0, $28623b45b974975c$export$95541f1a5e3a994),
            setRequiredAttributes: (0, $28623b45b974975c$export$f18efc7fc22567f3),
            setCredentials: (0, $28623b45b974975c$export$3a6cdb4d139acb5f),
            setFieldErrors: (0, $28623b45b974975c$export$6c79f1f160aff8ba),
            setRemoteError: (0, $28623b45b974975c$export$a6a2df750d905c59),
            setTotpSecretCode: (0, $28623b45b974975c$export$623e894a03312e76),
            setUnverifiedContactMethods: (0, $28623b45b974975c$export$a15839655cde632a),
            setUser: (0, $28623b45b974975c$export$8b6bb3dd62a01be2),
            setUsernameAuthAttributes: (0, $28623b45b974975c$export$12b5e0d209e80876),
            sendUpdate: (0, $9cec7b12efdda519$export$7f8b724299523eb6)()
        },
        guards: {
            shouldAutoSignIn: (e)=>"autoSignIn" === (null == e ? void 0 : e.intent),
            shouldAutoSubmit: (e)=>"autoSignInSubmit" === (null == e ? void 0 : e.intent),
            shouldConfirmSignIn: (e, t)=>$3003bbb4a9472e63$var$j($3003bbb4a9472e63$var$F(t)),
            shouldForceChangePassword: (e, t)=>$3003bbb4a9472e63$var$O($3003bbb4a9472e63$var$F(t), "NEW_PASSWORD_REQUIRED"),
            shouldRedirectToConfirmResetPassword: (e, t)=>"PasswordResetRequiredException" === t.data.code,
            shouldRedirectToConfirmSignUp: (e, t)=>"UserNotConfirmedException" === t.data.code,
            shouldRequestVerification: (e, t)=>{
                const { unverified: r, verified: n } = t.data;
                return (0, $15a7c5986a3f06c2$export$dd1bc94b04021eeb)(n) && !(0, $15a7c5986a3f06c2$export$dd1bc94b04021eeb)(r);
            },
            shouldSetupTOTP: (e, t)=>$3003bbb4a9472e63$var$O($3003bbb4a9472e63$var$F(t), "MFA_SETUP")
        },
        services: {
            signIn (t) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { authAttributes: e = {}, formValues: r = {} } = t, o = Object.assign(Object.assign({}, e), r), { username: i, password: s } = o;
                    return yield n.handleSignIn({
                        username: i,
                        password: s
                    });
                });
            },
            confirmSignIn (t) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { challengeName: e, user: o } = t, { confirmation_code: i } = t.formValues, s = $3003bbb4a9472e63$var$j(e) ? e : void 0;
                    return yield n.handleConfirmSignIn({
                        user: o,
                        code: i,
                        mfaType: s
                    }), yield (0, $cc420cb14b670b2a$export$334c29725a78c21d).currentAuthenticatedUser();
                });
            },
            forceNewPassword (n) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { user: e, formValues: o } = n;
                    let i, { password: s, confirm_password: a, phone_number: d, country_code: c } = o, l = (0, $2a754a1c7faca113$export$3c9a16f847548506)(o, [
                        "password",
                        "confirm_password",
                        "phone_number",
                        "country_code"
                    ]);
                    d && (i = `${c}${d}`.replace(/[^A-Z0-9+]/gi, ""), l = Object.assign(Object.assign({}, l), {
                        phone_number: i
                    }));
                    try {
                        const t = yield (0, $cc420cb14b670b2a$export$334c29725a78c21d).completeNewPassword(e, s, l);
                        return t.challengeName ? t : (0, $cc420cb14b670b2a$export$334c29725a78c21d).currentAuthenticatedUser();
                    } catch (e) {
                        return Promise.reject(e);
                    }
                });
            },
            getTotpSecretCode (t) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { user: e } = t;
                    return (0, $cc420cb14b670b2a$export$334c29725a78c21d).setupTOTP(e);
                });
            },
            verifyTotpToken (t) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { formValues: e, user: n } = t, { confirmation_code: o } = e;
                    return (0, $cc420cb14b670b2a$export$334c29725a78c21d).verifyTotpToken(n, o);
                });
            },
            federatedSignIn (t, n) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { provider: e } = n.data;
                    return yield (0, $cc420cb14b670b2a$export$334c29725a78c21d).federatedSignIn({
                        provider: e
                    });
                });
            },
            checkVerifiedContact (t) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { user: e } = t;
                    return yield (0, $cc420cb14b670b2a$export$334c29725a78c21d).verifiedContact(e);
                });
            },
            verifyUser (t) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { unverifiedAttr: e } = t.formValues, n = yield (0, $cc420cb14b670b2a$export$334c29725a78c21d).verifyCurrentUserAttribute(e);
                    return t.attributeToVerify = e, n;
                });
            },
            confirmVerifyUser (t) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { attributeToVerify: e } = t, { confirmation_code: n } = t.formValues;
                    return yield (0, $cc420cb14b670b2a$export$334c29725a78c21d).verifyCurrentUserAttributeSubmit(e, n);
                });
            },
            validateFields (t) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    return (0, $d2d621530b694cb3$export$59e2b39f02edfada)(t.formValues, t.touched, t.passwordSettings, [
                        (0, $3026204c9959d254$export$7ae2d201ca9520b).validateFormPassword,
                        (0, $3026204c9959d254$export$7ae2d201ca9520b).validateConfirmPassword
                    ]);
                });
            }
        }
    });
}




const $b61db1507db42ffb$export$2f15f45f1f7b7787 = (0, $c9f97204c6723ccf$export$aaa7fa18f8e9b2e8)({
    initial: "pending",
    id: "signOutActor",
    predictableActionArguments: !0,
    states: {
        pending: {
            tags: [
                "pending"
            ],
            invoke: {
                src: "signOut",
                onDone: "resolved",
                onError: "rejected"
            }
        },
        resolved: {
            type: "final"
        },
        rejected: {
            type: "final"
        }
    }
}, {
    services: {
        signOut: ()=>(0, $cc420cb14b670b2a$export$334c29725a78c21d).signOut()
    }
});







function $d0d2bcbecc78f3ca$export$9e01526a2f4b3199({ services: f }) {
    return (0, $c9f97204c6723ccf$export$aaa7fa18f8e9b2e8)({
        id: "resetPasswordActor",
        initial: "init",
        predictableActionArguments: !0,
        states: {
            init: {
                always: [
                    {
                        target: "confirmResetPassword",
                        cond: "shouldAutoConfirmReset",
                        actions: "resendCode"
                    },
                    {
                        target: "resetPassword"
                    }
                ]
            },
            resetPassword: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            BLUR: {
                                actions: "handleBlur"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "sendUpdate",
                            "setUsername",
                            "clearError"
                        ],
                        invoke: {
                            src: "resetPassword",
                            onDone: {
                                target: "#resetPasswordActor.confirmResetPassword"
                            },
                            onError: {
                                actions: [
                                    "setRemoteError"
                                ],
                                target: "edit"
                            }
                        }
                    }
                }
            },
            confirmResetPassword: {
                type: "parallel",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearUsername",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submission: {
                        initial: "idle",
                        states: {
                            idle: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    },
                                    RESEND: "resendCode",
                                    CHANGE: {
                                        actions: "handleInput"
                                    },
                                    BLUR: {
                                        actions: "handleBlur"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "pending",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "idle",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            resendCode: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "clearError",
                                    "sendUpdate"
                                ],
                                invoke: {
                                    src: "resetPassword",
                                    onDone: {
                                        target: "idle"
                                    },
                                    onError: {
                                        actions: "setRemoteError",
                                        target: "idle"
                                    }
                                }
                            },
                            pending: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "clearError",
                                    "sendUpdate"
                                ],
                                invoke: {
                                    src: "confirmResetPassword",
                                    onDone: {
                                        actions: "clearUsername",
                                        target: "#resetPasswordActor.resolved"
                                    },
                                    onError: {
                                        actions: "setRemoteError",
                                        target: "idle"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final"
            }
        }
    }, {
        actions: {
            clearError: (0, $28623b45b974975c$export$a15ba4bdf59dacc9),
            clearFormValues: (0, $28623b45b974975c$export$bfa16614c507dc4b),
            clearTouched: (0, $28623b45b974975c$export$c459b227ec8b5bb),
            clearUsername: (0, $28623b45b974975c$export$1d20f61d217c468f),
            clearValidationError: (0, $28623b45b974975c$export$5270f204082eebfb),
            handleInput: (0, $28623b45b974975c$export$412508d679148d5c),
            handleSubmit: (0, $28623b45b974975c$export$89c2621768820c8b),
            handleBlur: (0, $28623b45b974975c$export$27d5d91e7417534c),
            resendCode: (0, $28623b45b974975c$export$90e3d721ed7e24a8),
            setFieldErrors: (0, $28623b45b974975c$export$6c79f1f160aff8ba),
            setRemoteError: (0, $28623b45b974975c$export$a6a2df750d905c59),
            setUsername: (0, $28623b45b974975c$export$6ae5cbbde4bec733),
            sendUpdate: (0, $9cec7b12efdda519$export$7f8b724299523eb6)()
        },
        guards: {
            shouldAutoConfirmReset: (e, r)=>!(!e.intent || "confirmPasswordReset" !== e.intent)
        },
        services: {
            resetPassword (r) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { username: e } = r;
                    return f.handleForgotPassword(e);
                });
            },
            confirmResetPassword (r) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { username: e } = r, { confirmation_code: t, password: s } = r.formValues;
                    return f.handleForgotPasswordSubmit({
                        username: e,
                        code: t,
                        password: s
                    });
                });
            },
            validateFields (r, t) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    return (0, $d2d621530b694cb3$export$59e2b39f02edfada)(r.formValues, r.touched, r.passwordSettings, [
                        (0, $3026204c9959d254$export$7ae2d201ca9520b).validateFormPassword,
                        (0, $3026204c9959d254$export$7ae2d201ca9520b).validateConfirmPassword
                    ]);
                });
            }
        }
    });
}






var $9b6d46093811e2aa$exports = {};

var $5aba4f6d9f8304a3$exports = {};
var $e780807e2b795134$exports = {};
var $ec073f38db6e7d54$exports = {};

var $769812b29c18141e$exports = {};
var $567f2dd161ebd4f6$exports = {};

var $1081bd3a2e361911$exports = {};
var $a29ccdc0f60e279e$exports = {};

var $dda8f7b6b589544e$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
$dda8f7b6b589544e$exports = $dda8f7b6b589544e$var$setCacheAdd;


var $66732c92c350622c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$66732c92c350622c$exports = $66732c92c350622c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4902f64a16640324$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $dda8f7b6b589544e$exports;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $66732c92c350622c$exports;
$a29ccdc0f60e279e$exports = $a29ccdc0f60e279e$var$SetCache;


var $aae24ad60cc3cfcb$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$aae24ad60cc3cfcb$exports = $aae24ad60cc3cfcb$var$arraySome;


var $1b44096ad4b9e2d5$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
$1b44096ad4b9e2d5$exports = $1b44096ad4b9e2d5$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $a29ccdc0f60e279e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$aae24ad60cc3cfcb$exports(other, function(othValue, othIndex) {
                if (!$1b44096ad4b9e2d5$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$1081bd3a2e361911$exports = $1081bd3a2e361911$var$equalArrays;


var $baf52b9e146f3da7$exports = {};




var $91d4444cbb077e0c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$91d4444cbb077e0c$exports = $91d4444cbb077e0c$var$mapToArray;


var $11f509f8f53d8c36$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$11f509f8f53d8c36$exports = $11f509f8f53d8c36$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = "[object Boolean]", $baf52b9e146f3da7$var$dateTag = "[object Date]", $baf52b9e146f3da7$var$errorTag = "[object Error]", $baf52b9e146f3da7$var$mapTag = "[object Map]", $baf52b9e146f3da7$var$numberTag = "[object Number]", $baf52b9e146f3da7$var$regexpTag = "[object RegExp]", $baf52b9e146f3da7$var$setTag = "[object Set]", $baf52b9e146f3da7$var$stringTag = "[object String]", $baf52b9e146f3da7$var$symbolTag = "[object Symbol]";
var $baf52b9e146f3da7$var$arrayBufferTag = "[object ArrayBuffer]", $baf52b9e146f3da7$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $facf83d1449a27b8$exports(object), new $facf83d1449a27b8$exports(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $50557587dab070a0$exports(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $91d4444cbb077e0c$exports;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $11f509f8f53d8c36$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1081bd3a2e361911$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
$baf52b9e146f3da7$exports = $baf52b9e146f3da7$var$equalByTag;


var $ac8a81cbae0357e8$exports = {};
var $7958eecccfe4cef6$exports = {};
var $9144d49da7a47a72$exports = {};
var $cc77dbb7c08db6a8$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$cc77dbb7c08db6a8$exports = $cc77dbb7c08db6a8$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0488fde9aa355453$exports(object) ? result : $cc77dbb7c08db6a8$exports(result, symbolsFunc(object));
}
$9144d49da7a47a72$exports = $9144d49da7a47a72$var$baseGetAllKeys;


var $51326a29f571e7cd$exports = {};
var $6549fed720324048$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$6549fed720324048$exports = $6549fed720324048$var$arrayFilter;


var $8fc9f7df9b0c06bb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
$8fc9f7df9b0c06bb$exports = $8fc9f7df9b0c06bb$var$stubArray;


/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $8fc9f7df9b0c06bb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $6549fed720324048$exports($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
$51326a29f571e7cd$exports = $51326a29f571e7cd$var$getSymbols;


var $08f0eaf3fbcb2fde$exports = {};

var $e811d2e210fb58cc$exports = {};

var $0b26005314403d97$exports = {};

/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $ff813e49bf3cca3d$exports(Object.keys, Object);
$0b26005314403d97$exports = $0b26005314403d97$var$nativeKeys;


/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$292432068be14a79$exports(object)) return $0b26005314403d97$exports(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$e811d2e210fb58cc$exports = $e811d2e210fb58cc$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $ac2c42592aa05543$exports(object) ? $64568844439edb7f$exports(object) : $e811d2e210fb58cc$exports(object);
}
$08f0eaf3fbcb2fde$exports = $08f0eaf3fbcb2fde$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $9144d49da7a47a72$exports(object, $08f0eaf3fbcb2fde$exports, $51326a29f571e7cd$exports);
}
$7958eecccfe4cef6$exports = $7958eecccfe4cef6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $7958eecccfe4cef6$exports(object), objLength = objProps.length, othProps = $7958eecccfe4cef6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$ac8a81cbae0357e8$exports = $ac8a81cbae0357e8$var$equalObjects;


var $474f685f496bfe31$exports = {};
var $41ce0ff3b38ee753$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $5037fd2e597c2a03$exports($23YZo, "DataView");
$41ce0ff3b38ee753$exports = $41ce0ff3b38ee753$var$DataView;



var $b0226bdea11cb834$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $5037fd2e597c2a03$exports($23YZo, "Promise");
$b0226bdea11cb834$exports = $b0226bdea11cb834$var$Promise;


var $05f44e958da968eb$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $5037fd2e597c2a03$exports($23YZo, "Set");
$05f44e958da968eb$exports = $05f44e958da968eb$var$Set;


var $aedce50092a1e6a6$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $5037fd2e597c2a03$exports($23YZo, "WeakMap");
$aedce50092a1e6a6$exports = $aedce50092a1e6a6$var$WeakMap;




/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = "[object Map]", $474f685f496bfe31$var$objectTag = "[object Object]", $474f685f496bfe31$var$promiseTag = "[object Promise]", $474f685f496bfe31$var$setTag = "[object Set]", $474f685f496bfe31$var$weakMapTag = "[object WeakMap]";
var $474f685f496bfe31$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $9c6b3ec69362487e$exports($41ce0ff3b38ee753$exports), $474f685f496bfe31$var$mapCtorString = $9c6b3ec69362487e$exports($19b02faa57603249$exports), $474f685f496bfe31$var$promiseCtorString = $9c6b3ec69362487e$exports($b0226bdea11cb834$exports), $474f685f496bfe31$var$setCtorString = $9c6b3ec69362487e$exports($05f44e958da968eb$exports), $474f685f496bfe31$var$weakMapCtorString = $9c6b3ec69362487e$exports($aedce50092a1e6a6$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $a7f8a2555793d7d3$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($41ce0ff3b38ee753$exports && $474f685f496bfe31$var$getTag(new $41ce0ff3b38ee753$exports(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $19b02faa57603249$exports && $474f685f496bfe31$var$getTag(new $19b02faa57603249$exports) != $474f685f496bfe31$var$mapTag || $b0226bdea11cb834$exports && $474f685f496bfe31$var$getTag($b0226bdea11cb834$exports.resolve()) != $474f685f496bfe31$var$promiseTag || $05f44e958da968eb$exports && $474f685f496bfe31$var$getTag(new $05f44e958da968eb$exports) != $474f685f496bfe31$var$setTag || $aedce50092a1e6a6$exports && $474f685f496bfe31$var$getTag(new $aedce50092a1e6a6$exports) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $a7f8a2555793d7d3$exports(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9c6b3ec69362487e$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
$474f685f496bfe31$exports = $474f685f496bfe31$var$getTag;




var $f504n = parcelRequire("f504n");

/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = "[object Arguments]", $567f2dd161ebd4f6$var$arrayTag = "[object Array]", $567f2dd161ebd4f6$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0488fde9aa355453$exports(object), othIsArr = $0488fde9aa355453$exports(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bbb2d98cae25b61a$exports);
        return objIsArr || $156c3727697ab085$exports(object) ? $1081bd3a2e361911$exports(object, other, bitmask, customizer, equalFunc, stack) : $baf52b9e146f3da7$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bbb2d98cae25b61a$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bbb2d98cae25b61a$exports);
    return $ac8a81cbae0357e8$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$567f2dd161ebd4f6$exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$61269cf1f3e020be$exports(value) && !$61269cf1f3e020be$exports(other)) return value !== value && other !== other;
    return $567f2dd161ebd4f6$exports(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
$769812b29c18141e$exports = $769812b29c18141e$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bbb2d98cae25b61a$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $769812b29c18141e$exports(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$ec073f38db6e7d54$exports = $ec073f38db6e7d54$var$baseIsMatch;


var $6b4f84f6be7f825c$exports = {};
var $0ff8edf4f90a7955$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$f9ff2e983beb6b86$exports(value);
}
$0ff8edf4f90a7955$exports = $0ff8edf4f90a7955$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $08f0eaf3fbcb2fde$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $0ff8edf4f90a7955$exports(value)
        ];
    }
    return result;
}
$6b4f84f6be7f825c$exports = $6b4f84f6be7f825c$var$getMatchData;


var $1f9d5e891556ddb9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1f9d5e891556ddb9$exports = $1f9d5e891556ddb9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $6b4f84f6be7f825c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1f9d5e891556ddb9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $ec073f38db6e7d54$exports(object, source, matchData);
    };
}
$e780807e2b795134$exports = $e780807e2b795134$var$baseMatches;


var $d5fe8a98fe4800eb$exports = {};


var $221e04e57e35dd04$exports = {};
var $d53c6080f339a51f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d53c6080f339a51f$exports = $d53c6080f339a51f$var$baseHasIn;


var $85aaea8f77d790ae$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4d60aa8c33155976$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $15d215b19bcf1187$exports(length) && $d83738e053b5eb08$exports(key, length) && ($0488fde9aa355453$exports(object) || $7d0c6fd0eb26be0e$exports(object));
}
$85aaea8f77d790ae$exports = $85aaea8f77d790ae$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $d53c6080f339a51f$exports);
}
$221e04e57e35dd04$exports = $221e04e57e35dd04$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($03e9beb856e9b4cd$exports(path) && $0ff8edf4f90a7955$exports(srcValue)) return $1f9d5e891556ddb9$exports($4d60aa8c33155976$exports(path), srcValue);
    return function(object) {
        var objValue = $d299ac421c05c135$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $221e04e57e35dd04$exports(object, path) : $769812b29c18141e$exports(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
$d5fe8a98fe4800eb$exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;




var $87123e72266aa58c$exports = {};
var $d45a621b4548f6bb$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$d45a621b4548f6bb$exports = $d45a621b4548f6bb$var$baseProperty;


var $e029d02f9dd10368$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $fd2d90f592c63519$exports(object, path);
    };
}
$e029d02f9dd10368$exports = $e029d02f9dd10368$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $03e9beb856e9b4cd$exports(path) ? $d45a621b4548f6bb$exports($4d60aa8c33155976$exports(path)) : $e029d02f9dd10368$exports(path);
}
$87123e72266aa58c$exports = $87123e72266aa58c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $37dff9aa04444f9c$exports;
    if (typeof value == "object") return $0488fde9aa355453$exports(value) ? $d5fe8a98fe4800eb$exports(value[0], value[1]) : $e780807e2b795134$exports(value);
    return $87123e72266aa58c$exports(value);
}
$5aba4f6d9f8304a3$exports = $5aba4f6d9f8304a3$var$baseIteratee;


var $4e551d8e73f04819$exports = {};

var $aba0e6d66e8d80dd$exports = {};





/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $aba0e6d66e8d80dd$var$baseSet(object, path, value, customizer) {
    if (!$f9ff2e983beb6b86$exports(object)) return object;
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $4d60aa8c33155976$exports(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $f9ff2e983beb6b86$exports(objValue) ? objValue : $d83738e053b5eb08$exports(path[index + 1]) ? [] : {};
        }
        $3da413f0b86c10df$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$aba0e6d66e8d80dd$exports = $aba0e6d66e8d80dd$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $4e551d8e73f04819$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $fd2d90f592c63519$exports(object, path);
        if (predicate(value, path)) $aba0e6d66e8d80dd$exports(result, $38afcbfab85a0553$exports(path, object), value);
    }
    return result;
}
$4e551d8e73f04819$exports = $4e551d8e73f04819$var$basePickBy;


var $d1b85174ea17081a$exports = {};

var $77e3eeed2d30c6bc$exports = {};




/* Built-in method references for those with the same name as other `lodash` methods. */ var $77e3eeed2d30c6bc$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $77e3eeed2d30c6bc$var$getSymbolsIn = !$77e3eeed2d30c6bc$var$nativeGetSymbols ? $8fc9f7df9b0c06bb$exports : function(object) {
    var result = [];
    while(object){
        $cc77dbb7c08db6a8$exports(result, $51326a29f571e7cd$exports(object));
        object = $8e492c1d7a7ea307$exports(object);
    }
    return result;
};
$77e3eeed2d30c6bc$exports = $77e3eeed2d30c6bc$var$getSymbolsIn;



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d1b85174ea17081a$var$getAllKeysIn(object) {
    return $9144d49da7a47a72$exports(object, $af87da9a76941740$exports, $77e3eeed2d30c6bc$exports);
}
$d1b85174ea17081a$exports = $d1b85174ea17081a$var$getAllKeysIn;


/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $9b6d46093811e2aa$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $d26d80da1ba3948c$exports($d1b85174ea17081a$exports(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $5aba4f6d9f8304a3$exports(predicate);
    return $4e551d8e73f04819$exports(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
$9b6d46093811e2aa$exports = $9b6d46093811e2aa$var$pickBy;





function $b3c0e468c114dbfa$export$a5c4b20d9017fce9({ services: y }) {
    return (0, $c9f97204c6723ccf$export$aaa7fa18f8e9b2e8)({
        id: "signUpActor",
        initial: "init",
        predictableActionArguments: !0,
        states: {
            init: {
                always: [
                    {
                        target: "confirmSignUp",
                        cond: "shouldInitConfirmSignUp"
                    },
                    {
                        target: "signUp"
                    }
                ]
            },
            signUp: {
                type: "parallel",
                exit: [
                    "clearError",
                    "clearFormValues",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateSignUp",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submission: {
                        initial: "idle",
                        states: {
                            idle: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    },
                                    FEDERATED_SIGN_IN: "federatedSignIn"
                                }
                            },
                            federatedSignIn: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "federatedSignIn",
                                    onDone: "#signUpActor.resolved",
                                    onError: {
                                        actions: "setRemoteError"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateSignUp",
                                    onDone: {
                                        target: "pending",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "idle",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            pending: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "parsePhoneNumber",
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "signUp",
                                    onDone: [
                                        {
                                            cond: "shouldSkipConfirm",
                                            target: "skipConfirm",
                                            actions: [
                                                "setUser",
                                                "setCredentials"
                                            ]
                                        },
                                        {
                                            target: "resolved",
                                            actions: [
                                                "setUser",
                                                "setCredentials",
                                                "setCodeDeliveryDetails"
                                            ]
                                        }
                                    ],
                                    onError: {
                                        target: "idle",
                                        actions: "setRemoteError"
                                    }
                                }
                            },
                            skipConfirm: {
                                always: {
                                    target: "#signUpActor.resolved",
                                    actions: "setAutoSignInIntent"
                                }
                            },
                            resolved: {
                                type: "final",
                                always: "#signUpActor.confirmSignUp"
                            }
                        }
                    }
                }
            },
            confirmSignUp: {
                initial: "edit",
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            BLUR: {
                                actions: "handleBlur"
                            },
                            RESEND: "resend"
                        }
                    },
                    resend: {
                        tags: [
                            "pending"
                        ],
                        entry: "sendUpdate",
                        invoke: {
                            src: "resendConfirmationCode",
                            onDone: {
                                target: "edit"
                            },
                            onError: [
                                {
                                    target: "#signUpActor.resolved",
                                    actions: "setAutoSignInIntent",
                                    cond: "isUserAlreadyConfirmed"
                                },
                                {
                                    target: "edit",
                                    actions: "setRemoteError"
                                }
                            ]
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "sendUpdate",
                            "clearError"
                        ],
                        invoke: {
                            src: "confirmSignUp",
                            onDone: {
                                target: "#signUpActor.resolved",
                                actions: "setAutoSignInIntent"
                            },
                            onError: {
                                target: "edit",
                                actions: "setRemoteError"
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: (e, t)=>{
                    const { username: r, password: i } = e.authAttributes;
                    return {
                        user: (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(t, "data.user") || e.user,
                        authAttributes: {
                            username: r,
                            password: i
                        },
                        intent: e.intent
                    };
                }
            }
        }
    }, {
        guards: {
            isUserAlreadyConfirmed: (e, t)=>"User is already confirmed." === t.data.message,
            shouldInitConfirmSignUp: (e)=>e.intent && "confirmSignUp" === e.intent,
            shouldSkipConfirm: (e, t)=>t.data.userConfirmed
        },
        actions: {
            clearError: (0, $28623b45b974975c$export$a15ba4bdf59dacc9),
            clearFormValues: (0, $28623b45b974975c$export$bfa16614c507dc4b),
            clearTouched: (0, $28623b45b974975c$export$c459b227ec8b5bb),
            clearValidationError: (0, $28623b45b974975c$export$5270f204082eebfb),
            handleInput: (0, $28623b45b974975c$export$412508d679148d5c),
            handleSubmit: (0, $28623b45b974975c$export$89c2621768820c8b),
            handleBlur: (0, $28623b45b974975c$export$27d5d91e7417534c),
            parsePhoneNumber: (0, $28623b45b974975c$export$da44e4eaa54bc82e),
            setCredentials: (0, $28623b45b974975c$export$3a6cdb4d139acb5f),
            setFieldErrors: (0, $28623b45b974975c$export$6c79f1f160aff8ba),
            setRemoteError: (0, $28623b45b974975c$export$a6a2df750d905c59),
            setCodeDeliveryDetails: (0, $28623b45b974975c$export$f9df8f75fe67ab58),
            setUser: (0, $28623b45b974975c$export$8b6bb3dd62a01be2),
            sendUpdate: (0, $9cec7b12efdda519$export$7f8b724299523eb6)(),
            setAutoSignInIntent: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                intent: (e)=>"confirmSignUp" === (null == e ? void 0 : e.intent) ? "autoSignInSubmit" : "autoSignIn"
            })
        },
        services: {
            confirmSignUp (t, r) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { user: e, authAttributes: r, formValues: i } = t, { confirmation_code: a } = i, s = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(e, "username") || (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(r, "username");
                    return yield y.handleConfirmSignUp({
                        username: s,
                        code: a
                    });
                });
            },
            resendConfirmationCode (r, i) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { user: e, authAttributes: i } = r, a = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(e, "username") || (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(i, "username");
                    return (0, $cc420cb14b670b2a$export$334c29725a78c21d).resendSignUp(a);
                });
            },
            federatedSignIn (n, r) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { provider: e } = r.data;
                    return yield (0, $cc420cb14b670b2a$export$334c29725a78c21d).federatedSignIn({
                        provider: e
                    });
                });
            },
            signUp (t, n) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    const { formValues: e, loginMechanisms: n } = t, [i = "username"] = n, { [i]: a, password: s } = e, o = (0, (/*@__PURE__*/$parcel$interopDefault($9b6d46093811e2aa$exports)))(e, (e, t)=>{
                        switch(t){
                            case "address":
                            case "birthdate":
                            case "email":
                            case "family_name":
                            case "gender":
                            case "given_name":
                            case "locale":
                            case "middle_name":
                            case "name":
                            case "nickname":
                            case "phone_number":
                            case "picture":
                            case "preferred_username":
                            case "profile":
                            case "updated_at":
                            case "website":
                            case "zoneinfo":
                                return !0;
                            default:
                                return t.startsWith("custom:");
                        }
                    });
                    return yield y.handleSignUp({
                        username: a,
                        password: s,
                        attributes: o
                    });
                });
            },
            validateSignUp (t, n) {
                return (0, $2a754a1c7faca113$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    return (0, $d2d621530b694cb3$export$59e2b39f02edfada)(t.formValues, t.touched, t.passwordSettings, [
                        y.validateFormPassword,
                        y.validateConfirmPassword,
                        y.validatePreferredUsername,
                        y.validateCustomSignUp
                    ]);
                });
            }
        }
    });
}


const { choose: $61ccbb2c6dbc6806$var$g } = (0, $ab1fe168d053d080$exports);
function $61ccbb2c6dbc6806$export$af98f08c6e0e0d4d() {
    return (0, $c9f97204c6723ccf$export$aaa7fa18f8e9b2e8)({
        id: "authenticator",
        initial: "idle",
        context: {
            user: void 0,
            config: {},
            services: (0, $3026204c9959d254$export$7ae2d201ca9520b),
            actorRef: void 0,
            hasSetup: !1
        },
        predictableActionArguments: !0,
        states: {
            idle: {
                invoke: {
                    src: "getCurrentUser",
                    onDone: {
                        actions: "setUser",
                        target: "authenticated"
                    },
                    onError: {
                        target: "setup"
                    }
                }
            },
            setup: {
                initial: "waitConfig",
                states: {
                    waitConfig: {
                        on: {
                            INIT: {
                                actions: [
                                    "configure",
                                    "setHasSetup"
                                ],
                                target: "applyConfig"
                            }
                        }
                    },
                    applyConfig: {
                        invoke: {
                            src: "getAmplifyConfig",
                            onDone: {
                                actions: "applyAmplifyConfig",
                                target: "goToInitialState"
                            }
                        }
                    },
                    goToInitialState: {
                        always: [
                            {
                                target: "#authenticator.signUp",
                                cond: "isInitialStateSignUp"
                            },
                            {
                                target: "#authenticator.resetPassword",
                                cond: "isInitialStateResetPassword"
                            },
                            {
                                target: "#authenticator.signIn"
                            }
                        ]
                    }
                }
            },
            signIn: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignInActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: "stopSignInActor"
                    }
                },
                on: {
                    SIGN_UP: "signUp",
                    RESET_PASSWORD: "resetPassword",
                    "done.invoke.signInActor": [
                        {
                            target: "signUp",
                            actions: "setActorDoneData",
                            cond: "shouldRedirectToSignUp"
                        },
                        {
                            target: "resetPassword",
                            actions: "setActorDoneData",
                            cond: "shouldRedirectToResetPassword"
                        },
                        {
                            target: "authenticated",
                            actions: "setActorDoneData"
                        }
                    ]
                }
            },
            signUp: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignUpActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: "stopSignUpActor"
                    },
                    autoSignIn: {
                        invoke: {
                            src: "getCurrentUser",
                            onDone: "#authenticator.authenticated",
                            onError: "#authenticator.setup.goToInitialState"
                        }
                    }
                },
                on: {
                    SIGN_IN: "signIn",
                    "done.invoke.signUpActor": {
                        target: "#authenticator.signIn",
                        actions: "setActorDoneData",
                        cond: "shouldAutoSignIn"
                    }
                }
            },
            resetPassword: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnResetPasswordActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: "stopResetPasswordActor"
                    }
                },
                on: {
                    SIGN_IN: "signIn",
                    "done.invoke.resetPasswordActor": {
                        target: "signIn",
                        actions: "setActorDoneData"
                    }
                }
            },
            signOut: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignOutActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: [
                            "stopSignOutActor",
                            "clearUser"
                        ]
                    }
                },
                on: {
                    "done.invoke.signOutActor": [
                        {
                            target: "setup",
                            cond: "shouldSetup"
                        },
                        {
                            target: "setup.goToInitialState"
                        }
                    ]
                }
            },
            authenticated: {
                initial: "idle",
                states: {
                    idle: {
                        on: {
                            TOKEN_REFRESH: "refreshUser"
                        }
                    },
                    refreshUser: {
                        invoke: {
                            src: "getCurrentUser",
                            onDone: {
                                actions: "setUser",
                                target: "idle"
                            },
                            onError: {
                                target: "#authenticator.signOut"
                            }
                        }
                    }
                },
                on: {
                    SIGN_OUT: "signOut"
                }
            }
        },
        on: {
            CHANGE: {
                actions: "forwardToActor"
            },
            BLUR: {
                actions: "forwardToActor"
            },
            SUBMIT: {
                actions: "forwardToActor"
            },
            FEDERATED_SIGN_IN: {
                actions: "forwardToActor"
            },
            AUTO_SIGN_IN: {
                actions: "forwardToActor"
            },
            RESEND: {
                actions: "forwardToActor"
            },
            SIGN_IN: {
                actions: "forwardToActor"
            },
            SKIP: {
                actions: "forwardToActor"
            }
        }
    }, {
        actions: {
            forwardToActor: $61ccbb2c6dbc6806$var$g([
                {
                    cond: "hasActor",
                    actions: (0, $9cec7b12efdda519$export$eb147b7589db8e8a)((t)=>t.actorRef)
                }
            ]),
            setUser: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                user: (t, o)=>o.data
            }),
            setActorDoneData: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                actorDoneData: (t, o)=>{
                    var i, n;
                    return {
                        authAttributes: Object.assign({}, null === (i = o.data) || void 0 === i ? void 0 : i.authAttributes),
                        intent: null === (n = o.data) || void 0 === n ? void 0 : n.intent
                    };
                },
                user: (t, o)=>{
                    var i;
                    return null === (i = o.data) || void 0 === i ? void 0 : i.user;
                }
            }),
            clearUser: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                user: void 0
            }),
            clearActorDoneData: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                actorDoneData: void 0
            }),
            applyAmplifyConfig: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                config (t, o) {
                    var i, n, e, r, s, a, c, d, u;
                    const l = null !== (n = null === (i = o.data.aws_cognito_username_attributes) || void 0 === i ? void 0 : i.map((t)=>t.toLowerCase())) && void 0 !== n ? n : [], g = null !== (r = null === (e = o.data.aws_cognito_verification_mechanisms) || void 0 === e ? void 0 : e.map((t)=>t.toLowerCase())) && void 0 !== r ? r : [], v = null !== (a = null === (s = o.data.aws_cognito_signup_attributes) || void 0 === s ? void 0 : s.map((t)=>t.toLowerCase())) && void 0 !== a ? a : [], A = null !== (d = null === (c = o.data.aws_cognito_social_providers) || void 0 === c ? void 0 : c.map((t)=>t.toLowerCase())) && void 0 !== d ? d : [], f = o.data.aws_cognito_password_protection_settings || {};
                    0 === l.length && l.push("username");
                    const { loginMechanisms: w, signUpAttributes: S, socialProviders: m, initialState: h, formFields: D } = t.config;
                    return {
                        loginMechanisms: null != w ? w : l,
                        formFields: null !== (u = $61ccbb2c6dbc6806$var$p(D)) && void 0 !== u ? u : {},
                        passwordSettings: f,
                        signUpAttributes: null != S ? S : Array.from(new Set([
                            ...g,
                            ...v
                        ])),
                        socialProviders: null != m ? m : A.sort(),
                        initialState: h
                    };
                }
            }),
            spawnSignInActor: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                actorRef: (t, o)=>{
                    var i, n, r, s, c, d, u;
                    const { services: l } = t, g = (0, $3003bbb4a9472e63$export$f9c30eaa77191700)({
                        services: l
                    }).withContext({
                        authAttributes: null !== (n = null === (i = t.actorDoneData) || void 0 === i ? void 0 : i.authAttributes) && void 0 !== n ? n : {},
                        user: t.user,
                        intent: null === (r = t.actorDoneData) || void 0 === r ? void 0 : r.intent,
                        country_code: "+1",
                        formValues: {},
                        touched: {},
                        validationError: {},
                        passwordSettings: null === (s = t.config) || void 0 === s ? void 0 : s.passwordSettings,
                        loginMechanisms: null === (c = t.config) || void 0 === c ? void 0 : c.loginMechanisms,
                        socialProviders: null === (d = t.config) || void 0 === d ? void 0 : d.socialProviders,
                        formFields: null === (u = t.config) || void 0 === u ? void 0 : u.formFields
                    });
                    return (0, $9ab7fd156e8ddce7$export$1713f5ac2bf0caf5)(g, {
                        name: "signInActor"
                    });
                }
            }),
            spawnSignUpActor: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                actorRef: (t, o)=>{
                    var i, n, r, s, a, c, d;
                    const { services: u } = t, g = (0, $b3c0e468c114dbfa$export$a5c4b20d9017fce9)({
                        services: u
                    }).withContext({
                        authAttributes: null !== (n = null === (i = t.actorDoneData) || void 0 === i ? void 0 : i.authAttributes) && void 0 !== n ? n : {},
                        country_code: "+1",
                        intent: null === (r = t.actorDoneData) || void 0 === r ? void 0 : r.intent,
                        formValues: {},
                        touched: {},
                        validationError: {},
                        loginMechanisms: null === (s = t.config) || void 0 === s ? void 0 : s.loginMechanisms,
                        socialProviders: null === (a = t.config) || void 0 === a ? void 0 : a.socialProviders,
                        formFields: null === (c = t.config) || void 0 === c ? void 0 : c.formFields,
                        passwordSettings: null === (d = t.config) || void 0 === d ? void 0 : d.passwordSettings
                    });
                    return (0, $9ab7fd156e8ddce7$export$1713f5ac2bf0caf5)(g, {
                        name: "signUpActor"
                    });
                }
            }),
            spawnResetPasswordActor: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                actorRef: (t, o)=>{
                    var i, n, r, s, a;
                    const { services: c } = t, u = (0, $d0d2bcbecc78f3ca$export$9e01526a2f4b3199)({
                        services: c
                    }).withContext({
                        formValues: {},
                        touched: {},
                        intent: null === (i = t.actorDoneData) || void 0 === i ? void 0 : i.intent,
                        username: null === (r = null === (n = t.actorDoneData) || void 0 === n ? void 0 : n.authAttributes) || void 0 === r ? void 0 : r.username,
                        formFields: null === (s = t.config) || void 0 === s ? void 0 : s.formFields,
                        validationError: {},
                        passwordSettings: null === (a = t.config) || void 0 === a ? void 0 : a.passwordSettings
                    });
                    return (0, $9ab7fd156e8ddce7$export$1713f5ac2bf0caf5)(u, {
                        name: "resetPasswordActor"
                    });
                }
            }),
            spawnSignOutActor: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                actorRef: (t)=>{
                    const o = (0, $b61db1507db42ffb$export$2f15f45f1f7b7787).withContext({
                        user: t.user
                    });
                    return (0, $9ab7fd156e8ddce7$export$1713f5ac2bf0caf5)(o, {
                        name: "signOutActor"
                    });
                }
            }),
            stopSignInActor: (0, $28623b45b974975c$export$b6947cfc708251b6)("signInActor"),
            stopSignUpActor: (0, $28623b45b974975c$export$b6947cfc708251b6)("signUpActor"),
            stopResetPasswordActor: (0, $28623b45b974975c$export$b6947cfc708251b6)("resetPasswordActor"),
            stopSignOutActor: (0, $28623b45b974975c$export$b6947cfc708251b6)("signOutActor"),
            configure: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)((o, i)=>{
                const n = i.data, { services: e } = n, r = (0, $2a754a1c7faca113$export$3c9a16f847548506)(n, [
                    "services"
                ]);
                return {
                    services: Object.assign(Object.assign({}, (0, $3026204c9959d254$export$7ae2d201ca9520b)), e),
                    config: r
                };
            }),
            setHasSetup: (0, $9cec7b12efdda519$export$e6e34fd1f2686227)({
                hasSetup: !0
            })
        },
        guards: {
            isInitialStateSignUp: (t)=>"signUp" === t.config.initialState,
            isInitialStateResetPassword: (t)=>"resetPassword" === t.config.initialState,
            shouldRedirectToSignUp: (t, o)=>{
                var i;
                return "confirmSignUp" === (null === (i = o.data) || void 0 === i ? void 0 : i.intent);
            },
            shouldRedirectToResetPassword: (t, o)=>{
                var i;
                return "confirmPasswordReset" === (null === (i = o.data) || void 0 === i ? void 0 : i.intent);
            },
            shouldAutoSignIn: (t, o)=>{
                var i, n;
                return "autoSignIn" === (null === (i = o.data) || void 0 === i ? void 0 : i.intent) || "autoSignInSubmit" === (null === (n = o.data) || void 0 === n ? void 0 : n.intent);
            },
            shouldSetup: (t)=>!1 === t.hasSetup,
            hasActor: (t)=>!!t.actorRef
        },
        services: {
            getCurrentUser: (t, o)=>t.services.getCurrentUser(),
            getAmplifyConfig: (t, o)=>t.services.getAmplifyConfig()
        }
    });
}
function $61ccbb2c6dbc6806$var$p(t) {
    return t && Object.keys(t).forEach((o)=>{
        Object.keys(t[o]).forEach((i)=>{
            let n = t[o][i];
            n.required = n.isRequired;
        });
    }), t;
}



const $cce185cc40fefbe8$var$createHubHandler = (options)=>(data, service)=>(0, $41adf626f46b9a45$export$1050f835b63b671e)(void 0, void 0, void 0, function*() {
            yield (0, $9ad1914df4b6fe69$export$f726708373635d8a)(data, service, options);
        });
function $cce185cc40fefbe8$export$2e2bcd8739ae039({ children: children }) {
    // `authStatus` is exposed by `useAuthenticator` but should not be derived directly from the
    // state machine as the machine only updates on `Authenticator` initiated events, which
    // leads to scenarios where the state machine `authStatus` gets "stuck". For exmample,
    // if a user was to sign in using `Auth.signIn` directly rather than using `Authenticator`
    const [authStatus, setAuthStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("configuring");
    // only run on first render
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (0, $cc420cb14b670b2a$export$334c29725a78c21d).currentAuthenticatedUser().then(()=>{
            setAuthStatus("authenticated");
        }).catch(()=>{
            setAuthStatus("unauthenticated");
        });
    }, []);
    /**
     * Based on use cases, developer might already have added another Provider
     * outside Authenticator. In that case, we sync the two providers by just
     * passing the parent value.
     *
     * TODO(BREAKING): enforce only one provider in App tree
     */ const parentProviderVal = (0, $acw62.useContext)((0, $cde51257bc807626$export$2254a7bd02a5abf7));
    const service = (0, $7999b7c62f1eeee0$exports.useInterpret)((0, $61ccbb2c6dbc6806$export$af98f08c6e0e0d4d));
    const value = (0, $acw62.useMemo)(()=>!parentProviderVal ? {
            authStatus: authStatus,
            service: service
        } : parentProviderVal, [
        authStatus,
        parentProviderVal,
        service
    ]);
    const { service: activeService } = value;
    (0, $acw62.useEffect)(()=>{
        const onSignIn = ()=>{
            setAuthStatus("authenticated");
        };
        const onSignOut = ()=>{
            setAuthStatus("unauthenticated");
        };
        const unsubscribe = (0, $9ad1914df4b6fe69$export$4776c363cae9362c)(activeService, $cce185cc40fefbe8$var$createHubHandler({
            onSignIn: onSignIn,
            onSignOut: onSignOut
        }));
        return unsubscribe;
    }, [
        activeService
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cde51257bc807626$export$2254a7bd02a5abf7).Provider, {
        value: value
    }, children);
}


var $acw62 = parcelRequire("acw62");

// only select `route` from machine context
const $9386158d06477018$export$55f632bbdf6d0e4 = ({ route: route })=>[
        route
    ];
function $9386158d06477018$export$2e2bcd8739ae039(data) {
    const { route: route, initializeMachine: initializeMachine } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)($9386158d06477018$export$55f632bbdf6d0e4);
    const hasInitialized = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!hasInitialized.current && route === "setup") {
            initializeMachine(data);
            hasInitialized.current = true;
        }
    }, [
        initializeMachine,
        route,
        data
    ]);
}


const $5423b34164054b36$export$a4ad2735b021c132 = "5.3.0";



var $acw62 = parcelRequire("acw62");
/**
 * Logs a deprecation warning message.
 *
 * @important Please use the React/React Native specific platform implementations.
 * This version of the hook is a base implementation that the others extend from due
 * to env differences between running in RN or the browser
 */ const $58f9d037789fef06$export$2e2bcd8739ae039 = ({ shouldWarn: shouldWarn, message: message })=>{
    $acw62.useEffect(()=>{
        if (shouldWarn) // eslint-disable-next-line no-console
        console.warn(message);
    }, [
        shouldWarn,
        message
    ]);
};



const $6a7b590023baed18$export$406e4c8585b97b03 = ({ message: s, shouldWarn: o })=>{
    const r = o && ("undefined" == typeof $cfae44f0dfdf62c0$exports || $cfae44f0dfdf62c0$exports && false);
    (0, $58f9d037789fef06$export$2e2bcd8739ae039)({
        message: s,
        shouldWarn: r
    });
};



var $acw62 = parcelRequire("acw62");
const $34076cf41c51978d$export$da5ac45a736a5880 = $acw62.createContext(null), $34076cf41c51978d$export$b0e9d19f717d0a5c = ()=>{
    const e = $acw62.useContext($34076cf41c51978d$export$da5ac45a736a5880);
    if (!e) throw new Error("`useCustomComponents` cannot be used outside of a `CustomComponentsContext.Provider`");
    return e;
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

const $76a2c3bc206f31bd$var$T = {
    amazon: "Amazon",
    apple: "Apple",
    facebook: "Facebook",
    google: "Google"
}, $76a2c3bc206f31bd$export$34e9c32aebe14fbb = {
    getBackToSignInText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).BACK_SIGN_IN),
    getChangePasswordText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CHANGE_PASSWORD),
    getChangingText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CHANGING_PASSWORD),
    getConfirmText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CONFIRM),
    getConfirmingText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CONFIRMING),
    getCopyText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).UPPERCASE_COPY),
    getHidePasswordText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).HIDE_PASSWORD),
    getLoadingText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).LOADING),
    getOrText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).OR),
    getResendCodeText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).RESEND_CODE),
    getSendCodeText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).SEND_CODE),
    getSendingText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).SENDING),
    getShowPasswordText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).SHOW_PASSWORD),
    getSubmitText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).SUBMIT),
    getSubmittingText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).SUBMITTING),
    getSignInTabText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).SIGN_IN_TAB),
    getSignUpTabText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CREATE_ACCOUNT),
    getForgotPasswordText: (T)=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)(T ? (0, $237c4f1f3df38a24$export$6ba37fd455cdd594).FORGOT_PASSWORD : (0, $237c4f1f3df38a24$export$6ba37fd455cdd594).FORGOT_YOUR_PASSWORD),
    getSigningInText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).SIGNING_IN_BUTTON),
    getSignInText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).SIGN_IN_BUTTON),
    getCreatingAccountText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CREATING_ACCOUNT),
    getCreateAccountText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CREATE_ACCOUNT),
    getDeliveryMessageText: (T)=>{
        const { DeliveryMedium: n, Destination: g } = null != T ? T : {}, i = "EMAIL" === n, S = "SMS" === n, o = (0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CODE_ARRIVAL);
        if (!i && !S) return `${(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CODE_SENT)}. ${o}.`;
        return `${(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)(i ? (0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CODE_EMAILED : (0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CODE_TEXTED)} ${g}. ${o}.`;
    },
    getDeliveryMethodText: (T)=>{
        const { DeliveryMedium: n } = null != T ? T : {}, g = "EMAIL" === n;
        return (0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)(g || "SMS" !== n ? g ? (0, $237c4f1f3df38a24$export$6ba37fd455cdd594).WE_EMAILED : (0, $237c4f1f3df38a24$export$6ba37fd455cdd594).WE_TEXTED : (0, $237c4f1f3df38a24$export$6ba37fd455cdd594).WE_SENT_CODE);
    },
    getChallengeText: (T)=>{
        switch(T){
            case "SMS_MFA":
                return (0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CONFIRM_SMS);
            case "SOFTWARE_TOKEN_MFA":
                return (0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).CONFIRM_TOTP);
            default:
                throw new Error(`${(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)("Unexpected challengeName encountered in ConfirmSignIn:")} ${T}`);
        }
    },
    getResetYourPasswordText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).RESET_PASSWORD),
    getSetupTOTPText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).SETUP_TOTP),
    getSetupTOTPInstructionsText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)("Copy and paste the secret key below into an authenticator app and then enter the code in the text field below."),
    getCopiedText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)("COPIED"),
    getSignInWithFederationText: (t, n)=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)(`Sign ${"signIn" === t ? "In" : "Up"} with ${$76a2c3bc206f31bd$var$T[n]}`),
    getSkipText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).SKIP),
    getVerifyText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).VERIFY),
    getVerifyContactText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).VERIFY_CONTACT),
    getAccountRecoveryInfoText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)((0, $237c4f1f3df38a24$export$6ba37fd455cdd594).VERIFY_HEADING),
    getInvalidEmailText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)("Please enter a valid email"),
    getRequiredFieldText: ()=>(0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)("This field is required")
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $6bbabf3c01bf9470$var$extendStatics = function(d, b) {
    $6bbabf3c01bf9470$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $6bbabf3c01bf9470$var$extendStatics(d, b);
};
function $6bbabf3c01bf9470$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $6bbabf3c01bf9470$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6bbabf3c01bf9470$export$18ce0697a983be9b = function() {
    $6bbabf3c01bf9470$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6bbabf3c01bf9470$export$18ce0697a983be9b.apply(this, arguments);
};
function $6bbabf3c01bf9470$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6bbabf3c01bf9470$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6bbabf3c01bf9470$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6bbabf3c01bf9470$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6bbabf3c01bf9470$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6bbabf3c01bf9470$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $6bbabf3c01bf9470$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $6bbabf3c01bf9470$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $6bbabf3c01bf9470$export$45d3717a4c69092e(o, m, p);
}
function $6bbabf3c01bf9470$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6bbabf3c01bf9470$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6bbabf3c01bf9470$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6bbabf3c01bf9470$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6bbabf3c01bf9470$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6bbabf3c01bf9470$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $6bbabf3c01bf9470$export$10c90e4f7922046c(v) {
    return this instanceof $6bbabf3c01bf9470$export$10c90e4f7922046c ? (this.v = v, this) : new $6bbabf3c01bf9470$export$10c90e4f7922046c(v);
}
function $6bbabf3c01bf9470$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6bbabf3c01bf9470$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6bbabf3c01bf9470$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6bbabf3c01bf9470$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $6bbabf3c01bf9470$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6bbabf3c01bf9470$export$19a8beecd37a4c45 === "function" ? $6bbabf3c01bf9470$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6bbabf3c01bf9470$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $6bbabf3c01bf9470$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $6bbabf3c01bf9470$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6bbabf3c01bf9470$export$45d3717a4c69092e(result, mod, k);
    }
    $6bbabf3c01bf9470$var$__setModuleDefault(result, mod);
    return result;
}
function $6bbabf3c01bf9470$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6bbabf3c01bf9470$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $6bbabf3c01bf9470$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $6bbabf3c01bf9470$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


var $2e2104fc51777f8c$exports = {};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, $2e2104fc51777f8c$exports) {
        classNames.default = classNames;
        $2e2104fc51777f8c$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $acw62 = parcelRequire("acw62");

var $53f428d35a39841a$export$a5e41a4bc3f9b1d6;
!function(e) {
    e.Alert = "amplify-alert", e.AlertIcon = "amplify-alert__icon", e.AlertHeading = "amplify-alert__heading", e.AlertBody = "amplify-alert__body", e.AlertDismiss = "amplify-alert__dismiss", e.Autocomplete = "amplify-autocomplete", e.AutocompleteMenu = "amplify-autocomplete__menu", e.AutocompleteMenuEmpty = "amplify-autocomplete__menu--empty", e.AutocompleteMenuFooter = "amplify-autocomplete__menu__footer", e.AutocompleteMenuHeader = "amplify-autocomplete__menu__header", e.AutocompleteMenuLoading = "amplify-autocomplete__menu--loading", e.AutocompleteMenuOption = "amplify-autocomplete__menu__option", e.AutocompleteMenuOptions = "amplify-autocomplete__menu__options", e.Badge = "amplify-badge", e.Breadcrumbs = "amplify-breadcrumbs", e.BreadcrumbsList = "amplify-breadcrumbs__list", e.BreadcrumbsItem = "amplify-breadcrumbs__item", e.BreadcrumbsSeparator = "amplify-breadcrumbs__separator", e.BreadcrumbsLink = "amplify-breadcrumbs__link", e.Button = "amplify-button", e.ButtonGroup = "amplify-buttongroup", e.ButtonLoaderWrapper = "amplify-button__loader-wrapper", e.Card = "amplify-card", e.Checkbox = "amplify-checkbox", e.CheckboxButton = "amplify-checkbox__button", e.CheckboxIcon = "amplify-checkbox__icon", e.CheckboxInput = "amplify-checkbox__input", e.CheckboxLabel = "amplify-checkbox__label", e.CheckboxField = "amplify-checkboxfield", e.Collection = "amplify-collection", e.CollectionItems = "amplify-collection-items", e.CollectionSearch = "amplify-collection-search", e.CollectionPagination = "amplify-collection-pagination", e.CountryCodeSelect = "amplify-countrycodeselect", e.DialCodeSelect = "amplify-dialcodeselect", e.Divider = "amplify-divider", e.DividerLabel = "amplify-divider--label", e.DropZone = "amplify-dropzone", e.Expander = "amplify-expander", e.ExpanderContent = "amplify-expander__content", e.ExpanderContentText = "amplify-expander__content__text", e.ExpanderHeader = "amplify-expander__header", e.ExpanderIcon = "amplify-expander__icon", e.ExpanderItem = "amplify-expander__item", e.ExpanderTrigger = "amplify-expander__trigger", e.Field = "amplify-field", e.FieldDescription = "amplify-field__description", e.FieldErrorMessage = "amplify-field__error-message", e.FieldGroup = "amplify-field-group", e.FieldGroupControl = "amplify-field-group__control", e.FieldGroupOuterEnd = "amplify-field-group__outer-end", e.FieldGroupOuterStart = "amplify-field-group__outer-start", e.FieldGroupInnerEnd = "amplify-field-group__inner-end", e.FieldGroupInnerStart = "amplify-field-group__inner-start", e.FieldGroupIcon = "amplify-field-group__icon", e.FieldGroupIconButton = "amplify-field-group__icon-button", e.FieldGroupHasInnerEnd = "amplify-field-group--has-inner-end", e.FieldGroupHasInnerStart = "amplify-field-group--has-inner-start", e.FieldShowPassword = "amplify-field__show-password", e.FieldGroupFieldWrapper = "amplify-field-group__field-wrapper", e.Fieldset = "amplify-fieldset", e.FieldsetLegend = "amplify-fieldset__legend", e.FileUploaderDropZone = "amplify-fileuploader__dropzone", e.FileUploaderDropZoneIcon = "amplify-fileuploader__dropzone__icon", e.FileUploaderDropZoneText = "amplify-fileuploader__dropzone__text", e.FileUploaderDropZoneButton = "amplify-fileuploader__dropzone__button", e.FileUploaderFile = "amplify-fileuploader__file", e.FileUploaderFileWrapper = "amplify-fileuploader__file__wrapper", e.FileUploaderFileName = "amplify-fileuploader__file__name", e.FileUploaderFileSize = "amplify-fileuploader__file__size", e.FileUploaderFileInfo = "amplify-fileuploader__file__info", e.FileUploaderFileImage = "amplify-fileuploader__file__image", e.FileUploaderFileMain = "amplify-fileuploader__file__main", e.FileUploaderFileStatus = "amplify-fileuploader__file__status", e.FileUploaderLoader = "amplify-fileuploader__loader", e.FileUploaderPreviewer = "amplify-fileuploader__previewer", e.FileUploaderPreviewerText = "amplify-fileuploader__previewer__text", e.FileUploaderPreviewerBody = "amplify-fileuploader__previewer__body", e.FileUploaderPreviewerFooter = "amplify-fileuploader__previewer__footer", e.FileUploaderPreviewerFooterActions = "amplify-fileuploader__previewer__footer__actions", e.Flex = "amplify-flex", e.Grid = "amplify-grid", e.Heading = "amplify-heading", e.HighlightMatch = "amplify-highlightmatch", e.HighlightMatchHighlighted = "amplify-highlightmatch__highlighted", e.Icon = "amplify-icon", e.Image = "amplify-image", e.Input = "amplify-input", e.Label = "amplify-label", e.Link = "amplify-link", e.Loader = "amplify-loader", e.LoaderDeterminate = "amplify-loader--determinate", e.LoaderPercentageText = "amplify-loader__percentage-text", e.MenuContent = "amplify-menu-content", e.MenuContentWrapper = "amplify-menu-content-wrapper", e.MenuItem = "amplify-menu-content__item", e.MenuTrigger = "amplify-menu-trigger", e.Message = "amplify-message", e.MessageIcon = "amplify-message__icon", e.MessageHeading = "amplify-message__heading", e.MessageBody = "amplify-message__body", e.MessageContent = "amplify-message__content", e.MessageDismiss = "amplify-message__dismiss", e.Pagination = "amplify-pagination", e.PaginationItemButton = "amplify-pagination__item-button", e.PaginationItemCurrent = "amplify-pagination__item-current", e.PaginationItemEllipsis = "amplify-pagination__item-ellipsis", e.PasswordField = "amplify-passwordfield", e.PhoneNumberField = "amplify-phonenumberfield", e.Placeholder = "amplify-placeholder", e.Radio = "amplify-radio", e.RadioButton = "amplify-radio__button", e.RadioInput = "amplify-radio__input", e.RadioLabel = "amplify-radio__label", e.RadioGroupField = "amplify-radiogroupfield", e.RadioGroup = "amplify-radiogroup", e.Rating = "amplify-rating", e.ScrollView = "amplify-scrollview", e.SearchField = "amplify-searchfield", e.SearchFieldClear = "amplify-searchfield__clear", e.SearchFieldSearch = "amplify-searchfield__search", e.Select = "amplify-select", e.SelectField = "amplify-selectfield", e.SelectWrapper = "amplify-select__wrapper", e.SelectIconWrapper = "amplify-select__icon-wrapper", e.SliderField = "amplify-sliderfield", e.SliderFieldGroup = "amplify-sliderfield__group", e.SliderFieldLabel = "amplify-sliderfield__label", e.SliderFieldRange = "amplify-sliderfield__range", e.SliderFieldRoot = "amplify-sliderfield__root", e.SliderFieldThumb = "amplify-sliderfield__thumb", e.SliderFieldTrack = "amplify-sliderfield__track", e.StepperField = "amplify-stepperfield", e.StepperFieldButtonDecrease = "amplify-stepperfield__button--decrease", e.StepperFieldButtonIncrease = "amplify-stepperfield__button--increase", e.StepperFieldInput = "amplify-stepperfield__input", e.StorageImage = "amplify-storageimage", e.StorageManager = "amplify-storagemanager", e.StorageManagerDropZone = "amplify-storagemanager__dropzone", e.StorageManagerDropZoneIcon = "amplify-storagemanager__dropzone__icon", e.StorageManagerDropZoneText = "amplify-storagemanager__dropzone__text", e.StorageManagerFilePicker = "amplify-storagemanager__file__picker", e.StorageManagerFile = "amplify-storagemanager__file", e.StorageManagerFileWrapper = "amplify-storagemanager__file__wrapper", e.StorageManagerFileList = "amplify-storagemanager__file__list", e.StorageManagerFileName = "amplify-storagemanager__file__name", e.StorageManagerFileSize = "amplify-storagemanager__file__size", e.StorageManagerFileInfo = "amplify-storagemanager__file__info", e.StorageManagerFileImage = "amplify-storagemanager__file__image", e.StorageManagerFileMain = "amplify-storagemanager__file__main", e.StorageManagerFileStatus = "amplify-storagemanager__file__status", e.StorageManagerLoader = "amplify-storagemanager__loader", e.StorageManagerPreviewer = "amplify-storagemanager__previewer", e.StorageManagerPreviewerText = "amplify-storagemanager__previewer__text", e.StorageManagerPreviewerActions = "amplify-storagemanager__previewer__actions", e.StorageManagerPreviewerFooter = "amplify-storagemanager__previewer__footer", e.SwitchField = "amplify-switchfield", e.SwitchLabel = "amplify-switch-label", e.SwitchThumb = "amplify-switch-thumb", e.SwitchTrack = "amplify-switch-track", e.SwitchWrapper = "amplify-switch__wrapper", e.Table = "amplify-table", e.TableCaption = "amplify-table__caption", e.TableBody = "amplify-table__body", e.TableTd = "amplify-table__td", e.TableTh = "amplify-table__th", e.TableFoot = "amplify-table__foot", e.TableHead = "amplify-table__head", e.TableRow = "amplify-table__row", e.Tabs = "amplify-tabs", e.TabItems = "amplify-tabs-item", e.Text = "amplify-text", e.Textarea = "amplify-textarea", e.TextAreaField = "amplify-textareafield", e.TextField = "amplify-textfield", e.ToggleButton = "amplify-togglebutton", e.ToggleButtonGroup = "amplify-togglebuttongroup", e.VisuallyHidden = "amplify-visually-hidden";
}($53f428d35a39841a$export$a5e41a4bc3f9b1d6 || ($53f428d35a39841a$export$a5e41a4bc3f9b1d6 = {}));


const $ca5815d75ab8dc16$export$d520e33dec8f4319 = {
    Alert: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Alert,
        components: [
            "Alert"
        ],
        description: "Top level element that wraps the Alert primitive"
    },
    AlertIcon: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).AlertIcon,
        components: [
            "Alert"
        ],
        description: "Class applied to Icon component within the Alert primitive"
    },
    AlertHeading: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).AlertHeading,
        components: [
            "Alert"
        ],
        description: "Class applied to the heading View"
    },
    AlertBody: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).AlertBody,
        components: [
            "Alert"
        ],
        description: "Class applied to the body View"
    },
    AlertDismiss: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).AlertDismiss,
        components: [
            "Alert"
        ],
        description: "Class applied to the close Button"
    },
    Autocomplete: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Autocomplete,
        components: [
            "Autocomplete"
        ],
        description: "Top level element that wraps the Autocomplete primitive"
    },
    AutocompleteMenu: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).AutocompleteMenu,
        components: [
            "Autocomplete"
        ],
        description: "Top level element that wraps the dropdown menu"
    },
    AutocompleteMenuEmpty: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).AutocompleteMenuEmpty,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to the no options slot of menu"
    },
    AutocompleteMenuFooter: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).AutocompleteMenuFooter,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to menu footer"
    },
    AutocompleteMenuHeader: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).AutocompleteMenuHeader,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to menu header"
    },
    AutocompleteMenuLoading: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).AutocompleteMenuLoading,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to the loading slot of menu"
    },
    AutocompleteMenuOption: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).AutocompleteMenuOption,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to each li option"
    },
    AutocompleteMenuOptions: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).AutocompleteMenuOptions,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to ul container element"
    },
    Badge: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Badge,
        components: [
            "Badge"
        ],
        description: "Top level element that wraps the Badge component"
    },
    Breadcrumbs: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Breadcrumbs,
        components: [
            "Breadcrumbs"
        ],
        description: "Top level element that wraps the Breadcrumbs component"
    },
    BreadcrumbsItem: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).BreadcrumbsItem,
        components: [
            "Breadcrumbs"
        ],
        description: "Each breadcrumb"
    },
    BreadcrumbsLink: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).BreadcrumbsLink,
        components: [
            "Breadcrumbs"
        ],
        description: "Links used within breadcrumbs"
    },
    BreadcrumbsList: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).BreadcrumbsList,
        components: [
            "Breadcrumbs"
        ],
        description: "List element within nav"
    },
    BreadcrumbsSeparator: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).BreadcrumbsSeparator,
        components: [
            "Breadcrumbs"
        ],
        description: "Separator between each breadcrumb"
    },
    Button: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Button,
        components: [
            "Button"
        ],
        description: "Top level element that wraps the Button primitive"
    },
    ButtonGroup: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).ButtonGroup
    },
    ButtonLoaderWrapper: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).ButtonLoaderWrapper,
        components: [
            "Button"
        ],
        description: "Class applied to the Loader component within the Button Loading state"
    },
    Card: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Card,
        components: [
            "Card"
        ],
        description: "Top level element that wraps the Card primitive"
    },
    Checkbox: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Checkbox,
        components: [
            "Checkbox"
        ],
        description: "Top level element that wraps the Checkbox primitive"
    },
    CheckboxButton: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).CheckboxButton,
        components: [
            "Checkbox"
        ],
        description: "Wrapper for the checked icon within the Checkbox primitive"
    },
    CheckboxIcon: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).CheckboxIcon,
        components: [
            "Checkbox"
        ],
        description: "Class applied to the checked icon within the Checkbox primitive"
    },
    CheckboxInput: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).CheckboxInput,
        components: [
            "Checkbox"
        ],
        description: "Class applied to the visually hidden checkbox input within the Checkbox primitive"
    },
    CheckboxLabel: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).CheckboxLabel,
        components: [
            "Checkbox"
        ],
        description: "Class applied to the label within the Checkbox primitive"
    },
    CheckboxField: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).CheckboxField,
        components: [
            "CheckboxField"
        ],
        description: "Top level element that wraps the CheckboxField primitive"
    },
    Collection: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Collection,
        components: [
            "Collection"
        ],
        description: "Top level element that wraps the Collection primitive"
    },
    CollectionItems: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).CollectionItems,
        components: [
            "Collection"
        ],
        description: "Class applied to the element that wraps all the items in a collection"
    },
    CollectionSearch: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).CollectionSearch,
        components: [
            "Collection"
        ],
        description: "Class applied to the element that wraps the collection search box"
    },
    CollectionPagination: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).CollectionPagination,
        components: [
            "Collection"
        ],
        description: "Class applied to the element that wraps the pagination component in a collection"
    },
    CountryCodeSelect: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).CountryCodeSelect,
        components: [
            "PhoneNumberField"
        ],
        description: "Class applied to the Dial Code Select within the PhoneNumberField primitive"
    },
    DialCodeSelect: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).DialCodeSelect,
        components: [
            "PhoneNumberField"
        ],
        description: "Class applied to the Dial Code Select within the PhoneNumberField primitive"
    },
    Divider: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Divider,
        components: [
            "Divider"
        ],
        description: "Top level element that wraps the Divider primitive"
    },
    DividerLabel: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).DividerLabel,
        components: [
            "Divider"
        ],
        description: "Class applied to the label of the Divider component"
    },
    DropZone: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).DropZone,
        components: [
            "DropZone"
        ],
        description: "Class applied to the DropZone component"
    },
    Expander: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Expander,
        components: [
            "Expander"
        ],
        description: "Top level element that wraps the Expander primitive"
    },
    ExpanderContent: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).ExpanderContent,
        components: [
            "Expander"
        ],
        description: "Expander content container"
    },
    ExpanderContentText: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).ExpanderContentText,
        components: [
            "Expander"
        ],
        description: "Expander content text"
    },
    ExpanderHeader: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).ExpanderHeader,
        components: [
            "Expander"
        ],
        description: "Expander item header"
    },
    ExpanderIcon: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).ExpanderIcon,
        components: [
            "Expander"
        ],
        description: "Icon to indicate whether an item is expanded or collapsed"
    },
    ExpanderItem: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).ExpanderItem,
        components: [
            "Expander"
        ],
        description: "Expander item(containier for header, trigger, and content)"
    },
    ExpanderTrigger: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).ExpanderTrigger,
        components: [
            "Expander"
        ],
        description: "Expander item trigger(button)"
    },
    Field: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Field
    },
    FieldDescription: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldDescription
    },
    FieldErrorMessage: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldErrorMessage
    },
    FieldGroup: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldGroup
    },
    FieldGroupControl: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldGroupControl
    },
    FieldGroupFieldWrapper: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldGroupFieldWrapper
    },
    FieldGroupOuterEnd: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldGroupOuterEnd
    },
    FieldGroupOuterStart: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldGroupOuterStart
    },
    FieldGroupInnerEnd: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldGroupInnerEnd
    },
    FieldGroupInnerStart: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldGroupInnerStart
    },
    FieldGroupIcon: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldGroupIcon
    },
    FieldGroupIconButton: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldGroupIconButton
    },
    FieldGroupHasInnerEnd: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldGroupHasInnerEnd
    },
    FieldGroupHasInnerStart: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldGroupHasInnerStart
    },
    FieldShowPassword: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldShowPassword
    },
    Fieldset: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Fieldset,
        components: [
            "Fieldset"
        ],
        description: "Top level element that wraps the Fieldset primitive"
    },
    FieldsetLegend: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FieldsetLegend,
        components: [
            "Fieldset"
        ],
        description: "Visual label for the Fieldset primitive"
    },
    FileUploaderDropZone: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderDropZone,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderDropZoneIcon: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderDropZoneIcon,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderDropZoneText: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderDropZoneText,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderDropZoneButton: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderDropZoneButton,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFile: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderFile,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileWrapper: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderFileWrapper,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileName: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderFileName,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderLoader: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderLoader,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileSize: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderFileSize,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileInfo: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderFileInfo,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileImage: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderFileImage,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileMain: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderFileMain,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileStatus: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderFileStatus,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderPreviewer: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderPreviewer,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderPreviewerText: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderPreviewerText,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderPreviewerBody: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderPreviewerBody,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderPreviewerFooter: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderPreviewerFooter,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderPreviewerFooterActions: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).FileUploaderPreviewerFooterActions,
        components: [
            "FileUploader"
        ]
    },
    Flex: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Flex,
        components: [
            "Flex"
        ],
        description: "Top level element that wraps the Flex primitive"
    },
    Grid: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Grid,
        components: [
            "Grid"
        ],
        description: "Top level element that wraps the Grid primitive"
    },
    Heading: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Heading,
        components: [
            "Heading"
        ],
        description: "Top level element that wraps the Heading primitive"
    },
    HighlightMatch: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).HighlightMatch,
        components: [
            "HighlightMatch"
        ],
        description: "Top level element that wraps the HighlightMatch primitive"
    },
    HighlightMatchHighlighted: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).HighlightMatchHighlighted,
        components: [
            "HighlightMatch"
        ],
        description: "Class applied to the highlighted text of the HighlightMatch primitive"
    },
    Icon: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Icon,
        components: [
            "Icon"
        ],
        description: "Top level element that wraps the Icon primitive"
    },
    Image: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Image,
        components: [
            "Image"
        ],
        description: "Top level element that wraps the Image primitive"
    },
    Input: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Input,
        components: [
            "Input"
        ],
        description: "Class applied to the input element"
    },
    Label: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Label,
        components: [
            "Label"
        ],
        description: "Class applied to the label element"
    },
    Link: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Link,
        components: [
            "Link"
        ],
        description: "Top level element that wraps the Link primitive"
    },
    Loader: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Loader,
        components: [
            "Loader"
        ],
        description: "Top level element that wraps the Loader primitive"
    },
    LoaderDeterminate: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).LoaderDeterminate,
        components: [
            "Loader"
        ],
        description: "Class applied to a determinate loader"
    },
    LoaderPercentageText: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).LoaderPercentageText,
        components: [
            "Loader"
        ],
        description: "Class applied to the percentage text of loader"
    },
    MenuContent: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).MenuContent,
        components: [
            "Menu"
        ],
        description: "Menu content container (Flex)"
    },
    MenuContentWrapper: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).MenuContentWrapper,
        components: [
            "Menu"
        ],
        description: "Menu content wrapper"
    },
    MenuItem: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).MenuItem,
        components: [
            "Menu"
        ],
        description: "Menu item button (MenuButton, wrapped in amplify-menu-content class)"
    },
    MenuTrigger: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).MenuTrigger,
        components: [
            "Menu"
        ],
        description: "Menu trigger button (MenuButton, not wrapped in amplify-menu-content class)"
    },
    Message: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Message,
        components: [
            "Message"
        ],
        description: "Class applied to the root element of the Message"
    },
    MessageIcon: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).MessageIcon,
        components: [
            "Message"
        ],
        description: "Class applied to Icon component within the Message primitive"
    },
    MessageHeading: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).MessageHeading,
        components: [
            "Message"
        ],
        description: "Class applied to the heading View"
    },
    MessageBody: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).MessageBody,
        components: [
            "Message"
        ],
        description: "Class applied to the body View"
    },
    MessageContent: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).MessageContent,
        components: [
            "Message"
        ],
        description: "Class applied to the wrappar around heading and children of the Message"
    },
    MessageDismiss: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).MessageDismiss,
        components: [
            "Message"
        ],
        description: "Class applied to the close Button"
    },
    Pagination: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Pagination,
        components: [
            "Pagination"
        ],
        description: "Top level element that wraps the Pagination primitive"
    },
    PaginationItemButton: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).PaginationItemButton,
        components: [
            "Pagination"
        ],
        description: "Class applied to the pagination buttons"
    },
    PaginationItemCurrent: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).PaginationItemCurrent,
        components: [
            "Pagination"
        ],
        description: "Class applied to the currently selected pagination button"
    },
    PaginationItemEllipsis: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).PaginationItemEllipsis,
        components: [
            "Pagination"
        ],
        description: "Class applied to the ellipsis within the Pagination primitive"
    },
    PasswordField: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).PasswordField,
        components: [
            "PasswordField"
        ],
        description: "Top level element that wraps the PasswordField primitive"
    },
    PhoneNumberField: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).PhoneNumberField,
        components: [
            "PhoneNumberField"
        ],
        description: "Top level element that wraps the PhoneNumberField primitive"
    },
    Placeholder: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Placeholder,
        components: [
            "Placeholder"
        ],
        description: "Top level element that wraps the Placeholder primitive"
    },
    Radio: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Radio,
        components: [
            "RadioGroupField",
            "Radio"
        ],
        description: "Top level element that wraps the Radio primitive"
    },
    RadioButton: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).RadioButton,
        components: [
            "RadioGroupField",
            "Radio"
        ],
        description: "Class applied to the displayed radio button"
    },
    RadioInput: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).RadioInput,
        components: [
            "RadioGroupField",
            "Radio"
        ],
        description: "Class applied to the visually hidden radio input"
    },
    RadioLabel: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).RadioLabel,
        components: [
            "RadioGroupField",
            "Radio"
        ],
        description: "Class applied to the radio label"
    },
    RadioGroupField: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).RadioGroupField,
        components: [
            "RadioGroupField"
        ],
        description: "Top level element that wraps the RadioGroupField primitive"
    },
    RadioGroup: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).RadioGroup,
        components: [
            "RadioGroupField"
        ],
        description: "Class applied to the radio group wrapper"
    },
    Rating: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Rating,
        components: [
            "Rating"
        ],
        description: "Top level element that wraps the Rating primitive"
    },
    ScrollView: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).ScrollView,
        components: [
            "ScrollView"
        ],
        description: "Top level element that wraps the ScrollView primitive"
    },
    SearchField: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SearchField,
        components: [
            "SearchField"
        ],
        description: "Top level element that wraps the SearchField primitive"
    },
    SearchFieldClear: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SearchFieldClear,
        components: [
            "SearchField"
        ],
        description: "Class applied to the search field clear button"
    },
    SearchFieldSearch: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SearchFieldSearch,
        components: [
            "SearchField"
        ],
        description: "Class applied to the search button"
    },
    Select: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Select,
        components: [
            "Select",
            "SelectField"
        ],
        description: "Class applied to the select element"
    },
    SelectField: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SelectField,
        components: [
            "SelectField"
        ],
        description: "Top level element that wraps the SelectField primitive"
    },
    SelectWrapper: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SelectWrapper,
        components: [
            "Select",
            "SelectField"
        ],
        description: "Class applied to the select wrapper"
    },
    SelectIconWrapper: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SelectIconWrapper,
        components: [
            "Select",
            "SelectField"
        ],
        description: "Class applied to the select icon wrapper"
    },
    SliderField: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SliderField,
        components: [
            "SliderField"
        ],
        description: "Top level element that wraps the SliderField primitive"
    },
    SliderFieldGroup: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SliderFieldGroup,
        components: [
            "SliderField"
        ],
        description: "Class applied to the element that wraps the slider root"
    },
    SliderFieldLabel: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SliderFieldLabel,
        components: [
            "SliderField"
        ],
        description: "Class applied to the slider label"
    },
    SliderFieldRange: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SliderFieldRange,
        components: [
            "SliderField"
        ],
        description: "Class applied to the filled in portion of the slider track"
    },
    SliderFieldRoot: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SliderFieldRoot,
        components: [
            "SliderField"
        ],
        description: "Class applied to the slider root which wraps the track and thumb"
    },
    SliderFieldThumb: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SliderFieldThumb,
        components: [
            "SliderField"
        ],
        description: "Class applied to the slider thumb"
    },
    SliderFieldTrack: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SliderFieldTrack,
        components: [
            "SliderField"
        ],
        description: "Class applied to the slider track"
    },
    StepperField: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StepperField,
        components: [
            "StepperField"
        ],
        description: "Top level element that wraps the StepperField primitive"
    },
    StepperFieldButtonDecrease: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StepperFieldButtonDecrease,
        components: [
            "StepperField"
        ],
        description: "Class applied to the decrease button"
    },
    StepperFieldButtonIncrease: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StepperFieldButtonIncrease,
        components: [
            "StepperField"
        ],
        description: "Class applied to the increase button"
    },
    StepperFieldInput: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StepperFieldInput,
        components: [
            "StepperField"
        ],
        description: "Class applied to the StepperField input"
    },
    StorageImage: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageImage,
        components: [
            "StorageImage"
        ],
        description: "Class applied to the img tag"
    },
    StorageManager: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManager,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerDropZone: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerDropZone,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerDropZoneIcon: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerDropZoneIcon,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerDropZoneText: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerDropZoneText,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFilePicker: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerFilePicker,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFile: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerFile,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileWrapper: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerFileWrapper,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileList: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerFileList,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileName: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerFileName,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerLoader: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerLoader,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileSize: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerFileSize,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileInfo: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerFileInfo,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileImage: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerFileImage,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileMain: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerFileMain,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileStatus: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerFileStatus,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerPreviewer: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerPreviewer,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerPreviewerText: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerPreviewerText,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerPreviewerActions: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerPreviewerActions,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerPreviewerFooter: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).StorageManagerPreviewerFooter,
        components: [
            "StorageManager"
        ]
    },
    SwitchField: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SwitchField,
        components: [
            "SwitchField"
        ],
        description: "Top level element that wraps the SwitchField primitive"
    },
    SwitchLabel: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SwitchLabel,
        components: [
            "SwitchField"
        ],
        description: "Class applied to the SwitchField label text"
    },
    SwitchThumb: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SwitchThumb,
        components: [
            "SwitchField"
        ],
        description: "Class applied to the SwitchField thumb"
    },
    SwitchTrack: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SwitchTrack,
        components: [
            "SwitchField"
        ],
        description: "Class applied to the SwitchField track"
    },
    SwitchWrapper: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).SwitchWrapper,
        components: [
            "SwitchField"
        ],
        description: "Class applied to the label element that wraps the SwitchField label and track"
    },
    Table: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Table,
        components: [
            "Table"
        ],
        description: "Top level element that wraps the Table primitive"
    },
    TableCaption: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).TableCaption,
        components: [
            "Table"
        ],
        description: "Class applied to the content provided as the caption prop"
    },
    TableBody: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).TableBody,
        components: [
            "Table"
        ],
        description: "Class applied to TableBody component"
    },
    TableTd: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).TableTd,
        components: [
            "Table"
        ],
        description: 'Class applied to TableCell component rendered as a <td> element (<TableCell as="td" />)'
    },
    TableTh: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).TableTh,
        components: [
            "Table"
        ],
        description: 'Class applied to TableCell comopnent rendered as a <th> element (<TableCell as="th" />)'
    },
    TableFoot: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).TableFoot,
        components: [
            "Table"
        ],
        description: "Class applied to TableFoot component"
    },
    TableHead: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).TableHead,
        components: [
            "Table"
        ],
        description: "Class applied to TableHead component"
    },
    TableRow: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).TableRow,
        components: [
            "Table"
        ],
        description: "Class applied to TableRow component"
    },
    Tabs: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Tabs,
        components: [
            "Tabs"
        ],
        description: "Top level element that wraps the Tabs primitive"
    },
    TabItems: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).TabItems,
        components: [
            "Tabs"
        ],
        description: "Top level element that wraps the TabItem primitive"
    },
    Text: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Text,
        components: [
            "Text"
        ],
        description: "Top level element that wraps the Text primitive"
    },
    Textarea: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).Textarea,
        components: [
            "TextAreaField"
        ],
        description: "Class applied to the text area"
    },
    TextAreaField: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).TextAreaField,
        components: [
            "TextAreaField"
        ],
        description: "Top level element that wraps the TextAreaField primitive"
    },
    TextField: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).TextField,
        components: [
            "TextField"
        ],
        description: "Top level element that wraps the TextField primitive"
    },
    ToggleButton: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).ToggleButton,
        components: [
            "ToggleButton"
        ],
        description: "Top level element that wraps the ToggleButton primitive"
    },
    ToggleButtonGroup: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).ToggleButtonGroup,
        components: [
            "ToggleButton",
            "ToggleButtonGroup"
        ],
        description: "Top level element that wraps the ToggleButtonGroup primitive"
    },
    VisuallyHidden: {
        className: (0, $53f428d35a39841a$export$a5e41a4bc3f9b1d6).VisuallyHidden,
        components: [
            "VisuallyHidden"
        ],
        description: "Top level element that wraps the VisuallyHidden primitive"
    }
}, $ca5815d75ab8dc16$export$da015ee4e3f15a81 = {
    Alert: $ca5815d75ab8dc16$export$d520e33dec8f4319.Alert.className,
    AlertIcon: $ca5815d75ab8dc16$export$d520e33dec8f4319.AlertIcon.className,
    AlertHeading: $ca5815d75ab8dc16$export$d520e33dec8f4319.AlertHeading.className,
    AlertBody: $ca5815d75ab8dc16$export$d520e33dec8f4319.AlertBody.className,
    AlertDismiss: $ca5815d75ab8dc16$export$d520e33dec8f4319.AlertDismiss.className,
    Autocomplete: $ca5815d75ab8dc16$export$d520e33dec8f4319.Autocomplete.className,
    AutocompleteMenu: $ca5815d75ab8dc16$export$d520e33dec8f4319.AutocompleteMenu.className,
    AutocompleteMenuEmpty: $ca5815d75ab8dc16$export$d520e33dec8f4319.AutocompleteMenuEmpty.className,
    AutocompleteMenuFooter: $ca5815d75ab8dc16$export$d520e33dec8f4319.AutocompleteMenuFooter.className,
    AutocompleteMenuHeader: $ca5815d75ab8dc16$export$d520e33dec8f4319.AutocompleteMenuHeader.className,
    AutocompleteMenuLoading: $ca5815d75ab8dc16$export$d520e33dec8f4319.AutocompleteMenuLoading.className,
    AutocompleteMenuOption: $ca5815d75ab8dc16$export$d520e33dec8f4319.AutocompleteMenuOption.className,
    AutocompleteMenuOptions: $ca5815d75ab8dc16$export$d520e33dec8f4319.AutocompleteMenuOptions.className,
    Badge: $ca5815d75ab8dc16$export$d520e33dec8f4319.Badge.className,
    Breadcrumbs: $ca5815d75ab8dc16$export$d520e33dec8f4319.Breadcrumbs.className,
    BreadcrumbsItem: $ca5815d75ab8dc16$export$d520e33dec8f4319.BreadcrumbsItem.className,
    BreadcrumbsLink: $ca5815d75ab8dc16$export$d520e33dec8f4319.BreadcrumbsLink.className,
    BreadcrumbsList: $ca5815d75ab8dc16$export$d520e33dec8f4319.BreadcrumbsList.className,
    BreadcrumbsSeparator: $ca5815d75ab8dc16$export$d520e33dec8f4319.BreadcrumbsSeparator.className,
    Button: $ca5815d75ab8dc16$export$d520e33dec8f4319.Button.className,
    ButtonGroup: $ca5815d75ab8dc16$export$d520e33dec8f4319.ButtonGroup.className,
    ButtonLoaderWrapper: $ca5815d75ab8dc16$export$d520e33dec8f4319.ButtonLoaderWrapper.className,
    Card: $ca5815d75ab8dc16$export$d520e33dec8f4319.Card.className,
    Checkbox: $ca5815d75ab8dc16$export$d520e33dec8f4319.Checkbox.className,
    CheckboxButton: $ca5815d75ab8dc16$export$d520e33dec8f4319.CheckboxButton.className,
    CheckboxIcon: $ca5815d75ab8dc16$export$d520e33dec8f4319.CheckboxIcon.className,
    CheckboxInput: $ca5815d75ab8dc16$export$d520e33dec8f4319.CheckboxInput.className,
    CheckboxLabel: $ca5815d75ab8dc16$export$d520e33dec8f4319.CheckboxLabel.className,
    CheckboxField: $ca5815d75ab8dc16$export$d520e33dec8f4319.CheckboxField.className,
    Collection: $ca5815d75ab8dc16$export$d520e33dec8f4319.Collection.className,
    CollectionItems: $ca5815d75ab8dc16$export$d520e33dec8f4319.CollectionItems.className,
    CollectionSearch: $ca5815d75ab8dc16$export$d520e33dec8f4319.CollectionSearch.className,
    CollectionPagination: $ca5815d75ab8dc16$export$d520e33dec8f4319.CollectionPagination.className,
    CountryCodeSelect: $ca5815d75ab8dc16$export$d520e33dec8f4319.CountryCodeSelect.className,
    DialCodeSelect: $ca5815d75ab8dc16$export$d520e33dec8f4319.DialCodeSelect.className,
    Divider: $ca5815d75ab8dc16$export$d520e33dec8f4319.Divider.className,
    DividerLabel: $ca5815d75ab8dc16$export$d520e33dec8f4319.DividerLabel.className,
    DropZone: $ca5815d75ab8dc16$export$d520e33dec8f4319.DropZone.className,
    Expander: $ca5815d75ab8dc16$export$d520e33dec8f4319.Expander.className,
    ExpanderContent: $ca5815d75ab8dc16$export$d520e33dec8f4319.ExpanderContent.className,
    ExpanderContentText: $ca5815d75ab8dc16$export$d520e33dec8f4319.ExpanderContentText.className,
    ExpanderHeader: $ca5815d75ab8dc16$export$d520e33dec8f4319.ExpanderHeader.className,
    ExpanderIcon: $ca5815d75ab8dc16$export$d520e33dec8f4319.ExpanderIcon.className,
    ExpanderItem: $ca5815d75ab8dc16$export$d520e33dec8f4319.ExpanderItem.className,
    ExpanderTrigger: $ca5815d75ab8dc16$export$d520e33dec8f4319.ExpanderTrigger.className,
    Field: $ca5815d75ab8dc16$export$d520e33dec8f4319.Field.className,
    FieldDescription: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldDescription.className,
    FieldErrorMessage: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldErrorMessage.className,
    FieldGroup: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldGroup.className,
    FieldGroupControl: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldGroupControl.className,
    FieldGroupOuterEnd: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldGroupOuterEnd.className,
    FieldGroupOuterStart: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldGroupOuterStart.className,
    FieldGroupInnerEnd: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldGroupInnerEnd.className,
    FieldGroupInnerStart: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldGroupInnerStart.className,
    FieldGroupIcon: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldGroupIcon.className,
    FieldGroupIconButton: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldGroupIconButton.className,
    FieldGroupHasInnerEnd: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldGroupHasInnerEnd.className,
    FieldGroupHasInnerStart: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldGroupHasInnerStart.className,
    FieldShowPassword: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldShowPassword.className,
    FieldGroupFieldWrapper: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldGroupFieldWrapper.className,
    Fieldset: $ca5815d75ab8dc16$export$d520e33dec8f4319.Fieldset.className,
    FieldsetLegend: $ca5815d75ab8dc16$export$d520e33dec8f4319.FieldsetLegend.className,
    FileUploaderDropZone: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderDropZone.className,
    FileUploaderDropZoneIcon: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderDropZoneIcon.className,
    FileUploaderDropZoneText: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderDropZoneText.className,
    FileUploaderDropZoneButton: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderDropZoneButton.className,
    FileUploaderFile: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderFile.className,
    FileUploaderFileWrapper: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderFileWrapper.className,
    FileUploaderFileName: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderFileName.className,
    FileUploaderLoader: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderLoader.className,
    FileUploaderFileSize: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderFileSize.className,
    FileUploaderFileInfo: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderFileInfo.className,
    FileUploaderFileImage: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderFileImage.className,
    FileUploaderFileMain: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderFileMain.className,
    FileUploaderFileStatus: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderFileStatus.className,
    FileUploaderPreviewer: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderPreviewer.className,
    FileUploaderPreviewerText: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderPreviewerText.className,
    FileUploaderPreviewerBody: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderPreviewerBody.className,
    FileUploaderPreviewerFooter: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderPreviewerFooter.className,
    FileUploaderPreviewerFooterActions: $ca5815d75ab8dc16$export$d520e33dec8f4319.FileUploaderPreviewerFooterActions.className,
    Flex: $ca5815d75ab8dc16$export$d520e33dec8f4319.Flex.className,
    Grid: $ca5815d75ab8dc16$export$d520e33dec8f4319.Grid.className,
    Heading: $ca5815d75ab8dc16$export$d520e33dec8f4319.Heading.className,
    HighlightMatch: $ca5815d75ab8dc16$export$d520e33dec8f4319.HighlightMatch.className,
    HighlightMatchHighlighted: $ca5815d75ab8dc16$export$d520e33dec8f4319.HighlightMatchHighlighted.className,
    Icon: $ca5815d75ab8dc16$export$d520e33dec8f4319.Icon.className,
    Image: $ca5815d75ab8dc16$export$d520e33dec8f4319.Image.className,
    Input: $ca5815d75ab8dc16$export$d520e33dec8f4319.Input.className,
    Label: $ca5815d75ab8dc16$export$d520e33dec8f4319.Label.className,
    Link: $ca5815d75ab8dc16$export$d520e33dec8f4319.Link.className,
    Loader: $ca5815d75ab8dc16$export$d520e33dec8f4319.Loader.className,
    LoaderDeterminate: $ca5815d75ab8dc16$export$d520e33dec8f4319.LoaderDeterminate.className,
    LoaderPercentageText: $ca5815d75ab8dc16$export$d520e33dec8f4319.LoaderPercentageText.className,
    MenuContent: $ca5815d75ab8dc16$export$d520e33dec8f4319.MenuContent.className,
    MenuContentWrapper: $ca5815d75ab8dc16$export$d520e33dec8f4319.MenuContentWrapper.className,
    MenuItem: $ca5815d75ab8dc16$export$d520e33dec8f4319.MenuItem.className,
    MenuTrigger: $ca5815d75ab8dc16$export$d520e33dec8f4319.MenuTrigger.className,
    Message: $ca5815d75ab8dc16$export$d520e33dec8f4319.Message.className,
    MessageIcon: $ca5815d75ab8dc16$export$d520e33dec8f4319.MessageIcon.className,
    MessageHeading: $ca5815d75ab8dc16$export$d520e33dec8f4319.MessageHeading.className,
    MessageBody: $ca5815d75ab8dc16$export$d520e33dec8f4319.MessageBody.className,
    MessageContent: $ca5815d75ab8dc16$export$d520e33dec8f4319.MessageContent.className,
    MessageDismiss: $ca5815d75ab8dc16$export$d520e33dec8f4319.MessageDismiss.className,
    Pagination: $ca5815d75ab8dc16$export$d520e33dec8f4319.Pagination.className,
    PaginationItemButton: $ca5815d75ab8dc16$export$d520e33dec8f4319.PaginationItemButton.className,
    PaginationItemCurrent: $ca5815d75ab8dc16$export$d520e33dec8f4319.PaginationItemCurrent.className,
    PaginationItemEllipsis: $ca5815d75ab8dc16$export$d520e33dec8f4319.PaginationItemEllipsis.className,
    PasswordField: $ca5815d75ab8dc16$export$d520e33dec8f4319.PasswordField.className,
    PhoneNumberField: $ca5815d75ab8dc16$export$d520e33dec8f4319.PhoneNumberField.className,
    Placeholder: $ca5815d75ab8dc16$export$d520e33dec8f4319.Placeholder.className,
    Radio: $ca5815d75ab8dc16$export$d520e33dec8f4319.Radio.className,
    RadioButton: $ca5815d75ab8dc16$export$d520e33dec8f4319.RadioButton.className,
    RadioInput: $ca5815d75ab8dc16$export$d520e33dec8f4319.RadioInput.className,
    RadioLabel: $ca5815d75ab8dc16$export$d520e33dec8f4319.RadioLabel.className,
    RadioGroupField: $ca5815d75ab8dc16$export$d520e33dec8f4319.RadioGroupField.className,
    RadioGroup: $ca5815d75ab8dc16$export$d520e33dec8f4319.RadioGroup.className,
    Rating: $ca5815d75ab8dc16$export$d520e33dec8f4319.Rating.className,
    ScrollView: $ca5815d75ab8dc16$export$d520e33dec8f4319.ScrollView.className,
    SearchField: $ca5815d75ab8dc16$export$d520e33dec8f4319.SearchField.className,
    SearchFieldClear: $ca5815d75ab8dc16$export$d520e33dec8f4319.SearchFieldClear.className,
    SearchFieldSearch: $ca5815d75ab8dc16$export$d520e33dec8f4319.SearchFieldSearch.className,
    Select: $ca5815d75ab8dc16$export$d520e33dec8f4319.Select.className,
    SelectField: $ca5815d75ab8dc16$export$d520e33dec8f4319.SelectField.className,
    SelectWrapper: $ca5815d75ab8dc16$export$d520e33dec8f4319.SelectWrapper.className,
    SelectIconWrapper: $ca5815d75ab8dc16$export$d520e33dec8f4319.SelectIconWrapper.className,
    SliderField: $ca5815d75ab8dc16$export$d520e33dec8f4319.SliderField.className,
    SliderFieldGroup: $ca5815d75ab8dc16$export$d520e33dec8f4319.SliderFieldGroup.className,
    SliderFieldLabel: $ca5815d75ab8dc16$export$d520e33dec8f4319.SliderFieldLabel.className,
    SliderFieldRange: $ca5815d75ab8dc16$export$d520e33dec8f4319.SliderFieldRange.className,
    SliderFieldRoot: $ca5815d75ab8dc16$export$d520e33dec8f4319.SliderFieldRoot.className,
    SliderFieldThumb: $ca5815d75ab8dc16$export$d520e33dec8f4319.SliderFieldThumb.className,
    SliderFieldTrack: $ca5815d75ab8dc16$export$d520e33dec8f4319.SliderFieldTrack.className,
    StepperField: $ca5815d75ab8dc16$export$d520e33dec8f4319.StepperField.className,
    StepperFieldButtonDecrease: $ca5815d75ab8dc16$export$d520e33dec8f4319.StepperFieldButtonDecrease.className,
    StepperFieldButtonIncrease: $ca5815d75ab8dc16$export$d520e33dec8f4319.StepperFieldButtonIncrease.className,
    StepperFieldInput: $ca5815d75ab8dc16$export$d520e33dec8f4319.StepperFieldInput.className,
    StorageImage: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageImage.className,
    StorageManager: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManager.className,
    StorageManagerDropZone: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerDropZone.className,
    StorageManagerDropZoneIcon: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerDropZoneIcon.className,
    StorageManagerDropZoneText: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerDropZoneText.className,
    StorageManagerFilePicker: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerFilePicker.className,
    StorageManagerFile: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerFile.className,
    StorageManagerFileWrapper: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerFileWrapper.className,
    StorageManagerFileList: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerFileList.className,
    StorageManagerFileName: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerFileName.className,
    StorageManagerLoader: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerLoader.className,
    StorageManagerFileSize: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerFileSize.className,
    StorageManagerFileInfo: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerFileInfo.className,
    StorageManagerFileImage: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerFileImage.className,
    StorageManagerFileMain: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerFileMain.className,
    StorageManagerFileStatus: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerFileStatus.className,
    StorageManagerPreviewer: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerPreviewer.className,
    StorageManagerPreviewerText: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerPreviewerText.className,
    StorageManagerPreviewerActions: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerPreviewerActions.className,
    StorageManagerPreviewerFooter: $ca5815d75ab8dc16$export$d520e33dec8f4319.StorageManagerPreviewerFooter.className,
    SwitchField: $ca5815d75ab8dc16$export$d520e33dec8f4319.SwitchField.className,
    SwitchLabel: $ca5815d75ab8dc16$export$d520e33dec8f4319.SwitchLabel.className,
    SwitchThumb: $ca5815d75ab8dc16$export$d520e33dec8f4319.SwitchThumb.className,
    SwitchTrack: $ca5815d75ab8dc16$export$d520e33dec8f4319.SwitchTrack.className,
    SwitchWrapper: $ca5815d75ab8dc16$export$d520e33dec8f4319.SwitchWrapper.className,
    Table: $ca5815d75ab8dc16$export$d520e33dec8f4319.Table.className,
    TableCaption: $ca5815d75ab8dc16$export$d520e33dec8f4319.TableCaption.className,
    TableBody: $ca5815d75ab8dc16$export$d520e33dec8f4319.TableBody.className,
    TableTd: $ca5815d75ab8dc16$export$d520e33dec8f4319.TableTd.className,
    TableTh: $ca5815d75ab8dc16$export$d520e33dec8f4319.TableTh.className,
    TableFoot: $ca5815d75ab8dc16$export$d520e33dec8f4319.TableFoot.className,
    TableHead: $ca5815d75ab8dc16$export$d520e33dec8f4319.TableHead.className,
    TableRow: $ca5815d75ab8dc16$export$d520e33dec8f4319.TableRow.className,
    Tabs: $ca5815d75ab8dc16$export$d520e33dec8f4319.Tabs.className,
    TabItems: $ca5815d75ab8dc16$export$d520e33dec8f4319.TabItems.className,
    Text: $ca5815d75ab8dc16$export$d520e33dec8f4319.Text.className,
    Textarea: $ca5815d75ab8dc16$export$d520e33dec8f4319.Textarea.className,
    TextAreaField: $ca5815d75ab8dc16$export$d520e33dec8f4319.TextAreaField.className,
    TextField: $ca5815d75ab8dc16$export$d520e33dec8f4319.TextField.className,
    ToggleButton: $ca5815d75ab8dc16$export$d520e33dec8f4319.ToggleButton.className,
    ToggleButtonGroup: $ca5815d75ab8dc16$export$d520e33dec8f4319.ToggleButtonGroup.className,
    VisuallyHidden: $ca5815d75ab8dc16$export$d520e33dec8f4319.VisuallyHidden.className
}, $ca5815d75ab8dc16$export$529e7eefcb1e2a4c = {
    Alert: {
        dismissButtonLabel: "Dismiss alert"
    },
    Autocomplete: {
        emptyText: "No options found",
        loadingText: "Loading options..."
    },
    Collection: {
        searchButtonLabel: "Search",
        searchNoResultsFound: "No results found"
    },
    Fields: {
        clearButtonLabel: "Clear input"
    },
    Message: {
        dismissLabel: "Dismiss message"
    },
    PaginationItem: {
        currentPageLabel: "Page",
        nextLabel: "Go to next page",
        pageLabel: "Go to page",
        previousLabel: "Go to previous page"
    },
    PhoneNumberField: {
        countryCodeLabel: "Country code"
    },
    SearchField: {
        searchButtonLabel: "Search"
    },
    PasswordField: {
        passwordIsHidden: "Password is hidden",
        passwordIsShown: "Password is shown",
        showPassword: "Show password"
    },
    StepperField: {
        increaseButtonLabel: "Increase to",
        decreaseButtonLabel: "Decrease to"
    }
}, $ca5815d75ab8dc16$export$f486c23e21d151b2 = {
    backgroundColor: "colors",
    borderColor: "colors",
    borderWidth: "borderWidths",
    color: "colors",
    borderRadius: "radii",
    fontSize: "fontSizes",
    fontWeight: "fontWeights",
    fontFamily: "fonts",
    lineHeight: "lineHeights",
    opacity: "opacities",
    boxShadow: "shadows",
    transform: "transforms",
    left: "space",
    right: "space",
    top: "space",
    bottom: "space",
    height: "space",
    width: "space",
    letterSpacing: "space",
    margin: "space",
    marginBlock: "space",
    marginBlockEnd: "space",
    marginBlockStart: "space",
    marginInline: "space",
    marginInlineEnd: "space",
    marginInlineStart: "space",
    marginLeft: "space",
    marginRight: "space",
    marginTop: "space",
    marginBottom: "space",
    maxHeight: "space",
    maxWidth: "space",
    minHeight: "space",
    minWidth: "space",
    padding: "space",
    paddingBlock: "space",
    paddingBlockEnd: "space",
    paddingBlockStart: "space",
    paddingInline: "space",
    paddingInlineEnd: "space",
    paddingInlineStart: "space",
    paddingLeft: "space",
    paddingRight: "space",
    paddingTop: "space",
    paddingBottom: "space",
    gap: "space",
    columnGap: "space",
    rowGap: "space"
}, $ca5815d75ab8dc16$export$728705b4513abbb5 = "Escape", $ca5815d75ab8dc16$export$4162dbd8c730437 = "Enter", $ca5815d75ab8dc16$export$8188339dbe6c99c4 = "ArrowUp", $ca5815d75ab8dc16$export$59f214baefff6196 = "ArrowDown";



var $acw62 = parcelRequire("acw62");
const $3b7aa0a2fb31e524$export$74e4d3bc6dc1117 = $acw62.createContext({
    isFieldsetDisabled: !1
}), $3b7aa0a2fb31e524$export$b140571ec72925dd = ()=>$acw62.useContext($3b7aa0a2fb31e524$export$74e4d3bc6dc1117);




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $fa74499edcf324c6$exports = {};
var $0b2d21aee1d97729$exports = {};
var $1389b3710f5da9e8$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1389b3710f5da9e8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$1389b3710f5da9e8$exports = $1389b3710f5da9e8$var$arrayReduce;


var $ed80fa8833e2b532$exports = {};
var $3384256242a1b577$exports = {};
var $dcb2a7eb44d37cba$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $dcb2a7eb44d37cba$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$dcb2a7eb44d37cba$exports = $dcb2a7eb44d37cba$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $3384256242a1b577$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "Ā": "A",
    "Ă": "A",
    "Ą": "A",
    "ā": "a",
    "ă": "a",
    "ą": "a",
    "Ć": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Č": "C",
    "ć": "c",
    "ĉ": "c",
    "ċ": "c",
    "č": "c",
    "Ď": "D",
    "Đ": "D",
    "ď": "d",
    "đ": "d",
    "Ē": "E",
    "Ĕ": "E",
    "Ė": "E",
    "Ę": "E",
    "Ě": "E",
    "ē": "e",
    "ĕ": "e",
    "ė": "e",
    "ę": "e",
    "ě": "e",
    "Ĝ": "G",
    "Ğ": "G",
    "Ġ": "G",
    "Ģ": "G",
    "ĝ": "g",
    "ğ": "g",
    "ġ": "g",
    "ģ": "g",
    "Ĥ": "H",
    "Ħ": "H",
    "ĥ": "h",
    "ħ": "h",
    "Ĩ": "I",
    "Ī": "I",
    "Ĭ": "I",
    "Į": "I",
    "İ": "I",
    "ĩ": "i",
    "ī": "i",
    "ĭ": "i",
    "į": "i",
    "ı": "i",
    "Ĵ": "J",
    "ĵ": "j",
    "Ķ": "K",
    "ķ": "k",
    "ĸ": "k",
    "Ĺ": "L",
    "Ļ": "L",
    "Ľ": "L",
    "Ŀ": "L",
    "Ł": "L",
    "ĺ": "l",
    "ļ": "l",
    "ľ": "l",
    "ŀ": "l",
    "ł": "l",
    "Ń": "N",
    "Ņ": "N",
    "Ň": "N",
    "Ŋ": "N",
    "ń": "n",
    "ņ": "n",
    "ň": "n",
    "ŋ": "n",
    "Ō": "O",
    "Ŏ": "O",
    "Ő": "O",
    "ō": "o",
    "ŏ": "o",
    "ő": "o",
    "Ŕ": "R",
    "Ŗ": "R",
    "Ř": "R",
    "ŕ": "r",
    "ŗ": "r",
    "ř": "r",
    "Ś": "S",
    "Ŝ": "S",
    "Ş": "S",
    "Š": "S",
    "ś": "s",
    "ŝ": "s",
    "ş": "s",
    "š": "s",
    "Ţ": "T",
    "Ť": "T",
    "Ŧ": "T",
    "ţ": "t",
    "ť": "t",
    "ŧ": "t",
    "Ũ": "U",
    "Ū": "U",
    "Ŭ": "U",
    "Ů": "U",
    "Ű": "U",
    "Ų": "U",
    "ũ": "u",
    "ū": "u",
    "ŭ": "u",
    "ů": "u",
    "ű": "u",
    "ų": "u",
    "Ŵ": "W",
    "ŵ": "w",
    "Ŷ": "Y",
    "ŷ": "y",
    "Ÿ": "Y",
    "Ź": "Z",
    "Ż": "Z",
    "Ž": "Z",
    "ź": "z",
    "ż": "z",
    "ž": "z",
    "Ĳ": "IJ",
    "ĳ": "ij",
    "Œ": "Oe",
    "œ": "oe",
    "ŉ": "'n",
    "ſ": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $3384256242a1b577$var$deburrLetter = $dcb2a7eb44d37cba$exports($3384256242a1b577$var$deburredLetters);
$3384256242a1b577$exports = $3384256242a1b577$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ed80fa8833e2b532$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ed80fa8833e2b532$var$rsComboMarksRange = "\\u0300-\\u036f", $ed80fa8833e2b532$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $ed80fa8833e2b532$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $ed80fa8833e2b532$var$rsComboRange = $ed80fa8833e2b532$var$rsComboMarksRange + $ed80fa8833e2b532$var$reComboHalfMarksRange + $ed80fa8833e2b532$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ed80fa8833e2b532$var$rsCombo = "[" + $ed80fa8833e2b532$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ed80fa8833e2b532$var$reComboMark = RegExp($ed80fa8833e2b532$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ed80fa8833e2b532$var$deburr(string) {
    string = $f5d9385a9cc7e413$exports(string);
    return string && string.replace($ed80fa8833e2b532$var$reLatin, $3384256242a1b577$exports).replace($ed80fa8833e2b532$var$reComboMark, "");
}
$ed80fa8833e2b532$exports = $ed80fa8833e2b532$var$deburr;


var $12f2ccb7e11b3895$exports = {};
var $7e165cbd28a9af51$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $7e165cbd28a9af51$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $7e165cbd28a9af51$var$asciiWords(string) {
    return string.match($7e165cbd28a9af51$var$reAsciiWord) || [];
}
$7e165cbd28a9af51$exports = $7e165cbd28a9af51$var$asciiWords;


var $8688e0b23f5a081b$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $8688e0b23f5a081b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $8688e0b23f5a081b$var$hasUnicodeWord(string) {
    return $8688e0b23f5a081b$var$reHasUnicodeWord.test(string);
}
$8688e0b23f5a081b$exports = $8688e0b23f5a081b$var$hasUnicodeWord;



var $325a565efdffbc96$exports = {};
/** Used to compose unicode character classes. */ var $325a565efdffbc96$var$rsAstralRange = "\ud800-\udfff", $325a565efdffbc96$var$rsComboMarksRange = "\\u0300-\\u036f", $325a565efdffbc96$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $325a565efdffbc96$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $325a565efdffbc96$var$rsComboRange = $325a565efdffbc96$var$rsComboMarksRange + $325a565efdffbc96$var$reComboHalfMarksRange + $325a565efdffbc96$var$rsComboSymbolsRange, $325a565efdffbc96$var$rsDingbatRange = "\\u2700-\\u27bf", $325a565efdffbc96$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $325a565efdffbc96$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $325a565efdffbc96$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $325a565efdffbc96$var$rsPunctuationRange = "\\u2000-\\u206f", $325a565efdffbc96$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $325a565efdffbc96$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $325a565efdffbc96$var$rsVarRange = "\\ufe0e\\ufe0f", $325a565efdffbc96$var$rsBreakRange = $325a565efdffbc96$var$rsMathOpRange + $325a565efdffbc96$var$rsNonCharRange + $325a565efdffbc96$var$rsPunctuationRange + $325a565efdffbc96$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $325a565efdffbc96$var$rsApos = "['’]", $325a565efdffbc96$var$rsBreak = "[" + $325a565efdffbc96$var$rsBreakRange + "]", $325a565efdffbc96$var$rsCombo = "[" + $325a565efdffbc96$var$rsComboRange + "]", $325a565efdffbc96$var$rsDigits = "\\d+", $325a565efdffbc96$var$rsDingbat = "[" + $325a565efdffbc96$var$rsDingbatRange + "]", $325a565efdffbc96$var$rsLower = "[" + $325a565efdffbc96$var$rsLowerRange + "]", $325a565efdffbc96$var$rsMisc = "[^" + $325a565efdffbc96$var$rsAstralRange + $325a565efdffbc96$var$rsBreakRange + $325a565efdffbc96$var$rsDigits + $325a565efdffbc96$var$rsDingbatRange + $325a565efdffbc96$var$rsLowerRange + $325a565efdffbc96$var$rsUpperRange + "]", $325a565efdffbc96$var$rsFitz = "\ud83c[\udffb-\udfff]", $325a565efdffbc96$var$rsModifier = "(?:" + $325a565efdffbc96$var$rsCombo + "|" + $325a565efdffbc96$var$rsFitz + ")", $325a565efdffbc96$var$rsNonAstral = "[^" + $325a565efdffbc96$var$rsAstralRange + "]", $325a565efdffbc96$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $325a565efdffbc96$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $325a565efdffbc96$var$rsUpper = "[" + $325a565efdffbc96$var$rsUpperRange + "]", $325a565efdffbc96$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $325a565efdffbc96$var$rsMiscLower = "(?:" + $325a565efdffbc96$var$rsLower + "|" + $325a565efdffbc96$var$rsMisc + ")", $325a565efdffbc96$var$rsMiscUpper = "(?:" + $325a565efdffbc96$var$rsUpper + "|" + $325a565efdffbc96$var$rsMisc + ")", $325a565efdffbc96$var$rsOptContrLower = "(?:" + $325a565efdffbc96$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $325a565efdffbc96$var$rsOptContrUpper = "(?:" + $325a565efdffbc96$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $325a565efdffbc96$var$reOptMod = $325a565efdffbc96$var$rsModifier + "?", $325a565efdffbc96$var$rsOptVar = "[" + $325a565efdffbc96$var$rsVarRange + "]?", $325a565efdffbc96$var$rsOptJoin = "(?:" + $325a565efdffbc96$var$rsZWJ + "(?:" + [
    $325a565efdffbc96$var$rsNonAstral,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join("|") + ")" + $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + ")*", $325a565efdffbc96$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $325a565efdffbc96$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $325a565efdffbc96$var$rsSeq = $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + $325a565efdffbc96$var$rsOptJoin, $325a565efdffbc96$var$rsEmoji = "(?:" + [
    $325a565efdffbc96$var$rsDingbat,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join("|") + ")" + $325a565efdffbc96$var$rsSeq;
/** Used to match complex or compound words. */ var $325a565efdffbc96$var$reUnicodeWord = RegExp([
    $325a565efdffbc96$var$rsUpper + "?" + $325a565efdffbc96$var$rsLower + "+" + $325a565efdffbc96$var$rsOptContrLower + "(?=" + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper,
        "$"
    ].join("|") + ")",
    $325a565efdffbc96$var$rsMiscUpper + "+" + $325a565efdffbc96$var$rsOptContrUpper + "(?=" + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper + $325a565efdffbc96$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $325a565efdffbc96$var$rsUpper + "?" + $325a565efdffbc96$var$rsMiscLower + "+" + $325a565efdffbc96$var$rsOptContrLower,
    $325a565efdffbc96$var$rsUpper + "+" + $325a565efdffbc96$var$rsOptContrUpper,
    $325a565efdffbc96$var$rsOrdUpper,
    $325a565efdffbc96$var$rsOrdLower,
    $325a565efdffbc96$var$rsDigits,
    $325a565efdffbc96$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $325a565efdffbc96$var$unicodeWords(string) {
    return string.match($325a565efdffbc96$var$reUnicodeWord) || [];
}
$325a565efdffbc96$exports = $325a565efdffbc96$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $12f2ccb7e11b3895$var$words(string, pattern, guard) {
    string = $f5d9385a9cc7e413$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $8688e0b23f5a081b$exports(string) ? $325a565efdffbc96$exports(string) : $7e165cbd28a9af51$exports(string);
    return string.match(pattern) || [];
}
$12f2ccb7e11b3895$exports = $12f2ccb7e11b3895$var$words;


/** Used to compose unicode capture groups. */ var $0b2d21aee1d97729$var$rsApos = "['’]";
/** Used to match apostrophes. */ var $0b2d21aee1d97729$var$reApos = RegExp($0b2d21aee1d97729$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $0b2d21aee1d97729$var$createCompounder(callback) {
    return function(string) {
        return $1389b3710f5da9e8$exports($12f2ccb7e11b3895$exports($ed80fa8833e2b532$exports(string).replace($0b2d21aee1d97729$var$reApos, "")), callback, "");
    };
}
$0b2d21aee1d97729$exports = $0b2d21aee1d97729$var$createCompounder;


/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $fa74499edcf324c6$var$kebabCase = $0b2d21aee1d97729$exports(function(result, word, index) {
    return result + (index ? "-" : "") + word.toLowerCase();
});
$fa74499edcf324c6$exports = $fa74499edcf324c6$var$kebabCase;


var $ff3cc90cb76ac26c$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $283c8f0374cf594f$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $be1adfaa5ce5d8e4$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ const $be1adfaa5ce5d8e4$var$defaults = {
    opening_character: "{",
    closing_character: "}",
    separator: "."
};
$be1adfaa5ce5d8e4$exports = $be1adfaa5ce5d8e4$var$defaults;


function $283c8f0374cf594f$var$createReferenceRegex(opts = {}) {
    const options = Object.assign({}, $be1adfaa5ce5d8e4$exports, opts);
    return new RegExp("\\" + options.opening_character + "([^" + options.closing_character + "]+)" + "\\" + options.closing_character, "g");
}
$283c8f0374cf594f$exports = $283c8f0374cf594f$var$createReferenceRegex;


/**
 * Checks if the value uses a value reference.
 * @memberof Dictionary
 * @param {string} value
 * @param {Object|RegExp} regexOrOptions
 * @returns {boolean} - True, if the value uses a value reference
 */ function $ff3cc90cb76ac26c$var$usesReference(value, regexOrOptions = {}) {
    const regex = regexOrOptions instanceof RegExp ? regexOrOptions : $283c8f0374cf594f$exports(regexOrOptions);
    if (typeof value === "string") return regex.test(value);
    if (typeof value === "object") {
        let hasReference = false;
        // iterate over each property in the object,
        // if any element passes the regex test,
        // the whole thing should be true
        for(const key in value)if (value.hasOwnProperty(key)) {
            const element = value[key];
            let reference = $ff3cc90cb76ac26c$var$usesReference(element, regexOrOptions);
            if (reference) {
                hasReference = true;
                break;
            }
        }
        return hasReference;
    }
    return false;
}
$ff3cc90cb76ac26c$exports = $ff3cc90cb76ac26c$var$usesReference;



const $79988c6708933e3f$export$f9ebafeabd662d32 = "amplify", $79988c6708933e3f$var$s = [
    "offsetX",
    "offsetY",
    "blurRadius",
    "spreadRadius",
    "color"
];
function $79988c6708933e3f$var$i(e) {
    if (!e) return "";
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ff3cc90cb76ac26c$exports)))(e)) return `var(--${$79988c6708933e3f$export$8658ddf1aae625a3({
        path: e.replace(/\{|\}/g, "").replace(".value", "").split(".")
    })})`;
    return e;
}
function $79988c6708933e3f$export$55101aa37e5c1f8f(e) {
    const { value: t } = e;
    return (0, $15a7c5986a3f06c2$export$844ec244b1367d54)(t) ? $79988c6708933e3f$var$i(t) : $79988c6708933e3f$export$50306062f6ed54c(t) ? $79988c6708933e3f$var$s.map((n)=>$79988c6708933e3f$var$i($79988c6708933e3f$export$50306062f6ed54c(e) ? e[n] : t[n])).join(" ") : t;
}
function $79988c6708933e3f$export$8658ddf1aae625a3({ path: t = [] }) {
    return `${(0, (/*@__PURE__*/$parcel$interopDefault($fa74499edcf324c6$exports)))([
        $79988c6708933e3f$export$f9ebafeabd662d32,
        ...t
    ].join(" "))}`;
}
function $79988c6708933e3f$export$daee9cd42beef6d1(e) {
    return (0, $15a7c5986a3f06c2$export$a6cdc56e425d0d0a)(e) && (0, $15a7c5986a3f06c2$export$a4f4bb6b1453fff5)(e, "value");
}
function $79988c6708933e3f$export$50306062f6ed54c(e) {
    return (0, $15a7c5986a3f06c2$export$a6cdc56e425d0d0a)(e) && (0, $15a7c5986a3f06c2$export$a4f4bb6b1453fff5)(e, "offsetX");
}
function $79988c6708933e3f$export$4ae67d38aae8ca2e({ tokens: e, path: t = [], setupToken: o }) {
    if ((0, $15a7c5986a3f06c2$export$a4f4bb6b1453fff5)(e, "value")) return o({
        token: e,
        path: t
    });
    const u = {};
    for(const s in e)if ((0, $15a7c5986a3f06c2$export$a4f4bb6b1453fff5)(e, s)) {
        const r = e[s], i = (0, $15a7c5986a3f06c2$export$a6cdc56e425d0d0a)(r) ? r : {
            value: r
        };
        u[s] = $79988c6708933e3f$export$4ae67d38aae8ca2e({
            tokens: i,
            path: t.concat(s),
            setupToken: o
        });
    }
    return u;
}


const $750400f93007aa11$export$c69338bc7d797351 = {
    alignContent: "alignContent",
    alignItems: "alignItems",
    alignSelf: "alignSelf",
    area: "gridArea",
    aspectRatio: "aspectRatio",
    autoColumns: "gridAutoColumns",
    autoFlow: "gridAutoFlow",
    autoRows: "gridAutoRows",
    backgroundColor: "backgroundColor",
    backgroundImage: "backgroundImage",
    basis: "flexBasis",
    border: "border",
    borderRadius: "borderRadius",
    borderColor: "borderColor",
    borderWidth: "borderWidth",
    borderStyle: "borderStyle",
    bottom: "bottom",
    boxShadow: "boxShadow",
    color: "color",
    column: "gridColumn",
    columnEnd: "gridColumnEnd",
    columnGap: "columnGap",
    columnSpan: "gridColumn",
    columnStart: "gridColumnStart",
    direction: "flexDirection",
    display: "display",
    flex: "flex",
    fontFamily: "fontFamily",
    fontSize: "fontSize",
    fontStyle: "fontStyle",
    fontWeight: "fontWeight",
    gap: "gap",
    grow: "flexGrow",
    height: "height",
    justifyContent: "justifyContent",
    left: "left",
    letterSpacing: "letterSpacing",
    lineHeight: "lineHeight",
    margin: "margin",
    marginBlock: "marginBlock",
    marginBlockEnd: "marginBlockEnd",
    marginBlockStart: "marginBlockStart",
    marginBottom: "marginBlockEnd",
    marginInline: "marginInline",
    marginInlineEnd: "marginInlineEnd",
    marginInlineStart: "marginInlineStart",
    marginLeft: "marginInlineStart",
    marginRight: "marginInlineEnd",
    marginTop: "marginBlockStart",
    maxHeight: "maxHeight",
    maxWidth: "maxWidth",
    minHeight: "minHeight",
    minWidth: "minWidth",
    objectFit: "objectFit",
    objectPosition: "objectPosition",
    opacity: "opacity",
    order: "order",
    overflow: "overflow",
    padding: "padding",
    paddingBlock: "paddingBlock",
    paddingBlockEnd: "paddingBlockEnd",
    paddingBlockStart: "paddingBlockStart",
    paddingBottom: "paddingBlockEnd",
    paddingInline: "paddingInline",
    paddingInlineEnd: "paddingInlineEnd",
    paddingInlineStart: "paddingInlineStart",
    paddingLeft: "paddingInlineStart",
    paddingRight: "paddingInlineEnd",
    paddingTop: "paddingBlockStart",
    position: "position",
    resize: "resize",
    right: "right",
    row: "gridRow",
    rowEnd: "gridRowEnd",
    rowGap: "rowGap",
    rowSpan: "gridRow",
    rowStart: "gridRowStart",
    shrink: "flexShrink",
    templateAreas: "gridTemplateAreas",
    templateColumns: "gridTemplateColumns",
    templateRows: "gridTemplateRows",
    textAlign: "textAlign",
    textDecoration: "textDecoration",
    textTransform: "textTransform",
    top: "top",
    transform: "transform",
    transformOrigin: "transformOrigin",
    width: "width",
    whiteSpace: "whiteSpace",
    wrap: "flexWrap"
}, $750400f93007aa11$export$885e0ebc08cdd9a0 = Object.keys($750400f93007aa11$export$c69338bc7d797351);


const $a8975b29198b9cfb$export$6f3cc5789c9e770e = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};


const $2e0bbe07577db1fa$export$8f45430ccf837300 = {
    red: {
        10: {
            value: "hsl(0, 75%, 95%)"
        },
        20: {
            value: "hsl(0, 75%, 85%)"
        },
        40: {
            value: "hsl(0, 75%, 75%)"
        },
        60: {
            value: "hsl(0, 50%, 50%)"
        },
        80: {
            value: "hsl(0, 95%, 30%)"
        },
        90: {
            value: "hsl(0, 100%, 20%)"
        },
        100: {
            value: "hsl(0, 100%, 15%)"
        }
    },
    orange: {
        10: {
            value: "hsl(30, 75%, 95%)"
        },
        20: {
            value: "hsl(30, 75%, 85%)"
        },
        40: {
            value: "hsl(30, 75%, 75%)"
        },
        60: {
            value: "hsl(30, 50%, 50%)"
        },
        80: {
            value: "hsl(30, 95%, 30%)"
        },
        90: {
            value: "hsl(30, 100%, 20%)"
        },
        100: {
            value: "hsl(30, 100%, 15%)"
        }
    },
    yellow: {
        10: {
            value: "hsl(60, 75%, 95%)"
        },
        20: {
            value: "hsl(60, 75%, 85%)"
        },
        40: {
            value: "hsl(60, 75%, 75%)"
        },
        60: {
            value: "hsl(60, 50%, 50%)"
        },
        80: {
            value: "hsl(60, 95%, 30%)"
        },
        90: {
            value: "hsl(60, 100%, 20%)"
        },
        100: {
            value: "hsl(60, 100%, 15%)"
        }
    },
    green: {
        10: {
            value: "hsl(130, 60%, 95%)"
        },
        20: {
            value: "hsl(130, 60%, 90%)"
        },
        40: {
            value: "hsl(130, 44%, 63%)"
        },
        60: {
            value: "hsl(130, 43%, 46%)"
        },
        80: {
            value: "hsl(130, 33%, 37%)"
        },
        90: {
            value: "hsl(130, 27%, 29%)"
        },
        100: {
            value: "hsl(130, 22%, 23%)"
        }
    },
    teal: {
        10: {
            value: "hsl(190, 75%, 95%)"
        },
        20: {
            value: "hsl(190, 75%, 85%)"
        },
        40: {
            value: "hsl(190, 70%, 70%)"
        },
        60: {
            value: "hsl(190, 50%, 50%)"
        },
        80: {
            value: "hsl(190, 95%, 30%)"
        },
        90: {
            value: "hsl(190, 100%, 20%)"
        },
        100: {
            value: "hsl(190, 100%, 15%)"
        }
    },
    blue: {
        10: {
            value: "hsl(220, 95%, 95%)"
        },
        20: {
            value: "hsl(220, 85%, 85%)"
        },
        40: {
            value: "hsl(220, 70%, 70%)"
        },
        60: {
            value: "hsl(220, 50%, 50%)"
        },
        80: {
            value: "hsl(220, 95%, 30%)"
        },
        90: {
            value: "hsl(220, 100%, 20%)"
        },
        100: {
            value: "hsl(220, 100%, 15%)"
        }
    },
    purple: {
        10: {
            value: "hsl(300, 95%, 95%)"
        },
        20: {
            value: "hsl(300, 85%, 85%)"
        },
        40: {
            value: "hsl(300, 70%, 70%)"
        },
        60: {
            value: "hsl(300, 50%, 50%)"
        },
        80: {
            value: "hsl(300, 95%, 30%)"
        },
        90: {
            value: "hsl(300, 100%, 20%)"
        },
        100: {
            value: "hsl(300, 100%, 15%)"
        }
    },
    pink: {
        10: {
            value: "hsl(340, 95%, 95%)"
        },
        20: {
            value: "hsl(340, 90%, 85%)"
        },
        40: {
            value: "hsl(340, 70%, 70%)"
        },
        60: {
            value: "hsl(340, 50%, 50%)"
        },
        80: {
            value: "hsl(340, 95%, 30%)"
        },
        90: {
            value: "hsl(340, 100%, 20%)"
        },
        100: {
            value: "hsl(340, 100%, 15%)"
        }
    },
    neutral: {
        10: {
            value: "hsl(210, 5%, 98%)"
        },
        20: {
            value: "hsl(210, 5%, 94%)"
        },
        40: {
            value: "hsl(210, 5%, 87%)"
        },
        60: {
            value: "hsl(210, 10%, 58%)"
        },
        80: {
            value: "hsl(210, 10%, 40%)"
        },
        90: {
            value: "hsl(210, 25%, 25%)"
        },
        100: {
            value: "hsl(210, 50%, 10%)"
        }
    },
    brand: {
        primary: {
            10: {
                value: "{colors.teal.10.value}"
            },
            20: {
                value: "{colors.teal.20.value}"
            },
            40: {
                value: "{colors.teal.40.value}"
            },
            60: {
                value: "{colors.teal.60.value}"
            },
            80: {
                value: "{colors.teal.80.value}"
            },
            90: {
                value: "{colors.teal.90.value}"
            },
            100: {
                value: "{colors.teal.100.value}"
            }
        },
        secondary: {
            10: {
                value: "{colors.purple.10.value}"
            },
            20: {
                value: "{colors.purple.20.value}"
            },
            40: {
                value: "{colors.purple.40.value}"
            },
            60: {
                value: "{colors.purple.60.value}"
            },
            80: {
                value: "{colors.purple.80.value}"
            },
            90: {
                value: "{colors.purple.90.value}"
            },
            100: {
                value: "{colors.purple.100.value}"
            }
        }
    },
    font: {
        primary: {
            value: "{colors.neutral.100.value}"
        },
        secondary: {
            value: "{colors.neutral.90.value}"
        },
        tertiary: {
            value: "{colors.neutral.80.value}"
        },
        disabled: {
            value: "{colors.neutral.60.value}"
        },
        inverse: {
            value: "{colors.white.value}"
        },
        interactive: {
            value: "{colors.brand.primary.80.value}"
        },
        hover: {
            value: "{colors.brand.primary.90.value}"
        },
        focus: {
            value: "{colors.brand.primary.100.value}"
        },
        active: {
            value: "{colors.brand.primary.100.value}"
        },
        info: {
            value: "{colors.blue.90.value}"
        },
        warning: {
            value: "{colors.orange.90.value}"
        },
        error: {
            value: "{colors.red.90.value}"
        },
        success: {
            value: "{colors.green.90.value}"
        }
    },
    background: {
        primary: {
            value: "{colors.white.value}"
        },
        secondary: {
            value: "{colors.neutral.10.value}"
        },
        tertiary: {
            value: "{colors.neutral.20.value}"
        },
        quaternary: {
            value: "{colors.neutral.60.value}"
        },
        disabled: {
            value: "{colors.background.tertiary.value}"
        },
        info: {
            value: "{colors.blue.10.value}"
        },
        warning: {
            value: "{colors.orange.10.value}"
        },
        error: {
            value: "{colors.red.10.value}"
        },
        success: {
            value: "{colors.green.10.value}"
        }
    },
    border: {
        primary: {
            value: "{colors.neutral.60.value}"
        },
        secondary: {
            value: "{colors.neutral.40.value}"
        },
        tertiary: {
            value: "{colors.neutral.20.value}"
        },
        disabled: {
            value: "{colors.border.tertiary.value}"
        },
        pressed: {
            value: "{colors.brand.primary.100.value}"
        },
        focus: {
            value: "{colors.brand.primary.100.value}"
        },
        error: {
            value: "{colors.red.80.value}"
        },
        info: {
            value: "{colors.blue.80.value}"
        },
        success: {
            value: "{colors.green.80.value}"
        },
        warning: {
            value: "{colors.orange.80.value}"
        }
    },
    shadow: {
        primary: {
            value: "hsla(210, 50%, 10%, 0.25)"
        },
        secondary: {
            value: "hsla(210, 50%, 10%, 0.15)"
        },
        tertiary: {
            value: "hsla(210, 50%, 10%, 0.05)"
        }
    },
    overlay: {
        5: {
            value: "hsla(0, 0%, 0%, 0.05)"
        },
        10: {
            value: "hsla(0, 0%, 0%, 0.1)"
        },
        20: {
            value: "hsla(0, 0%, 0%, 0.2)"
        },
        30: {
            value: "hsla(0, 0%, 0%, 0.3)"
        },
        40: {
            value: "hsla(0, 0%, 0%, 0.4)"
        },
        50: {
            value: "hsla(0, 0%, 0%, 0.5)"
        },
        60: {
            value: "hsla(0, 0%, 0%, 0.6)"
        },
        70: {
            value: "hsla(0, 0%, 0%, 0.7)"
        },
        80: {
            value: "hsla(0, 0%, 0%, 0.8)"
        },
        90: {
            value: "hsla(0, 0%, 0%, 0.9)"
        }
    },
    black: {
        value: "hsl(0, 0%, 0%)"
    },
    white: {
        value: "hsl(0, 0%, 100%)"
    },
    transparent: {
        value: "transparent"
    }
};


const $bec4305ae6d66eaf$export$5ea928c9faf85bd3 = {
    alignItems: {
        value: "center"
    },
    justifyContent: {
        value: "space-between"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    paddingBlock: {
        value: "{space.small.value}"
    },
    paddingInline: {
        value: "{space.medium.value}"
    },
    icon: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    heading: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    info: {
        color: {
            value: "{colors.font.info.value}"
        },
        backgroundColor: {
            value: "{colors.background.info.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        backgroundColor: {
            value: "{colors.background.error.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        },
        backgroundColor: {
            value: "{colors.background.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        },
        backgroundColor: {
            value: "{colors.background.success.value}"
        }
    }
};


const $19d27a80d95aea0a$export$485ded5f26ebe08d = {
    menu: {
        width: {
            value: "100%"
        },
        marginBlockStart: {
            value: "{space.xxxs}"
        },
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        options: {
            display: {
                value: "flex"
            },
            flexDirection: {
                value: "column"
            },
            maxHeight: {
                value: "300px"
            }
        },
        option: {
            backgroundColor: {
                value: "{colors.background.primary}"
            },
            color: {
                value: "currentcolor"
            },
            cursor: {
                value: "pointer"
            },
            transitionDuration: {
                value: "{time.short}"
            },
            transitionProperty: {
                value: "background-color, color"
            },
            transitionTimingFunction: {
                value: "ease"
            },
            _active: {
                backgroundColor: {
                    value: "{colors.brand.primary.80}"
                },
                color: {
                    value: "{colors.white}"
                }
            }
        },
        _empty: {
            display: {
                value: "flex"
            }
        },
        _loading: {
            alignItems: {
                value: "center"
            },
            display: {
                value: "flex"
            },
            gap: {
                value: "{space.xxxs}"
            }
        },
        spaceShared: {
            paddingBlock: {
                value: "{space.xs}"
            },
            paddingInline: {
                value: "{space.small}"
            }
        }
    }
};


const $41f4c1bd3a4174a0$export$d5cb6eef88ffbde2 = {
    maxWidth: {
        value: "60rem"
    },
    modal: {
        width: {
            value: "{space.relative.full}"
        },
        height: {
            value: "{space.relative.full}"
        },
        backgroundColor: {
            value: "{colors.overlay.50.value}"
        },
        top: {
            value: "{space.zero}"
        },
        left: {
            value: "{space.zero}"
        }
    },
    container: {
        widthMax: {
            value: "30rem"
        }
    },
    router: {
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        boxShadow: {
            value: "{shadows.medium.value}"
        }
    },
    footer: {
        paddingBottom: {
            value: "{space.medium.value}"
        }
    },
    form: {
        padding: {
            value: "{space.xl.value}"
        }
    },
    state: {
        inactive: {
            backgroundColor: {
                value: "{colors.background.secondary.value}"
            }
        }
    },
    orContainer: {
        color: {
            value: "{colors.neutral.80.value}"
        },
        orLine: {
            backgroundColor: {
                value: "{colors.background.primary.value}"
            }
        }
    }
};


const $1e8fe783c8d33315$export$4aebd143f31d0c0d = {
    color: {
        value: "{colors.font.primary.value}"
    },
    lineHeight: {
        value: 1
    },
    fontWeight: {
        value: "{fontWeights.semibold.value}"
    },
    fontSize: {
        value: "{fontSizes.small.value}"
    },
    textAlign: {
        value: "center"
    },
    paddingVertical: {
        value: "{space.xs.value}"
    },
    paddingHorizontal: {
        value: "{space.small.value}"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    borderRadius: {
        value: "{radii.xl.value}"
    },
    info: {
        color: {
            value: "{colors.font.info.value}"
        },
        backgroundColor: {
            value: "{colors.background.info.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        },
        backgroundColor: {
            value: "{colors.background.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        },
        backgroundColor: {
            value: "{colors.background.success.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        backgroundColor: {
            value: "{colors.background.error.value}"
        }
    },
    small: {
        fontSize: {
            value: "{fontSizes.xs.value}"
        },
        paddingVertical: {
            value: "{space.xxs.value}"
        },
        paddingHorizontal: {
            value: "{space.xs.value}"
        }
    },
    large: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        paddingVertical: {
            value: "{space.small.value}"
        },
        paddingHorizontal: {
            value: "{space.medium.value}"
        }
    }
};


const $24f22a7c51d90b29$export$515d2155aaad79e4 = {
    flexDirection: {
        value: "row"
    },
    flexWrap: {
        value: "wrap"
    },
    gap: {
        value: "0"
    },
    color: {
        value: "{colors.font.tertiary}"
    },
    item: {
        flexDirection: {
            value: "row"
        },
        color: {
            value: "inherit"
        },
        fontSize: {
            value: "inherit"
        },
        alignItems: {
            value: "center"
        },
        lineHeight: {
            value: "1"
        }
    },
    separator: {
        color: {
            value: "inherit"
        },
        fontSize: {
            value: "inherit"
        },
        paddingInline: {
            value: "{space.xxs}"
        }
    },
    link: {
        color: {
            value: "{components.link.color}"
        },
        fontSize: {
            value: "inherit"
        },
        fontWeight: {
            value: "normal"
        },
        textDecoration: {
            value: "none"
        },
        paddingInline: {
            value: "{space.xs}"
        },
        paddingBlock: {
            value: "{space.xxs}"
        },
        current: {
            color: {
                value: "inherit"
            },
            fontSize: {
                value: "inherit"
            },
            fontWeight: {
                value: "normal"
            },
            textDecoration: {
                value: "none"
            }
        }
    }
};


const $0c80b08df2937294$export$2ba01fb71ed41cb6 = {
    fontWeight: {
        value: "{fontWeights.bold.value}"
    },
    transitionDuration: {
        value: "{components.fieldcontrol.transitionDuration.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    lineHeight: {
        value: "{components.fieldcontrol.lineHeight.value}"
    },
    paddingBlockStart: {
        value: "{components.fieldcontrol.paddingBlockStart.value}"
    },
    paddingBlockEnd: {
        value: "{components.fieldcontrol.paddingBlockEnd.value}"
    },
    paddingInlineStart: {
        value: "{components.fieldcontrol.paddingInlineStart.value}"
    },
    paddingInlineEnd: {
        value: "{components.fieldcontrol.paddingInlineEnd.value}"
    },
    backgroundColor: {
        value: "transparent"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    borderWidth: {
        value: "{components.fieldcontrol.borderWidth.value}"
    },
    borderStyle: {
        value: "{components.fieldcontrol.borderStyle.value}"
    },
    borderRadius: {
        value: "{components.fieldcontrol.borderRadius.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    _hover: {
        color: {
            value: "{colors.font.focus.value}"
        },
        backgroundColor: {
            value: "{colors.brand.primary.10.value}"
        },
        borderColor: {
            value: "{colors.brand.primary.60.value}"
        }
    },
    _focus: {
        color: {
            value: "{colors.font.focus.value}"
        },
        backgroundColor: {
            value: "{colors.brand.primary.10.value}"
        },
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        boxShadow: {
            value: "{components.fieldcontrol._focus.boxShadow.value}"
        }
    },
    _active: {
        color: {
            value: "{colors.font.active.value}"
        },
        backgroundColor: {
            value: "{colors.brand.primary.20.value}"
        },
        borderColor: {
            value: "{colors.brand.primary.100.value}"
        }
    },
    _loading: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.tertiary.value}"
        }
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.tertiary.value}"
        }
    },
    outlined: {
        info: {
            borderColor: {
                value: "{colors.blue.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.blue.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.blue.60.value}"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.blue.100.value}"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.blue.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.blue.100.value}"
                },
                backgroundColor: {
                    value: "{colors.blue.20.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                }
            }
        },
        warning: {
            borderColor: {
                value: "{colors.orange.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.orange.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.orange.60.value}"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.orange.100.value}"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.orange.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.orange.100.value}"
                },
                backgroundColor: {
                    value: "{colors.orange.20.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                }
            }
        },
        success: {
            borderColor: {
                value: "{colors.green.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.green.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.green.60.value}"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.green.100.value}"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.green.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.green.100.value}"
                },
                backgroundColor: {
                    value: "{colors.green.20.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                }
            }
        },
        error: {
            borderColor: {
                value: "{colors.red.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.red.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.red.60.value}"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.red.100.value}"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.red.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.red.100.value}"
                },
                backgroundColor: {
                    value: "{colors.red.20.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                }
            }
        },
        overlay: {
            borderColor: {
                value: "{colors.overlay.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.primary.value}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.overlay.60.value}"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.neutral.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.neutral.90.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.overlay.90.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.overlay.10.value}"
                },
                color: {
                    value: "{colors.neutral.100.value}"
                }
            }
        }
    },
    primary: {
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        backgroundColor: {
            value: "{colors.brand.primary.80.value}"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.90.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.90.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.100.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            }
        },
        info: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.blue.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.blue.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        warning: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.orange.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.orange.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        error: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.red.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        success: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.green.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.green.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        overlay: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.overlay.70}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.overlay.90.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        }
    },
    menu: {
        borderWidth: {
            value: "{space.zero.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        justifyContent: {
            value: "start"
        },
        _hover: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.brand.primary.80.value}"
            }
        },
        _focus: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.brand.primary.80.value}"
            }
        },
        _active: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.brand.primary.90.value}"
            }
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    link: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.interactive.value}"
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.10.value}"
            },
            color: {
                value: "{colors.font.hover.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.10.value}"
            },
            color: {
                value: "{colors.font.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.20.value}"
            },
            color: {
                value: "{colors.font.active.value}"
            }
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        info: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.blue.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.blue.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.20.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                }
            }
        },
        warning: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.orange.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.orange.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.20.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                }
            }
        },
        success: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.green.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.green.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.20.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                }
            }
        },
        error: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.red.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.red.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.20.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                }
            }
        },
        overlay: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.neutral.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.overlay.80.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.overlay.90.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.10.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                }
            }
        }
    },
    warning: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.red.60}"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        color: {
            value: "{colors.red.60}"
        },
        _hover: {
            borderColor: {
                value: "{colors.red.80}"
            },
            backgroundColor: {
                value: "{colors.red.10}"
            },
            color: {
                value: "{colors.font.error}"
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.red.80}"
            },
            backgroundColor: {
                value: "{colors.red.10}"
            },
            color: {
                value: "{colors.red.80}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._error._focus.boxShadow}"
            }
        },
        _active: {
            borderColor: {
                value: "{colors.red.100}"
            },
            backgroundColor: {
                value: "{colors.red.20}"
            },
            color: {
                value: "{colors.red.100}"
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.tertiary}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        },
        _loading: {
            borderColor: {
                value: "{colors.border.tertiary}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        }
    },
    destructive: {
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderStyle: {
            value: "solid"
        },
        backgroundColor: {
            value: "{colors.red.60}"
        },
        color: {
            value: "{colors.font.inverse}"
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled}"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled}"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.80}"
            },
            color: {
                value: "{colors.font.inverse}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.80}"
            },
            color: {
                value: "{colors.font.inverse}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._error._focus.boxShadow}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.100}"
            },
            color: {
                value: "{colors.font.inverse}"
            }
        }
    },
    small: {
        fontSize: {
            value: "{components.fieldcontrol.small.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{components.fieldcontrol.small.paddingBlockStart.value}"
        },
        paddingBlockEnd: {
            value: "{components.fieldcontrol.small.paddingBlockEnd.value}"
        },
        paddingInlineStart: {
            value: "{components.fieldcontrol.small.paddingInlineStart.value}"
        },
        paddingInlineEnd: {
            value: "{components.fieldcontrol.small.paddingInlineEnd.value}"
        }
    },
    large: {
        fontSize: {
            value: "{components.fieldcontrol.large.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{components.fieldcontrol.large.paddingBlockStart.value}"
        },
        paddingBlockEnd: {
            value: "{components.fieldcontrol.large.paddingBlockEnd.value}"
        },
        paddingInlineStart: {
            value: "{components.fieldcontrol.large.paddingInlineStart.value}"
        },
        paddingInlineEnd: {
            value: "{components.fieldcontrol.large.paddingInlineEnd.value}"
        }
    },
    loaderWrapper: {
        alignItems: {
            value: "center"
        },
        gap: {
            value: "{space.xs.value}"
        }
    }
};


const $6d665a1d82ea047e$export$aa3e815946b80764 = {
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    borderWidth: {
        value: "0"
    },
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "transparent"
    },
    boxShadow: {
        value: "none"
    },
    padding: {
        value: "{space.medium.value}"
    },
    outlined: {
        backgroundColor: {
            value: "{components.card.backgroundColor.value}"
        },
        borderRadius: {
            value: "{radii.xs.value}"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        boxShadow: {
            value: "{components.card.boxShadow.value}"
        }
    },
    elevated: {
        backgroundColor: {
            value: "{components.card.backgroundColor.value}"
        },
        borderRadius: {
            value: "{radii.xs.value}"
        },
        borderWidth: {
            value: "0"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "transparent"
        },
        boxShadow: {
            value: "{shadows.medium.value}"
        }
    }
};


const $883caafbc212356e$export$b07e517d22efa1ca = {
    cursor: {
        value: "pointer"
    },
    alignItems: {
        value: "center"
    },
    _disabled: {
        cursor: {
            value: "not-allowed"
        }
    },
    button: {
        position: {
            value: "relative"
        },
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        before: {
            width: {
                value: "100%"
            },
            height: {
                value: "100%"
            },
            borderWidth: {
                value: "{borderWidths.medium.value}"
            },
            borderRadius: {
                value: "20%"
            },
            borderStyle: {
                value: "solid"
            },
            borderColor: {
                value: "{colors.border.primary.value}"
            }
        },
        _focus: {
            outlineColor: {
                value: "{colors.transparent.value}"
            },
            outlineStyle: {
                value: "solid"
            },
            outlineWidth: {
                value: "{outlineWidths.medium.value}"
            },
            outlineOffset: {
                value: "{outlineOffsets.medium.value}"
            },
            borderColor: {
                value: "{colors.transparent.value}"
            },
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.border.focus.value}"
                }
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            }
        },
        _error: {
            borderColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                borderColor: {
                    value: "{colors.transparent.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "2px",
                        color: "{colors.border.error.value}"
                    }
                }
            }
        }
    },
    icon: {
        backgroundColor: {
            value: "{colors.brand.primary.80.value}"
        },
        borderRadius: {
            value: "20%"
        },
        opacity: {
            value: "{opacities.0.value}"
        },
        transform: {
            value: "scale(0)"
        },
        transitionProperty: {
            value: "all"
        },
        transitionDuration: {
            value: "{time.short.value}"
        },
        transitionTimingFunction: {
            value: "ease-in-out"
        },
        _checked: {
            opacity: {
                value: "{opacities.100.value}"
            },
            transform: {
                value: "scale(1)"
            },
            _disabled: {
                backgroundColor: {
                    value: "{colors.background.disabled.value}"
                }
            }
        },
        _indeterminate: {
            opacity: {
                value: "{opacities.100.value}"
            },
            transform: {
                value: "scale(1)"
            },
            _disabled: {
                backgroundColor: {
                    value: "{colors.background.disabled.value}"
                }
            }
        }
    },
    label: {
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    }
};


const $3ee1929fe38456a5$export$282c9e915736aefa = {
    alignItems: {
        value: "flex-start"
    },
    alignContent: {
        value: "center"
    },
    flexDirection: {
        value: "column"
    },
    justifyContent: {
        value: "center"
    }
};


const $f4543b6713bfc928$export$bf5175b0c24981cd = {
    pagination: {
        current: {
            color: {
                value: "{components.pagination.current.color}"
            },
            backgroundColor: {
                value: "{components.pagination.current.backgroundColor}"
            }
        },
        button: {
            color: {
                value: "{components.pagination.button.color}"
            },
            _hover: {
                backgroundColor: {
                    value: "{components.pagination.button.hover.backgroundColor}"
                },
                color: {
                    value: "{components.pagination.button.hover.color}"
                }
            },
            _disabled: {
                color: {
                    value: "{components.pagination.button.disabled.color}"
                }
            }
        }
    },
    search: {
        input: {
            color: {
                value: "{components.searchfield.color}"
            }
        },
        button: {
            color: {
                value: "{components.searchfield.button.color}"
            },
            _active: {
                backgroundColor: {
                    value: "{components.searchfield.button._active.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._active.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._active.color}"
                }
            },
            _disabled: {
                backgroundColor: {
                    value: "{components.searchfield.button._disabled.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._disabled.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._disabled.color}"
                }
            },
            _focus: {
                backgroundColor: {
                    value: "{components.searchfield.button._focus.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._focus.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._focus.color}"
                }
            },
            _hover: {
                backgroundColor: {
                    value: "{components.searchfield.button._hover.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._hover.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._hover.color}"
                }
            }
        }
    }
};


const $8db344c3fb954ff7$export$784d13d8ee351f07 = {
    fontSize: {
        value: "{fontSizes.xs}"
    },
    gap: {
        value: "{space.relative.medium}"
    },
    svg: {
        path: {
            fill: {
                value: "{colors.font.primary}"
            }
        }
    },
    toolTip: {
        bottom: {
            value: "{space.large}"
        },
        color: {
            value: "{colors.teal.100}"
        },
        fontSize: {
            value: "{fontSizes.xxs}"
        }
    }
};


const $1a2a749b4e933021$export$5a80fc6ecf647d64 = {
    height: {
        value: "{space.relative.full.value}"
    }
};


const $7867047f959439e5$export$e8c9778bf415dd08 = {
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    borderWidth: {
        value: "{borderWidths.medium.value}"
    },
    label: {
        color: {
            value: "{colors.font.tertiary.value}"
        },
        paddingInline: {
            value: "{space.medium.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        }
    },
    small: {
        borderWidth: {
            value: "{borderWidths.small.value}"
        }
    },
    large: {
        borderWidth: {
            value: "{borderWidths.large.value}"
        }
    },
    opacity: {
        value: "{opacities.60.value}"
    }
};


const $e6be58ce2ad0628e$export$585d0a7a39ed94ea = {
    backgroundColor: {
        value: "{colors.background.primary}"
    },
    borderRadius: {
        value: "{radii.small}"
    },
    borderColor: {
        value: "{colors.border.primary}"
    },
    borderStyle: {
        value: "dashed"
    },
    borderWidth: {
        value: "{borderWidths.small}"
    },
    color: {
        value: "{colors.font.primary}"
    },
    gap: {
        value: "{space.small}"
    },
    paddingBlock: {
        value: "{space.xl}"
    },
    paddingInline: {
        value: "{space.large}"
    },
    textAlign: {
        value: "center"
    },
    _active: {
        backgroundColor: {
            value: "{colors.brand.primary.10}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.pressed}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.primary}"
        }
    },
    _disabled: {
        backgroundColor: {
            value: "{colors.background.disabled}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.disabled}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.disabled}"
        }
    },
    accepted: {
        backgroundColor: {
            value: "{colors.background.success}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.success}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.success}"
        }
    },
    rejected: {
        backgroundColor: {
            value: "{colors.background.error}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.pressed}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.error}"
        }
    }
};


const $b4fc23392a1382f9$export$f194ed9df726ec47 = {
    display: {
        value: "block"
    },
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.medium.value}"
    },
    boxShadow: {
        value: "{shadows.large.value}"
    },
    width: {
        value: "100%"
    },
    item: {
        marginTop: {
            value: "1px"
        },
        boxShadow: {
            value: "{shadows.small.value}"
        },
        borderBottomLeftRadius: {
            value: "{radii.medium.value}"
        },
        borderBottomRightRadius: {
            value: "{radii.medium.value}"
        },
        borderTopLeftRadius: {
            value: "{radii.medium.value}"
        },
        borderTopRightRadius: {
            value: "{radii.medium.value}"
        },
        borderStartStartRadius: {
            value: "{radii.medium.value}"
        },
        borderStartEndRadius: {
            value: "{radii.medium.value}"
        },
        borderEndStartRadius: {
            value: "{radii.medium.value}"
        },
        borderEndEndRadius: {
            value: "{radii.medium.value}"
        },
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0",
                    offsetY: "0",
                    blurRadius: "0",
                    spreadRadius: "2px",
                    color: "{colors.border.focus.value}"
                }
            }
        }
    },
    header: {
        boxShadow: {
            value: {
                offsetX: "0",
                offsetY: "1px",
                blurRadius: "0",
                color: "{colors.overlay.20.value}"
            }
        }
    },
    trigger: {
        minHeight: {
            value: "3rem"
        },
        paddingInlineStart: {
            value: "{space.large.value}"
        },
        paddingInlineEnd: {
            value: "{space.large.value}"
        },
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "space-between"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            }
        }
    },
    content: {
        paddingInlineStart: {
            value: "{space.large.value}"
        },
        paddingInlineEnd: {
            value: "{space.large.value}"
        },
        text: {
            color: {
                value: "{colors.font.secondary.value}"
            },
            paddingBlockStart: {
                value: "{space.medium.value}"
            },
            paddingBlockEnd: {
                value: "{space.medium.value}"
            }
        },
        _open: {
            animationDuration: {
                value: "{time.medium.value}"
            },
            animationTimingFunction: {
                value: "cubic-bezier(0.87, 0, 0.13, 1)"
            }
        },
        _closed: {
            animationDuration: {
                value: "{time.medium.value}"
            },
            animationTimingFunction: {
                value: "cubic-bezier(0.87, 0, 0.13, 1)"
            }
        }
    },
    icon: {
        transitionDuration: {
            value: "{time.medium.value}"
        },
        transitionTimingFunction: {
            value: "cubic-bezier(0.87, 0, 0.13, 1)"
        }
    }
};


const $59c31b53b3006a12$export$e0f35d825088c098 = {
    gap: {
        value: "{space.xs.value}"
    },
    fontSize: {
        value: "{fontSizes.medium.value}"
    },
    flexDirection: {
        value: "column"
    },
    small: {
        gap: {
            value: "{space.xxxs.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    large: {
        gap: {
            value: "{space.small.value}"
        },
        fontSize: {
            value: "{fontSizes.large.value}"
        }
    },
    label: {
        color: {
            value: "{colors.font.secondary.value}"
        }
    }
};


const $97b7d4879e2615ef$export$5ba822cdf6eca6d5 = {
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderRadius: {
        value: "{radii.small.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    paddingBlockStart: {
        value: "{space.xs.value}"
    },
    paddingBlockEnd: {
        value: "{space.xs.value}"
    },
    paddingInlineStart: {
        value: "{space.medium.value}"
    },
    paddingInlineEnd: {
        value: "{space.medium.value}"
    },
    fontSize: {
        value: "{components.field.fontSize.value}"
    },
    lineHeight: {
        value: "{lineHeights.medium.value}"
    },
    transitionDuration: {
        value: "{time.medium.value}"
    },
    outlineColor: {
        value: "{colors.transparent.value}"
    },
    outlineStyle: {
        value: "solid"
    },
    outlineWidth: {
        value: "{outlineWidths.medium.value}"
    },
    outlineOffset: {
        value: "{outlineOffsets.medium.value}"
    },
    small: {
        fontSize: {
            value: "{components.field.small.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{space.xxs.value}"
        },
        paddingBlockEnd: {
            value: "{space.xxs.value}"
        },
        paddingInlineStart: {
            value: "{space.small.value}"
        },
        paddingInlineEnd: {
            value: "{space.small.value}"
        }
    },
    large: {
        fontSize: {
            value: "{components.field.large.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{space.xs.value}"
        },
        paddingBlockEnd: {
            value: "{space.xs.value}"
        },
        paddingInlineStart: {
            value: "{space.medium.value}"
        },
        paddingInlineEnd: {
            value: "{space.medium.value}"
        }
    },
    quiet: {
        borderStyle: {
            value: "none"
        },
        borderInlineStart: {
            value: "none"
        },
        borderInlineEnd: {
            value: "none"
        },
        borderBlockStart: {
            value: "none"
        },
        borderRadius: {
            value: "0"
        },
        _focus: {
            borderBlockEndColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "1px",
                    color: "{colors.border.focus.value}",
                    blurRadius: "0px"
                }
            }
        },
        _error: {
            borderBlockEndColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "1px",
                        color: "{colors.border.error.value}",
                        blurRadius: "0px"
                    }
                }
            }
        }
    },
    _focus: {
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        boxShadow: {
            value: {
                offsetX: "0px",
                offsetY: "0px",
                blurRadius: "0px",
                spreadRadius: "1px",
                color: "{colors.border.focus.value}"
            }
        }
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        cursor: {
            value: "not-allowed"
        },
        borderColor: {
            value: "{colors.transparent.value}"
        },
        backgroundColor: {
            value: "{colors.background.disabled.value}"
        }
    },
    _error: {
        borderColor: {
            value: "{colors.border.error.value}"
        },
        color: {
            value: "{colors.font.error.value}"
        },
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "1px",
                    color: "{colors.border.error.value}"
                }
            }
        }
    }
};


const $a9e92787979aad5d$export$886e4abc352a8403 = {
    gap: {
        value: "{space.zero.value}"
    },
    vertical: {
        alignItems: {
            value: "center"
        }
    },
    outer: {
        alignItems: {
            value: "center"
        }
    }
};


const $4a33cdbb5d7ba73b$export$a38812d1aa1302d9 = {
    backgroundColor: {
        value: "transparent"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    flexDirection: {
        value: "column"
    },
    gap: {
        value: "{components.field.gap.value}"
    },
    legend: {
        color: {
            value: "{colors.font.primary.value}"
        },
        fontSize: {
            value: "{components.field.fontSize.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        lineHeight: {
            value: "{lineHeights.medium.value}"
        },
        small: {
            fontSize: "{components.field.small.fontSize.value}"
        },
        large: {
            fontSize: "{components.field.large.fontSize.value}"
        }
    },
    outlined: {
        padding: "{space.medium.value}",
        borderColor: "{colors.neutral.40.value}",
        borderWidth: "{borderWidths.small.value}",
        borderStyle: "solid",
        small: {
            padding: "{space.small.value}"
        },
        large: {
            padding: "{space.large.value}"
        }
    },
    small: {
        gap: "{components.field.small.gap.value}"
    },
    large: {
        gap: "{components.field.large.gap.value}"
    }
};


const $0a54c96138c270f2$export$b29676ca3eb575f7 = {
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    description: {
        color: {
            value: "{colors.font.secondary.value}"
        },
        fontStyle: {
            value: "italic"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    }
};


const $51f6f3218de3b3d8$export$ec053a04994851f2 = {
    dropzone: {
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderStyle: {
            value: "dashed"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        gap: {
            value: "{space.small}"
        },
        paddingBlock: {
            value: "{space.xl}"
        },
        paddingInline: {
            value: "{space.large}"
        },
        textAlign: {
            value: "center"
        },
        _active: {
            backgroundColor: {
                value: "{colors.brand.primary.10}"
            },
            borderRadius: {
                value: "{components.fileuploader.dropzone.borderRadius}"
            },
            borderColor: {
                value: "{colors.border.pressed}"
            },
            borderStyle: {
                value: "{components.fileuploader.dropzone.borderStyle}"
            },
            borderWidth: {
                value: "{borderWidths.medium}"
            }
        },
        icon: {
            color: {
                value: "{colors.border.primary}"
            },
            fontSize: {
                value: "{fontSizes.xxl}"
            }
        },
        text: {
            color: {
                value: "{colors.font.tertiary}"
            },
            fontSize: {
                value: "{fontSizes.medium}"
            },
            fontWeight: {
                value: "{fontWeights.bold}"
            }
        }
    },
    file: {
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        paddingBlock: {
            value: "{space.xs}"
        },
        paddingInline: {
            value: "{space.small}"
        },
        gap: {
            value: "{space.small}"
        },
        alignItems: {
            value: "baseline"
        },
        name: {
            fontSize: {
                value: "{fontSizes.medium}"
            },
            fontWeight: {
                value: "{fontWeights.bold}"
            },
            color: {
                value: "{colors.font.primary}"
            }
        },
        size: {
            fontSize: {
                value: "{fontSizes.small}"
            },
            fontWeight: {
                value: "{fontWeights.normal}"
            },
            color: {
                value: "{colors.font.tertiary}"
            }
        },
        image: {
            width: {
                value: "{space.xxl}"
            },
            height: {
                value: "{space.xxl}"
            },
            backgroundColor: {
                value: "{colors.background.secondary}"
            },
            color: {
                value: "{colors.font.tertiary}"
            },
            borderRadius: {
                value: "{radii.small}"
            }
        }
    },
    loader: {
        strokeLinecap: {
            value: "round"
        },
        strokeEmpty: {
            value: "{colors.border.secondary}"
        },
        strokeFilled: {
            value: "{components.loader.strokeFilled}"
        },
        strokeWidth: {
            value: "{borderWidths.large}"
        }
    },
    previewer: {
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        paddingBlock: {
            value: "{space.zero}"
        },
        paddingInline: {
            value: "{space.zero}"
        },
        maxHeight: {
            value: "40rem"
        },
        maxWidth: {
            value: "auto"
        },
        text: {
            fontSize: {
                value: "{fontSizes.medium}"
            },
            fontWeight: {
                value: "{fontWeights.bold}"
            },
            color: {
                value: "{colors.font.primary}"
            }
        },
        body: {
            paddingBlock: {
                value: "{space.medium}"
            },
            paddingInline: {
                value: "{space.medium}"
            },
            gap: {
                value: "{space.small}"
            }
        },
        footer: {
            borderColor: {
                value: "{colors.border.secondary}"
            },
            borderStyle: {
                value: "solid"
            },
            borderWidth: {
                value: "{borderWidths.small}"
            },
            paddingBlock: {
                value: "{space.medium}"
            },
            paddingInline: {
                value: "{space.medium}"
            },
            justifyContent: {
                value: "space-between"
            }
        }
    }
};


const $16ff6fc9bbd54056$export$97691fbb80847c19 = {
    gap: {
        value: "{space.medium.value}"
    },
    justifyContent: {
        value: "normal"
    },
    alignItems: {
        value: "stretch"
    },
    alignContent: {
        value: "normal"
    },
    flexWrap: {
        value: "nowrap"
    }
};


const $af76cb595b84d485$export$46e4a324ac90507f = {
    color: {
        value: "{colors.font.primary.value}"
    },
    lineHeight: {
        value: "{lineHeights.small.value}"
    },
    1: {
        fontSize: {
            value: "{fontSizes.xxxxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.light.value}"
        }
    },
    2: {
        fontSize: {
            value: "{fontSizes.xxxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.normal.value}"
        }
    },
    3: {
        fontSize: {
            value: "{fontSizes.xxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.medium.value}"
        }
    },
    4: {
        fontSize: {
            value: "{fontSizes.xl.value}"
        },
        fontWeight: {
            value: "{fontWeights.semibold.value}"
        }
    },
    5: {
        fontSize: {
            value: "{fontSizes.large.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    6: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.extrabold.value}"
        }
    }
};


const $228fa908dc7770eb$export$5340050496cd0f8f = {
    highlighted: {
        fontWeight: {
            value: "{fontWeights.bold}"
        }
    }
};


const $58807e7e8b206d6e$export$1ca1ec8b29a4ce27 = {
    lineHeight: {
        value: 1
    },
    height: {
        value: "1em"
    }
};


const $b81024d15d3d3618$export$b7e3ae3d7c15e42e = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};


const $9fbcf71a23db9e28$export$5c452ff88e35e47d = {
    maxWidth: {
        value: "100%"
    },
    height: {
        value: "auto"
    },
    objectFit: {
        value: "initial"
    },
    objectPosition: {
        value: "initial"
    }
};


const $d6f6f4015629c2d0$export$be5f4c7eec37e17e = {
    banner: {
        height: {
            value: "150px "
        },
        width: {
            value: "400px "
        }
    },
    button: {
        backgroundColor: {
            value: "#e8e8e8"
        },
        borderRadius: {
            value: "5px"
        },
        color: {
            value: "black"
        }
    },
    dialog: {
        height: {
            value: "50vh"
        },
        minHeight: {
            value: "400px"
        },
        minWidth: {
            value: "400px"
        },
        width: {
            value: "30vw"
        }
    },
    header: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.extrabold.value}"
        }
    }
};


const $9989e6e3b387a601$export$9c30223ca0a664fb = {
    active: {
        color: {
            value: "{colors.font.active.value}"
        }
    },
    color: {
        value: "{colors.font.interactive.value}"
    },
    focus: {
        color: {
            value: "{colors.font.focus.value}"
        }
    },
    hover: {
        color: {
            value: "{colors.font.hover.value}"
        }
    },
    visited: {
        color: {
            value: "{colors.font.interactive.value}"
        }
    }
};


const $5823b9ba2649253d$export$674047c1a0a83243 = {
    cameraModule: {
        backgroundColor: {
            value: "{colors.black}"
        }
    }
};


const $e7e751e0333962e3$export$f4c5de44377d2946 = {
    width: {
        value: "{fontSizes.medium.value}"
    },
    height: {
        value: "{fontSizes.medium.value}"
    },
    fontSize: {
        value: "{fontSizes.xs.value}"
    },
    strokeEmpty: {
        value: "{colors.neutral.20.value}"
    },
    strokeFilled: {
        value: "{colors.brand.primary.80.value}"
    },
    strokeLinecap: {
        value: "round"
    },
    animationDuration: {
        value: "1s"
    },
    small: {
        width: {
            value: "{fontSizes.small.value}"
        },
        height: {
            value: "{fontSizes.small.value}"
        },
        fontSize: {
            value: "{fontSizes.xxs.value}"
        }
    },
    large: {
        width: {
            value: "{fontSizes.large.value}"
        },
        height: {
            value: "{fontSizes.large.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    linear: {
        width: {
            value: "100%"
        },
        minWidth: {
            value: "5rem"
        },
        fontSize: {
            value: "{fontSizes.xxs.value}"
        },
        strokeWidth: {
            value: "{fontSizes.xxs.value}"
        },
        strokeFilled: {
            value: "{colors.brand.primary.80.value}"
        },
        strokeEmpty: {
            value: "{colors.neutral.20.value}"
        },
        strokeLinecap: {
            value: "round"
        },
        animationDuration: {
            value: "1s"
        },
        small: {
            strokeWidth: {
                value: "{fontSizes.xxxs.value}"
            },
            fontSize: {
                value: "{fontSizes.xxxs.value}"
            }
        },
        large: {
            strokeWidth: {
                value: "{fontSizes.xs.value}"
            },
            fontSize: {
                value: "{fontSizes.xs.value}"
            }
        }
    },
    text: {
        fill: {
            value: "{colors.font.primary.value}"
        }
    }
};


const $e51e3f6b5f5a58e7$export$b1e5508a851be14d = {
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.medium.value}"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    boxShadow: {
        value: "{shadows.large.value}"
    },
    flexDirection: {
        value: "column"
    },
    gap: {
        value: "{space.zero.value}"
    },
    maxWidth: {
        value: "30rem"
    },
    minWidth: {
        value: "14rem"
    },
    small: {
        width: {
            value: "{fontSizes.medium.value}"
        },
        height: {
            value: "{fontSizes.medium.value}"
        }
    },
    large: {
        width: {
            value: "{fontSizes.xxxl.value}"
        },
        height: {
            value: "{fontSizes.xxxl.value}"
        }
    },
    item: {
        minHeight: {
            value: "2.5rem"
        },
        paddingInlineStart: {
            value: "{space.medium.value}"
        },
        paddingInlineEnd: {
            value: "{space.medium.value}"
        }
    }
};


const $cc4a2b4005158ec6$export$a8ecead220dd38a6 = {
    alignItems: {
        value: "center"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    borderColor: {
        value: "transparent"
    },
    borderStyle: {
        value: "solid"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    justifyContent: {
        value: "flex-start"
    },
    paddingBlock: {
        value: "{space.small.value}"
    },
    paddingInline: {
        value: "{space.medium.value}"
    },
    lineHeight: {
        value: "{lineHeights.small.value}"
    },
    icon: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    heading: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    dismiss: {
        gap: {
            value: "{space.xxs.value}"
        }
    },
    plain: {
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "transparent"
        },
        info: {
            color: {
                value: "{colors.font.info.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        error: {
            color: {
                value: "{colors.font.error.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        success: {
            color: {
                value: "{colors.font.success.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        warning: {
            color: {
                value: "{colors.font.warning.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        }
    },
    outlined: {
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        info: {
            color: {
                value: "{colors.font.info.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.info.value}"
            }
        },
        error: {
            color: {
                value: "{colors.font.error.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.error.value}"
            }
        },
        success: {
            color: {
                value: "{colors.font.success.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.success.value}"
            }
        },
        warning: {
            color: {
                value: "{colors.font.warning.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.warning.value}"
            }
        }
    },
    filled: {
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.secondary.value}"
        },
        borderColor: {
            value: "transparent"
        },
        info: {
            color: {
                value: "{colors.font.info.value}"
            },
            backgroundColor: {
                value: "{colors.background.info.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        error: {
            color: {
                value: "{colors.font.error.value}"
            },
            backgroundColor: {
                value: "{colors.background.error.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        success: {
            color: {
                value: "{colors.font.success.value}"
            },
            backgroundColor: {
                value: "{colors.background.success.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        warning: {
            color: {
                value: "{colors.font.warning.value}"
            },
            backgroundColor: {
                value: "{colors.background.warning.value}"
            },
            borderColor: {
                value: "transparent"
            }
        }
    }
};


const $c29a4a63d26eabe4$export$22fa394f3ba39578 = {
    current: {
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        },
        backgroundColor: {
            value: "{colors.overlay.40.value}"
        }
    },
    button: {
        color: {
            value: "{colors.font.primary.value}"
        },
        paddingInlineStart: {
            value: "{space.xxs.value}"
        },
        paddingInlineEnd: {
            value: "{space.xxs.value}"
        },
        transitionProperty: {
            value: "background-color"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    ellipsis: {
        alignItems: {
            value: "baseline"
        },
        justifyContent: {
            value: "center"
        },
        paddingInlineStart: {
            value: "{space.xs.value}"
        },
        paddingInlineEnd: {
            value: "{space.xs.value}"
        }
    },
    itemContainer: {
        marginLeft: {
            value: "{space.xxxs.value}"
        },
        marginRight: {
            value: "{space.xxxs.value}"
        }
    },
    itemShared: {
        height: {
            value: "{fontSizes.xxl.value}"
        },
        minWidth: {
            value: "{fontSizes.xxl.value}"
        },
        borderRadius: {
            value: "{fontSizes.medium.value}"
        }
    }
};


const $31e9a5e13922fa0d$export$75dd6c0d8e7c7e6b = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    button: {
        color: {
            value: "{components.button.color.value}"
        },
        _active: {
            backgroundColor: {
                value: "{components.button._active.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._active.borderColor.value}"
            },
            color: {
                value: "{components.button._active.color.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{components.button._disabled.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._disabled.borderColor.value}"
            },
            color: {
                value: "{components.button._disabled.color.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{components.button._focus.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._focus.borderColor.value}"
            },
            color: {
                value: "{components.button._focus.color.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{components.button._hover.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._hover.borderColor.value}"
            },
            color: {
                value: "{components.button._hover.color.value}"
            }
        }
    }
};


const $b54e115615f5479c$export$2b14d7973e978f83 = {
    color: {
        value: "{components.fieldcontrol.color}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor}"
        }
    }
};


const $98359e808cf34a79$export$c7187bbd1a7a9244 = {
    borderRadius: {
        value: "{radii.small.value}"
    },
    transitionDuration: {
        value: "{time.long.value}"
    },
    startColor: {
        value: "{colors.background.secondary.value}"
    },
    endColor: {
        value: "{colors.background.tertiary.value}"
    },
    small: {
        height: {
            value: "{space.small.value}"
        }
    },
    default: {
        height: {
            value: "{space.medium.value}"
        }
    },
    large: {
        height: {
            value: "{space.large.value}"
        }
    }
};


const $5eaba2d2dad5c3e3$export$b56dc0f160585b86 = {
    alignItems: {
        value: "center"
    },
    justifyContent: {
        value: "flex-start"
    },
    gap: {
        value: "inherit"
    },
    _disabled: {
        cursor: {
            value: "not-allowed"
        }
    },
    button: {
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        width: {
            value: "{fontSizes.medium.value}"
        },
        height: {
            value: "{fontSizes.medium.value}"
        },
        boxSizing: {
            value: "border-box"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "50%"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        color: {
            value: "{colors.background.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        transitionProperty: {
            value: "all"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        outlineColor: {
            value: "{colors.transparent.value}"
        },
        outlineStyle: {
            value: "solid"
        },
        outlineWidth: {
            value: "{outlineWidths.medium.value}"
        },
        outlineOffset: {
            value: "{outlineOffsets.medium.value}"
        },
        padding: {
            value: "{borderWidths.medium.value}"
        },
        small: {
            width: {
                value: "{fontSizes.small.value}"
            },
            height: {
                value: "{fontSizes.small.value}"
            }
        },
        large: {
            width: {
                value: "{fontSizes.large.value}"
            },
            height: {
                value: "{fontSizes.large.value}"
            }
        },
        _checked: {
            color: {
                value: "{colors.brand.primary.80.value}"
            },
            _disabled: {
                color: {
                    value: "{colors.background.disabled.value}"
                }
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _error: {
            borderColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            }
        }
    },
    label: {
        color: {
            value: "{components.text.color.value}"
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    }
};


const $1afb33fa5003f99a$export$19d611f01a2bdcee = {
    radio: {
        borderWidth: {
            value: "{components.radio.button.borderWidth}"
        },
        borderColor: {
            value: "{components.radio.button.borderColor}"
        },
        backgroundColor: {
            value: "{components.radio.button.backgroundColor}"
        },
        _checked: {
            color: {
                value: "{components.radio.button._checked.color}"
            }
        },
        label: {
            color: {
                value: "{components.radio.label.color}"
            }
        }
    },
    label: {
        color: {
            value: "{components.field.label.color}"
        }
    }
};


const $da01fb2fd4a88ddf$export$8121c87bde23d44 = {
    large: {
        size: {
            value: "{fontSizes.xxxl.value}"
        }
    },
    default: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    small: {
        size: {
            value: "{fontSizes.small.value}"
        }
    },
    filled: {
        color: {
            value: "{colors.brand.secondary.80.value}"
        }
    },
    empty: {
        color: {
            value: "{colors.background.tertiary.value}"
        }
    }
};


const $1393e2cfef83c07c$export$20f8183d3857720a = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    button: {
        color: {
            value: "{components.button.color.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        _active: {
            backgroundColor: {
                value: "{components.button._active.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._active.borderColor.value}"
            },
            color: {
                value: "{components.button._active.color.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{components.button._disabled.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._disabled.borderColor.value}"
            },
            color: {
                value: "{components.button._disabled.color.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{components.button._focus.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._focus.borderColor.value}"
            },
            color: {
                value: "{components.button._focus.color.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{components.button._hover.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._hover.borderColor.value}"
            },
            color: {
                value: "{components.button._hover.color.value}"
            }
        }
    }
};


const $63b38229c8bcceaa$export$2e6c959c16ff56b8 = {
    paddingInlineEnd: {
        value: "{space.xxl.value}"
    },
    wrapper: {
        flex: {
            value: "1"
        },
        display: {
            value: "block"
        },
        position: {
            value: "relative"
        },
        cursor: {
            value: "pointer"
        }
    },
    iconWrapper: {
        alignItems: {
            value: "center"
        },
        position: {
            value: "absolute"
        },
        top: {
            value: "50%"
        },
        right: {
            value: "{space.medium.value}"
        },
        transform: {
            value: "translateY(-50%)"
        },
        pointerEvents: {
            value: "none"
        },
        small: {
            right: {
                value: "{space.xs.value}"
            }
        },
        large: {
            right: {
                value: "{space.medium.value}"
            }
        }
    },
    option: {
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    whiteSpace: {
        value: "nowrap"
    },
    minWidth: {
        value: "6.5rem"
    },
    small: {
        minWidth: {
            value: "5.5rem"
        },
        paddingInlineEnd: {
            value: "{space.xl.value}"
        }
    },
    large: {
        minWidth: {
            value: "7.5rem"
        },
        paddingInlineEnd: {
            value: "{space.xxl.value}"
        }
    }
};


const $07d9f9a19a265e3c$export$43b12a9ec74e5c15 = {
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    color: {
        value: "{components.fieldcontrol.color}"
    },
    flexDirection: {
        value: "column"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor}"
        }
    },
    label: {
        color: {
            value: "{components.field.label.color}"
        }
    }
};


const $874b7e9f4e83aeb9$export$91a82c92775294e7 = {
    paddingBlock: {
        value: "{space.xs.value}"
    },
    track: {
        backgroundColor: {
            value: "{colors.background.quaternary.value}"
        },
        borderRadius: {
            value: "9999px"
        },
        height: {
            value: "0.375rem"
        },
        minWidth: {
            value: "10rem"
        }
    },
    range: {
        backgroundColor: {
            value: "{colors.brand.primary.80.value}"
        },
        borderRadius: {
            value: "9999px"
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            }
        }
    },
    thumb: {
        width: {
            value: "1.25rem"
        },
        height: {
            value: "1.25rem"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        boxShadow: {
            value: "{shadows.small.value}"
        },
        borderRadius: {
            value: "50%"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            borderColor: {
                value: "transparent"
            },
            boxShadow: {
                value: "none"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.focus.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: {
                    offsetX: "0",
                    offsetY: "0",
                    blurRadius: "0",
                    spreadRadius: "2px",
                    color: "{colors.border.focus.value}"
                }
            }
        }
    },
    small: {
        track: {
            height: {
                value: "0.25rem"
            }
        },
        thumb: {
            width: {
                value: "1rem"
            },
            height: {
                value: "1rem"
            }
        }
    },
    large: {
        track: {
            height: {
                value: "0.625rem"
            }
        },
        thumb: {
            width: {
                value: "1.5rem"
            },
            height: {
                value: "1.5rem"
            }
        }
    }
};


const $39a43c31f59a7deb$export$2391ed8b13703124 = {
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    flexDirection: {
        value: "column"
    },
    input: {
        color: {
            value: "{components.fieldcontrol.color}"
        },
        fontSize: {
            value: "{components.fieldcontrol.fontSize}"
        },
        textAlign: {
            value: "center"
        }
    },
    button: {
        color: {
            value: "{components.button.color}"
        },
        backgroundColor: {
            value: "{colors.transparent}"
        },
        _active: {
            color: {
                value: "{components.button._active.color}"
            },
            backgroundColor: {
                value: "{components.button._active.backgroundColor}"
            }
        },
        _focus: {
            color: {
                value: "{components.button._focus.color}"
            },
            backgroundColor: {
                value: "{components.button._focus.backgroundColor}"
            }
        },
        _disabled: {
            color: {
                value: "{components.button._disabled.color}"
            },
            backgroundColor: {
                value: "{components.fieldcontrol._disabled.backgroundColor}"
            }
        },
        _hover: {
            color: {
                value: "{components.button._hover.color}"
            },
            backgroundColor: {
                value: "{components.button._hover.backgroundColor}"
            }
        }
    }
};



const $e5acb3a5cbad27a1$export$38e5783f648ff5e4 = Object.assign(Object.assign({}, (0, $51f6f3218de3b3d8$export$ec053a04994851f2)), {
    filelist: {
        flexDirection: {
            value: "column"
        },
        gap: {
            value: "{space.small}"
        }
    },
    previewer: Object.assign(Object.assign({}, (0, $51f6f3218de3b3d8$export$ec053a04994851f2).previewer), {
        footer: {
            justifyContent: {
                value: "flex-end"
            }
        }
    })
});


const $26c3566fa4e73b6d$export$3df77196ea7dd221 = {
    _disabled: {
        opacity: {
            value: "{opacities.60.value}"
        }
    },
    _focused: {
        shadow: {
            value: {
                offsetX: "0px",
                offsetY: "0px",
                blurRadius: "0px",
                spreadRadius: "2px",
                color: "{colors.border.focus.value}"
            }
        }
    },
    fontSize: {
        value: "{fontSizes.medium.value}"
    },
    large: {
        fontSize: {
            value: "{fontSizes.large.value}"
        }
    },
    small: {
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    label: {
        padding: {
            value: "{space.xs.value}"
        }
    },
    thumb: {
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "{radii.xxxl.value}"
        },
        checked: {
            transform: {
                value: "{transforms.slideX.medium.value}"
            }
        },
        transition: {
            duration: {
                value: "{time.medium.value}"
            }
        },
        width: {
            value: "{space.relative.medium.value}"
        }
    },
    track: {
        backgroundColor: {
            value: "{colors.background.quaternary.value}"
        },
        borderRadius: {
            value: "{radii.xxxl.value}"
        },
        checked: {
            backgroundColor: {
                value: "{colors.brand.primary.80.value}"
            }
        },
        height: {
            value: "{space.relative.medium.value}"
        },
        padding: {
            value: "{outlineWidths.medium.value}"
        },
        transition: {
            duration: {
                value: "{time.short.value}"
            }
        },
        width: {
            value: "{space.relative.xl.value}"
        },
        _error: {
            backgroundColor: {
                value: "{colors.background.error.value}"
            }
        }
    }
};


const $37ba69579db8723a$export$9852986a3ec5f6a0 = {
    borderCollapse: {
        value: "collapse"
    },
    display: {
        value: "table"
    },
    width: {
        value: "100%"
    },
    head: {
        display: {
            value: "table-header-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    body: {
        display: {
            value: "table-row-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    foot: {
        display: {
            value: "table-footer-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    row: {
        display: {
            value: "table-row"
        },
        verticalAlign: {
            value: "middle"
        },
        hover: {
            backgroundColor: {
                value: "{colors.background.tertiary.value}"
            }
        },
        striped: {
            backgroundColor: {
                value: "{colors.background.secondary.value}"
            }
        }
    },
    header: {
        borderColor: {
            value: "{colors.border.tertiary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-cell"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        padding: {
            value: "{space.medium.value}"
        },
        verticalAlign: {
            value: "middle"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            },
            padding: {
                value: "{space.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            },
            padding: {
                value: "{space.xs.value}"
            }
        }
    },
    data: {
        borderColor: {
            value: "{colors.border.tertiary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-cell"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.normal.value}"
        },
        padding: {
            value: "{space.medium.value}"
        },
        verticalAlign: {
            value: "middle"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            },
            padding: {
                value: "{space.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            },
            padding: {
                value: "{space.xs.value}"
            }
        }
    },
    caption: {
        captionSide: {
            value: "bottom"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-caption"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        textAlign: {
            value: "center"
        },
        wordBreak: {
            value: "break-all"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            }
        }
    }
};


const $ad09ef87dda87847$export$39f5674517ec0000 = {
    backgroundColor: {
        value: "transparent"
    },
    borderColor: {
        value: "{colors.border.secondary.value}"
    },
    borderStyle: {
        value: "solid"
    },
    borderWidth: {
        value: "{borderWidths.medium.value}"
    },
    gap: {
        value: "0"
    },
    item: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.secondary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        color: {
            value: "{colors.font.secondary.value}"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        paddingVertical: {
            value: "{space.small.value}"
        },
        paddingHorizontal: {
            value: "{space.medium.value}"
        },
        textAlign: {
            value: "center"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        _hover: {
            color: {
                value: "{colors.font.hover.value}"
            }
        },
        _focus: {
            color: {
                value: "{colors.font.focus.value}"
            }
        },
        _active: {
            color: {
                value: "{colors.font.interactive.value}"
            },
            borderColor: {
                value: "{colors.font.interactive.value}"
            },
            backgroundColor: {
                value: "transparent"
            }
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            borderColor: {
                value: "{colors.border.tertiary.value}"
            }
        }
    }
};


const $d358bac333190241$export$6f093cfa640b7166 = {
    color: {
        value: "{colors.font.primary.value}"
    },
    primary: {
        color: {
            value: "{colors.font.primary.value}"
        }
    },
    secondary: {
        color: {
            value: "{colors.font.secondary.value}"
        }
    },
    tertiary: {
        color: {
            value: "{colors.font.tertiary.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        }
    },
    info: {
        color: {
            value: "{colors.font.info.value}"
        }
    }
};


const $f868dc4325f84d63$export$a97649e9ae9088d4 = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};


const $947a5f838e72d8d7$export$a0baff9279ccf6a1 = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};


const $5af1a465bd9bd3b8$export$72f8a860416016a1 = {
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    _hover: {
        backgroundColor: {
            value: "{colors.overlay.10.value}"
        }
    },
    _focus: {
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        }
    },
    _active: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        }
    },
    _disabled: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        borderColor: {
            value: "{colors.border.disabled.value}"
        },
        color: {
            value: "{colors.font.disabled.value}"
        }
    },
    _pressed: {
        borderColor: {
            value: "{colors.border.pressed.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.overlay.20.value}"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.30.value}"
            }
        }
    },
    primary: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _pressed: {
            backgroundColor: {
                value: "{colors.brand.primary.80.value}"
            },
            borderColor: {
                value: "{colors.brand.primary.80.value}"
            },
            color: {
                value: "{colors.background.primary.value}"
            },
            _focus: {
                backgroundColor: {
                    value: "{colors.border.focus.value}"
                },
                borderColor: {
                    value: "{colors.border.focus.value}"
                },
                color: {
                    value: "{colors.background.primary.value}"
                }
            },
            _hover: {
                borderColor: {
                    value: "{colors.brand.primary.60.value}"
                },
                backgroundColor: {
                    value: "{colors.brand.primary.60.value}"
                },
                boxShadow: {
                    value: "{colors.brand.primary.60.value}"
                },
                color: {
                    value: "{colors.background.primary.value}"
                }
            }
        }
    },
    link: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        color: {
            value: "{colors.overlay.50.value}"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.50.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.50.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _pressed: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.90.value}"
            },
            _focus: {
                backgroundColor: {
                    value: "{colors.transparent.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                }
            },
            _hover: {
                color: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.transparent.value}"
                }
            }
        }
    }
};


const $0d52797c1dd9d428$export$8f367359b07a0011 = {
    alignItems: {
        value: "center"
    },
    alignContent: {
        value: "center"
    },
    justifyContent: {
        value: "flex-start"
    }
};


const $39257f3c15966b1c$export$9b5ac10f59f76296 = {
    alert: (0, $bec4305ae6d66eaf$export$5ea928c9faf85bd3),
    authenticator: (0, $41f4c1bd3a4174a0$export$d5cb6eef88ffbde2),
    autocomplete: (0, $19d27a80d95aea0a$export$485ded5f26ebe08d),
    badge: (0, $1e8fe783c8d33315$export$4aebd143f31d0c0d),
    breadcrumbs: (0, $24f22a7c51d90b29$export$515d2155aaad79e4),
    button: (0, $0c80b08df2937294$export$2ba01fb71ed41cb6),
    card: (0, $6d665a1d82ea047e$export$aa3e815946b80764),
    checkbox: (0, $883caafbc212356e$export$b07e517d22efa1ca),
    checkboxfield: (0, $3ee1929fe38456a5$export$282c9e915736aefa),
    collection: (0, $f4543b6713bfc928$export$bf5175b0c24981cd),
    copy: (0, $8db344c3fb954ff7$export$784d13d8ee351f07),
    countrycodeselect: (0, $1a2a749b4e933021$export$5a80fc6ecf647d64),
    divider: (0, $7867047f959439e5$export$e8c9778bf415dd08),
    dropzone: (0, $e6be58ce2ad0628e$export$585d0a7a39ed94ea),
    expander: (0, $b4fc23392a1382f9$export$f194ed9df726ec47),
    field: (0, $59c31b53b3006a12$export$e0f35d825088c098),
    fieldcontrol: (0, $97b7d4879e2615ef$export$5ba822cdf6eca6d5),
    fieldgroup: (0, $a9e92787979aad5d$export$886e4abc352a8403),
    fieldmessages: (0, $0a54c96138c270f2$export$b29676ca3eb575f7),
    fieldset: (0, $4a33cdbb5d7ba73b$export$a38812d1aa1302d9),
    fileuploader: (0, $51f6f3218de3b3d8$export$ec053a04994851f2),
    flex: (0, $16ff6fc9bbd54056$export$97691fbb80847c19),
    heading: (0, $af76cb595b84d485$export$46e4a324ac90507f),
    icon: (0, $58807e7e8b206d6e$export$1ca1ec8b29a4ce27),
    highlightmatch: (0, $228fa908dc7770eb$export$5340050496cd0f8f),
    image: (0, $9fbcf71a23db9e28$export$5c452ff88e35e47d),
    inappmessaging: (0, $d6f6f4015629c2d0$export$be5f4c7eec37e17e),
    input: (0, $b81024d15d3d3618$export$b7e3ae3d7c15e42e),
    link: (0, $9989e6e3b387a601$export$9c30223ca0a664fb),
    liveness: (0, $5823b9ba2649253d$export$674047c1a0a83243),
    loader: (0, $e7e751e0333962e3$export$f4c5de44377d2946),
    menu: (0, $e51e3f6b5f5a58e7$export$b1e5508a851be14d),
    message: (0, $cc4a2b4005158ec6$export$a8ecead220dd38a6),
    pagination: (0, $c29a4a63d26eabe4$export$22fa394f3ba39578),
    passwordfield: (0, $31e9a5e13922fa0d$export$75dd6c0d8e7c7e6b),
    phonenumberfield: (0, $b54e115615f5479c$export$2b14d7973e978f83),
    placeholder: (0, $98359e808cf34a79$export$c7187bbd1a7a9244),
    radio: (0, $5eaba2d2dad5c3e3$export$b56dc0f160585b86),
    radiogroup: (0, $1afb33fa5003f99a$export$19d611f01a2bdcee),
    rating: (0, $da01fb2fd4a88ddf$export$8121c87bde23d44),
    searchfield: (0, $1393e2cfef83c07c$export$20f8183d3857720a),
    select: (0, $63b38229c8bcceaa$export$2e6c959c16ff56b8),
    selectfield: (0, $07d9f9a19a265e3c$export$43b12a9ec74e5c15),
    sliderfield: (0, $874b7e9f4e83aeb9$export$91a82c92775294e7),
    stepperfield: (0, $39a43c31f59a7deb$export$2391ed8b13703124),
    storagemanager: (0, $e5acb3a5cbad27a1$export$38e5783f648ff5e4),
    switchfield: (0, $26c3566fa4e73b6d$export$3df77196ea7dd221),
    table: (0, $37ba69579db8723a$export$9852986a3ec5f6a0),
    tabs: (0, $ad09ef87dda87847$export$39f5674517ec0000),
    text: (0, $d358bac333190241$export$6f093cfa640b7166),
    textareafield: (0, $f868dc4325f84d63$export$a97649e9ae9088d4),
    textfield: (0, $947a5f838e72d8d7$export$a0baff9279ccf6a1),
    togglebutton: (0, $5af1a465bd9bd3b8$export$72f8a860416016a1),
    togglebuttongroup: (0, $0d52797c1dd9d428$export$8f367359b07a0011)
};


const $26dbd1a497b7e3c0$export$f45fbea8fe20ca8a = {
    default: {
        variable: {
            value: "'InterVariable', 'Inter var', 'Inter', -apple-system, BlinkMacSystemFont,\n        'Helvetica Neue', 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans',\n        sans-serif"
        },
        static: {
            value: "'Inter', -apple-system, BlinkMacSystemFont, 'Helvetica Neue',\n        'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', sans-serif"
        }
    }
};


const $ea0f6ad1fbd1178e$export$67baea80019ff381 = {
    xxxs: {
        value: "0.375rem"
    },
    xxs: {
        value: "0.5rem"
    },
    xs: {
        value: "0.75rem"
    },
    small: {
        value: "0.875rem"
    },
    medium: {
        value: "1rem"
    },
    large: {
        value: "1.25rem"
    },
    xl: {
        value: "1.5rem"
    },
    xxl: {
        value: "2rem"
    },
    xxxl: {
        value: "2.5rem"
    },
    xxxxl: {
        value: "3rem"
    }
};


const $f2923f6b45e2aba3$export$59230918eb9bd861 = {
    hairline: {
        value: 100
    },
    thin: {
        value: 200
    },
    light: {
        value: 300
    },
    normal: {
        value: 400
    },
    medium: {
        value: 500
    },
    semibold: {
        value: 600
    },
    bold: {
        value: 700
    },
    extrabold: {
        value: 800
    },
    black: {
        value: 900
    }
};


const $5da5b9f165e5297e$export$e646ed6b629bf51e = {
    small: {
        value: "1.25"
    },
    medium: {
        value: "1.5"
    },
    large: {
        value: "2"
    }
};


const $858bdedec98aea82$export$da6c1b172b339805 = {
    0: {
        value: "0"
    },
    10: {
        value: "0.1"
    },
    20: {
        value: "0.2"
    },
    30: {
        value: "0.3"
    },
    40: {
        value: "0.4"
    },
    50: {
        value: "0.5"
    },
    60: {
        value: "0.6"
    },
    70: {
        value: "0.7"
    },
    80: {
        value: "0.8"
    },
    90: {
        value: "0.9"
    },
    100: {
        value: "1"
    }
};


const $86a30deb2530766c$export$ef75ee03a03b44a8 = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};


const $b63e0ed58afa0e95$export$d532f76375153c47 = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};


const $0d8b4205acf1ea13$export$18f838d5aba6962a = {
    xs: {
        value: "0.125rem"
    },
    small: {
        value: "0.25rem"
    },
    medium: {
        value: "0.5rem"
    },
    large: {
        value: "1rem"
    },
    xl: {
        value: "2rem"
    },
    xxl: {
        value: "4rem"
    },
    xxxl: {
        value: "8rem"
    }
};


const $16027c0a294c4b01$export$3eb26d38a832ce9a = {
    small: {
        value: {
            offsetX: "0px",
            offsetY: "2px",
            blurRadius: "4px",
            color: "{colors.shadow.tertiary.value}"
        }
    },
    medium: {
        value: {
            offsetX: "0px",
            offsetY: "2px",
            blurRadius: "6px",
            color: "{colors.shadow.secondary.value}"
        }
    },
    large: {
        value: {
            offsetX: "0px",
            offsetY: "4px",
            blurRadius: "12px",
            color: "{colors.shadow.primary.value}"
        }
    }
};


const $b63c56e406261b1b$export$a941ed4b947d12f8 = {
    zero: {
        value: "0"
    },
    xxxs: {
        value: "0.25rem"
    },
    xxs: {
        value: "0.375rem"
    },
    xs: {
        value: "0.5rem"
    },
    small: {
        value: "0.75rem"
    },
    medium: {
        value: "1rem"
    },
    large: {
        value: "1.5rem"
    },
    xl: {
        value: "2.0rem"
    },
    xxl: {
        value: "3.0rem"
    },
    xxxl: {
        value: "4.5rem"
    },
    relative: {
        xxxs: {
            value: "0.25em"
        },
        xxs: {
            value: "0.375em"
        },
        xs: {
            value: "0.5em"
        },
        small: {
            value: "0.75em"
        },
        medium: {
            value: "1em"
        },
        large: {
            value: "1.5em"
        },
        xl: {
            value: "2.0em"
        },
        xxl: {
            value: "3.0em"
        },
        xxxl: {
            value: "4.5em"
        },
        full: {
            value: "100%"
        }
    }
};


const $655d12358d7ddf1e$export$2da9be4cfdb689b1 = {
    short: {
        value: "100ms"
    },
    medium: {
        value: "250ms"
    },
    long: {
        value: "500ms"
    }
};


const $3a14a8ce348e4d40$export$63e4f03d302d3e40 = {
    slideX: {
        small: {
            value: "translateX(0.5em)"
        },
        medium: {
            value: "translateX(1em)"
        },
        large: {
            value: "translateX(2em)"
        }
    }
};


const $f23534e427118905$export$6ad93df59e712c43 = {
    components: (0, $39257f3c15966b1c$export$9b5ac10f59f76296),
    borderWidths: (0, $a8975b29198b9cfb$export$6f3cc5789c9e770e),
    colors: (0, $2e0bbe07577db1fa$export$8f45430ccf837300),
    fonts: (0, $26dbd1a497b7e3c0$export$f45fbea8fe20ca8a),
    fontSizes: (0, $ea0f6ad1fbd1178e$export$67baea80019ff381),
    fontWeights: (0, $f2923f6b45e2aba3$export$59230918eb9bd861),
    lineHeights: (0, $5da5b9f165e5297e$export$e646ed6b629bf51e),
    opacities: (0, $858bdedec98aea82$export$da6c1b172b339805),
    outlineOffsets: (0, $86a30deb2530766c$export$ef75ee03a03b44a8),
    outlineWidths: (0, $b63e0ed58afa0e95$export$d532f76375153c47),
    radii: (0, $0d8b4205acf1ea13$export$18f838d5aba6962a),
    shadows: (0, $16027c0a294c4b01$export$3eb26d38a832ce9a),
    space: (0, $b63c56e406261b1b$export$a941ed4b947d12f8),
    time: (0, $655d12358d7ddf1e$export$2da9be4cfdb689b1),
    transforms: (0, $3a14a8ce348e4d40$export$63e4f03d302d3e40)
}, $f23534e427118905$export$166e3af4fe3ca756 = {
    colors: (0, $2e0bbe07577db1fa$export$8f45430ccf837300),
    borderWidths: (0, $a8975b29198b9cfb$export$6f3cc5789c9e770e),
    fontSizes: {
        xxs: (0, $ea0f6ad1fbd1178e$export$67baea80019ff381).xxs,
        xs: (0, $ea0f6ad1fbd1178e$export$67baea80019ff381).xs,
        small: (0, $ea0f6ad1fbd1178e$export$67baea80019ff381).small,
        medium: (0, $ea0f6ad1fbd1178e$export$67baea80019ff381).medium,
        large: (0, $ea0f6ad1fbd1178e$export$67baea80019ff381).large,
        xl: (0, $ea0f6ad1fbd1178e$export$67baea80019ff381).xl,
        xxl: (0, $ea0f6ad1fbd1178e$export$67baea80019ff381).xxl,
        xxxl: (0, $ea0f6ad1fbd1178e$export$67baea80019ff381).xxxl
    },
    fontWeights: (0, $f2923f6b45e2aba3$export$59230918eb9bd861),
    opacities: (0, $858bdedec98aea82$export$da6c1b172b339805),
    space: {
        xxs: (0, $b63c56e406261b1b$export$a941ed4b947d12f8).xxxs,
        xs: (0, $b63c56e406261b1b$export$a941ed4b947d12f8).xs,
        small: (0, $b63c56e406261b1b$export$a941ed4b947d12f8).small,
        medium: (0, $b63c56e406261b1b$export$a941ed4b947d12f8).medium,
        large: (0, $b63c56e406261b1b$export$a941ed4b947d12f8).large,
        xl: (0, $b63c56e406261b1b$export$a941ed4b947d12f8).xl,
        xxl: (0, $b63c56e406261b1b$export$a941ed4b947d12f8).xxl,
        xxxl: (0, $b63c56e406261b1b$export$a941ed4b947d12f8).xxxl
    },
    radii: (0, $0d8b4205acf1ea13$export$18f838d5aba6962a),
    time: (0, $655d12358d7ddf1e$export$2da9be4cfdb689b1)
};


const $7d581e416ac82bbd$export$d07517a676ce386f = {
    values: {
        base: 0,
        small: 480,
        medium: 768,
        large: 992,
        xl: 1280,
        xxl: 1536
    },
    defaultBreakpoint: "base"
};


const $053586288d2629c2$export$164de7ab8df77ef0 = {
    tokens: (0, $f23534e427118905$export$6ad93df59e712c43),
    breakpoints: (0, $7d581e416ac82bbd$export$d07517a676ce386f),
    name: "default-theme"
};




const $74227e2c17a6ccd2$export$2e3e72bc642e327 = (s)=>s in (0, $ca5815d75ab8dc16$export$f486c23e21d151b2);



const $b7bb2ff42595de4b$export$c6251bf2bc4bb464 = (t)=>"string" == typeof t && t.length > 0, $b7bb2ff42595de4b$export$78d1711480f95c3e = (t)=>"string" == typeof t && 0 === t.length, $b7bb2ff42595de4b$export$68b32c1946a6b59c = (t)=>null == t || $b7bb2ff42595de4b$export$78d1711480f95c3e(t), $b7bb2ff42595de4b$export$12cda49cb4509427 = (t, r)=>{
    const e = r - t + 1;
    return Array.from({
        length: e
    }, (r, e)=>e + t);
}, $b7bb2ff42595de4b$export$259b4dd69e654a7a = (t)=>Object.keys(t), $b7bb2ff42595de4b$export$b0c777ec01738e5b = (o, s, n)=>{
    if ("string" != typeof s) return s;
    if (s.includes(" ")) return s.split(" ").map((t)=>$b7bb2ff42595de4b$export$b0c777ec01738e5b(o, t, n)).join(" ");
    if ((0, $74227e2c17a6ccd2$export$2e3e72bc642e327)(o)) {
        const e = s.split("."), f = (0, $ca5815d75ab8dc16$export$f486c23e21d151b2)[o];
        let l = n[f];
        for(let t = 0; t < e.length && l; t++)l = l[e[t]];
        return (0, $79988c6708933e3f$export$daee9cd42beef6d1)(l) ? `var(--${(0, $79988c6708933e3f$export$8658ddf1aae625a3)({
            path: [
                (0, $ca5815d75ab8dc16$export$f486c23e21d151b2)[o],
                ...e
            ]
        })})` : s;
    }
    return s;
};


const $bdd6fcd5522468b6$export$7791b19c8f6fdbca = ({ breakpoint: o, breakpoints: e, values: s })=>{
    let i = {};
    const n = (0, $b7bb2ff42595de4b$export$259b4dd69e654a7a)(e).sort((r, t)=>e[r] - e[t]);
    var a;
    return Array.isArray(s) ? s.forEach((r, t)=>{
        i[n[t]] = r;
    }) : "object" == typeof s && (i = (0, $b7bb2ff42595de4b$export$259b4dd69e654a7a)(a = s).reduce((t, o)=>o in (0, $053586288d2629c2$export$164de7ab8df77ef0).breakpoints.values ? Object.assign(Object.assign({}, t), {
            [o]: a[o]
        }) : t, {})), (({ breakpoint: r, breakpoints: o, values: e })=>{
        const s = e[r];
        if (void 0 !== s) return s;
        const i = (0, $b7bb2ff42595de4b$export$259b4dd69e654a7a)(o).sort((r, t)=>o[t] - o[r]), n = i.slice(i.indexOf(r));
        for (const r of n){
            const t = e[r];
            if (void 0 !== t) return t;
        }
        return null;
    })({
        breakpoint: o,
        breakpoints: e,
        values: i
    });
};



var $acw62 = parcelRequire("acw62");

const $93b365d5259a7cd8$export$872f03ff2a363331 = ({ breakpoints: n })=>{
    const r = (0, $b7bb2ff42595de4b$export$259b4dd69e654a7a)(n).sort((t, r)=>n[r] - n[t]);
    return r.map((t, i)=>{
        let o = "";
        const m = n[t], e = r[i - 1], p = e ? n[e] - 1 : null;
        return m >= 0 && (o = `(min-width: ${m}px)`), null !== p && (o && (o += " and "), o += `(max-width: ${p}px)`), {
            breakpoint: t,
            query: o,
            maxWidth: p,
            minWidth: m
        };
    });
};


const $30d92f79c3b4f6b2$var$n = "undefined" == typeof window ? $acw62.useEffect : $acw62.useLayoutEffect, $30d92f79c3b4f6b2$export$199d6754bdf4e1e3 = ({ breakpoints: o, defaultBreakpoint: a })=>{
    const r = "undefined" != typeof window && void 0 !== window.matchMedia ? window.matchMedia : null, i = $acw62.useMemo(()=>(0, $93b365d5259a7cd8$export$872f03ff2a363331)({
            breakpoints: o
        }), [
        o
    ]), [s, u] = $acw62.useState(a), c = $acw62.useCallback((e, t)=>{
        e && u(t);
    }, [
        u
    ]);
    return $30d92f79c3b4f6b2$var$n(()=>{
        if (!r) return;
        const e = i.map(({ query: e, breakpoint: t })=>{
            const n = r(e);
            c(n.matches, t);
            const o = (e)=>{
                e.matches && u(t);
            };
            return n.addEventListener("change", o), ()=>n.removeEventListener("change", o);
        });
        return ()=>{
            e.forEach((e)=>e());
        };
    }, [
        o,
        u,
        r,
        i
    ]), $acw62.useDebugValue(s, (e)=>e), s;
};




var $acw62 = parcelRequire("acw62");
var $864a32aaa8614b1c$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $fa11d244b809f165$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};



/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $4caa032c183be831$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            İ: "i",
            I: "ı",
            İ: "i"
        }
    },
    az: {
        regexp: /\u0130/g,
        map: {
            İ: "i",
            I: "ı",
            İ: "i"
        }
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "i̇",
            J: "j̇",
            Į: "į̇",
            Ì: "i̇̀",
            Í: "i̇́",
            Ĩ: "i̇̃"
        }
    }
};
function $4caa032c183be831$export$206cd6ecad4fcdde(str, locale) {
    var lang = $4caa032c183be831$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $4caa032c183be831$export$61d6efbc6547e8eb(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $4caa032c183be831$export$61d6efbc6547e8eb(str);
}
function $4caa032c183be831$export$61d6efbc6547e8eb(str) {
    return str.toLowerCase();
}


// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var $bb839e30d903d5e0$var$DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var $bb839e30d903d5e0$var$DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function $bb839e30d903d5e0$export$a596972587f860c8(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? $bb839e30d903d5e0$var$DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? $bb839e30d903d5e0$var$DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? (0, $4caa032c183be831$export$61d6efbc6547e8eb) : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = $bb839e30d903d5e0$var$replace($bb839e30d903d5e0$var$replace(input, splitRegexp, "$1\x00$2"), stripRegexp, "\x00");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\x00")start++;
    while(result.charAt(end - 1) === "\x00")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\x00").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function $bb839e30d903d5e0$var$replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}


function $1c101dfc925f9f17$export$66a4dfea2695736(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") return "_" + firstChar + lowerChars;
    return "" + firstChar.toUpperCase() + lowerChars;
}
function $1c101dfc925f9f17$export$c27cf446dc44c0b9(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function $1c101dfc925f9f17$export$26c6f48841fe1a8a(input, options) {
    if (options === void 0) options = {};
    return (0, $bb839e30d903d5e0$export$a596972587f860c8)(input, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        delimiter: "",
        transform: $1c101dfc925f9f17$export$66a4dfea2695736
    }, options));
}


function $4690c22a3f79a44e$export$1c6885769b2bad6f(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, $1c101dfc925f9f17$export$66a4dfea2695736)(input, index);
}
function $4690c22a3f79a44e$export$f3c8e8146a7dbf93(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, $1c101dfc925f9f17$export$c27cf446dc44c0b9)(input);
}
function $4690c22a3f79a44e$export$8a7688a96d852767(input, options) {
    if (options === void 0) options = {};
    return (0, $1c101dfc925f9f17$export$26c6f48841fe1a8a)(input, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        transform: $4690c22a3f79a44e$export$1c6885769b2bad6f
    }, options));
}




function $4395beeb50d15822$export$e1b697368b9a68f5(input, options) {
    if (options === void 0) options = {};
    return (0, $bb839e30d903d5e0$export$a596972587f860c8)(input, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        delimiter: "."
    }, options));
}


function $3c541ac1dfaf7179$export$c68d52815ae74c39(input, options) {
    if (options === void 0) options = {};
    return (0, $4395beeb50d15822$export$e1b697368b9a68f5)(input, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        delimiter: "-"
    }, options));
}



function $5be6cdd8e661e6b8$export$feae9a740c003485(input, options) {
    if (options === void 0) options = {};
    return (0, $4395beeb50d15822$export$e1b697368b9a68f5)(input, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        delimiter: "_"
    }, options));
}


const $fa11d244b809f165$var$reduce = function(obj, f, accumulator_init) {
    return Object.keys(obj || {}).reduce((accumulator, key)=>{
        let value = obj[key];
        return f(accumulator, value, key, obj);
    }, accumulator_init);
};
const $fa11d244b809f165$var$forEach = function(obj, f) {
    Object.keys(obj || {}).forEach((key)=>{
        let value = obj[key];
        f(value, key);
    });
};
// Note: This is a crappy version to a certain extent... don't use with Strings, for example...
const $fa11d244b809f165$var$clone = function(object) {
    return Object.assign(new object.constructor(), object);
};
const $fa11d244b809f165$var$cloneDeep = function(obj) {
    if (obj === null || obj === undefined || typeof obj !== "object") return obj;
    if (obj instanceof Array) return obj.reduce((arr, item, i)=>{
        arr[i] = $fa11d244b809f165$var$cloneDeep(item);
        return arr;
    }, []);
    if (obj instanceof Object) return Object.keys(obj || {}).reduce((cpObj, key)=>{
        cpObj[key] = $fa11d244b809f165$var$cloneDeep(obj[key]);
        return cpObj;
    }, {});
};
const $fa11d244b809f165$var$isObject = function(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function");
};
const $fa11d244b809f165$var$isString = function(obj) {
    return typeof obj === "string" || obj instanceof String;
};
const $fa11d244b809f165$var$isArray = function(obj) {
    return Array.isArray(obj);
};
const $fa11d244b809f165$var$isEmpty = function(obj) {
    return [
        Object,
        Array
    ].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
};
function $fa11d244b809f165$var$isPlainObject(value) {
    if (typeof value !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    let proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}
const $fa11d244b809f165$var$filter = function(arr, filter) {
    if (typeof filter !== "function") throw "filter is not a function";
    if (typeof arr === "undefined") return [];
    return arr.filter(filter);
};
const $fa11d244b809f165$var$assign = function() {
    let args = Array.prototype.slice.call(arguments);
    args.unshift({});
    return Object.assign(...args);
};
/* global Set */ const $fa11d244b809f165$var$pull = function(arr, ...removeList) {
    var removeSet = new Set(removeList);
    for(let i = arr.length - 1; i >= 0; i--)if (removeSet.has(arr[i])) arr.splice(i, 1);
};
const $fa11d244b809f165$var$unique = function(arr) {
    return [
        ...new Set(arr)
    ];
};
const $fa11d244b809f165$var$upperFirst = function(str) {
    return str ? str[0].toUpperCase() + str.substr(1) : "";
};
const $fa11d244b809f165$var$matchFn = function(inputObj, testObj) {
    if ($fa11d244b809f165$var$isObject(testObj)) return Object.keys(testObj).every((key)=>$fa11d244b809f165$var$matchFn(inputObj[key], testObj[key]));
    else return inputObj == testObj;
};
const $fa11d244b809f165$var$matches = function(matchObj) {
    let cloneObj = $fa11d244b809f165$var$cloneDeep(matchObj);
    let matchesFn = (inputObj)=>$fa11d244b809f165$var$matchFn(inputObj, cloneObj);
    return matchesFn;
};
const $fa11d244b809f165$var$DEFAULT_OPTIONS = {
    transform: $4690c22a3f79a44e$export$f3c8e8146a7dbf93
};
const $fa11d244b809f165$var$changeDefaultCaseTransform = function(caseFunction, default_options) {
    return (caseToChange, options)=>caseFunction(caseToChange, Object.assign({}, $fa11d244b809f165$var$DEFAULT_OPTIONS, default_options, options));
};
$fa11d244b809f165$exports = {
    each: $fa11d244b809f165$var$forEach,
    forEach: $fa11d244b809f165$var$forEach,
    forIn: $fa11d244b809f165$var$forEach,
    keys: Object.keys,
    clone: $fa11d244b809f165$var$clone,
    cloneDeep: $fa11d244b809f165$var$cloneDeep,
    extend: Object.assign,
    isString: $fa11d244b809f165$var$isString,
    isArray: $fa11d244b809f165$var$isArray,
    isObject: $fa11d244b809f165$var$isObject,
    isPlainObject: $fa11d244b809f165$var$isPlainObject,
    isEmpty: $fa11d244b809f165$var$isEmpty,
    filter: $fa11d244b809f165$var$filter,
    reduce: $fa11d244b809f165$var$reduce,
    assign: $fa11d244b809f165$var$assign,
    upperFirst: $fa11d244b809f165$var$upperFirst,
    camelCase: $fa11d244b809f165$var$changeDefaultCaseTransform($4690c22a3f79a44e$export$8a7688a96d852767),
    snakeCase: $5be6cdd8e661e6b8$export$feae9a740c003485,
    kebabCase: $3c541ac1dfaf7179$export$c68d52815ae74c39,
    pull: $fa11d244b809f165$var$pull,
    matches: $fa11d244b809f165$var$matches,
    unique: $fa11d244b809f165$var$unique
};


/**
 * Performs an deep extend on the objects, from right to left.
 * @private
 * @param {Object[]} objects - An array of JS objects
 * @param {Function} collision - A function to be called when a merge collision happens.
 * @param {string[]} path - (for internal use) An array of strings which is the current path down the object when this is called recursively.
 * @returns {Object}
 */ function $864a32aaa8614b1c$var$deepExtend(objects, collision, path) {
    if (objects == null) return {};
    var src, copyIsArray, copy, name, options, clone, target = objects[0] || {}, i = 1, length = objects.length;
    path = path || [];
    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== "object") target = {};
    for(; i < length; i++){
        // Only deal with non-null/undefined values
        if ((options = objects[i]) != null) // Extend the base object
        for(name in options){
            if (!options.hasOwnProperty(name)) continue;
            if (name === "__proto__") continue;
            src = target[name];
            copy = options[name];
            // Prevent never-ending loop
            if (target === copy) continue;
            // Recurse if we're merging plain objects or arrays
            if (copy && ($fa11d244b809f165$exports.isPlainObject(copy) || (copyIsArray = $fa11d244b809f165$exports.isArray(copy)))) {
                if (copyIsArray) {
                    copyIsArray = false;
                    clone = src && $fa11d244b809f165$exports.isArray(src) ? src : [];
                } else clone = src && $fa11d244b809f165$exports.isPlainObject(src) ? src : {};
                var nextPath = path.slice(0);
                nextPath.push(name);
                // Never move original objects, clone them
                target[name] = $864a32aaa8614b1c$var$deepExtend([
                    clone,
                    copy
                ], collision, nextPath);
            // Don't bring in undefined values
            } else if (copy !== undefined) {
                if (src != null && typeof collision == "function") collision({
                    target: target,
                    copy: options,
                    path: path,
                    key: name
                });
                target[name] = copy;
            }
        }
    }
    return target;
}
$864a32aaa8614b1c$exports = $864a32aaa8614b1c$var$deepExtend;


var $a1c985c713bae1e8$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
/**
 * Takes an plain javascript object and will make a flat array of all the leaf nodes.
 * A leaf node in this context has a 'value' property. Potentially refactor this to
 * be more generic.
 * @private
 * @param  {Object} properties - The plain object you want flattened into an array.
 * @param  {Array} [to_ret=[]] - Properties array. This function is recursive therefore this is what gets passed along.
 * @return {Array}
 */ function $a1c985c713bae1e8$var$flattenProperties(properties, to_ret) {
    to_ret = to_ret || [];
    for(var name in properties)if (properties.hasOwnProperty(name)) {
        // TODO: this is a bit fragile and arbitrary to stop when we get to a 'value' property.
        if ($fa11d244b809f165$exports.isPlainObject(properties[name]) && "value" in properties[name]) to_ret.push(properties[name]);
        else if ($fa11d244b809f165$exports.isPlainObject(properties[name])) $a1c985c713bae1e8$var$flattenProperties(properties[name], to_ret);
    }
    return to_ret;
}
$a1c985c713bae1e8$exports = $a1c985c713bae1e8$var$flattenProperties;




const $dd377fe16a54f3cf$var$r = ({ token: e, path: n })=>{
    const o = `--${(0, $79988c6708933e3f$export$8658ddf1aae625a3)({
        path: n
    })}`, { value: t } = e, r = (0, $79988c6708933e3f$export$55101aa37e5c1f8f)(e);
    return {
        name: o,
        original: t,
        path: n,
        value: r,
        toString: ()=>`var(${o})`
    };
};
function $dd377fe16a54f3cf$export$25d302a5b900a763(a, i = (0, $053586288d2629c2$export$164de7ab8df77ef0)) {
    const s = (0, (/*@__PURE__*/$parcel$interopDefault($864a32aaa8614b1c$exports)))([
        {},
        i,
        a
    ]), m = (0, $79988c6708933e3f$export$4ae67d38aae8ca2e)({
        tokens: s.tokens,
        setupToken: $dd377fe16a54f3cf$var$r
    }), { breakpoints: l, name: p } = s;
    let d = `[data-amplify-theme="${p}"] {\n` + (0, (/*@__PURE__*/$parcel$interopDefault($a1c985c713bae1e8$exports)))(m).map((e)=>`${e.name}: ${e.value};`).join("\n") + "\n}\n", c = [];
    return s.overrides && (c = s.overrides.map((e)=>{
        const o = (0, $79988c6708933e3f$export$4ae67d38aae8ca2e)({
            tokens: e.tokens,
            setupToken: $dd377fe16a54f3cf$var$r
        }), a = (0, (/*@__PURE__*/$parcel$interopDefault($a1c985c713bae1e8$exports)))(o).map((e)=>`${e.name}: ${e.value};`).join("\n");
        if ("selector" in e && (d += `\n${e.selector} {\n${a}\n}\n`), "mediaQuery" in e && (d += `\n@media (${e.mediaQuery}) {\n  [data-amplify-theme="${p}"] {\n    ${a}\n  }\n}\n`), "breakpoint" in e) {
            const n = s.breakpoints.values[e.breakpoint];
            d += `\n@media (min-width: ${n}px) {\n  [data-amplify-theme="${p}"] {\n    ${a}\n  }\n}\n`;
        }
        return "colorMode" in e && (d += `\n@media (prefers-color-scheme: ${e.colorMode}) {\n          [data-amplify-theme="${p}"][data-amplify-color-mode="system"] {\n            ${a}\n            color-scheme: ${e.colorMode};\n          }\n        }\n`, d += `\n[data-amplify-theme="${p}"][data-amplify-color-mode="${e.colorMode}"] {\n          ${a}\n          color-scheme: ${e.colorMode};\n        }\n`), Object.assign(Object.assign({}, e), {
            tokens: o
        });
    })), {
        tokens: m,
        breakpoints: l,
        name: p,
        cssText: d,
        overrides: c
    };
}



var $acw62 = parcelRequire("acw62");

const $4d99154a9395498c$export$1292f175d4b89c7c = $acw62.createContext({
    theme: (0, $dd377fe16a54f3cf$export$25d302a5b900a763)()
});


const $a21ed349376287d0$export$1a3896b0420de28d = (o)=>void 0 === o || void 0 === o.theme ? (0, $dd377fe16a54f3cf$export$25d302a5b900a763)() : o.theme, $a21ed349376287d0$export$93d4e7f90805808f = ()=>{
    const t = $acw62.useContext((0, $4d99154a9395498c$export$1292f175d4b89c7c));
    return $a21ed349376287d0$export$1a3896b0420de28d(t);
};




const $561188d23235248f$export$741ad47189a64aa0 = ({ value: i, propKey: m, tokens: p })=>(0, $79988c6708933e3f$export$daee9cd42beef6d1)(i) ? i.toString() : (0, $15a7c5986a3f06c2$export$844ec244b1367d54)(i) ? (0, $15a7c5986a3f06c2$export$844ec244b1367d54)(m) ? (0, $b7bb2ff42595de4b$export$b0c777ec01738e5b)(m, i, p) : i : null;



const $7c50d668595dadb6$export$63d3b2476bc623b7 = (o)=>"auto" === o || "number" == typeof o && !isNaN(o) || "string" == typeof o && !isNaN(parseFloat(o)), $7c50d668595dadb6$export$7a05ae144bf7b4de = (o)=>"auto" === o ? "auto" : `span ${o}`, $7c50d668595dadb6$export$2289a9e09445ac09 = (o)=>$7c50d668595dadb6$export$63d3b2476bc623b7(o) ? $7c50d668595dadb6$export$7a05ae144bf7b4de(o) : Array.isArray(o) ? o.map((o)=>$7c50d668595dadb6$export$7a05ae144bf7b4de(o)) : "object" == typeof o && null != o ? Object.entries(o).reduce((o, [e, t])=>Object.assign(Object.assign({}, o), {
            [e]: $7c50d668595dadb6$export$7a05ae144bf7b4de(t)
        }), {}) : null, $7c50d668595dadb6$export$708ec223603a550 = (t)=>{
    const { rowSpan: r, columnSpan: s, row: n, column: p } = t, a = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(t, [
        "rowSpan",
        "columnSpan",
        "row",
        "column"
    ]), { rowFromSpanValue: m, columnFromSpanValue: l } = $acw62.useMemo(()=>({
            rowFromSpanValue: $7c50d668595dadb6$export$2289a9e09445ac09(r),
            columnFromSpanValue: $7c50d668595dadb6$export$2289a9e09445ac09(s)
        }), [
        r,
        s
    ]);
    return Object.assign({
        row: (0, $b7bb2ff42595de4b$export$68b32c1946a6b59c)(n) ? m : n,
        column: (0, $b7bb2ff42595de4b$export$68b32c1946a6b59c)(p) ? l : p
    }, a);
}, $7c50d668595dadb6$export$2184e8c9a9308f34 = ({ props: o = {}, style: e = {}, breakpoint: n, breakpoints: p, tokens: i })=>{
    const u = {};
    return Object.keys(o).filter((e)=>null !== o[e]).forEach((c)=>{
        if (c in (0, $750400f93007aa11$export$c69338bc7d797351)) {
            const u = o[c];
            if (!u || (0, $b7bb2ff42595de4b$export$78d1711480f95c3e)(u)) return;
            const f = (0, $750400f93007aa11$export$c69338bc7d797351)[c];
            let b = "";
            (0, $79988c6708933e3f$export$daee9cd42beef6d1)(u) ? b = u.toString() : "string" == typeof u ? b = (0, $b7bb2ff42595de4b$export$b0c777ec01738e5b)(c, u, i) : "number" == typeof u ? b = u : "object" == typeof u && (b = (0, $561188d23235248f$export$741ad47189a64aa0)({
                propKey: c,
                tokens: i,
                value: (0, $bdd6fcd5522468b6$export$7791b19c8f6fdbca)({
                    values: u,
                    breakpoint: n,
                    breakpoints: p
                })
            })), e = Object.assign(Object.assign({}, e), {
                [f]: b
            });
        } else void 0 !== o[c] && (u[c] = o[c]);
    }), {
        propStyles: e,
        nonStyleProps: u
    };
}, $7c50d668595dadb6$export$28e6b9b82ee883c = (o, t)=>{
    const { breakpoints: { values: r, defaultBreakpoint: s }, tokens: a } = (0, $a21ed349376287d0$export$93d4e7f90805808f)(), i = (0, $30d92f79c3b4f6b2$export$199d6754bdf4e1e3)({
        breakpoints: r,
        defaultBreakpoint: s
    }), m = $7c50d668595dadb6$export$708ec223603a550(o);
    return $acw62.useMemo(()=>$7c50d668595dadb6$export$2184e8c9a9308f34({
            props: m,
            style: t,
            breakpoint: i,
            breakpoints: r,
            tokens: a
        }), [
        m,
        t,
        r,
        i,
        a
    ]);
};


const $f797d956b0744e8f$export$27a5bd065ad55220 = $acw62.forwardRef((s, a)=>{
    var { as: i = "div", children: l, testId: d, ariaLabel: n, isDisabled: o, style: m, inert: b } = s, p = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(s, [
        "as",
        "children",
        "testId",
        "ariaLabel",
        "isDisabled",
        "style",
        "inert"
    ]);
    const { propStyles: c, nonStyleProps: y } = (0, $7c50d668595dadb6$export$28e6b9b82ee883c)(p, m);
    return $acw62.createElement(i, Object.assign({
        "aria-label": n,
        "data-testid": d,
        disabled: o,
        ref: a,
        inert: b ? "" : null,
        style: c
    }, y), l);
});
$f797d956b0744e8f$export$27a5bd065ad55220.displayName = "View";


const $d23456b19983b31e$export$f51f4c4ede09e011 = $acw62.forwardRef((t, o)=>{
    var { className: i, children: c } = t, l = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(t, [
        "className",
        "children"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Flex, i),
        ref: o
    }, l), c);
});
$d23456b19983b31e$export$f51f4c4ede09e011.displayName = "Flex";




var $acw62 = parcelRequire("acw62");




const $5acf83d6c1f21d4a$export$c47c5262afb3a760 = "linear-empty", $5acf83d6c1f21d4a$export$84e78a619b590ebb = "linear-filled", $5acf83d6c1f21d4a$export$2dac697651a47d0c = "circular-empty", $5acf83d6c1f21d4a$export$c6c37ac3a7f79d5a = "circular-filled", $5acf83d6c1f21d4a$export$a2450a64b7863610 = 8, $5acf83d6c1f21d4a$export$2d2c9be8b5b863f = 42, $5acf83d6c1f21d4a$export$d13f13f2833cdb46 = 84 * Math.PI, $5acf83d6c1f21d4a$export$3b0d6d7590275603 = $acw62.forwardRef((c, d)=>{
    var { className: p, filledColor: f, emptyColor: x, size: g, variation: u, isDeterminate: v = !1, isPercentageTextHidden: E = !1, percentage: h = 0 } = c, k = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(c, [
        "className",
        "filledColor",
        "emptyColor",
        "size",
        "variation",
        "isDeterminate",
        "isPercentageTextHidden",
        "percentage"
    ]);
    h = Math.min(h, 100);
    const L = `${h = Math.max(h, 0)}%`, N = (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Loader, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Loader, g), (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Loader, u), v ? (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).LoaderDeterminate : null, p), D = $acw62.createElement("g", null, $acw62.createElement("line", {
        x1: "0",
        x2: "100%",
        y1: "50%",
        y2: "50%",
        style: {
            stroke: String(x)
        },
        "data-testid": $5acf83d6c1f21d4a$export$c47c5262afb3a760
    }), $acw62.createElement("line", {
        x1: "0",
        x2: v ? L : "100%",
        y1: "50%",
        y2: "50%",
        style: {
            stroke: v && 0 === h ? "none" : f ? String(f) : void 0
        },
        "data-testid": $5acf83d6c1f21d4a$export$84e78a619b590ebb
    }), v ? $acw62.createElement("text", {
        "aria-live": "polite",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).LoaderPercentageText, E ? (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).VisuallyHidden : null),
        x: `${-1 + h}%`,
        y: "200%"
    }, L) : null), P = $acw62.createElement("g", null, $acw62.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: "42%",
        strokeWidth: "8%",
        style: {
            stroke: String(x)
        },
        "data-testid": $5acf83d6c1f21d4a$export$2dac697651a47d0c
    }), $acw62.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: "42%",
        strokeWidth: "8%",
        style: {
            stroke: String(f),
            strokeDasharray: v ? `${$5acf83d6c1f21d4a$export$d13f13f2833cdb46}% ${$5acf83d6c1f21d4a$export$d13f13f2833cdb46}%` : void 0,
            strokeDashoffset: v ? $5acf83d6c1f21d4a$export$d13f13f2833cdb46 - $5acf83d6c1f21d4a$export$d13f13f2833cdb46 * h / 100 + "%" : void 0
        },
        "data-testid": $5acf83d6c1f21d4a$export$c6c37ac3a7f79d5a
    }), v ? $acw62.createElement("text", {
        "aria-live": "polite",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).LoaderPercentageText, E ? (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).VisuallyHidden : null),
        x: "130%",
        y: "80%"
    }, L) : null);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: "svg",
        className: N,
        "data-size": g,
        "data-variation": u,
        ref: d,
        role: "img"
    }, k), "linear" === u ? D : P);
});
$5acf83d6c1f21d4a$export$3b0d6d7590275603.displayName = "Loader";



const $2732fbaf46f35309$var$m = [
    "link",
    "primary",
    void 0
], $2732fbaf46f35309$export$353f5b6fc5456de1 = $acw62.forwardRef((u, p)=>{
    var c, { className: f, children: b, colorTheme: h, isFullWidth: B = !1, isDisabled: F, isLoading: g, loadingText: v = "", size: j, type: w = "button", variation: y } = u, x = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(u, [
        "className",
        "children",
        "colorTheme",
        "isFullWidth",
        "isDisabled",
        "isLoading",
        "loadingText",
        "size",
        "type",
        "variation"
    ]);
    const L = $2732fbaf46f35309$var$m.includes(y) && h ? `${null != y ? y : "outlined"}--${h}` : void 0, { isFieldsetDisabled: N } = (0, $3b7aa0a2fb31e524$export$b140571ec72925dd)(), z = N || (null !== (c = null != F ? F : g) && void 0 !== c ? c : x.disabled), D = (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Button, (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupControl, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Button, y), (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Button, L), (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Button, j), (0, $15a7c5986a3f06c2$export$3c152e7b97c7496c)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Button, "disabled", z), (0, $15a7c5986a3f06c2$export$3c152e7b97c7496c)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Button, "loading", g), (0, $15a7c5986a3f06c2$export$3c152e7b97c7496c)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Button, "fullwidth", B), f);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        ref: p,
        as: "button",
        className: D,
        "data-fullwidth": B,
        "data-loading": g,
        "data-size": j,
        "data-variation": y,
        isDisabled: z,
        type: w
    }, x), g ? $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        as: "span",
        className: (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).ButtonLoaderWrapper
    }, $acw62.createElement((0, $5acf83d6c1f21d4a$export$3b0d6d7590275603), {
        size: j
    }), v || null) : b);
});
$2732fbaf46f35309$export$353f5b6fc5456de1.displayName = "Button";





var $acw62 = parcelRequire("acw62");




const $7476e035421a7fc1$var$n = {
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
}, $7476e035421a7fc1$export$a8a3e93435678ff9 = $acw62.forwardRef((o, c)=>{
    var { className: l, children: d, isTruncated: f, level: h = 6 } = o, p = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className",
        "children",
        "isTruncated",
        "level"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: $7476e035421a7fc1$var$n[h],
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Heading, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Heading, h), (0, $15a7c5986a3f06c2$export$3c152e7b97c7496c)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Heading, "truncated", f), l),
        ref: c
    }, p), d);
});
$7476e035421a7fc1$export$a8a3e93435678ff9.displayName = "Heading";




var $acw62 = parcelRequire("acw62");




const $c617e684f7eee362$export$5f1af8db9871e1d6 = $acw62.forwardRef((o, n)=>{
    var { as: c = "p", className: d, children: f, isTruncated: l, variation: p } = o, u = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "as",
        "className",
        "children",
        "isTruncated",
        "variation"
    ]);
    const T = (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Text, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Text, p), (0, $15a7c5986a3f06c2$export$3c152e7b97c7496c)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Text, "truncated", l), d);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: c,
        className: T,
        "data-truncate": l,
        "data-variation": p,
        ref: n
    }, u), f);
});
$c617e684f7eee362$export$5f1af8db9871e1d6.displayName = "Text";





var $acw62 = parcelRequire("acw62");
const $9086333a7c6f61d1$export$896ffc81198e4315 = (r)=>"object" == typeof r && null !== r && "message" in r && "string" == typeof r.message, $9086333a7c6f61d1$export$b41f3ff9bba7a33e = (e)=>{
    if ($9086333a7c6f61d1$export$896ffc81198e4315(e)) return e;
    try {
        return new Error(JSON.stringify(e));
    } catch (r) {
        return new Error(String(e));
    }
}, $9086333a7c6f61d1$export$82f46aa4e6535a45 = (r)=>$9086333a7c6f61d1$export$b41f3ff9bba7a33e(r).message, $9086333a7c6f61d1$export$e29bbbec84471f66 = (r)=>{
    const e = new FormData(r.target);
    return Object.fromEntries(e);
};



function $e594a02664ea54b9$export$df6a82844cee724c() {
    const { submitForm: a, updateBlur: m, updateForm: u } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.submitForm,
            e.updateBlur,
            e.updateForm
        ]);
    return {
        handleBlur: (0, $acw62.useCallback)(({ target: { name: e } })=>{
            m({
                name: e
            });
        }, [
            m
        ]),
        handleChange: (0, $acw62.useCallback)(({ target: { checked: e, name: t, type: r, value: a } })=>{
            u({
                name: t,
                value: "checkbox" === r && !e ? void 0 : a
            });
        }, [
            u
        ]),
        handleSubmit: (0, $acw62.useCallback)((e)=>{
            e.preventDefault(), a((0, $9086333a7c6f61d1$export$e29bbbec84471f66)(e));
        }, [
            a
        ])
    };
}



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $0902f9a03ae75542$export$5f8c516af44338bb = $acw62.createContext({});


function $a89121c5b5441ea2$export$75b0b37acc90e887(r) {
    const n = $acw62.useContext((0, $0902f9a03ae75542$export$5f8c516af44338bb));
    if (r && n) return n[r];
}







var $acw62 = parcelRequire("acw62");



const $97d664812409ea01$export$8fb9587943155ce3 = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z",
        fill: "currentColor"
    })));
};





var $acw62 = parcelRequire("acw62");


const $347410f20c34f461$export$66493327321323ad = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
        fill: "currentColor"
    })));
};





var $acw62 = parcelRequire("acw62");


const $e972af9b74bb75f1$export$340bfce9b4df026b = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
        fill: "currentColor"
    })));
};





var $acw62 = parcelRequire("acw62");


const $8b6f870ee566926d$export$5be70e40251e6f9b = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z",
        fill: "currentColor"
    })));
};


const $5c7c7994d3a66a91$export$4a143c8822a09fb4 = ({ variation: s, ariaHidden: a })=>{
    var m, l, d, I;
    const p = (0, $a89121c5b5441ea2$export$75b0b37acc90e887)("alert");
    let u;
    switch(s){
        case "info":
            u = null !== (m = null == p ? void 0 : p.info) && void 0 !== m ? m : $acw62.createElement((0, $e972af9b74bb75f1$export$340bfce9b4df026b), {
                "aria-hidden": a
            });
            break;
        case "error":
            u = null !== (l = null == p ? void 0 : p.error) && void 0 !== l ? l : $acw62.createElement((0, $347410f20c34f461$export$66493327321323ad), {
                "aria-hidden": a
            });
            break;
        case "warning":
            u = null !== (d = null == p ? void 0 : p.warning) && void 0 !== d ? d : $acw62.createElement((0, $8b6f870ee566926d$export$5be70e40251e6f9b), {
                "aria-hidden": a
            });
            break;
        case "success":
            u = null !== (I = null == p ? void 0 : p.success) && void 0 !== I ? I : $acw62.createElement((0, $97d664812409ea01$export$8fb9587943155ce3), {
                "aria-hidden": a
            });
    }
    return u ? $acw62.createElement("span", {
        className: (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).AlertIcon
    }, u) : null;
};
$5c7c7994d3a66a91$export$4a143c8822a09fb4.displayName = "AlertIcon";








var $acw62 = parcelRequire("acw62");


const $fe581c01cc898db5$export$e04bcc6127e699bf = (i)=>{
    const { className: o, size: a } = i, l = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(i, [
        "className",
        "size"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: null != a ? a : "1em",
        height: null != a ? a : "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Icon, o)
    }, l), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: a ? {
            width: a,
            height: a
        } : void 0
    }, $acw62.createElement("path", {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
        fill: "currentColor"
    })));
};


const $c671a44227404083$export$caec2af78bcc877f = $acw62.forwardRef((p, u)=>{
    var b, { buttonRef: I, children: j, className: h, dismissButtonLabel: v = (0, $ca5815d75ab8dc16$export$529e7eefcb1e2a4c).Alert.dismissButtonLabel, hasIcon: A = !0, heading: x, isDismissible: E = !1, onDismiss: N, variation: B } = p, D = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(p, [
        "buttonRef",
        "children",
        "className",
        "dismissButtonLabel",
        "hasIcon",
        "heading",
        "isDismissible",
        "onDismiss",
        "variation"
    ]);
    const [g, w] = $acw62.useState(!1), C = (0, $a89121c5b5441ea2$export$75b0b37acc90e887)("alert"), L = $acw62.useCallback(()=>{
        w(!g), (0, $15a7c5986a3f06c2$export$f6e2535fb5126e54)(N) && N();
    }, [
        w,
        N,
        g
    ]);
    return g ? null : $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Alert, h, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Alert, B)),
        "data-variation": B,
        ref: u,
        role: "alert"
    }, D), A && $acw62.createElement((0, $5c7c7994d3a66a91$export$4a143c8822a09fb4), {
        variation: B,
        ariaHidden: !0
    }), $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        flex: "1"
    }, x && $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        className: (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).AlertHeading
    }, x), $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        className: (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).AlertBody
    }, j)), E && $acw62.createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        ariaLabel: v,
        variation: "link",
        className: (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).AlertDismiss,
        onClick: L,
        ref: I
    }, null !== (b = null == C ? void 0 : C.close) && void 0 !== b ? b : $acw62.createElement((0, $fe581c01cc898db5$export$e04bcc6127e699bf), {
        "aria-hidden": "true"
    })));
});
$c671a44227404083$export$caec2af78bcc877f.displayName = "Alert";


const $ba192fe9f9543e36$export$3caa4b6a8cb6c61a = ()=>{
    const { error: m } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((r)=>[
            r.error
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, m ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c671a44227404083$export$caec2af78bcc877f), {
        variation: "error",
        isDismissible: !0
    }, (0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)(m)) : null);
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



const $007ba0001dda9356$export$439d29a4e110a164 = $acw62.forwardRef((i, t)=>{
    var { as: o = "span", children: l, className: n } = i, c = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(i, [
        "as",
        "children",
        "className"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: o,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).VisuallyHidden, n),
        ref: t
    }, c), l);
});
$007ba0001dda9356$export$439d29a4e110a164.displayName = "VisuallyHidden";










var $acw62 = parcelRequire("acw62");


const $6a333cb4c13e6ee8$export$9ef36bcf05bb63d9 = (r)=>{
    const { className: o } = r, a = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(r, [
        "className"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Icon, o)
    }, a), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M12 6.0002C15.79 6.0002 19.17 8.1302 20.82 11.5002C20.23 12.7202 19.4 13.7702 18.41 14.6202L19.82 16.0302C21.21 14.8002 22.31 13.2602 23 11.5002C21.27 7.1102 17 4.0002 12 4.0002C10.73 4.0002 9.51 4.2002 8.36 4.5702L10.01 6.2202C10.66 6.0902 11.32 6.0002 12 6.0002ZM10.93 7.14019L13 9.2102C13.57 9.4602 14.03 9.9202 14.28 10.4902L16.35 12.5602C16.43 12.2202 16.49 11.8602 16.49 11.4902C16.5 9.0102 14.48 7.0002 12 7.0002C11.63 7.0002 11.28 7.05019 10.93 7.14019ZM2.01 3.8702L4.69 6.5502C3.06 7.8302 1.77 9.5302 1 11.5002C2.73 15.8902 7 19.0002 12 19.0002C13.52 19.0002 14.98 18.7102 16.32 18.1802L19.74 21.6002L21.15 20.1902L3.42 2.4502L2.01 3.8702ZM9.51 11.3702L12.12 13.9802C12.08 13.9902 12.04 14.0002 12 14.0002C10.62 14.0002 9.5 12.8802 9.5 11.5002C9.5 11.4502 9.51 11.4202 9.51 11.3702V11.3702ZM6.11 7.97019L7.86 9.7202C7.63 10.2702 7.5 10.8702 7.5 11.5002C7.5 13.9802 9.52 16.0002 12 16.0002C12.63 16.0002 13.23 15.8702 13.77 15.6402L14.75 16.6202C13.87 16.8602 12.95 17.0002 12 17.0002C8.21 17.0002 4.83 14.8702 3.18 11.5002C3.88 10.0702 4.9 8.89019 6.11 7.97019Z",
        fill: "currentColor"
    })));
};





var $acw62 = parcelRequire("acw62");


const $c4bc3719a8829cc0$export$e8b904c5d6d728c0 = (o)=>{
    const { className: a } = o, C = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Icon, a)
    }, C), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z",
        fill: "currentColor"
    })));
};



const { passwordIsHidden: $380bb98e2a77fa22$var$w, passwordIsShown: $380bb98e2a77fa22$var$p, showPassword: $380bb98e2a77fa22$var$c } = (0, $ca5815d75ab8dc16$export$529e7eefcb1e2a4c).PasswordField, $380bb98e2a77fa22$export$c42f83a0ca8c8188 = $acw62.forwardRef((t, f)=>{
    var h, u, { fieldType: I, passwordIsHiddenLabel: b = $380bb98e2a77fa22$var$w, passwordIsShownLabel: j = $380bb98e2a77fa22$var$p, showPasswordButtonLabel: y = $380bb98e2a77fa22$var$c, size: v, hasError: L } = t, P = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(t, [
        "fieldType",
        "passwordIsHiddenLabel",
        "passwordIsShownLabel",
        "showPasswordButtonLabel",
        "size",
        "hasError"
    ]);
    const E = (0, $a89121c5b5441ea2$export$75b0b37acc90e887)("passwordField"), S = (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldShowPassword, (0, $15a7c5986a3f06c2$export$3c152e7b97c7496c)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldShowPassword, "error", L)), V = "password" === I ? null !== (h = null == E ? void 0 : E.visibility) && void 0 !== h ? h : $acw62.createElement((0, $c4bc3719a8829cc0$export$e8b904c5d6d728c0), {
        "aria-hidden": "true"
    }) : null !== (u = null == E ? void 0 : E.visibilityOff) && void 0 !== u ? u : $acw62.createElement((0, $6a333cb4c13e6ee8$export$9ef36bcf05bb63d9), {
        "aria-hidden": "true"
    });
    return $acw62.createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), Object.assign({
        "aria-checked": "password" !== I,
        ariaLabel: y,
        className: S,
        ref: f,
        role: "switch",
        size: v
    }, P), $acw62.createElement((0, $007ba0001dda9356$export$439d29a4e110a164), {
        "aria-live": "polite"
    }, "password" === I ? b : j), V);
});
$380bb98e2a77fa22$export$c42f83a0ca8c8188.displayName = "ShowPasswordButton";




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



const $a5f3577765b39b4d$export$806e181b7f4dca8a = "qa-field-description", $a5f3577765b39b4d$export$873ced4623a3149c = (d)=>{
    var { descriptiveText: l, labelHidden: m } = d, o = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(d, [
        "descriptiveText",
        "labelHidden"
    ]);
    return l ? $acw62.createElement((0, $c617e684f7eee362$export$5f1af8db9871e1d6), Object.assign({
        "data-testid": $a5f3577765b39b4d$export$806e181b7f4dca8a,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldDescription, {
            [(0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).VisuallyHidden]: m
        })
    }, o), l) : null;
};
$a5f3577765b39b4d$export$873ced4623a3149c.displayName = "FieldDescription";




var $acw62 = parcelRequire("acw62");


const $91d5caa3c17c7574$export$1c081951d49ad6f6 = (o)=>{
    var { errorMessage: t, hasError: m } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "errorMessage",
        "hasError"
    ]);
    return m && t ? $acw62.createElement((0, $c617e684f7eee362$export$5f1af8db9871e1d6), Object.assign({
        className: (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldErrorMessage
    }, i), t) : null;
};
$91d5caa3c17c7574$export$1c081951d49ad6f6.displayName = "FieldErrorMessage";





var $acw62 = parcelRequire("acw62");





const $217cb0d31b5e6b93$export$f0fe469072bc6950 = $acw62.forwardRef((l, m)=>{
    var { children: p, className: s, innerEndComponent: d, innerStartComponent: u, orientation: c = "horizontal", outerEndComponent: F, outerStartComponent: E, variation: G } = l, f = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(l, [
        "children",
        "className",
        "innerEndComponent",
        "innerStartComponent",
        "orientation",
        "outerEndComponent",
        "outerStartComponent",
        "variation"
    ]);
    const N = null != d, C = null != u ? (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupHasInnerStart : null, S = N ? (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupHasInnerEnd : null, O = (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroup, C, S, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroup, c), s);
    return $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), Object.assign({
        className: O,
        "data-orientation": c,
        ref: m
    }, f), E && $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupOuterStart, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupOuterStart, G))
    }, E), $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupFieldWrapper, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupFieldWrapper, c)),
        "data-orientation": c
    }, u && $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        className: (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupInnerStart
    }, u), p, d && $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        className: (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupInnerEnd
    }, d)), F && $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupOuterEnd, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupOuterEnd, G))
    }, F));
});
$217cb0d31b5e6b93$export$f0fe469072bc6950.displayName = "FieldGroup";





var $acw62 = parcelRequire("acw62");





const $cefcb73ac9f287bd$export$f5b8910cec6cf069 = $acw62.forwardRef((o, u)=>{
    var { autoComplete: m, checked: p, className: n, defaultChecked: c, defaultValue: f, id: h, isDisabled: v, isReadOnly: y, isRequired: C, size: b, type: k = "text", hasError: I = !1, value: R, variation: V } = o, j = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "autoComplete",
        "checked",
        "className",
        "defaultChecked",
        "defaultValue",
        "id",
        "isDisabled",
        "isReadOnly",
        "isRequired",
        "size",
        "type",
        "hasError",
        "value",
        "variation"
    ]);
    const w = (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Input, (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupControl, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Input, V), (0, $15a7c5986a3f06c2$export$3c152e7b97c7496c)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Input, "error", I), (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Input, b), n), { isFieldsetDisabled: D } = (0, $3b7aa0a2fb31e524$export$b140571ec72925dd)();
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        "aria-invalid": I,
        as: "input",
        autoComplete: m,
        checked: p,
        className: w,
        "data-size": b,
        "data-variation": V,
        defaultChecked: c,
        defaultValue: f,
        isDisabled: D || v,
        id: h,
        readOnly: y,
        ref: u,
        required: C,
        type: k,
        value: R
    }, j));
});
$cefcb73ac9f287bd$export$f5b8910cec6cf069.displayName = "Input";




var $acw62 = parcelRequire("acw62");



const $d87aad0dee92c2d5$export$b04be29aa201d4f5 = $acw62.forwardRef((i, m)=>{
    var { children: t, className: o, visuallyHidden: n } = i, c = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(i, [
        "children",
        "className",
        "visuallyHidden"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: "label",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Label, o, {
            [(0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).VisuallyHidden]: n
        }),
        ref: m
    }, c), t);
});
$d87aad0dee92c2d5$export$b04be29aa201d4f5.displayName = "Label";



const $7195401a46d6d318$export$584a75f5facb0a5 = (t)=>{
    const e = {
        styleProps: {},
        rest: {}
    };
    return Object.keys(t).forEach((r)=>{
        ((t)=>t in (0, $750400f93007aa11$export$c69338bc7d797351))(r) ? e.styleProps = Object.assign(Object.assign({}, e.styleProps), {
            [r]: t[r]
        }) : e.rest = Object.assign(Object.assign({}, e.rest), {
            [r]: t[r]
        });
    }), e;
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $603233391f743b02$export$e5c5a5f917a5871c = (null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? $acw62.useLayoutEffect : ()=>{};


const $1095fef8c965210c$export$766b2b49c9d08de4 = "amplify-id", $1095fef8c965210c$var$e = $acw62["useId".toString()] || (()=>{});
let $1095fef8c965210c$var$n = 0;
const $1095fef8c965210c$export$5c0b1cf3fea224ac = (s)=>{
    const [u, i] = $acw62.useState($1095fef8c965210c$var$e());
    return (0, $603233391f743b02$export$e5c5a5f917a5871c)(()=>{
        s || i((t)=>null != t ? t : String($1095fef8c965210c$var$n++));
    }, [
        s
    ]), null != s ? s : u ? `${$1095fef8c965210c$export$766b2b49c9d08de4}-${u}` : "";
};


const $8aecf2eb33426e70$export$2c73285ae9390cec = $acw62.forwardRef((u, f)=>{
    const { className: E, descriptiveText: F, errorMessage: b, hasError: j = !1, id: C, innerEndComponent: v, innerStartComponent: S, label: x, labelHidden: y = !1, outerEndComponent: g, outerStartComponent: h, size: I, testId: T, variation: z, inputStyles: H } = u, M = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(u, [
        "className",
        "descriptiveText",
        "errorMessage",
        "hasError",
        "id",
        "innerEndComponent",
        "innerStartComponent",
        "label",
        "labelHidden",
        "outerEndComponent",
        "outerStartComponent",
        "size",
        "testId",
        "variation",
        "inputStyles"
    ]), N = (0, $1095fef8c965210c$export$5c0b1cf3fea224ac)(C), P = (0, $1095fef8c965210c$export$5c0b1cf3fea224ac)(), w = F ? P : void 0, { styleProps: G, rest: L } = (0, $7195401a46d6d318$export$584a75f5facb0a5)(M);
    return $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Field, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Field, I), (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).TextField, E),
        "data-size": I,
        testId: T
    }, G), $acw62.createElement((0, $d87aad0dee92c2d5$export$b04be29aa201d4f5), {
        htmlFor: N,
        visuallyHidden: y
    }, x), $acw62.createElement((0, $a5f3577765b39b4d$export$873ced4623a3149c), {
        id: P,
        labelHidden: y,
        descriptiveText: F
    }), $acw62.createElement((0, $217cb0d31b5e6b93$export$f0fe469072bc6950), {
        outerStartComponent: h,
        outerEndComponent: g,
        innerStartComponent: S,
        innerEndComponent: v,
        variation: z
    }, $acw62.createElement((0, $cefcb73ac9f287bd$export$f5b8910cec6cf069), Object.assign({
        "aria-describedby": w,
        hasError: j,
        id: N,
        ref: f,
        size: I,
        variation: z
    }, H, L))), $acw62.createElement((0, $91d5caa3c17c7574$export$1c081951d49ad6f6), {
        hasError: j,
        errorMessage: b
    }));
});
$8aecf2eb33426e70$export$2c73285ae9390cec.displayName = "TextField";


const $16cf63c29139dbf9$export$65ed9482db2257fa = $acw62.forwardRef((d, l)=>{
    var { autoComplete: w = "current-password", label: n, className: m, hideShowPassword: i = !1, passwordIsHiddenLabel: p, passwordIsShownLabel: h, showPasswordButtonLabel: b, showPasswordButtonRef: u, size: c, hasError: f } = d, P = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(d, [
        "autoComplete",
        "label",
        "className",
        "hideShowPassword",
        "passwordIsHiddenLabel",
        "passwordIsShownLabel",
        "showPasswordButtonLabel",
        "showPasswordButtonRef",
        "size",
        "hasError"
    ]);
    const [L, E] = $acw62.useState("password"), S = $acw62.useCallback(()=>{
        E("password" === L ? "text" : "password");
    }, [
        E,
        L
    ]);
    return $acw62.createElement((0, $8aecf2eb33426e70$export$2c73285ae9390cec), Object.assign({
        autoComplete: w,
        outerEndComponent: i ? null : $acw62.createElement((0, $380bb98e2a77fa22$export$c42f83a0ca8c8188), {
            fieldType: L,
            onClick: S,
            passwordIsHiddenLabel: p,
            passwordIsShownLabel: h,
            ref: u,
            size: c,
            showPasswordButtonLabel: b,
            hasError: f
        }),
        size: c,
        type: L,
        label: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).PasswordField, m),
        ref: l,
        hasError: f
    }, P));
});
$16cf63c29139dbf9$export$65ed9482db2257fa.displayName = "PasswordField";




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");


const $9f58f19f595e5904$export$e0c00b3c5102a294 = (o)=>{
    const { className: a } = o, i = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Icon, a)
    }, i), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z",
        fill: "currentColor"
    })));
};



const $f0b0a556af67bf8c$export$ef9b1a59e592288f = $acw62.forwardRef((d, p)=>{
    var u, { autoComplete: f, className: v, size: I, variation: j, value: x, defaultValue: E, hasError: S, icon: h, iconColor: C, children: b, placeholder: F, isDisabled: N, isRequired: V } = d, w = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(d, [
        "autoComplete",
        "className",
        "size",
        "variation",
        "value",
        "defaultValue",
        "hasError",
        "icon",
        "iconColor",
        "children",
        "placeholder",
        "isDisabled",
        "isRequired"
    ]);
    const D = void 0 === x && void 0 === E && F, q = (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Select, (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).FieldGroupControl, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Select, I), (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Select, j), (0, $15a7c5986a3f06c2$export$3c152e7b97c7496c)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Select, "error", S), v), z = (0, $a89121c5b5441ea2$export$75b0b37acc90e887)("select"), { isFieldsetDisabled: R } = (0, $3b7aa0a2fb31e524$export$b140571ec72925dd)();
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        className: (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).SelectWrapper
    }, $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        "aria-invalid": S,
        as: "select",
        autoComplete: f,
        value: x,
        defaultValue: D ? "" : E,
        isDisabled: R || N,
        required: V,
        "data-size": I,
        "data-variation": j,
        className: q,
        ref: p
    }, w), F && $acw62.createElement("option", {
        value: ""
    }, F), b), $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).SelectIconWrapper, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).SelectIconWrapper, I)),
        color: C
    }, null !== (u = null != h ? h : null == z ? void 0 : z.expand) && void 0 !== u ? u : $acw62.createElement((0, $9f58f19f595e5904$export$e0c00b3c5102a294), null)));
});
$f0b0a556af67bf8c$export$ef9b1a59e592288f.displayName = "Select";




const $09a16f3fd05b871c$export$d55b50a564d0b931 = $acw62.forwardRef((c, f)=>{
    const { children: F, className: h, descriptiveText: b, errorMessage: u, hasError: j = !1, id: E, label: v, labelHidden: g = !1, options: y, size: S, testId: x, inputStyles: I } = c, z = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(c, [
        "children",
        "className",
        "descriptiveText",
        "errorMessage",
        "hasError",
        "id",
        "label",
        "labelHidden",
        "options",
        "size",
        "testId",
        "inputStyles"
    ]), H = (0, $1095fef8c965210c$export$5c0b1cf3fea224ac)(E), M = (0, $1095fef8c965210c$export$5c0b1cf3fea224ac)(), N = b ? M : void 0, { styleProps: w, rest: P } = (0, $7195401a46d6d318$export$584a75f5facb0a5)(z);
    return $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Field, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Field, S), (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).SelectField, h),
        "data-size": S,
        testId: x
    }, w), $acw62.createElement((0, $d87aad0dee92c2d5$export$b04be29aa201d4f5), {
        htmlFor: H,
        visuallyHidden: g
    }, v), $acw62.createElement((0, $a5f3577765b39b4d$export$873ced4623a3149c), {
        id: M,
        labelHidden: g,
        descriptiveText: b
    }), $acw62.createElement((0, $f0b0a556af67bf8c$export$ef9b1a59e592288f), Object.assign({
        "aria-describedby": N,
        hasError: j,
        id: H,
        ref: f,
        size: S
    }, P, I), (({ children: e, options: i })=>e ? ((null == i ? void 0 : i.length) && console.warn("Amplify UI: <SelectField> component  defaults to rendering children over `options`. When using the `options` prop, omit children."), e) : null == i ? void 0 : i.map((e, i)=>$acw62.createElement("option", {
                label: e,
                value: e,
                key: `${e}-${i}`
            }, e)))({
        children: F,
        options: y
    })), $acw62.createElement((0, $91d5caa3c17c7574$export$1c081951d49ad6f6), {
        hasError: j,
        errorMessage: u
    }));
});
$09a16f3fd05b871c$export$d55b50a564d0b931.displayName = "SelectField";


const $1c70adf24ca42295$export$3978650a8f87744f = $acw62.forwardRef((r, i)=>{
    var { className: m, dialCodeList: d, isReadOnly: c } = r, n = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(r, [
        "className",
        "dialCodeList",
        "isReadOnly"
    ]);
    const p = null != d ? d : (0, $f077a85279c81c4a$export$a51e8cda1526c737), f = $acw62.useMemo(()=>p.map((e)=>$acw62.createElement("option", {
                key: e,
                value: e,
                disabled: c
            }, e)), [
        p,
        c
    ]);
    return $acw62.createElement((0, $09a16f3fd05b871c$export$d55b50a564d0b931), Object.assign({
        "aria-disabled": c,
        autoComplete: "tel-country-code",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).CountryCodeSelect, (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).DialCodeSelect, m),
        labelHidden: !0,
        ref: i
    }, n), f);
});
$1c70adf24ca42295$export$3978650a8f87744f.displayName = "CountryCodeSelect";



const $ac0db1a07e7e9125$export$522a16be7a55e553 = $acw62.forwardRef((d, i)=>{
    var { autoComplete: s = "tel-national", className: C, countryCodeName: m, countryCodeLabel: u = (0, $ca5815d75ab8dc16$export$529e7eefcb1e2a4c).PhoneNumberField.countryCodeLabel, countryCodeRef: c, defaultCountryCode: f, defaultDialCode: y, dialCodeLabel: b = (0, $ca5815d75ab8dc16$export$529e7eefcb1e2a4c).PhoneNumberField.countryCodeLabel, dialCodeList: p, dialCodeName: h, dialCodeRef: N, hasError: L, isDisabled: R, isReadOnly: D, onCountryCodeChange: g, onDialCodeChange: E, onInput: F, size: v, variation: O } = d, j = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(d, [
        "autoComplete",
        "className",
        "countryCodeName",
        "countryCodeLabel",
        "countryCodeRef",
        "defaultCountryCode",
        "defaultDialCode",
        "dialCodeLabel",
        "dialCodeList",
        "dialCodeName",
        "dialCodeRef",
        "hasError",
        "isDisabled",
        "isReadOnly",
        "onCountryCodeChange",
        "onDialCodeChange",
        "onInput",
        "size",
        "variation"
    ]);
    const z = null != h ? h : m, P = null != b ? b : u, x = null != y ? y : f, I = null != E ? E : g, S = null != N ? N : c;
    return $acw62.createElement((0, $8aecf2eb33426e70$export$2c73285ae9390cec), Object.assign({
        outerStartComponent: $acw62.createElement((0, $1c70adf24ca42295$export$3978650a8f87744f), {
            defaultValue: x,
            dialCodeList: p,
            className: C,
            hasError: L,
            isDisabled: R,
            isReadOnly: D,
            label: P,
            name: z,
            onChange: I,
            ref: S,
            size: v,
            variation: O
        }),
        autoComplete: s,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).PhoneNumberField, C),
        hasError: L,
        isDisabled: R,
        isReadOnly: D,
        onInput: F,
        ref: i,
        size: v,
        type: "tel",
        variation: O
    }, j));
});
$ac0db1a07e7e9125$export$522a16be7a55e553.displayName = "PhoneNumberField";






var $acw62 = parcelRequire("acw62");



const $799d7d619c84d2be$export$db10347ccaf03b65 = ({ errors: m, id: o, dataAttr: a })=>{
    if (!((null == m ? void 0 : m.length) > 0)) return null;
    const n = a ? {
        [a]: !0
    } : {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({}, n, {
        id: o
    }), m.map((t)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c617e684f7eee362$export$5f1af8db9871e1d6), {
            key: t,
            role: "alert",
            variation: "error"
        }, (0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)(t))));
};


function $5294be4505fe32a7$export$56e87bf42978147a(d) {
    var { autocomplete: n, dialCode: p, name: c, type: u } = d, f = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(d, [
        "autocomplete",
        "dialCode",
        "name",
        "type"
    ]);
    const { validationErrors: E } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)(({ validationErrors: e })=>[
            e
        ]), b = $acw62.useMemo(()=>(0, $2227b0b05b5cd59e$export$501239432719417d)(E[c]), [
        c,
        E
    ]), y = (null == b ? void 0 : b.length) > 0, g = (0, $1095fef8c965210c$export$5c0b1cf3fea224ac)(), v = y ? g : void 0;
    return "tel" === u ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $ac0db1a07e7e9125$export$522a16be7a55e553), Object.assign({}, f, {
        name: c,
        defaultDialCode: p,
        dialCodeName: "country_code",
        autoComplete: n,
        hasError: y,
        "aria-describedby": v
    })), $acw62.createElement((0, $799d7d619c84d2be$export$db10347ccaf03b65), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: b,
        id: g
    })) : "password" === u ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $16cf63c29139dbf9$export$65ed9482db2257fa), Object.assign({}, f, {
        name: c,
        autoComplete: n,
        hasError: y,
        "aria-describedby": v
    })), $acw62.createElement((0, $799d7d619c84d2be$export$db10347ccaf03b65), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: b,
        id: g
    })) : $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $8aecf2eb33426e70$export$2c73285ae9390cec), Object.assign({}, f, {
        name: c,
        autoComplete: n,
        hasError: y,
        type: u,
        "aria-describedby": v
    })), $acw62.createElement((0, $799d7d619c84d2be$export$db10347ccaf03b65), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: b,
        id: g
    }));
}



function $036d7109f9666f35$export$125d0b248abd3e88() {
    const { fields: m } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)(({ route: e })=>[
            e
        ]), o = $acw62.useRef(m.map((t, m)=>$acw62.createElement((0, $5294be4505fe32a7$export$56e87bf42978147a), Object.assign({
            key: m
        }, t)))).current;
    return $acw62.createElement($acw62.Fragment, null, o);
}



var $acw62 = parcelRequire("acw62");



const $837c07886f78538a$var$r = (e)=>"signIn" === e || "signUp";
function $837c07886f78538a$export$253df7dc30f737bc({ children: n, className: m, variation: i = "default" }) {
    const { route: s } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)(({ route: e })=>[
            e
        ]), { components: { Header: c, Footer: l } } = (0, $34076cf41c51978d$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        className: m,
        "data-amplify-authenticator": "",
        "data-variation": i
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        "data-amplify-container": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(c, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        "data-amplify-router": "",
        "data-amplify-router-content": $837c07886f78538a$var$r(s) ? void 0 : ""
    }, n), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(l, null)));
}


const { getDeliveryMessageText: $0a3cdc9f602c61e3$var$u, getDeliveryMethodText: $0a3cdc9f602c61e3$var$p, getConfirmingText: $0a3cdc9f602c61e3$var$f, getConfirmText: $0a3cdc9f602c61e3$var$g, getResendCodeText: $0a3cdc9f602c61e3$var$C } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb);
function $0a3cdc9f602c61e3$export$649c708157e61c64({ className: t, variation: i }) {
    const { isPending: p, resendCode: v, codeDeliveryDetails: y } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.isPending,
            e.resendCode,
            e.codeDeliveryDetails
        ]), { handleChange: E, handleSubmit: D } = (0, $e594a02664ea54b9$export$df6a82844cee724c)(), { components: { ConfirmSignUp: { Header: x = $0a3cdc9f602c61e3$export$649c708157e61c64.Header, Footer: j = $0a3cdc9f602c61e3$export$649c708157e61c64.Footer } } } = (0, $34076cf41c51978d$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $837c07886f78538a$export$253df7dc30f737bc), {
        className: t,
        variation: i
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmsignup": "",
        method: "post",
        onChange: E,
        onSubmit: D
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: p
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(x, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c617e684f7eee362$export$5f1af8db9871e1d6), {
        className: "amplify-authenticator__subtitle"
    }, $0a3cdc9f602c61e3$var$u(y)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $036d7109f9666f35$export$125d0b248abd3e88), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba192fe9f9543e36$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        variation: "primary",
        isDisabled: p,
        type: "submit",
        loadingText: $0a3cdc9f602c61e3$var$f(),
        isLoading: p,
        fontWeight: "normal"
    }, $0a3cdc9f602c61e3$var$g()), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        onClick: v,
        type: "button",
        fontWeight: "normal"
    }, $0a3cdc9f602c61e3$var$C())), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(j, null))));
}
$0a3cdc9f602c61e3$export$649c708157e61c64.Header = ()=>{
    const { codeDeliveryDetails: t } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.codeDeliveryDetails
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7476e035421a7fc1$export$a8a3e93435678ff9), {
        level: 4
    }, $0a3cdc9f602c61e3$var$p(t));
}, $0a3cdc9f602c61e3$export$649c708157e61c64.Footer = function() {
    return null;
};



var $acw62 = parcelRequire("acw62");










const { getChangePasswordText: $6be1927e7d0e5ef3$var$d, getChangingText: $6be1927e7d0e5ef3$var$c, getBackToSignInText: $6be1927e7d0e5ef3$var$p } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb), $6be1927e7d0e5ef3$export$b3aae0a112274a60 = ({ className: t, variation: n })=>{
    const { isPending: l, toSignIn: g } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.isPending,
            e.toSignIn
        ]), { handleBlur: F, handleChange: h, handleSubmit: E } = (0, $e594a02664ea54b9$export$df6a82844cee724c)(), { components: { ForceNewPassword: { FormFields: C = $6be1927e7d0e5ef3$export$b3aae0a112274a60.FormFields, Header: j = $6be1927e7d0e5ef3$export$b3aae0a112274a60.Header, Footer: v = $6be1927e7d0e5ef3$export$b3aae0a112274a60.Footer } } } = (0, $34076cf41c51978d$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $837c07886f78538a$export$253df7dc30f737bc), {
        className: t,
        variation: n
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-forcenewpassword": "",
        method: "post",
        onChange: h,
        onSubmit: E,
        onBlur: F
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(j, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(C, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba192fe9f9543e36$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        isDisabled: l,
        type: "submit",
        variation: "primary",
        isLoading: l,
        loadingText: $6be1927e7d0e5ef3$var$c(),
        fontWeight: "normal"
    }, $6be1927e7d0e5ef3$var$d()), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        onClick: g,
        type: "button",
        fontWeight: "normal",
        variation: "link",
        size: "small"
    }, $6be1927e7d0e5ef3$var$p()), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(v, null))));
};
$6be1927e7d0e5ef3$export$b3aae0a112274a60.FormFields = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $036d7109f9666f35$export$125d0b248abd3e88), null);
}, $6be1927e7d0e5ef3$export$b3aae0a112274a60.Header = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7476e035421a7fc1$export$a8a3e93435678ff9), {
        level: 4
    }, $6be1927e7d0e5ef3$var$d());
}, $6be1927e7d0e5ef3$export$b3aae0a112274a60.Footer = function() {
    return null;
};



var $092c7e998bebe629$exports = {};

$parcel$export($092c7e998bebe629$exports, "create", () => $092c7e998bebe629$export$185802fd694ee1f5, (v) => $092c7e998bebe629$export$185802fd694ee1f5 = v);
$parcel$export($092c7e998bebe629$exports, "toCanvas", () => $092c7e998bebe629$export$f87f6982d1fd4f81, (v) => $092c7e998bebe629$export$f87f6982d1fd4f81 = v);
$parcel$export($092c7e998bebe629$exports, "toDataURL", () => $092c7e998bebe629$export$723e4939e5a27c8, (v) => $092c7e998bebe629$export$723e4939e5a27c8 = v);
$parcel$export($092c7e998bebe629$exports, "toString", () => $092c7e998bebe629$export$f84e8e69fd4488a5, (v) => $092c7e998bebe629$export$f84e8e69fd4488a5 = v);
var $092c7e998bebe629$export$185802fd694ee1f5;
var $092c7e998bebe629$export$f87f6982d1fd4f81;
var $092c7e998bebe629$export$723e4939e5a27c8;
// only svg for now.
var $092c7e998bebe629$export$f84e8e69fd4488a5;
var $e6419622b12b5572$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$e6419622b12b5572$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $5f2127839fe01a16$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $c1483b5b1305278f$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $c1483b5b1305278f$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $c1483b5b1305278f$export$ed1d66da50968976;
var $c1483b5b1305278f$export$6733b14783f975c2;
var $c1483b5b1305278f$export$ce5b1274f8597fa0;
var $c1483b5b1305278f$export$43dd553ecded716d;
let $c1483b5b1305278f$var$toSJISFunction;
const $c1483b5b1305278f$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$c1483b5b1305278f$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$c1483b5b1305278f$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $c1483b5b1305278f$var$CODEWORDS_COUNT[version];
};
$c1483b5b1305278f$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$c1483b5b1305278f$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $c1483b5b1305278f$var$toSJISFunction = f;
};
$c1483b5b1305278f$export$ce5b1274f8597fa0 = function() {
    return typeof $c1483b5b1305278f$var$toSJISFunction !== "undefined";
};
$c1483b5b1305278f$export$43dd553ecded716d = function toSJIS(kanji) {
    return $c1483b5b1305278f$var$toSJISFunction(kanji);
};


var $d22956012916b666$export$61196ced6d74a310;
var $d22956012916b666$export$3a1a48c8f6ef640e;
var $d22956012916b666$export$3722cfe417b6ed86;
var $d22956012916b666$export$7f8ddf7c7c20b3cd;
var $d22956012916b666$export$1ea939691cdc45b8;
var $d22956012916b666$export$6788812c4e6611e6;
$d22956012916b666$export$61196ced6d74a310 = {
    bit: 1
};
$d22956012916b666$export$3a1a48c8f6ef640e = {
    bit: 0
};
$d22956012916b666$export$3722cfe417b6ed86 = {
    bit: 3
};
$d22956012916b666$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $d22956012916b666$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $d22956012916b666$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $d22956012916b666$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $d22956012916b666$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $d22956012916b666$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$d22956012916b666$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$d22956012916b666$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($d22956012916b666$export$1ea939691cdc45b8(value)) return value;
    try {
        return $d22956012916b666$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $22a6389bcfc83921$exports = {};
function $22a6389bcfc83921$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$22a6389bcfc83921$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$22a6389bcfc83921$exports = $22a6389bcfc83921$var$BitBuffer;


var $3c0264e2c9c64d36$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $3c0264e2c9c64d36$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$3c0264e2c9c64d36$exports = $3c0264e2c9c64d36$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $c20e4b3185223698$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c20e4b3185223698$export$c39457c570f2b189;

var $c20e4b3185223698$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
$c20e4b3185223698$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $c20e4b3185223698$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$c20e4b3185223698$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $c20e4b3185223698$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b4836838cc492349$export$c39457c570f2b189;

var $b4836838cc492349$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
const $b4836838cc492349$var$FINDER_PATTERN_SIZE = 7;
$b4836838cc492349$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b4836838cc492349$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $1edc2624fba191d0$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $1edc2624fba191d0$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $1edc2624fba191d0$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $1edc2624fba191d0$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $1edc2624fba191d0$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $1edc2624fba191d0$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $1edc2624fba191d0$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $1edc2624fba191d0$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $1edc2624fba191d0$export$fe9625aaceb0e563;
$1edc2624fba191d0$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $1edc2624fba191d0$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$1edc2624fba191d0$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$1edc2624fba191d0$export$6788812c4e6611e6 = function from(value) {
    return $1edc2624fba191d0$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$1edc2624fba191d0$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$1edc2624fba191d0$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N2;
};
$1edc2624fba191d0$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N3;
};
$1edc2624fba191d0$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $1edc2624fba191d0$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $1edc2624fba191d0$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$1edc2624fba191d0$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $1edc2624fba191d0$var$getMaskAt(pattern, row, col));
    }
};
$1edc2624fba191d0$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($1edc2624fba191d0$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $1edc2624fba191d0$export$a5fd3a02c14d0b3e(data) + $1edc2624fba191d0$export$9a9385107a518e46(data) + $1edc2624fba191d0$export$ade754353f0dc75e(data) + $1edc2624fba191d0$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $7f809b8d8966b945$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $7f809b8d8966b945$export$683d1b3e8a1a8438;

const $7f809b8d8966b945$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $7f809b8d8966b945$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$7f809b8d8966b945$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$7f809b8d8966b945$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $06a1abce65162dc0$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $9563d144998a4c78$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $9563d144998a4c78$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $9563d144998a4c78$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $758ebb328fd03b3c$export$6e3a27864ab166fe;
const $758ebb328fd03b3c$var$EXP_TABLE = new Uint8Array(512);
const $758ebb328fd03b3c$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $758ebb328fd03b3c$var$EXP_TABLE[i] = x;
        $758ebb328fd03b3c$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$758ebb328fd03b3c$var$EXP_TABLE[i] = $758ebb328fd03b3c$var$EXP_TABLE[i - 255];
})();
$758ebb328fd03b3c$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $758ebb328fd03b3c$var$LOG_TABLE[n];
};
$758ebb328fd03b3c$export$b310ec824aaee37f = function exp(n) {
    return $758ebb328fd03b3c$var$EXP_TABLE[n];
};
$758ebb328fd03b3c$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $758ebb328fd03b3c$var$EXP_TABLE[$758ebb328fd03b3c$var$LOG_TABLE[x] + $758ebb328fd03b3c$var$LOG_TABLE[y]];
};


$9563d144998a4c78$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$9563d144998a4c78$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$9563d144998a4c78$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $9563d144998a4c78$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $758ebb328fd03b3c$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $06a1abce65162dc0$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $9563d144998a4c78$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $9563d144998a4c78$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$06a1abce65162dc0$exports = $06a1abce65162dc0$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $140eee110ea3b5f9$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $140eee110ea3b5f9$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $140eee110ea3b5f9$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $140eee110ea3b5f9$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $21e4e023abb588c2$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $21e4e023abb588c2$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $21e4e023abb588c2$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $21e4e023abb588c2$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $21e4e023abb588c2$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $7f0bebb05133540b$export$1ea939691cdc45b8;
$7f0bebb05133540b$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $d479c387334094fb$export$a4d452c2363c8e12;
var $d479c387334094fb$export$9df7c29d562bab83;
var $d479c387334094fb$export$8f4bf8f7eb581284;
var $d479c387334094fb$export$4d318981b5a83836;
var $d479c387334094fb$export$376a9ed239d6c1c8;
var $d479c387334094fb$export$175f16aef75a4569;
var $d479c387334094fb$export$50b7f9bf92c74274;
var $d479c387334094fb$export$4ba5f52893b4ac97;
const $d479c387334094fb$var$numeric = "[0-9]+";
const $d479c387334094fb$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $d479c387334094fb$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$d479c387334094fb$var$kanji = $d479c387334094fb$var$kanji.replace(/u/g, "\\u");
const $d479c387334094fb$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $d479c387334094fb$var$kanji + ")(?:.|[\r\n]))+";
$d479c387334094fb$export$a4d452c2363c8e12 = new RegExp($d479c387334094fb$var$kanji, "g");
$d479c387334094fb$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$d479c387334094fb$export$8f4bf8f7eb581284 = new RegExp($d479c387334094fb$var$byte, "g");
$d479c387334094fb$export$4d318981b5a83836 = new RegExp($d479c387334094fb$var$numeric, "g");
$d479c387334094fb$export$376a9ed239d6c1c8 = new RegExp($d479c387334094fb$var$alphanumeric, "g");
const $d479c387334094fb$var$TEST_KANJI = new RegExp("^" + $d479c387334094fb$var$kanji + "$");
const $d479c387334094fb$var$TEST_NUMERIC = new RegExp("^" + $d479c387334094fb$var$numeric + "$");
const $d479c387334094fb$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$d479c387334094fb$export$175f16aef75a4569 = function testKanji(str) {
    return $d479c387334094fb$var$TEST_KANJI.test(str);
};
$d479c387334094fb$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $d479c387334094fb$var$TEST_NUMERIC.test(str);
};
$d479c387334094fb$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $d479c387334094fb$var$TEST_ALPHANUMERIC.test(str);
};


$21e4e023abb588c2$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$21e4e023abb588c2$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$21e4e023abb588c2$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$21e4e023abb588c2$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$21e4e023abb588c2$export$bb410559a65d3418 = {
    bit: -1
};
$21e4e023abb588c2$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$21e4e023abb588c2$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($d479c387334094fb$export$50b7f9bf92c74274(dataStr)) return $21e4e023abb588c2$export$4d318981b5a83836;
    else if ($d479c387334094fb$export$4ba5f52893b4ac97(dataStr)) return $21e4e023abb588c2$export$376a9ed239d6c1c8;
    else if ($d479c387334094fb$export$175f16aef75a4569(dataStr)) return $21e4e023abb588c2$export$a4d452c2363c8e12;
    else return $21e4e023abb588c2$export$8f4bf8f7eb581284;
};
$21e4e023abb588c2$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$21e4e023abb588c2$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $21e4e023abb588c2$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $21e4e023abb588c2$export$4d318981b5a83836;
        case "alphanumeric":
            return $21e4e023abb588c2$export$376a9ed239d6c1c8;
        case "kanji":
            return $21e4e023abb588c2$export$a4d452c2363c8e12;
        case "byte":
            return $21e4e023abb588c2$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$21e4e023abb588c2$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($21e4e023abb588c2$export$1ea939691cdc45b8(value)) return value;
    try {
        return $21e4e023abb588c2$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $140eee110ea3b5f9$var$G18 = 7973;
const $140eee110ea3b5f9$var$G18_BCH = $c1483b5b1305278f$export$ed1d66da50968976($140eee110ea3b5f9$var$G18);
function $140eee110ea3b5f9$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $140eee110ea3b5f9$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $21e4e023abb588c2$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $140eee110ea3b5f9$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $140eee110ea3b5f9$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $21e4e023abb588c2$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$140eee110ea3b5f9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($7f0bebb05133540b$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$140eee110ea3b5f9$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $21e4e023abb588c2$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $140eee110ea3b5f9$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$140eee110ea3b5f9$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $d22956012916b666$export$6788812c4e6611e6(errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $140eee110ea3b5f9$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $140eee110ea3b5f9$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$140eee110ea3b5f9$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH >= 0)d ^= $140eee110ea3b5f9$var$G18 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $1f894980312e7d2a$export$eee5438974ef6f0e;

const $1f894980312e7d2a$var$G15 = 1335;
const $1f894980312e7d2a$var$G15_MASK = 21522;
const $1f894980312e7d2a$var$G15_BCH = $c1483b5b1305278f$export$ed1d66da50968976($1f894980312e7d2a$var$G15);
$1f894980312e7d2a$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH >= 0)d ^= $1f894980312e7d2a$var$G15 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $1f894980312e7d2a$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $06b6d7424b9df2df$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $06b6d7424b9df2df$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $06b6d7424b9df2df$export$89ab1afb9839589b;

var $7a5bacf4a539441d$exports = {};

function $7a5bacf4a539441d$var$NumericData(data) {
    this.mode = $21e4e023abb588c2$export$4d318981b5a83836;
    this.data = data.toString();
}
$7a5bacf4a539441d$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$7a5bacf4a539441d$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7a5bacf4a539441d$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $7a5bacf4a539441d$var$NumericData.getBitsLength(this.data.length);
};
$7a5bacf4a539441d$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$7a5bacf4a539441d$exports = $7a5bacf4a539441d$var$NumericData;


var $f6549c884fd9ace3$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $f6549c884fd9ace3$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $f6549c884fd9ace3$var$AlphanumericData(data) {
    this.mode = $21e4e023abb588c2$export$376a9ed239d6c1c8;
    this.data = data;
}
$f6549c884fd9ace3$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $f6549c884fd9ace3$var$AlphanumericData.getBitsLength(this.data.length);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$f6549c884fd9ace3$exports = $f6549c884fd9ace3$var$AlphanumericData;


var $47f01312d66828cb$exports = {};
var $b5acdf7c8123a019$exports = {};
"use strict";
$b5acdf7c8123a019$exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};



function $47f01312d66828cb$var$ByteData(data) {
    this.mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    this.data = new Uint8Array($b5acdf7c8123a019$exports(data));
}
$47f01312d66828cb$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$47f01312d66828cb$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$47f01312d66828cb$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $47f01312d66828cb$var$ByteData.getBitsLength(this.data.length);
};
$47f01312d66828cb$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$47f01312d66828cb$exports = $47f01312d66828cb$var$ByteData;


var $668803520f2d7445$exports = {};


function $668803520f2d7445$var$KanjiData(data) {
    this.mode = $21e4e023abb588c2$export$a4d452c2363c8e12;
    this.data = data;
}
$668803520f2d7445$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$668803520f2d7445$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$668803520f2d7445$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $668803520f2d7445$var$KanjiData.getBitsLength(this.data.length);
};
$668803520f2d7445$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $c1483b5b1305278f$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$668803520f2d7445$exports = $668803520f2d7445$var$KanjiData;




var $6c1abb425b529163$exports = {};
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $6c1abb425b529163$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $6c1abb425b529163$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $6c1abb425b529163$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $6c1abb425b529163$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $6c1abb425b529163$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$6c1abb425b529163$exports = $6c1abb425b529163$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $06b6d7424b9df2df$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegmentsFromString(dataStr) {
    const numSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$4d318981b5a83836, $21e4e023abb588c2$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$376a9ed239d6c1c8, $21e4e023abb588c2$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($c1483b5b1305278f$export$ce5b1274f8597fa0()) {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$8f4bf8f7eb581284, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$a4d452c2363c8e12, $21e4e023abb588c2$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$9df7c29d562bab83, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $06b6d7424b9df2df$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return $7a5bacf4a539441d$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return $f6549c884fd9ace3$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return $668803520f2d7445$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return $47f01312d66828cb$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $21e4e023abb588c2$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $06b6d7424b9df2df$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(node.length, node.mode) + 4 + $21e4e023abb588c2$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $06b6d7424b9df2df$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $21e4e023abb588c2$export$1bd4c93ffb42e55e(data);
    mode = $21e4e023abb588c2$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $21e4e023abb588c2$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $21e4e023abb588c2$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $21e4e023abb588c2$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $21e4e023abb588c2$export$a4d452c2363c8e12 && !$c1483b5b1305278f$export$ce5b1274f8597fa0()) mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return new $7a5bacf4a539441d$exports(data);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return new $f6549c884fd9ace3$exports(data);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return new $668803520f2d7445$exports(data);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return new $47f01312d66828cb$exports(data);
    }
}
$06b6d7424b9df2df$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$06b6d7424b9df2df$export$3004f64547af360e = function fromString(data, version) {
    const segs = $06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0());
    const nodes = $06b6d7424b9df2df$var$buildNodes(segs);
    const graph = $06b6d7424b9df2df$var$buildGraph(nodes, version);
    const path = $6c1abb425b529163$exports.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$mergeSegments(optimizedSegs));
};
$06b6d7424b9df2df$export$89ab1afb9839589b = function rawSplit(data) {
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $b4836838cc492349$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $5f2127839fe01a16$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupAlignmentPattern(matrix, version) {
    const pos = $c20e4b3185223698$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $140eee110ea3b5f9$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $5f2127839fe01a16$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $1f894980312e7d2a$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $5f2127839fe01a16$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $22a6389bcfc83921$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $21e4e023abb588c2$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $5f2127839fe01a16$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $7f809b8d8966b945$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $06a1abce65162dc0$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $06b6d7424b9df2df$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $06b6d7424b9df2df$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $06b6d7424b9df2df$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $c1483b5b1305278f$export$8d4a06d3facd414b(version);
    const modules = new $3c0264e2c9c64d36$exports(moduleCount);
    // Add function modules
    $5f2127839fe01a16$var$setupFinderPattern(modules, version);
    $5f2127839fe01a16$var$setupTimingPattern(modules);
    $5f2127839fe01a16$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $5f2127839fe01a16$var$setupVersionInfo(modules, version);
    // Add data codewords
    $5f2127839fe01a16$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $1edc2624fba191d0$export$fe9625aaceb0e563(modules, $5f2127839fe01a16$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $1edc2624fba191d0$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$5f2127839fe01a16$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $d22956012916b666$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $d22956012916b666$export$6788812c4e6611e6(options.errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
        version = $140eee110ea3b5f9$export$6788812c4e6611e6(options.version);
        mask = $1edc2624fba191d0$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $c1483b5b1305278f$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $53c344a5283c422c$export$b3890eb0ae9dca99;
var $53c344a5283c422c$export$c3e5526bbaf70a25;
var $c890d85f31194258$export$d2312e68e1f5ad00;
var $c890d85f31194258$export$5cdac61cf538712e;
var $c890d85f31194258$export$c3a1a1f268a8142b;
var $c890d85f31194258$export$83136f57c739c5f3;
function $c890d85f31194258$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$c890d85f31194258$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $c890d85f31194258$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $c890d85f31194258$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$c890d85f31194258$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$c890d85f31194258$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $c890d85f31194258$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$c890d85f31194258$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $c890d85f31194258$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $53c344a5283c422c$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $53c344a5283c422c$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$53c344a5283c422c$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $53c344a5283c422c$var$getCanvasElement();
    opts = $c890d85f31194258$export$d2312e68e1f5ad00(opts);
    const size = $c890d85f31194258$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $c890d85f31194258$export$83136f57c739c5f3(image.data, qrData, opts);
    $53c344a5283c422c$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$53c344a5283c422c$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $53c344a5283c422c$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $3112213e4acbe245$export$b3890eb0ae9dca99;

function $3112213e4acbe245$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $3112213e4acbe245$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $3112213e4acbe245$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $3112213e4acbe245$var$svgCmd("M", col + margin, 0.5 + row + margin) : $3112213e4acbe245$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $3112213e4acbe245$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$3112213e4acbe245$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $c890d85f31194258$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $3112213e4acbe245$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $092c7e998bebe629$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$e6419622b12b5572$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$092c7e998bebe629$export$185802fd694ee1f5 = $5f2127839fe01a16$export$185802fd694ee1f5;
$092c7e998bebe629$export$f87f6982d1fd4f81 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$b3890eb0ae9dca99);
$092c7e998bebe629$export$723e4939e5a27c8 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$c3e5526bbaf70a25);
$092c7e998bebe629$export$f84e8e69fd4488a5 = $092c7e998bebe629$var$renderCanvas.bind(null, function(data, _, opts) {
    return $3112213e4acbe245$export$b3890eb0ae9dca99(data, opts);
});



var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




const { getConfirmText: $8d042abd29f9bef2$var$r, getConfirmingText: $8d042abd29f9bef2$var$m, getBackToSignInText: $8d042abd29f9bef2$var$a } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb), $8d042abd29f9bef2$export$76e9c0cec6811ff4 = ()=>{
    const { isPending: i, toSignIn: l } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((t)=>[
            t.isPending,
            t.toSignIn
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        isDisabled: i,
        type: "submit",
        variation: "primary",
        fontWeight: "normal",
        isLoading: i,
        loadingText: $8d042abd29f9bef2$var$m()
    }, $8d042abd29f9bef2$var$r()), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        onClick: l,
        type: "button",
        variation: "link",
        fontWeight: "normal",
        size: "small"
    }, $8d042abd29f9bef2$var$a()));
};





const $0e5ad6295a47c6dc$var$g = new (0, $22e905ae30d82ab4$exports.ConsoleLogger)("SetupTOTP-logger"), { getSetupTOTPText: $0e5ad6295a47c6dc$var$h, getCopiedText: $0e5ad6295a47c6dc$var$C, getLoadingText: $0e5ad6295a47c6dc$var$E } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb), $0e5ad6295a47c6dc$export$1cb4d977b4f6b776 = ({ className: r, variation: a })=>{
    var n;
    const { totpSecretCode: h, isPending: y, user: H, QRFields: w } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.isPending,
            e.totpSecretCode
        ]), { handleChange: S, handleSubmit: F } = (0, $e594a02664ea54b9$export$df6a82844cee724c)(), { components: { SetupTOTP: { Header: T = $0e5ad6295a47c6dc$export$1cb4d977b4f6b776.Header, Footer: x = $0e5ad6295a47c6dc$export$1cb4d977b4f6b776.Footer } } } = (0, $34076cf41c51978d$export$b0e9d19f717d0a5c)(), [j, V] = $acw62.useState(!0), [b, P] = $acw62.useState(), [R, k] = $acw62.useState("COPY"), { totpIssuer: L = "AWSCognito", totpUsername: M = null == H ? void 0 : H.username } = null !== (n = w) && void 0 !== n ? n : {}, O = $acw62.useCallback(()=>(0, $6bbabf3c01bf9470$export$1050f835b63b671e)(void 0, void 0, void 0, function*() {
            try {
                const e = (0, $9ad1914df4b6fe69$export$f1f323074be5cac0)(L, M, h), o = yield (0, (/*@__PURE__*/$parcel$interopDefault($092c7e998bebe629$exports))).toDataURL(e);
                P(o);
            } catch (e) {
                $0e5ad6295a47c6dc$var$g.error(e);
            } finally{
                V(!1);
            }
        }), [
        L,
        M,
        h
    ]);
    $acw62.useEffect(()=>{
        b || O();
    }, [
        O,
        b
    ]);
    return $acw62.createElement((0, $837c07886f78538a$export$253df7dc30f737bc), {
        className: r,
        variation: a
    }, $acw62.createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-setup-totp": "",
        method: "post",
        onChange: S,
        onSubmit: F
    }, $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: y
    }, $acw62.createElement(T, null), $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        direction: "column"
    }, j ? $acw62.createElement("p", null, $0e5ad6295a47c6dc$var$E(), "…") : $acw62.createElement("img", {
        "data-amplify-qrcode": !0,
        src: b,
        alt: "qr code",
        width: "228",
        height: "228"
    }), $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        "data-amplify-copy": !0
    }, $acw62.createElement("div", null, h), $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        "data-amplify-copy-svg": !0,
        onClick: ()=>{
            navigator.clipboard.writeText(h), k($0e5ad6295a47c6dc$var$C());
        }
    }, $acw62.createElement("div", {
        "data-amplify-copy-tooltip": !0
    }, R), $acw62.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, $acw62.createElement("path", {
        d: "M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z"
    })))), $acw62.createElement((0, $036d7109f9666f35$export$125d0b248abd3e88), null), $acw62.createElement((0, $ba192fe9f9543e36$export$3caa4b6a8cb6c61a), null)), $acw62.createElement((0, $8d042abd29f9bef2$export$76e9c0cec6811ff4), null), $acw62.createElement(x, null))));
};
$0e5ad6295a47c6dc$export$1cb4d977b4f6b776.Header = function() {
    return $acw62.createElement((0, $7476e035421a7fc1$export$a8a3e93435678ff9), {
        level: 3
    }, $0e5ad6295a47c6dc$var$h());
}, $0e5ad6295a47c6dc$export$1cb4d977b4f6b776.Footer = function() {
    return null;
};








var $acw62 = parcelRequire("acw62");




var $1e222a1434bedc9c$exports = {};

$parcel$export($1e222a1434bedc9c$exports, "createTabsScope", () => $1e222a1434bedc9c$export$355f5bd209d7b13a);
$parcel$export($1e222a1434bedc9c$exports, "Tabs", () => $1e222a1434bedc9c$export$b2539bed5023c21c);
$parcel$export($1e222a1434bedc9c$exports, "TabsList", () => $1e222a1434bedc9c$export$9712d22edc0d78c1);
$parcel$export($1e222a1434bedc9c$exports, "TabsTrigger", () => $1e222a1434bedc9c$export$8114b9fdfdf9f3ba);
$parcel$export($1e222a1434bedc9c$exports, "TabsContent", () => $1e222a1434bedc9c$export$bd905d70e8fd2ebb);
$parcel$export($1e222a1434bedc9c$exports, "Root", () => $1e222a1434bedc9c$export$be92b6f5f03c0fe9);
$parcel$export($1e222a1434bedc9c$exports, "List", () => $1e222a1434bedc9c$export$54c2e3dc7acea9f5);
$parcel$export($1e222a1434bedc9c$exports, "Trigger", () => $1e222a1434bedc9c$export$41fb9f06171c75f4);
$parcel$export($1e222a1434bedc9c$exports, "Content", () => $1e222a1434bedc9c$export$7c6e2c02157bb7d2);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}



var $acw62 = parcelRequire("acw62");
function $e0f75533c8da79e2$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $acw62 = parcelRequire("acw62");
function $a27e3b74a1e4b413$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $acw62.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $a27e3b74a1e4b413$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $acw62.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $a27e3b74a1e4b413$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $a27e3b74a1e4b413$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $06dbdeafb212d82f$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $06dbdeafb212d82f$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$06dbdeafb212d82f$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $06dbdeafb212d82f$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $acw62.useCallback)($06dbdeafb212d82f$export$43e446d32b3d21af(...refs), refs);
}




var $acw62 = parcelRequire("acw62");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $2fad294522b5ed20$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $acw62.Children).toArray(children);
    const slottable = childrenArray.find($2fad294522b5ed20$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $acw62.Children).count(newElement) > 1) return (0, $acw62.Children).only(null);
                return /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $acw62.createElement)($2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? /*#__PURE__*/ (0, $acw62.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $acw62.createElement)($2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$2fad294522b5ed20$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(children)) return /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ...$2fad294522b5ed20$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $06dbdeafb212d82f$export$43e446d32b3d21af)(forwardedRef, children.ref)
    });
    return (0, $acw62.Children).count(children) > 1 ? (0, $acw62.Children).only(null) : null;
});
$2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $2fad294522b5ed20$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $2fad294522b5ed20$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(child) && child.type === $2fad294522b5ed20$export$d9f1ccf0bdb05d45;
}
function $2fad294522b5ed20$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName); // if it's a handler, modify the override by composing the base handler
        if (isHandler) overrideProps[propName] = (...args)=>{
            childPropValue === null || childPropValue === void 0 || childPropValue(...args);
            slotPropValue === null || slotPropValue === void 0 || slotPropValue(...args);
        };
        else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $2fad294522b5ed20$export$be92b6f5f03c0fe9 = $2fad294522b5ed20$export$8c6ed5c666ac1360;


// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $435c9fb8798de9ba$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fad294522b5ed20$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fad294522b5ed20$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $b37fe3d39d956993$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $acw62.useLayoutEffect) : ()=>{};


const $f3afa084f31a11ef$var$$1746a345f3d73bb7$var$useReactId = $acw62["useId".toString()] || (()=>undefined);
let $f3afa084f31a11ef$var$$1746a345f3d73bb7$var$count = 0;
function $f3afa084f31a11ef$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($f3afa084f31a11ef$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($f3afa084f31a11ef$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}




var $acw62 = parcelRequire("acw62");


const $ffa305e20fe06c82$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "h2",
    "h3",
    "img",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $ffa305e20fe06c82$export$250ffa63cdc0d034 = $ffa305e20fe06c82$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $2fad294522b5ed20$export$8c6ed5c666ac1360) : node;
        (0, $acw62.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $acw62.createElement)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $ffa305e20fe06c82$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $11492dca620dcaa5$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $ffa305e20fe06c82$export$be92b6f5f03c0fe9 = $ffa305e20fe06c82$export$250ffa63cdc0d034;



var $acw62 = parcelRequire("acw62");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $6421c5b6e6501f6d$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $acw62.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}



var $acw62 = parcelRequire("acw62");

function $206b7034d5d190d4$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $206b7034d5d190d4$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $acw62.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $206b7034d5d190d4$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $acw62.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $acw62.useRef)(value);
    const handleChange = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onChange);
    (0, $acw62.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



var $acw62 = parcelRequire("acw62");
const $a0d8f34db6c98cd1$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $a0d8f34db6c98cd1$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)($a0d8f34db6c98cd1$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $a0d8f34db6c98cd1$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $acw62.useContext)($a0d8f34db6c98cd1$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $a0d8f34db6c98cd1$export$2881499e37b75b9a = $a0d8f34db6c98cd1$export$c760c09fdd558351;


const $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$Collection, $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$useCollection, $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$createCollectionScope] = (0, $435c9fb8798de9ba$export$c74125a8e3af6bb2)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $31e40192e19ff522$export$c7109489551a4f4] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext] = $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const $31e40192e19ff522$export$8699f7c8af148338 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $acw62.createElement)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $acw62.createElement)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $acw62.createElement)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($31e40192e19ff522$export$8699f7c8af148338, {
    displayName: $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, ...groupProps } = props;
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $a0d8f34db6c98cd1$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $206b7034d5d190d4$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, $acw62.useState)(false);
    const handleEntryFocus = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $acw62.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $acw62.useCallback)(()=>setIsTabbingBackOut(true), [])
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: isTabbingBackOut ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $31e40192e19ff522$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, ...itemProps } = props;
    const id = (0, $f3afa084f31a11ef$export$f680877a34711e37)();
    const context = $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    return /*#__PURE__*/ (0, $acw62.createElement)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).span, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($31e40192e19ff522$export$ab9df7c53fe8454, {
    displayName: $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $31e40192e19ff522$export$be92b6f5f03c0fe9 = $31e40192e19ff522$export$8699f7c8af148338;
const $31e40192e19ff522$export$6d08773d2e66f8f2 = $31e40192e19ff522$export$ab9df7c53fe8454;



var $acw62 = parcelRequire("acw62");



function $33a5aa769cc85be3$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $acw62.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $33a5aa769cc85be3$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $acw62.Children).only(children);
    const ref = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
        ref: ref
    }) : null;
};
$33a5aa769cc85be3$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $33a5aa769cc85be3$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $acw62.useState)();
    const stylesRef = (0, $acw62.useRef)({});
    const prevPresentRef = (0, $acw62.useRef)(present);
    const prevAnimationNameRef = (0, $acw62.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $33a5aa769cc85be3$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $acw62.useEffect)(()=>{
        const currentAnimationName = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $11492dca620dcaa5$exports.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $acw62.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}






/* -------------------------------------------------------------------------------------------------
 * Tabs
 * -----------------------------------------------------------------------------------------------*/ const $1e222a1434bedc9c$var$$69cb30bb0017df05$var$TABS_NAME = "Tabs";
const [$1e222a1434bedc9c$var$$69cb30bb0017df05$var$createTabsContext, $1e222a1434bedc9c$export$355f5bd209d7b13a] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)($1e222a1434bedc9c$var$$69cb30bb0017df05$var$TABS_NAME, [
    (0, $31e40192e19ff522$export$c7109489551a4f4)
]);
const $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useRovingFocusGroupScope = (0, $31e40192e19ff522$export$c7109489551a4f4)();
const [$1e222a1434bedc9c$var$$69cb30bb0017df05$var$TabsProvider, $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useTabsContext] = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$createTabsContext($1e222a1434bedc9c$var$$69cb30bb0017df05$var$TABS_NAME);
const $1e222a1434bedc9c$export$b2539bed5023c21c = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: valueProp, onValueChange: onValueChange, defaultValue: defaultValue, orientation: orientation = "horizontal", dir: dir, activationMode: activationMode = "automatic", ...tabsProps } = props;
    const direction = (0, $a0d8f34db6c98cd1$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $206b7034d5d190d4$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /*#__PURE__*/ (0, $acw62.createElement)($1e222a1434bedc9c$var$$69cb30bb0017df05$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, $f3afa084f31a11ef$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        dir: direction,
        "data-orientation": orientation
    }, tabsProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($1e222a1434bedc9c$export$b2539bed5023c21c, {
    displayName: $1e222a1434bedc9c$var$$69cb30bb0017df05$var$TABS_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsList
 * -----------------------------------------------------------------------------------------------*/ const $1e222a1434bedc9c$var$$69cb30bb0017df05$var$TAB_LIST_NAME = "TabsList";
const $1e222a1434bedc9c$export$9712d22edc0d78c1 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, loop: loop = true, ...listProps } = props;
    const context = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useTabsContext($1e222a1434bedc9c$var$$69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $31e40192e19ff522$export$be92b6f5f03c0fe9), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: context.orientation,
        dir: context.dir,
        loop: loop
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "tablist",
        "aria-orientation": context.orientation
    }, listProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($1e222a1434bedc9c$export$9712d22edc0d78c1, {
    displayName: $1e222a1434bedc9c$var$$69cb30bb0017df05$var$TAB_LIST_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsTrigger
 * -----------------------------------------------------------------------------------------------*/ const $1e222a1434bedc9c$var$$69cb30bb0017df05$var$TRIGGER_NAME = "TabsTrigger";
const $1e222a1434bedc9c$export$8114b9fdfdf9f3ba = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, disabled: disabled = false, ...triggerProps } = props;
    const context = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useTabsContext($1e222a1434bedc9c$var$$69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $31e40192e19ff522$export$6d08773d2e66f8f2), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled,
        active: isSelected
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button",
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": contentId,
        "data-state": isSelected ? "active" : "inactive",
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        id: triggerId
    }, triggerProps, {
        ref: forwardedRef,
        onMouseDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
            else event.preventDefault();
        }),
        onKeyDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if ([
                " ",
                "Enter"
            ].includes(event.key)) context.onValueChange(value);
        }),
        onFocus: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onFocus, ()=>{
            // handle "automatic" activation if necessary
            // ie. activate tab following focus
            const isAutomaticActivation = context.activationMode !== "manual";
            if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
        })
    })));
});
/*#__PURE__*/ Object.assign($1e222a1434bedc9c$export$8114b9fdfdf9f3ba, {
    displayName: $1e222a1434bedc9c$var$$69cb30bb0017df05$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsContent
 * -----------------------------------------------------------------------------------------------*/ const $1e222a1434bedc9c$var$$69cb30bb0017df05$var$CONTENT_NAME = "TabsContent";
const $1e222a1434bedc9c$export$bd905d70e8fd2ebb = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, forceMount: forceMount, children: children, ...contentProps } = props;
    const context = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useTabsContext($1e222a1434bedc9c$var$$69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = (0, $acw62.useRef)(isSelected);
    (0, $acw62.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $33a5aa769cc85be3$export$99c2b779aa4e8b8b), {
        present: forceMount || isSelected
    }, ({ present: present })=>/*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            "data-state": isSelected ? "active" : "inactive",
            "data-orientation": context.orientation,
            role: "tabpanel",
            "aria-labelledby": triggerId,
            hidden: !present,
            id: contentId,
            tabIndex: 0
        }, contentProps, {
            ref: forwardedRef,
            style: {
                ...props.style,
                animationDuration: isMountAnimationPreventedRef.current ? "0s" : undefined
            }
        }), present && children));
});
/*#__PURE__*/ Object.assign($1e222a1434bedc9c$export$bd905d70e8fd2ebb, {
    displayName: $1e222a1434bedc9c$var$$69cb30bb0017df05$var$CONTENT_NAME
});
/* ---------------------------------------------------------------------------------------------- */ function $1e222a1434bedc9c$var$$69cb30bb0017df05$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $1e222a1434bedc9c$var$$69cb30bb0017df05$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
const $1e222a1434bedc9c$export$be92b6f5f03c0fe9 = $1e222a1434bedc9c$export$b2539bed5023c21c;
const $1e222a1434bedc9c$export$54c2e3dc7acea9f5 = $1e222a1434bedc9c$export$9712d22edc0d78c1;
const $1e222a1434bedc9c$export$41fb9f06171c75f4 = $1e222a1434bedc9c$export$8114b9fdfdf9f3ba;
const $1e222a1434bedc9c$export$7c6e2c02157bb7d2 = $1e222a1434bedc9c$export$bd905d70e8fd2ebb;



var $acw62 = parcelRequire("acw62");




const { Root: $1bebff84cf93854d$var$o, List: $1bebff84cf93854d$var$m, Trigger: $1bebff84cf93854d$var$c, Content: $1bebff84cf93854d$var$d } = (0, $15a7c5986a3f06c2$export$fa356a32a7b5bee2)($1e222a1434bedc9c$exports), $1bebff84cf93854d$var$f = (e)=>$acw62.isValidElement(e), $1bebff84cf93854d$export$b2539bed5023c21c = $acw62.forwardRef((r, i)=>{
    var { ariaLabel: l, children: c, className: p, defaultIndex: u = 0, currentIndex: g, onChange: b, indicatorPosition: h, spacing: x } = r, N = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(r, [
        "ariaLabel",
        "children",
        "className",
        "defaultIndex",
        "currentIndex",
        "onChange",
        "indicatorPosition",
        "spacing"
    ]);
    const C = {
        defaultValue: u.toString(),
        value: null != g ? g.toString() : void 0,
        onValueChange: b
    }, E = $acw62.Children.toArray(c).filter((e)=>!!e);
    return $acw62.createElement($1bebff84cf93854d$var$o, Object.assign({}, C), $acw62.createElement($1bebff84cf93854d$var$m, {
        "aria-label": l
    }, $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Tabs, p),
        "data-indicator-position": h,
        ref: i
    }, N), $acw62.Children.map(E, (e, a)=>{
        if ($1bebff84cf93854d$var$f(e)) return $acw62.cloneElement(e, {
            "data-spacing": x,
            key: a,
            value: `${a}`
        });
    }))), $acw62.Children.map(E, (e, a)=>{
        if ($1bebff84cf93854d$var$f(e)) return $acw62.createElement($1bebff84cf93854d$var$d, {
            key: a,
            value: `${a}`
        }, e.props.children);
    }));
}), $1bebff84cf93854d$export$17043b9d35150718 = $acw62.forwardRef((r, i)=>{
    var { className: s, title: o } = r, m = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(r, [
        "className",
        "title"
    ]);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: $1bebff84cf93854d$var$c,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).TabItems, s),
        ref: i
    }, m), o);
});
$1bebff84cf93854d$export$b2539bed5023c21c.displayName = "Tabs", $1bebff84cf93854d$export$17043b9d35150718.displayName = "TabItem";




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
var $de171c47dc7ed9e8$export$4d240f091c25e146, $de171c47dc7ed9e8$export$5733d30e1ebcb3c0;
!function(o) {
    o.Apple = "SignInWithApple", o.Amazon = "LoginWithAmazon", o.Facebook = "Facebook", o.Google = "Google";
}($de171c47dc7ed9e8$export$4d240f091c25e146 || ($de171c47dc7ed9e8$export$4d240f091c25e146 = {})), function(o) {
    o.Email = "email", o.PhoneNumber = "phone_number";
}($de171c47dc7ed9e8$export$5733d30e1ebcb3c0 || ($de171c47dc7ed9e8$export$5733d30e1ebcb3c0 = {}));





var $acw62 = parcelRequire("acw62");



const $2741823ea694db3b$export$2e0a83ec2e27ecbb = $acw62.forwardRef((o, m)=>{
    var { className: l, orientation: n = "horizontal", size: c, label: d } = o, f = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(o, [
        "className",
        "orientation",
        "size",
        "label"
    ]);
    const p = (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Divider, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Divider, n), (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Divider, c), d ? (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).DividerLabel : null, l);
    return $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        "aria-orientation": n,
        as: "hr",
        className: p,
        "data-size": c,
        "data-label": d,
        ref: m
    }, f));
});
$2741823ea694db3b$export$2e0a83ec2e27ecbb.displayName = "Divider";





var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



const $36d790c170b74ac9$var$s = {
    minX: 0,
    minY: 0,
    width: 24,
    height: 24
}, $36d790c170b74ac9$export$f04a61298a47a40f = $acw62.forwardRef((r, n)=>{
    var { className: o, as: h = "svg", fill: l = "currentColor", pathData: c, viewBox: p = $36d790c170b74ac9$var$s, children: f, paths: d } = r, w = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(r, [
        "className",
        "as",
        "fill",
        "pathData",
        "viewBox",
        "children",
        "paths"
    ]);
    const g = p.minX ? p.minX : $36d790c170b74ac9$var$s.minX, v = p.minY ? p.minY : $36d790c170b74ac9$var$s.minY, j = p.width ? p.width : $36d790c170b74ac9$var$s.width, x = p.height ? p.height : $36d790c170b74ac9$var$s.height;
    let N;
    return f && (N = f), d && (N = d.map((e, a)=>$acw62.createElement("path", Object.assign({}, e, {
            key: a
        })))), c && (N = $acw62.createElement("path", {
        d: c,
        fill: l
    })), $acw62.createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), Object.assign({
        as: h,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Icon, o),
        ref: n,
        viewBox: `${g} ${v} ${j} ${x}`
    }, w), N);
});
$36d790c170b74ac9$export$f04a61298a47a40f.displayName = "Icon";








const $b2dce05307710745$var$n = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-label": "Apple icon",
        className: "amplify-icon federated-sign-in-icon",
        fill: "#000",
        preserveAspectRatio: "xMidYMid",
        stroke: "#000",
        strokeWidth: "0",
        viewBox: "0 0 1024 1024",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
    })), $b2dce05307710745$var$r = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-label": "Google icon",
        className: "amplify-icon federated-sign-in-icon",
        viewBox: "0 0 256 262",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027",
        fill: "#4285F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1",
        fill: "#34A853"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782",
        fill: "#FBBC05"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251",
        fill: "#EB4335"
    })), $b2dce05307710745$var$o = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $36d790c170b74ac9$export$f04a61298a47a40f), {
        className: "federated-sign-in-icon",
        ariaLabel: "Facebook icon",
        viewBox: {
            minX: 0,
            minY: 0,
            width: 279,
            height: 538
        },
        pathData: "M82.3409742,538 L82.3409742,292.936652 L0,292.936652 L0,196.990154 L82.2410458,196.990154 L82.2410458,126.4295 C82.2410458,44.575144 132.205229,0 205.252865,0 C240.227794,0 270.306232,2.59855099 279,3.79788222 L279,89.2502322 L228.536175,89.2502322 C188.964542,89.2502322 181.270057,108.139699 181.270057,135.824262 L181.270057,196.89021 L276.202006,196.89021 L263.810888,292.836708 L181.16913,292.836708 L181.16913,538 L82.3409742,538 Z",
        fill: "#1877F2"
    }), $b2dce05307710745$var$c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-label": "Amazon icon",
        className: "amplify-icon federated-sign-in-icon",
        viewBox: "0 0 243 264",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M230.826 208.039C227.468 203.683 208.551 205.982 200.056 206.998C197.471 207.321 197.076 205.042 199.407 203.405C214.475 192.665 239.201 195.766 242.082 199.364C244.966 202.982 241.337 228.071 227.173 240.049C225.001 241.888 222.93 240.904 223.898 238.468C227.077 230.431 234.205 212.419 230.826 208.039ZM123.769 264C71.0234 264 39.0764 241.955 14.7853 217.542C9.97339 212.706 3.71799 206.296 0.311513 200.691C-1.09773 198.372 2.59096 195.022 5.04421 196.844C35.239 219.268 79.1012 239.538 122.53 239.538C151.82 239.538 188.046 227.47 217.669 214.868C222.147 212.966 222.147 219.18 221.512 221.061C221.183 222.032 206.515 236.221 186.247 247.047C167.304 257.166 143.397 264 123.769 264Z",
        fill: "#F2541B"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M142.943 111.185C142.943 124.756 143.268 136.054 136.406 148.123C130.856 157.913 122.027 163.95 112.222 163.95C98.8288 163.95 90.9806 153.772 90.9806 138.693C90.9806 109.036 117.677 103.647 142.943 103.647V111.185ZM178.166 196.081C175.858 198.15 171.635 198.22 169.914 196.894C157.974 187.684 149.89 173.688 149.89 173.688C130.706 193.156 117.127 199 92.2879 199C62.8772 199 40 180.905 40 144.729C40 116.461 55.3552 97.2408 77.2563 87.823C96.2094 79.5256 122.684 78.0173 142.943 75.7517C142.943 75.7517 144.633 53.933 138.699 45.9806C134.098 39.8163 126.272 36.9329 119.089 36.9329C106.127 36.8829 93.61 43.9051 91.1262 57.4188C90.4136 61.2829 87.5533 64.5261 84.54 64.206L51.0823 60.5922C48.5156 60.2951 45.0381 57.6639 45.8636 53.3081C53.644 12.3684 90.7373 0 123.989 0C140.983 0 163.21 4.51651 176.608 17.3349C193.597 33.1648 191.969 54.2755 191.969 77.2722V131.51C191.969 147.835 198.768 154.987 205.151 163.775C207.376 166.953 207.886 170.714 205.04 173.032C197.902 178.999 178.166 196.081 178.166 196.081Z",
        fill: "#F2541B"
    })), $b2dce05307710745$export$66f93ed48923765d = (l)=>{
    const { icon: m, provider: s, text: p } = l, { toFederatedSignIn: C } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)();
    let d;
    return "facebook" === m ? d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2dce05307710745$var$o, null) : "google" === m ? d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2dce05307710745$var$r, null) : "amazon" === m ? d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2dce05307710745$var$c, null) : "apple" === m && (d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2dce05307710745$var$n, null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        onClick: (e)=>{
            e.preventDefault(), C({
                provider: s
            });
        },
        className: "federated-sign-in-button",
        fontWeight: "normal",
        gap: "1rem"
    }, d, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c617e684f7eee362$export$5f1af8db9871e1d6), {
        as: "span"
    }, p));
};


const { getSignInWithFederationText: $19ec72845411ec9f$var$m, getOrText: $19ec72845411ec9f$var$s } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb);
function $19ec72845411ec9f$export$558443b7244c6aa() {
    const { route: o, socialProviders: c } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)(({ route: e, socialProviders: t })=>[
            e,
            t
        ]);
    return 0 === c.length ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        direction: "column",
        padding: "0 0 1rem 0",
        className: "federated-sign-in-container"
    }, c.map((r)=>{
        switch(r){
            case "amazon":
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2dce05307710745$export$66f93ed48923765d), {
                    icon: "amazon",
                    key: r,
                    provider: (0, $de171c47dc7ed9e8$export$4d240f091c25e146).Amazon,
                    text: $19ec72845411ec9f$var$m(o, r)
                });
            case "apple":
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2dce05307710745$export$66f93ed48923765d), {
                    icon: "apple",
                    key: r,
                    provider: (0, $de171c47dc7ed9e8$export$4d240f091c25e146).Apple,
                    text: $19ec72845411ec9f$var$m(o, r)
                });
            case "facebook":
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2dce05307710745$export$66f93ed48923765d), {
                    icon: "facebook",
                    key: r,
                    provider: (0, $de171c47dc7ed9e8$export$4d240f091c25e146).Facebook,
                    text: $19ec72845411ec9f$var$m(o, r)
                });
            case "google":
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2dce05307710745$export$66f93ed48923765d), {
                    icon: "google",
                    key: r,
                    provider: (0, $de171c47dc7ed9e8$export$4d240f091c25e146).Google,
                    text: $19ec72845411ec9f$var$m(o, r)
                });
            default:
                console.error(`Authenticator does not support ${r}. Please open an issue: https://github.com/aws-amplify/amplify-ui/issues/choose`);
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2741823ea694db3b$export$2e0a83ec2e27ecbb), {
        size: "small",
        label: $19ec72845411ec9f$var$s()
    }));
}







const { getSignInText: $8c1aa707d7850e37$var$c, getSigningInText: $8c1aa707d7850e37$var$p, getForgotPasswordText: $8c1aa707d7850e37$var$f } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb);
function $8c1aa707d7850e37$export$b64708c6f1b3ed96() {
    const { isPending: t } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), { handleChange: f, handleSubmit: E } = (0, $e594a02664ea54b9$export$df6a82844cee724c)(), { components: { SignIn: { Header: F = $8c1aa707d7850e37$export$b64708c6f1b3ed96.Header, Footer: h = $8c1aa707d7850e37$export$b64708c6f1b3ed96.Footer } } } = (0, $34076cf41c51978d$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(F, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-signin": "",
        method: "post",
        onSubmit: E,
        onChange: f
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19ec72845411ec9f$export$558443b7244c6aa), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $007ba0001dda9356$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("legend", null, $8c1aa707d7850e37$var$c())), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $036d7109f9666f35$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba192fe9f9543e36$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        isDisabled: t,
        isFullWidth: !0,
        type: "submit",
        variation: "primary",
        isLoading: t,
        loadingText: $8c1aa707d7850e37$var$p()
    }, $8c1aa707d7850e37$var$c()))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(h, null));
}
$8c1aa707d7850e37$export$b64708c6f1b3ed96.Footer = ()=>{
    const { toResetPassword: t } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.toResetPassword
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        "data-amplify-footer": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        fontWeight: "normal",
        onClick: t,
        size: "small",
        variation: "link"
    }, $8c1aa707d7850e37$var$f()));
}, $8c1aa707d7850e37$export$b64708c6f1b3ed96.Header = function() {
    return null;
};



var $acw62 = parcelRequire("acw62");










const { getCreateAccountText: $2ef3197110afebed$var$d, getCreatingAccountText: $2ef3197110afebed$var$c } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb);
function $2ef3197110afebed$export$4ee457d816cea81a() {
    const { hasValidationErrors: t, isPending: u } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.hasValidationErrors,
            e.isPending
        ]), { handleChange: f, handleBlur: F, handleSubmit: g } = (0, $e594a02664ea54b9$export$df6a82844cee724c)(), { components: { SignUp: { Header: h = $2ef3197110afebed$export$4ee457d816cea81a.Header, FormFields: E = $2ef3197110afebed$export$4ee457d816cea81a.FormFields, Footer: j = $2ef3197110afebed$export$4ee457d816cea81a.Footer } } } = (0, $34076cf41c51978d$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(h, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-signup": "",
        method: "post",
        onChange: f,
        onSubmit: g,
        onBlur: F
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19ec72845411ec9f$export$558443b7244c6aa), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(E, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba192fe9f9543e36$export$3caa4b6a8cb6c61a), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        isDisabled: t || u,
        isFullWidth: !0,
        type: "submit",
        variation: "primary",
        isLoading: u,
        loadingText: $2ef3197110afebed$var$c()
    }, $2ef3197110afebed$var$d()))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(j, null));
}
$2ef3197110afebed$export$4ee457d816cea81a.Header = function() {
    return null;
}, $2ef3197110afebed$export$4ee457d816cea81a.FormFields = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $036d7109f9666f35$export$125d0b248abd3e88), null);
}, $2ef3197110afebed$export$4ee457d816cea81a.Footer = function() {
    return null;
};



const { getSignInTabText: $255dd366e7743337$var$p, getSignUpTabText: $255dd366e7743337$var$s } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb), $255dd366e7743337$export$6815ad73b98d75ed = ({ className: t, hideSignUp: c, variation: g })=>{
    const { route: u, toSignIn: f, toSignUp: S } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.route,
            e.toSignIn,
            e.toSignUp
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $837c07886f78538a$export$253df7dc30f737bc), {
        className: t,
        variation: g
    }, c ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        "data-amplify-router-content": ""
    }, "signIn" === u && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c1aa707d7850e37$export$b64708c6f1b3ed96), null)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1bebff84cf93854d$export$b2539bed5023c21c), {
        indicatorPosition: "top",
        currentIndex: "signIn" === u ? 0 : 1,
        spacing: "equal",
        justifyContent: "center",
        onChange: ()=>"signIn" === u ? S() : f()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1bebff84cf93854d$export$17043b9d35150718), {
        title: $255dd366e7743337$var$p()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        "data-amplify-router-content": ""
    }, "signIn" === u && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c1aa707d7850e37$export$b64708c6f1b3ed96), null))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1bebff84cf93854d$export$17043b9d35150718), {
        title: $255dd366e7743337$var$s()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f797d956b0744e8f$export$27a5bd065ad55220), {
        "data-amplify-router-content": ""
    }, "signUp" === u && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2ef3197110afebed$export$4ee457d816cea81a), null)))));
};



var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




const { getSubmitText: $17798f30713dd189$var$a, getSubmittingText: $17798f30713dd189$var$m } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb), $17798f30713dd189$export$8311b872375357fe = (t)=>{
    const { cancelButtonSendType: o, cancelButtonText: l, submitButtonText: c } = t, { isPending: s, resendCode: u, skipVerification: p, toSignIn: f } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), g = s ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, $17798f30713dd189$var$m(), "…") : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, $17798f30713dd189$var$a()), b = null != c ? c : g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        fontWeight: "normal",
        variation: "primary",
        isDisabled: s,
        type: "submit"
    }, b), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2732fbaf46f35309$export$353f5b6fc5456de1), {
        onClick: ()=>{
            switch(o){
                case "SKIP":
                    p();
                    break;
                case "RESEND":
                    u();
                    break;
                case "SIGN_IN":
                    f();
                    break;
                default:
                    return;
            }
        },
        type: "button",
        variation: "link",
        fontWeight: "normal",
        size: "small"
    }, l));
};




const { getAccountRecoveryInfoText: $15576d32bd9e2ccd$var$u, getSkipText: $15576d32bd9e2ccd$var$f } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb), $15576d32bd9e2ccd$export$79a17bba512ce899 = ({ className: t, variation: r })=>{
    const { isPending: u } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), { handleChange: d, handleSubmit: h } = (0, $e594a02664ea54b9$export$df6a82844cee724c)(), { components: { ConfirmVerifyUser: { Header: E = $15576d32bd9e2ccd$export$79a17bba512ce899.Header, Footer: F = $15576d32bd9e2ccd$export$79a17bba512ce899.Footer } } } = (0, $34076cf41c51978d$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $837c07886f78538a$export$253df7dc30f737bc), {
        className: t,
        variation: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmverifyuser": "",
        method: "post",
        onChange: d,
        onSubmit: h
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(E, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $036d7109f9666f35$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba192fe9f9543e36$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $17798f30713dd189$export$8311b872375357fe), {
        cancelButtonText: $15576d32bd9e2ccd$var$f(),
        cancelButtonSendType: "SKIP"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(F, null))));
};
$15576d32bd9e2ccd$export$79a17bba512ce899.Header = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7476e035421a7fc1$export$a8a3e93435678ff9), {
        level: 3
    }, $15576d32bd9e2ccd$var$u());
}, $15576d32bd9e2ccd$export$79a17bba512ce899.Footer = function() {
    return null;
};



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
const $d1e264e1574a1d27$export$a79eda4ff50e30b6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    name: "default"
}), $d1e264e1574a1d27$export$7bea016dc7ad2ddf = ()=>(0, $acw62.useContext)($d1e264e1574a1d27$export$a79eda4ff50e30b6);



const $baf5f999a96ac1e6$export$d493a8d66e90d1ca = (p, c)=>{
    var { children: h, className: u, id: b, isDisabled: f, testId: R, value: g, labelPosition: v, height: j, width: N, bottom: x, left: y, position: E, padding: F, right: I, top: w } = p, D = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(p, [
        "children",
        "className",
        "id",
        "isDisabled",
        "testId",
        "value",
        "labelPosition",
        "height",
        "width",
        "bottom",
        "left",
        "position",
        "padding",
        "right",
        "top"
    ]);
    const { currentValue: C, defaultValue: O, name: P, hasError: V, isGroupDisabled: k, isRequired: q, isReadOnly: z, onChange: B, size: G, labelPosition: T } = (0, $d1e264e1574a1d27$export$7bea016dc7ad2ddf)(), { isFieldsetDisabled: H } = (0, $3b7aa0a2fb31e524$export$b140571ec72925dd)(), L = H || k || f || z && O !== g, A = void 0 !== C ? g === C : void 0, J = void 0 !== O ? g === O : void 0, K = v || T;
    return $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        as: "label",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Radio, (0, $15a7c5986a3f06c2$export$3c152e7b97c7496c)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Radio, "disabled", L), u),
        "data-disabled": L,
        "data-label-position": K,
        height: j,
        width: N,
        bottom: x,
        top: w,
        right: I,
        left: y,
        position: E,
        padding: F
    }, h && $acw62.createElement((0, $c617e684f7eee362$export$5f1af8db9871e1d6), {
        as: "span",
        className: (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).RadioLabel,
        "data-disabled": L
    }, h), $acw62.createElement((0, $cefcb73ac9f287bd$export$f5b8910cec6cf069), Object.assign({
        checked: A,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).VisuallyHidden, (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).RadioInput),
        defaultChecked: J,
        hasError: V,
        id: b,
        isDisabled: L,
        isReadOnly: z,
        isRequired: q,
        onChange: B,
        ref: c,
        type: "radio",
        name: P,
        value: g
    }, D)), $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        "aria-hidden": "true",
        as: "span",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).RadioButton, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).RadioButton, G)),
        "data-size": G,
        testId: R
    }));
}, $baf5f999a96ac1e6$export$d7b12c4107be0d61 = $acw62.forwardRef($baf5f999a96ac1e6$export$d493a8d66e90d1ca);
$baf5f999a96ac1e6$export$d7b12c4107be0d61.displayName = "Radio";




var $acw62 = parcelRequire("acw62");











const $8dd9d0d1ecbd34bc$export$ec17b125bc42c229 = (o, t)=>o && t ? `${o}-${t}` : void 0;



const $209756f6ebcc802c$export$a314277471067e8a = $acw62.forwardRef((c, f)=>{
    var { children: b, className: F, defaultValue: j, descriptiveText: E, errorMessage: g, hasError: h = !1, id: R, isDisabled: v, isRequired: y, isReadOnly: x, label: H, labelHidden: I = !1, labelPosition: V, onChange: G, name: M, size: N, testId: z, value: C } = c, D = (0, $6bbabf3c01bf9470$export$3c9a16f847548506)(c, [
        "children",
        "className",
        "defaultValue",
        "descriptiveText",
        "errorMessage",
        "hasError",
        "id",
        "isDisabled",
        "isRequired",
        "isReadOnly",
        "label",
        "labelHidden",
        "labelPosition",
        "onChange",
        "name",
        "size",
        "testId",
        "value"
    ]);
    const O = (0, $1095fef8c965210c$export$5c0b1cf3fea224ac)(R), P = (0, $1095fef8c965210c$export$5c0b1cf3fea224ac)(), T = E ? P : void 0, q = (0, $8dd9d0d1ecbd34bc$export$ec17b125bc42c229)(z, (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).RadioGroup), w = $acw62.useMemo(()=>({
            currentValue: C,
            defaultValue: j,
            hasError: h,
            isRequired: y,
            isReadOnly: x,
            isGroupDisabled: v,
            onChange: G,
            size: N,
            name: M,
            labelPosition: V
        }), [
        j,
        h,
        v,
        y,
        x,
        G,
        N,
        M,
        C,
        V
    ]);
    return $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), Object.assign({
        as: "fieldset",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2e2104fc51777f8c$exports)))((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Field, (0, $15a7c5986a3f06c2$export$1d6fb99b5e148be8)((0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).Field, N), (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).RadioGroupField, F),
        "data-size": N,
        ref: f,
        role: "radiogroup",
        testId: z
    }, D), $acw62.createElement((0, $007ba0001dda9356$export$439d29a4e110a164), {
        as: "legend"
    }, H), $acw62.createElement((0, $d87aad0dee92c2d5$export$b04be29aa201d4f5), {
        "aria-hidden": !0,
        visuallyHidden: I
    }, H), $acw62.createElement((0, $a5f3577765b39b4d$export$873ced4623a3149c), {
        id: P,
        labelHidden: I,
        descriptiveText: E
    }), $acw62.createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        "aria-describedby": T,
        className: (0, $ca5815d75ab8dc16$export$da015ee4e3f15a81).RadioGroup,
        id: O,
        testId: q
    }, $acw62.createElement((0, $d1e264e1574a1d27$export$a79eda4ff50e30b6).Provider, {
        value: w
    }, b)), $acw62.createElement((0, $91d5caa3c17c7574$export$1c081951d49ad6f6), {
        hasError: h,
        errorMessage: g
    }));
});
$209756f6ebcc802c$export$a314277471067e8a.displayName = "RadioGroupField";








const { getSkipText: $0b75f1ee82f56fab$var$v, getVerifyText: $0b75f1ee82f56fab$var$E, getVerifyContactText: $0b75f1ee82f56fab$var$h, getAccountRecoveryInfoText: $0b75f1ee82f56fab$var$y } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb), $0b75f1ee82f56fab$var$F = (t)=>Object.entries(t).map(([t, m])=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $baf5f999a96ac1e6$export$d7b12c4107be0d61), {
            name: "unverifiedAttr",
            value: t,
            key: t
        }, ((e, t)=>{
            const r = (0, $237c4f1f3df38a24$export$d73ee8ef04f5226a)(e);
            let m = t;
            if ("Phone Number" === e) m = (0, $9ad1914df4b6fe69$export$72b2b64445441bf7)(t);
            else if ("Email" === e) {
                const e = t.split("@");
                m = `${(0, $9ad1914df4b6fe69$export$655775443891f2b8)(e[0])}@${e[1]}`;
            }
            return `${r}: ${m}`;
        })((0, $5c28317e8c66931c$export$1222d357a3c2c47f)[t].label, m))), $0b75f1ee82f56fab$export$da61eb776d8ee98b = ({ className: t, variation: r })=>{
    const { components: { VerifyUser: { Header: o = $0b75f1ee82f56fab$export$da61eb776d8ee98b.Header, Footer: n = $0b75f1ee82f56fab$export$da61eb776d8ee98b.Footer } } } = (0, $34076cf41c51978d$export$b0e9d19f717d0a5c)(), { isPending: i, unverifiedContactMethods: a } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)(({ isPending: e, unverifiedContactMethods: t })=>[
            e,
            t
        ]), { handleChange: l, handleSubmit: y } = (0, $e594a02664ea54b9$export$df6a82844cee724c)(), C = i ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, "Verifying…") : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, $0b75f1ee82f56fab$var$E()), j = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $209756f6ebcc802c$export$a314277471067e8a), {
        label: $0b75f1ee82f56fab$var$h(),
        labelHidden: !0,
        name: "verify_context",
        isDisabled: i
    }, $0b75f1ee82f56fab$var$F(a));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $837c07886f78538a$export$253df7dc30f737bc), {
        className: t,
        variation: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-verifyuser": "",
        method: "post",
        onChange: l,
        onSubmit: y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: i
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(o, null), j, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba192fe9f9543e36$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $17798f30713dd189$export$8311b872375357fe), {
        cancelButtonText: $0b75f1ee82f56fab$var$v(),
        cancelButtonSendType: "SKIP",
        submitButtonText: C
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(n, null))));
};
$0b75f1ee82f56fab$export$da61eb776d8ee98b.Header = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7476e035421a7fc1$export$a8a3e93435678ff9), {
        level: 3
    }, $0b75f1ee82f56fab$var$y());
}, $0b75f1ee82f56fab$export$da61eb776d8ee98b.Footer = function() {
    return null;
};



var $acw62 = parcelRequire("acw62");










const { getChallengeText: $f309a92f34c5b3de$var$u } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb), $f309a92f34c5b3de$export$b8b09b30a5bdd893 = ({ className: r, variation: t })=>{
    const { isPending: u } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), { handleChange: d, handleSubmit: p } = (0, $e594a02664ea54b9$export$df6a82844cee724c)(), { components: { ConfirmSignIn: { Header: g = $f309a92f34c5b3de$export$b8b09b30a5bdd893.Header, Footer: h = $f309a92f34c5b3de$export$b8b09b30a5bdd893.Footer } } } = (0, $34076cf41c51978d$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $837c07886f78538a$export$253df7dc30f737bc), {
        className: r,
        variation: t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmsignin": "",
        method: "post",
        onChange: d,
        onSubmit: p
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(g, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $036d7109f9666f35$export$125d0b248abd3e88), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba192fe9f9543e36$export$3caa4b6a8cb6c61a), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8d042abd29f9bef2$export$76e9c0cec6811ff4), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(h, null))));
};
$f309a92f34c5b3de$export$b8b09b30a5bdd893.Header = function() {
    const { user: { challengeName: r } } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)(({ user: e })=>[
            e
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7476e035421a7fc1$export$a8a3e93435678ff9), {
        level: 3
    }, $f309a92f34c5b3de$var$u(r));
}, $f309a92f34c5b3de$export$b8b09b30a5bdd893.Footer = function() {
    return null;
};



var $acw62 = parcelRequire("acw62");










const { getResendCodeText: $b5ff1ac2459d08a9$var$c, getResetYourPasswordText: $b5ff1ac2459d08a9$var$d } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb), $b5ff1ac2459d08a9$export$fb3a0d1a16180c0d = ({ className: t, variation: r })=>{
    const { isPending: d } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), { handleBlur: f, handleChange: E, handleSubmit: h } = (0, $e594a02664ea54b9$export$df6a82844cee724c)(), { components: { ConfirmResetPassword: { Header: C = $b5ff1ac2459d08a9$export$fb3a0d1a16180c0d.Header, Footer: F = $b5ff1ac2459d08a9$export$fb3a0d1a16180c0d.Footer } } } = (0, $34076cf41c51978d$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $837c07886f78538a$export$253df7dc30f737bc), {
        className: t,
        variation: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmresetpassword": "",
        method: "post",
        onSubmit: h,
        onChange: E,
        onBlur: f
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(C, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $036d7109f9666f35$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba192fe9f9543e36$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $17798f30713dd189$export$8311b872375357fe), {
        cancelButtonSendType: "RESEND",
        cancelButtonText: $b5ff1ac2459d08a9$var$c()
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(F, null))));
};
$b5ff1ac2459d08a9$export$fb3a0d1a16180c0d.Header = function() {
    const t = $b5ff1ac2459d08a9$var$d();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7476e035421a7fc1$export$a8a3e93435678ff9), {
        level: 3
    }, t);
}, $b5ff1ac2459d08a9$export$fb3a0d1a16180c0d.Footer = function() {
    return null;
};



var $acw62 = parcelRequire("acw62");










const { getBackToSignInText: $ec857cbd1d5238bc$var$c, getSendingText: $ec857cbd1d5238bc$var$d, getSendCodeText: $ec857cbd1d5238bc$var$p, getResetYourPasswordText: $ec857cbd1d5238bc$var$f } = (0, $76a2c3bc206f31bd$export$34e9c32aebe14fbb), $ec857cbd1d5238bc$export$a4c3d56613a57187 = ({ className: t, variation: r })=>{
    const { isPending: f } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)((e)=>[
            e.isPending
        ]), { handleChange: E, handleSubmit: F } = (0, $e594a02664ea54b9$export$df6a82844cee724c)(), { components: { ResetPassword: { Header: h = $ec857cbd1d5238bc$export$a4c3d56613a57187.Header, Footer: x = $ec857cbd1d5238bc$export$a4c3d56613a57187.Footer } } } = (0, $34076cf41c51978d$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $837c07886f78538a$export$253df7dc30f737bc), {
        className: t,
        variation: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-resetpassword": "",
        method: "post",
        onChange: E,
        onSubmit: F
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: f
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(h, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d23456b19983b31e$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $036d7109f9666f35$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba192fe9f9543e36$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $17798f30713dd189$export$8311b872375357fe), {
        cancelButtonText: $ec857cbd1d5238bc$var$c(),
        cancelButtonSendType: "SIGN_IN",
        submitButtonText: f ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, $ec857cbd1d5238bc$var$d(), "…") : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, $ec857cbd1d5238bc$var$p())
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(x, null))));
};
$ec857cbd1d5238bc$export$a4c3d56613a57187.Header = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7476e035421a7fc1$export$a8a3e93435678ff9), {
        level: 3
    }, $ec857cbd1d5238bc$var$f());
}, $ec857cbd1d5238bc$export$a4c3d56613a57187.Footer = function() {
    return null;
};


const $0977e5418699c87b$export$c92b4b399eea902a = (n)=>"signIn" === n || "signUp" === n;


function $440f8b66f5b7d893$var$d() {
    return null;
}
function $440f8b66f5b7d893$export$55185c17a0fcbe46({ className: l, hideSignUp: w, variation: j }) {
    const { route: U } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)(({ route: r })=>[
            r
        ]), g = (0, $acw62.useMemo)(()=>((r)=>{
            switch(r){
                case "authenticated":
                case "idle":
                case "setup":
                case "transition":
                    return $440f8b66f5b7d893$var$d;
                case "confirmSignUp":
                    return 0, $0a3cdc9f602c61e3$export$649c708157e61c64;
                case "confirmSignIn":
                    return 0, $f309a92f34c5b3de$export$b8b09b30a5bdd893;
                case "setupTOTP":
                    return 0, $0e5ad6295a47c6dc$export$1cb4d977b4f6b776;
                case "signIn":
                case "signUp":
                    return 0, $255dd366e7743337$export$6815ad73b98d75ed;
                case "forceNewPassword":
                    return 0, $6be1927e7d0e5ef3$export$b3aae0a112274a60;
                case "resetPassword":
                    return 0, $ec857cbd1d5238bc$export$a4c3d56613a57187;
                case "confirmResetPassword":
                    return 0, $b5ff1ac2459d08a9$export$fb3a0d1a16180c0d;
                case "verifyUser":
                    return 0, $0b75f1ee82f56fab$export$da61eb776d8ee98b;
                case "confirmVerifyUser":
                    return 0, $15576d32bd9e2ccd$export$79a17bba512ce899;
                default:
                    return console.warn(`Unhandled Authenticator route - please open an issue: ${r}`), $440f8b66f5b7d893$var$d;
            }
        })(U), [
        U
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(g, {
        className: l,
        hideSignUp: (0, $0977e5418699c87b$export$c92b4b399eea902a)(U) ? w : void 0,
        variation: j
    });
}


















const $2274ee5b33c30d21$export$71abc632aa29e6fe = {
    Header: ()=>null,
    SignIn: {
        Header: (0, $8c1aa707d7850e37$export$b64708c6f1b3ed96).Header,
        Footer: (0, $8c1aa707d7850e37$export$b64708c6f1b3ed96).Footer
    },
    SignUp: {
        Header: (0, $2ef3197110afebed$export$4ee457d816cea81a).Header,
        FormFields: (0, $2ef3197110afebed$export$4ee457d816cea81a).FormFields,
        Footer: (0, $2ef3197110afebed$export$4ee457d816cea81a).Footer
    },
    ConfirmSignUp: {
        Header: (0, $0a3cdc9f602c61e3$export$649c708157e61c64).Header,
        Footer: (0, $0a3cdc9f602c61e3$export$649c708157e61c64).Footer
    },
    SetupTOTP: {
        Header: (0, $0e5ad6295a47c6dc$export$1cb4d977b4f6b776).Header,
        Footer: (0, $0e5ad6295a47c6dc$export$1cb4d977b4f6b776).Footer
    },
    ConfirmResetPassword: {
        Header: (0, $b5ff1ac2459d08a9$export$fb3a0d1a16180c0d).Header,
        Footer: (0, $b5ff1ac2459d08a9$export$fb3a0d1a16180c0d).Footer
    },
    ConfirmSignIn: {
        Header: (0, $f309a92f34c5b3de$export$b8b09b30a5bdd893).Header,
        Footer: (0, $f309a92f34c5b3de$export$b8b09b30a5bdd893).Footer
    },
    VerifyUser: {
        Header: (0, $0b75f1ee82f56fab$export$da61eb776d8ee98b).Header,
        Footer: (0, $0b75f1ee82f56fab$export$da61eb776d8ee98b).Footer
    },
    ConfirmVerifyUser: {
        Header: (0, $15576d32bd9e2ccd$export$79a17bba512ce899).Header,
        Footer: (0, $15576d32bd9e2ccd$export$79a17bba512ce899).Footer
    },
    ForceNewPassword: {
        Header: (0, $6be1927e7d0e5ef3$export$b3aae0a112274a60).Header,
        Footer: (0, $6be1927e7d0e5ef3$export$b3aae0a112274a60).Footer,
        FormFields: (0, $6be1927e7d0e5ef3$export$b3aae0a112274a60).FormFields
    },
    ResetPassword: {
        Header: (0, $ec857cbd1d5238bc$export$a4c3d56613a57187).Header,
        Footer: (0, $ec857cbd1d5238bc$export$a4c3d56613a57187).Footer
    },
    Footer: ()=>null
};


function $8a2ad27c7b4dbdca$export$213d252991da224({ children: s, className: r, components: m, formFields: u, hideSignUp: c, initialState: l, loginMechanisms: f, passwordSettings: d, signUpAttributes: w, services: j, socialProviders: P, variation: S }) {
    (0, $6a7b590023baed18$export$406e4c8585b97b03)({
        message: "The `passwordSettings` prop has been deprecated and will be removed in a future major version of Amplify UI.",
        shouldWarn: !!d
    });
    const { route: v, signOut: h, user: O } = (0, $636ff7311f818a38$export$2e2bcd8739ae039)(({ route: e, signOut: s, user: o })=>[
            e,
            s,
            o
        ]);
    (0, $9386158d06477018$export$2e2bcd8739ae039)({
        initialState: l,
        loginMechanisms: f,
        services: j,
        signUpAttributes: w,
        socialProviders: P,
        formFields: u
    });
    const C = $acw62.useMemo(()=>({
            components: Object.assign(Object.assign({}, (0, $2274ee5b33c30d21$export$71abc632aa29e6fe)), m)
        }), [
        m
    ]);
    return "authenticated" === v || "signOut" === v ? s ? $acw62.createElement($acw62.Fragment, null, (0, $15a7c5986a3f06c2$export$f6e2535fb5126e54)(s) ? s({
        signOut: h,
        user: O
    }) : s) : null : $acw62.createElement((0, $34076cf41c51978d$export$da5ac45a736a5880).Provider, {
        value: C
    }, $acw62.createElement((0, $440f8b66f5b7d893$export$55185c17a0fcbe46), {
        className: r,
        hideSignUp: c,
        variation: S
    }));
}
function $8a2ad27c7b4dbdca$export$3d7a1e8452f884f3(o) {
    return $acw62.useEffect(()=>{
        (0, $9ad1914df4b6fe69$export$3c7f711f5942602f)({
            packageName: "@aws-amplify/ui-react",
            version: (0, $5423b34164054b36$export$a4ad2735b021c132)
        });
    }, []), $acw62.createElement((0, $cce185cc40fefbe8$export$2e2bcd8739ae039), null, $acw62.createElement($8a2ad27c7b4dbdca$export$213d252991da224, Object.assign({}, o)));
}
$8a2ad27c7b4dbdca$export$3d7a1e8452f884f3.Provider = (0, $cce185cc40fefbe8$export$2e2bcd8739ae039), $8a2ad27c7b4dbdca$export$3d7a1e8452f884f3.ResetPassword = (0, $ec857cbd1d5238bc$export$a4c3d56613a57187), $8a2ad27c7b4dbdca$export$3d7a1e8452f884f3.SetupTOTP = (0, $0e5ad6295a47c6dc$export$1cb4d977b4f6b776), $8a2ad27c7b4dbdca$export$3d7a1e8452f884f3.SignIn = (0, $8c1aa707d7850e37$export$b64708c6f1b3ed96), $8a2ad27c7b4dbdca$export$3d7a1e8452f884f3.SignUp = (0, $2ef3197110afebed$export$4ee457d816cea81a), $8a2ad27c7b4dbdca$export$3d7a1e8452f884f3.ForceNewPassword = (0, $6be1927e7d0e5ef3$export$b3aae0a112274a60);


const $a88ea9323d3a23c8$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.querySelector("#root"));
$a88ea9323d3a23c8$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a2ad27c7b4dbdca$export$3d7a1e8452f884f3).Provider, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {})
    })
}));


//# sourceMappingURL=index.aa285daf.js.map
